import { ɵɵdefineInjectable, Injectable, EventEmitter, Component, Input, Output, ɵɵinject, ChangeDetectorRef, ChangeDetectionStrategy, ViewChild, Directive, NgModule, HostListener, ElementRef, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { OverlayModule } from '@angular/cdk/overlay';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { DatePipe, CommonModule } from '@angular/common';
import { FormControl, Validators, FormBuilder, FormsModule, ReactiveFormsModule, NG_VALUE_ACCESSOR, FormGroup, FormArray } from '@angular/forms';
import { TranslocoService, TranslocoModule } from '@ngneat/transloco';
import { AuthModule } from '@lbmx/phoenix-lib-auth';
import { BaseAPIService, PimAPIService, LoggerService, CoreModule } from '@lbmx/phoenix-lib-core';
import { SpinnerService as SpinnerService$1, ToastrNotificationService as ToastrNotificationService$1, UtilsModule, ValidationService } from '@lbmx/phoenix-lib-utils';
import { SearchContainerLoaderService, SearchContainerLoaderModule, SearchContainerModule } from '@lbmx/search-container';
import { TemplateTypes, AnalyticsModule } from '@lbmx/analytics';
import { PerFormPrimengModule, LuiWidgetWrapperModule, LuiWizardV3Module } from '@lbmx/per-form-primeng';
import { ConfirmationService, MessageService, ConfirmDialog, ConfirmDialogModule, ButtonModule as ButtonModule$1, InputTextModule as InputTextModule$1, DropdownModule as DropdownModule$1, PickListModule, TableModule as TableModule$1, DialogModule as DialogModule$2, DialogService, FileUploadModule, TooltipModule } from 'primeng-lts';
import { AccordionModule } from 'primeng-lts/accordion';
import { ConfirmationService as ConfirmationService$1, MessageService as MessageService$1 } from 'primeng-lts/api';
import { ButtonModule } from 'primeng-lts/button';
import { CalendarModule } from 'primeng-lts/calendar';
import { CardModule } from 'primeng-lts/card';
import { ChartModule } from 'primeng-lts/chart';
import { CheckboxModule } from 'primeng-lts/checkbox';
import { ConfirmDialogModule as ConfirmDialogModule$1 } from 'primeng-lts/confirmdialog';
import { DialogModule } from 'primeng-lts/dialog';
import { DragDropModule } from 'primeng-lts/dragdrop';
import { DropdownModule } from 'primeng-lts/dropdown';
import { DynamicDialogRef, DynamicDialogConfig, DynamicDialogModule } from 'primeng-lts/dynamicdialog';
import { EditorModule } from 'primeng-lts/editor';
import { FileUploadModule as FileUploadModule$1 } from 'primeng-lts/fileupload';
import { FullCalendarModule } from 'primeng-lts/fullcalendar';
import { InputNumberModule } from 'primeng-lts/inputnumber';
import { InputTextModule } from 'primeng-lts/inputtext';
import { InputTextareaModule } from 'primeng-lts/inputtextarea';
import { KeyFilterModule } from 'primeng-lts/keyfilter';
import { MenuModule } from 'primeng-lts/menu';
import { MenubarModule } from 'primeng-lts/menubar';
import { MultiSelectModule } from 'primeng-lts/multiselect';
import { PanelModule } from 'primeng-lts/panel';
import { PasswordModule } from 'primeng-lts/password';
import { PickListModule as PickListModule$1 } from 'primeng-lts/picklist';
import { ProgressSpinnerModule } from 'primeng-lts/progressspinner';
import { SelectButtonModule as SelectButtonModule$1 } from 'primeng-lts/selectbutton';
import { SplitButtonModule } from 'primeng-lts/splitbutton';
import { TableModule } from 'primeng-lts/table';
import { TabViewModule } from 'primeng-lts/tabview';
import { ToastModule } from 'primeng-lts/toast';
import { ToggleButtonModule } from 'primeng-lts/togglebutton';
import { TreeModule } from 'primeng-lts/tree';
import { TreeTableModule } from 'primeng-lts/treetable';
import { __rest } from 'tslib';
import { Router, ActivatedRoute, RouterModule, NavigationStart } from '@angular/router';
import { timer, of, forkJoin, BehaviorSubject, combineLatest, Observable, from, zip, Subject, merge } from 'rxjs';
import { selectors, sortFields, actions, actionTypes } from '@lbmx/app-state';
import { SpinnerService, ToastrNotificationService } from '@lbmx/phoenix-lib-utils/';
import { toolKeys } from '@lbmx/types';
import { select, Store, createAction, props, createReducer, on, createFeatureSelector, createSelector, StoreModule } from '@ngrx/store';
import { utcToZonedTime } from 'date-fns-tz';
import { map, withLatestFrom, switchMap, tap, first, finalize, shareReplay, take, filter, exhaustMap, catchError, mergeMap, skip, toArray, debounceTime, mapTo, scan, takeUntil, defaultIfEmpty } from 'rxjs/operators';
import { HttpClient, HttpClientModule, HttpParams } from '@angular/common/http';
import urlJoin from 'proper-url-join';
import { saveAs } from 'file-saver';
import { createEffect, ofType, Actions, EffectsModule } from '@ngrx/effects';
import { SelectButtonModule, DialogModule as DialogModule$1, ConfirmationService as ConfirmationService$2 } from 'primeng';
import { FormControlRole, GenerateFormService } from '@lbmx/per-form';
import { ComponentStore } from '@ngrx/component-store';
import { BaseHttpService } from '@lbmx/root-services';
import { BreadcrumbService } from 'xng-breadcrumb';

class PimService {
    constructor() {
        /** empty block */
    }
    setConfig(config) {
        this.config = config;
    }
    getConfig() {
        return this.config;
    }
    setFilters(filters) {
        this.filterData = filters;
    }
    getFilters() {
        return this.filterData;
    }
}
PimService.ɵprov = ɵɵdefineInjectable({ factory: function PimService_Factory() { return new PimService(); }, token: PimService, providedIn: "root" });
PimService.decorators = [
    { type: Injectable, args: [{
                providedIn: 'root'
            },] }
];
PimService.ctorParameters = () => [];

class ApprovedProductsResponse {
}
class GetHierarchiesResponse {
}
class CategoryHierarchy {
}
class Hierarchy {
}
class PendingProductsResponse {
}
class SearchRange {
}
class Paging {
}
class ProductDetailsRequest {
}
class ProductDetailsResponse {
}
class Dimensions {
}
class CookerHeatingElement {
}
class CookerOvenCompartmentCapacity {
}
class GasBurner {
}
class CookerOvenCompartmentFeature {
}
class CookerOvenHeatingElementDimension {
}
class CookerOvenCompartment {
}
class Asset {
    constructor() {
        this.name = null;
        this.filename = null;
        this.url = null;
        this.isAvailable = false;
    }
}
class Fitting {
}
class ExtraText {
}
class TextLabel {
}
class ConnectionSize {
}
class ValveConnectionType {
}
class AssetDetails {
}
class Aggregation {
}
class AggregationResponse {
}
class Product {
    constructor() {
        this.primaryImage = new Asset();
        this.fittingA = new Fitting();
        this.fittingB = new Fitting();
        this.masterPackCase = new Dimensions();
        this.palletInformation = new Dimensions();
        this.consumerPackage = new Dimensions();
        this.consumerItem = new Dimensions();
    }
}

var Templates;
(function (Templates) {
    Templates["FEATURE"] = "Feature";
    Templates["MASTER"] = "master";
    Templates["CONSUMER"] = "consumer";
    Templates["PALLET"] = "pallet";
    Templates["PRIMARYIMAGE"] = "Primary";
    Templates["SECONDARYIMAGE"] = "Secondary";
    Templates["VIDEOS"] = "Video";
    Templates["DOCUMENTS"] = "Document";
})(Templates || (Templates = {}));
var Type;
(function (Type) {
    Type[Type["Array"] = 1] = "Array";
    Type[Type["Object"] = 2] = "Object";
})(Type || (Type = {}));
var Facets;
(function (Facets) {
    Facets["categoryName"] = "PIM.FACET_HEADERS.CATEGORY_NAME";
    Facets["completionPercent"] = "PIM.FACET_HEADERS.COMPLETION_PERCENT";
    Facets["className"] = "PIM.FACET_HEADERS.CLASS_NAME";
    Facets["colourName"] = "PIM.FACET_HEADERS.COLOUR_NAME";
    Facets["departmentName"] = "PIM.FACET_HEADERS.DEPARTMENT_NAME";
    Facets["divisionName"] = "PIM.FACET_HEADERS.DIVISION_NAME";
    Facets["groupHierarchy"] = "PIM.FACET_HEADERS.GROUP_HIERARCHY";
    Facets["majorClassName"] = "PIM.FACET_HEADERS.MAJOR_CLASS_NAME";
    Facets["majorDepartmentName"] = "PIM.FACET_HEADERS.MAJOR_DEPARTMENT_NAME";
    Facets["memberHierarchy"] = "PIM.FACET_HEADERS.MEMBER_HIERARCHY";
    Facets["sizeName"] = "PIM.FACET_HEADERS.SIZE_NAME";
    Facets["subClassName"] = "PIM.FACET_HEADERS.SUB_CLASS_NAME";
    Facets["subDepartmentName"] = "PIM.FACET_HEADERS.SUB_DEPARTMENT_NAME";
    Facets["supplierHierarchy"] = "PIM.FACET_HEADERS.SUPPLIER_HIERARCHY";
    Facets["supplierName"] = "PIM.FACET_HEADERS.SUPPLIER_NAME";
    Facets["gender"] = "PIM.FACET_HEADERS.GENDER";
    Facets["listPrice"] = "PIM.FACET_HEADERS.LIST_PRICE";
    Facets["msrp"] = "PIM.FACET_HEADERS.MSRP";
    Facets["dateAdded"] = "PIM.FACET_HEADERS.DATE_ADDED";
    Facets["dateLastChanged"] = "PIM.FACET_HEADERS.DATE_LAST_CHANGED";
    Facets["discontinueDate"] = "PIM.FACET_HEADERS.DISCONTINUE_DATE";
    Facets["startShipDate"] = "PIM.FACET_HEADERS.START_SHIP_DATE";
    Facets["endShipDate"] = "PIM.FACET_HEADERS.END_SHIP_DATE";
    Facets["consumerDate"] = "PIM.FACET_HEADERS.CONSUMER_DATE";
    Facets["showOnlineStartDate"] = "PIM.FACET_HEADERS.SHOW_ONLINE_START_DATE";
    Facets["showOnlineEndDate"] = "PIM.FACET_HEADERS.SHOW_ONLINE_END_DATE";
    Facets["productImage"] = "PIM.FACET_HEADERS.PRODUCT_IMAGE";
    Facets["brandName"] = "PIM.FACET_HEADERS.BRAND_NAME";
    Facets["outboundHierarchy"] = "PIM.FACET_HEADERS.OUTBOUND_HIERARCHY";
    Facets["suggestedHierarchy"] = "PIM.FACET_HEADERS.SUGGESTED_HIERARCHY";
})(Facets || (Facets = {}));
var ProductFieldsEnum;
(function (ProductFieldsEnum) {
    ProductFieldsEnum[ProductFieldsEnum["id"] = 1] = "id";
    ProductFieldsEnum[ProductFieldsEnum["sku"] = 2] = "sku";
    ProductFieldsEnum[ProductFieldsEnum["description"] = 3] = "description";
    ProductFieldsEnum[ProductFieldsEnum["groupSKU"] = 4] = "groupSKU";
    ProductFieldsEnum[ProductFieldsEnum["groupDescription"] = 5] = "groupDescription";
    ProductFieldsEnum[ProductFieldsEnum["memberSKU"] = 6] = "memberSKU";
    ProductFieldsEnum[ProductFieldsEnum["memberDescription"] = 7] = "memberDescription";
    ProductFieldsEnum[ProductFieldsEnum["supplierSKU"] = 8] = "supplierSKU";
    ProductFieldsEnum[ProductFieldsEnum["manufacturerSKU"] = 9] = "manufacturerSKU";
    ProductFieldsEnum[ProductFieldsEnum["supplierNumber"] = 10] = "supplierNumber";
    ProductFieldsEnum[ProductFieldsEnum["supplierName"] = 11] = "supplierName";
    ProductFieldsEnum[ProductFieldsEnum["manufacturerCode"] = 12] = "manufacturerCode";
    ProductFieldsEnum[ProductFieldsEnum["manufacturerName"] = 13] = "manufacturerName";
    ProductFieldsEnum[ProductFieldsEnum["lbmxSupplierID"] = 14] = "lbmxSupplierID";
    ProductFieldsEnum[ProductFieldsEnum["deleted_15Status"] = 15] = "deleted_15Status";
    ProductFieldsEnum[ProductFieldsEnum["upc"] = 16] = "upc";
    ProductFieldsEnum[ProductFieldsEnum["ean"] = 17] = "ean";
    ProductFieldsEnum[ProductFieldsEnum["gtin"] = 18] = "gtin";
    ProductFieldsEnum[ProductFieldsEnum["isbn"] = 19] = "isbn";
    ProductFieldsEnum[ProductFieldsEnum["notes"] = 20] = "notes";
    ProductFieldsEnum[ProductFieldsEnum["supplierHierarchy"] = 21] = "supplierHierarchy";
    ProductFieldsEnum[ProductFieldsEnum["groupHierarchy"] = 22] = "groupHierarchy";
    ProductFieldsEnum[ProductFieldsEnum["memberHierarchy"] = 23] = "memberHierarchy";
    ProductFieldsEnum[ProductFieldsEnum["divisionCode"] = 24] = "divisionCode";
    ProductFieldsEnum[ProductFieldsEnum["divisionName"] = 25] = "divisionName";
    ProductFieldsEnum[ProductFieldsEnum["majorDepartmentCode"] = 26] = "majorDepartmentCode";
    ProductFieldsEnum[ProductFieldsEnum["majorDepartmentName"] = 27] = "majorDepartmentName";
    ProductFieldsEnum[ProductFieldsEnum["departmentCode"] = 28] = "departmentCode";
    ProductFieldsEnum[ProductFieldsEnum["departmentName"] = 29] = "departmentName";
    ProductFieldsEnum[ProductFieldsEnum["subDepartmentCode"] = 30] = "subDepartmentCode";
    ProductFieldsEnum[ProductFieldsEnum["subDepartmentName"] = 31] = "subDepartmentName";
    ProductFieldsEnum[ProductFieldsEnum["majorClassCode"] = 32] = "majorClassCode";
    ProductFieldsEnum[ProductFieldsEnum["majorClassName"] = 33] = "majorClassName";
    ProductFieldsEnum[ProductFieldsEnum["classCode"] = 34] = "classCode";
    ProductFieldsEnum[ProductFieldsEnum["className"] = 35] = "className";
    ProductFieldsEnum[ProductFieldsEnum["subClassCode"] = 36] = "subClassCode";
    ProductFieldsEnum[ProductFieldsEnum["subClassName"] = 37] = "subClassName";
    ProductFieldsEnum[ProductFieldsEnum["categoryCode"] = 38] = "categoryCode";
    ProductFieldsEnum[ProductFieldsEnum["categoryName"] = 39] = "categoryName";
    ProductFieldsEnum[ProductFieldsEnum["genderCode"] = 40] = "genderCode";
    ProductFieldsEnum[ProductFieldsEnum["gender"] = 41] = "gender";
    ProductFieldsEnum[ProductFieldsEnum["colourCode"] = 42] = "colourCode";
    ProductFieldsEnum[ProductFieldsEnum["colourName"] = 43] = "colourName";
    ProductFieldsEnum[ProductFieldsEnum["sizeCode"] = 44] = "sizeCode";
    ProductFieldsEnum[ProductFieldsEnum["sizeName"] = 45] = "sizeName";
    ProductFieldsEnum[ProductFieldsEnum["listPrice"] = 46] = "listPrice";
    ProductFieldsEnum[ProductFieldsEnum["listCurrency"] = 47] = "listCurrency";
    ProductFieldsEnum[ProductFieldsEnum["msrp"] = 48] = "msrp";
    ProductFieldsEnum[ProductFieldsEnum["msrpCurrency"] = 49] = "msrpCurrency";
    ProductFieldsEnum[ProductFieldsEnum["unitOfMeasure"] = 50] = "unitOfMeasure";
    ProductFieldsEnum[ProductFieldsEnum["availableDate"] = 51] = "availableDate";
    ProductFieldsEnum[ProductFieldsEnum["discontinueDate"] = 52] = "discontinueDate";
    ProductFieldsEnum[ProductFieldsEnum["consumerDate"] = 53] = "consumerDate";
    ProductFieldsEnum[ProductFieldsEnum["dateAdded"] = 54] = "dateAdded";
    ProductFieldsEnum[ProductFieldsEnum["dateLastChanged"] = 55] = "dateLastChanged";
    ProductFieldsEnum[ProductFieldsEnum["startShipDate"] = 56] = "startShipDate";
    ProductFieldsEnum[ProductFieldsEnum["endShipDate"] = 57] = "endShipDate";
    ProductFieldsEnum[ProductFieldsEnum["productSeason"] = 58] = "productSeason";
    ProductFieldsEnum[ProductFieldsEnum["minOrderQty"] = 59] = "minOrderQty";
    ProductFieldsEnum[ProductFieldsEnum["maxOrderQty"] = 60] = "maxOrderQty";
    ProductFieldsEnum[ProductFieldsEnum["orderQtyMultiple"] = 61] = "orderQtyMultiple";
    ProductFieldsEnum[ProductFieldsEnum["dropShippable"] = 62] = "dropShippable";
    ProductFieldsEnum[ProductFieldsEnum["innerPackQty"] = 63] = "innerPackQty";
    ProductFieldsEnum[ProductFieldsEnum["outerPackQty"] = 64] = "outerPackQty";
    ProductFieldsEnum[ProductFieldsEnum["masterPackCaseLength"] = 65] = "masterPackCaseLength";
    ProductFieldsEnum[ProductFieldsEnum["masterPackCaseLengthUOM"] = 66] = "masterPackCaseLengthUOM";
    ProductFieldsEnum[ProductFieldsEnum["masterPackCaseWidth"] = 67] = "masterPackCaseWidth";
    ProductFieldsEnum[ProductFieldsEnum["masterPackCaseWidthUOM"] = 68] = "masterPackCaseWidthUOM";
    ProductFieldsEnum[ProductFieldsEnum["masterPackCaseHeight"] = 69] = "masterPackCaseHeight";
    ProductFieldsEnum[ProductFieldsEnum["masterPackCaseHeightUOM"] = 70] = "masterPackCaseHeightUOM";
    ProductFieldsEnum[ProductFieldsEnum["masterPackCaseWeight"] = 71] = "masterPackCaseWeight";
    ProductFieldsEnum[ProductFieldsEnum["masterPackCaseWeightUOM"] = 72] = "masterPackCaseWeightUOM";
    ProductFieldsEnum[ProductFieldsEnum["masterPackCaseVolume"] = 73] = "masterPackCaseVolume";
    ProductFieldsEnum[ProductFieldsEnum["masterPackCaseVolumeUOM"] = 74] = "masterPackCaseVolumeUOM";
    ProductFieldsEnum[ProductFieldsEnum["masterPackCaseUPC"] = 75] = "masterPackCaseUPC";
    ProductFieldsEnum[ProductFieldsEnum["consumerPackageLength"] = 76] = "consumerPackageLength";
    ProductFieldsEnum[ProductFieldsEnum["consumerPackageLengthUOM"] = 77] = "consumerPackageLengthUOM";
    ProductFieldsEnum[ProductFieldsEnum["consumerPackageWidth"] = 78] = "consumerPackageWidth";
    ProductFieldsEnum[ProductFieldsEnum["consumerPackageWidthUOM"] = 79] = "consumerPackageWidthUOM";
    ProductFieldsEnum[ProductFieldsEnum["consumerPackageHeight"] = 80] = "consumerPackageHeight";
    ProductFieldsEnum[ProductFieldsEnum["consumerPackageHeightUOM"] = 81] = "consumerPackageHeightUOM";
    ProductFieldsEnum[ProductFieldsEnum["consumerPackageWeight"] = 82] = "consumerPackageWeight";
    ProductFieldsEnum[ProductFieldsEnum["consumerPackageWeightUOM"] = 83] = "consumerPackageWeightUOM";
    ProductFieldsEnum[ProductFieldsEnum["consumerPackageVolume"] = 84] = "consumerPackageVolume";
    ProductFieldsEnum[ProductFieldsEnum["consumerPackageVolumeUOM"] = 85] = "consumerPackageVolumeUOM";
    ProductFieldsEnum[ProductFieldsEnum["palletQuantity"] = 86] = "palletQuantity";
    ProductFieldsEnum[ProductFieldsEnum["palletInformationHeight"] = 87] = "palletInformationHeight";
    ProductFieldsEnum[ProductFieldsEnum["palletInformationHeightUOM"] = 88] = "palletInformationHeightUOM";
    ProductFieldsEnum[ProductFieldsEnum["palletInformationWidth"] = 89] = "palletInformationWidth";
    ProductFieldsEnum[ProductFieldsEnum["palletInformationWidthUOM"] = 90] = "palletInformationWidthUOM";
    ProductFieldsEnum[ProductFieldsEnum["palletInformationLength"] = 91] = "palletInformationLength";
    ProductFieldsEnum[ProductFieldsEnum["palletInformationLengthUOM"] = 92] = "palletInformationLengthUOM";
    ProductFieldsEnum[ProductFieldsEnum["palletInformationWeight"] = 93] = "palletInformationWeight";
    ProductFieldsEnum[ProductFieldsEnum["palletInformationWeightUOM"] = 94] = "palletInformationWeightUOM";
    ProductFieldsEnum[ProductFieldsEnum["palletInformationBlocks"] = 95] = "palletInformationBlocks";
    ProductFieldsEnum[ProductFieldsEnum["palletInformationVolume"] = 96] = "palletInformationVolume";
    ProductFieldsEnum[ProductFieldsEnum["palletInformationVolumeUOM"] = 97] = "palletInformationVolumeUOM";
    ProductFieldsEnum[ProductFieldsEnum["longProductName"] = 98] = "longProductName";
    ProductFieldsEnum[ProductFieldsEnum["longMarketingDescription"] = 99] = "longMarketingDescription";
    ProductFieldsEnum[ProductFieldsEnum["features"] = 100] = "features";
    ProductFieldsEnum[ProductFieldsEnum["keyWords"] = 101] = "keyWords";
    ProductFieldsEnum[ProductFieldsEnum["countryOfOriginCode"] = 102] = "countryOfOriginCode";
    ProductFieldsEnum[ProductFieldsEnum["deleted_103CountryOfOrigin"] = 103] = "deleted_103CountryOfOrigin";
    ProductFieldsEnum[ProductFieldsEnum["productBullet"] = 104] = "productBullet";
    ProductFieldsEnum[ProductFieldsEnum["optionalAccessory"] = 105] = "optionalAccessory";
    ProductFieldsEnum[ProductFieldsEnum["primaryImageFilename"] = 106] = "primaryImageFilename";
    ProductFieldsEnum[ProductFieldsEnum["primaryImageName"] = 107] = "primaryImageName";
    ProductFieldsEnum[ProductFieldsEnum["secondaryImageFilename"] = 108] = "secondaryImageFilename";
    ProductFieldsEnum[ProductFieldsEnum["secondaryImageName"] = 109] = "secondaryImageName";
    ProductFieldsEnum[ProductFieldsEnum["videoName"] = 110] = "videoName";
    ProductFieldsEnum[ProductFieldsEnum["videoFilename"] = 111] = "videoFilename";
    ProductFieldsEnum[ProductFieldsEnum["documentName"] = 112] = "documentName";
    ProductFieldsEnum[ProductFieldsEnum["documentFilename"] = 113] = "documentFilename";
    ProductFieldsEnum[ProductFieldsEnum["harmonizedTariffCode"] = 114] = "harmonizedTariffCode";
    ProductFieldsEnum[ProductFieldsEnum["aersol"] = 115] = "aersol";
    ProductFieldsEnum[ProductFieldsEnum["waterResistant"] = 116] = "waterResistant";
    ProductFieldsEnum[ProductFieldsEnum["waterResistantDescription"] = 117] = "waterResistantDescription";
    ProductFieldsEnum[ProductFieldsEnum["energyStarCompliant"] = 118] = "energyStarCompliant";
    ProductFieldsEnum[ProductFieldsEnum["fabricDescription"] = 119] = "fabricDescription";
    ProductFieldsEnum[ProductFieldsEnum["fastenerType"] = 120] = "fastenerType";
    ProductFieldsEnum[ProductFieldsEnum["fastenerLocation"] = 121] = "fastenerLocation";
    ProductFieldsEnum[ProductFieldsEnum["apparelCut"] = 122] = "apparelCut";
    ProductFieldsEnum[ProductFieldsEnum["collarType"] = 123] = "collarType";
    ProductFieldsEnum[ProductFieldsEnum["sleeveType"] = 124] = "sleeveType";
    ProductFieldsEnum[ProductFieldsEnum["sleeveLength"] = 125] = "sleeveLength";
    ProductFieldsEnum[ProductFieldsEnum["sleeveLengthUOM"] = 126] = "sleeveLengthUOM";
    ProductFieldsEnum[ProductFieldsEnum["pantInseamLength"] = 127] = "pantInseamLength";
    ProductFieldsEnum[ProductFieldsEnum["pantInseamLengthUOM"] = 128] = "pantInseamLengthUOM";
    ProductFieldsEnum[ProductFieldsEnum["dressSkirtLength"] = 129] = "dressSkirtLength";
    ProductFieldsEnum[ProductFieldsEnum["dressSkirtLengthUOM"] = 130] = "dressSkirtLengthUOM";
    ProductFieldsEnum[ProductFieldsEnum["isHangerIncluded"] = 131] = "isHangerIncluded";
    ProductFieldsEnum[ProductFieldsEnum["itemHanging"] = 132] = "itemHanging";
    ProductFieldsEnum[ProductFieldsEnum["careInstructions"] = 133] = "careInstructions";
    ProductFieldsEnum[ProductFieldsEnum["areBatteriesIncluded"] = 134] = "areBatteriesIncluded";
    ProductFieldsEnum[ProductFieldsEnum["areBatteriesRequired"] = 135] = "areBatteriesRequired";
    ProductFieldsEnum[ProductFieldsEnum["powerSupplyCode"] = 136] = "powerSupplyCode";
    ProductFieldsEnum[ProductFieldsEnum["batteryMaterials"] = 137] = "batteryMaterials";
    ProductFieldsEnum[ProductFieldsEnum["areBatteriesBuiltIn"] = 138] = "areBatteriesBuiltIn";
    ProductFieldsEnum[ProductFieldsEnum["batteryTechType"] = 139] = "batteryTechType";
    ProductFieldsEnum[ProductFieldsEnum["batteryType"] = 140] = "batteryType";
    ProductFieldsEnum[ProductFieldsEnum["batteryWeight"] = 141] = "batteryWeight";
    ProductFieldsEnum[ProductFieldsEnum["batteryWeightUOM"] = 142] = "batteryWeightUOM";
    ProductFieldsEnum[ProductFieldsEnum["batteryQuantityBuiltIn"] = 143] = "batteryQuantityBuiltIn";
    ProductFieldsEnum[ProductFieldsEnum["batteryQuantityRequired"] = 144] = "batteryQuantityRequired";
    ProductFieldsEnum[ProductFieldsEnum["batteryTypeQualifierCode"] = 145] = "batteryTypeQualifierCode";
    ProductFieldsEnum[ProductFieldsEnum["batteryWattHourRating"] = 146] = "batteryWattHourRating";
    ProductFieldsEnum[ProductFieldsEnum["batteryMaximumLife"] = 147] = "batteryMaximumLife";
    ProductFieldsEnum[ProductFieldsEnum["deleted_bendAngleCode"] = 148] = "deleted_bendAngleCode";
    ProductFieldsEnum[ProductFieldsEnum["deleted_insideDiameter"] = 149] = "deleted_insideDiameter";
    ProductFieldsEnum[ProductFieldsEnum["deleted_insideDiameterUOM"] = 150] = "deleted_insideDiameterUOM";
    ProductFieldsEnum[ProductFieldsEnum["deleted_outsideDiameter"] = 151] = "deleted_outsideDiameter";
    ProductFieldsEnum[ProductFieldsEnum["deleted_outsideDiameterUOM"] = 152] = "deleted_outsideDiameterUOM";
    ProductFieldsEnum[ProductFieldsEnum["deleted_pipeSchedule"] = 153] = "deleted_pipeSchedule";
    ProductFieldsEnum[ProductFieldsEnum["deleted_plumbingControlTypeCode"] = 154] = "deleted_plumbingControlTypeCode";
    ProductFieldsEnum[ProductFieldsEnum["deleted_plumbingConnectionAgencyCode"] = 155] = "deleted_plumbingConnectionAgencyCode";
    ProductFieldsEnum[ProductFieldsEnum["deleted_plumbingConnectionCode"] = 156] = "deleted_plumbingConnectionCode";
    ProductFieldsEnum[ProductFieldsEnum["deleted_plumbingConnectionTypeCode"] = 157] = "deleted_plumbingConnectionTypeCode";
    ProductFieldsEnum[ProductFieldsEnum["deleted_threadTypeCode"] = 158] = "deleted_threadTypeCode";
    ProductFieldsEnum[ProductFieldsEnum["deleted_meshMaterialCode"] = 159] = "deleted_meshMaterialCode";
    ProductFieldsEnum[ProductFieldsEnum["deleted_meshSizeCode"] = 160] = "deleted_meshSizeCode";
    ProductFieldsEnum[ProductFieldsEnum["deleted_workingPressureRatingClassCode"] = 161] = "deleted_workingPressureRatingClassCode";
    ProductFieldsEnum[ProductFieldsEnum["deleted_workingPressureRatingMax"] = 162] = "deleted_workingPressureRatingMax";
    ProductFieldsEnum[ProductFieldsEnum["deleted_workingPressureRatingMin"] = 163] = "deleted_workingPressureRatingMin";
    ProductFieldsEnum[ProductFieldsEnum["warrantyDescription"] = 164] = "warrantyDescription";
    ProductFieldsEnum[ProductFieldsEnum["warrantyConstraint"] = 165] = "warrantyConstraint";
    ProductFieldsEnum[ProductFieldsEnum["warrantyDuration"] = 166] = "warrantyDuration";
    ProductFieldsEnum[ProductFieldsEnum["warrantyEffectiveDateType"] = 167] = "warrantyEffectiveDateType";
    ProductFieldsEnum[ProductFieldsEnum["warrantyType"] = 168] = "warrantyType";
    ProductFieldsEnum[ProductFieldsEnum["actualProductLength"] = 169] = "actualProductLength";
    ProductFieldsEnum[ProductFieldsEnum["actualProductLengthUOM"] = 170] = "actualProductLengthUOM";
    ProductFieldsEnum[ProductFieldsEnum["actualProductThickness"] = 171] = "actualProductThickness";
    ProductFieldsEnum[ProductFieldsEnum["actualProductThicknessUOM"] = 172] = "actualProductThicknessUOM";
    ProductFieldsEnum[ProductFieldsEnum["actualProductWidth"] = 173] = "actualProductWidth";
    ProductFieldsEnum[ProductFieldsEnum["actualProductWidthUOM"] = 174] = "actualProductWidthUOM";
    ProductFieldsEnum[ProductFieldsEnum["appearanceBoardType"] = 175] = "appearanceBoardType";
    ProductFieldsEnum[ProductFieldsEnum["boardJointType"] = 176] = "boardJointType";
    ProductFieldsEnum[ProductFieldsEnum["finishType"] = 177] = "finishType";
    ProductFieldsEnum[ProductFieldsEnum["lumberGrade"] = 178] = "lumberGrade";
    ProductFieldsEnum[ProductFieldsEnum["woodSpecies"] = 179] = "woodSpecies";
    ProductFieldsEnum[ProductFieldsEnum["texture"] = 180] = "texture";
    ProductFieldsEnum[ProductFieldsEnum["engineeredWoodType"] = 181] = "engineeredWoodType";
    ProductFieldsEnum[ProductFieldsEnum["isPressureTreated"] = 182] = "isPressureTreated";
    ProductFieldsEnum[ProductFieldsEnum["isTongueAndGroove"] = 183] = "isTongueAndGroove";
    ProductFieldsEnum[ProductFieldsEnum["handleLength"] = 184] = "handleLength";
    ProductFieldsEnum[ProductFieldsEnum["handleLengthUOM"] = 185] = "handleLengthUOM";
    ProductFieldsEnum[ProductFieldsEnum["bladeLength"] = 186] = "bladeLength";
    ProductFieldsEnum[ProductFieldsEnum["bladeLengthUOM"] = 187] = "bladeLengthUOM";
    ProductFieldsEnum[ProductFieldsEnum["bladeWidth"] = 188] = "bladeWidth";
    ProductFieldsEnum[ProductFieldsEnum["bladeWidthUOM"] = 189] = "bladeWidthUOM";
    ProductFieldsEnum[ProductFieldsEnum["headWeight"] = 190] = "headWeight";
    ProductFieldsEnum[ProductFieldsEnum["headWeightUOM"] = 191] = "headWeightUOM";
    ProductFieldsEnum[ProductFieldsEnum["clawType"] = 192] = "clawType";
    ProductFieldsEnum[ProductFieldsEnum["hammerType"] = 193] = "hammerType";
    ProductFieldsEnum[ProductFieldsEnum["handToolType"] = 194] = "handToolType";
    ProductFieldsEnum[ProductFieldsEnum["handleShape"] = 195] = "handleShape";
    ProductFieldsEnum[ProductFieldsEnum["handleMaterial"] = 196] = "handleMaterial";
    ProductFieldsEnum[ProductFieldsEnum["driveStyle"] = 197] = "driveStyle";
    ProductFieldsEnum[ProductFieldsEnum["individualOrSet"] = 198] = "individualOrSet";
    ProductFieldsEnum[ProductFieldsEnum["setPieces"] = 199] = "setPieces";
    ProductFieldsEnum[ProductFieldsEnum["measurementStandard"] = 200] = "measurementStandard";
    ProductFieldsEnum[ProductFieldsEnum["ratcheting"] = 201] = "ratcheting";
    ProductFieldsEnum[ProductFieldsEnum["sawType"] = 202] = "sawType";
    ProductFieldsEnum[ProductFieldsEnum["socketDepth"] = 203] = "socketDepth";
    ProductFieldsEnum[ProductFieldsEnum["socketType"] = 204] = "socketType";
    ProductFieldsEnum[ProductFieldsEnum["caliperType"] = 205] = "caliperType";
    ProductFieldsEnum[ProductFieldsEnum["chiselTipStyle"] = 206] = "chiselTipStyle";
    ProductFieldsEnum[ProductFieldsEnum["clampType"] = 207] = "clampType";
    ProductFieldsEnum[ProductFieldsEnum["fileType"] = 208] = "fileType";
    ProductFieldsEnum[ProductFieldsEnum["keyType"] = 209] = "keyType";
    ProductFieldsEnum[ProductFieldsEnum["laserLevelType"] = 210] = "laserLevelType";
    ProductFieldsEnum[ProductFieldsEnum["levelType"] = 211] = "levelType";
    ProductFieldsEnum[ProductFieldsEnum["mountingMethod"] = 212] = "mountingMethod";
    ProductFieldsEnum[ProductFieldsEnum["pliersType"] = 213] = "pliersType";
    ProductFieldsEnum[ProductFieldsEnum["rightLeftHanded"] = 214] = "rightLeftHanded";
    ProductFieldsEnum[ProductFieldsEnum["selfLeveling"] = 215] = "selfLeveling";
    ProductFieldsEnum[ProductFieldsEnum["snipsType"] = 216] = "snipsType";
    ProductFieldsEnum[ProductFieldsEnum["viseType"] = 217] = "viseType";
    ProductFieldsEnum[ProductFieldsEnum["wrenchType"] = 218] = "wrenchType";
    ProductFieldsEnum[ProductFieldsEnum["weatherproof"] = 219] = "weatherproof";
    ProductFieldsEnum[ProductFieldsEnum["materialApplication"] = 220] = "materialApplication";
    ProductFieldsEnum[ProductFieldsEnum["toolType"] = 221] = "toolType";
    ProductFieldsEnum[ProductFieldsEnum["cordlessCorded"] = 222] = "cordlessCorded";
    ProductFieldsEnum[ProductFieldsEnum["isChargerIncluded"] = 223] = "isChargerIncluded";
    ProductFieldsEnum[ProductFieldsEnum["motorType"] = 224] = "motorType";
    ProductFieldsEnum[ProductFieldsEnum["hasLaserGuide"] = 225] = "hasLaserGuide";
    ProductFieldsEnum[ProductFieldsEnum["isVariableSpeed"] = 226] = "isVariableSpeed";
    ProductFieldsEnum[ProductFieldsEnum["numberOfSpeeds"] = 227] = "numberOfSpeeds";
    ProductFieldsEnum[ProductFieldsEnum["chuckSize"] = 228] = "chuckSize";
    ProductFieldsEnum[ProductFieldsEnum["chuckSizeUOM"] = 229] = "chuckSizeUOM";
    ProductFieldsEnum[ProductFieldsEnum["chuckType"] = 230] = "chuckType";
    ProductFieldsEnum[ProductFieldsEnum["maximumSpeed"] = 231] = "maximumSpeed";
    ProductFieldsEnum[ProductFieldsEnum["fittingA_Size"] = 232] = "fittingA_Size";
    ProductFieldsEnum[ProductFieldsEnum["fittingA_SizeUOM"] = 233] = "fittingA_SizeUOM";
    ProductFieldsEnum[ProductFieldsEnum["fittingA_Type"] = 234] = "fittingA_Type";
    ProductFieldsEnum[ProductFieldsEnum["productType"] = 235] = "productType";
    ProductFieldsEnum[ProductFieldsEnum["lubricationType"] = 236] = "lubricationType";
    ProductFieldsEnum[ProductFieldsEnum["airOutletSize"] = 237] = "airOutletSize";
    ProductFieldsEnum[ProductFieldsEnum["airOutletSizeUOM"] = 238] = "airOutletSizeUOM";
    ProductFieldsEnum[ProductFieldsEnum["isCompressorComboKit"] = 239] = "isCompressorComboKit";
    ProductFieldsEnum[ProductFieldsEnum["powerSource"] = 240] = "powerSource";
    ProductFieldsEnum[ProductFieldsEnum["gauge"] = 241] = "gauge";
    ProductFieldsEnum[ProductFieldsEnum["airInletSize"] = 242] = "airInletSize";
    ProductFieldsEnum[ProductFieldsEnum["airInletSizeUOM"] = 243] = "airInletSizeUOM";
    ProductFieldsEnum[ProductFieldsEnum["fluidDeliveryType"] = 244] = "fluidDeliveryType";
    ProductFieldsEnum[ProductFieldsEnum["application"] = 245] = "application";
    ProductFieldsEnum[ProductFieldsEnum["hoseLength"] = 246] = "hoseLength";
    ProductFieldsEnum[ProductFieldsEnum["hoseLengthUOM"] = 247] = "hoseLengthUOM";
    ProductFieldsEnum[ProductFieldsEnum["horsepower"] = 248] = "horsepower";
    ProductFieldsEnum[ProductFieldsEnum["soundLevel"] = 249] = "soundLevel";
    ProductFieldsEnum[ProductFieldsEnum["nailgunAngle"] = 250] = "nailgunAngle";
    ProductFieldsEnum[ProductFieldsEnum["minPSI"] = 251] = "minPSI";
    ProductFieldsEnum[ProductFieldsEnum["wheelDiameter"] = 252] = "wheelDiameter";
    ProductFieldsEnum[ProductFieldsEnum["wheelDiameterUOM"] = 253] = "wheelDiameterUOM";
    ProductFieldsEnum[ProductFieldsEnum["maxSpeed"] = 254] = "maxSpeed";
    ProductFieldsEnum[ProductFieldsEnum["grindingSpeed"] = 255] = "grindingSpeed";
    ProductFieldsEnum[ProductFieldsEnum["blowsPerMinute"] = 256] = "blowsPerMinute";
    ProductFieldsEnum[ProductFieldsEnum["sandingSpeed"] = 257] = "sandingSpeed";
    ProductFieldsEnum[ProductFieldsEnum["hasAdjustableExhaustPort"] = 258] = "hasAdjustableExhaustPort";
    ProductFieldsEnum[ProductFieldsEnum["hasAutoShutOff"] = 259] = "hasAutoShutOff";
    ProductFieldsEnum[ProductFieldsEnum["hasAutoStart"] = 260] = "hasAutoStart";
    ProductFieldsEnum[ProductFieldsEnum["hasDeflation"] = 261] = "hasDeflation";
    ProductFieldsEnum[ProductFieldsEnum["hasDualControls"] = 262] = "hasDualControls";
    ProductFieldsEnum[ProductFieldsEnum["hasFastenerDepthControl"] = 263] = "hasFastenerDepthControl";
    ProductFieldsEnum[ProductFieldsEnum["hasHandle"] = 264] = "hasHandle";
    ProductFieldsEnum[ProductFieldsEnum["hasOilFreeCompressor"] = 265] = "hasOilFreeCompressor";
    ProductFieldsEnum[ProductFieldsEnum["hasTankPressureGauge"] = 266] = "hasTankPressureGauge";
    ProductFieldsEnum[ProductFieldsEnum["hasWheels"] = 267] = "hasWheels";
    ProductFieldsEnum[ProductFieldsEnum["hasUniversalQuickConnectors"] = 268] = "hasUniversalQuickConnectors";
    ProductFieldsEnum[ProductFieldsEnum["compatibleTruckSize"] = 269] = "compatibleTruckSize";
    ProductFieldsEnum[ProductFieldsEnum["beltMaterial"] = 270] = "beltMaterial";
    ProductFieldsEnum[ProductFieldsEnum["pocketMaterial"] = 271] = "pocketMaterial";
    ProductFieldsEnum[ProductFieldsEnum["hasToolboxWheels"] = 272] = "hasToolboxWheels";
    ProductFieldsEnum[ProductFieldsEnum["isLockable"] = 273] = "isLockable";
    ProductFieldsEnum[ProductFieldsEnum["numberOfInsidePockets"] = 274] = "numberOfInsidePockets";
    ProductFieldsEnum[ProductFieldsEnum["numberOfOutsidePockets"] = 275] = "numberOfOutsidePockets";
    ProductFieldsEnum[ProductFieldsEnum["numberOfPockets"] = 276] = "numberOfPockets";
    ProductFieldsEnum[ProductFieldsEnum["numberOfCompartments"] = 277] = "numberOfCompartments";
    ProductFieldsEnum[ProductFieldsEnum["numberOfShelves"] = 278] = "numberOfShelves";
    ProductFieldsEnum[ProductFieldsEnum["numberOfTrays"] = 279] = "numberOfTrays";
    ProductFieldsEnum[ProductFieldsEnum["frameSteelGauge"] = 280] = "frameSteelGauge";
    ProductFieldsEnum[ProductFieldsEnum["numberOfDrawers"] = 281] = "numberOfDrawers";
    ProductFieldsEnum[ProductFieldsEnum["hasCarabiner"] = 282] = "hasCarabiner";
    ProductFieldsEnum[ProductFieldsEnum["hasDaisyChain"] = 283] = "hasDaisyChain";
    ProductFieldsEnum[ProductFieldsEnum["hasToolboxHandle"] = 284] = "hasToolboxHandle";
    ProductFieldsEnum[ProductFieldsEnum["hasPaddedBottom"] = 285] = "hasPaddedBottom";
    ProductFieldsEnum[ProductFieldsEnum["hasRubberFeet"] = 286] = "hasRubberFeet";
    ProductFieldsEnum[ProductFieldsEnum["hasRubberizedBottom"] = 287] = "hasRubberizedBottom";
    ProductFieldsEnum[ProductFieldsEnum["hasShoulderStrap"] = 288] = "hasShoulderStrap";
    ProductFieldsEnum[ProductFieldsEnum["hasTapeChain"] = 289] = "hasTapeChain";
    ProductFieldsEnum[ProductFieldsEnum["hasHiVisTrim"] = 290] = "hasHiVisTrim";
    ProductFieldsEnum[ProductFieldsEnum["hasFeaturesWheels"] = 291] = "hasFeaturesWheels";
    ProductFieldsEnum[ProductFieldsEnum["hasAdjustableShelves"] = 292] = "hasAdjustableShelves";
    ProductFieldsEnum[ProductFieldsEnum["hasBallBearingSlides"] = 293] = "hasBallBearingSlides";
    ProductFieldsEnum[ProductFieldsEnum["hasDeepChest"] = 294] = "hasDeepChest";
    ProductFieldsEnum[ProductFieldsEnum["hasGasLidStruts"] = 295] = "hasGasLidStruts";
    ProductFieldsEnum[ProductFieldsEnum["isScratchResistant"] = 296] = "isScratchResistant";
    ProductFieldsEnum[ProductFieldsEnum["hasSecureLid"] = 297] = "hasSecureLid";
    ProductFieldsEnum[ProductFieldsEnum["hasSoftCloseDrawers"] = 298] = "hasSoftCloseDrawers";
    ProductFieldsEnum[ProductFieldsEnum["isWallMountable"] = 299] = "isWallMountable";
    ProductFieldsEnum[ProductFieldsEnum["hasWheelLocks"] = 300] = "hasWheelLocks";
    ProductFieldsEnum[ProductFieldsEnum["hasWorktop"] = 301] = "hasWorktop";
    ProductFieldsEnum[ProductFieldsEnum["supplierKey"] = 302] = "supplierKey";
    ProductFieldsEnum[ProductFieldsEnum["isPending"] = 303] = "isPending";
    ProductFieldsEnum[ProductFieldsEnum["isApproved"] = 304] = "isApproved";
    ProductFieldsEnum[ProductFieldsEnum["parentProductID"] = 305] = "parentProductID";
    ProductFieldsEnum[ProductFieldsEnum["addedBy"] = 306] = "addedBy";
    ProductFieldsEnum[ProductFieldsEnum["modifiedBy"] = 307] = "modifiedBy";
    ProductFieldsEnum[ProductFieldsEnum["fittingB_Size"] = 308] = "fittingB_Size";
    ProductFieldsEnum[ProductFieldsEnum["fittingB_SizeUOM"] = 309] = "fittingB_SizeUOM";
    ProductFieldsEnum[ProductFieldsEnum["fittingB_Type"] = 310] = "fittingB_Type";
    ProductFieldsEnum[ProductFieldsEnum["accountKey"] = 311] = "accountKey";
    ProductFieldsEnum[ProductFieldsEnum["completionPercent"] = 312] = "completionPercent";
    ProductFieldsEnum[ProductFieldsEnum["brandCode"] = 313] = "brandCode";
    ProductFieldsEnum[ProductFieldsEnum["brandName"] = 314] = "brandName";
    ProductFieldsEnum[ProductFieldsEnum["accessoryItem"] = 315] = "accessoryItem";
    ProductFieldsEnum[ProductFieldsEnum["shortMarketingDescription"] = 316] = "shortMarketingDescription";
    ProductFieldsEnum[ProductFieldsEnum["warrantyUom"] = 317] = "warrantyUom";
    ProductFieldsEnum[ProductFieldsEnum["consumerItemLength"] = 318] = "consumerItemLength";
    ProductFieldsEnum[ProductFieldsEnum["consumerItemLengthUom"] = 319] = "consumerItemLengthUom";
    ProductFieldsEnum[ProductFieldsEnum["consumerItemWidth"] = 320] = "consumerItemWidth";
    ProductFieldsEnum[ProductFieldsEnum["consumerItemWidthUom"] = 321] = "consumerItemWidthUom";
    ProductFieldsEnum[ProductFieldsEnum["consumerItemHeight"] = 322] = "consumerItemHeight";
    ProductFieldsEnum[ProductFieldsEnum["consumerItemHeightUom"] = 323] = "consumerItemHeightUom";
    ProductFieldsEnum[ProductFieldsEnum["consumerItemDepth"] = 324] = "consumerItemDepth";
    ProductFieldsEnum[ProductFieldsEnum["consumerItemDepthUom"] = 325] = "consumerItemDepthUom";
    ProductFieldsEnum[ProductFieldsEnum["consumerItemNetWeight"] = 326] = "consumerItemNetWeight";
    ProductFieldsEnum[ProductFieldsEnum["consumerItemNetWeightUom"] = 327] = "consumerItemNetWeightUom";
    ProductFieldsEnum[ProductFieldsEnum["consumerItemGrossWeight"] = 328] = "consumerItemGrossWeight";
    ProductFieldsEnum[ProductFieldsEnum["consumerItemGrossWeightUom"] = 329] = "consumerItemGrossWeightUom";
    ProductFieldsEnum[ProductFieldsEnum["productGroup"] = 330] = "productGroup";
    ProductFieldsEnum[ProductFieldsEnum["productFamily"] = 331] = "productFamily";
    ProductFieldsEnum[ProductFieldsEnum["energyStarRating"] = 332] = "energyStarRating";
    ProductFieldsEnum[ProductFieldsEnum["energyRating"] = 333] = "energyRating";
    ProductFieldsEnum[ProductFieldsEnum["energyEfficiencyClass"] = 334] = "energyEfficiencyClass";
    ProductFieldsEnum[ProductFieldsEnum["noiseLevel"] = 335] = "noiseLevel";
    ProductFieldsEnum[ProductFieldsEnum["noiseLevelUom"] = 336] = "noiseLevelUom";
    ProductFieldsEnum[ProductFieldsEnum["fridgeCompartmentType"] = 337] = "fridgeCompartmentType";
    ProductFieldsEnum[ProductFieldsEnum["frostFreeSystem"] = 338] = "frostFreeSystem";
    ProductFieldsEnum[ProductFieldsEnum["fridgeType"] = 339] = "fridgeType";
    ProductFieldsEnum[ProductFieldsEnum["fridgeFreezerArrangement"] = 340] = "fridgeFreezerArrangement";
    ProductFieldsEnum[ProductFieldsEnum["euCatOfHhRefrigeratingModel"] = 341] = "euCatOfHhRefrigeratingModel";
    ProductFieldsEnum[ProductFieldsEnum["coverDoorInstallationSystem"] = 342] = "coverDoorInstallationSystem";
    ProductFieldsEnum[ProductFieldsEnum["fridgeWaterIceDispenser"] = 343] = "fridgeWaterIceDispenser";
    ProductFieldsEnum[ProductFieldsEnum["splitType"] = 344] = "splitType";
    ProductFieldsEnum[ProductFieldsEnum["numberOfFridgeFreezerCompartments"] = 345] = "numberOfFridgeFreezerCompartments";
    ProductFieldsEnum[ProductFieldsEnum["numberOfDrawersBaskets"] = 346] = "numberOfDrawersBaskets";
    ProductFieldsEnum[ProductFieldsEnum["numberOfFreezingFlaps"] = 347] = "numberOfFreezingFlaps";
    ProductFieldsEnum[ProductFieldsEnum["numberOfCompressors"] = 348] = "numberOfCompressors";
    ProductFieldsEnum[ProductFieldsEnum["numberOfIndependentCoolingSystems"] = 349] = "numberOfIndependentCoolingSystems";
    ProductFieldsEnum[ProductFieldsEnum["numberOfTemperatureZones"] = 350] = "numberOfTemperatureZones";
    ProductFieldsEnum[ProductFieldsEnum["fridgeNumberOfShelves"] = 351] = "fridgeNumberOfShelves";
    ProductFieldsEnum[ProductFieldsEnum["fridgeNumberOfAdjustableShelves"] = 352] = "fridgeNumberOfAdjustableShelves";
    ProductFieldsEnum[ProductFieldsEnum["fridgeShelfMaterial"] = 353] = "fridgeShelfMaterial";
    ProductFieldsEnum[ProductFieldsEnum["fridgeNumberOfDrawers"] = 354] = "fridgeNumberOfDrawers";
    ProductFieldsEnum[ProductFieldsEnum["freezerNumberOfShelves"] = 355] = "freezerNumberOfShelves";
    ProductFieldsEnum[ProductFieldsEnum["freezerNumberOfAdjustableShelves"] = 356] = "freezerNumberOfAdjustableShelves";
    ProductFieldsEnum[ProductFieldsEnum["freezerNumberOfDrawers"] = 357] = "freezerNumberOfDrawers";
    ProductFieldsEnum[ProductFieldsEnum["freezerShelfMaterial"] = 358] = "freezerShelfMaterial";
    ProductFieldsEnum[ProductFieldsEnum["bordeauxBottleCapacity"] = 359] = "bordeauxBottleCapacity";
    ProductFieldsEnum[ProductFieldsEnum["humidifyingEquipment"] = 360] = "humidifyingEquipment";
    ProductFieldsEnum[ProductFieldsEnum["thermometerFreezerSection"] = 361] = "thermometerFreezerSection";
    ProductFieldsEnum[ProductFieldsEnum["thermometerFridgeSection"] = 362] = "thermometerFridgeSection";
    ProductFieldsEnum[ProductFieldsEnum["defrostProcessFridge"] = 363] = "defrostProcessFridge";
    ProductFieldsEnum[ProductFieldsEnum["defrostProcessFreezer"] = 364] = "defrostProcessFreezer";
    ProductFieldsEnum[ProductFieldsEnum["isFrostFree"] = 365] = "isFrostFree";
    ProductFieldsEnum[ProductFieldsEnum["hasMotorDrivenIceMaker"] = 366] = "hasMotorDrivenIceMaker";
    ProductFieldsEnum[ProductFieldsEnum["hasSeparatedAirFlow"] = 367] = "hasSeparatedAirFlow";
    ProductFieldsEnum[ProductFieldsEnum["hasWaterDispenser"] = 368] = "hasWaterDispenser";
    ProductFieldsEnum[ProductFieldsEnum["hasIceDispenser"] = 369] = "hasIceDispenser";
    ProductFieldsEnum[ProductFieldsEnum["hasWaterIceDispenser"] = 370] = "hasWaterIceDispenser";
    ProductFieldsEnum[ProductFieldsEnum["hasWaterThawDrainageSystem"] = 371] = "hasWaterThawDrainageSystem";
    ProductFieldsEnum[ProductFieldsEnum["hasOpenDoorAlert"] = 372] = "hasOpenDoorAlert";
    ProductFieldsEnum[ProductFieldsEnum["hasFridgeOpenDoorAlert"] = 373] = "hasFridgeOpenDoorAlert";
    ProductFieldsEnum[ProductFieldsEnum["hasFreezerOpenDoorAlert"] = 374] = "hasFreezerOpenDoorAlert";
    ProductFieldsEnum[ProductFieldsEnum["hasFridgeFreezerIntegration"] = 375] = "hasFridgeFreezerIntegration";
    ProductFieldsEnum[ProductFieldsEnum["hasFridgeAdjustableShelves"] = 376] = "hasFridgeAdjustableShelves";
    ProductFieldsEnum[ProductFieldsEnum["hasFreezerAdjustableShelves"] = 377] = "hasFreezerAdjustableShelves";
    ProductFieldsEnum[ProductFieldsEnum["hasReversibleDoor"] = 378] = "hasReversibleDoor";
    ProductFieldsEnum[ProductFieldsEnum["hasTemperatureAdjustment"] = 379] = "hasTemperatureAdjustment";
    ProductFieldsEnum[ProductFieldsEnum["hasFridgeTemperatureAdjustment"] = 380] = "hasFridgeTemperatureAdjustment";
    ProductFieldsEnum[ProductFieldsEnum["hasFreezerTemperatureAdjustment"] = 381] = "hasFreezerTemperatureAdjustment";
    ProductFieldsEnum[ProductFieldsEnum["hasPowerFailureSafeStorage"] = 382] = "hasPowerFailureSafeStorage";
    ProductFieldsEnum[ProductFieldsEnum["hasWarningSignalMalfunction"] = 383] = "hasWarningSignalMalfunction";
    ProductFieldsEnum[ProductFieldsEnum["hasInteriorVentilationFridge"] = 384] = "hasInteriorVentilationFridge";
    ProductFieldsEnum[ProductFieldsEnum["hasFastFreezeFunction"] = 385] = "hasFastFreezeFunction";
    ProductFieldsEnum[ProductFieldsEnum["hasFastCoolingFunction"] = 386] = "hasFastCoolingFunction";
    ProductFieldsEnum[ProductFieldsEnum["hasFastFreezeCompartment"] = 387] = "hasFastFreezeCompartment";
    ProductFieldsEnum[ProductFieldsEnum["hasFrozenFoodCompartment"] = 388] = "hasFrozenFoodCompartment";
    ProductFieldsEnum[ProductFieldsEnum["hasIceCubeTray"] = 389] = "hasIceCubeTray";
    ProductFieldsEnum[ProductFieldsEnum["hasBeverageCompartment"] = 390] = "hasBeverageCompartment";
    ProductFieldsEnum[ProductFieldsEnum["hasCheeseCompartment"] = 391] = "hasCheeseCompartment";
    ProductFieldsEnum[ProductFieldsEnum["hasEggTray"] = 392] = "hasEggTray";
    ProductFieldsEnum[ProductFieldsEnum["hasVegetableCompartment"] = 393] = "hasVegetableCompartment";
    ProductFieldsEnum[ProductFieldsEnum["hasSaladCrisper"] = 394] = "hasSaladCrisper";
    ProductFieldsEnum[ProductFieldsEnum["hasFreshFoodsCompartment"] = 395] = "hasFreshFoodsCompartment";
    ProductFieldsEnum[ProductFieldsEnum["hasShelfForBottles"] = 396] = "hasShelfForBottles";
    ProductFieldsEnum[ProductFieldsEnum["fridgeGrossCapacity"] = 397] = "fridgeGrossCapacity";
    ProductFieldsEnum[ProductFieldsEnum["fridgeGrossCapacityUOM"] = 398] = "fridgeGrossCapacityUOM";
    ProductFieldsEnum[ProductFieldsEnum["freezerGrossCapacity"] = 399] = "freezerGrossCapacity";
    ProductFieldsEnum[ProductFieldsEnum["freezerGrossCapacityUOM"] = 400] = "freezerGrossCapacityUOM";
    ProductFieldsEnum[ProductFieldsEnum["fridgeNetCapacity"] = 401] = "fridgeNetCapacity";
    ProductFieldsEnum[ProductFieldsEnum["fridgeNetCapacityUOM"] = 402] = "fridgeNetCapacityUOM";
    ProductFieldsEnum[ProductFieldsEnum["freezerNetCapacity"] = 403] = "freezerNetCapacity";
    ProductFieldsEnum[ProductFieldsEnum["freezerNetCapacityUOM"] = 404] = "freezerNetCapacityUOM";
    ProductFieldsEnum[ProductFieldsEnum["temperatureRiseTime"] = 405] = "temperatureRiseTime";
    ProductFieldsEnum[ProductFieldsEnum["temperatureRiseTimeUOM"] = 406] = "temperatureRiseTimeUOM";
    ProductFieldsEnum[ProductFieldsEnum["designTemperature"] = 407] = "designTemperature";
    ProductFieldsEnum[ProductFieldsEnum["designTemperatureUOM"] = 408] = "designTemperatureUOM";
    ProductFieldsEnum[ProductFieldsEnum["minAmbientTemperature"] = 409] = "minAmbientTemperature";
    ProductFieldsEnum[ProductFieldsEnum["minAmbientTemperatureUOM"] = 410] = "minAmbientTemperatureUOM";
    ProductFieldsEnum[ProductFieldsEnum["maxAmbientTemperature"] = 411] = "maxAmbientTemperature";
    ProductFieldsEnum[ProductFieldsEnum["maxAmbientTemperatureUOM"] = 412] = "maxAmbientTemperatureUOM";
    ProductFieldsEnum[ProductFieldsEnum["depthWithDoorOpen"] = 413] = "depthWithDoorOpen";
    ProductFieldsEnum[ProductFieldsEnum["depthWithDoorOpenUOM"] = 414] = "depthWithDoorOpenUOM";
    ProductFieldsEnum[ProductFieldsEnum["typology"] = 415] = "typology";
    ProductFieldsEnum[ProductFieldsEnum["fitType"] = 416] = "fitType";
    ProductFieldsEnum[ProductFieldsEnum["mainColor"] = 417] = "mainColor";
    ProductFieldsEnum[ProductFieldsEnum["secondaryColor"] = 418] = "secondaryColor";
    ProductFieldsEnum[ProductFieldsEnum["appliancesControlPanel"] = 419] = "appliancesControlPanel";
    ProductFieldsEnum[ProductFieldsEnum["controlPanelMaterial"] = 420] = "controlPanelMaterial";
    ProductFieldsEnum[ProductFieldsEnum["typeOfControl"] = 421] = "typeOfControl";
    ProductFieldsEnum[ProductFieldsEnum["typeOfControlSettings"] = 422] = "typeOfControlSettings";
    ProductFieldsEnum[ProductFieldsEnum["constructionType"] = 423] = "constructionType";
    ProductFieldsEnum[ProductFieldsEnum["constructionMaterial"] = 424] = "constructionMaterial";
    ProductFieldsEnum[ProductFieldsEnum["installationType"] = 425] = "installationType";
    ProductFieldsEnum[ProductFieldsEnum["cableStorage"] = 426] = "cableStorage";
    ProductFieldsEnum[ProductFieldsEnum["climateClass"] = 427] = "climateClass";
    ProductFieldsEnum[ProductFieldsEnum["safetyFeatures"] = 428] = "safetyFeatures";
    ProductFieldsEnum[ProductFieldsEnum["cleaningFeatures"] = 429] = "cleaningFeatures";
    ProductFieldsEnum[ProductFieldsEnum["energyInput"] = 430] = "energyInput";
    ProductFieldsEnum[ProductFieldsEnum["typeOfLight"] = 431] = "typeOfLight";
    ProductFieldsEnum[ProductFieldsEnum["lightControlType"] = 432] = "lightControlType";
    ProductFieldsEnum[ProductFieldsEnum["positionOfInteriorLights"] = 433] = "positionOfInteriorLights";
    ProductFieldsEnum[ProductFieldsEnum["portionSizes"] = 434] = "portionSizes";
    ProductFieldsEnum[ProductFieldsEnum["coffeeSystem"] = 435] = "coffeeSystem";
    ProductFieldsEnum[ProductFieldsEnum["waterProtectionSystemDescription"] = 436] = "waterProtectionSystemDescription";
    ProductFieldsEnum[ProductFieldsEnum["waterGaugeType"] = 437] = "waterGaugeType";
    ProductFieldsEnum[ProductFieldsEnum["additionalProgramOptions"] = 438] = "additionalProgramOptions";
    ProductFieldsEnum[ProductFieldsEnum["doorColor"] = 439] = "doorColor";
    ProductFieldsEnum[ProductFieldsEnum["doorMaterial"] = 440] = "doorMaterial";
    ProductFieldsEnum[ProductFieldsEnum["doorD\u00E9corPanel"] = 441] = "doorD\u00E9corPanel";
    ProductFieldsEnum[ProductFieldsEnum["doorHingeType"] = 442] = "doorHingeType";
    ProductFieldsEnum[ProductFieldsEnum["doorOpeningType"] = 443] = "doorOpeningType";
    ProductFieldsEnum[ProductFieldsEnum["adjustableFeet"] = 444] = "adjustableFeet";
    ProductFieldsEnum[ProductFieldsEnum["filterType"] = 445] = "filterType";
    ProductFieldsEnum[ProductFieldsEnum["cylinderType"] = 446] = "cylinderType";
    ProductFieldsEnum[ProductFieldsEnum["powerSupply"] = 447] = "powerSupply";
    ProductFieldsEnum[ProductFieldsEnum["applianceWattage"] = 448] = "applianceWattage";
    ProductFieldsEnum[ProductFieldsEnum["applianceCurrent"] = 449] = "applianceCurrent";
    ProductFieldsEnum[ProductFieldsEnum["applianceVoltage"] = 450] = "applianceVoltage";
    ProductFieldsEnum[ProductFieldsEnum["applianceFrequency"] = 451] = "applianceFrequency";
    ProductFieldsEnum[ProductFieldsEnum["approvalCertificates"] = 452] = "approvalCertificates";
    ProductFieldsEnum[ProductFieldsEnum["languagesDisplayed"] = 453] = "languagesDisplayed";
    ProductFieldsEnum[ProductFieldsEnum["includedApplianceAccessory"] = 454] = "includedApplianceAccessory";
    ProductFieldsEnum[ProductFieldsEnum["optionalApplianceAccessory"] = 455] = "optionalApplianceAccessory";
    ProductFieldsEnum[ProductFieldsEnum["listOfPrograms"] = 456] = "listOfPrograms";
    ProductFieldsEnum[ProductFieldsEnum["plugType"] = 457] = "plugType";
    ProductFieldsEnum[ProductFieldsEnum["toolsIncluded"] = 458] = "toolsIncluded";
    ProductFieldsEnum[ProductFieldsEnum["numberOfPrograms"] = 459] = "numberOfPrograms";
    ProductFieldsEnum[ProductFieldsEnum["numberOfBrowningLevels"] = 460] = "numberOfBrowningLevels";
    ProductFieldsEnum[ProductFieldsEnum["numberOfPowerLevels"] = 461] = "numberOfPowerLevels";
    ProductFieldsEnum[ProductFieldsEnum["numberOfAppliancesSpeeds"] = 462] = "numberOfAppliancesSpeeds";
    ProductFieldsEnum[ProductFieldsEnum["numberOfSlots"] = 463] = "numberOfSlots";
    ProductFieldsEnum[ProductFieldsEnum["numberOfAttachments"] = 464] = "numberOfAttachments";
    ProductFieldsEnum[ProductFieldsEnum["numberOfPumps"] = 465] = "numberOfPumps";
    ProductFieldsEnum[ProductFieldsEnum["numberOfHeatingElements"] = 466] = "numberOfHeatingElements";
    ProductFieldsEnum[ProductFieldsEnum["numberOfIndicators"] = 467] = "numberOfIndicators";
    ProductFieldsEnum[ProductFieldsEnum["numberOfMotors"] = 468] = "numberOfMotors";
    ProductFieldsEnum[ProductFieldsEnum["numberOfLights"] = 469] = "numberOfLights";
    ProductFieldsEnum[ProductFieldsEnum["maxNumberOfReferencePlates"] = 470] = "maxNumberOfReferencePlates";
    ProductFieldsEnum[ProductFieldsEnum["maxNumberOfEspressoCups"] = 471] = "maxNumberOfEspressoCups";
    ProductFieldsEnum[ProductFieldsEnum["hasPowerOnIndicator"] = 472] = "hasPowerOnIndicator";
    ProductFieldsEnum[ProductFieldsEnum["hasRemoteControl"] = 473] = "hasRemoteControl";
    ProductFieldsEnum[ProductFieldsEnum["applianceHasWheels"] = 474] = "applianceHasWheels";
    ProductFieldsEnum[ProductFieldsEnum["hasColumnInstallation"] = 475] = "hasColumnInstallation";
    ProductFieldsEnum[ProductFieldsEnum["hasElectronicIgnition"] = 476] = "hasElectronicIgnition";
    ProductFieldsEnum[ProductFieldsEnum["hasSoftwareUpdate"] = 477] = "hasSoftwareUpdate";
    ProductFieldsEnum[ProductFieldsEnum["hasSpeedControl"] = 478] = "hasSpeedControl";
    ProductFieldsEnum[ProductFieldsEnum["isUpright"] = 479] = "isUpright";
    ProductFieldsEnum[ProductFieldsEnum["isBagless"] = 480] = "isBagless";
    ProductFieldsEnum[ProductFieldsEnum["hasWaterGauge"] = 481] = "hasWaterGauge";
    ProductFieldsEnum[ProductFieldsEnum["hasWaterProtectionSystem"] = 482] = "hasWaterProtectionSystem";
    ProductFieldsEnum[ProductFieldsEnum["canRapidBoil"] = 483] = "canRapidBoil";
    ProductFieldsEnum[ProductFieldsEnum["hasLimescaleFilter"] = 484] = "hasLimescaleFilter";
    ProductFieldsEnum[ProductFieldsEnum["hasTemperatureSelector"] = 485] = "hasTemperatureSelector";
    ProductFieldsEnum[ProductFieldsEnum["isDishwasherSafe"] = 486] = "isDishwasherSafe";
    ProductFieldsEnum[ProductFieldsEnum["hasFrothingNozzle"] = 487] = "hasFrothingNozzle";
    ProductFieldsEnum[ProductFieldsEnum["hasHotWaterSpout"] = 488] = "hasHotWaterSpout";
    ProductFieldsEnum[ProductFieldsEnum["hasCoffeeGroundsContainer"] = 489] = "hasCoffeeGroundsContainer";
    ProductFieldsEnum[ProductFieldsEnum["hasRemovableBrewUnit"] = 490] = "hasRemovableBrewUnit";
    ProductFieldsEnum[ProductFieldsEnum["hasPreBrewSystem"] = 491] = "hasPreBrewSystem";
    ProductFieldsEnum[ProductFieldsEnum["hasPreGrindSystem"] = 492] = "hasPreGrindSystem";
    ProductFieldsEnum[ProductFieldsEnum["hasPrepare2Cups"] = 493] = "hasPrepare2Cups";
    ProductFieldsEnum[ProductFieldsEnum["hasStandbyFunction"] = 494] = "hasStandbyFunction";
    ProductFieldsEnum[ProductFieldsEnum["hasInteriorLight"] = 495] = "hasInteriorLight";
    ProductFieldsEnum[ProductFieldsEnum["hasClock"] = 496] = "hasClock";
    ProductFieldsEnum[ProductFieldsEnum["hasElectricTimer"] = 497] = "hasElectricTimer";
    ProductFieldsEnum[ProductFieldsEnum["hasDelayTimer"] = 498] = "hasDelayTimer";
    ProductFieldsEnum[ProductFieldsEnum["hasDoor"] = 499] = "hasDoor";
    ProductFieldsEnum[ProductFieldsEnum["hasDoorHinge"] = 500] = "hasDoorHinge";
    ProductFieldsEnum[ProductFieldsEnum["hasWideDoorOpening"] = 501] = "hasWideDoorOpening";
    ProductFieldsEnum[ProductFieldsEnum["hasLockableDoor"] = 502] = "hasLockableDoor";
    ProductFieldsEnum[ProductFieldsEnum["hasCrushIce"] = 503] = "hasCrushIce";
    ProductFieldsEnum[ProductFieldsEnum["hasSteamShot"] = 504] = "hasSteamShot";
    ProductFieldsEnum[ProductFieldsEnum["hasSteamControl"] = 505] = "hasSteamControl";
    ProductFieldsEnum[ProductFieldsEnum["hasResidualHeatIndicator"] = 506] = "hasResidualHeatIndicator";
    ProductFieldsEnum[ProductFieldsEnum["hasRemovableWorkTop"] = 507] = "hasRemovableWorkTop";
    ProductFieldsEnum[ProductFieldsEnum["isIntegrated"] = 508] = "isIntegrated";
    ProductFieldsEnum[ProductFieldsEnum["grossCapacity"] = 509] = "grossCapacity";
    ProductFieldsEnum[ProductFieldsEnum["grossCapacityUOM"] = 510] = "grossCapacityUOM";
    ProductFieldsEnum[ProductFieldsEnum["netCapacity"] = 511] = "netCapacity";
    ProductFieldsEnum[ProductFieldsEnum["netCapacityUOM"] = 512] = "netCapacityUOM";
    ProductFieldsEnum[ProductFieldsEnum["jugCapacity"] = 513] = "jugCapacity";
    ProductFieldsEnum[ProductFieldsEnum["jugCapacityUOM"] = 514] = "jugCapacityUOM";
    ProductFieldsEnum[ProductFieldsEnum["liquidCapacity"] = 515] = "liquidCapacity";
    ProductFieldsEnum[ProductFieldsEnum["liquidCapacityUOM"] = 516] = "liquidCapacityUOM";
    ProductFieldsEnum[ProductFieldsEnum["dustCapacity"] = 517] = "dustCapacity";
    ProductFieldsEnum[ProductFieldsEnum["dustCapacityUOM"] = 518] = "dustCapacityUOM";
    ProductFieldsEnum[ProductFieldsEnum["waterContainerCapacity"] = 519] = "waterContainerCapacity";
    ProductFieldsEnum[ProductFieldsEnum["waterContainerCapacityUOM"] = 520] = "waterContainerCapacityUOM";
    ProductFieldsEnum[ProductFieldsEnum["beanContainerCapacity"] = 521] = "beanContainerCapacity";
    ProductFieldsEnum[ProductFieldsEnum["beanContainerCapacityUOM"] = 522] = "beanContainerCapacityUOM";
    ProductFieldsEnum[ProductFieldsEnum["bottleCapacity"] = 523] = "bottleCapacity";
    ProductFieldsEnum[ProductFieldsEnum["bottleCapacityUOM"] = 524] = "bottleCapacityUOM";
    ProductFieldsEnum[ProductFieldsEnum["bowlCapacity"] = 525] = "bowlCapacity";
    ProductFieldsEnum[ProductFieldsEnum["bowlCapacityUOM"] = 526] = "bowlCapacityUOM";
    ProductFieldsEnum[ProductFieldsEnum["useableCavityVolume"] = 527] = "useableCavityVolume";
    ProductFieldsEnum[ProductFieldsEnum["useableCavityVolumeUOM"] = 528] = "useableCavityVolumeUOM";
    ProductFieldsEnum[ProductFieldsEnum["depthWithDoor90Degrees"] = 529] = "depthWithDoor90Degrees";
    ProductFieldsEnum[ProductFieldsEnum["depthWithDoor90DegreesUOM"] = 530] = "depthWithDoor90DegreesUOM";
    ProductFieldsEnum[ProductFieldsEnum["removableWorkTopHeight"] = 531] = "removableWorkTopHeight";
    ProductFieldsEnum[ProductFieldsEnum["removableWorkTopHeightUOM"] = 532] = "removableWorkTopHeightUOM";
    ProductFieldsEnum[ProductFieldsEnum["cableLength"] = 533] = "cableLength";
    ProductFieldsEnum[ProductFieldsEnum["cableLengthUOM"] = 534] = "cableLengthUOM";
    ProductFieldsEnum[ProductFieldsEnum["cordLength"] = 535] = "cordLength";
    ProductFieldsEnum[ProductFieldsEnum["cordLengthUOM"] = 536] = "cordLengthUOM";
    ProductFieldsEnum[ProductFieldsEnum["referencePlateDiameter"] = 537] = "referencePlateDiameter";
    ProductFieldsEnum[ProductFieldsEnum["referencePlateDiameterUOM"] = 538] = "referencePlateDiameterUOM";
    ProductFieldsEnum[ProductFieldsEnum["deviceReach"] = 539] = "deviceReach";
    ProductFieldsEnum[ProductFieldsEnum["deviceReachUOM"] = 540] = "deviceReachUOM";
    ProductFieldsEnum[ProductFieldsEnum["minNicheHeight"] = 541] = "minNicheHeight";
    ProductFieldsEnum[ProductFieldsEnum["minNicheHeightUOM"] = 542] = "minNicheHeightUOM";
    ProductFieldsEnum[ProductFieldsEnum["maxNicheHeight"] = 543] = "maxNicheHeight";
    ProductFieldsEnum[ProductFieldsEnum["maxNicheHeightUOM"] = 544] = "maxNicheHeightUOM";
    ProductFieldsEnum[ProductFieldsEnum["minNicheWidth"] = 545] = "minNicheWidth";
    ProductFieldsEnum[ProductFieldsEnum["minNicheWidthUOM"] = 546] = "minNicheWidthUOM";
    ProductFieldsEnum[ProductFieldsEnum["maxNicheWidth"] = 547] = "maxNicheWidth";
    ProductFieldsEnum[ProductFieldsEnum["maxNicheWidthUOM"] = 548] = "maxNicheWidthUOM";
    ProductFieldsEnum[ProductFieldsEnum["nicheDepth"] = 549] = "nicheDepth";
    ProductFieldsEnum[ProductFieldsEnum["nicheDepthUOM"] = 550] = "nicheDepthUOM";
    ProductFieldsEnum[ProductFieldsEnum["adjustableBaseMeasurement"] = 551] = "adjustableBaseMeasurement";
    ProductFieldsEnum[ProductFieldsEnum["adjustableBaseMeasurementUOM"] = 552] = "adjustableBaseMeasurementUOM";
    ProductFieldsEnum[ProductFieldsEnum["adjustableFeetMeasurement"] = 553] = "adjustableFeetMeasurement";
    ProductFieldsEnum[ProductFieldsEnum["adjustableFeetMeasurementUOM"] = 554] = "adjustableFeetMeasurementUOM";
    ProductFieldsEnum[ProductFieldsEnum["leftOnDuration"] = 555] = "leftOnDuration";
    ProductFieldsEnum[ProductFieldsEnum["leftOnDurationUOM"] = 556] = "leftOnDurationUOM";
    ProductFieldsEnum[ProductFieldsEnum["startDelayTimeMax"] = 557] = "startDelayTimeMax";
    ProductFieldsEnum[ProductFieldsEnum["startDelayTimeMaxUOM"] = 558] = "startDelayTimeMaxUOM";
    ProductFieldsEnum[ProductFieldsEnum["stopDelayTimeMax"] = 559] = "stopDelayTimeMax";
    ProductFieldsEnum[ProductFieldsEnum["stopDelayTimeMaxUOM"] = 560] = "stopDelayTimeMaxUOM";
    ProductFieldsEnum[ProductFieldsEnum["hobType"] = 561] = "hobType";
    ProductFieldsEnum[ProductFieldsEnum["energyType"] = 562] = "energyType";
    ProductFieldsEnum[ProductFieldsEnum["cookerOvenType"] = 563] = "cookerOvenType";
    ProductFieldsEnum[ProductFieldsEnum["microwaveOvenType"] = 564] = "microwaveOvenType";
    ProductFieldsEnum[ProductFieldsEnum["cookerOvenControlPanel"] = 565] = "cookerOvenControlPanel";
    ProductFieldsEnum[ProductFieldsEnum["cookerOvenControlPanelLocation"] = 566] = "cookerOvenControlPanelLocation";
    ProductFieldsEnum[ProductFieldsEnum["cookerOvenTimerControl"] = 567] = "cookerOvenTimerControl";
    ProductFieldsEnum[ProductFieldsEnum["cookerOvenTimeOptions"] = 568] = "cookerOvenTimeOptions";
    ProductFieldsEnum[ProductFieldsEnum["manualControlDevices"] = 569] = "manualControlDevices";
    ProductFieldsEnum[ProductFieldsEnum["automaticControlDevices"] = 570] = "automaticControlDevices";
    ProductFieldsEnum[ProductFieldsEnum["steamGeneratorLocation"] = 571] = "steamGeneratorLocation";
    ProductFieldsEnum[ProductFieldsEnum["operatingMode"] = 572] = "operatingMode";
    ProductFieldsEnum[ProductFieldsEnum["typeOfAutoCooking"] = 573] = "typeOfAutoCooking";
    ProductFieldsEnum[ProductFieldsEnum["chimneyMaterial"] = 574] = "chimneyMaterial";
    ProductFieldsEnum[ProductFieldsEnum["chimneyColor"] = 575] = "chimneyColor";
    ProductFieldsEnum[ProductFieldsEnum["microwaveCavityMaterial"] = 576] = "microwaveCavityMaterial";
    ProductFieldsEnum[ProductFieldsEnum["motorLocation"] = 577] = "motorLocation";
    ProductFieldsEnum[ProductFieldsEnum["surfaceMaterial"] = 578] = "surfaceMaterial";
    ProductFieldsEnum[ProductFieldsEnum["typeOfFrame"] = 579] = "typeOfFrame";
    ProductFieldsEnum[ProductFieldsEnum["colorOfFrame"] = 580] = "colorOfFrame";
    ProductFieldsEnum[ProductFieldsEnum["grillType"] = 581] = "grillType";
    ProductFieldsEnum[ProductFieldsEnum["grillFuel"] = 582] = "grillFuel";
    ProductFieldsEnum[ProductFieldsEnum["grillBasinMaterial"] = 583] = "grillBasinMaterial";
    ProductFieldsEnum[ProductFieldsEnum["grillGratingMaterial"] = 584] = "grillGratingMaterial";
    ProductFieldsEnum[ProductFieldsEnum["fuelType"] = 585] = "fuelType";
    ProductFieldsEnum[ProductFieldsEnum["alternativeFuelType"] = 586] = "alternativeFuelType";
    ProductFieldsEnum[ProductFieldsEnum["gasConnectionLocation"] = 587] = "gasConnectionLocation";
    ProductFieldsEnum[ProductFieldsEnum["gasAverageEfficiency"] = 588] = "gasAverageEfficiency";
    ProductFieldsEnum[ProductFieldsEnum["gasHobEfficiency"] = 589] = "gasHobEfficiency";
    ProductFieldsEnum[ProductFieldsEnum["fluidDynamicEfficiency"] = 590] = "fluidDynamicEfficiency";
    ProductFieldsEnum[ProductFieldsEnum["fluidDynamicEfficiencyClass"] = 591] = "fluidDynamicEfficiencyClass";
    ProductFieldsEnum[ProductFieldsEnum["lightingEfficiency"] = 592] = "lightingEfficiency";
    ProductFieldsEnum[ProductFieldsEnum["lightingEfficiencyClass"] = 593] = "lightingEfficiencyClass";
    ProductFieldsEnum[ProductFieldsEnum["greaseFilteringEfficiency"] = 594] = "greaseFilteringEfficiency";
    ProductFieldsEnum[ProductFieldsEnum["greaseFilteringEfficiencyClass"] = 595] = "greaseFilteringEfficiencyClass";
    ProductFieldsEnum[ProductFieldsEnum["maxAirFlow"] = 596] = "maxAirFlow";
    ProductFieldsEnum[ProductFieldsEnum["minAirFlow"] = 597] = "minAirFlow";
    ProductFieldsEnum[ProductFieldsEnum["airFlowBoost"] = 598] = "airFlowBoost";
    ProductFieldsEnum[ProductFieldsEnum["soundPowerMaxSpeed"] = 599] = "soundPowerMaxSpeed";
    ProductFieldsEnum[ProductFieldsEnum["soundPowerMinSpeed"] = 600] = "soundPowerMinSpeed";
    ProductFieldsEnum[ProductFieldsEnum["soundPowerBoost"] = 601] = "soundPowerBoost";
    ProductFieldsEnum[ProductFieldsEnum["noiseLevelBoostPosition"] = 602] = "noiseLevelBoostPosition";
    ProductFieldsEnum[ProductFieldsEnum["adjustableTemperatureRange"] = 603] = "adjustableTemperatureRange";
    ProductFieldsEnum[ProductFieldsEnum["maxOutputAirExtraction"] = 604] = "maxOutputAirExtraction";
    ProductFieldsEnum[ProductFieldsEnum["boostPositionAirExtraction"] = 605] = "boostPositionAirExtraction";
    ProductFieldsEnum[ProductFieldsEnum["maxOutputRecirculatingAir"] = 606] = "maxOutputRecirculatingAir";
    ProductFieldsEnum[ProductFieldsEnum["boostPositionOutputRecirculating"] = 607] = "boostPositionOutputRecirculating";
    ProductFieldsEnum[ProductFieldsEnum["typeOfRegulation"] = 608] = "typeOfRegulation";
    ProductFieldsEnum[ProductFieldsEnum["typeOfLid"] = 609] = "typeOfLid";
    ProductFieldsEnum[ProductFieldsEnum["typeOfPanSupport"] = 610] = "typeOfPanSupport";
    ProductFieldsEnum[ProductFieldsEnum["typeOfSafetyForGas"] = 611] = "typeOfSafetyForGas";
    ProductFieldsEnum[ProductFieldsEnum["residualHeatIndicatorType"] = 612] = "residualHeatIndicatorType";
    ProductFieldsEnum[ProductFieldsEnum["gasBurnerEfficiency"] = 613] = "gasBurnerEfficiency";
    ProductFieldsEnum[ProductFieldsEnum["heatingElementType"] = 614] = "heatingElementType";
    ProductFieldsEnum[ProductFieldsEnum["heatingElementPower"] = 615] = "heatingElementPower";
    ProductFieldsEnum[ProductFieldsEnum["heatingElementLocation"] = 616] = "heatingElementLocation";
    ProductFieldsEnum[ProductFieldsEnum["typeOfHeatingElement"] = 617] = "typeOfHeatingElement";
    ProductFieldsEnum[ProductFieldsEnum["greaseFilterMaterial"] = 618] = "greaseFilterMaterial";
    ProductFieldsEnum[ProductFieldsEnum["greaseFilterType"] = 619] = "greaseFilterType";
    ProductFieldsEnum[ProductFieldsEnum["cookerOvenGuides"] = 620] = "cookerOvenGuides";
    ProductFieldsEnum[ProductFieldsEnum["integratedCleaningSystem"] = 621] = "integratedCleaningSystem";
    ProductFieldsEnum[ProductFieldsEnum["grillPower"] = 622] = "grillPower";
    ProductFieldsEnum[ProductFieldsEnum["maxMicrowavePower"] = 623] = "maxMicrowavePower";
    ProductFieldsEnum[ProductFieldsEnum["burnerPowerRange"] = 624] = "burnerPowerRange";
    ProductFieldsEnum[ProductFieldsEnum["totalPowerOfMotors"] = 625] = "totalPowerOfMotors";
    ProductFieldsEnum[ProductFieldsEnum["cookerCompartmentType"] = 626] = "cookerCompartmentType";
    ProductFieldsEnum[ProductFieldsEnum["cookerCompartmentCookingMethod"] = 627] = "cookerCompartmentCookingMethod";
    ProductFieldsEnum[ProductFieldsEnum["cookerCompartmentGrillType"] = 628] = "cookerCompartmentGrillType";
    ProductFieldsEnum[ProductFieldsEnum["cookerCompartmentFuelType"] = 629] = "cookerCompartmentFuelType";
    ProductFieldsEnum[ProductFieldsEnum["cookerCompartmentEnergyEffClass"] = 630] = "cookerCompartmentEnergyEffClass";
    ProductFieldsEnum[ProductFieldsEnum["cookerCompartmentEnergyEffIndex"] = 631] = "cookerCompartmentEnergyEffIndex";
    ProductFieldsEnum[ProductFieldsEnum["cookerCompartmentCleaningSystem"] = 632] = "cookerCompartmentCleaningSystem";
    ProductFieldsEnum[ProductFieldsEnum["cookerCompartmentNumberOfShelves"] = 633] = "cookerCompartmentNumberOfShelves";
    ProductFieldsEnum[ProductFieldsEnum["cookerCompartmentNumberOfGrids"] = 634] = "cookerCompartmentNumberOfGrids";
    ProductFieldsEnum[ProductFieldsEnum["cookerCompartmentDoorMaterial"] = 635] = "cookerCompartmentDoorMaterial";
    ProductFieldsEnum[ProductFieldsEnum["cookingMethods"] = 636] = "cookingMethods";
    ProductFieldsEnum[ProductFieldsEnum["numberOfCookingCompartments"] = 637] = "numberOfCookingCompartments";
    ProductFieldsEnum[ProductFieldsEnum["numberOfBurners"] = 638] = "numberOfBurners";
    ProductFieldsEnum[ProductFieldsEnum["numberOfGasBurners"] = 639] = "numberOfGasBurners";
    ProductFieldsEnum[ProductFieldsEnum["numberOfBurnersUsedSimultaneously"] = 640] = "numberOfBurnersUsedSimultaneously";
    ProductFieldsEnum[ProductFieldsEnum["numberOfElectricCookingZones"] = 641] = "numberOfElectricCookingZones";
    ProductFieldsEnum[ProductFieldsEnum["numberOfElectricPlates"] = 642] = "numberOfElectricPlates";
    ProductFieldsEnum[ProductFieldsEnum["numberOfRadiantPlates"] = 643] = "numberOfRadiantPlates";
    ProductFieldsEnum[ProductFieldsEnum["numberOfHalogenPlates"] = 644] = "numberOfHalogenPlates";
    ProductFieldsEnum[ProductFieldsEnum["numberOfInductionPlates"] = 645] = "numberOfInductionPlates";
    ProductFieldsEnum[ProductFieldsEnum["numberOfElectricWarmingZones"] = 646] = "numberOfElectricWarmingZones";
    ProductFieldsEnum[ProductFieldsEnum["numberOfCookerOvenTrays"] = 647] = "numberOfCookerOvenTrays";
    ProductFieldsEnum[ProductFieldsEnum["numberOfCookingPrograms"] = 648] = "numberOfCookingPrograms";
    ProductFieldsEnum[ProductFieldsEnum["numberOfHoodSpeeds"] = 649] = "numberOfHoodSpeeds";
    ProductFieldsEnum[ProductFieldsEnum["ignitionSystem"] = 650] = "ignitionSystem";
    ProductFieldsEnum[ProductFieldsEnum["mainOnoffSwitch"] = 651] = "mainOnoffSwitch";
    ProductFieldsEnum[ProductFieldsEnum["cookerOverAutomaticPrograms"] = 652] = "cookerOverAutomaticPrograms";
    ProductFieldsEnum[ProductFieldsEnum["combineCookingZones"] = 653] = "combineCookingZones";
    ProductFieldsEnum[ProductFieldsEnum["noReturnAirFlowFlap"] = 654] = "noReturnAirFlowFlap";
    ProductFieldsEnum[ProductFieldsEnum["odorFilter"] = 655] = "odorFilter";
    ProductFieldsEnum[ProductFieldsEnum["turntable"] = 656] = "turntable";
    ProductFieldsEnum[ProductFieldsEnum["drainValve"] = 657] = "drainValve";
    ProductFieldsEnum[ProductFieldsEnum["hasCookerCompartmentMotorizedSpit"] = 658] = "hasCookerCompartmentMotorizedSpit";
    ProductFieldsEnum[ProductFieldsEnum["hasCookerCompartmentProbe"] = 659] = "hasCookerCompartmentProbe";
    ProductFieldsEnum[ProductFieldsEnum["hasCookerCompartmentTimer"] = 660] = "hasCookerCompartmentTimer";
    ProductFieldsEnum[ProductFieldsEnum["hasCookerCompartmentInteriorLight"] = 661] = "hasCookerCompartmentInteriorLight";
    ProductFieldsEnum[ProductFieldsEnum["hasGasConnection"] = 662] = "hasGasConnection";
    ProductFieldsEnum[ProductFieldsEnum["hasGrillCookingMethod"] = 663] = "hasGrillCookingMethod";
    ProductFieldsEnum[ProductFieldsEnum["hasFanCookingMethod"] = 664] = "hasFanCookingMethod";
    ProductFieldsEnum[ProductFieldsEnum["hasConventionalCookingMethod"] = 665] = "hasConventionalCookingMethod";
    ProductFieldsEnum[ProductFieldsEnum["hasWokBurner"] = 666] = "hasWokBurner";
    ProductFieldsEnum[ProductFieldsEnum["hasGriddle"] = 667] = "hasGriddle";
    ProductFieldsEnum[ProductFieldsEnum["hasIntegratedControls"] = 668] = "hasIntegratedControls";
    ProductFieldsEnum[ProductFieldsEnum["microwaveCavityHeight"] = 669] = "microwaveCavityHeight";
    ProductFieldsEnum[ProductFieldsEnum["microwaveCavityHeightUOM"] = 670] = "microwaveCavityHeightUOM";
    ProductFieldsEnum[ProductFieldsEnum["microwaveCavityWidth"] = 671] = "microwaveCavityWidth";
    ProductFieldsEnum[ProductFieldsEnum["microwaveCavityWidthUOM"] = 672] = "microwaveCavityWidthUOM";
    ProductFieldsEnum[ProductFieldsEnum["microwaveCavityDepth"] = 673] = "microwaveCavityDepth";
    ProductFieldsEnum[ProductFieldsEnum["microwaveCavityDepthUOM"] = 674] = "microwaveCavityDepthUOM";
    ProductFieldsEnum[ProductFieldsEnum["turntableDiameter"] = 675] = "turntableDiameter";
    ProductFieldsEnum[ProductFieldsEnum["turntableDiameterUOM"] = 676] = "turntableDiameterUOM";
    ProductFieldsEnum[ProductFieldsEnum["heightWithoutChimney"] = 677] = "heightWithoutChimney";
    ProductFieldsEnum[ProductFieldsEnum["heightWithoutChimneyUOM"] = 678] = "heightWithoutChimneyUOM";
    ProductFieldsEnum[ProductFieldsEnum["diameterOfAirOutlet"] = 679] = "diameterOfAirOutlet";
    ProductFieldsEnum[ProductFieldsEnum["diameterOfAirOutletUOM"] = 680] = "diameterOfAirOutletUOM";
    ProductFieldsEnum[ProductFieldsEnum["cookingCavityHeight"] = 681] = "cookingCavityHeight";
    ProductFieldsEnum[ProductFieldsEnum["cookingCavityHeightUOM"] = 682] = "cookingCavityHeightUOM";
    ProductFieldsEnum[ProductFieldsEnum["cookingCavityWidth"] = 683] = "cookingCavityWidth";
    ProductFieldsEnum[ProductFieldsEnum["cookingCavityWidthUOM"] = 684] = "cookingCavityWidthUOM";
    ProductFieldsEnum[ProductFieldsEnum["cookingCavityDepth"] = 685] = "cookingCavityDepth";
    ProductFieldsEnum[ProductFieldsEnum["cookingCavityDepthUOM"] = 686] = "cookingCavityDepthUOM";
    ProductFieldsEnum[ProductFieldsEnum["heatingElementDimension"] = 687] = "heatingElementDimension";
    ProductFieldsEnum[ProductFieldsEnum["heatingElementDimensionUOM"] = 688] = "heatingElementDimensionUOM";
    ProductFieldsEnum[ProductFieldsEnum["microwaveCavityCapacity"] = 689] = "microwaveCavityCapacity";
    ProductFieldsEnum[ProductFieldsEnum["microwaveCavityCapacityUOM"] = 690] = "microwaveCavityCapacityUOM";
    ProductFieldsEnum[ProductFieldsEnum["waterTankVolume"] = 691] = "waterTankVolume";
    ProductFieldsEnum[ProductFieldsEnum["waterTankVolumeUOM"] = 692] = "waterTankVolumeUOM";
    ProductFieldsEnum[ProductFieldsEnum["cookingUsableVolume"] = 693] = "cookingUsableVolume";
    ProductFieldsEnum[ProductFieldsEnum["cookingUsableVolumeUOM"] = 694] = "cookingUsableVolumeUOM";
    ProductFieldsEnum[ProductFieldsEnum["cookerCompartmentCapacity"] = 695] = "cookerCompartmentCapacity";
    ProductFieldsEnum[ProductFieldsEnum["cookerCompartmentCapacityUOM"] = 696] = "cookerCompartmentCapacityUOM";
    ProductFieldsEnum[ProductFieldsEnum["numberOfPlaceSettings"] = 697] = "numberOfPlaceSettings";
    ProductFieldsEnum[ProductFieldsEnum["dishwasherNumberOfWashTemperatures"] = 698] = "dishwasherNumberOfWashTemperatures";
    ProductFieldsEnum[ProductFieldsEnum["dishwasherNumberOfPrograms"] = 699] = "dishwasherNumberOfPrograms";
    ProductFieldsEnum[ProductFieldsEnum["dishwasherControlPanel"] = 700] = "dishwasherControlPanel";
    ProductFieldsEnum[ProductFieldsEnum["dishwasherTypeOfControl"] = 701] = "dishwasherTypeOfControl";
    ProductFieldsEnum[ProductFieldsEnum["dishwasherTubMaterial"] = 702] = "dishwasherTubMaterial";
    ProductFieldsEnum[ProductFieldsEnum["adjustableBase"] = 703] = "adjustableBase";
    ProductFieldsEnum[ProductFieldsEnum["dishwasherRefProgram"] = 704] = "dishwasherRefProgram";
    ProductFieldsEnum[ProductFieldsEnum["dishwasherCleaningPerformance"] = 705] = "dishwasherCleaningPerformance";
    ProductFieldsEnum[ProductFieldsEnum["dishwasherDryingPerformance"] = 706] = "dishwasherDryingPerformance";
    ProductFieldsEnum[ProductFieldsEnum["dishwasherDryingSystem"] = 707] = "dishwasherDryingSystem";
    ProductFieldsEnum[ProductFieldsEnum["dishwasherStartDelayOption"] = 708] = "dishwasherStartDelayOption";
    ProductFieldsEnum[ProductFieldsEnum["singleBasketWashing"] = 709] = "singleBasketWashing";
    ProductFieldsEnum[ProductFieldsEnum["adjustableUpperBasket"] = 710] = "adjustableUpperBasket";
    ProductFieldsEnum[ProductFieldsEnum["basketWithHandle"] = 711] = "basketWithHandle";
    ProductFieldsEnum[ProductFieldsEnum["cutleryCase"] = 712] = "cutleryCase";
    ProductFieldsEnum[ProductFieldsEnum["hasAutomaticPrograms"] = 713] = "hasAutomaticPrograms";
    ProductFieldsEnum[ProductFieldsEnum["hasDelicateProgram"] = 714] = "hasDelicateProgram";
    ProductFieldsEnum[ProductFieldsEnum["hasHalfLoadOption"] = 715] = "hasHalfLoadOption";
    ProductFieldsEnum[ProductFieldsEnum["hasDishwasherQuickWash"] = 716] = "hasDishwasherQuickWash";
    ProductFieldsEnum[ProductFieldsEnum["hasCycleIndicator"] = 717] = "hasCycleIndicator";
    ProductFieldsEnum[ProductFieldsEnum["hasEndOfCycleAlert"] = 718] = "hasEndOfCycleAlert";
    ProductFieldsEnum[ProductFieldsEnum["hasDigitalCountdown"] = 719] = "hasDigitalCountdown";
    ProductFieldsEnum[ProductFieldsEnum["hiddenHeatElement"] = 720] = "hiddenHeatElement";
    ProductFieldsEnum[ProductFieldsEnum["saltLightIndicator"] = 721] = "saltLightIndicator";
    ProductFieldsEnum[ProductFieldsEnum["rinseLightIndicator"] = 722] = "rinseLightIndicator";
    ProductFieldsEnum[ProductFieldsEnum["waterSoftener"] = 723] = "waterSoftener";
    ProductFieldsEnum[ProductFieldsEnum["lowerBasketWash"] = 724] = "lowerBasketWash";
    ProductFieldsEnum[ProductFieldsEnum["intakeHoseLength"] = 725] = "intakeHoseLength";
    ProductFieldsEnum[ProductFieldsEnum["intakeHoseLengthUOM"] = 726] = "intakeHoseLengthUOM";
    ProductFieldsEnum[ProductFieldsEnum["outgoingHoseLength"] = 727] = "outgoingHoseLength";
    ProductFieldsEnum[ProductFieldsEnum["outgoingHoseLengthUOM"] = 728] = "outgoingHoseLengthUOM";
    ProductFieldsEnum[ProductFieldsEnum["openDoorDepth"] = 729] = "openDoorDepth";
    ProductFieldsEnum[ProductFieldsEnum["openDoorDepthUOM"] = 730] = "openDoorDepthUOM";
    ProductFieldsEnum[ProductFieldsEnum["minWashTemperature"] = 731] = "minWashTemperature";
    ProductFieldsEnum[ProductFieldsEnum["minWashTemperatureUOM"] = 732] = "minWashTemperatureUOM";
    ProductFieldsEnum[ProductFieldsEnum["maxWashTemperature"] = 733] = "maxWashTemperature";
    ProductFieldsEnum[ProductFieldsEnum["maxWashTemperatureUOM"] = 734] = "maxWashTemperatureUOM";
    ProductFieldsEnum[ProductFieldsEnum["maxIntakeWaterTemp"] = 735] = "maxIntakeWaterTemp";
    ProductFieldsEnum[ProductFieldsEnum["maxIntakeWaterTempUOM"] = 736] = "maxIntakeWaterTempUOM";
    ProductFieldsEnum[ProductFieldsEnum["washerType"] = 737] = "washerType";
    ProductFieldsEnum[ProductFieldsEnum["washerDrumMaterial"] = 738] = "washerDrumMaterial";
    ProductFieldsEnum[ProductFieldsEnum["washerDoorType"] = 739] = "washerDoorType";
    ProductFieldsEnum[ProductFieldsEnum["dryerType"] = 740] = "dryerType";
    ProductFieldsEnum[ProductFieldsEnum["dryerDrumMaterial"] = 741] = "dryerDrumMaterial";
    ProductFieldsEnum[ProductFieldsEnum["dryerDoorType"] = 742] = "dryerDoorType";
    ProductFieldsEnum[ProductFieldsEnum["dryerPowerHeatingElement"] = 743] = "dryerPowerHeatingElement";
    ProductFieldsEnum[ProductFieldsEnum["dryerTemperatureRange"] = 744] = "dryerTemperatureRange";
    ProductFieldsEnum[ProductFieldsEnum["dryingProcess"] = 745] = "dryingProcess";
    ProductFieldsEnum[ProductFieldsEnum["washerDryerControlPanel"] = 746] = "washerDryerControlPanel";
    ProductFieldsEnum[ProductFieldsEnum["waterSupply"] = 747] = "waterSupply";
    ProductFieldsEnum[ProductFieldsEnum["loadingType"] = 748] = "loadingType";
    ProductFieldsEnum[ProductFieldsEnum["condensationEffClass"] = 749] = "condensationEffClass";
    ProductFieldsEnum[ProductFieldsEnum["standardCottonProgram"] = 750] = "standardCottonProgram";
    ProductFieldsEnum[ProductFieldsEnum["avgCondensationEffFull"] = 751] = "avgCondensationEffFull";
    ProductFieldsEnum[ProductFieldsEnum["avgCondensationEffPartial"] = 752] = "avgCondensationEffPartial";
    ProductFieldsEnum[ProductFieldsEnum["weightedCondensationEff"] = 753] = "weightedCondensationEff";
    ProductFieldsEnum[ProductFieldsEnum["moistureMonitoringSystem"] = 754] = "moistureMonitoringSystem";
    ProductFieldsEnum[ProductFieldsEnum["moistureContentAfterMaxSpin"] = 755] = "moistureContentAfterMaxSpin";
    ProductFieldsEnum[ProductFieldsEnum["locationOfVentExit"] = 756] = "locationOfVentExit";
    ProductFieldsEnum[ProductFieldsEnum["progressIndicator"] = 757] = "progressIndicator";
    ProductFieldsEnum[ProductFieldsEnum["startDelayOption"] = 758] = "startDelayOption";
    ProductFieldsEnum[ProductFieldsEnum["startDelayOrStopDelayOption"] = 759] = "startDelayOrStopDelayOption";
    ProductFieldsEnum[ProductFieldsEnum["delicateDryCycle"] = 760] = "delicateDryCycle";
    ProductFieldsEnum[ProductFieldsEnum["endOfCycleIndicator"] = 761] = "endOfCycleIndicator";
    ProductFieldsEnum[ProductFieldsEnum["washingPerformanceClass"] = 762] = "washingPerformanceClass";
    ProductFieldsEnum[ProductFieldsEnum["spinSpeedOptions"] = 763] = "spinSpeedOptions";
    ProductFieldsEnum[ProductFieldsEnum["separateTempControlOptions"] = 764] = "separateTempControlOptions";
    ProductFieldsEnum[ProductFieldsEnum["spinDryPerformanceClass"] = 765] = "spinDryPerformanceClass";
    ProductFieldsEnum[ProductFieldsEnum["numberOfWashPrograms"] = 766] = "numberOfWashPrograms";
    ProductFieldsEnum[ProductFieldsEnum["numberOfDryPrograms"] = 767] = "numberOfDryPrograms";
    ProductFieldsEnum[ProductFieldsEnum["hasAdjustableDryingTemperature"] = 768] = "hasAdjustableDryingTemperature";
    ProductFieldsEnum[ProductFieldsEnum["hasAdjustableWashingTemperature"] = 769] = "hasAdjustableWashingTemperature";
    ProductFieldsEnum[ProductFieldsEnum["hasHotWaterIntake"] = 770] = "hasHotWaterIntake";
    ProductFieldsEnum[ProductFieldsEnum["hasColdWaterIntake"] = 771] = "hasColdWaterIntake";
    ProductFieldsEnum[ProductFieldsEnum["hasHotColdWaterIntake"] = 772] = "hasHotColdWaterIntake";
    ProductFieldsEnum[ProductFieldsEnum["hasDryingTimeSelector"] = 773] = "hasDryingTimeSelector";
    ProductFieldsEnum[ProductFieldsEnum["hasVentHose"] = 774] = "hasVentHose";
    ProductFieldsEnum[ProductFieldsEnum["hasDigitalCountdownIndicator"] = 775] = "hasDigitalCountdownIndicator";
    ProductFieldsEnum[ProductFieldsEnum["hasReverseTumbleAction"] = 776] = "hasReverseTumbleAction";
    ProductFieldsEnum[ProductFieldsEnum["hasControlPanelLock"] = 777] = "hasControlPanelLock";
    ProductFieldsEnum[ProductFieldsEnum["hasDailyQuickProgram"] = 778] = "hasDailyQuickProgram";
    ProductFieldsEnum[ProductFieldsEnum["has3DDynamicWash"] = 779] = "has3DDynamicWash";
    ProductFieldsEnum[ProductFieldsEnum["hasEconomyWash"] = 780] = "hasEconomyWash";
    ProductFieldsEnum[ProductFieldsEnum["hasHalfLoad"] = 781] = "hasHalfLoad";
    ProductFieldsEnum[ProductFieldsEnum["hasHandWash"] = 782] = "hasHandWash";
    ProductFieldsEnum[ProductFieldsEnum["hasPreWash"] = 783] = "hasPreWash";
    ProductFieldsEnum[ProductFieldsEnum["hasQuickWash"] = 784] = "hasQuickWash";
    ProductFieldsEnum[ProductFieldsEnum["hasQuickDry"] = 785] = "hasQuickDry";
    ProductFieldsEnum[ProductFieldsEnum["hasRinseHold"] = 786] = "hasRinseHold";
    ProductFieldsEnum[ProductFieldsEnum["hasColdWash"] = 787] = "hasColdWash";
    ProductFieldsEnum[ProductFieldsEnum["hasWaterPlus"] = 788] = "hasWaterPlus";
    ProductFieldsEnum[ProductFieldsEnum["hasSkipSpinCycle"] = 789] = "hasSkipSpinCycle";
    ProductFieldsEnum[ProductFieldsEnum["hasWeightMeasurement"] = 790] = "hasWeightMeasurement";
    ProductFieldsEnum[ProductFieldsEnum["hasDirtyRecognition"] = 791] = "hasDirtyRecognition";
    ProductFieldsEnum[ProductFieldsEnum["hasSilkWash"] = 792] = "hasSilkWash";
    ProductFieldsEnum[ProductFieldsEnum["hasExtraSpin"] = 793] = "hasExtraSpin";
    ProductFieldsEnum[ProductFieldsEnum["hasMixedLoad"] = 794] = "hasMixedLoad";
    ProductFieldsEnum[ProductFieldsEnum["hasFoamControl"] = 795] = "hasFoamControl";
    ProductFieldsEnum[ProductFieldsEnum["hasBalanceControl"] = 796] = "hasBalanceControl";
    ProductFieldsEnum[ProductFieldsEnum["hasWoolProgram"] = 797] = "hasWoolProgram";
    ProductFieldsEnum[ProductFieldsEnum["hasDelicateWash"] = 798] = "hasDelicateWash";
    ProductFieldsEnum[ProductFieldsEnum["hasAllergyCare"] = 799] = "hasAllergyCare";
    ProductFieldsEnum[ProductFieldsEnum["hasIntelligentWashSystem"] = 800] = "hasIntelligentWashSystem";
    ProductFieldsEnum[ProductFieldsEnum["hasIntensiveCycle"] = 801] = "hasIntensiveCycle";
    ProductFieldsEnum[ProductFieldsEnum["hasSportsProgram"] = 802] = "hasSportsProgram";
    ProductFieldsEnum[ProductFieldsEnum["hasCottonProgram"] = 803] = "hasCottonProgram";
    ProductFieldsEnum[ProductFieldsEnum["hasSynthetics"] = 804] = "hasSynthetics";
    ProductFieldsEnum[ProductFieldsEnum["hasBabyProgram"] = 805] = "hasBabyProgram";
    ProductFieldsEnum[ProductFieldsEnum["hasAntiCreaseProgram"] = 806] = "hasAntiCreaseProgram";
    ProductFieldsEnum[ProductFieldsEnum["hasFinalCoolTumbleDry"] = 807] = "hasFinalCoolTumbleDry";
    ProductFieldsEnum[ProductFieldsEnum["hasFullTankIndicator"] = 808] = "hasFullTankIndicator";
    ProductFieldsEnum[ProductFieldsEnum["hasFullFilterIndicator"] = 809] = "hasFullFilterIndicator";
    ProductFieldsEnum[ProductFieldsEnum["hasBlockedFilterIndicator"] = 810] = "hasBlockedFilterIndicator";
    ProductFieldsEnum[ProductFieldsEnum["hasExhaustWaterPipe"] = 811] = "hasExhaustWaterPipe";
    ProductFieldsEnum[ProductFieldsEnum["washerDrumCapacity"] = 812] = "washerDrumCapacity";
    ProductFieldsEnum[ProductFieldsEnum["washerDrumCapacityUOM"] = 813] = "washerDrumCapacityUOM";
    ProductFieldsEnum[ProductFieldsEnum["dryerDrumCapacity"] = 814] = "dryerDrumCapacity";
    ProductFieldsEnum[ProductFieldsEnum["dryerDrumCapacityUOM"] = 815] = "dryerDrumCapacityUOM";
    ProductFieldsEnum[ProductFieldsEnum["waterConsumptionFullLoad"] = 816] = "waterConsumptionFullLoad";
    ProductFieldsEnum[ProductFieldsEnum["waterConsumptionFullLoadUOM"] = 817] = "waterConsumptionFullLoadUOM";
    ProductFieldsEnum[ProductFieldsEnum["washerMaxSpinSpeed"] = 818] = "washerMaxSpinSpeed";
    ProductFieldsEnum[ProductFieldsEnum["washerMaxSpinSpeedUOM"] = 819] = "washerMaxSpinSpeedUOM";
    ProductFieldsEnum[ProductFieldsEnum["dryerMaxSpinSpeed"] = 820] = "dryerMaxSpinSpeed";
    ProductFieldsEnum[ProductFieldsEnum["dryerMaxSpinSpeedUOM"] = 821] = "dryerMaxSpinSpeedUOM";
    ProductFieldsEnum[ProductFieldsEnum["cottonCapacityWashing"] = 822] = "cottonCapacityWashing";
    ProductFieldsEnum[ProductFieldsEnum["cottonCapacityWashingUOM"] = 823] = "cottonCapacityWashingUOM";
    ProductFieldsEnum[ProductFieldsEnum["cottonCapacityDrying"] = 824] = "cottonCapacityDrying";
    ProductFieldsEnum[ProductFieldsEnum["cottonCapacityDryingUOM"] = 825] = "cottonCapacityDryingUOM";
    ProductFieldsEnum[ProductFieldsEnum["washerSpinNoiseLevel"] = 826] = "washerSpinNoiseLevel";
    ProductFieldsEnum[ProductFieldsEnum["washerSpinNoiseLevelUOM"] = 827] = "washerSpinNoiseLevelUOM";
    ProductFieldsEnum[ProductFieldsEnum["washerNoiseLevel"] = 828] = "washerNoiseLevel";
    ProductFieldsEnum[ProductFieldsEnum["washerNoiseLevelUOM"] = 829] = "washerNoiseLevelUOM";
    ProductFieldsEnum[ProductFieldsEnum["dryerNoiseLevel"] = 830] = "dryerNoiseLevel";
    ProductFieldsEnum[ProductFieldsEnum["dryerNoiseLevelUOM"] = 831] = "dryerNoiseLevelUOM";
    ProductFieldsEnum[ProductFieldsEnum["quickWashTime"] = 832] = "quickWashTime";
    ProductFieldsEnum[ProductFieldsEnum["quickWashTimeUOM"] = 833] = "quickWashTimeUOM";
    ProductFieldsEnum[ProductFieldsEnum["avgWashTimeCottonFullLoad"] = 834] = "avgWashTimeCottonFullLoad";
    ProductFieldsEnum[ProductFieldsEnum["avgWashTimeCottonFullLoadUOM"] = 835] = "avgWashTimeCottonFullLoadUOM";
    ProductFieldsEnum[ProductFieldsEnum["avgWashTimeCottonPartialLoad"] = 836] = "avgWashTimeCottonPartialLoad";
    ProductFieldsEnum[ProductFieldsEnum["avgWashTimeCottonPartialLoadUOM"] = 837] = "avgWashTimeCottonPartialLoadUOM";
    ProductFieldsEnum[ProductFieldsEnum["standardCottonTimeFull"] = 838] = "standardCottonTimeFull";
    ProductFieldsEnum[ProductFieldsEnum["standardCottonTimeFullUOM"] = 839] = "standardCottonTimeFullUOM";
    ProductFieldsEnum[ProductFieldsEnum["standardCottonTimeHalf"] = 840] = "standardCottonTimeHalf";
    ProductFieldsEnum[ProductFieldsEnum["standardCottonTimeHalfUOM"] = 841] = "standardCottonTimeHalfUOM";
    ProductFieldsEnum[ProductFieldsEnum["weightedProgramTime"] = 842] = "weightedProgramTime";
    ProductFieldsEnum[ProductFieldsEnum["weightedProgramTimeUOM"] = 843] = "weightedProgramTimeUOM";
    ProductFieldsEnum[ProductFieldsEnum["ventHoseLength"] = 844] = "ventHoseLength";
    ProductFieldsEnum[ProductFieldsEnum["ventHoseLengthUOM"] = 845] = "ventHoseLengthUOM";
    ProductFieldsEnum[ProductFieldsEnum["washerWindowSize"] = 846] = "washerWindowSize";
    ProductFieldsEnum[ProductFieldsEnum["washerWindowSizeUOM"] = 847] = "washerWindowSizeUOM";
    ProductFieldsEnum[ProductFieldsEnum["dryerWindowSize"] = 848] = "dryerWindowSize";
    ProductFieldsEnum[ProductFieldsEnum["dryerWindowSizeUOM"] = 849] = "dryerWindowSizeUOM";
    ProductFieldsEnum[ProductFieldsEnum["sinkFinish"] = 850] = "sinkFinish";
    ProductFieldsEnum[ProductFieldsEnum["tapStyle"] = 851] = "tapStyle";
    ProductFieldsEnum[ProductFieldsEnum["tapType"] = 852] = "tapType";
    ProductFieldsEnum[ProductFieldsEnum["tapMaterial"] = 853] = "tapMaterial";
    ProductFieldsEnum[ProductFieldsEnum["variationDetails"] = 854] = "variationDetails";
    ProductFieldsEnum[ProductFieldsEnum["minBaseUnit"] = 855] = "minBaseUnit";
    ProductFieldsEnum[ProductFieldsEnum["overflow"] = 856] = "overflow";
    ProductFieldsEnum[ProductFieldsEnum["gaskets"] = 857] = "gaskets";
    ProductFieldsEnum[ProductFieldsEnum["fixingClips"] = 858] = "fixingClips";
    ProductFieldsEnum[ProductFieldsEnum["numberOfBowls"] = 859] = "numberOfBowls";
    ProductFieldsEnum[ProductFieldsEnum["numberOfDrains"] = 860] = "numberOfDrains";
    ProductFieldsEnum[ProductFieldsEnum["hasDrain"] = 861] = "hasDrain";
    ProductFieldsEnum[ProductFieldsEnum["hasChilledWater"] = 862] = "hasChilledWater";
    ProductFieldsEnum[ProductFieldsEnum["hasColdWater"] = 863] = "hasColdWater";
    ProductFieldsEnum[ProductFieldsEnum["hasHotWater"] = 864] = "hasHotWater";
    ProductFieldsEnum[ProductFieldsEnum["hasPullOutSpray"] = 865] = "hasPullOutSpray";
    ProductFieldsEnum[ProductFieldsEnum["drainWidth"] = 866] = "drainWidth";
    ProductFieldsEnum[ProductFieldsEnum["drainWidthUOM"] = 867] = "drainWidthUOM";
    ProductFieldsEnum[ProductFieldsEnum["tapHeight"] = 868] = "tapHeight";
    ProductFieldsEnum[ProductFieldsEnum["tapHeightUOM"] = 869] = "tapHeightUOM";
    ProductFieldsEnum[ProductFieldsEnum["spoutReach"] = 870] = "spoutReach";
    ProductFieldsEnum[ProductFieldsEnum["spoutReachUOM"] = 871] = "spoutReachUOM";
    ProductFieldsEnum[ProductFieldsEnum["spoutHeight"] = 872] = "spoutHeight";
    ProductFieldsEnum[ProductFieldsEnum["spoutHeightUOM"] = 873] = "spoutHeightUOM";
    ProductFieldsEnum[ProductFieldsEnum["tvResolution"] = 874] = "tvResolution";
    ProductFieldsEnum[ProductFieldsEnum["tvType"] = 875] = "tvType";
    ProductFieldsEnum[ProductFieldsEnum["inputTypes"] = 876] = "inputTypes";
    ProductFieldsEnum[ProductFieldsEnum["numberOfInputs"] = 877] = "numberOfInputs";
    ProductFieldsEnum[ProductFieldsEnum["numberOfHdmiInputs"] = 878] = "numberOfHdmiInputs";
    ProductFieldsEnum[ProductFieldsEnum["isSmartTv"] = 879] = "isSmartTv";
    ProductFieldsEnum[ProductFieldsEnum["is4K"] = 880] = "is4K";
    ProductFieldsEnum[ProductFieldsEnum["is3D"] = 881] = "is3D";
    ProductFieldsEnum[ProductFieldsEnum["hasFreeView"] = 882] = "hasFreeView";
    ProductFieldsEnum[ProductFieldsEnum["isHD"] = 883] = "isHD";
    ProductFieldsEnum[ProductFieldsEnum["hasDolbyVision"] = 884] = "hasDolbyVision";
    ProductFieldsEnum[ProductFieldsEnum["isCurved"] = 885] = "isCurved";
    ProductFieldsEnum[ProductFieldsEnum["hasInternetConnection"] = 886] = "hasInternetConnection";
    ProductFieldsEnum[ProductFieldsEnum["hasDvdPlayer"] = 887] = "hasDvdPlayer";
    ProductFieldsEnum[ProductFieldsEnum["hasTvStand"] = 888] = "hasTvStand";
    ProductFieldsEnum[ProductFieldsEnum["isTvWallMountable"] = 889] = "isTvWallMountable";
    ProductFieldsEnum[ProductFieldsEnum["tvSize"] = 890] = "tvSize";
    ProductFieldsEnum[ProductFieldsEnum["tvSizeUOM"] = 891] = "tvSizeUOM";
    ProductFieldsEnum[ProductFieldsEnum["supplierProductKey"] = 892] = "supplierProductKey";
    ProductFieldsEnum[ProductFieldsEnum["isExcluded"] = 893] = "isExcluded";
    ProductFieldsEnum[ProductFieldsEnum["consumerPackageQuantity"] = 894] = "consumerPackageQuantity";
    ProductFieldsEnum[ProductFieldsEnum["masterPackCaseQuantity"] = 895] = "masterPackCaseQuantity";
    ProductFieldsEnum[ProductFieldsEnum["palletInformationUPC"] = 896] = "palletInformationUPC";
    ProductFieldsEnum[ProductFieldsEnum["sccCode"] = 897] = "sccCode";
    ProductFieldsEnum[ProductFieldsEnum["gaugeDimension"] = 898] = "gaugeDimension";
    ProductFieldsEnum[ProductFieldsEnum["gaugeDimensionUOM"] = 899] = "gaugeDimensionUOM";
    ProductFieldsEnum[ProductFieldsEnum["groupCost"] = 900] = "groupCost";
    ProductFieldsEnum[ProductFieldsEnum["groupCostCurrency"] = 901] = "groupCostCurrency";
    ProductFieldsEnum[ProductFieldsEnum["memberCost"] = 902] = "memberCost";
    ProductFieldsEnum[ProductFieldsEnum["memberCostCurrency"] = 903] = "memberCostCurrency";
    ProductFieldsEnum[ProductFieldsEnum["scentName"] = 904] = "scentName";
    ProductFieldsEnum[ProductFieldsEnum["material"] = 905] = "material";
    ProductFieldsEnum[ProductFieldsEnum["consumerPackageUPC"] = 906] = "consumerPackageUPC";
    ProductFieldsEnum[ProductFieldsEnum["showOnlineStartDate"] = 907] = "showOnlineStartDate";
    ProductFieldsEnum[ProductFieldsEnum["showOnlineEndDate"] = 908] = "showOnlineEndDate";
    ProductFieldsEnum[ProductFieldsEnum["maximumPressureRating"] = 909] = "maximumPressureRating";
    ProductFieldsEnum[ProductFieldsEnum["tankCapacity"] = 910] = "tankCapacity";
    ProductFieldsEnum[ProductFieldsEnum["tankCapacityUOM"] = 911] = "tankCapacityUOM";
    ProductFieldsEnum[ProductFieldsEnum["hoseDiameter"] = 912] = "hoseDiameter";
    ProductFieldsEnum[ProductFieldsEnum["hoseDiameterUOM"] = 913] = "hoseDiameterUOM";
    ProductFieldsEnum[ProductFieldsEnum["hasAdjustableHeatSettings"] = 914] = "hasAdjustableHeatSettings";
    ProductFieldsEnum[ProductFieldsEnum["hasApparelBatteriesIncluded"] = 915] = "hasApparelBatteriesIncluded";
    ProductFieldsEnum[ProductFieldsEnum["hasApparelChargerIncluded"] = 916] = "hasApparelChargerIncluded";
    ProductFieldsEnum[ProductFieldsEnum["heatingPanelCount"] = 917] = "heatingPanelCount";
    ProductFieldsEnum[ProductFieldsEnum["heatingZone"] = 918] = "heatingZone";
    ProductFieldsEnum[ProductFieldsEnum["hasApparelHooded"] = 919] = "hasApparelHooded";
    ProductFieldsEnum[ProductFieldsEnum["hasApparelInsulated"] = 920] = "hasApparelInsulated";
    ProductFieldsEnum[ProductFieldsEnum["hasMachineWashable"] = 921] = "hasMachineWashable";
    ProductFieldsEnum[ProductFieldsEnum["hasMoistureManagement"] = 922] = "hasMoistureManagement";
    ProductFieldsEnum[ProductFieldsEnum["pocketsInside"] = 923] = "pocketsInside";
    ProductFieldsEnum[ProductFieldsEnum["pocketsOutside"] = 924] = "pocketsOutside";
    ProductFieldsEnum[ProductFieldsEnum["hasApparelRemovableHood"] = 925] = "hasApparelRemovableHood";
    ProductFieldsEnum[ProductFieldsEnum["hasApparelWaterResistant"] = 926] = "hasApparelWaterResistant";
    ProductFieldsEnum[ProductFieldsEnum["hasApparelWaterproof"] = 927] = "hasApparelWaterproof";
    ProductFieldsEnum[ProductFieldsEnum["batteryAmpereHour"] = 928] = "batteryAmpereHour";
    ProductFieldsEnum[ProductFieldsEnum["hasBatteryChargerIncluded"] = 929] = "hasBatteryChargerIncluded";
    ProductFieldsEnum[ProductFieldsEnum["batteryCount"] = 930] = "batteryCount";
    ProductFieldsEnum[ProductFieldsEnum["batteryLife"] = 931] = "batteryLife";
    ProductFieldsEnum[ProductFieldsEnum["hasBatteryRechargeable"] = 932] = "hasBatteryRechargeable";
    ProductFieldsEnum[ProductFieldsEnum["batterySize"] = 933] = "batterySize";
    ProductFieldsEnum[ProductFieldsEnum["batteryVoltage"] = 934] = "batteryVoltage";
    ProductFieldsEnum[ProductFieldsEnum["chargeTime"] = 935] = "chargeTime";
    ProductFieldsEnum[ProductFieldsEnum["hasAdjustableThroat"] = 936] = "hasAdjustableThroat";
    ProductFieldsEnum[ProductFieldsEnum["handToolsApplication"] = 937] = "handToolsApplication";
    ProductFieldsEnum[ProductFieldsEnum["hasHandToolsBeltClip"] = 938] = "hasHandToolsBeltClip";
    ProductFieldsEnum[ProductFieldsEnum["bevelAngle"] = 939] = "bevelAngle";
    ProductFieldsEnum[ProductFieldsEnum["bevelOrientation"] = 940] = "bevelOrientation";
    ProductFieldsEnum[ProductFieldsEnum["bladeCount"] = 941] = "bladeCount";
    ProductFieldsEnum[ProductFieldsEnum["hasBladeLockable"] = 942] = "hasBladeLockable";
    ProductFieldsEnum[ProductFieldsEnum["bladeMaterial"] = 943] = "bladeMaterial";
    ProductFieldsEnum[ProductFieldsEnum["hasBladeRetractable"] = 944] = "hasBladeRetractable";
    ProductFieldsEnum[ProductFieldsEnum["bladeThickness"] = 945] = "bladeThickness";
    ProductFieldsEnum[ProductFieldsEnum["bladeThicknessUOM"] = 946] = "bladeThicknessUOM";
    ProductFieldsEnum[ProductFieldsEnum["bladeType"] = 947] = "bladeType";
    ProductFieldsEnum[ProductFieldsEnum["boxHeadDesign"] = 948] = "boxHeadDesign";
    ProductFieldsEnum[ProductFieldsEnum["handToolsBulbType"] = 949] = "handToolsBulbType";
    ProductFieldsEnum[ProductFieldsEnum["handToolsCaseContents"] = 950] = "handToolsCaseContents";
    ProductFieldsEnum[ProductFieldsEnum["hasHandToolsCaseIncluded"] = 951] = "hasHandToolsCaseIncluded";
    ProductFieldsEnum[ProductFieldsEnum["hasHandToolsChargerIncluded"] = 952] = "hasHandToolsChargerIncluded";
    ProductFieldsEnum[ProductFieldsEnum["connectionDesign"] = 953] = "connectionDesign";
    ProductFieldsEnum[ProductFieldsEnum["hasCorrugatedSole"] = 954] = "hasCorrugatedSole";
    ProductFieldsEnum[ProductFieldsEnum["crownSizeRange"] = 955] = "crownSizeRange";
    ProductFieldsEnum[ProductFieldsEnum["hasDeepOffset"] = 956] = "hasDeepOffset";
    ProductFieldsEnum[ProductFieldsEnum["dieSize"] = 957] = "dieSize";
    ProductFieldsEnum[ProductFieldsEnum["dieSizeUOM"] = 958] = "dieSizeUOM";
    ProductFieldsEnum[ProductFieldsEnum["driveSize"] = 959] = "driveSize";
    ProductFieldsEnum[ProductFieldsEnum["hasDriverIncluded"] = 960] = "hasDriverIncluded";
    ProductFieldsEnum[ProductFieldsEnum["hasDropForged"] = 961] = "hasDropForged";
    ProductFieldsEnum[ProductFieldsEnum["hasHandToolsElectronic"] = 962] = "hasHandToolsElectronic";
    ProductFieldsEnum[ProductFieldsEnum["fastenerCategory"] = 963] = "fastenerCategory";
    ProductFieldsEnum[ProductFieldsEnum["fastenerDiameter"] = 964] = "fastenerDiameter";
    ProductFieldsEnum[ProductFieldsEnum["fastenerDiameterUOM"] = 965] = "fastenerDiameterUOM";
    ProductFieldsEnum[ProductFieldsEnum["fastenerGaugeRange"] = 966] = "fastenerGaugeRange";
    ProductFieldsEnum[ProductFieldsEnum["fastenerHeadStyle"] = 967] = "fastenerHeadStyle";
    ProductFieldsEnum[ProductFieldsEnum["fastenerLength"] = 968] = "fastenerLength";
    ProductFieldsEnum[ProductFieldsEnum["fastenerLengthRange"] = 969] = "fastenerLengthRange";
    ProductFieldsEnum[ProductFieldsEnum["fastenerLengthUOM"] = 970] = "fastenerLengthUOM";
    ProductFieldsEnum[ProductFieldsEnum["fastenerMaterial"] = 971] = "fastenerMaterial";
    ProductFieldsEnum[ProductFieldsEnum["fastenerPlating"] = 972] = "fastenerPlating";
    ProductFieldsEnum[ProductFieldsEnum["fastenerSize"] = 973] = "fastenerSize";
    ProductFieldsEnum[ProductFieldsEnum["fastenerThreadType"] = 974] = "fastenerThreadType";
    ProductFieldsEnum[ProductFieldsEnum["handToolsFastenerType"] = 975] = "handToolsFastenerType";
    ProductFieldsEnum[ProductFieldsEnum["femaleDriveSize"] = 976] = "femaleDriveSize";
    ProductFieldsEnum[ProductFieldsEnum["frogAngle"] = 977] = "frogAngle";
    ProductFieldsEnum[ProductFieldsEnum["gearRatio"] = 978] = "gearRatio";
    ProductFieldsEnum[ProductFieldsEnum["handleType"] = 979] = "handleType";
    ProductFieldsEnum[ProductFieldsEnum["headMaterial"] = 980] = "headMaterial";
    ProductFieldsEnum[ProductFieldsEnum["hexKeySizes"] = 981] = "hexKeySizes";
    ProductFieldsEnum[ProductFieldsEnum["inchSize"] = 982] = "inchSize";
    ProductFieldsEnum[ProductFieldsEnum["inchSizeSockets"] = 983] = "inchSizeSockets";
    ProductFieldsEnum[ProductFieldsEnum["handToolsIndoorOutdoor"] = 984] = "handToolsIndoorOutdoor";
    ProductFieldsEnum[ProductFieldsEnum["handToolsInsideDiameter"] = 985] = "handToolsInsideDiameter";
    ProductFieldsEnum[ProductFieldsEnum["handToolsInsideDiameterUOM"] = 986] = "handToolsInsideDiameterUOM";
    ProductFieldsEnum[ProductFieldsEnum["hasHandToolsInsulatedHandle"] = 987] = "hasHandToolsInsulatedHandle";
    ProductFieldsEnum[ProductFieldsEnum["jawCapacity"] = 988] = "jawCapacity";
    ProductFieldsEnum[ProductFieldsEnum["jawCapacityUOM"] = 989] = "jawCapacityUOM";
    ProductFieldsEnum[ProductFieldsEnum["jawTipSize"] = 990] = "jawTipSize";
    ProductFieldsEnum[ProductFieldsEnum["jawTipSizeUOM"] = 991] = "jawTipSizeUOM";
    ProductFieldsEnum[ProductFieldsEnum["jawWidth"] = 992] = "jawWidth";
    ProductFieldsEnum[ProductFieldsEnum["jawWidthUOM"] = 993] = "jawWidthUOM";
    ProductFieldsEnum[ProductFieldsEnum["hasLaserBeam360Degrees"] = 994] = "hasLaserBeam360Degrees";
    ProductFieldsEnum[ProductFieldsEnum["laserFunctions"] = 995] = "laserFunctions";
    ProductFieldsEnum[ProductFieldsEnum["laserMaximumDistance"] = 996] = "laserMaximumDistance";
    ProductFieldsEnum[ProductFieldsEnum["laserMaximumDistanceUOM"] = 997] = "laserMaximumDistanceUOM";
    ProductFieldsEnum[ProductFieldsEnum["laserMountingMethod"] = 998] = "laserMountingMethod";
    ProductFieldsEnum[ProductFieldsEnum["hasHandToolsLEDDisplay"] = 999] = "hasHandToolsLEDDisplay";
    ProductFieldsEnum[ProductFieldsEnum["hasHandToolsLegsIncluded"] = 1000] = "hasHandToolsLegsIncluded";
    ProductFieldsEnum[ProductFieldsEnum["lightUnitofMeasureQuantity"] = 1001] = "lightUnitofMeasureQuantity";
    ProductFieldsEnum[ProductFieldsEnum["hasHandToolsLockable"] = 1002] = "hasHandToolsLockable";
    ProductFieldsEnum[ProductFieldsEnum["hasHandToolsMagnetic"] = 1003] = "hasHandToolsMagnetic";
    ProductFieldsEnum[ProductFieldsEnum["maleDriveSize"] = 1004] = "maleDriveSize";
    ProductFieldsEnum[ProductFieldsEnum["markingToolCategory"] = 1005] = "markingToolCategory";
    ProductFieldsEnum[ProductFieldsEnum["maximumFastenerLength"] = 1006] = "maximumFastenerLength";
    ProductFieldsEnum[ProductFieldsEnum["maximumFastenerLengthUOM"] = 1007] = "maximumFastenerLengthUOM";
    ProductFieldsEnum[ProductFieldsEnum["maximumOpening"] = 1008] = "maximumOpening";
    ProductFieldsEnum[ProductFieldsEnum["maximumOpeningUOM"] = 1009] = "maximumOpeningUOM";
    ProductFieldsEnum[ProductFieldsEnum["metricSize"] = 1010] = "metricSize";
    ProductFieldsEnum[ProductFieldsEnum["metricSizeSockets"] = 1011] = "metricSizeSockets";
    ProductFieldsEnum[ProductFieldsEnum["minimumFastenerLength"] = 1012] = "minimumFastenerLength";
    ProductFieldsEnum[ProductFieldsEnum["minimumFastenerLengthUOM"] = 1013] = "minimumFastenerLengthUOM";
    ProductFieldsEnum[ProductFieldsEnum["nailCoating"] = 1014] = "nailCoating";
    ProductFieldsEnum[ProductFieldsEnum["nailGauge"] = 1015] = "nailGauge";
    ProductFieldsEnum[ProductFieldsEnum["nailHeadStyle"] = 1016] = "nailHeadStyle";
    ProductFieldsEnum[ProductFieldsEnum["nailLength"] = 1017] = "nailLength";
    ProductFieldsEnum[ProductFieldsEnum["nailLengthUOM"] = 1018] = "nailLengthUOM";
    ProductFieldsEnum[ProductFieldsEnum["nailMaterial"] = 1019] = "nailMaterial";
    ProductFieldsEnum[ProductFieldsEnum["nailType"] = 1020] = "nailType";
    ProductFieldsEnum[ProductFieldsEnum["numberofVials"] = 1021] = "numberofVials";
    ProductFieldsEnum[ProductFieldsEnum["numberofVialsMeasuringLevel"] = 1022] = "numberofVialsMeasuringLevel";
    ProductFieldsEnum[ProductFieldsEnum["numberofVialsMeasuringPlumb"] = 1023] = "numberofVialsMeasuringPlumb";
    ProductFieldsEnum[ProductFieldsEnum["offsetHeadAngle1"] = 1024] = "offsetHeadAngle1";
    ProductFieldsEnum[ProductFieldsEnum["offsetHeadAngle2"] = 1025] = "offsetHeadAngle2";
    ProductFieldsEnum[ProductFieldsEnum["handToolsOutsideDiameter"] = 1026] = "handToolsOutsideDiameter";
    ProductFieldsEnum[ProductFieldsEnum["handToolsOutsideDiameterUOM"] = 1027] = "handToolsOutsideDiameterUOM";
    ProductFieldsEnum[ProductFieldsEnum["planeBedMaterial"] = 1028] = "planeBedMaterial";
    ProductFieldsEnum[ProductFieldsEnum["punchShape"] = 1029] = "punchShape";
    ProductFieldsEnum[ProductFieldsEnum["punchType"] = 1030] = "punchType";
    ProductFieldsEnum[ProductFieldsEnum["ratchetSize"] = 1031] = "ratchetSize";
    ProductFieldsEnum[ProductFieldsEnum["screwStyle"] = 1032] = "screwStyle";
    ProductFieldsEnum[ProductFieldsEnum["screwType"] = 1033] = "screwType";
    ProductFieldsEnum[ProductFieldsEnum["screwdriverHeadSize"] = 1034] = "screwdriverHeadSize";
    ProductFieldsEnum[ProductFieldsEnum["screwdriverSetsIncluded"] = 1035] = "screwdriverSetsIncluded";
    ProductFieldsEnum[ProductFieldsEnum["screwdriverStyle"] = 1036] = "screwdriverStyle";
    ProductFieldsEnum[ProductFieldsEnum["hasHandToolsSelfAdhesive"] = 1037] = "hasHandToolsSelfAdhesive";
    ProductFieldsEnum[ProductFieldsEnum["hasSelfDrilling"] = 1038] = "hasSelfDrilling";
    ProductFieldsEnum[ProductFieldsEnum["hasSelfTapping"] = 1039] = "hasSelfTapping";
    ProductFieldsEnum[ProductFieldsEnum["sensorRange"] = 1040] = "sensorRange";
    ProductFieldsEnum[ProductFieldsEnum["hasSharpenable"] = 1041] = "hasSharpenable";
    ProductFieldsEnum[ProductFieldsEnum["handToolsSize"] = 1042] = "handToolsSize";
    ProductFieldsEnum[ProductFieldsEnum["hasSocketDeepWell"] = 1043] = "hasSocketDeepWell";
    ProductFieldsEnum[ProductFieldsEnum["socketPoints"] = 1044] = "socketPoints";
    ProductFieldsEnum[ProductFieldsEnum["socketSize"] = 1045] = "socketSize";
    ProductFieldsEnum[ProductFieldsEnum["socketSizeUOM"] = 1046] = "socketSizeUOM";
    ProductFieldsEnum[ProductFieldsEnum["soleLength"] = 1047] = "soleLength";
    ProductFieldsEnum[ProductFieldsEnum["soleLengthUOM"] = 1048] = "soleLengthUOM";
    ProductFieldsEnum[ProductFieldsEnum["soleWidth"] = 1049] = "soleWidth";
    ProductFieldsEnum[ProductFieldsEnum["soleWidthUOM"] = 1050] = "soleWidthUOM";
    ProductFieldsEnum[ProductFieldsEnum["hasStampedSizeIdentification"] = 1051] = "hasStampedSizeIdentification";
    ProductFieldsEnum[ProductFieldsEnum["stapleCrownSize"] = 1052] = "stapleCrownSize";
    ProductFieldsEnum[ProductFieldsEnum["stapleCrownSizeUOM"] = 1053] = "stapleCrownSizeUOM";
    ProductFieldsEnum[ProductFieldsEnum["stapleLegLength"] = 1054] = "stapleLegLength";
    ProductFieldsEnum[ProductFieldsEnum["stapleLegLengthUOM"] = 1055] = "stapleLegLengthUOM";
    ProductFieldsEnum[ProductFieldsEnum["stringLength"] = 1056] = "stringLength";
    ProductFieldsEnum[ProductFieldsEnum["stringLengthUOM"] = 1057] = "stringLengthUOM";
    ProductFieldsEnum[ProductFieldsEnum["tapeLength"] = 1058] = "tapeLength";
    ProductFieldsEnum[ProductFieldsEnum["tapeLengthUOM"] = 1059] = "tapeLengthUOM";
    ProductFieldsEnum[ProductFieldsEnum["tapeWidth"] = 1060] = "tapeWidth";
    ProductFieldsEnum[ProductFieldsEnum["tapeWidthUOM"] = 1061] = "tapeWidthUOM";
    ProductFieldsEnum[ProductFieldsEnum["teethPerInch"] = 1062] = "teethPerInch";
    ProductFieldsEnum[ProductFieldsEnum["throatDepth"] = 1063] = "throatDepth";
    ProductFieldsEnum[ProductFieldsEnum["throatDepthUOM"] = 1064] = "throatDepthUOM";
    ProductFieldsEnum[ProductFieldsEnum["tipSize"] = 1065] = "tipSize";
    ProductFieldsEnum[ProductFieldsEnum["toothConfiguration"] = 1066] = "toothConfiguration";
    ProductFieldsEnum[ProductFieldsEnum["toothCount"] = 1067] = "toothCount";
    ProductFieldsEnum[ProductFieldsEnum["toothMaterial"] = 1068] = "toothMaterial";
    ProductFieldsEnum[ProductFieldsEnum["hasTripodIncluded"] = 1069] = "hasTripodIncluded";
    ProductFieldsEnum[ProductFieldsEnum["hasHandToolsWaterResistant"] = 1070] = "hasHandToolsWaterResistant";
    ProductFieldsEnum[ProductFieldsEnum["wrenchSize"] = 1071] = "wrenchSize";
    ProductFieldsEnum[ProductFieldsEnum["additionalCuttingSpecs"] = 1072] = "additionalCuttingSpecs";
    ProductFieldsEnum[ProductFieldsEnum["powerToolsAirInletSize"] = 1073] = "powerToolsAirInletSize";
    ProductFieldsEnum[ProductFieldsEnum["powerToolsAirInletSizeUOM"] = 1074] = "powerToolsAirInletSizeUOM";
    ProductFieldsEnum[ProductFieldsEnum["airVelocity"] = 1075] = "airVelocity";
    ProductFieldsEnum[ProductFieldsEnum["airVolume"] = 1076] = "airVolume";
    ProductFieldsEnum[ProductFieldsEnum["powerToolsAmperage"] = 1077] = "powerToolsAmperage";
    ProductFieldsEnum[ProductFieldsEnum["arborHoleSize"] = 1078] = "arborHoleSize";
    ProductFieldsEnum[ProductFieldsEnum["arborSize"] = 1079] = "arborSize";
    ProductFieldsEnum[ProductFieldsEnum["arborSizeUOM"] = 1080] = "arborSizeUOM";
    ProductFieldsEnum[ProductFieldsEnum["hasPowerToolsAutomaticShutOff"] = 1081] = "hasPowerToolsAutomaticShutOff";
    ProductFieldsEnum[ProductFieldsEnum["averageAirConsumption"] = 1082] = "averageAirConsumption";
    ProductFieldsEnum[ProductFieldsEnum["beltSize"] = 1083] = "beltSize";
    ProductFieldsEnum[ProductFieldsEnum["beltSizeUOM"] = 1084] = "beltSizeUOM";
    ProductFieldsEnum[ProductFieldsEnum["bevelCapability"] = 1085] = "bevelCapability";
    ProductFieldsEnum[ProductFieldsEnum["bevelCapacity"] = 1086] = "bevelCapacity";
    ProductFieldsEnum[ProductFieldsEnum["bevelDirection"] = 1087] = "bevelDirection";
    ProductFieldsEnum[ProductFieldsEnum["hasBevelStop"] = 1088] = "hasBevelStop";
    ProductFieldsEnum[ProductFieldsEnum["bitChangeType"] = 1089] = "bitChangeType";
    ProductFieldsEnum[ProductFieldsEnum["bitDiameter"] = 1090] = "bitDiameter";
    ProductFieldsEnum[ProductFieldsEnum["bitMaterials"] = 1091] = "bitMaterials";
    ProductFieldsEnum[ProductFieldsEnum["bitSizes"] = 1092] = "bitSizes";
    ProductFieldsEnum[ProductFieldsEnum["bitType"] = 1093] = "bitType";
    ProductFieldsEnum[ProductFieldsEnum["bladeCuttingMaterial"] = 1094] = "bladeCuttingMaterial";
    ProductFieldsEnum[ProductFieldsEnum["powerToolsBladeDiameter"] = 1095] = "powerToolsBladeDiameter";
    ProductFieldsEnum[ProductFieldsEnum["powerToolsBladeDiameterUOM"] = 1096] = "powerToolsBladeDiameterUOM";
    ProductFieldsEnum[ProductFieldsEnum["powerToolsBladeLocation"] = 1097] = "powerToolsBladeLocation";
    ProductFieldsEnum[ProductFieldsEnum["bladeMaterialCut"] = 1098] = "bladeMaterialCut";
    ProductFieldsEnum[ProductFieldsEnum["bladeSpeed"] = 1099] = "bladeSpeed";
    ProductFieldsEnum[ProductFieldsEnum["bladeWrenchIncluded"] = 1100] = "bladeWrenchIncluded";
    ProductFieldsEnum[ProductFieldsEnum["powerToolsBladesIncluded"] = 1101] = "powerToolsBladesIncluded";
    ProductFieldsEnum[ProductFieldsEnum["blastsPerMinute"] = 1102] = "blastsPerMinute";
    ProductFieldsEnum[ProductFieldsEnum["btuHeatRating"] = 1103] = "btuHeatRating";
    ProductFieldsEnum[ProductFieldsEnum["cartridgeType"] = 1104] = "cartridgeType";
    ProductFieldsEnum[ProductFieldsEnum["powerToolsCaseContents"] = 1105] = "powerToolsCaseContents";
    ProductFieldsEnum[ProductFieldsEnum["hasPowerToolsCaseIncluded"] = 1106] = "hasPowerToolsCaseIncluded";
    ProductFieldsEnum[ProductFieldsEnum["chargerBatterySizes"] = 1107] = "chargerBatterySizes";
    ProductFieldsEnum[ProductFieldsEnum["chargerBatteryVoltages"] = 1108] = "chargerBatteryVoltages";
    ProductFieldsEnum[ProductFieldsEnum["chargerInputVoltage"] = 1109] = "chargerInputVoltage";
    ProductFieldsEnum[ProductFieldsEnum["clutchSettings"] = 1110] = "clutchSettings";
    ProductFieldsEnum[ProductFieldsEnum["commercialResidential"] = 1111] = "commercialResidential";
    ProductFieldsEnum[ProductFieldsEnum["powerToolsCordLength"] = 1112] = "powerToolsCordLength";
    ProductFieldsEnum[ProductFieldsEnum["powerToolsCordLengthUOM"] = 1113] = "powerToolsCordLengthUOM";
    ProductFieldsEnum[ProductFieldsEnum["crosscutCapacity0Miter45LeftBevel"] = 1114] = "crosscutCapacity0Miter45LeftBevel";
    ProductFieldsEnum[ProductFieldsEnum["crosscutCapacity0Miter45RightBevel"] = 1115] = "crosscutCapacity0Miter45RightBevel";
    ProductFieldsEnum[ProductFieldsEnum["crosscutCapacity45Miter45LeftBevel"] = 1116] = "crosscutCapacity45Miter45LeftBevel";
    ProductFieldsEnum[ProductFieldsEnum["crosscutCapacity45Miter45RightBevel"] = 1117] = "crosscutCapacity45Miter45RightBevel";
    ProductFieldsEnum[ProductFieldsEnum["crosscutCapacity45Miter0Bevel"] = 1118] = "crosscutCapacity45Miter0Bevel";
    ProductFieldsEnum[ProductFieldsEnum["cutsPerMinute"] = 1119] = "cutsPerMinute";
    ProductFieldsEnum[ProductFieldsEnum["cuttingCapacity"] = 1120] = "cuttingCapacity";
    ProductFieldsEnum[ProductFieldsEnum["cuttingCapacityUOM"] = 1121] = "cuttingCapacityUOM";
    ProductFieldsEnum[ProductFieldsEnum["cuttingDepth"] = 1122] = "cuttingDepth";
    ProductFieldsEnum[ProductFieldsEnum["cuttingDepthUOM"] = 1123] = "cuttingDepthUOM";
    ProductFieldsEnum[ProductFieldsEnum["cuttingDiameter"] = 1124] = "cuttingDiameter";
    ProductFieldsEnum[ProductFieldsEnum["cuttingDiameterUOM"] = 1125] = "cuttingDiameterUOM";
    ProductFieldsEnum[ProductFieldsEnum["cuttingWidth"] = 1126] = "cuttingWidth";
    ProductFieldsEnum[ProductFieldsEnum["cuttingWidthUOM"] = 1127] = "cuttingWidthUOM";
    ProductFieldsEnum[ProductFieldsEnum["powerToolsDecibelRating"] = 1128] = "powerToolsDecibelRating";
    ProductFieldsEnum[ProductFieldsEnum["hasPowerToolsDepthAdjustment"] = 1129] = "hasPowerToolsDepthAdjustment";
    ProductFieldsEnum[ProductFieldsEnum["discDiameter"] = 1130] = "discDiameter";
    ProductFieldsEnum[ProductFieldsEnum["discDiameterUOM"] = 1131] = "discDiameterUOM";
    ProductFieldsEnum[ProductFieldsEnum["discThickness"] = 1132] = "discThickness";
    ProductFieldsEnum[ProductFieldsEnum["discThicknessUOM"] = 1133] = "discThicknessUOM";
    ProductFieldsEnum[ProductFieldsEnum["drillType"] = 1134] = "drillType";
    ProductFieldsEnum[ProductFieldsEnum["drillingDepth"] = 1135] = "drillingDepth";
    ProductFieldsEnum[ProductFieldsEnum["drillingDepthUOM"] = 1136] = "drillingDepthUOM";
    ProductFieldsEnum[ProductFieldsEnum["driveDesign"] = 1137] = "driveDesign";
    ProductFieldsEnum[ProductFieldsEnum["hasDustBlower"] = 1138] = "hasDustBlower";
    ProductFieldsEnum[ProductFieldsEnum["hasDustCollection"] = 1139] = "hasDustCollection";
    ProductFieldsEnum[ProductFieldsEnum["hasDustPort"] = 1140] = "hasDustPort";
    ProductFieldsEnum[ProductFieldsEnum["hasEdgerCapable"] = 1141] = "hasEdgerCapable";
    ProductFieldsEnum[ProductFieldsEnum["hasElectricMotorBrake"] = 1142] = "hasElectricMotorBrake";
    ProductFieldsEnum[ProductFieldsEnum["hasExternalMotorBrushAccess"] = 1143] = "hasExternalMotorBrushAccess";
    ProductFieldsEnum[ProductFieldsEnum["hasFleshSensingSystem"] = 1144] = "hasFleshSensingSystem";
    ProductFieldsEnum[ProductFieldsEnum["fluteLength"] = 1145] = "fluteLength";
    ProductFieldsEnum[ProductFieldsEnum["fluteLengthUOM"] = 1146] = "fluteLengthUOM";
    ProductFieldsEnum[ProductFieldsEnum["hasForwardReverseSwitch"] = 1147] = "hasForwardReverseSwitch";
    ProductFieldsEnum[ProductFieldsEnum["grinderType"] = 1148] = "grinderType";
    ProductFieldsEnum[ProductFieldsEnum["hasGrinderWheel"] = 1149] = "hasGrinderWheel";
    ProductFieldsEnum[ProductFieldsEnum["grit"] = 1150] = "grit";
    ProductFieldsEnum[ProductFieldsEnum["gritSizeCAMI"] = 1151] = "gritSizeCAMI";
    ProductFieldsEnum[ProductFieldsEnum["gritSizeFEPA"] = 1152] = "gritSizeFEPA";
    ProductFieldsEnum[ProductFieldsEnum["holeSawDiameter"] = 1153] = "holeSawDiameter";
    ProductFieldsEnum[ProductFieldsEnum["holeSawDiameterUOM"] = 1154] = "holeSawDiameterUOM";
    ProductFieldsEnum[ProductFieldsEnum["holeSawMaterial"] = 1155] = "holeSawMaterial";
    ProductFieldsEnum[ProductFieldsEnum["holeSawType"] = 1156] = "holeSawType";
    ProductFieldsEnum[ProductFieldsEnum["horizontalCrosscutCapacity"] = 1157] = "horizontalCrosscutCapacity";
    ProductFieldsEnum[ProductFieldsEnum["horizontalCrosscutCapacityUOM"] = 1158] = "horizontalCrosscutCapacityUOM";
    ProductFieldsEnum[ProductFieldsEnum["powerToolsHorsepower"] = 1159] = "powerToolsHorsepower";
    ProductFieldsEnum[ProductFieldsEnum["impactStandard"] = 1160] = "impactStandard";
    ProductFieldsEnum[ProductFieldsEnum["impactWrenchDriveSize"] = 1161] = "impactWrenchDriveSize";
    ProductFieldsEnum[ProductFieldsEnum["impactWrenchDriveSizeUOM"] = 1162] = "impactWrenchDriveSizeUOM";
    ProductFieldsEnum[ProductFieldsEnum["impactsPerMinute"] = 1163] = "impactsPerMinute";
    ProductFieldsEnum[ProductFieldsEnum["integratedRafterHook"] = 1164] = "integratedRafterHook";
    ProductFieldsEnum[ProductFieldsEnum["integratedWorkLight"] = 1165] = "integratedWorkLight";
    ProductFieldsEnum[ProductFieldsEnum["kerf"] = 1166] = "kerf";
    ProductFieldsEnum[ProductFieldsEnum["kerfUOM"] = 1167] = "kerfUOM";
    ProductFieldsEnum[ProductFieldsEnum["keylessKeyedBladeChange"] = 1168] = "keylessKeyedBladeChange";
    ProductFieldsEnum[ProductFieldsEnum["hasLadderHook"] = 1169] = "hasLadderHook";
    ProductFieldsEnum[ProductFieldsEnum["lineDiameter"] = 1170] = "lineDiameter";
    ProductFieldsEnum[ProductFieldsEnum["lineDiameterUOM"] = 1171] = "lineDiameterUOM";
    ProductFieldsEnum[ProductFieldsEnum["lineFeedType"] = 1172] = "lineFeedType";
    ProductFieldsEnum[ProductFieldsEnum["hasPowerToolsLockOnSwitch"] = 1173] = "hasPowerToolsLockOnSwitch";
    ProductFieldsEnum[ProductFieldsEnum["magazineCapacity"] = 1174] = "magazineCapacity";
    ProductFieldsEnum[ProductFieldsEnum["maxCutDepth45degrees"] = 1175] = "maxCutDepth45degrees";
    ProductFieldsEnum[ProductFieldsEnum["maxCutDepth45degreesUOM"] = 1176] = "maxCutDepth45degreesUOM";
    ProductFieldsEnum[ProductFieldsEnum["maxCutDepth90degrees"] = 1177] = "maxCutDepth90degrees";
    ProductFieldsEnum[ProductFieldsEnum["maxCutDepth90degreesUOM"] = 1178] = "maxCutDepth90degreesUOM";
    ProductFieldsEnum[ProductFieldsEnum["maximumLeftBevel"] = 1179] = "maximumLeftBevel";
    ProductFieldsEnum[ProductFieldsEnum["maximumLeftMiter"] = 1180] = "maximumLeftMiter";
    ProductFieldsEnum[ProductFieldsEnum["maximumPowerOutput"] = 1181] = "maximumPowerOutput";
    ProductFieldsEnum[ProductFieldsEnum["maximumRightBevel"] = 1182] = "maximumRightBevel";
    ProductFieldsEnum[ProductFieldsEnum["maximumRightMiter"] = 1183] = "maximumRightMiter";
    ProductFieldsEnum[ProductFieldsEnum["maximumStrokesperMinute"] = 1184] = "maximumStrokesperMinute";
    ProductFieldsEnum[ProductFieldsEnum["maximumTemperature"] = 1185] = "maximumTemperature";
    ProductFieldsEnum[ProductFieldsEnum["maximumTorqueftlbs"] = 1186] = "maximumTorqueftlbs";
    ProductFieldsEnum[ProductFieldsEnum["maximumTorqueinlbs"] = 1187] = "maximumTorqueinlbs";
    ProductFieldsEnum[ProductFieldsEnum["minimumChuckSize"] = 1188] = "minimumChuckSize";
    ProductFieldsEnum[ProductFieldsEnum["powerToolsMotorSpeed"] = 1189] = "powerToolsMotorSpeed";
    ProductFieldsEnum[ProductFieldsEnum["powerToolsNumberofPieces"] = 1190] = "powerToolsNumberofPieces";
    ProductFieldsEnum[ProductFieldsEnum["oscillationsPerMinute"] = 1191] = "oscillationsPerMinute";
    ProductFieldsEnum[ProductFieldsEnum["hasPowerToolsOverloadProtection"] = 1192] = "hasPowerToolsOverloadProtection";
    ProductFieldsEnum[ProductFieldsEnum["pilotBitDiameter"] = 1193] = "pilotBitDiameter";
    ProductFieldsEnum[ProductFieldsEnum["pilotBitDiameterUOM"] = 1194] = "pilotBitDiameterUOM";
    ProductFieldsEnum[ProductFieldsEnum["powerToolsPlateThickness"] = 1195] = "powerToolsPlateThickness";
    ProductFieldsEnum[ProductFieldsEnum["powerToolsPlateThicknessUOM"] = 1196] = "powerToolsPlateThicknessUOM";
    ProductFieldsEnum[ProductFieldsEnum["presetBevelAngleDetents"] = 1197] = "presetBevelAngleDetents";
    ProductFieldsEnum[ProductFieldsEnum["presetMiterAngleDetents"] = 1198] = "presetMiterAngleDetents";
    ProductFieldsEnum[ProductFieldsEnum["hasQuickChange"] = 1199] = "hasQuickChange";
    ProductFieldsEnum[ProductFieldsEnum["hasQuickReleaseVise"] = 1200] = "hasQuickReleaseVise";
    ProductFieldsEnum[ProductFieldsEnum["recommendedAirPressure"] = 1201] = "recommendedAirPressure";
    ProductFieldsEnum[ProductFieldsEnum["powerToolsRecommendedHoseSize"] = 1202] = "powerToolsRecommendedHoseSize";
    ProductFieldsEnum[ProductFieldsEnum["powerToolsRecommendedHoseSizeUOM"] = 1203] = "powerToolsRecommendedHoseSizeUOM";
    ProductFieldsEnum[ProductFieldsEnum["hasPowerToolsReverse"] = 1204] = "hasPowerToolsReverse";
    ProductFieldsEnum[ProductFieldsEnum["hasPowerToolsRockerSwitch"] = 1205] = "hasPowerToolsRockerSwitch";
    ProductFieldsEnum[ProductFieldsEnum["hasRustResistant"] = 1206] = "hasRustResistant";
    ProductFieldsEnum[ProductFieldsEnum["sanderBeltSize"] = 1207] = "sanderBeltSize";
    ProductFieldsEnum[ProductFieldsEnum["sanderBeltSizeUOM"] = 1208] = "sanderBeltSizeUOM";
    ProductFieldsEnum[ProductFieldsEnum["sandingGrade"] = 1209] = "sandingGrade";
    ProductFieldsEnum[ProductFieldsEnum["sandingGrit"] = 1210] = "sandingGrit";
    ProductFieldsEnum[ProductFieldsEnum["sandingMineral"] = 1211] = "sandingMineral";
    ProductFieldsEnum[ProductFieldsEnum["sandingSpeedMax"] = 1212] = "sandingSpeedMax";
    ProductFieldsEnum[ProductFieldsEnum["sandingSpeedMin"] = 1213] = "sandingSpeedMin";
    ProductFieldsEnum[ProductFieldsEnum["sandpaperAccessoryType"] = 1214] = "sandpaperAccessoryType";
    ProductFieldsEnum[ProductFieldsEnum["sawDrive"] = 1215] = "sawDrive";
    ProductFieldsEnum[ProductFieldsEnum["powerToolsSawType"] = 1216] = "powerToolsSawType";
    ProductFieldsEnum[ProductFieldsEnum["scanDepth"] = 1217] = "scanDepth";
    ProductFieldsEnum[ProductFieldsEnum["scanDepthUOM"] = 1218] = "scanDepthUOM";
    ProductFieldsEnum[ProductFieldsEnum["shankDiameter"] = 1219] = "shankDiameter";
    ProductFieldsEnum[ProductFieldsEnum["shankDiameterUOM"] = 1220] = "shankDiameterUOM";
    ProductFieldsEnum[ProductFieldsEnum["shoeLength"] = 1221] = "shoeLength";
    ProductFieldsEnum[ProductFieldsEnum["shoeLengthUOM"] = 1222] = "shoeLengthUOM";
    ProductFieldsEnum[ProductFieldsEnum["hasPowerToolsShoulderStrap"] = 1223] = "hasPowerToolsShoulderStrap";
    ProductFieldsEnum[ProductFieldsEnum["speedSurfaceFeetOrbitsPerMinute"] = 1224] = "speedSurfaceFeetOrbitsPerMinute";
    ProductFieldsEnum[ProductFieldsEnum["hasPowerToolsSpeedControl"] = 1225] = "hasPowerToolsSpeedControl";
    ProductFieldsEnum[ProductFieldsEnum["powerToolsStartType"] = 1226] = "powerToolsStartType";
    ProductFieldsEnum[ProductFieldsEnum["strokeLength"] = 1227] = "strokeLength";
    ProductFieldsEnum[ProductFieldsEnum["strokeLengthUOM"] = 1228] = "strokeLengthUOM";
    ProductFieldsEnum[ProductFieldsEnum["surfaceCoating"] = 1229] = "surfaceCoating";
    ProductFieldsEnum[ProductFieldsEnum["switchType"] = 1230] = "switchType";
    ProductFieldsEnum[ProductFieldsEnum["hasToolLessBladeChanging"] = 1231] = "hasToolLessBladeChanging";
    ProductFieldsEnum[ProductFieldsEnum["torqueIncrements"] = 1232] = "torqueIncrements";
    ProductFieldsEnum[ProductFieldsEnum["trimmerLineCount"] = 1233] = "trimmerLineCount";
    ProductFieldsEnum[ProductFieldsEnum["verticalCrosscutCapacity"] = 1234] = "verticalCrosscutCapacity";
    ProductFieldsEnum[ProductFieldsEnum["verticalCrosscutCapacityUOM"] = 1235] = "verticalCrosscutCapacityUOM";
    ProductFieldsEnum[ProductFieldsEnum["powerToolsVoltage"] = 1236] = "powerToolsVoltage";
    ProductFieldsEnum[ProductFieldsEnum["powerToolsWattage"] = 1237] = "powerToolsWattage";
    ProductFieldsEnum[ProductFieldsEnum["hasWetDry"] = 1238] = "hasWetDry";
    ProductFieldsEnum[ProductFieldsEnum["wetorDryApplication"] = 1239] = "wetorDryApplication";
    ProductFieldsEnum[ProductFieldsEnum["powerToolsWheelDiameter"] = 1240] = "powerToolsWheelDiameter";
    ProductFieldsEnum[ProductFieldsEnum["powerToolsWheelDiameterUOM"] = 1241] = "powerToolsWheelDiameterUOM";
    ProductFieldsEnum[ProductFieldsEnum["powerToolsWheelThickness"] = 1242] = "powerToolsWheelThickness";
    ProductFieldsEnum[ProductFieldsEnum["powerToolsWheelThicknessUOM"] = 1243] = "powerToolsWheelThicknessUOM";
    ProductFieldsEnum[ProductFieldsEnum["consumerPackageUOM"] = 1244] = "consumerPackageUOM";
    ProductFieldsEnum[ProductFieldsEnum["palletInformationNumberofCases"] = 1245] = "palletInformationNumberofCases";
    ProductFieldsEnum[ProductFieldsEnum["palletInformationNumberofRows"] = 1246] = "palletInformationNumberofRows";
    ProductFieldsEnum[ProductFieldsEnum["masterPackCaseUOM"] = 1247] = "masterPackCaseUOM";
    ProductFieldsEnum[ProductFieldsEnum["palletInformationUOM"] = 1248] = "palletInformationUOM";
    ProductFieldsEnum[ProductFieldsEnum["hasCSACertified"] = 1249] = "hasCSACertified";
    ProductFieldsEnum[ProductFieldsEnum["hasETLListed"] = 1250] = "hasETLListed";
    ProductFieldsEnum[ProductFieldsEnum["hasULListed"] = 1251] = "hasULListed";
    ProductFieldsEnum[ProductFieldsEnum["isOriginalManufacturerEquipment"] = 1252] = "isOriginalManufacturerEquipment";
    ProductFieldsEnum[ProductFieldsEnum["consumerPackageDepth"] = 1253] = "consumerPackageDepth";
    ProductFieldsEnum[ProductFieldsEnum["consumerPackageDepthUOM"] = 1254] = "consumerPackageDepthUOM";
    ProductFieldsEnum[ProductFieldsEnum["acidType"] = 1255] = "acidType";
    ProductFieldsEnum[ProductFieldsEnum["braidMaterial"] = 1256] = "braidMaterial";
    ProductFieldsEnum[ProductFieldsEnum["burstPressure"] = 1257] = "burstPressure";
    ProductFieldsEnum[ProductFieldsEnum["compoundType"] = 1258] = "compoundType";
    ProductFieldsEnum[ProductFieldsEnum["connectionMaterial"] = 1259] = "connectionMaterial";
    ProductFieldsEnum[ProductFieldsEnum["connectionSize"] = 1260] = "connectionSize";
    ProductFieldsEnum[ProductFieldsEnum["connectionSizeUOM"] = 1261] = "connectionSizeUOM";
    ProductFieldsEnum[ProductFieldsEnum["flexibleHoseExteriorDiameterUOM"] = 1262] = "flexibleHoseExteriorDiameterUOM";
    ProductFieldsEnum[ProductFieldsEnum["flexibleHoseExteriorDiameter"] = 1263] = "flexibleHoseExteriorDiameter";
    ProductFieldsEnum[ProductFieldsEnum["flexibleHoseInteriorDiameterUOM"] = 1264] = "flexibleHoseInteriorDiameterUOM";
    ProductFieldsEnum[ProductFieldsEnum["flexibleHoseInteriorDiameter"] = 1265] = "flexibleHoseInteriorDiameter";
    ProductFieldsEnum[ProductFieldsEnum["maximumWorkingPressure"] = 1266] = "maximumWorkingPressure";
    ProductFieldsEnum[ProductFieldsEnum["tubingMaterial"] = 1267] = "tubingMaterial";
    ProductFieldsEnum[ProductFieldsEnum["airFilterCapacity"] = 1268] = "airFilterCapacity";
    ProductFieldsEnum[ProductFieldsEnum["airFilterEfficiency"] = 1269] = "airFilterEfficiency";
    ProductFieldsEnum[ProductFieldsEnum["airFilterHeaderType"] = 1270] = "airFilterHeaderType";
    ProductFieldsEnum[ProductFieldsEnum["airFilterLayerType"] = 1271] = "airFilterLayerType";
    ProductFieldsEnum[ProductFieldsEnum["airFilterPerformanceRating"] = 1272] = "airFilterPerformanceRating";
    ProductFieldsEnum[ProductFieldsEnum["airFilterStyle"] = 1273] = "airFilterStyle";
    ProductFieldsEnum[ProductFieldsEnum["airFilterType"] = 1274] = "airFilterType";
    ProductFieldsEnum[ProductFieldsEnum["filtersOut"] = 1275] = "filtersOut";
    ProductFieldsEnum[ProductFieldsEnum["airFiltersMaximumTemperature"] = 1276] = "airFiltersMaximumTemperature";
    ProductFieldsEnum[ProductFieldsEnum["nominalFilterSize"] = 1277] = "nominalFilterSize";
    ProductFieldsEnum[ProductFieldsEnum["removesParticlesDownTo"] = 1278] = "removesParticlesDownTo";
    ProductFieldsEnum[ProductFieldsEnum["airCleaningMethod"] = 1279] = "airCleaningMethod";
    ProductFieldsEnum[ProductFieldsEnum["airCleaningTechnology"] = 1280] = "airCleaningTechnology";
    ProductFieldsEnum[ProductFieldsEnum["hasAirQualitySensor"] = 1281] = "hasAirQualitySensor";
    ProductFieldsEnum[ProductFieldsEnum["bucketCapacity"] = 1282] = "bucketCapacity";
    ProductFieldsEnum[ProductFieldsEnum["bucketCapacityUOM"] = 1283] = "bucketCapacityUOM";
    ProductFieldsEnum[ProductFieldsEnum["dustCleanAirDeliveryRate"] = 1284] = "dustCleanAirDeliveryRate";
    ProductFieldsEnum[ProductFieldsEnum["pollenCleanAirDeliveryRate"] = 1285] = "pollenCleanAirDeliveryRate";
    ProductFieldsEnum[ProductFieldsEnum["smokeCleanAirDeliveryRate"] = 1286] = "smokeCleanAirDeliveryRate";
    ProductFieldsEnum[ProductFieldsEnum["dailyHumidificationCapacity"] = 1287] = "dailyHumidificationCapacity";
    ProductFieldsEnum[ProductFieldsEnum["dailyHumidificationCapacityUOM"] = 1288] = "dailyHumidificationCapacityUOM";
    ProductFieldsEnum[ProductFieldsEnum["dailyWaterRemovalCapacity"] = 1289] = "dailyWaterRemovalCapacity";
    ProductFieldsEnum[ProductFieldsEnum["dailyWaterRemovalCapacityUOM"] = 1290] = "dailyWaterRemovalCapacityUOM";
    ProductFieldsEnum[ProductFieldsEnum["dehumidificationMethod"] = 1291] = "dehumidificationMethod";
    ProductFieldsEnum[ProductFieldsEnum["drainPumpOptions"] = 1292] = "drainPumpOptions";
    ProductFieldsEnum[ProductFieldsEnum["drainHoseLength"] = 1293] = "drainHoseLength";
    ProductFieldsEnum[ProductFieldsEnum["drainHoseLengthUOM"] = 1294] = "drainHoseLengthUOM";
    ProductFieldsEnum[ProductFieldsEnum["hasFilterChangeReminder"] = 1295] = "hasFilterChangeReminder";
    ProductFieldsEnum[ProductFieldsEnum["filtersDownTo"] = 1296] = "filtersDownTo";
    ProductFieldsEnum[ProductFieldsEnum["filtersIncluded"] = 1297] = "filtersIncluded";
    ProductFieldsEnum[ProductFieldsEnum["hasHourMeter"] = 1298] = "hasHourMeter";
    ProductFieldsEnum[ProductFieldsEnum["humidificationMethod"] = 1299] = "humidificationMethod";
    ProductFieldsEnum[ProductFieldsEnum["humiditySettings"] = 1300] = "humiditySettings";
    ProductFieldsEnum[ProductFieldsEnum["hasDrainHose"] = 1301] = "hasDrainHose";
    ProductFieldsEnum[ProductFieldsEnum["hasIonization"] = 1302] = "hasIonization";
    ProductFieldsEnum[ProductFieldsEnum["hasWaterFillHose"] = 1303] = "hasWaterFillHose";
    ProductFieldsEnum[ProductFieldsEnum["hasWaterLevelFloat"] = 1304] = "hasWaterLevelFloat";
    ProductFieldsEnum[ProductFieldsEnum["hasIntegratedHumidistat"] = 1305] = "hasIntegratedHumidistat";
    ProductFieldsEnum[ProductFieldsEnum["ionOutput"] = 1306] = "ionOutput";
    ProductFieldsEnum[ProductFieldsEnum["maximumAirFlow"] = 1307] = "maximumAirFlow";
    ProductFieldsEnum[ProductFieldsEnum["maximumCoverageArea"] = 1308] = "maximumCoverageArea";
    ProductFieldsEnum[ProductFieldsEnum["maximumRuntime"] = 1309] = "maximumRuntime";
    ProductFieldsEnum[ProductFieldsEnum["numberofReservoirs"] = 1310] = "numberofReservoirs";
    ProductFieldsEnum[ProductFieldsEnum["numberofStages"] = 1311] = "numberofStages";
    ProductFieldsEnum[ProductFieldsEnum["hasOccupancySensor"] = 1312] = "hasOccupancySensor";
    ProductFieldsEnum[ProductFieldsEnum["hasPadWickChangeReminder"] = 1313] = "hasPadWickChangeReminder";
    ProductFieldsEnum[ProductFieldsEnum["reservoirCapacity"] = 1314] = "reservoirCapacity";
    ProductFieldsEnum[ProductFieldsEnum["reservoirCapacityUOM"] = 1315] = "reservoirCapacityUOM";
    ProductFieldsEnum[ProductFieldsEnum["hasReservoirFillReminder"] = 1316] = "hasReservoirFillReminder";
    ProductFieldsEnum[ProductFieldsEnum["reservoirType"] = 1317] = "reservoirType";
    ProductFieldsEnum[ProductFieldsEnum["airFlow"] = 1318] = "airFlow";
    ProductFieldsEnum[ProductFieldsEnum["airFlowDirection"] = 1319] = "airFlowDirection";
    ProductFieldsEnum[ProductFieldsEnum["annualFuelUtilizationEfficiency"] = 1320] = "annualFuelUtilizationEfficiency";
    ProductFieldsEnum[ProductFieldsEnum["availableCoolingTons"] = 1321] = "availableCoolingTons";
    ProductFieldsEnum[ProductFieldsEnum["compressorType"] = 1322] = "compressorType";
    ProductFieldsEnum[ProductFieldsEnum["coolingCapacity"] = 1323] = "coolingCapacity";
    ProductFieldsEnum[ProductFieldsEnum["coolingMethod"] = 1324] = "coolingMethod";
    ProductFieldsEnum[ProductFieldsEnum["dehumidificationRate"] = 1325] = "dehumidificationRate";
    ProductFieldsEnum[ProductFieldsEnum["electricalConduitSize"] = 1326] = "electricalConduitSize";
    ProductFieldsEnum[ProductFieldsEnum["exhaustAirFlow"] = 1327] = "exhaustAirFlow";
    ProductFieldsEnum[ProductFieldsEnum["heatingCapacity"] = 1328] = "heatingCapacity";
    ProductFieldsEnum[ProductFieldsEnum["heatingCapacityInput"] = 1329] = "heatingCapacityInput";
    ProductFieldsEnum[ProductFieldsEnum["heatingCapacityOutput"] = 1330] = "heatingCapacityOutput";
    ProductFieldsEnum[ProductFieldsEnum["heatingMethod"] = 1331] = "heatingMethod";
    ProductFieldsEnum[ProductFieldsEnum["liquidLineSize"] = 1332] = "liquidLineSize";
    ProductFieldsEnum[ProductFieldsEnum["liquidLineSizeUOM"] = 1333] = "liquidLineSizeUOM";
    ProductFieldsEnum[ProductFieldsEnum["liquidValveSize"] = 1334] = "liquidValveSize";
    ProductFieldsEnum[ProductFieldsEnum["liquidValveSizeUOM"] = 1335] = "liquidValveSizeUOM";
    ProductFieldsEnum[ProductFieldsEnum["maximumCoolingCapacity"] = 1336] = "maximumCoolingCapacity";
    ProductFieldsEnum[ProductFieldsEnum["maximumOvercurrentProtection"] = 1337] = "maximumOvercurrentProtection";
    ProductFieldsEnum[ProductFieldsEnum["maximumOverloadProtectionDevice"] = 1338] = "maximumOverloadProtectionDevice";
    ProductFieldsEnum[ProductFieldsEnum["minimumMaximumVolts"] = 1339] = "minimumMaximumVolts";
    ProductFieldsEnum[ProductFieldsEnum["minimumCircuitAmpacity"] = 1340] = "minimumCircuitAmpacity";
    ProductFieldsEnum[ProductFieldsEnum["minimumOverloadProtectionDevice"] = 1341] = "minimumOverloadProtectionDevice";
    ProductFieldsEnum[ProductFieldsEnum["nominalCapacity"] = 1342] = "nominalCapacity";
    ProductFieldsEnum[ProductFieldsEnum["nominalCoolingCapacity"] = 1343] = "nominalCoolingCapacity";
    ProductFieldsEnum[ProductFieldsEnum["suctionLineSize"] = 1344] = "suctionLineSize";
    ProductFieldsEnum[ProductFieldsEnum["suctionLineSizeUOM"] = 1345] = "suctionLineSizeUOM";
    ProductFieldsEnum[ProductFieldsEnum["suctionValveSize"] = 1346] = "suctionValveSize";
    ProductFieldsEnum[ProductFieldsEnum["suctionValveSizeUOM"] = 1347] = "suctionValveSizeUOM";
    ProductFieldsEnum[ProductFieldsEnum["supplyAirFlow"] = 1348] = "supplyAirFlow";
    ProductFieldsEnum[ProductFieldsEnum["valveConnectionType"] = 1349] = "valveConnectionType";
    ProductFieldsEnum[ProductFieldsEnum["voltagePhase"] = 1350] = "voltagePhase";
    ProductFieldsEnum[ProductFieldsEnum["backlitScreen"] = 1351] = "backlitScreen";
    ProductFieldsEnum[ProductFieldsEnum["backlitScreenColor"] = 1352] = "backlitScreenColor";
    ProductFieldsEnum[ProductFieldsEnum["screenBacklightType"] = 1353] = "screenBacklightType";
    ProductFieldsEnum[ProductFieldsEnum["batteryBackup"] = 1354] = "batteryBackup";
    ProductFieldsEnum[ProductFieldsEnum["compatibleSystemType"] = 1355] = "compatibleSystemType";
    ProductFieldsEnum[ProductFieldsEnum["displayType"] = 1356] = "displayType";
    ProductFieldsEnum[ProductFieldsEnum["electricalConnectionType"] = 1357] = "electricalConnectionType";
    ProductFieldsEnum[ProductFieldsEnum["hasIncludesBatteries"] = 1358] = "hasIncludesBatteries";
    ProductFieldsEnum[ProductFieldsEnum["hasKeypadLockout"] = 1359] = "hasKeypadLockout";
    ProductFieldsEnum[ProductFieldsEnum["maximumControlTemperature"] = 1360] = "maximumControlTemperature";
    ProductFieldsEnum[ProductFieldsEnum["minimumControlTemperature"] = 1361] = "minimumControlTemperature";
    ProductFieldsEnum[ProductFieldsEnum["numberofCoolingStages"] = 1362] = "numberofCoolingStages";
    ProductFieldsEnum[ProductFieldsEnum["numberofHeatingStages"] = 1363] = "numberofHeatingStages";
    ProductFieldsEnum[ProductFieldsEnum["programmingCapability"] = 1364] = "programmingCapability";
    ProductFieldsEnum[ProductFieldsEnum["switchAction"] = 1365] = "switchAction";
    ProductFieldsEnum[ProductFieldsEnum["thermostatSwitchType"] = 1366] = "thermostatSwitchType";
    ProductFieldsEnum[ProductFieldsEnum["systemSettings"] = 1367] = "systemSettings";
    ProductFieldsEnum[ProductFieldsEnum["temperatureDifferential"] = 1368] = "temperatureDifferential";
    ProductFieldsEnum[ProductFieldsEnum["temperatureDisplay"] = 1369] = "temperatureDisplay";
    ProductFieldsEnum[ProductFieldsEnum["temperatureScale"] = 1370] = "temperatureScale";
    ProductFieldsEnum[ProductFieldsEnum["temperatureSensitivity"] = 1371] = "temperatureSensitivity";
    ProductFieldsEnum[ProductFieldsEnum["temperatureSettingsPerDay"] = 1372] = "temperatureSettingsPerDay";
    ProductFieldsEnum[ProductFieldsEnum["hasTemporaryProgramOverride"] = 1373] = "hasTemporaryProgramOverride";
    ProductFieldsEnum[ProductFieldsEnum["thermostatApplication"] = 1374] = "thermostatApplication";
    ProductFieldsEnum[ProductFieldsEnum["thermostatControlType"] = 1375] = "thermostatControlType";
    ProductFieldsEnum[ProductFieldsEnum["thermostatType"] = 1376] = "thermostatType";
    ProductFieldsEnum[ProductFieldsEnum["boreDiameter"] = 1377] = "boreDiameter";
    ProductFieldsEnum[ProductFieldsEnum["boreDiameterUOM"] = 1378] = "boreDiameterUOM";
    ProductFieldsEnum[ProductFieldsEnum["maximumMotorPower"] = 1379] = "maximumMotorPower";
    ProductFieldsEnum[ProductFieldsEnum["fanBladesPropellersMaximumSpeed"] = 1380] = "fanBladesPropellersMaximumSpeed";
    ProductFieldsEnum[ProductFieldsEnum["minimumMotorPower"] = 1381] = "minimumMotorPower";
    ProductFieldsEnum[ProductFieldsEnum["numberofSetScrews"] = 1382] = "numberofSetScrews";
    ProductFieldsEnum[ProductFieldsEnum["pitch"] = 1383] = "pitch";
    ProductFieldsEnum[ProductFieldsEnum["propellerDiameter"] = 1384] = "propellerDiameter";
    ProductFieldsEnum[ProductFieldsEnum["propellerDiameterUOM"] = 1385] = "propellerDiameterUOM";
    ProductFieldsEnum[ProductFieldsEnum["requiredMotorPower"] = 1386] = "requiredMotorPower";
    ProductFieldsEnum[ProductFieldsEnum["rotation"] = 1387] = "rotation";
    ProductFieldsEnum[ProductFieldsEnum["coefficientofPerformance"] = 1388] = "coefficientofPerformance";
    ProductFieldsEnum[ProductFieldsEnum["combinedEnergyEfficiencyRatio"] = 1389] = "combinedEnergyEfficiencyRatio";
    ProductFieldsEnum[ProductFieldsEnum["energyEfficiencyRatio"] = 1390] = "energyEfficiencyRatio";
    ProductFieldsEnum[ProductFieldsEnum["hvacAirflow"] = 1391] = "hvacAirflow";
    ProductFieldsEnum[ProductFieldsEnum["hvacApplication"] = 1392] = "hvacApplication";
    ProductFieldsEnum[ProductFieldsEnum["hasHVACAutoRestart"] = 1393] = "hasHVACAutoRestart";
    ProductFieldsEnum[ProductFieldsEnum["hasHVACAutoShutOff"] = 1394] = "hasHVACAutoShutOff";
    ProductFieldsEnum[ProductFieldsEnum["hvacBladeDiameter"] = 1395] = "hvacBladeDiameter";
    ProductFieldsEnum[ProductFieldsEnum["hvacBladeDiameterUOM"] = 1396] = "hvacBladeDiameterUOM";
    ProductFieldsEnum[ProductFieldsEnum["hvacBladeMaterial"] = 1397] = "hvacBladeMaterial";
    ProductFieldsEnum[ProductFieldsEnum["hasHVACBluetoothCompatible"] = 1398] = "hasHVACBluetoothCompatible";
    ProductFieldsEnum[ProductFieldsEnum["hvacComplianceStandards"] = 1399] = "hvacComplianceStandards";
    ProductFieldsEnum[ProductFieldsEnum["hvacControlFeatures"] = 1400] = "hvacControlFeatures";
    ProductFieldsEnum[ProductFieldsEnum["hasHVACControlLock"] = 1401] = "hasHVACControlLock";
    ProductFieldsEnum[ProductFieldsEnum["hvacControlType"] = 1402] = "hvacControlType";
    ProductFieldsEnum[ProductFieldsEnum["hvacCurrent"] = 1403] = "hvacCurrent";
    ProductFieldsEnum[ProductFieldsEnum["hvacDefrostType"] = 1404] = "hvacDefrostType";
    ProductFieldsEnum[ProductFieldsEnum["hasHVACEnergyStarCertified"] = 1405] = "hasHVACEnergyStarCertified";
    ProductFieldsEnum[ProductFieldsEnum["hvacEnergyStarRating"] = 1406] = "hvacEnergyStarRating";
    ProductFieldsEnum[ProductFieldsEnum["hvacEquipmentType"] = 1407] = "hvacEquipmentType";
    ProductFieldsEnum[ProductFieldsEnum["hvacFrequency"] = 1408] = "hvacFrequency";
    ProductFieldsEnum[ProductFieldsEnum["hvacFuelType"] = 1409] = "hvacFuelType";
    ProductFieldsEnum[ProductFieldsEnum["hvacFunction"] = 1410] = "hvacFunction";
    ProductFieldsEnum[ProductFieldsEnum["hvacMaximumFanSpeed"] = 1411] = "hvacMaximumFanSpeed";
    ProductFieldsEnum[ProductFieldsEnum["hvacMotorHorsepower"] = 1412] = "hvacMotorHorsepower";
    ProductFieldsEnum[ProductFieldsEnum["hvacMotorSpeed"] = 1413] = "hvacMotorSpeed";
    ProductFieldsEnum[ProductFieldsEnum["hvacMountType"] = 1414] = "hvacMountType";
    ProductFieldsEnum[ProductFieldsEnum["hvacMountingLocation"] = 1415] = "hvacMountingLocation";
    ProductFieldsEnum[ProductFieldsEnum["hvacMountingOrientation"] = 1416] = "hvacMountingOrientation";
    ProductFieldsEnum[ProductFieldsEnum["hvacNEMAPlugConfiguration"] = 1417] = "hvacNEMAPlugConfiguration";
    ProductFieldsEnum[ProductFieldsEnum["hvacNEMAPlugRating"] = 1418] = "hvacNEMAPlugRating";
    ProductFieldsEnum[ProductFieldsEnum["hvacNoiseLevel"] = 1419] = "hvacNoiseLevel";
    ProductFieldsEnum[ProductFieldsEnum["hvacNoiseLevelUOM"] = 1420] = "hvacNoiseLevelUOM";
    ProductFieldsEnum[ProductFieldsEnum["hvacNumberofBlades"] = 1421] = "hvacNumberofBlades";
    ProductFieldsEnum[ProductFieldsEnum["hvacNumberofCasters"] = 1422] = "hvacNumberofCasters";
    ProductFieldsEnum[ProductFieldsEnum["hvacNumberofSpeeds"] = 1423] = "hvacNumberofSpeeds";
    ProductFieldsEnum[ProductFieldsEnum["hvacOperatingMode"] = 1424] = "hvacOperatingMode";
    ProductFieldsEnum[ProductFieldsEnum["hvacOperatingTemperatureRange"] = 1425] = "hvacOperatingTemperatureRange";
    ProductFieldsEnum[ProductFieldsEnum["hvacPhase"] = 1426] = "hvacPhase";
    ProductFieldsEnum[ProductFieldsEnum["hvacPowerConsumption"] = 1427] = "hvacPowerConsumption";
    ProductFieldsEnum[ProductFieldsEnum["hvacPowerCordLength"] = 1428] = "hvacPowerCordLength";
    ProductFieldsEnum[ProductFieldsEnum["hvacPowerCordLengthUOM"] = 1429] = "hvacPowerCordLengthUOM";
    ProductFieldsEnum[ProductFieldsEnum["hvacProgrammingCapability"] = 1430] = "hvacProgrammingCapability";
    ProductFieldsEnum[ProductFieldsEnum["hvacRefrigerantCharge"] = 1431] = "hvacRefrigerantCharge";
    ProductFieldsEnum[ProductFieldsEnum["hvacRefrigerantType"] = 1432] = "hvacRefrigerantType";
    ProductFieldsEnum[ProductFieldsEnum["hvacRemoteControlFunctions"] = 1433] = "hvacRemoteControlFunctions";
    ProductFieldsEnum[ProductFieldsEnum["hvacSmartConnectivity"] = 1434] = "hvacSmartConnectivity";
    ProductFieldsEnum[ProductFieldsEnum["hvacSystemType"] = 1435] = "hvacSystemType";
    ProductFieldsEnum[ProductFieldsEnum["hvacVoltage"] = 1436] = "hvacVoltage";
    ProductFieldsEnum[ProductFieldsEnum["hvacWaterSupply"] = 1437] = "hvacWaterSupply";
    ProductFieldsEnum[ProductFieldsEnum["hvacWattage"] = 1438] = "hvacWattage";
    ProductFieldsEnum[ProductFieldsEnum["hasHVACWiFiCompatible"] = 1439] = "hasHVACWiFiCompatible";
    ProductFieldsEnum[ProductFieldsEnum["maximumVelocity"] = 1440] = "maximumVelocity";
    ProductFieldsEnum[ProductFieldsEnum["motorDutyClass"] = 1441] = "motorDutyClass";
    ProductFieldsEnum[ProductFieldsEnum["motorEnclosure"] = 1442] = "motorEnclosure";
    ProductFieldsEnum[ProductFieldsEnum["motorFrameDesignation"] = 1443] = "motorFrameDesignation";
    ProductFieldsEnum[ProductFieldsEnum["motorInsulation"] = 1444] = "motorInsulation";
    ProductFieldsEnum[ProductFieldsEnum["hvacMotorLocation"] = 1445] = "hvacMotorLocation";
    ProductFieldsEnum[ProductFieldsEnum["hvacMotorType"] = 1446] = "hvacMotorType";
    ProductFieldsEnum[ProductFieldsEnum["nameplateVoltage"] = 1447] = "nameplateVoltage";
    ProductFieldsEnum[ProductFieldsEnum["seasonalEnergyEfficiencyRatio"] = 1448] = "seasonalEnergyEfficiencyRatio";
    ProductFieldsEnum[ProductFieldsEnum["actuator"] = 1449] = "actuator";
    ProductFieldsEnum[ProductFieldsEnum["airType"] = 1450] = "airType";
    ProductFieldsEnum[ProductFieldsEnum["bearingType"] = 1451] = "bearingType";
    ProductFieldsEnum[ProductFieldsEnum["damperDiameter"] = 1452] = "damperDiameter";
    ProductFieldsEnum[ProductFieldsEnum["damperDiameterUOM"] = 1453] = "damperDiameterUOM";
    ProductFieldsEnum[ProductFieldsEnum["dischargeDirection"] = 1454] = "dischargeDirection";
    ProductFieldsEnum[ProductFieldsEnum["driveType"] = 1455] = "driveType";
    ProductFieldsEnum[ProductFieldsEnum["ductDiameter"] = 1456] = "ductDiameter";
    ProductFieldsEnum[ProductFieldsEnum["ductDiameterUOM"] = 1457] = "ductDiameterUOM";
    ProductFieldsEnum[ProductFieldsEnum["ductFittingDiameter"] = 1458] = "ductFittingDiameter";
    ProductFieldsEnum[ProductFieldsEnum["ductFittingDiameterUOM"] = 1459] = "ductFittingDiameterUOM";
    ProductFieldsEnum[ProductFieldsEnum["ductFittingLength"] = 1460] = "ductFittingLength";
    ProductFieldsEnum[ProductFieldsEnum["ductFittingLengthUOM"] = 1461] = "ductFittingLengthUOM";
    ProductFieldsEnum[ProductFieldsEnum["ductFittingMaterial"] = 1462] = "ductFittingMaterial";
    ProductFieldsEnum[ProductFieldsEnum["ductFittingType"] = 1463] = "ductFittingType";
    ProductFieldsEnum[ProductFieldsEnum["ductGauge"] = 1464] = "ductGauge";
    ProductFieldsEnum[ProductFieldsEnum["ductInsulationType"] = 1465] = "ductInsulationType";
    ProductFieldsEnum[ProductFieldsEnum["energyRecoveryWheel"] = 1466] = "energyRecoveryWheel";
    ProductFieldsEnum[ProductFieldsEnum["flangeWidth"] = 1467] = "flangeWidth";
    ProductFieldsEnum[ProductFieldsEnum["flangeWidthUOM"] = 1468] = "flangeWidthUOM";
    ProductFieldsEnum[ProductFieldsEnum["fullLoadCurrent"] = 1469] = "fullLoadCurrent";
    ProductFieldsEnum[ProductFieldsEnum["fullLoadWattage"] = 1470] = "fullLoadWattage";
    ProductFieldsEnum[ProductFieldsEnum["grilleMaterial"] = 1471] = "grilleMaterial";
    ProductFieldsEnum[ProductFieldsEnum["hasHighEfficiencyMotor"] = 1472] = "hasHighEfficiencyMotor";
    ProductFieldsEnum[ProductFieldsEnum["louverType"] = 1473] = "louverType";
    ProductFieldsEnum[ProductFieldsEnum["maximumAmbientTemperature"] = 1474] = "maximumAmbientTemperature";
    ProductFieldsEnum[ProductFieldsEnum["maximumExhaustAirflow"] = 1475] = "maximumExhaustAirflow";
    ProductFieldsEnum[ProductFieldsEnum["maximumInletAirTemperature"] = 1476] = "maximumInletAirTemperature";
    ProductFieldsEnum[ProductFieldsEnum["maximumStaticPressure"] = 1477] = "maximumStaticPressure";
    ProductFieldsEnum[ProductFieldsEnum["maximumVentPipeDiameter"] = 1478] = "maximumVentPipeDiameter";
    ProductFieldsEnum[ProductFieldsEnum["maximumVentPipeDiameterUOM"] = 1479] = "maximumVentPipeDiameterUOM";
    ProductFieldsEnum[ProductFieldsEnum["minimumVentPipeDiameter"] = 1480] = "minimumVentPipeDiameter";
    ProductFieldsEnum[ProductFieldsEnum["minimumVentPipeDiameterUOM"] = 1481] = "minimumVentPipeDiameterUOM";
    ProductFieldsEnum[ProductFieldsEnum["portLocation"] = 1482] = "portLocation";
    ProductFieldsEnum[ProductFieldsEnum["pressureDifferentialMaximum"] = 1483] = "pressureDifferentialMaximum";
    ProductFieldsEnum[ProductFieldsEnum["sparkResistantConstructionType"] = 1484] = "sparkResistantConstructionType";
    ProductFieldsEnum[ProductFieldsEnum["ventilationType"] = 1485] = "ventilationType";
    ProductFieldsEnum[ProductFieldsEnum["wheelMaterial"] = 1486] = "wheelMaterial";
    ProductFieldsEnum[ProductFieldsEnum["wheelType"] = 1487] = "wheelType";
    ProductFieldsEnum[ProductFieldsEnum["freightClassCode"] = 1488] = "freightClassCode";
    ProductFieldsEnum[ProductFieldsEnum["warningLabel"] = 1489] = "warningLabel";
    ProductFieldsEnum[ProductFieldsEnum["warningLabelDescription"] = 1490] = "warningLabelDescription";
    ProductFieldsEnum[ProductFieldsEnum["suggestedHierarchy"] = 1491] = "suggestedHierarchy";
    ProductFieldsEnum[ProductFieldsEnum["buildingMaterialsApplication"] = 1492] = "buildingMaterialsApplication";
    ProductFieldsEnum[ProductFieldsEnum["coverageArea"] = 1493] = "coverageArea";
    ProductFieldsEnum[ProductFieldsEnum["coverageAreaUOM"] = 1494] = "coverageAreaUOM";
    ProductFieldsEnum[ProductFieldsEnum["mil"] = 1495] = "mil";
    ProductFieldsEnum[ProductFieldsEnum["legDimensions"] = 1496] = "legDimensions";
    ProductFieldsEnum[ProductFieldsEnum["flangeThickness"] = 1497] = "flangeThickness";
    ProductFieldsEnum[ProductFieldsEnum["flangeThicknessUOM"] = 1498] = "flangeThicknessUOM";
    ProductFieldsEnum[ProductFieldsEnum["buildingMaterialsFlangeWidth"] = 1499] = "buildingMaterialsFlangeWidth";
    ProductFieldsEnum[ProductFieldsEnum["buildingMaterialsFlangeWidthUOM"] = 1500] = "buildingMaterialsFlangeWidthUOM";
    ProductFieldsEnum[ProductFieldsEnum["rValue"] = 1501] = "rValue";
    ProductFieldsEnum[ProductFieldsEnum["shelfLife"] = 1502] = "shelfLife";
    ProductFieldsEnum[ProductFieldsEnum["shelfLifeUOM"] = 1503] = "shelfLifeUOM";
    ProductFieldsEnum[ProductFieldsEnum["storageInformation"] = 1504] = "storageInformation";
    ProductFieldsEnum[ProductFieldsEnum["edgeType"] = 1505] = "edgeType";
    ProductFieldsEnum[ProductFieldsEnum["fireResistant"] = 1506] = "fireResistant";
    ProductFieldsEnum[ProductFieldsEnum["fireRating"] = 1507] = "fireRating";
    ProductFieldsEnum[ProductFieldsEnum["includedItems"] = 1508] = "includedItems";
    ProductFieldsEnum[ProductFieldsEnum["dryColour"] = 1509] = "dryColour";
    ProductFieldsEnum[ProductFieldsEnum["recycledContent"] = 1510] = "recycledContent";
    ProductFieldsEnum[ProductFieldsEnum["minimumEmbedment"] = 1511] = "minimumEmbedment";
    ProductFieldsEnum[ProductFieldsEnum["minimumEmbedmentUOM"] = 1512] = "minimumEmbedmentUOM";
    ProductFieldsEnum[ProductFieldsEnum["pullMaximum"] = 1513] = "pullMaximum";
    ProductFieldsEnum[ProductFieldsEnum["pullMaximumUOM"] = 1514] = "pullMaximumUOM";
    ProductFieldsEnum[ProductFieldsEnum["shearMaximum"] = 1515] = "shearMaximum";
    ProductFieldsEnum[ProductFieldsEnum["shearMaximumUOM"] = 1516] = "shearMaximumUOM";
    ProductFieldsEnum[ProductFieldsEnum["collated"] = 1517] = "collated";
    ProductFieldsEnum[ProductFieldsEnum["collationMaterial"] = 1518] = "collationMaterial";
    ProductFieldsEnum[ProductFieldsEnum["topShape"] = 1519] = "topShape";
    ProductFieldsEnum[ProductFieldsEnum["windResistance"] = 1520] = "windResistance";
    ProductFieldsEnum[ProductFieldsEnum["loadCapacity"] = 1521] = "loadCapacity";
    ProductFieldsEnum[ProductFieldsEnum["loadCapacityUOM"] = 1522] = "loadCapacityUOM";
    ProductFieldsEnum[ProductFieldsEnum["safeWorkingLoad"] = 1523] = "safeWorkingLoad";
    ProductFieldsEnum[ProductFieldsEnum["safeWorkingLoadUOM"] = 1524] = "safeWorkingLoadUOM";
    ProductFieldsEnum[ProductFieldsEnum["strength"] = 1525] = "strength";
    ProductFieldsEnum[ProductFieldsEnum["strengthUOM"] = 1526] = "strengthUOM";
    ProductFieldsEnum[ProductFieldsEnum["fastenerShankType"] = 1527] = "fastenerShankType";
    ProductFieldsEnum[ProductFieldsEnum["vocRating"] = 1528] = "vocRating";
    ProductFieldsEnum[ProductFieldsEnum["vocContent"] = 1529] = "vocContent";
    ProductFieldsEnum[ProductFieldsEnum["buildingMaterialsInstallationType"] = 1530] = "buildingMaterialsInstallationType";
    ProductFieldsEnum[ProductFieldsEnum["buildingMaterialsWattage"] = 1531] = "buildingMaterialsWattage";
    ProductFieldsEnum[ProductFieldsEnum["pressureTreatedType"] = 1532] = "pressureTreatedType";
    ProductFieldsEnum[ProductFieldsEnum["replacementProductId"] = 1533] = "replacementProductId";
    ProductFieldsEnum[ProductFieldsEnum["replacementProductDescription"] = 1534] = "replacementProductDescription";
    ProductFieldsEnum[ProductFieldsEnum["colorFamily"] = 1535] = "colorFamily";
    ProductFieldsEnum[ProductFieldsEnum["exposureDurability"] = 1536] = "exposureDurability";
    ProductFieldsEnum[ProductFieldsEnum["modelNumber"] = 1537] = "modelNumber";
    ProductFieldsEnum[ProductFieldsEnum["outboundHierarchy"] = 1538] = "outboundHierarchy";
    ProductFieldsEnum[ProductFieldsEnum["ratingLabel"] = 1539] = "ratingLabel";
    ProductFieldsEnum[ProductFieldsEnum["ratingLabelDescription"] = 1540] = "ratingLabelDescription";
    ProductFieldsEnum[ProductFieldsEnum["breakingStrength"] = 1541] = "breakingStrength";
    ProductFieldsEnum[ProductFieldsEnum["workingLoadLimit"] = 1542] = "workingLoadLimit";
    ProductFieldsEnum[ProductFieldsEnum["minimumTemperature"] = 1543] = "minimumTemperature";
    ProductFieldsEnum[ProductFieldsEnum["recommendedTemperature"] = 1544] = "recommendedTemperature";
    ProductFieldsEnum[ProductFieldsEnum["recommendedWorkingPressure"] = 1545] = "recommendedWorkingPressure";
})(ProductFieldsEnum || (ProductFieldsEnum = {}));

const hierarchyTypes = [
    'supplierHierarchy',
    'groupHierarchy',
    'memberHierarchy',
    'outboundHierarchy',
    'suggestedHierarchy',
];
class AdvancedSearchComponent {
    constructor(router, route, datePipe) {
        this.router = router;
        this.route = route;
        this.datePipe = datePipe;
        this.setFilterEvent = new EventEmitter();
        this.emitFilters = new EventEmitter();
        this.ISODateTimeFormat = 'yyyy-MM-ddTHH:mm:ss';
        this.facetEnum = Facets;
        this.subscriptions = [];
        this.selectedPickListItems = {};
        this.selectedHierarchyItems = {};
        this.selectedNumericRangeItems = {};
        this.nextDay = new Date(new Date().setTime(new Date().getTime() + 24 * 60 * 60 * 1000));
        this.selectedDateRangeItems = {
            discontinueDate: { min: this.nextDay },
        };
        this.selectedDateTimeRangeItems = {};
        this.dateRangeItemsISOFormat = {};
        this.dateTimeRangeItemsISOFormat = {};
        this.selectedTreeNodes = {};
        this.appliedIcon = 'assets/images/filter-on.png';
        this.productImage = {
            fieldName: 'productImage',
        };
    }
    set facetDataSetter(facetData) {
        this.facetData = facetData;
        this.setFacetData();
    }
    set paramFiltersSetter(paramFilters) {
        if (paramFilters) {
            this.handleParamFilters(paramFilters);
        }
    }
    ngOnInit() {
        this.facetsToDisplay = [...this.facetsToDisplay, this.productImage].sort((a, b) => {
            if (a.fieldKey === ProductFieldsEnum.supplierName) {
                return -1;
            }
            if (b.fieldKey === ProductFieldsEnum.supplierName) {
                return 1;
            }
            return a.fieldName.localeCompare(b.fieldName);
        });
        this.nextDay.setHours(0);
        this.nextDay.setMinutes(0);
        this.nextDay.setSeconds(0);
        this.nextDay.setMilliseconds(0);
        this.subscriptions.push(timer(0).subscribe(() => {
            this.handleAdvancedSearch();
        }));
    }
    ngOnDestroy() {
        if (this.subscriptions) {
            this.subscriptions.forEach((subscription) => subscription.unsubscribe());
        }
    }
    setFacetData() {
        hierarchyTypes.forEach((type) => {
            var _a;
            const selectedHierarchy = this.selectedTreeNodes[type];
            const facetHierarchy = this.facetData && this.facetData[type];
            if (facetHierarchy && typeof facetHierarchy[0].value === 'string') {
                this.facetData[type][0].value = JSON.parse(this.facetData[type][0].value);
            }
            if (selectedHierarchy && facetHierarchy) {
                (_a = this.selectedTreeNodes[type]) === null || _a === void 0 ? void 0 : _a.forEach((node) => (node.partialSelected = true));
                this.selectedTreeNodes[type] = [];
                this.checkNode(facetHierarchy[0].value, selectedHierarchy.map((node) => node.data), type);
            }
        });
    }
    handleParamFilters(filters) {
        if (filters.PickList) {
            const productImageKeys = [
                'primaryImageFileName',
                'secondaryImageFileName',
            ];
            const productImage = productImageKeys.filter((key) => filters.PickList[key]);
            this.selectedPickListItems = Object.assign(Object.assign(Object.assign({}, this.selectedPickListItems), { productImage }), filters.PickList);
        }
        if (filters.DateTimeRange) {
            Object.keys(filters.DateTimeRange).forEach((dateTime) => {
                const { min, max } = filters.DateTimeRange[dateTime];
                this.selectedDateTimeRangeItems = Object.assign(Object.assign({}, this.selectedDateTimeRangeItems), { [dateTime]: this.setMinMax(min, max, (d) => new Date(d)) });
            });
        }
        if (filters.DateRange) {
            Object.keys(filters.DateRange).forEach((date) => {
                const { min, max } = filters.DateRange[date];
                this.selectedDateRangeItems = Object.assign(Object.assign({}, this.selectedDateRangeItems), { [date]: this.setMinMax(min, max, (d) => new Date(d)) });
            });
        }
        if (filters.NumericRange) {
            Object.keys(filters.NumericRange).forEach((numeric) => {
                const { min, max } = filters.NumericRange[numeric];
                this.selectedNumericRangeItems = Object.assign(Object.assign({}, this.selectedNumericRangeItems), { [numeric]: this.setMinMax(min, max) });
            });
        }
        if (filters.Hierarchy) {
            Object.keys(filters.Hierarchy).forEach((hierarchy) => {
                this.selectedHierarchyItems[hierarchy] = filters.Hierarchy[hierarchy];
                if (hierarchyTypes.includes(hierarchy)) {
                    this.selectedTreeNodes[hierarchy] = this.buildTreeFromItems(filters.Hierarchy[hierarchy]);
                }
            });
        }
    }
    facetType(facetKey) {
        if (facetKey !== 'dateAdded' &&
            facetKey !== 'dateLastChanged' &&
            facetKey !== 'discontinueDate' &&
            facetKey !== 'startShipDate' &&
            facetKey !== 'endShipDate' &&
            facetKey !== 'consumerDate' &&
            facetKey !== 'msrp' &&
            facetKey !== 'listPrice' &&
            !hierarchyTypes.includes(facetKey) &&
            facetKey !== 'completionPercent' &&
            facetKey !== 'showOnlineStartDate' &&
            facetKey !== 'showOnlineEndDate') {
            if (this.facetData[facetKey] !== undefined) {
                const tempFacet = this.facetData[facetKey];
                const index = tempFacet.map((x) => x.value).indexOf('Unspecified');
                if (index !== -1) {
                    const temp = this.facetData[facetKey].splice(index, 1);
                    this.facetData[facetKey].push(temp[0]);
                }
            }
            return 'pickList';
        }
        else if (hierarchyTypes.includes(facetKey)) {
            if (this.selectedTreeNodes[facetKey] === undefined) {
                this.selectedTreeNodes[facetKey] = [];
            }
            return 'hierarchy';
        }
        else {
            if (facetKey === 'listPrice' ||
                facetKey === 'msrp' ||
                facetKey === 'completionPercent') {
                if (this.selectedNumericRangeItems[facetKey] === undefined) {
                    this.selectedNumericRangeItems[facetKey] = new SearchRange();
                }
                return 'numericRange';
            }
            else {
                if (facetKey === 'dateAdded' || facetKey === 'dateLastChanged') {
                    if (this.selectedDateTimeRangeItems[facetKey] === undefined) {
                        this.selectedDateTimeRangeItems[facetKey] = {
                            max: null,
                            min: null,
                            timeZone: this.timeZoneCode,
                        };
                    }
                    return 'dateTimeRange';
                }
                else {
                    if (this.selectedDateRangeItems[facetKey] === undefined) {
                        this.selectedDateRangeItems[facetKey] = {
                            max: null,
                            min: null,
                        };
                    }
                    return 'dateRange';
                }
            }
        }
    }
    handleAdvancedSearch() {
        const _a = this.selectedPickListItems, { productImage } = _a, rest = __rest(_a, ["productImage"]);
        const transformedPickList = Object.assign(Object.assign({}, rest), (productImage || []).reduce((query, image) => {
            return Object.assign(Object.assign({}, query), { [image]: ['Unspecified'] });
        }, {}));
        // Reload updated hierarchy selections
        hierarchyTypes.forEach((hierarchy) => {
            if (this.selectedTreeNodes[hierarchy] !== undefined) {
                this.selectedHierarchyItems[hierarchy] = this.selectedTreeNodes[hierarchy].map((node) => node.data);
            }
        });
        for (const property in this.selectedDateTimeRangeItems) {
            if (this.facetsToDisplay.filter((a) => a['fieldName'] === property)
                .length !== 0) {
                if (this.selectedDateTimeRangeItems[property]) {
                    if (!this.dateTimeRangeItemsISOFormat[property]) {
                        this.dateTimeRangeItemsISOFormat[property] = {
                            max: null,
                            min: null,
                            timeZone: this.timeZoneCode,
                        };
                    }
                    if (this.selectedDateTimeRangeItems[property].min) {
                        this.dateTimeRangeItemsISOFormat[property].min =
                            this.datePipe.transform(this.selectedDateTimeRangeItems[property].min, this.ISODateTimeFormat);
                    }
                    else {
                        this.dateTimeRangeItemsISOFormat[property].min = null;
                    }
                    if (this.selectedDateTimeRangeItems[property].max) {
                        this.dateTimeRangeItemsISOFormat[property].max =
                            this.datePipe.transform(this.selectedDateTimeRangeItems[property].max, this.ISODateTimeFormat);
                    }
                    else {
                        this.dateTimeRangeItemsISOFormat[property].max = null;
                    }
                }
            }
        }
        for (const property in this.selectedDateRangeItems) {
            if (this.facetsToDisplay.filter((a) => a['fieldName'] === property)
                .length !== 0) {
                if (this.selectedDateRangeItems[property]) {
                    if (!this.dateRangeItemsISOFormat[property]) {
                        this.dateRangeItemsISOFormat[property] = {
                            max: null,
                            min: null,
                        };
                    }
                    if (this.selectedDateRangeItems[property].min) {
                        this.dateRangeItemsISOFormat[property].min =
                            this.datePipe.transform(this.selectedDateRangeItems[property].min, this.ISODateTimeFormat);
                    }
                    else {
                        this.dateRangeItemsISOFormat[property].min = null;
                    }
                    if (this.selectedDateRangeItems[property].max) {
                        this.dateRangeItemsISOFormat[property].max =
                            this.datePipe.transform(this.selectedDateRangeItems[property].max, this.ISODateTimeFormat);
                    }
                    else {
                        this.dateRangeItemsISOFormat[property].max = null;
                    }
                }
            }
        }
        const searchFilters = {
            Hierarchy: this.selectedHierarchyItems,
            PickList: transformedPickList,
            NumericRange: this.selectedNumericRangeItems,
            DateRange: this.dateRangeItemsISOFormat,
            DateTimeRange: this.dateTimeRangeItemsISOFormat,
        };
        this.filtersStringparam = JSON.stringify(searchFilters);
        const allObjectsNullOrEmpty = this.isObjectNullOrEmpty(searchFilters);
        this.setFilterEvent.emit({
            filters: allObjectsNullOrEmpty
                ? {}
                : {
                    Hierarchy: this.selectedHierarchyItems,
                    PickList: transformedPickList,
                    NumericRange: this.selectedNumericRangeItems,
                    DateRange: this.dateRangeItemsISOFormat,
                    DateTimeRange: this.dateTimeRangeItemsISOFormat,
                },
            options: { search: true },
        });
        this.emitFilters.emit(this.filtersStringparam);
        this.router.navigate([], {
            relativeTo: this.route,
            queryParams: { filters: this.filtersStringparam },
        });
    }
    isObjectNullOrEmpty(obj) {
        for (const key in obj) {
            if (key === 'timeZone') {
                continue;
            }
            const value = obj[key];
            if (value !== null && value !== undefined && value !== '') {
                if (typeof value === 'object' && !this.isObjectNullOrEmpty(value)) {
                    return false;
                }
                else if (typeof value !== 'object') {
                    return false;
                }
            }
        }
        return true;
    }
    clearAdvancedSearch() {
        this.selectedDateRangeItems = {};
        this.selectedDateTimeRangeItems = {};
        this.selectedHierarchyItems = {};
        this.selectedPickListItems = {};
        this.selectedNumericRangeItems = {};
        this.selectedTreeNodes = {};
        this.setFilterEvent.emit({
            filters: {},
            options: { search: true },
        });
    }
    buildTreeFromItems(items) {
        const treeNodes = [];
        const map = {};
        items.forEach((item) => {
            const itemParts = item.split('|').filter((part) => part.trim() !== '');
            let parentNode = null;
            itemParts.forEach((part, index) => {
                const key = itemParts.slice(0, index + 1).join('|');
                if (!map[key]) {
                    const newNode = {
                        data: item,
                        label: part,
                        children: [],
                    };
                    if (parentNode) {
                        parentNode.children.push(newNode);
                        treeNodes.push(newNode);
                    }
                    else {
                        treeNodes.push(newNode);
                    }
                    map[key] = newNode;
                }
                parentNode = map[key];
            });
        });
        return treeNodes;
    }
    checkNode(nodes, str, hierarchy) {
        nodes.forEach((node) => {
            if (str.filter((x) => x.startsWith(node.data)).length !== 0) {
                node.expanded = true;
                node.partialSelected = true;
                if (str.includes(node.data)) {
                    this.selectedTreeNodes[hierarchy].push(node);
                }
            }
            if (node.children !== undefined) {
                node.children.forEach((child) => {
                    if (str.includes(child.data) && !str.includes(node.data)) {
                        node.partialSelected = true;
                        node.expanded = true;
                        child.parent = node;
                    }
                    if (str.includes(node.label)) {
                        child.parent = node;
                    }
                });
            }
            else {
                return;
            }
            this.checkNode(node.children, str, hierarchy);
        });
    }
    getValidDate($event, facetKey, type) {
        this.selectedDateRangeItems[facetKey][type] = $event;
    }
    getValidDateTime($event, facetKey, type) {
        this.selectedDateTimeRangeItems[facetKey][type] = $event;
    }
    setMinMax(min, max, callback = (x) => x) {
        return Object.assign({}, min && { min: callback(min) }, max && { max: callback(max) });
    }
}
AdvancedSearchComponent.decorators = [
    { type: Component, args: [{
                selector: 'lib-advanced-search',
                template: "<div class=\"vertical-flow advanced-search\">\r\n  <div class=\"horizontal-fixed space-between-075\">\r\n    <button\r\n      pButton\r\n      class=\"ds width-50\"\r\n      type=\"button\"\r\n      label=\"{{ 'ADVANCED_SEARCH.CLEAR' | transloco }}\"\r\n      (click)=\"clearAdvancedSearch()\"\r\n    ></button>\r\n\r\n    <button\r\n      pButton\r\n      class=\"ds width-50\"\r\n      type=\"button\"\r\n      label=\"{{ 'ADVANCED_SEARCH.APPLY' | transloco }}\"\r\n      (click)=\"handleAdvancedSearch()\"\r\n    ></button>\r\n  </div>\r\n  <div class=\"space-before-100\">\r\n    <p-accordion\r\n      [multiple]=\"true\"\r\n      styleClass=\"advancedSearchTabHeader\"\r\n      expandIcon=\"pi pi-caret-right\"\r\n      collapseIcon=\"pi pi-caret-down\"\r\n    >\r\n      <ng-container\r\n        *ngIf=\"\r\n          facetData && selectedDateRangeItems && selectedDateTimeRangeItems\r\n        \"\r\n      >\r\n        <div class=\"vertical-flow space-between-025\">\r\n          <ng-container *ngFor=\"let facet of facetsToDisplay\">\r\n            <p-accordionTab *ngIf=\"facetType(facet.fieldName) === 'hierarchy'\">\r\n              <p-header>\r\n                <div class=\"facet-header\">\r\n                  <div class=\"facet-title\">\r\n                    {{ facetEnum[facet.fieldName] | transloco }}\r\n                  </div>\r\n\r\n                  <div\r\n                    class=\"facet-icon\"\r\n                    *ngIf=\"selectedTreeNodes[facet.fieldName]?.length\"\r\n                  >\r\n                    <img [src]=\"appliedIcon\" />\r\n                  </div>\r\n                </div>\r\n              </p-header>\r\n              <div class=\"input\">\r\n                <p-tree\r\n                  [value]=\"facetData[facet.fieldName][0].value\"\r\n                  selectionMode=\"checkbox\"\r\n                  [(selection)]=\"selectedTreeNodes[facet.fieldName]\"\r\n                ></p-tree>\r\n              </div>\r\n            </p-accordionTab>\r\n            <p-accordionTab\r\n              class=\"ui-selection-helper\"\r\n              *ngIf=\"facetType(facet.fieldName) === 'pickList'\"\r\n            >\r\n              <p-header>\r\n                <div class=\"facet-header\">\r\n                  <div class=\"facet-title\">\r\n                    {{ facetEnum[facet.fieldName] | transloco }}\r\n                  </div>\r\n                  <div\r\n                    class=\"facet-icon\"\r\n                    *ngIf=\"selectedPickListItems[facet.fieldName]?.length\"\r\n                  >\r\n                    <img [src]=\"appliedIcon\" />\r\n                  </div>\r\n                </div>\r\n              </p-header>\r\n              <div class=\"input\">\r\n                <div\r\n                  *ngFor=\"\r\n                    let rowData of facetData[facet.fieldName];\r\n                    let i = index\r\n                  \"\r\n                  class=\"vertical-flow\"\r\n                >\r\n                  <p-checkbox\r\n                    [ngClass]=\"i > 0 ? 'space-before-075' : ''\"\r\n                    [name]=\"facet.fieldName\"\r\n                    [value]=\"rowData.value\"\r\n                    [label]=\"rowData.label ? rowData.label : rowData.value\"\r\n                    [(ngModel)]=\"selectedPickListItems[facet.fieldName]\"\r\n                  ></p-checkbox>\r\n                </div>\r\n              </div>\r\n            </p-accordionTab>\r\n            <p-accordionTab\r\n              *ngIf=\"facetType(facet.fieldName) === 'numericRange'\"\r\n            >\r\n              <p-header>\r\n                <div class=\"facet-header\">\r\n                  <div class=\"facet-title\">\r\n                    {{ facetEnum[facet.fieldName] | transloco }}\r\n                  </div>\r\n                  <div\r\n                    class=\"facet-icon\"\r\n                    *ngIf=\"\r\n                      selectedNumericRangeItems[facet.fieldName].min ||\r\n                      selectedNumericRangeItems[facet.fieldName].max\r\n                    \"\r\n                  >\r\n                    <img [src]=\"appliedIcon\" />\r\n                  </div>\r\n                </div>\r\n              </p-header>\r\n              <div class=\"vertical-flow space-between-075 input-filter\">\r\n                <div>{{ 'ADVANCED_SEARCH.MINMAX' | transloco }}</div>\r\n                <div>\r\n                  <p-inputNumber\r\n                    mode=\"decimal\"\r\n                    [name]=\"facet.fieldName + 'min'\"\r\n                    [minFractionDigits]=\"facet.decimalLimit\"\r\n                    [maxFractionDigits]=\"facet.decimalLimit\"\r\n                    [(ngModel)]=\"selectedNumericRangeItems[facet.fieldName].min\"\r\n                    [placeholder]=\"\r\n                      facet.fieldName === 'completionPercent' ? '0' : '$0'\r\n                    \"\r\n                  ></p-inputNumber>\r\n                </div>\r\n                <div>\r\n                  <p-inputNumber\r\n                    mode=\"decimal\"\r\n                    [name]=\"facet.fieldName + 'max'\"\r\n                    [minFractionDigits]=\"facet.decimalLimit\"\r\n                    [maxFractionDigits]=\"facet.decimalLimit\"\r\n                    [(ngModel)]=\"selectedNumericRangeItems[facet.fieldName].max\"\r\n                    [placeholder]=\"\r\n                      facet.fieldName === 'completionPercent'\r\n                        ? '100'\r\n                        : '$1000000'\r\n                    \"\r\n                  ></p-inputNumber>\r\n                </div>\r\n              </div>\r\n            </p-accordionTab>\r\n            <p-accordionTab *ngIf=\"facetType(facet.fieldName) === 'dateRange'\">\r\n              <p-header>\r\n                <div class=\"facet-header\">\r\n                  <div class=\"facet-title\">\r\n                    {{ facetEnum[facet.fieldName] | transloco }}\r\n                  </div>\r\n                  <div\r\n                    class=\"facet-icon\"\r\n                    *ngIf=\"\r\n                      selectedDateRangeItems[facet.fieldName].max ||\r\n                      selectedDateRangeItems[facet.fieldName].min\r\n                    \"\r\n                  >\r\n                    <img [src]=\"appliedIcon\" />\r\n                  </div>\r\n                </div>\r\n              </p-header>\r\n\r\n              <div class=\"vertical-flow space-between-075 input-filter\">\r\n                <div>{{ 'ADVANCED_SEARCH.RANGE' | transloco }}</div>\r\n                <div>\r\n                  <p-calendar\r\n                    [showIcon]=\"true\"\r\n                    [maxDate]=\"selectedDateRangeItems[facet.fieldName].max\"\r\n                    [name]=\"facet.fieldName + 'min'\"\r\n                    [(ngModel)]=\"selectedDateRangeItems[facet.fieldName].min\"\r\n                    appendTo=\"body\"\r\n                    [dateFormat]=\"dateType.primeNgFormat\"\r\n                    [placeholder]=\"dateType.description\"\r\n                    (onSelect)=\"getValidDate($event, facet.fieldName, 'min')\"\r\n                  ></p-calendar>\r\n                </div>\r\n                <div>\r\n                  <p-calendar\r\n                    [minDate]=\"selectedDateRangeItems[facet.fieldName].min\"\r\n                    [showIcon]=\"true\"\r\n                    [name]=\"facet.fieldName + 'max'\"\r\n                    appendTo=\"body\"\r\n                    [dateFormat]=\"dateType.primeNgFormat\"\r\n                    [placeholder]=\"dateType.description\"\r\n                    [(ngModel)]=\"selectedDateRangeItems[facet.fieldName].max\"\r\n                    (onSelect)=\"getValidDate($event, facet.fieldName, 'max')\"\r\n                  ></p-calendar>\r\n                </div>\r\n              </div>\r\n            </p-accordionTab>\r\n            <p-accordionTab\r\n              *ngIf=\"facetType(facet.fieldName) === 'dateTimeRange'\"\r\n            >\r\n              <p-header>\r\n                <div class=\"facet-header\">\r\n                  <div class=\"facet-title\">\r\n                    {{ facetEnum[facet.fieldName] | transloco }}\r\n                  </div>\r\n                  <div\r\n                    class=\"facet-icon\"\r\n                    *ngIf=\"\r\n                      selectedDateTimeRangeItems[facet.fieldName].max ||\r\n                      selectedDateTimeRangeItems[facet.fieldName].min\r\n                    \"\r\n                  >\r\n                    <img [src]=\"appliedIcon\" />\r\n                  </div>\r\n                </div>\r\n              </p-header>\r\n              <div class=\"vertical-flow space-between-075\">\r\n                <div>{{ 'ADVANCED_SEARCH.RANGE' | transloco }}</div>\r\n                <div>\r\n                  <p-calendar\r\n                    [showIcon]=\"true\"\r\n                    [name]=\"facet.fieldName + 'min'\"\r\n                    [maxDate]=\"selectedDateTimeRangeItems[facet.fieldName].max\"\r\n                    [(ngModel)]=\"\r\n                      selectedDateTimeRangeItems[facet.fieldName].min\r\n                    \"\r\n                    appendTo=\"body\"\r\n                    [dateFormat]=\"dateType.primeNgFormat\"\r\n                    [placeholder]=\"dateType.description\"\r\n                    class=\"advancedSearch\"\r\n                    (onSelect)=\"\r\n                      getValidDateTime($event, facet.fieldName, 'min')\r\n                    \"\r\n                  ></p-calendar>\r\n                </div>\r\n                <div>\r\n                  <p-calendar\r\n                    [showIcon]=\"true\"\r\n                    [name]=\"facet.fieldName + 'max'\"\r\n                    appendTo=\"body\"\r\n                    [minDate]=\"selectedDateTimeRangeItems[facet.fieldName].min\"\r\n                    [dateFormat]=\"dateType.primeNgFormat\"\r\n                    [placeholder]=\"dateType.description\"\r\n                    [(ngModel)]=\"\r\n                      selectedDateTimeRangeItems[facet.fieldName].max\r\n                    \"\r\n                    class=\"advancedSearch\"\r\n                    (onSelect)=\"\r\n                      getValidDateTime($event, facet.fieldName, 'max')\r\n                    \"\r\n                  ></p-calendar>\r\n                </div>\r\n              </div>\r\n            </p-accordionTab>\r\n          </ng-container>\r\n        </div>\r\n      </ng-container>\r\n    </p-accordion>\r\n  </div>\r\n</div>\r\n",
                styles: [""]
            },] }
];
AdvancedSearchComponent.ctorParameters = () => [
    { type: Router },
    { type: ActivatedRoute },
    { type: DatePipe }
];
AdvancedSearchComponent.propDecorators = {
    facetDataSetter: [{ type: Input, args: ['facetData',] }],
    facetsToDisplay: [{ type: Input }],
    paramFiltersSetter: [{ type: Input, args: ['paramFilters',] }],
    dateType: [{ type: Input }],
    timeZoneCode: [{ type: Input }],
    timeType: [{ type: Input }],
    setFilterEvent: [{ type: Output }],
    emitFilters: [{ type: Output }]
};

class GetProductsRequest {
}
class SearchProductsRequest {
}
class DeleteProductRequest {
}
class SearchFilters {
}
class KPIRequest {
}
class KPIResponse {
}
class TermsAggregationRequest {
}

var ExportFormatTypes;
(function (ExportFormatTypes) {
    ExportFormatTypes[ExportFormatTypes["Excel"] = 1] = "Excel";
    ExportFormatTypes[ExportFormatTypes["JSON"] = 2] = "JSON";
    ExportFormatTypes[ExportFormatTypes["XML"] = 3] = "XML";
    ExportFormatTypes[ExportFormatTypes["PDF"] = 4] = "PDF";
})(ExportFormatTypes || (ExportFormatTypes = {}));
var ExportDataTypes;
(function (ExportDataTypes) {
    ExportDataTypes[ExportDataTypes["Data"] = 1] = "Data";
    ExportDataTypes[ExportDataTypes["Assets"] = 2] = "Assets";
    ExportDataTypes[ExportDataTypes["DataAndAssets"] = 3] = "DataAndAssets";
})(ExportDataTypes || (ExportDataTypes = {}));
var ExportSelectionType;
(function (ExportSelectionType) {
    ExportSelectionType[ExportSelectionType["SelectedItems"] = 1] = "SelectedItems";
    ExportSelectionType[ExportSelectionType["CurrentPage"] = 2] = "CurrentPage";
    ExportSelectionType[ExportSelectionType["AllPages"] = 3] = "AllPages";
})(ExportSelectionType || (ExportSelectionType = {}));

const ProductFieldEnumMap = new Map([
    [ProductFieldsEnum.id, { field: 'id' }],
    [ProductFieldsEnum.sku, { field: 'sku' }],
    [
        ProductFieldsEnum.description,
        {
            field: 'description',
        },
    ],
    [ProductFieldsEnum.groupSKU, { field: 'groupSKU' }],
    [
        ProductFieldsEnum.groupDescription,
        {
            field: 'groupDescription',
        },
    ],
    [
        ProductFieldsEnum.memberSKU,
        {
            field: 'memberSKU',
        },
    ],
    [
        ProductFieldsEnum.memberDescription,
        {
            field: 'memberDescription',
        },
    ],
    [
        ProductFieldsEnum.supplierSKU,
        {
            field: 'supplierSKU',
        },
    ],
    [
        ProductFieldsEnum.manufacturerSKU,
        {
            field: 'manufacturerSKU',
        },
    ],
    [
        ProductFieldsEnum.supplierNumber,
        {
            field: 'supplierNumber',
        },
    ],
    [
        ProductFieldsEnum.supplierName,
        {
            field: 'supplierName',
        },
    ],
    [
        ProductFieldsEnum.manufacturerCode,
        {
            field: 'manufacturerCode',
        },
    ],
    [
        ProductFieldsEnum.manufacturerName,
        {
            field: 'manufacturerName',
        },
    ],
    [
        ProductFieldsEnum.lbmxSupplierID,
        {
            field: 'lbmxSupplierID',
        },
    ],
    [ProductFieldsEnum.upc, { field: 'upc' }],
    [ProductFieldsEnum.ean, { field: 'ean' }],
    [ProductFieldsEnum.gtin, { field: 'gtin' }],
    [ProductFieldsEnum.isbn, { field: 'isbn' }],
    [ProductFieldsEnum.notes, { field: 'notes' }],
    [
        ProductFieldsEnum.supplierHierarchy,
        {
            field: 'supplierHierarchy',
        },
    ],
    [
        ProductFieldsEnum.groupHierarchy,
        {
            field: 'groupHierarchy',
        },
    ],
    [
        ProductFieldsEnum.memberHierarchy,
        {
            field: 'memberHierarchy',
        },
    ],
    [
        ProductFieldsEnum.divisionCode,
        {
            field: 'divisionCode',
        },
    ],
    [
        ProductFieldsEnum.divisionName,
        {
            field: 'divisionName',
        },
    ],
    [
        ProductFieldsEnum.majorDepartmentCode,
        {
            field: 'majorDepartmentCode',
        },
    ],
    [
        ProductFieldsEnum.majorDepartmentName,
        {
            field: 'majorDepartmentName',
        },
    ],
    [
        ProductFieldsEnum.departmentCode,
        {
            field: 'departmentCode',
        },
    ],
    [
        ProductFieldsEnum.departmentName,
        {
            field: 'departmentName',
        },
    ],
    [
        ProductFieldsEnum.subDepartmentCode,
        {
            field: 'subDepartmentCode',
        },
    ],
    [
        ProductFieldsEnum.subDepartmentName,
        {
            field: 'subDepartmentName',
        },
    ],
    [
        ProductFieldsEnum.majorClassCode,
        {
            field: 'majorClassCode',
        },
    ],
    [
        ProductFieldsEnum.majorClassName,
        {
            field: 'majorClassName',
        },
    ],
    [
        ProductFieldsEnum.classCode,
        {
            field: 'classCode',
        },
    ],
    [
        ProductFieldsEnum.className,
        {
            field: 'className',
        },
    ],
    [
        ProductFieldsEnum.subClassCode,
        {
            field: 'subClassCode',
        },
    ],
    [
        ProductFieldsEnum.subClassName,
        {
            field: 'subClassName',
        },
    ],
    [
        ProductFieldsEnum.categoryCode,
        {
            field: 'categoryCode',
        },
    ],
    [
        ProductFieldsEnum.categoryName,
        {
            field: 'categoryName',
        },
    ],
    [
        ProductFieldsEnum.genderCode,
        {
            field: 'genderCode',
        },
    ],
    [ProductFieldsEnum.gender, { field: 'gender' }],
    [
        ProductFieldsEnum.colourCode,
        {
            field: 'colourCode',
        },
    ],
    [
        ProductFieldsEnum.colourName,
        {
            field: 'colourName',
        },
    ],
    [ProductFieldsEnum.sizeCode, { field: 'sizeCode' }],
    [ProductFieldsEnum.sizeName, { field: 'sizeName' }],
    [
        ProductFieldsEnum.listPrice,
        {
            field: 'listPrice',
        },
    ],
    [
        ProductFieldsEnum.listCurrency,
        {
            field: 'listCurrency',
        },
    ],
    [ProductFieldsEnum.msrp, { field: 'msrp' }],
    [
        ProductFieldsEnum.msrpCurrency,
        {
            field: 'msrpCurrency',
        },
    ],
    [
        ProductFieldsEnum.unitOfMeasure,
        {
            field: 'unitOfMeasure',
        },
    ],
    [
        ProductFieldsEnum.availableDate,
        {
            field: 'availableDate',
        },
    ],
    [
        ProductFieldsEnum.discontinueDate,
        {
            field: 'discontinueDate',
        },
    ],
    [
        ProductFieldsEnum.consumerDate,
        {
            field: 'consumerDate',
        },
    ],
    [
        ProductFieldsEnum.dateAdded,
        {
            field: 'dateAdded',
        },
    ],
    [
        ProductFieldsEnum.dateLastChanged,
        {
            field: 'dateLastChanged',
        },
    ],
    [
        ProductFieldsEnum.startShipDate,
        {
            field: 'startShipDate',
        },
    ],
    [
        ProductFieldsEnum.endShipDate,
        {
            field: 'endShipDate',
        },
    ],
    [
        ProductFieldsEnum.productSeason,
        {
            field: 'productSeason',
        },
    ],
    [
        ProductFieldsEnum.minOrderQty,
        {
            field: 'minOrderQty',
        },
    ],
    [
        ProductFieldsEnum.maxOrderQty,
        {
            field: 'maxOrderQty',
        },
    ],
    [
        ProductFieldsEnum.orderQtyMultiple,
        {
            field: 'orderQtyMultiple',
        },
    ],
    [
        ProductFieldsEnum.dropShippable,
        {
            field: 'dropShippable',
        },
    ],
    [
        ProductFieldsEnum.innerPackQty,
        {
            field: 'innerPackQty',
        },
    ],
    [
        ProductFieldsEnum.outerPackQty,
        {
            field: 'outerPackQty',
        },
    ],
    [
        ProductFieldsEnum.masterPackCaseLength,
        {
            field: 'masterPackCase.length',
            type: Type.Object,
            description: 'LENGTH',
        },
    ],
    [
        ProductFieldsEnum.masterPackCaseLengthUOM,
        {
            field: 'masterPackCase.lengthUOM',
            type: Type.Object,
            description: 'LENGTH_UOM',
        },
    ],
    [
        ProductFieldsEnum.masterPackCaseWidth,
        {
            field: 'masterPackCase.width',
            type: Type.Object,
            description: 'WIDTH',
        },
    ],
    [
        ProductFieldsEnum.masterPackCaseWidthUOM,
        {
            field: 'masterPackCase.widthUOM',
            type: Type.Object,
            description: 'WIDTH_UOM',
        },
    ],
    [
        ProductFieldsEnum.masterPackCaseHeight,
        {
            field: 'masterPackCase.height',
            type: Type.Object,
            description: 'HEIGHT',
        },
    ],
    [
        ProductFieldsEnum.masterPackCaseHeightUOM,
        {
            field: 'masterPackCase.heightUOM',
            type: Type.Object,
            description: 'HEIGHT_UOM',
        },
    ],
    [
        ProductFieldsEnum.masterPackCaseWeight,
        {
            field: 'masterPackCase.weight',
            type: Type.Object,
            description: 'WEIGHT',
        },
    ],
    [
        ProductFieldsEnum.masterPackCaseWeightUOM,
        {
            field: 'masterPackCase.weightUOM',
            type: Type.Object,
            description: 'WEIGHT_UOM',
        },
    ],
    [
        ProductFieldsEnum.masterPackCaseVolume,
        {
            field: 'masterPackCase.volume',
            type: Type.Object,
            description: 'VOLUME',
        },
    ],
    [
        ProductFieldsEnum.masterPackCaseVolumeUOM,
        {
            field: 'masterPackCase.volumeUOM',
            type: Type.Object,
            description: 'VOLUME_UOM',
        },
    ],
    [
        ProductFieldsEnum.masterPackCaseUPC,
        {
            field: 'masterPackCase.upc',
            type: Type.Object,
            description: 'UPC',
        },
    ],
    [
        ProductFieldsEnum.consumerPackageLength,
        {
            field: 'consumerPackage.length',
            type: Type.Object,
            description: 'LENGTH',
        },
    ],
    [
        ProductFieldsEnum.consumerPackageLengthUOM,
        {
            field: 'consumerPackage.lengthUOM',
            type: Type.Object,
            description: 'LENGTH_UOM',
        },
    ],
    [
        ProductFieldsEnum.consumerPackageWidth,
        {
            field: 'consumerPackage.width',
            type: Type.Object,
            description: 'WIDTH',
        },
    ],
    [
        ProductFieldsEnum.consumerPackageWidthUOM,
        {
            field: 'consumerPackage.widthUOM',
            type: Type.Object,
            description: 'WIDTH_UOM',
        },
    ],
    [
        ProductFieldsEnum.consumerPackageHeight,
        {
            field: 'consumerPackage.height',
            type: Type.Object,
            description: 'HEIGHT',
        },
    ],
    [
        ProductFieldsEnum.consumerPackageHeightUOM,
        {
            field: 'consumerPackage.heightUOM',
            type: Type.Object,
            description: 'HEIGHT_UOM',
        },
    ],
    [
        ProductFieldsEnum.consumerPackageWeight,
        {
            field: 'consumerPackage.weight',
            type: Type.Object,
            description: 'WEIGHT',
        },
    ],
    [
        ProductFieldsEnum.consumerPackageWeightUOM,
        {
            field: 'consumerPackage.weightUOM',
            type: Type.Object,
            description: 'WEIGHT_UOM',
        },
    ],
    [
        ProductFieldsEnum.consumerPackageVolume,
        {
            field: 'consumerPackage.volume',
            type: Type.Object,
            description: 'VOLUME',
        },
    ],
    [
        ProductFieldsEnum.consumerPackageVolumeUOM,
        {
            field: 'consumerPackage.volumeUOM',
            type: Type.Object,
            description: 'VOLUME_UOM',
        },
    ],
    [
        ProductFieldsEnum.palletQuantity,
        {
            field: 'palletInformation.quantity',
            type: Type.Object,
            description: 'QUANTITY',
        },
    ],
    [
        ProductFieldsEnum.palletInformationHeight,
        {
            field: 'palletInformation.height',
            type: Type.Object,
            description: 'HEIGHT',
        },
    ],
    [
        ProductFieldsEnum.palletInformationHeightUOM,
        {
            field: 'palletInformation.heightUOM',
            type: Type.Object,
            description: 'HEIGHT_UOM',
        },
    ],
    [
        ProductFieldsEnum.palletInformationWidth,
        {
            field: 'palletInformation.width',
            type: Type.Object,
            description: 'WIDTH',
        },
    ],
    [
        ProductFieldsEnum.palletInformationWidthUOM,
        {
            field: 'palletInformation.widthUOM',
            type: Type.Object,
            description: 'WIDTH_UOM',
        },
    ],
    [
        ProductFieldsEnum.palletInformationLength,
        {
            field: 'palletInformation.length',
            type: Type.Object,
            description: 'LENGTH',
        },
    ],
    [
        ProductFieldsEnum.palletInformationLengthUOM,
        {
            field: 'palletInformation.lengthUOM',
            type: Type.Object,
            description: 'LENGTH_UOM',
        },
    ],
    [
        ProductFieldsEnum.palletInformationWeight,
        {
            field: 'palletInformation.weight',
            type: Type.Object,
            description: 'WEIGHT',
        },
    ],
    [
        ProductFieldsEnum.palletInformationWeightUOM,
        {
            field: 'palletInformation.weightUOM',
            type: Type.Object,
            description: 'WEIGHT_UOM',
        },
    ],
    [
        ProductFieldsEnum.palletInformationBlocks,
        {
            field: 'palletInformation.blocks',
            type: Type.Object,
            description: 'BLOCKS',
        },
    ],
    [
        ProductFieldsEnum.palletInformationVolume,
        {
            field: 'palletInformation.volume',
            type: Type.Object,
            description: 'VOLUME',
        },
    ],
    [
        ProductFieldsEnum.palletInformationVolumeUOM,
        {
            field: 'palletInformation.volumeUOM',
            type: Type.Object,
            description: 'VOLUME_UOM',
        },
    ],
    [
        ProductFieldsEnum.longProductName,
        {
            field: 'longProductName',
        },
    ],
    [
        ProductFieldsEnum.longMarketingDescription,
        {
            field: 'longMarketingDescription',
        },
    ],
    [ProductFieldsEnum.features, { field: 'features' }],
    [ProductFieldsEnum.keyWords, { field: 'keyWords' }],
    [
        ProductFieldsEnum.countryOfOriginCode,
        {
            field: 'countryOfOriginCode',
        },
    ],
    [
        ProductFieldsEnum.productBullet,
        {
            field: 'productBullets',
            arrayObjectField: 'text',
            type: Type.Array,
        },
    ],
    [
        ProductFieldsEnum.optionalAccessory,
        {
            field: 'optionalAccessories',
            arrayObjectField: 'text',
            type: Type.Array,
        },
    ],
    [
        ProductFieldsEnum.primaryImageFilename,
        {
            field: 'primaryImage.filename',
            type: Type.Object,
        },
    ],
    [
        ProductFieldsEnum.primaryImageName,
        {
            field: 'primaryImage.name',
            type: Type.Object,
        },
    ],
    [
        ProductFieldsEnum.secondaryImageFilename,
        {
            field: 'secondaryImages',
            arrayObjectField: 'filename',
            type: Type.Array,
        },
    ],
    [
        ProductFieldsEnum.secondaryImageName,
        {
            field: 'secondaryImages',
            arrayObjectField: 'name',
            type: Type.Array,
        },
    ],
    [
        ProductFieldsEnum.videoName,
        {
            field: 'videos',
            arrayObjectField: 'name',
            type: Type.Array,
        },
    ],
    [
        ProductFieldsEnum.videoFilename,
        {
            field: 'videos',
            arrayObjectField: 'filename',
            type: Type.Array,
        },
    ],
    [
        ProductFieldsEnum.documentName,
        {
            field: 'documents',
            arrayObjectField: 'name',
            type: Type.Array,
        },
    ],
    [
        ProductFieldsEnum.documentFilename,
        {
            field: 'documents',
            arrayObjectField: 'filename',
            type: Type.Array,
        },
    ],
    [
        ProductFieldsEnum.harmonizedTariffCode,
        {
            field: 'harmonizedTariffCodes',
            arrayObjectField: 'text',
            type: Type.Array,
        },
    ],
    [ProductFieldsEnum.aersol, { field: 'aersol' }],
    [
        ProductFieldsEnum.waterResistant,
        {
            field: 'waterResistant',
        },
    ],
    [
        ProductFieldsEnum.waterResistantDescription,
        {
            field: 'waterResistantDescription',
        },
    ],
    [
        ProductFieldsEnum.energyStarCompliant,
        {
            field: 'energyStarCompliant',
        },
    ],
    [
        ProductFieldsEnum.fabricDescription,
        {
            field: 'fabricDescription',
        },
    ],
    [
        ProductFieldsEnum.fastenerType,
        {
            field: 'fastenerType',
        },
    ],
    [
        ProductFieldsEnum.fastenerLocation,
        {
            field: 'fastenerLocation',
        },
    ],
    [
        ProductFieldsEnum.apparelCut,
        {
            field: 'apparelCut',
        },
    ],
    [
        ProductFieldsEnum.collarType,
        {
            field: 'collarType',
        },
    ],
    [
        ProductFieldsEnum.sleeveType,
        {
            field: 'sleeveType',
        },
    ],
    [
        ProductFieldsEnum.sleeveLength,
        {
            field: 'sleeveLength',
        },
    ],
    [
        ProductFieldsEnum.sleeveLengthUOM,
        {
            field: 'sleeveLengthUOM',
        },
    ],
    [
        ProductFieldsEnum.pantInseamLength,
        {
            field: 'pantInseamLength',
        },
    ],
    [
        ProductFieldsEnum.pantInseamLengthUOM,
        {
            field: 'pantInseamLengthUOM',
        },
    ],
    [
        ProductFieldsEnum.dressSkirtLength,
        {
            field: 'dressSkirtLength',
        },
    ],
    [
        ProductFieldsEnum.dressSkirtLengthUOM,
        {
            field: 'dressSkirtLengthUOM',
        },
    ],
    [
        ProductFieldsEnum.isHangerIncluded,
        {
            field: 'isHangerIncluded',
        },
    ],
    [
        ProductFieldsEnum.itemHanging,
        {
            field: 'itemHanging',
        },
    ],
    [
        ProductFieldsEnum.careInstructions,
        {
            field: 'careInstructions',
        },
    ],
    [
        ProductFieldsEnum.areBatteriesIncluded,
        {
            field: 'areBatteriesIncluded',
        },
    ],
    [
        ProductFieldsEnum.areBatteriesRequired,
        {
            field: 'areBatteriesRequired',
        },
    ],
    [
        ProductFieldsEnum.powerSupplyCode,
        {
            field: 'powerSupplyCode',
        },
    ],
    [
        ProductFieldsEnum.batteryMaterials,
        {
            field: 'batteryMaterials',
        },
    ],
    [
        ProductFieldsEnum.areBatteriesBuiltIn,
        {
            field: 'areBatteriesBuiltIn',
        },
    ],
    [
        ProductFieldsEnum.batteryTechType,
        {
            field: 'batteryTechType',
        },
    ],
    [
        ProductFieldsEnum.batteryType,
        {
            field: 'batteryType',
        },
    ],
    [
        ProductFieldsEnum.batteryWeight,
        {
            field: 'batteryWeight',
        },
    ],
    [
        ProductFieldsEnum.batteryWeightUOM,
        {
            field: 'batteryWeightUOM',
        },
    ],
    [
        ProductFieldsEnum.batteryQuantityBuiltIn,
        {
            field: 'batteryQuantityBuiltIn',
        },
    ],
    [
        ProductFieldsEnum.batteryQuantityRequired,
        {
            field: 'batteryQuantityRequired',
        },
    ],
    [
        ProductFieldsEnum.batteryTypeQualifierCode,
        {
            field: 'batteryTypeQualifierCode',
        },
    ],
    [
        ProductFieldsEnum.batteryWattHourRating,
        {
            field: 'batteryWattHourRating',
        },
    ],
    [
        ProductFieldsEnum.batteryMaximumLife,
        {
            field: 'batteryMaximumLife',
        },
    ],
    [
        ProductFieldsEnum.warrantyDescription,
        {
            field: 'warrantyDescription',
        },
    ],
    [
        ProductFieldsEnum.warrantyConstraint,
        {
            field: 'warrantyConstraint',
        },
    ],
    [
        ProductFieldsEnum.warrantyDuration,
        {
            field: 'warrantyDuration',
        },
    ],
    [
        ProductFieldsEnum.warrantyEffectiveDateType,
        {
            field: 'warrantyEffectiveDateType',
        },
    ],
    [
        ProductFieldsEnum.warrantyType,
        {
            field: 'warrantyType',
        },
    ],
    [
        ProductFieldsEnum.actualProductLength,
        {
            field: 'actualProductLength',
        },
    ],
    [
        ProductFieldsEnum.actualProductLengthUOM,
        {
            field: 'actualProductLengthUOM',
        },
    ],
    [
        ProductFieldsEnum.actualProductThickness,
        {
            field: 'actualProductThickness',
        },
    ],
    [
        ProductFieldsEnum.actualProductThicknessUOM,
        {
            field: 'actualProductThicknessUOM',
        },
    ],
    [
        ProductFieldsEnum.actualProductWidth,
        {
            field: 'actualProductWidth',
        },
    ],
    [
        ProductFieldsEnum.actualProductWidthUOM,
        {
            field: 'actualProductWidthUOM',
        },
    ],
    [
        ProductFieldsEnum.appearanceBoardType,
        {
            field: 'appearanceBoardType',
        },
    ],
    [
        ProductFieldsEnum.boardJointType,
        {
            field: 'boardJointType',
        },
    ],
    [
        ProductFieldsEnum.finishType,
        {
            field: 'finishType',
        },
    ],
    [
        ProductFieldsEnum.lumberGrade,
        {
            field: 'lumberGrade',
        },
    ],
    [
        ProductFieldsEnum.woodSpecies,
        {
            field: 'woodSpecies',
        },
    ],
    [ProductFieldsEnum.texture, { field: 'texture' }],
    [
        ProductFieldsEnum.engineeredWoodType,
        {
            field: 'engineeredWoodType',
        },
    ],
    [
        ProductFieldsEnum.isPressureTreated,
        {
            field: 'isPressureTreated',
        },
    ],
    [
        ProductFieldsEnum.isTongueAndGroove,
        {
            field: 'isTongueAndGroove',
        },
    ],
    [
        ProductFieldsEnum.handleLength,
        {
            field: 'handleLength',
        },
    ],
    [
        ProductFieldsEnum.handleLengthUOM,
        {
            field: 'handleLengthUOM',
        },
    ],
    [
        ProductFieldsEnum.bladeLength,
        {
            field: 'bladeLength',
        },
    ],
    [
        ProductFieldsEnum.bladeLengthUOM,
        {
            field: 'bladeLengthUOM',
        },
    ],
    [
        ProductFieldsEnum.bladeWidth,
        {
            field: 'bladeWidth',
        },
    ],
    [
        ProductFieldsEnum.bladeWidthUOM,
        {
            field: 'bladeWidthUOM',
        },
    ],
    [
        ProductFieldsEnum.headWeight,
        {
            field: 'headWeight',
        },
    ],
    [
        ProductFieldsEnum.headWeightUOM,
        {
            field: 'headWeightUOM',
        },
    ],
    [ProductFieldsEnum.clawType, { field: 'clawType' }],
    [
        ProductFieldsEnum.hammerType,
        {
            field: 'hammerType',
        },
    ],
    [
        ProductFieldsEnum.handToolType,
        {
            field: 'handToolType',
        },
    ],
    [
        ProductFieldsEnum.handleShape,
        {
            field: 'handleShape',
        },
    ],
    [
        ProductFieldsEnum.handleMaterial,
        {
            field: 'handleMaterial',
        },
    ],
    [
        ProductFieldsEnum.driveStyle,
        {
            field: 'driveStyle',
        },
    ],
    [
        ProductFieldsEnum.individualOrSet,
        {
            field: 'individualOrSet',
        },
    ],
    [
        ProductFieldsEnum.setPieces,
        {
            field: 'setPieces',
        },
    ],
    [
        ProductFieldsEnum.measurementStandard,
        {
            field: 'measurementStandard',
        },
    ],
    [
        ProductFieldsEnum.ratcheting,
        {
            field: 'ratcheting',
        },
    ],
    [ProductFieldsEnum.sawType, { field: 'sawType' }],
    [
        ProductFieldsEnum.socketDepth,
        {
            field: 'socketDepth',
        },
    ],
    [
        ProductFieldsEnum.socketType,
        {
            field: 'socketType',
        },
    ],
    [
        ProductFieldsEnum.caliperType,
        {
            field: 'caliperType',
        },
    ],
    [
        ProductFieldsEnum.chiselTipStyle,
        {
            field: 'chiselTipStyle',
        },
    ],
    [
        ProductFieldsEnum.clampType,
        {
            field: 'clampType',
        },
    ],
    [ProductFieldsEnum.fileType, { field: 'fileType' }],
    [ProductFieldsEnum.keyType, { field: 'keyType' }],
    [
        ProductFieldsEnum.laserLevelType,
        {
            field: 'laserLevelType',
        },
    ],
    [
        ProductFieldsEnum.levelType,
        {
            field: 'levelType',
        },
    ],
    [
        ProductFieldsEnum.mountingMethod,
        {
            field: 'mountingMethod',
        },
    ],
    [
        ProductFieldsEnum.pliersType,
        {
            field: 'pliersType',
        },
    ],
    [
        ProductFieldsEnum.rightLeftHanded,
        {
            field: 'rightLeftHanded',
        },
    ],
    [
        ProductFieldsEnum.selfLeveling,
        {
            field: 'selfLeveling',
        },
    ],
    [
        ProductFieldsEnum.snipsType,
        {
            field: 'snipsType',
        },
    ],
    [ProductFieldsEnum.viseType, { field: 'viseType' }],
    [
        ProductFieldsEnum.wrenchType,
        {
            field: 'wrenchType',
        },
    ],
    [
        ProductFieldsEnum.weatherproof,
        {
            field: 'weatherproof',
        },
    ],
    [
        ProductFieldsEnum.materialApplication,
        {
            field: 'materialApplication',
        },
    ],
    [ProductFieldsEnum.toolType, { field: 'toolType' }],
    [
        ProductFieldsEnum.cordlessCorded,
        {
            field: 'cordlessCorded',
        },
    ],
    [
        ProductFieldsEnum.isChargerIncluded,
        {
            field: 'isChargerIncluded',
        },
    ],
    [
        ProductFieldsEnum.motorType,
        {
            field: 'motorType',
        },
    ],
    [
        ProductFieldsEnum.hasLaserGuide,
        {
            field: 'hasLaserGuide',
        },
    ],
    [
        ProductFieldsEnum.isVariableSpeed,
        {
            field: 'isVariableSpeed',
        },
    ],
    [
        ProductFieldsEnum.numberOfSpeeds,
        {
            field: 'numberOfSpeeds',
        },
    ],
    [
        ProductFieldsEnum.chuckSize,
        {
            field: 'chuckSize',
        },
    ],
    [
        ProductFieldsEnum.chuckSizeUOM,
        {
            field: 'chuckSizeUOM',
        },
    ],
    [
        ProductFieldsEnum.chuckType,
        {
            field: 'chuckType',
        },
    ],
    [
        ProductFieldsEnum.maximumSpeed,
        {
            field: 'maximumSpeed',
        },
    ],
    [
        ProductFieldsEnum.fittingA_Size,
        {
            field: 'fittingA.fittingSize',
            type: Type.Object,
        },
    ],
    [
        ProductFieldsEnum.fittingA_SizeUOM,
        {
            field: 'fittingA.fittingSizeUOM',
            type: Type.Object,
        },
    ],
    [
        ProductFieldsEnum.fittingA_Type,
        {
            field: 'fittingA.fittingType',
            type: Type.Object,
        },
    ],
    [
        ProductFieldsEnum.productType,
        {
            field: 'productType',
        },
    ],
    [
        ProductFieldsEnum.lubricationType,
        {
            field: 'lubricationType',
        },
    ],
    [
        ProductFieldsEnum.airOutletSize,
        {
            field: 'airOutletSize',
        },
    ],
    [
        ProductFieldsEnum.airOutletSizeUOM,
        {
            field: 'airOutletSizeUOM',
        },
    ],
    [
        ProductFieldsEnum.isCompressorComboKit,
        {
            field: 'isCompressorComboKit',
        },
    ],
    [
        ProductFieldsEnum.powerSource,
        {
            field: 'powerSource',
        },
    ],
    [ProductFieldsEnum.gauge, { field: 'gauge' }],
    [
        ProductFieldsEnum.airInletSize,
        {
            field: 'airInletSize',
        },
    ],
    [
        ProductFieldsEnum.airInletSizeUOM,
        {
            field: 'airInletSizeUOM',
        },
    ],
    [
        ProductFieldsEnum.fluidDeliveryType,
        {
            field: 'fluidDeliveryType',
        },
    ],
    [
        ProductFieldsEnum.application,
        {
            field: 'application',
        },
    ],
    [
        ProductFieldsEnum.hoseLength,
        {
            field: 'hoseLength',
        },
    ],
    [
        ProductFieldsEnum.hoseLengthUOM,
        {
            field: 'hoseLengthUOM',
        },
    ],
    [
        ProductFieldsEnum.horsepower,
        {
            field: 'horsepower',
        },
    ],
    [
        ProductFieldsEnum.soundLevel,
        {
            field: 'soundLevel',
        },
    ],
    [
        ProductFieldsEnum.nailgunAngle,
        {
            field: 'nailgunAngle',
        },
    ],
    [ProductFieldsEnum.minPSI, { field: 'minPSI' }],
    [
        ProductFieldsEnum.wheelDiameter,
        {
            field: 'wheelDiameter',
        },
    ],
    [
        ProductFieldsEnum.wheelDiameterUOM,
        {
            field: 'wheelDiameterUOM',
        },
    ],
    [ProductFieldsEnum.maxSpeed, { field: 'maxSpeed' }],
    [
        ProductFieldsEnum.grindingSpeed,
        {
            field: 'grindingSpeed',
        },
    ],
    [
        ProductFieldsEnum.blowsPerMinute,
        {
            field: 'blowsPerMinute',
        },
    ],
    [
        ProductFieldsEnum.sandingSpeed,
        {
            field: 'sandingSpeed',
        },
    ],
    [
        ProductFieldsEnum.hasAdjustableExhaustPort,
        {
            field: 'hasAdjustableExhaustPort',
        },
    ],
    [
        ProductFieldsEnum.hasAutoShutOff,
        {
            field: 'hasAutoShutOff',
        },
    ],
    [
        ProductFieldsEnum.hasAutoStart,
        {
            field: 'hasAutoStart',
        },
    ],
    [
        ProductFieldsEnum.hasDeflation,
        {
            field: 'hasDeflation',
        },
    ],
    [
        ProductFieldsEnum.hasDualControls,
        {
            field: 'hasDualControls',
        },
    ],
    [
        ProductFieldsEnum.hasFastenerDepthControl,
        {
            field: 'hasFastenerDepthControl',
        },
    ],
    [
        ProductFieldsEnum.hasHandle,
        {
            field: 'hasHandle',
        },
    ],
    [
        ProductFieldsEnum.hasOilFreeCompressor,
        {
            field: 'hasOilFreeCompressor',
        },
    ],
    [
        ProductFieldsEnum.hasTankPressureGauge,
        {
            field: 'hasTankPressureGauge',
        },
    ],
    [
        ProductFieldsEnum.hasWheels,
        {
            field: 'hasWheels',
        },
    ],
    [
        ProductFieldsEnum.hasUniversalQuickConnectors,
        {
            field: 'hasUniversalQuickConnectors',
        },
    ],
    [
        ProductFieldsEnum.compatibleTruckSize,
        {
            field: 'compatibleTruckSize',
        },
    ],
    [
        ProductFieldsEnum.beltMaterial,
        {
            field: 'beltMaterial',
        },
    ],
    [
        ProductFieldsEnum.pocketMaterial,
        {
            field: 'pocketMaterial',
        },
    ],
    [
        ProductFieldsEnum.hasToolboxWheels,
        {
            field: 'hasToolboxWheels',
        },
    ],
    [
        ProductFieldsEnum.isLockable,
        {
            field: 'isLockable',
        },
    ],
    [
        ProductFieldsEnum.numberOfInsidePockets,
        {
            field: 'numberOfInsidePockets',
        },
    ],
    [
        ProductFieldsEnum.numberOfOutsidePockets,
        {
            field: 'numberOfOutsidePockets',
        },
    ],
    [
        ProductFieldsEnum.numberOfPockets,
        {
            field: 'numberOfPockets',
        },
    ],
    [
        ProductFieldsEnum.numberOfCompartments,
        {
            field: 'numberOfCompartments',
        },
    ],
    [
        ProductFieldsEnum.numberOfShelves,
        {
            field: 'numberOfShelves',
        },
    ],
    [
        ProductFieldsEnum.numberOfTrays,
        {
            field: 'numberOfTrays',
        },
    ],
    [
        ProductFieldsEnum.frameSteelGauge,
        {
            field: 'frameSteelGauge',
        },
    ],
    [
        ProductFieldsEnum.numberOfDrawers,
        {
            field: 'numberOfDrawers',
        },
    ],
    [
        ProductFieldsEnum.hasCarabiner,
        {
            field: 'hasCarabiner',
        },
    ],
    [
        ProductFieldsEnum.hasDaisyChain,
        {
            field: 'hasDaisyChain',
        },
    ],
    [
        ProductFieldsEnum.hasToolboxHandle,
        {
            field: 'hasToolboxHandle',
        },
    ],
    [
        ProductFieldsEnum.hasPaddedBottom,
        {
            field: 'hasPaddedBottom',
        },
    ],
    [
        ProductFieldsEnum.hasRubberFeet,
        {
            field: 'hasRubberFeet',
        },
    ],
    [
        ProductFieldsEnum.hasRubberizedBottom,
        {
            field: 'hasRubberizedBottom',
        },
    ],
    [
        ProductFieldsEnum.hasShoulderStrap,
        {
            field: 'hasShoulderStrap',
        },
    ],
    [
        ProductFieldsEnum.hasTapeChain,
        {
            field: 'hasTapeChain',
        },
    ],
    [
        ProductFieldsEnum.hasHiVisTrim,
        {
            field: 'hasHiVisTrim',
        },
    ],
    [
        ProductFieldsEnum.hasFeaturesWheels,
        {
            field: 'hasFeaturesWheels',
        },
    ],
    [
        ProductFieldsEnum.hasAdjustableShelves,
        {
            field: 'hasAdjustableShelves',
        },
    ],
    [
        ProductFieldsEnum.hasBallBearingSlides,
        {
            field: 'hasBallBearingSlides',
        },
    ],
    [
        ProductFieldsEnum.hasDeepChest,
        {
            field: 'hasDeepChest',
        },
    ],
    [
        ProductFieldsEnum.hasGasLidStruts,
        {
            field: 'hasGasLidStruts',
        },
    ],
    [
        ProductFieldsEnum.isScratchResistant,
        {
            field: 'isScratchResistant',
        },
    ],
    [
        ProductFieldsEnum.hasSecureLid,
        {
            field: 'hasSecureLid',
        },
    ],
    [
        ProductFieldsEnum.hasSoftCloseDrawers,
        {
            field: 'hasSoftCloseDrawers',
        },
    ],
    [
        ProductFieldsEnum.isWallMountable,
        {
            field: 'isWallMountable',
        },
    ],
    [
        ProductFieldsEnum.hasWheelLocks,
        {
            field: 'hasWheelLocks',
        },
    ],
    [
        ProductFieldsEnum.hasWorktop,
        {
            field: 'hasWorktop',
        },
    ],
    [
        ProductFieldsEnum.supplierKey,
        {
            field: 'supplierKey',
        },
    ],
    [
        ProductFieldsEnum.isPending,
        {
            field: 'isPending',
        },
    ],
    [
        ProductFieldsEnum.isApproved,
        {
            field: 'isApproved',
        },
    ],
    [
        ProductFieldsEnum.parentProductID,
        {
            field: 'parentProductId',
        },
    ],
    [ProductFieldsEnum.addedBy, { field: 'addedBy' }],
    [
        ProductFieldsEnum.modifiedBy,
        {
            field: 'modifiedBy',
        },
    ],
    [
        ProductFieldsEnum.fittingB_Size,
        {
            field: 'fittingB.fittingSize',
            type: Type.Object,
        },
    ],
    [
        ProductFieldsEnum.fittingB_SizeUOM,
        {
            field: 'fittingB.fittingSizeUOM',
            type: Type.Object,
        },
    ],
    [
        ProductFieldsEnum.fittingB_Type,
        {
            field: 'fittingB.fittingType',
            type: Type.Object,
        },
    ],
    [
        ProductFieldsEnum.accountKey,
        {
            field: 'accountKey',
        },
    ],
    [
        ProductFieldsEnum.completionPercent,
        {
            field: 'completionPercent',
        },
    ],
    [
        ProductFieldsEnum.brandCode,
        {
            field: 'brandCode',
        },
    ],
    [
        ProductFieldsEnum.brandName,
        {
            field: 'brandName',
        },
    ],
    [
        ProductFieldsEnum.accessoryItem,
        {
            field: 'accessoryItem',
        },
    ],
    [
        ProductFieldsEnum.shortMarketingDescription,
        {
            field: 'shortMarketingDescription',
        },
    ],
    [
        ProductFieldsEnum.warrantyUom,
        {
            field: 'warrantyUOM',
        },
    ],
    [
        ProductFieldsEnum.consumerItemLength,
        {
            field: 'consumerItem.length',
            type: Type.Object,
            description: 'LENGTH',
        },
    ],
    [
        ProductFieldsEnum.consumerItemLengthUom,
        {
            field: 'consumerItem.lengthUOM',
            type: Type.Object,
            description: 'LENGTH_UOM',
        },
    ],
    [
        ProductFieldsEnum.consumerItemWidth,
        {
            field: 'consumerItem.width',
            type: Type.Object,
            description: 'WIDTH',
        },
    ],
    [
        ProductFieldsEnum.consumerItemWidthUom,
        {
            field: 'consumerItem.widthUOM',
            type: Type.Object,
            description: 'WIDTH_UOM',
        },
    ],
    [
        ProductFieldsEnum.consumerItemHeight,
        {
            field: 'consumerItem.height',
            type: Type.Object,
            description: 'HEIGHT',
        },
    ],
    [
        ProductFieldsEnum.consumerItemHeightUom,
        {
            field: 'consumerItem.heightUOM',
            type: Type.Object,
            description: 'HEIGHT_UOM',
        },
    ],
    [
        ProductFieldsEnum.consumerItemDepth,
        {
            field: 'consumerItem.depth',
            type: Type.Object,
            description: 'DEPTH',
        },
    ],
    [
        ProductFieldsEnum.consumerItemDepthUom,
        {
            field: 'consumerItem.depthUOM',
            type: Type.Object,
            description: 'DEPTH_UOM',
        },
    ],
    [
        ProductFieldsEnum.consumerItemNetWeight,
        {
            field: 'consumerItem.netWeight',
            type: Type.Object,
            description: 'NET_WEIGHT',
        },
    ],
    [
        ProductFieldsEnum.consumerItemNetWeightUom,
        {
            field: 'consumerItem.netWeightUOM',
            type: Type.Object,
            description: 'NET_WEIGHT_UOM',
        },
    ],
    [
        ProductFieldsEnum.consumerItemGrossWeight,
        {
            field: 'consumerItem.grossWeight',
            type: Type.Object,
            description: 'GROSS_WEIGHT',
        },
    ],
    [
        ProductFieldsEnum.consumerItemGrossWeightUom,
        {
            field: 'consumerItem.grossWeightUOM',
            type: Type.Object,
            description: 'GROSS_WEIGHT_UOM',
        },
    ],
    [
        ProductFieldsEnum.productGroup,
        {
            field: 'productGroup',
        },
    ],
    [
        ProductFieldsEnum.productFamily,
        {
            field: 'productFamily',
        },
    ],
    [
        ProductFieldsEnum.energyStarRating,
        {
            field: 'energyStarRating',
        },
    ],
    [
        ProductFieldsEnum.energyRating,
        {
            field: 'energyRating',
        },
    ],
    [
        ProductFieldsEnum.energyEfficiencyClass,
        {
            field: 'energyEfficiencyClass',
        },
    ],
    [
        ProductFieldsEnum.noiseLevel,
        {
            field: 'noiseLevel',
        },
    ],
    [
        ProductFieldsEnum.noiseLevelUom,
        {
            field: 'noiseLevelUOM',
        },
    ],
    [
        ProductFieldsEnum.fridgeCompartmentType,
        {
            field: 'fridgeCompartmentType',
        },
    ],
    [
        ProductFieldsEnum.frostFreeSystem,
        {
            field: 'frostFreeSystem',
        },
    ],
    [
        ProductFieldsEnum.fridgeType,
        {
            field: 'fridgeType',
        },
    ],
    [
        ProductFieldsEnum.fridgeFreezerArrangement,
        {
            field: 'fridgeFreezerArrangement',
        },
    ],
    [
        ProductFieldsEnum.euCatOfHhRefrigeratingModel,
        {
            field: 'euCatOfHhRefrigeratingModel',
        },
    ],
    [
        ProductFieldsEnum.coverDoorInstallationSystem,
        {
            field: 'coverDoorInstallationSystem',
        },
    ],
    [
        ProductFieldsEnum.fridgeWaterIceDispenser,
        {
            field: 'fridgeWaterIceDispenser',
        },
    ],
    [
        ProductFieldsEnum.splitType,
        {
            field: 'splitType',
        },
    ],
    [
        ProductFieldsEnum.numberOfFridgeFreezerCompartments,
        {
            field: 'numberOfFridgeFreezerCompartments',
        },
    ],
    [
        ProductFieldsEnum.numberOfDrawersBaskets,
        {
            field: 'numberOfDrawersBaskets',
        },
    ],
    [
        ProductFieldsEnum.numberOfFreezingFlaps,
        {
            field: 'numberOfFreezingFlaps',
        },
    ],
    [
        ProductFieldsEnum.numberOfCompressors,
        {
            field: 'numberOfCompressors',
        },
    ],
    [
        ProductFieldsEnum.numberOfIndependentCoolingSystems,
        {
            field: 'numberOfIndependentCoolingSystems',
        },
    ],
    [
        ProductFieldsEnum.numberOfTemperatureZones,
        {
            field: 'numberOfTemperatureZones',
        },
    ],
    [
        ProductFieldsEnum.fridgeNumberOfShelves,
        {
            field: 'fridgeNumberOfShelves',
        },
    ],
    [
        ProductFieldsEnum.fridgeNumberOfAdjustableShelves,
        {
            field: 'fridgeNumberOfAdjustableShelves',
        },
    ],
    [
        ProductFieldsEnum.fridgeShelfMaterial,
        {
            field: 'fridgeShelfMaterial',
        },
    ],
    [
        ProductFieldsEnum.fridgeNumberOfDrawers,
        {
            field: 'fridgeNumberOfDrawers',
        },
    ],
    [
        ProductFieldsEnum.freezerNumberOfShelves,
        {
            field: 'freezerNumberOfShelves',
        },
    ],
    [
        ProductFieldsEnum.freezerNumberOfAdjustableShelves,
        {
            field: 'freezerNumberOfAdjustableShelves',
        },
    ],
    [
        ProductFieldsEnum.freezerNumberOfDrawers,
        {
            field: 'freezerNumberOfDrawers',
        },
    ],
    [
        ProductFieldsEnum.freezerShelfMaterial,
        {
            field: 'freezerShelfMaterial',
        },
    ],
    [
        ProductFieldsEnum.bordeauxBottleCapacity,
        {
            field: 'bordeauxBottleCapacity',
        },
    ],
    [
        ProductFieldsEnum.humidifyingEquipment,
        {
            field: 'humidifyingEquipment',
        },
    ],
    [
        ProductFieldsEnum.thermometerFreezerSection,
        {
            field: 'thermometerFreezerSection',
        },
    ],
    [
        ProductFieldsEnum.thermometerFridgeSection,
        {
            field: 'thermometerFridgeSection',
        },
    ],
    [
        ProductFieldsEnum.defrostProcessFridge,
        {
            field: 'defrostProcessFridge',
        },
    ],
    [
        ProductFieldsEnum.defrostProcessFreezer,
        {
            field: 'defrostProcessFreezer',
        },
    ],
    [
        ProductFieldsEnum.isFrostFree,
        {
            field: 'isFrostFree',
        },
    ],
    [
        ProductFieldsEnum.hasMotorDrivenIceMaker,
        {
            field: 'hasMotorDrivenIceMaker',
        },
    ],
    [
        ProductFieldsEnum.hasSeparatedAirFlow,
        {
            field: 'hasSeparatedAirFlow',
        },
    ],
    [
        ProductFieldsEnum.hasWaterDispenser,
        {
            field: 'hasWaterDispenser',
        },
    ],
    [
        ProductFieldsEnum.hasIceDispenser,
        {
            field: 'hasIceDispenser',
        },
    ],
    [
        ProductFieldsEnum.hasWaterIceDispenser,
        {
            field: 'hasWaterIceDispenser',
        },
    ],
    [
        ProductFieldsEnum.hasWaterThawDrainageSystem,
        {
            field: 'hasWaterThawDrainageSystem',
        },
    ],
    [
        ProductFieldsEnum.hasOpenDoorAlert,
        {
            field: 'hasOpenDoorAlert',
        },
    ],
    [
        ProductFieldsEnum.hasFridgeOpenDoorAlert,
        {
            field: 'hasFridgeOpenDoorAlert',
        },
    ],
    [
        ProductFieldsEnum.hasFreezerOpenDoorAlert,
        {
            field: 'hasFreezerOpenDoorAlert',
        },
    ],
    [
        ProductFieldsEnum.hasFridgeFreezerIntegration,
        {
            field: 'hasFridgeFreezerIntegration',
        },
    ],
    [
        ProductFieldsEnum.hasFridgeAdjustableShelves,
        {
            field: 'hasFridgeAdjustableShelves',
        },
    ],
    [
        ProductFieldsEnum.hasFreezerAdjustableShelves,
        {
            field: 'hasFreezerAdjustableShelves',
        },
    ],
    [
        ProductFieldsEnum.hasReversibleDoor,
        {
            field: 'hasReversibleDoor',
        },
    ],
    [
        ProductFieldsEnum.hasTemperatureAdjustment,
        {
            field: 'hasTemperatureAdjustment',
        },
    ],
    [
        ProductFieldsEnum.hasFridgeTemperatureAdjustment,
        {
            field: 'hasFridgeTemperatureAdjustment',
        },
    ],
    [
        ProductFieldsEnum.hasFreezerTemperatureAdjustment,
        {
            field: 'hasFreezerTemperatureAdjustment',
        },
    ],
    [
        ProductFieldsEnum.hasPowerFailureSafeStorage,
        {
            field: 'hasPowerFailureSafeStorage',
        },
    ],
    [
        ProductFieldsEnum.hasWarningSignalMalfunction,
        {
            field: 'hasWarningSignalMalfunction',
        },
    ],
    [
        ProductFieldsEnum.hasInteriorVentilationFridge,
        {
            field: 'hasInteriorVentilationFridge',
        },
    ],
    [
        ProductFieldsEnum.hasFastFreezeFunction,
        {
            field: 'hasFastFreezeFunction',
        },
    ],
    [
        ProductFieldsEnum.hasFastCoolingFunction,
        {
            field: 'hasFastCoolingFunction',
        },
    ],
    [
        ProductFieldsEnum.hasFastFreezeCompartment,
        {
            field: 'hasFastFreezeCompartment',
        },
    ],
    [
        ProductFieldsEnum.hasFrozenFoodCompartment,
        {
            field: 'hasFrozenFoodCompartment',
        },
    ],
    [
        ProductFieldsEnum.hasIceCubeTray,
        {
            field: 'hasIceCubeTray',
        },
    ],
    [
        ProductFieldsEnum.hasBeverageCompartment,
        {
            field: 'hasBeverageCompartment',
        },
    ],
    [
        ProductFieldsEnum.hasCheeseCompartment,
        {
            field: 'hasCheeseCompartment',
        },
    ],
    [
        ProductFieldsEnum.hasEggTray,
        {
            field: 'hasEggTray',
        },
    ],
    [
        ProductFieldsEnum.hasVegetableCompartment,
        {
            field: 'hasVegetableCompartment',
        },
    ],
    [
        ProductFieldsEnum.hasSaladCrisper,
        {
            field: 'hasSaladCrisper',
        },
    ],
    [
        ProductFieldsEnum.hasFreshFoodsCompartment,
        {
            field: 'hasFreshFoodsCompartment',
        },
    ],
    [
        ProductFieldsEnum.hasShelfForBottles,
        {
            field: 'hasShelfForBottles',
        },
    ],
    [
        ProductFieldsEnum.fridgeGrossCapacity,
        {
            field: 'fridgeGrossCapacity',
        },
    ],
    [
        ProductFieldsEnum.fridgeGrossCapacityUOM,
        {
            field: 'fridgeGrossCapacityUOM',
        },
    ],
    [
        ProductFieldsEnum.freezerGrossCapacity,
        {
            field: 'freezerGrossCapacity',
        },
    ],
    [
        ProductFieldsEnum.freezerGrossCapacityUOM,
        {
            field: 'freezerGrossCapacityUOM',
        },
    ],
    [
        ProductFieldsEnum.fridgeNetCapacity,
        {
            field: 'fridgeNetCapacity',
        },
    ],
    [
        ProductFieldsEnum.fridgeNetCapacityUOM,
        {
            field: 'fridgeNetCapacityUOM',
        },
    ],
    [
        ProductFieldsEnum.freezerNetCapacity,
        {
            field: 'freezerNetCapacity',
        },
    ],
    [
        ProductFieldsEnum.freezerNetCapacityUOM,
        {
            field: 'freezerNetCapacityUOM',
        },
    ],
    [
        ProductFieldsEnum.temperatureRiseTime,
        {
            field: 'temperatureRiseTime',
        },
    ],
    [
        ProductFieldsEnum.temperatureRiseTimeUOM,
        {
            field: 'temperatureRiseTimeUOM',
        },
    ],
    [
        ProductFieldsEnum.designTemperature,
        {
            field: 'designTemperature',
        },
    ],
    [
        ProductFieldsEnum.designTemperatureUOM,
        {
            field: 'designTemperatureUOM',
        },
    ],
    [
        ProductFieldsEnum.minAmbientTemperature,
        {
            field: 'minAmbientTemperature',
        },
    ],
    [
        ProductFieldsEnum.minAmbientTemperatureUOM,
        {
            field: 'minAmbientTemperatureUOM',
        },
    ],
    [
        ProductFieldsEnum.maxAmbientTemperature,
        {
            field: 'maxAmbientTemperature',
        },
    ],
    [
        ProductFieldsEnum.maxAmbientTemperatureUOM,
        {
            field: 'maxAmbientTemperatureUOM',
        },
    ],
    [
        ProductFieldsEnum.depthWithDoorOpen,
        {
            field: 'depthWithDoorOpen',
        },
    ],
    [
        ProductFieldsEnum.depthWithDoorOpenUOM,
        {
            field: 'depthWithDoorOpenUOM',
        },
    ],
    [
        ProductFieldsEnum.typology,
        {
            field: 'typology',
        },
    ],
    [
        ProductFieldsEnum.fitType,
        {
            field: 'fitType',
        },
    ],
    [
        ProductFieldsEnum.mainColor,
        {
            field: 'mainColor',
        },
    ],
    [
        ProductFieldsEnum.secondaryColor,
        {
            field: 'secondaryColor',
        },
    ],
    [
        ProductFieldsEnum.appliancesControlPanel,
        {
            field: 'appliancesControlPanel',
        },
    ],
    [
        ProductFieldsEnum.controlPanelMaterial,
        {
            field: 'controlPanelMaterial',
        },
    ],
    [
        ProductFieldsEnum.typeOfControl,
        {
            field: 'typeOfControl',
        },
    ],
    [
        ProductFieldsEnum.typeOfControlSettings,
        {
            field: 'typeOfControlSettings',
        },
    ],
    [
        ProductFieldsEnum.constructionType,
        {
            field: 'constructionType',
        },
    ],
    [
        ProductFieldsEnum.constructionMaterial,
        {
            field: 'constructionMaterial',
        },
    ],
    [
        ProductFieldsEnum.installationType,
        {
            field: 'installationType',
        },
    ],
    [
        ProductFieldsEnum.cableStorage,
        {
            field: 'cableStorage',
        },
    ],
    [
        ProductFieldsEnum.climateClass,
        {
            field: 'climateClass',
        },
    ],
    [
        ProductFieldsEnum.safetyFeatures,
        {
            field: 'safetyFeatures',
        },
    ],
    [
        ProductFieldsEnum.cleaningFeatures,
        {
            field: 'cleaningFeatures',
        },
    ],
    [
        ProductFieldsEnum.energyInput,
        {
            field: 'energyInput',
        },
    ],
    [
        ProductFieldsEnum.typeOfLight,
        {
            field: 'typeOfLight',
        },
    ],
    [
        ProductFieldsEnum.lightControlType,
        {
            field: 'lightControlType',
        },
    ],
    [
        ProductFieldsEnum.positionOfInteriorLights,
        {
            field: 'positionOfInteriorLights',
        },
    ],
    [
        ProductFieldsEnum.portionSizes,
        {
            field: 'portionSizes',
        },
    ],
    [
        ProductFieldsEnum.coffeeSystem,
        {
            field: 'coffeeSystem',
        },
    ],
    [
        ProductFieldsEnum.waterProtectionSystemDescription,
        {
            field: 'waterProtectionSystemDescription',
        },
    ],
    [
        ProductFieldsEnum.waterGaugeType,
        {
            field: 'waterGaugeType',
        },
    ],
    [
        ProductFieldsEnum.additionalProgramOptions,
        {
            field: 'additionalProgramOptions',
        },
    ],
    [
        ProductFieldsEnum.doorColor,
        {
            field: 'doorColor',
        },
    ],
    [
        ProductFieldsEnum.doorMaterial,
        {
            field: 'doorMaterial',
        },
    ],
    [
        ProductFieldsEnum.doorDécorPanel,
        {
            field: 'doorDécorPanel',
        },
    ],
    [
        ProductFieldsEnum.doorHingeType,
        {
            field: 'doorHingeType',
        },
    ],
    [
        ProductFieldsEnum.doorOpeningType,
        {
            field: 'doorOpeningType',
        },
    ],
    [
        ProductFieldsEnum.adjustableFeet,
        {
            field: 'adjustableFeet',
        },
    ],
    [
        ProductFieldsEnum.filterType,
        {
            field: 'filterType',
        },
    ],
    [
        ProductFieldsEnum.cylinderType,
        {
            field: 'cylinderType',
        },
    ],
    [
        ProductFieldsEnum.powerSupply,
        {
            field: 'powerSupply',
        },
    ],
    [
        ProductFieldsEnum.applianceWattage,
        {
            field: 'applianceWattage',
        },
    ],
    [
        ProductFieldsEnum.applianceCurrent,
        {
            field: 'applianceCurrent',
        },
    ],
    [
        ProductFieldsEnum.applianceVoltage,
        {
            field: 'applianceVoltage',
        },
    ],
    [
        ProductFieldsEnum.applianceFrequency,
        {
            field: 'applianceFrequency',
        },
    ],
    [
        ProductFieldsEnum.approvalCertificates,
        {
            field: 'approvalCertificates',
        },
    ],
    [
        ProductFieldsEnum.languagesDisplayed,
        {
            field: 'languagesDisplayed',
        },
    ],
    [
        ProductFieldsEnum.includedApplianceAccessory,
        {
            field: 'includedApplianceAccessory',
        },
    ],
    [
        ProductFieldsEnum.optionalApplianceAccessory,
        {
            field: 'optionalApplianceAccessory',
        },
    ],
    [
        ProductFieldsEnum.listOfPrograms,
        {
            field: 'listOfPrograms',
        },
    ],
    [
        ProductFieldsEnum.plugType,
        {
            field: 'plugType',
        },
    ],
    [
        ProductFieldsEnum.toolsIncluded,
        {
            field: 'toolsIncluded',
        },
    ],
    [
        ProductFieldsEnum.numberOfPrograms,
        {
            field: 'numberOfPrograms',
        },
    ],
    [
        ProductFieldsEnum.numberOfBrowningLevels,
        {
            field: 'numberOfBrowningLevels',
        },
    ],
    [
        ProductFieldsEnum.numberOfPowerLevels,
        {
            field: 'numberOfPowerLevels',
        },
    ],
    [
        ProductFieldsEnum.numberOfAppliancesSpeeds,
        {
            field: 'numberOfAppliancesSpeeds',
        },
    ],
    [
        ProductFieldsEnum.numberOfSlots,
        {
            field: 'numberOfSlots',
        },
    ],
    [
        ProductFieldsEnum.numberOfAttachments,
        {
            field: 'numberOfAttachments',
        },
    ],
    [
        ProductFieldsEnum.numberOfPumps,
        {
            field: 'numberOfPumps',
        },
    ],
    [
        ProductFieldsEnum.numberOfHeatingElements,
        {
            field: 'numberOfHeatingElements',
        },
    ],
    [
        ProductFieldsEnum.numberOfIndicators,
        {
            field: 'numberOfIndicators',
        },
    ],
    [
        ProductFieldsEnum.numberOfMotors,
        {
            field: 'numberOfMotors',
        },
    ],
    [
        ProductFieldsEnum.numberOfLights,
        {
            field: 'numberOfLights',
        },
    ],
    [
        ProductFieldsEnum.maxNumberOfReferencePlates,
        {
            field: 'maxNumberOfReferencePlates',
        },
    ],
    [
        ProductFieldsEnum.maxNumberOfEspressoCups,
        {
            field: 'maxNumberOfEspressoCups',
        },
    ],
    [
        ProductFieldsEnum.hasPowerOnIndicator,
        {
            field: 'hasPowerOnIndicator',
        },
    ],
    [
        ProductFieldsEnum.hasRemoteControl,
        {
            field: 'hasRemoteControl',
        },
    ],
    [
        ProductFieldsEnum.applianceHasWheels,
        {
            field: 'applianceHasWheels',
        },
    ],
    [
        ProductFieldsEnum.hasColumnInstallation,
        {
            field: 'hasColumnInstallation',
        },
    ],
    [
        ProductFieldsEnum.hasElectronicIgnition,
        {
            field: 'hasElectronicIgnition',
        },
    ],
    [
        ProductFieldsEnum.hasSoftwareUpdate,
        {
            field: 'hasSoftwareUpdate',
        },
    ],
    [
        ProductFieldsEnum.hasSpeedControl,
        {
            field: 'hasSpeedControl',
        },
    ],
    [
        ProductFieldsEnum.isUpright,
        {
            field: 'isUpright',
        },
    ],
    [
        ProductFieldsEnum.isBagless,
        {
            field: 'isBagless',
        },
    ],
    [
        ProductFieldsEnum.hasWaterGauge,
        {
            field: 'hasWaterGauge',
        },
    ],
    [
        ProductFieldsEnum.hasWaterProtectionSystem,
        {
            field: 'hasWaterProtectionSystem',
        },
    ],
    [
        ProductFieldsEnum.canRapidBoil,
        {
            field: 'canRapidBoil',
        },
    ],
    [
        ProductFieldsEnum.hasLimescaleFilter,
        {
            field: 'hasLimescaleFilter',
        },
    ],
    [
        ProductFieldsEnum.hasTemperatureSelector,
        {
            field: 'hasTemperatureSelector',
        },
    ],
    [
        ProductFieldsEnum.isDishwasherSafe,
        {
            field: 'isDishwasherSafe',
        },
    ],
    [
        ProductFieldsEnum.hasFrothingNozzle,
        {
            field: 'hasFrothingNozzle',
        },
    ],
    [
        ProductFieldsEnum.hasHotWaterSpout,
        {
            field: 'hasHotWaterSpout',
        },
    ],
    [
        ProductFieldsEnum.hasCoffeeGroundsContainer,
        {
            field: 'hasCoffeeGroundsContainer',
        },
    ],
    [
        ProductFieldsEnum.hasRemovableBrewUnit,
        {
            field: 'hasRemovableBrewUnit',
        },
    ],
    [
        ProductFieldsEnum.hasPreBrewSystem,
        {
            field: 'hasPreBrewSystem',
        },
    ],
    [
        ProductFieldsEnum.hasPreGrindSystem,
        {
            field: 'hasPreGrindSystem',
        },
    ],
    [
        ProductFieldsEnum.hasPrepare2Cups,
        {
            field: 'hasPrepare2Cups',
        },
    ],
    [
        ProductFieldsEnum.hasStandbyFunction,
        {
            field: 'hasStandbyFunction',
        },
    ],
    [
        ProductFieldsEnum.hasInteriorLight,
        {
            field: 'hasInteriorLight',
        },
    ],
    [
        ProductFieldsEnum.hasClock,
        {
            field: 'hasClock',
        },
    ],
    [
        ProductFieldsEnum.hasElectricTimer,
        {
            field: 'hasElectricTimer',
        },
    ],
    [
        ProductFieldsEnum.hasDelayTimer,
        {
            field: 'hasDelayTimer',
        },
    ],
    [
        ProductFieldsEnum.hasDoor,
        {
            field: 'hasDoor',
        },
    ],
    [
        ProductFieldsEnum.hasDoorHinge,
        {
            field: 'hasDoorHinge',
        },
    ],
    [
        ProductFieldsEnum.hasWideDoorOpening,
        {
            field: 'hasWideDoorOpening',
        },
    ],
    [
        ProductFieldsEnum.hasLockableDoor,
        {
            field: 'hasLockableDoor',
        },
    ],
    [
        ProductFieldsEnum.hasCrushIce,
        {
            field: 'hasCrushIce',
        },
    ],
    [
        ProductFieldsEnum.hasSteamShot,
        {
            field: 'hasSteamShot',
        },
    ],
    [
        ProductFieldsEnum.hasSteamControl,
        {
            field: 'hasSteamControl',
        },
    ],
    [
        ProductFieldsEnum.hasResidualHeatIndicator,
        {
            field: 'hasResidualHeatIndicator',
        },
    ],
    [
        ProductFieldsEnum.hasRemovableWorkTop,
        {
            field: 'hasRemovableWorkTop',
        },
    ],
    [
        ProductFieldsEnum.isIntegrated,
        {
            field: 'isIntegrated',
        },
    ],
    [
        ProductFieldsEnum.grossCapacity,
        {
            field: 'grossCapacity',
        },
    ],
    [
        ProductFieldsEnum.grossCapacityUOM,
        {
            field: 'grossCapacityUOM',
        },
    ],
    [
        ProductFieldsEnum.netCapacity,
        {
            field: 'netCapacity',
        },
    ],
    [
        ProductFieldsEnum.netCapacityUOM,
        {
            field: 'netCapacityUOM',
        },
    ],
    [
        ProductFieldsEnum.jugCapacity,
        {
            field: 'jugCapacity',
        },
    ],
    [
        ProductFieldsEnum.jugCapacityUOM,
        {
            field: 'jugCapacityUOM',
        },
    ],
    [
        ProductFieldsEnum.liquidCapacity,
        {
            field: 'liquidCapacity',
        },
    ],
    [
        ProductFieldsEnum.liquidCapacityUOM,
        {
            field: 'liquidCapacityUOM',
        },
    ],
    [
        ProductFieldsEnum.dustCapacity,
        {
            field: 'dustCapacity',
        },
    ],
    [
        ProductFieldsEnum.dustCapacityUOM,
        {
            field: 'dustCapacityUOM',
        },
    ],
    [
        ProductFieldsEnum.waterContainerCapacity,
        {
            field: 'waterContainerCapacity',
        },
    ],
    [
        ProductFieldsEnum.waterContainerCapacityUOM,
        {
            field: 'waterContainerCapacityUOM',
        },
    ],
    [
        ProductFieldsEnum.beanContainerCapacity,
        {
            field: 'beanContainerCapacity',
        },
    ],
    [
        ProductFieldsEnum.beanContainerCapacityUOM,
        {
            field: 'beanContainerCapacityUOM',
        },
    ],
    [
        ProductFieldsEnum.bottleCapacity,
        {
            field: 'bottleCapacity',
        },
    ],
    [
        ProductFieldsEnum.bottleCapacityUOM,
        {
            field: 'bottleCapacityUOM',
        },
    ],
    [
        ProductFieldsEnum.bowlCapacity,
        {
            field: 'bowlCapacity',
        },
    ],
    [
        ProductFieldsEnum.bowlCapacityUOM,
        {
            field: 'bowlCapacityUOM',
        },
    ],
    [
        ProductFieldsEnum.useableCavityVolume,
        {
            field: 'useableCavityVolume',
        },
    ],
    [
        ProductFieldsEnum.useableCavityVolumeUOM,
        {
            field: 'useableCavityVolumeUOM',
        },
    ],
    [
        ProductFieldsEnum.depthWithDoor90Degrees,
        {
            field: 'depthWithDoor90Degrees',
        },
    ],
    [
        ProductFieldsEnum.depthWithDoor90DegreesUOM,
        {
            field: 'depthWithDoor90DegreesUOM',
        },
    ],
    [
        ProductFieldsEnum.removableWorkTopHeight,
        {
            field: 'removableWorkTopHeight',
        },
    ],
    [
        ProductFieldsEnum.removableWorkTopHeightUOM,
        {
            field: 'removableWorkTopHeightUOM',
        },
    ],
    [
        ProductFieldsEnum.cableLength,
        {
            field: 'cableLength',
        },
    ],
    [
        ProductFieldsEnum.cableLengthUOM,
        {
            field: 'cableLengthUOM',
        },
    ],
    [
        ProductFieldsEnum.cordLength,
        {
            field: 'cordLength',
        },
    ],
    [
        ProductFieldsEnum.cordLengthUOM,
        {
            field: 'cordLengthUOM',
        },
    ],
    [
        ProductFieldsEnum.referencePlateDiameter,
        {
            field: 'referencePlateDiameter',
        },
    ],
    [
        ProductFieldsEnum.referencePlateDiameterUOM,
        {
            field: 'referencePlateDiameterUOM',
        },
    ],
    [
        ProductFieldsEnum.deviceReach,
        {
            field: 'deviceReach',
        },
    ],
    [
        ProductFieldsEnum.deviceReachUOM,
        {
            field: 'deviceReachUOM',
        },
    ],
    [
        ProductFieldsEnum.minNicheHeight,
        {
            field: 'minNicheHeight',
        },
    ],
    [
        ProductFieldsEnum.minNicheHeightUOM,
        {
            field: 'minNicheHeightUOM',
        },
    ],
    [
        ProductFieldsEnum.maxNicheHeight,
        {
            field: 'maxNicheHeight',
        },
    ],
    [
        ProductFieldsEnum.maxNicheHeightUOM,
        {
            field: 'maxNicheHeightUOM',
        },
    ],
    [
        ProductFieldsEnum.minNicheWidth,
        {
            field: 'minNicheWidth',
        },
    ],
    [
        ProductFieldsEnum.minNicheWidthUOM,
        {
            field: 'minNicheWidthUOM',
        },
    ],
    [
        ProductFieldsEnum.maxNicheWidth,
        {
            field: 'maxNicheWidth',
        },
    ],
    [
        ProductFieldsEnum.maxNicheWidthUOM,
        {
            field: 'maxNicheWidthUOM',
        },
    ],
    [
        ProductFieldsEnum.nicheDepth,
        {
            field: 'nicheDepth',
        },
    ],
    [
        ProductFieldsEnum.nicheDepthUOM,
        {
            field: 'nicheDepthUOM',
        },
    ],
    [
        ProductFieldsEnum.adjustableBaseMeasurement,
        {
            field: 'adjustableBaseMeasurement',
        },
    ],
    [
        ProductFieldsEnum.adjustableBaseMeasurementUOM,
        {
            field: 'adjustableBaseMeasurementUOM',
        },
    ],
    [
        ProductFieldsEnum.adjustableFeetMeasurement,
        {
            field: 'adjustableFeetMeasurement',
        },
    ],
    [
        ProductFieldsEnum.adjustableFeetMeasurementUOM,
        {
            field: 'adjustableFeetMeasurementUOM',
        },
    ],
    [
        ProductFieldsEnum.leftOnDuration,
        {
            field: 'leftOnDuration',
        },
    ],
    [
        ProductFieldsEnum.leftOnDurationUOM,
        {
            field: 'leftOnDurationUOM',
        },
    ],
    [
        ProductFieldsEnum.startDelayTimeMax,
        {
            field: 'startDelayTimeMax',
        },
    ],
    [
        ProductFieldsEnum.startDelayTimeMaxUOM,
        {
            field: 'startDelayTimeMaxUOM',
        },
    ],
    [
        ProductFieldsEnum.stopDelayTimeMax,
        {
            field: 'stopDelayTimeMax',
        },
    ],
    [
        ProductFieldsEnum.stopDelayTimeMaxUOM,
        {
            field: 'stopDelayTimeMaxUOM',
        },
    ],
    [
        ProductFieldsEnum.hobType,
        {
            field: 'hobType',
        },
    ],
    [
        ProductFieldsEnum.energyType,
        {
            field: 'energyType',
        },
    ],
    [
        ProductFieldsEnum.cookerOvenType,
        {
            field: 'cookerOvenType',
        },
    ],
    [
        ProductFieldsEnum.microwaveOvenType,
        {
            field: 'microwaveOvenType',
        },
    ],
    [
        ProductFieldsEnum.cookerOvenControlPanel,
        {
            field: 'cookerOvenControlPanel',
        },
    ],
    [
        ProductFieldsEnum.cookerOvenControlPanelLocation,
        {
            field: 'cookerOvenControlPanelLocation',
        },
    ],
    [
        ProductFieldsEnum.cookerOvenTimerControl,
        {
            field: 'cookerOvenTimerControl',
        },
    ],
    [
        ProductFieldsEnum.cookerOvenTimeOptions,
        {
            field: 'cookerOvenTimeOptions',
        },
    ],
    [
        ProductFieldsEnum.manualControlDevices,
        {
            field: 'manualControlDevices',
        },
    ],
    [
        ProductFieldsEnum.automaticControlDevices,
        {
            field: 'automaticControlDevices',
        },
    ],
    [
        ProductFieldsEnum.steamGeneratorLocation,
        {
            field: 'steamGeneratorLocation',
        },
    ],
    [
        ProductFieldsEnum.operatingMode,
        {
            field: 'operatingMode',
        },
    ],
    [
        ProductFieldsEnum.typeOfAutoCooking,
        {
            field: 'typeOfAutoCooking',
        },
    ],
    [
        ProductFieldsEnum.chimneyMaterial,
        {
            field: 'chimneyMaterial',
        },
    ],
    [
        ProductFieldsEnum.chimneyColor,
        {
            field: 'chimneyColor',
        },
    ],
    [
        ProductFieldsEnum.microwaveCavityMaterial,
        {
            field: 'microwaveCavityMaterial',
        },
    ],
    [
        ProductFieldsEnum.motorLocation,
        {
            field: 'motorLocation',
        },
    ],
    [
        ProductFieldsEnum.surfaceMaterial,
        {
            field: 'surfaceMaterial',
        },
    ],
    [
        ProductFieldsEnum.typeOfFrame,
        {
            field: 'typeOfFrame',
        },
    ],
    [
        ProductFieldsEnum.colorOfFrame,
        {
            field: 'colorOfFrame',
        },
    ],
    [
        ProductFieldsEnum.grillType,
        {
            field: 'grillType',
        },
    ],
    [
        ProductFieldsEnum.grillFuel,
        {
            field: 'grillFuel',
        },
    ],
    [
        ProductFieldsEnum.grillBasinMaterial,
        {
            field: 'grillBasinMaterial',
        },
    ],
    [
        ProductFieldsEnum.grillGratingMaterial,
        {
            field: 'grillGratingMaterial',
        },
    ],
    [
        ProductFieldsEnum.fuelType,
        {
            field: 'fuelType',
        },
    ],
    [
        ProductFieldsEnum.alternativeFuelType,
        {
            field: 'alternativeFuelType',
        },
    ],
    [
        ProductFieldsEnum.gasConnectionLocation,
        {
            field: 'gasConnectionLocation',
        },
    ],
    [
        ProductFieldsEnum.gasAverageEfficiency,
        {
            field: 'gasAverageEfficiency',
        },
    ],
    [
        ProductFieldsEnum.gasHobEfficiency,
        {
            field: 'gasHobEfficiency',
        },
    ],
    [
        ProductFieldsEnum.fluidDynamicEfficiency,
        {
            field: 'fluidDynamicEfficiency',
        },
    ],
    [
        ProductFieldsEnum.fluidDynamicEfficiencyClass,
        {
            field: 'fluidDynamicEfficiencyClass',
        },
    ],
    [
        ProductFieldsEnum.lightingEfficiency,
        {
            field: 'lightingEfficiency',
        },
    ],
    [
        ProductFieldsEnum.lightingEfficiencyClass,
        {
            field: 'lightingEfficiencyClass',
        },
    ],
    [
        ProductFieldsEnum.greaseFilteringEfficiency,
        {
            field: 'greaseFilteringEfficiency',
        },
    ],
    [
        ProductFieldsEnum.greaseFilteringEfficiencyClass,
        {
            field: 'greaseFilteringEfficiencyClass',
        },
    ],
    [
        ProductFieldsEnum.maxAirFlow,
        {
            field: 'maxAirFlow',
        },
    ],
    [
        ProductFieldsEnum.minAirFlow,
        {
            field: 'minAirFlow',
        },
    ],
    [
        ProductFieldsEnum.airFlowBoost,
        {
            field: 'airFlowBoost',
        },
    ],
    [
        ProductFieldsEnum.soundPowerMaxSpeed,
        {
            field: 'soundPowerMaxSpeed',
        },
    ],
    [
        ProductFieldsEnum.soundPowerMinSpeed,
        {
            field: 'soundPowerMinSpeed',
        },
    ],
    [
        ProductFieldsEnum.soundPowerBoost,
        {
            field: 'soundPowerBoost',
        },
    ],
    [
        ProductFieldsEnum.noiseLevelBoostPosition,
        {
            field: 'noiseLevelBoostPosition',
        },
    ],
    [
        ProductFieldsEnum.adjustableTemperatureRange,
        {
            field: 'adjustableTemperatureRange',
        },
    ],
    [
        ProductFieldsEnum.maxOutputAirExtraction,
        {
            field: 'maxOutputAirExtraction',
        },
    ],
    [
        ProductFieldsEnum.boostPositionAirExtraction,
        {
            field: 'boostPositionAirExtraction',
        },
    ],
    [
        ProductFieldsEnum.maxOutputRecirculatingAir,
        {
            field: 'maxOutputRecirculatingAir',
        },
    ],
    [
        ProductFieldsEnum.boostPositionOutputRecirculating,
        {
            field: 'boostPositionOutputRecirculating',
        },
    ],
    [
        ProductFieldsEnum.typeOfRegulation,
        {
            field: 'typeOfRegulation',
        },
    ],
    [
        ProductFieldsEnum.typeOfLid,
        {
            field: 'typeOfLid',
        },
    ],
    [
        ProductFieldsEnum.typeOfPanSupport,
        {
            field: 'typeOfPanSupport',
        },
    ],
    [
        ProductFieldsEnum.typeOfSafetyForGas,
        {
            field: 'typeOfSafetyForGas',
        },
    ],
    [
        ProductFieldsEnum.residualHeatIndicatorType,
        {
            field: 'residualHeatIndicatorType',
        },
    ],
    [
        ProductFieldsEnum.gasBurnerEfficiency,
        {
            field: 'gasBurnerEfficiencies',
            type: Type.Array,
            arrayObjectField: 'efficiency',
        },
    ],
    [
        ProductFieldsEnum.heatingElementType,
        {
            field: 'cookerHeatingElements',
            type: Type.Array,
            arrayObjectField: 'type',
        },
    ],
    [
        ProductFieldsEnum.heatingElementPower,
        {
            field: 'cookerHeatingElements',
            type: Type.Array,
            arrayObjectField: 'power',
        },
    ],
    [
        ProductFieldsEnum.heatingElementLocation,
        {
            field: 'cookerHeatingElements',
            type: Type.Array,
            arrayObjectField: 'location',
        },
    ],
    [
        ProductFieldsEnum.typeOfHeatingElement,
        {
            field: 'typeOfHeatingElement',
        },
    ],
    [
        ProductFieldsEnum.greaseFilterMaterial,
        {
            field: 'greaseFilterMaterial',
        },
    ],
    [
        ProductFieldsEnum.greaseFilterType,
        {
            field: 'greaseFilterType',
        },
    ],
    [
        ProductFieldsEnum.cookerOvenGuides,
        {
            field: 'cookerOvenGuides',
        },
    ],
    [
        ProductFieldsEnum.integratedCleaningSystem,
        {
            field: 'integratedCleaningSystem',
        },
    ],
    [
        ProductFieldsEnum.grillPower,
        {
            field: 'grillPower',
        },
    ],
    [
        ProductFieldsEnum.maxMicrowavePower,
        {
            field: 'maxMicrowavePower',
        },
    ],
    [
        ProductFieldsEnum.burnerPowerRange,
        {
            field: 'burnerPowerRange',
        },
    ],
    [
        ProductFieldsEnum.totalPowerOfMotors,
        {
            field: 'totalPowerOfMotors',
        },
    ],
    [
        ProductFieldsEnum.cookerCompartmentType,
        {
            field: 'cookerOvenCompartments',
            type: Type.Array,
            arrayObjectField: 'type',
        },
    ],
    [
        ProductFieldsEnum.cookerCompartmentCookingMethod,
        {
            field: 'cookerOvenCompartments',
            type: Type.Array,
            arrayObjectField: 'cookingMethod',
        },
    ],
    [
        ProductFieldsEnum.cookerCompartmentGrillType,
        {
            field: 'cookerOvenCompartments',
            type: Type.Array,
            arrayObjectField: 'grillType',
        },
    ],
    [
        ProductFieldsEnum.cookerCompartmentFuelType,
        {
            field: 'cookerOvenCompartments',
            type: Type.Array,
            arrayObjectField: 'fuelType',
        },
    ],
    [
        ProductFieldsEnum.cookerCompartmentEnergyEffClass,
        {
            field: 'cookerOvenCompartments',
            type: Type.Array,
            arrayObjectField: 'energyEffClass',
        },
    ],
    [
        ProductFieldsEnum.cookerCompartmentEnergyEffIndex,
        {
            field: 'cookerOvenCompartments',
            type: Type.Array,
            arrayObjectField: 'energyEffIndex',
        },
    ],
    [
        ProductFieldsEnum.cookerCompartmentCleaningSystem,
        {
            field: 'cookerOvenCompartments',
            type: Type.Array,
            arrayObjectField: 'cleaningSystem',
        },
    ],
    [
        ProductFieldsEnum.cookerCompartmentNumberOfShelves,
        {
            field: 'cookerOvenCompartments',
            type: Type.Array,
            arrayObjectField: 'noOfShelves',
        },
    ],
    [
        ProductFieldsEnum.cookerCompartmentNumberOfGrids,
        {
            field: 'cookerOvenCompartments',
            type: Type.Array,
            arrayObjectField: 'noOfGrids',
        },
    ],
    [
        ProductFieldsEnum.cookerCompartmentDoorMaterial,
        {
            field: 'cookerOvenCompartments',
            type: Type.Array,
            arrayObjectField: 'doorMaterial',
        },
    ],
    [
        ProductFieldsEnum.cookingMethods,
        {
            field: 'cookingMethods',
        },
    ],
    [
        ProductFieldsEnum.numberOfCookingCompartments,
        {
            field: 'numberOfCookingCompartments',
        },
    ],
    [
        ProductFieldsEnum.numberOfBurners,
        {
            field: 'numberOfBurners',
        },
    ],
    [
        ProductFieldsEnum.numberOfGasBurners,
        {
            field: 'numberOfGasBurners',
        },
    ],
    [
        ProductFieldsEnum.numberOfBurnersUsedSimultaneously,
        {
            field: 'numberOfBurnersUsedSimultaneously',
        },
    ],
    [
        ProductFieldsEnum.numberOfElectricCookingZones,
        {
            field: 'numberOfElectricCookingZones',
        },
    ],
    [
        ProductFieldsEnum.numberOfElectricPlates,
        {
            field: 'numberOfElectricPlates',
        },
    ],
    [
        ProductFieldsEnum.numberOfRadiantPlates,
        {
            field: 'numberOfRadiantPlates',
        },
    ],
    [
        ProductFieldsEnum.numberOfHalogenPlates,
        {
            field: 'numberOfHalogenPlates',
        },
    ],
    [
        ProductFieldsEnum.numberOfInductionPlates,
        {
            field: 'numberOfInductionPlates',
        },
    ],
    [
        ProductFieldsEnum.numberOfElectricWarmingZones,
        {
            field: 'numberOfElectricWarmingZones',
        },
    ],
    [
        ProductFieldsEnum.numberOfCookerOvenTrays,
        {
            field: 'numberOfCookerOvenTrays',
        },
    ],
    [
        ProductFieldsEnum.numberOfCookingPrograms,
        {
            field: 'numberOfCookingPrograms',
        },
    ],
    [
        ProductFieldsEnum.numberOfHoodSpeeds,
        {
            field: 'numberOfHoodSpeeds',
        },
    ],
    [
        ProductFieldsEnum.ignitionSystem,
        {
            field: 'ignitionSystem',
        },
    ],
    [
        ProductFieldsEnum.mainOnoffSwitch,
        {
            field: 'mainOnoffSwitch',
        },
    ],
    [
        ProductFieldsEnum.cookerOverAutomaticPrograms,
        {
            field: 'cookerOverAutomaticPrograms',
        },
    ],
    [
        ProductFieldsEnum.combineCookingZones,
        {
            field: 'combineCookingZones',
        },
    ],
    [
        ProductFieldsEnum.noReturnAirFlowFlap,
        {
            field: 'noReturnAirFlowFlap',
        },
    ],
    [
        ProductFieldsEnum.odorFilter,
        {
            field: 'odorFilter',
        },
    ],
    [
        ProductFieldsEnum.turntable,
        {
            field: 'turntable',
        },
    ],
    [
        ProductFieldsEnum.drainValve,
        {
            field: 'drainValve',
        },
    ],
    [
        ProductFieldsEnum.hasCookerCompartmentMotorizedSpit,
        {
            field: 'cookerOvenCompartmentFeatures',
            type: Type.Array,
            arrayObjectField: 'hasMotorizedSpit',
        },
    ],
    [
        ProductFieldsEnum.hasCookerCompartmentProbe,
        {
            field: 'cookerOvenCompartmentFeatures',
            type: Type.Array,
            arrayObjectField: 'hasProbe',
        },
    ],
    [
        ProductFieldsEnum.hasCookerCompartmentTimer,
        {
            field: 'cookerOvenCompartmentFeatures',
            type: Type.Array,
            arrayObjectField: 'hasTimer',
        },
    ],
    [
        ProductFieldsEnum.hasCookerCompartmentInteriorLight,
        {
            field: 'cookerOvenCompartmentFeatures',
            type: Type.Array,
            arrayObjectField: 'hasInteriorLight',
        },
    ],
    [
        ProductFieldsEnum.hasGasConnection,
        {
            field: 'hasGasConnection',
        },
    ],
    [
        ProductFieldsEnum.hasGrillCookingMethod,
        {
            field: 'hasGrillCookingMethod',
        },
    ],
    [
        ProductFieldsEnum.hasFanCookingMethod,
        {
            field: 'hasFanCookingMethod',
        },
    ],
    [
        ProductFieldsEnum.hasConventionalCookingMethod,
        {
            field: 'hasConventionalCookingMethod',
        },
    ],
    [
        ProductFieldsEnum.hasWokBurner,
        {
            field: 'hasWokBurner',
        },
    ],
    [
        ProductFieldsEnum.hasGriddle,
        {
            field: 'hasGriddle',
        },
    ],
    [
        ProductFieldsEnum.hasIntegratedControls,
        {
            field: 'hasIntegratedControls',
        },
    ],
    [
        ProductFieldsEnum.microwaveCavityHeight,
        {
            field: 'microwaveCavityHeight',
        },
    ],
    [
        ProductFieldsEnum.microwaveCavityHeightUOM,
        {
            field: 'microwaveCavityHeightUOM',
        },
    ],
    [
        ProductFieldsEnum.microwaveCavityWidth,
        {
            field: 'microwaveCavityWidth',
        },
    ],
    [
        ProductFieldsEnum.microwaveCavityWidthUOM,
        {
            field: 'microwaveCavityWidthUOM',
        },
    ],
    [
        ProductFieldsEnum.microwaveCavityDepth,
        {
            field: 'microwaveCavityDepth',
        },
    ],
    [
        ProductFieldsEnum.microwaveCavityDepthUOM,
        {
            field: 'microwaveCavityDepthUOM',
        },
    ],
    [
        ProductFieldsEnum.turntableDiameter,
        {
            field: 'turntableDiameter',
        },
    ],
    [
        ProductFieldsEnum.turntableDiameterUOM,
        {
            field: 'turntableDiameterUOM',
        },
    ],
    [
        ProductFieldsEnum.heightWithoutChimney,
        {
            field: 'heightWithoutChimney',
        },
    ],
    [
        ProductFieldsEnum.heightWithoutChimneyUOM,
        {
            field: 'heightWithoutChimneyUOM',
        },
    ],
    [
        ProductFieldsEnum.diameterOfAirOutlet,
        {
            field: 'diameterOfAirOutlet',
        },
    ],
    [
        ProductFieldsEnum.diameterOfAirOutletUOM,
        {
            field: 'diameterOfAirOutletUOM',
        },
    ],
    [
        ProductFieldsEnum.cookingCavityHeight,
        {
            field: 'cookingCavityHeight',
        },
    ],
    [
        ProductFieldsEnum.cookingCavityHeightUOM,
        {
            field: 'cookingCavityHeightUOM',
        },
    ],
    [
        ProductFieldsEnum.cookingCavityWidth,
        {
            field: 'cookingCavityWidth',
        },
    ],
    [
        ProductFieldsEnum.cookingCavityWidthUOM,
        {
            field: 'cookingCavityWidthUOM',
        },
    ],
    [
        ProductFieldsEnum.cookingCavityDepth,
        {
            field: 'cookingCavityDepth',
        },
    ],
    [
        ProductFieldsEnum.cookingCavityDepthUOM,
        {
            field: 'cookingCavityDepthUOM',
        },
    ],
    [
        ProductFieldsEnum.heatingElementDimension,
        {
            field: 'cookerOvenHeatingElementDimensions',
            type: Type.Array,
            arrayObjectField: 'dimension',
        },
    ],
    [
        ProductFieldsEnum.heatingElementDimensionUOM,
        {
            field: 'cookerOvenHeatingElementDimensions',
            type: Type.Array,
            arrayObjectField: 'dimensionUOM',
        },
    ],
    [
        ProductFieldsEnum.microwaveCavityCapacity,
        {
            field: 'microwaveCavityCapacity',
        },
    ],
    [
        ProductFieldsEnum.microwaveCavityCapacityUOM,
        {
            field: 'microwaveCavityCapacityUOM',
        },
    ],
    [
        ProductFieldsEnum.waterTankVolume,
        {
            field: 'waterTankVolume',
        },
    ],
    [
        ProductFieldsEnum.waterTankVolumeUOM,
        {
            field: 'waterTankVolumeUOM',
        },
    ],
    [
        ProductFieldsEnum.cookingUsableVolume,
        {
            field: 'cookingUsableVolume',
        },
    ],
    [
        ProductFieldsEnum.cookingUsableVolumeUOM,
        {
            field: 'cookingUsableVolumeUOM',
        },
    ],
    [
        ProductFieldsEnum.cookerCompartmentCapacity,
        {
            field: 'cookerOvenCompartmentCapacities',
            type: Type.Array,
            arrayObjectField: 'capacity',
        },
    ],
    [
        ProductFieldsEnum.cookerCompartmentCapacityUOM,
        {
            field: 'cookerOvenCompartmentCapacities',
            type: Type.Array,
            arrayObjectField: 'capacityUOM',
        },
    ],
    [
        ProductFieldsEnum.numberOfPlaceSettings,
        {
            field: 'numberOfPlaceSettings',
        },
    ],
    [
        ProductFieldsEnum.dishwasherNumberOfWashTemperatures,
        {
            field: 'dishwasherNumberOfWashTemperatures',
        },
    ],
    [
        ProductFieldsEnum.dishwasherNumberOfPrograms,
        {
            field: 'dishwasherNumberOfPrograms',
        },
    ],
    [
        ProductFieldsEnum.dishwasherControlPanel,
        {
            field: 'dishwasherControlPanel',
        },
    ],
    [
        ProductFieldsEnum.dishwasherTypeOfControl,
        {
            field: 'dishwasherTypeOfControl',
        },
    ],
    [
        ProductFieldsEnum.dishwasherTubMaterial,
        {
            field: 'dishwasherTubMaterial',
        },
    ],
    [
        ProductFieldsEnum.adjustableBase,
        {
            field: 'adjustableBase',
        },
    ],
    [
        ProductFieldsEnum.dishwasherRefProgram,
        {
            field: 'dishwasherRefProgram',
        },
    ],
    [
        ProductFieldsEnum.dishwasherCleaningPerformance,
        {
            field: 'dishwasherCleaningPerformance',
        },
    ],
    [
        ProductFieldsEnum.dishwasherDryingPerformance,
        {
            field: 'dishwasherDryingPerformance',
        },
    ],
    [
        ProductFieldsEnum.dishwasherDryingSystem,
        {
            field: 'dishwasherDryingSystem',
        },
    ],
    [
        ProductFieldsEnum.dishwasherStartDelayOption,
        {
            field: 'dishwasherStartDelayOption',
        },
    ],
    [
        ProductFieldsEnum.singleBasketWashing,
        {
            field: 'singleBasketWashing',
        },
    ],
    [
        ProductFieldsEnum.adjustableUpperBasket,
        {
            field: 'adjustableUpperBasket',
        },
    ],
    [
        ProductFieldsEnum.basketWithHandle,
        {
            field: 'basketWithHandle',
        },
    ],
    [
        ProductFieldsEnum.cutleryCase,
        {
            field: 'cutleryCase',
        },
    ],
    [
        ProductFieldsEnum.hasAutomaticPrograms,
        {
            field: 'hasAutomaticPrograms',
        },
    ],
    [
        ProductFieldsEnum.hasDelicateProgram,
        {
            field: 'hasDelicateProgram',
        },
    ],
    [
        ProductFieldsEnum.hasHalfLoadOption,
        {
            field: 'hasHalfLoadOption',
        },
    ],
    [
        ProductFieldsEnum.hasDishwasherQuickWash,
        {
            field: 'hasDishwasherQuickWash',
        },
    ],
    [
        ProductFieldsEnum.hasCycleIndicator,
        {
            field: 'hasCycleIndicator',
        },
    ],
    [
        ProductFieldsEnum.hasEndOfCycleAlert,
        {
            field: 'hasEndOfCycleAlert',
        },
    ],
    [
        ProductFieldsEnum.hasDigitalCountdown,
        {
            field: 'hasDigitalCountdown',
        },
    ],
    [
        ProductFieldsEnum.hiddenHeatElement,
        {
            field: 'hiddenHeatElement',
        },
    ],
    [
        ProductFieldsEnum.saltLightIndicator,
        {
            field: 'saltLightIndicator',
        },
    ],
    [
        ProductFieldsEnum.rinseLightIndicator,
        {
            field: 'rinseLightIndicator',
        },
    ],
    [
        ProductFieldsEnum.waterSoftener,
        {
            field: 'waterSoftener',
        },
    ],
    [
        ProductFieldsEnum.lowerBasketWash,
        {
            field: 'lowerBasketWash',
        },
    ],
    [
        ProductFieldsEnum.intakeHoseLength,
        {
            field: 'intakeHoseLength',
        },
    ],
    [
        ProductFieldsEnum.intakeHoseLengthUOM,
        {
            field: 'intakeHoseLengthUOM',
        },
    ],
    [
        ProductFieldsEnum.outgoingHoseLength,
        {
            field: 'outgoingHoseLength',
        },
    ],
    [
        ProductFieldsEnum.outgoingHoseLengthUOM,
        {
            field: 'outgoingHoseLengthUOM',
        },
    ],
    [
        ProductFieldsEnum.openDoorDepth,
        {
            field: 'openDoorDepth',
        },
    ],
    [
        ProductFieldsEnum.openDoorDepthUOM,
        {
            field: 'openDoorDepthUOM',
        },
    ],
    [
        ProductFieldsEnum.minWashTemperature,
        {
            field: 'minWashTemperature',
        },
    ],
    [
        ProductFieldsEnum.minWashTemperatureUOM,
        {
            field: 'minWashTemperatureUOM',
        },
    ],
    [
        ProductFieldsEnum.maxWashTemperature,
        {
            field: 'maxWashTemperature',
        },
    ],
    [
        ProductFieldsEnum.maxWashTemperatureUOM,
        {
            field: 'maxWashTemperatureUOM',
        },
    ],
    [
        ProductFieldsEnum.maxIntakeWaterTemp,
        {
            field: 'maxIntakeWaterTemp',
        },
    ],
    [
        ProductFieldsEnum.maxIntakeWaterTempUOM,
        {
            field: 'maxIntakeWaterTempUOM',
        },
    ],
    [
        ProductFieldsEnum.washerType,
        {
            field: 'washerType',
        },
    ],
    [
        ProductFieldsEnum.washerDrumMaterial,
        {
            field: 'washerDrumMaterial',
        },
    ],
    [
        ProductFieldsEnum.washerDoorType,
        {
            field: 'washerDoorType',
        },
    ],
    [
        ProductFieldsEnum.dryerType,
        {
            field: 'dryerType',
        },
    ],
    [
        ProductFieldsEnum.dryerDrumMaterial,
        {
            field: 'dryerDrumMaterial',
        },
    ],
    [
        ProductFieldsEnum.dryerDoorType,
        {
            field: 'dryerDoorType',
        },
    ],
    [
        ProductFieldsEnum.dryerPowerHeatingElement,
        {
            field: 'dryerPowerHeatingElement',
        },
    ],
    [
        ProductFieldsEnum.dryerTemperatureRange,
        {
            field: 'dryerTemperatureRange',
        },
    ],
    [
        ProductFieldsEnum.dryingProcess,
        {
            field: 'dryingProcess',
        },
    ],
    [
        ProductFieldsEnum.washerDryerControlPanel,
        {
            field: 'washerDryerControlPanel',
        },
    ],
    [
        ProductFieldsEnum.waterSupply,
        {
            field: 'waterSupply',
        },
    ],
    [
        ProductFieldsEnum.loadingType,
        {
            field: 'loadingType',
        },
    ],
    [
        ProductFieldsEnum.condensationEffClass,
        {
            field: 'condensationEffClass',
        },
    ],
    [
        ProductFieldsEnum.standardCottonProgram,
        {
            field: 'standardCottonProgram',
        },
    ],
    [
        ProductFieldsEnum.avgCondensationEffFull,
        {
            field: 'avgCondensationEffFull',
        },
    ],
    [
        ProductFieldsEnum.avgCondensationEffPartial,
        {
            field: 'avgCondensationEffPartial',
        },
    ],
    [
        ProductFieldsEnum.weightedCondensationEff,
        {
            field: 'weightedCondensationEff',
        },
    ],
    [
        ProductFieldsEnum.moistureMonitoringSystem,
        {
            field: 'moistureMonitoringSystem',
        },
    ],
    [
        ProductFieldsEnum.moistureContentAfterMaxSpin,
        {
            field: 'moistureContentAfterMaxSpin',
        },
    ],
    [
        ProductFieldsEnum.locationOfVentExit,
        {
            field: 'locationOfVentExit',
        },
    ],
    [
        ProductFieldsEnum.progressIndicator,
        {
            field: 'progressIndicator',
        },
    ],
    [
        ProductFieldsEnum.startDelayOption,
        {
            field: 'startDelayOption',
        },
    ],
    [
        ProductFieldsEnum.startDelayOrStopDelayOption,
        {
            field: 'startDelayOrStopDelayOption',
        },
    ],
    [
        ProductFieldsEnum.delicateDryCycle,
        {
            field: 'delicateDryCycle',
        },
    ],
    [
        ProductFieldsEnum.endOfCycleIndicator,
        {
            field: 'endOfCycleIndicator',
        },
    ],
    [
        ProductFieldsEnum.washingPerformanceClass,
        {
            field: 'washingPerformanceClass',
        },
    ],
    [
        ProductFieldsEnum.spinSpeedOptions,
        {
            field: 'spinSpeedOptions',
        },
    ],
    [
        ProductFieldsEnum.separateTempControlOptions,
        {
            field: 'separateTempControlOptions',
        },
    ],
    [
        ProductFieldsEnum.spinDryPerformanceClass,
        {
            field: 'spinDryPerformanceClass',
        },
    ],
    [
        ProductFieldsEnum.numberOfWashPrograms,
        {
            field: 'numberOfWashPrograms',
        },
    ],
    [
        ProductFieldsEnum.numberOfDryPrograms,
        {
            field: 'numberOfDryPrograms',
        },
    ],
    [
        ProductFieldsEnum.hasAdjustableDryingTemperature,
        {
            field: 'hasAdjustableDryingTemperature',
        },
    ],
    [
        ProductFieldsEnum.hasAdjustableWashingTemperature,
        {
            field: 'hasAdjustableWashingTemperature',
        },
    ],
    [
        ProductFieldsEnum.hasHotWaterIntake,
        {
            field: 'hasHotWaterIntake',
        },
    ],
    [
        ProductFieldsEnum.hasColdWaterIntake,
        {
            field: 'hasColdWaterIntake',
        },
    ],
    [
        ProductFieldsEnum.hasHotColdWaterIntake,
        {
            field: 'hasHotColdWaterIntake',
        },
    ],
    [
        ProductFieldsEnum.hasDryingTimeSelector,
        {
            field: 'hasDryingTimeSelector',
        },
    ],
    [
        ProductFieldsEnum.hasVentHose,
        {
            field: 'hasVentHose',
        },
    ],
    [
        ProductFieldsEnum.hasDigitalCountdownIndicator,
        {
            field: 'hasDigitalCountdownIndicator',
        },
    ],
    [
        ProductFieldsEnum.hasReverseTumbleAction,
        {
            field: 'hasReverseTumbleAction',
        },
    ],
    [
        ProductFieldsEnum.hasControlPanelLock,
        {
            field: 'hasControlPanelLock',
        },
    ],
    [
        ProductFieldsEnum.hasDailyQuickProgram,
        {
            field: 'hasDailyQuickProgram',
        },
    ],
    [
        ProductFieldsEnum.has3DDynamicWash,
        {
            field: 'has3DDynamicWash',
        },
    ],
    [
        ProductFieldsEnum.hasEconomyWash,
        {
            field: 'hasEconomyWash',
        },
    ],
    [
        ProductFieldsEnum.hasHalfLoad,
        {
            field: 'hasHalfLoad',
        },
    ],
    [
        ProductFieldsEnum.hasHandWash,
        {
            field: 'hasHandWash',
        },
    ],
    [
        ProductFieldsEnum.hasPreWash,
        {
            field: 'hasPreWash',
        },
    ],
    [
        ProductFieldsEnum.hasQuickWash,
        {
            field: 'hasQuickWash',
        },
    ],
    [
        ProductFieldsEnum.hasQuickDry,
        {
            field: 'hasQuickDry',
        },
    ],
    [
        ProductFieldsEnum.hasRinseHold,
        {
            field: 'hasRinseHold',
        },
    ],
    [
        ProductFieldsEnum.hasColdWash,
        {
            field: 'hasColdWash',
        },
    ],
    [
        ProductFieldsEnum.hasWaterPlus,
        {
            field: 'hasWaterPlus',
        },
    ],
    [
        ProductFieldsEnum.hasSkipSpinCycle,
        {
            field: 'hasSkipSpinCycle',
        },
    ],
    [
        ProductFieldsEnum.hasWeightMeasurement,
        {
            field: 'hasWeightMeasurement',
        },
    ],
    [
        ProductFieldsEnum.hasDirtyRecognition,
        {
            field: 'hasDirtyRecognition',
        },
    ],
    [
        ProductFieldsEnum.hasSilkWash,
        {
            field: 'hasSilkWash',
        },
    ],
    [
        ProductFieldsEnum.hasExtraSpin,
        {
            field: 'hasExtraSpin',
        },
    ],
    [
        ProductFieldsEnum.hasMixedLoad,
        {
            field: 'hasMixedLoad',
        },
    ],
    [
        ProductFieldsEnum.hasFoamControl,
        {
            field: 'hasFoamControl',
        },
    ],
    [
        ProductFieldsEnum.hasBalanceControl,
        {
            field: 'hasBalanceControl',
        },
    ],
    [
        ProductFieldsEnum.hasWoolProgram,
        {
            field: 'hasWoolProgram',
        },
    ],
    [
        ProductFieldsEnum.hasDelicateWash,
        {
            field: 'hasDelicateWash',
        },
    ],
    [
        ProductFieldsEnum.hasAllergyCare,
        {
            field: 'hasAllergyCare',
        },
    ],
    [
        ProductFieldsEnum.hasIntelligentWashSystem,
        {
            field: 'hasIntelligentWashSystem',
        },
    ],
    [
        ProductFieldsEnum.hasIntensiveCycle,
        {
            field: 'hasIntensiveCycle',
        },
    ],
    [
        ProductFieldsEnum.hasSportsProgram,
        {
            field: 'hasSportsProgram',
        },
    ],
    [
        ProductFieldsEnum.hasCottonProgram,
        {
            field: 'hasCottonProgram',
        },
    ],
    [
        ProductFieldsEnum.hasSynthetics,
        {
            field: 'hasSynthetics',
        },
    ],
    [
        ProductFieldsEnum.hasBabyProgram,
        {
            field: 'hasBabyProgram',
        },
    ],
    [
        ProductFieldsEnum.hasAntiCreaseProgram,
        {
            field: 'hasAntiCreaseProgram',
        },
    ],
    [
        ProductFieldsEnum.hasFinalCoolTumbleDry,
        {
            field: 'hasFinalCoolTumbleDry',
        },
    ],
    [
        ProductFieldsEnum.hasFullTankIndicator,
        {
            field: 'hasFullTankIndicator',
        },
    ],
    [
        ProductFieldsEnum.hasFullFilterIndicator,
        {
            field: 'hasFullFilterIndicator',
        },
    ],
    [
        ProductFieldsEnum.hasBlockedFilterIndicator,
        {
            field: 'hasBlockedFilterIndicator',
        },
    ],
    [
        ProductFieldsEnum.hasExhaustWaterPipe,
        {
            field: 'hasExhaustWaterPipe',
        },
    ],
    [
        ProductFieldsEnum.washerDrumCapacity,
        {
            field: 'washerDrumCapacity',
        },
    ],
    [
        ProductFieldsEnum.washerDrumCapacityUOM,
        {
            field: 'washerDrumCapacityUOM',
        },
    ],
    [
        ProductFieldsEnum.dryerDrumCapacity,
        {
            field: 'dryerDrumCapacity',
        },
    ],
    [
        ProductFieldsEnum.dryerDrumCapacityUOM,
        {
            field: 'dryerDrumCapacityUOM',
        },
    ],
    [
        ProductFieldsEnum.waterConsumptionFullLoad,
        {
            field: 'waterConsumptionFullLoad',
        },
    ],
    [
        ProductFieldsEnum.waterConsumptionFullLoadUOM,
        {
            field: 'waterConsumptionFullLoadUOM',
        },
    ],
    [
        ProductFieldsEnum.washerMaxSpinSpeed,
        {
            field: 'washerMaxSpinSpeed',
        },
    ],
    [
        ProductFieldsEnum.washerMaxSpinSpeedUOM,
        {
            field: 'washerMaxSpinSpeedUOM',
        },
    ],
    [
        ProductFieldsEnum.dryerMaxSpinSpeed,
        {
            field: 'dryerMaxSpinSpeed',
        },
    ],
    [
        ProductFieldsEnum.dryerMaxSpinSpeedUOM,
        {
            field: 'dryerMaxSpinSpeedUOM',
        },
    ],
    [
        ProductFieldsEnum.cottonCapacityWashing,
        {
            field: 'cottonCapacityWashing',
        },
    ],
    [
        ProductFieldsEnum.cottonCapacityWashingUOM,
        {
            field: 'cottonCapacityWashingUOM',
        },
    ],
    [
        ProductFieldsEnum.cottonCapacityDrying,
        {
            field: 'cottonCapacityDrying',
        },
    ],
    [
        ProductFieldsEnum.cottonCapacityDryingUOM,
        {
            field: 'cottonCapacityDryingUOM',
        },
    ],
    [
        ProductFieldsEnum.washerSpinNoiseLevel,
        {
            field: 'washerSpinNoiseLevel',
        },
    ],
    [
        ProductFieldsEnum.washerSpinNoiseLevelUOM,
        {
            field: 'washerSpinNoiseLevelUOM',
        },
    ],
    [
        ProductFieldsEnum.washerNoiseLevel,
        {
            field: 'washerNoiseLevel',
        },
    ],
    [
        ProductFieldsEnum.washerNoiseLevelUOM,
        {
            field: 'washerNoiseLevelUOM',
        },
    ],
    [
        ProductFieldsEnum.dryerNoiseLevel,
        {
            field: 'dryerNoiseLevel',
        },
    ],
    [
        ProductFieldsEnum.dryerNoiseLevelUOM,
        {
            field: 'dryerNoiseLevelUOM',
        },
    ],
    [
        ProductFieldsEnum.quickWashTime,
        {
            field: 'quickWashTime',
        },
    ],
    [
        ProductFieldsEnum.quickWashTimeUOM,
        {
            field: 'quickWashTimeUOM',
        },
    ],
    [
        ProductFieldsEnum.avgWashTimeCottonFullLoad,
        {
            field: 'avgWashTimeCottonFullLoad',
        },
    ],
    [
        ProductFieldsEnum.avgWashTimeCottonFullLoadUOM,
        {
            field: 'avgWashTimeCottonFullLoadUOM',
        },
    ],
    [
        ProductFieldsEnum.avgWashTimeCottonPartialLoad,
        {
            field: 'avgWashTimeCottonPartialLoad',
        },
    ],
    [
        ProductFieldsEnum.avgWashTimeCottonPartialLoadUOM,
        {
            field: 'avgWashTimeCottonPartialLoadUOM',
        },
    ],
    [
        ProductFieldsEnum.standardCottonTimeFull,
        {
            field: 'standardCottonTimeFull',
        },
    ],
    [
        ProductFieldsEnum.standardCottonTimeFullUOM,
        {
            field: 'standardCottonTimeFullUOM',
        },
    ],
    [
        ProductFieldsEnum.standardCottonTimeHalf,
        {
            field: 'standardCottonTimeHalf',
        },
    ],
    [
        ProductFieldsEnum.standardCottonTimeHalfUOM,
        {
            field: 'standardCottonTimeHalfUOM',
        },
    ],
    [
        ProductFieldsEnum.weightedProgramTime,
        {
            field: 'weightedProgramTime',
        },
    ],
    [
        ProductFieldsEnum.weightedProgramTimeUOM,
        {
            field: 'weightedProgramTimeUOM',
        },
    ],
    [
        ProductFieldsEnum.ventHoseLength,
        {
            field: 'ventHoseLength',
        },
    ],
    [
        ProductFieldsEnum.ventHoseLengthUOM,
        {
            field: 'ventHoseLengthUOM',
        },
    ],
    [
        ProductFieldsEnum.washerWindowSize,
        {
            field: 'washerWindowSize',
        },
    ],
    [
        ProductFieldsEnum.washerWindowSizeUOM,
        {
            field: 'washerWindowSizeUOM',
        },
    ],
    [
        ProductFieldsEnum.dryerWindowSize,
        {
            field: 'dryerWindowSize',
        },
    ],
    [
        ProductFieldsEnum.dryerWindowSizeUOM,
        {
            field: 'dryerWindowSizeUOM',
        },
    ],
    [
        ProductFieldsEnum.sinkFinish,
        {
            field: 'sinkFinish',
        },
    ],
    [
        ProductFieldsEnum.tapStyle,
        {
            field: 'tapStyle',
        },
    ],
    [
        ProductFieldsEnum.tapType,
        {
            field: 'tapType',
        },
    ],
    [
        ProductFieldsEnum.tapMaterial,
        {
            field: 'tapMaterial',
        },
    ],
    [
        ProductFieldsEnum.variationDetails,
        {
            field: 'variationDetails',
        },
    ],
    [
        ProductFieldsEnum.minBaseUnit,
        {
            field: 'minBaseUnit',
        },
    ],
    [
        ProductFieldsEnum.overflow,
        {
            field: 'overflow',
        },
    ],
    [
        ProductFieldsEnum.gaskets,
        {
            field: 'gaskets',
        },
    ],
    [
        ProductFieldsEnum.fixingClips,
        {
            field: 'fixingClips',
        },
    ],
    [
        ProductFieldsEnum.numberOfBowls,
        {
            field: 'numberOfBowls',
        },
    ],
    [
        ProductFieldsEnum.numberOfDrains,
        {
            field: 'numberOfDrains',
        },
    ],
    [
        ProductFieldsEnum.hasDrain,
        {
            field: 'hasDrain',
        },
    ],
    [
        ProductFieldsEnum.hasChilledWater,
        {
            field: 'hasChilledWater',
        },
    ],
    [
        ProductFieldsEnum.hasColdWater,
        {
            field: 'hasColdWater',
        },
    ],
    [
        ProductFieldsEnum.hasHotWater,
        {
            field: 'hasHotWater',
        },
    ],
    [
        ProductFieldsEnum.hasPullOutSpray,
        {
            field: 'hasPullOutSpray',
        },
    ],
    [
        ProductFieldsEnum.drainWidth,
        {
            field: 'drainWidth',
        },
    ],
    [
        ProductFieldsEnum.drainWidthUOM,
        {
            field: 'drainWidthUOM',
        },
    ],
    [
        ProductFieldsEnum.tapHeight,
        {
            field: 'tapHeight',
        },
    ],
    [
        ProductFieldsEnum.tapHeightUOM,
        {
            field: 'tapHeightUOM',
        },
    ],
    [
        ProductFieldsEnum.spoutReach,
        {
            field: 'spoutReach',
        },
    ],
    [
        ProductFieldsEnum.spoutReachUOM,
        {
            field: 'spoutReachUOM',
        },
    ],
    [
        ProductFieldsEnum.spoutHeight,
        {
            field: 'spoutHeight',
        },
    ],
    [
        ProductFieldsEnum.spoutHeightUOM,
        {
            field: 'spoutHeightUOM',
        },
    ],
    [
        ProductFieldsEnum.tvResolution,
        {
            field: 'tvResolution',
        },
    ],
    [
        ProductFieldsEnum.tvType,
        {
            field: 'tvType',
        },
    ],
    [
        ProductFieldsEnum.inputTypes,
        {
            field: 'inputTypes',
        },
    ],
    [
        ProductFieldsEnum.numberOfInputs,
        {
            field: 'numberOfInputs',
        },
    ],
    [
        ProductFieldsEnum.numberOfHdmiInputs,
        {
            field: 'numberOfHdmiInputs',
        },
    ],
    [
        ProductFieldsEnum.isSmartTv,
        {
            field: 'isSmartTv',
        },
    ],
    [
        ProductFieldsEnum.is4K,
        {
            field: 'is4K',
        },
    ],
    [
        ProductFieldsEnum.is3D,
        {
            field: 'is3D',
        },
    ],
    [
        ProductFieldsEnum.hasFreeView,
        {
            field: 'hasFreeView',
        },
    ],
    [
        ProductFieldsEnum.isHD,
        {
            field: 'isHD',
        },
    ],
    [
        ProductFieldsEnum.hasDolbyVision,
        {
            field: 'hasDolbyVision',
        },
    ],
    [
        ProductFieldsEnum.isCurved,
        {
            field: 'isCurved',
        },
    ],
    [
        ProductFieldsEnum.hasInternetConnection,
        {
            field: 'hasInternetConnection',
        },
    ],
    [
        ProductFieldsEnum.hasDvdPlayer,
        {
            field: 'hasDvdPlayer',
        },
    ],
    [
        ProductFieldsEnum.hasTvStand,
        {
            field: 'hasTvStand',
        },
    ],
    [
        ProductFieldsEnum.isTvWallMountable,
        {
            field: 'isTvWallMountable',
        },
    ],
    [
        ProductFieldsEnum.tvSize,
        {
            field: 'tvSize',
        },
    ],
    [
        ProductFieldsEnum.tvSizeUOM,
        {
            field: 'tvSizeUOM',
        },
    ],
    [
        ProductFieldsEnum.supplierProductKey,
        {
            field: 'supplierProductKey',
        },
    ],
    [
        ProductFieldsEnum.isExcluded,
        {
            field: 'isExcluded',
        },
    ],
    [
        ProductFieldsEnum.consumerPackageQuantity,
        {
            field: 'consumerPackage.quantity',
            type: Type.Object,
            description: 'QUANTITY',
        },
    ],
    [
        ProductFieldsEnum.masterPackCaseQuantity,
        {
            field: 'masterPackCase.quantity',
            type: Type.Object,
            description: 'QUANTITY',
        },
    ],
    [
        ProductFieldsEnum.palletInformationUPC,
        {
            field: 'palletInformation.upc',
            type: Type.Object,
            description: 'UPC',
        },
    ],
    [
        ProductFieldsEnum.sccCode,
        {
            field: 'sccCode',
        },
    ],
    [
        ProductFieldsEnum.gaugeDimension,
        {
            field: 'gaugeDimension',
        },
    ],
    [
        ProductFieldsEnum.gaugeDimensionUOM,
        {
            field: 'gaugeDimensionUOM',
        },
    ],
    [
        ProductFieldsEnum.groupCost,
        {
            field: 'groupCost',
        },
    ],
    [
        ProductFieldsEnum.groupCostCurrency,
        {
            field: 'groupCostCurrency',
        },
    ],
    [
        ProductFieldsEnum.memberCost,
        {
            field: 'memberCost',
        },
    ],
    [
        ProductFieldsEnum.memberCostCurrency,
        {
            field: 'memberCostCurrency',
        },
    ],
    [
        ProductFieldsEnum.scentName,
        {
            field: 'scentName',
        },
    ],
    [
        ProductFieldsEnum.material,
        {
            field: 'material',
        },
    ],
    [
        ProductFieldsEnum.consumerPackageUPC,
        {
            field: 'consumerPackage.upc',
            type: Type.Object,
            description: 'UPC',
        },
    ],
    [
        ProductFieldsEnum.showOnlineStartDate,
        {
            field: 'showOnlineStartDate',
        },
    ],
    [
        ProductFieldsEnum.showOnlineEndDate,
        {
            field: 'showOnlineEndDate',
        },
    ],
    [
        ProductFieldsEnum.maximumPressureRating,
        {
            field: 'maximumPressureRating',
        },
    ],
    [
        ProductFieldsEnum.tankCapacity,
        {
            field: 'tankCapacity',
        },
    ],
    [
        ProductFieldsEnum.tankCapacityUOM,
        {
            field: 'tankCapacityUOM',
        },
    ],
    [
        ProductFieldsEnum.hoseDiameter,
        {
            field: 'hoseDiameter',
        },
    ],
    [
        ProductFieldsEnum.hoseDiameterUOM,
        {
            field: 'hoseDiameterUOM',
        },
    ],
    [
        ProductFieldsEnum.hasAdjustableHeatSettings,
        {
            field: 'hasAdjustableHeatSettings',
        },
    ],
    [
        ProductFieldsEnum.hasApparelBatteriesIncluded,
        {
            field: 'hasApparelBatteriesIncluded',
        },
    ],
    [
        ProductFieldsEnum.hasApparelChargerIncluded,
        {
            field: 'hasApparelChargerIncluded',
        },
    ],
    [
        ProductFieldsEnum.heatingPanelCount,
        {
            field: 'heatingPanelCount',
        },
    ],
    [
        ProductFieldsEnum.heatingZone,
        {
            field: 'heatingZone',
        },
    ],
    [
        ProductFieldsEnum.hasApparelHooded,
        {
            field: 'hasApparelHooded',
        },
    ],
    [
        ProductFieldsEnum.hasApparelInsulated,
        {
            field: 'hasApparelInsulated',
        },
    ],
    [
        ProductFieldsEnum.hasMachineWashable,
        {
            field: 'hasMachineWashable',
        },
    ],
    [
        ProductFieldsEnum.hasMoistureManagement,
        {
            field: 'hasMoistureManagement',
        },
    ],
    [
        ProductFieldsEnum.pocketsInside,
        {
            field: 'pocketsInside',
        },
    ],
    [
        ProductFieldsEnum.pocketsOutside,
        {
            field: 'pocketsOutside',
        },
    ],
    [
        ProductFieldsEnum.hasApparelRemovableHood,
        {
            field: 'hasApparelRemovableHood',
        },
    ],
    [
        ProductFieldsEnum.hasApparelWaterResistant,
        {
            field: 'hasApparelWaterResistant',
        },
    ],
    [
        ProductFieldsEnum.hasApparelWaterproof,
        {
            field: 'hasApparelWaterproof',
        },
    ],
    [
        ProductFieldsEnum.batteryAmpereHour,
        {
            field: 'batteryAmpereHour',
        },
    ],
    [
        ProductFieldsEnum.hasBatteryChargerIncluded,
        {
            field: 'hasBatteryChargerIncluded',
        },
    ],
    [
        ProductFieldsEnum.batteryCount,
        {
            field: 'batteryCount',
        },
    ],
    [
        ProductFieldsEnum.batteryLife,
        {
            field: 'batteryLife',
        },
    ],
    [
        ProductFieldsEnum.hasBatteryRechargeable,
        {
            field: 'hasBatteryRechargeable',
        },
    ],
    [
        ProductFieldsEnum.batterySize,
        {
            field: 'batterySize',
        },
    ],
    [
        ProductFieldsEnum.batteryVoltage,
        {
            field: 'batteryVoltage',
        },
    ],
    [
        ProductFieldsEnum.chargeTime,
        {
            field: 'chargeTime',
        },
    ],
    [
        ProductFieldsEnum.hasAdjustableThroat,
        {
            field: 'hasAdjustableThroat',
        },
    ],
    [
        ProductFieldsEnum.handToolsApplication,
        {
            field: 'handToolsApplication',
        },
    ],
    [
        ProductFieldsEnum.hasHandToolsBeltClip,
        {
            field: 'hasHandToolsBeltClip',
        },
    ],
    [
        ProductFieldsEnum.bevelAngle,
        {
            field: 'bevelAngle',
        },
    ],
    [
        ProductFieldsEnum.bevelOrientation,
        {
            field: 'bevelOrientation',
        },
    ],
    [
        ProductFieldsEnum.bladeCount,
        {
            field: 'bladeCount',
        },
    ],
    [
        ProductFieldsEnum.hasBladeLockable,
        {
            field: 'hasBladeLockable',
        },
    ],
    [
        ProductFieldsEnum.bladeMaterial,
        {
            field: 'bladeMaterial',
        },
    ],
    [
        ProductFieldsEnum.hasBladeRetractable,
        {
            field: 'hasBladeRetractable',
        },
    ],
    [
        ProductFieldsEnum.bladeThickness,
        {
            field: 'bladeThickness',
        },
    ],
    [
        ProductFieldsEnum.bladeThicknessUOM,
        {
            field: 'bladeThicknessUOM',
        },
    ],
    [
        ProductFieldsEnum.bladeType,
        {
            field: 'bladeType',
        },
    ],
    [
        ProductFieldsEnum.boxHeadDesign,
        {
            field: 'boxHeadDesign',
        },
    ],
    [
        ProductFieldsEnum.handToolsBulbType,
        {
            field: 'handToolsBulbType',
        },
    ],
    [
        ProductFieldsEnum.handToolsCaseContents,
        {
            field: 'handToolsCaseContents',
        },
    ],
    [
        ProductFieldsEnum.hasHandToolsCaseIncluded,
        {
            field: 'hasHandToolsCaseIncluded',
        },
    ],
    [
        ProductFieldsEnum.hasHandToolsChargerIncluded,
        {
            field: 'hasHandToolsChargerIncluded',
        },
    ],
    [
        ProductFieldsEnum.connectionDesign,
        {
            field: 'connectionDesign',
        },
    ],
    [
        ProductFieldsEnum.hasCorrugatedSole,
        {
            field: 'hasCorrugatedSole',
        },
    ],
    [
        ProductFieldsEnum.crownSizeRange,
        {
            field: 'crownSizeRange',
        },
    ],
    [
        ProductFieldsEnum.hasDeepOffset,
        {
            field: 'hasDeepOffset',
        },
    ],
    [
        ProductFieldsEnum.dieSize,
        {
            field: 'dieSize',
        },
    ],
    [
        ProductFieldsEnum.dieSizeUOM,
        {
            field: 'dieSizeUOM',
        },
    ],
    [
        ProductFieldsEnum.driveSize,
        {
            field: 'driveSize',
        },
    ],
    [
        ProductFieldsEnum.hasDriverIncluded,
        {
            field: 'hasDriverIncluded',
        },
    ],
    [
        ProductFieldsEnum.hasDropForged,
        {
            field: 'hasDropForged',
        },
    ],
    [
        ProductFieldsEnum.hasHandToolsElectronic,
        {
            field: 'hasHandToolsElectronic',
        },
    ],
    [
        ProductFieldsEnum.fastenerCategory,
        {
            field: 'fastenerCategory',
        },
    ],
    [
        ProductFieldsEnum.fastenerDiameter,
        {
            field: 'fastenerDiameter',
        },
    ],
    [
        ProductFieldsEnum.fastenerDiameterUOM,
        {
            field: 'fastenerDiameterUOM',
        },
    ],
    [
        ProductFieldsEnum.fastenerGaugeRange,
        {
            field: 'fastenerGaugeRange',
        },
    ],
    [
        ProductFieldsEnum.fastenerHeadStyle,
        {
            field: 'fastenerHeadStyle',
        },
    ],
    [
        ProductFieldsEnum.fastenerLength,
        {
            field: 'fastenerLength',
        },
    ],
    [
        ProductFieldsEnum.fastenerLengthRange,
        {
            field: 'fastenerLengthRange',
        },
    ],
    [
        ProductFieldsEnum.fastenerLengthUOM,
        {
            field: 'fastenerLengthUOM',
        },
    ],
    [
        ProductFieldsEnum.fastenerMaterial,
        {
            field: 'fastenerMaterial',
        },
    ],
    [
        ProductFieldsEnum.fastenerPlating,
        {
            field: 'fastenerPlating',
        },
    ],
    [
        ProductFieldsEnum.fastenerSize,
        {
            field: 'fastenerSize',
        },
    ],
    [
        ProductFieldsEnum.fastenerThreadType,
        {
            field: 'fastenerThreadType',
        },
    ],
    [
        ProductFieldsEnum.handToolsFastenerType,
        {
            field: 'handToolsFastenerType',
        },
    ],
    [
        ProductFieldsEnum.femaleDriveSize,
        {
            field: 'femaleDriveSize',
        },
    ],
    [
        ProductFieldsEnum.frogAngle,
        {
            field: 'frogAngle',
        },
    ],
    [
        ProductFieldsEnum.gearRatio,
        {
            field: 'gearRatio',
        },
    ],
    [
        ProductFieldsEnum.handleType,
        {
            field: 'handleType',
        },
    ],
    [
        ProductFieldsEnum.headMaterial,
        {
            field: 'headMaterial',
        },
    ],
    [
        ProductFieldsEnum.hexKeySizes,
        {
            field: 'hexKeySizes',
        },
    ],
    [
        ProductFieldsEnum.inchSize,
        {
            field: 'inchSize',
        },
    ],
    [
        ProductFieldsEnum.inchSizeSockets,
        {
            field: 'inchSizeSockets',
        },
    ],
    [
        ProductFieldsEnum.handToolsIndoorOutdoor,
        {
            field: 'handToolsIndoorOutdoor',
        },
    ],
    [
        ProductFieldsEnum.handToolsInsideDiameter,
        {
            field: 'handToolsInsideDiameter',
        },
    ],
    [
        ProductFieldsEnum.handToolsInsideDiameterUOM,
        {
            field: 'handToolsInsideDiameterUOM',
        },
    ],
    [
        ProductFieldsEnum.hasHandToolsInsulatedHandle,
        {
            field: 'hasHandToolsInsulatedHandle',
        },
    ],
    [
        ProductFieldsEnum.jawCapacity,
        {
            field: 'jawCapacity',
        },
    ],
    [
        ProductFieldsEnum.jawCapacityUOM,
        {
            field: 'jawCapacityUOM',
        },
    ],
    [
        ProductFieldsEnum.jawTipSize,
        {
            field: 'jawTipSize',
        },
    ],
    [
        ProductFieldsEnum.jawTipSizeUOM,
        {
            field: 'jawTipSizeUOM',
        },
    ],
    [
        ProductFieldsEnum.jawWidth,
        {
            field: 'jawWidth',
        },
    ],
    [
        ProductFieldsEnum.jawWidthUOM,
        {
            field: 'jawWidthUOM',
        },
    ],
    [
        ProductFieldsEnum.hasLaserBeam360Degrees,
        {
            field: 'hasLaserBeam360Degrees',
        },
    ],
    [
        ProductFieldsEnum.laserFunctions,
        {
            field: 'laserFunctions',
        },
    ],
    [
        ProductFieldsEnum.laserMaximumDistance,
        {
            field: 'laserMaximumDistance',
        },
    ],
    [
        ProductFieldsEnum.laserMaximumDistanceUOM,
        {
            field: 'laserMaximumDistanceUOM',
        },
    ],
    [
        ProductFieldsEnum.laserMountingMethod,
        {
            field: 'laserMountingMethod',
        },
    ],
    [
        ProductFieldsEnum.hasHandToolsLEDDisplay,
        {
            field: 'hasHandToolsLEDDisplay',
        },
    ],
    [
        ProductFieldsEnum.hasHandToolsLegsIncluded,
        {
            field: 'hasHandToolsLegsIncluded',
        },
    ],
    [
        ProductFieldsEnum.lightUnitofMeasureQuantity,
        {
            field: 'lightUnitofMeasureQuantity',
        },
    ],
    [
        ProductFieldsEnum.hasHandToolsLockable,
        {
            field: 'hasHandToolsLockable',
        },
    ],
    [
        ProductFieldsEnum.hasHandToolsMagnetic,
        {
            field: 'hasHandToolsMagnetic',
        },
    ],
    [
        ProductFieldsEnum.maleDriveSize,
        {
            field: 'maleDriveSize',
        },
    ],
    [
        ProductFieldsEnum.markingToolCategory,
        {
            field: 'markingToolCategory',
        },
    ],
    [
        ProductFieldsEnum.maximumFastenerLength,
        {
            field: 'maximumFastenerLength',
        },
    ],
    [
        ProductFieldsEnum.maximumFastenerLengthUOM,
        {
            field: 'maximumFastenerLengthUOM',
        },
    ],
    [
        ProductFieldsEnum.maximumOpening,
        {
            field: 'maximumOpening',
        },
    ],
    [
        ProductFieldsEnum.maximumOpeningUOM,
        {
            field: 'maximumOpeningUOM',
        },
    ],
    [
        ProductFieldsEnum.metricSize,
        {
            field: 'metricSize',
        },
    ],
    [
        ProductFieldsEnum.metricSizeSockets,
        {
            field: 'metricSizeSockets',
        },
    ],
    [
        ProductFieldsEnum.minimumFastenerLength,
        {
            field: 'minimumFastenerLength',
        },
    ],
    [
        ProductFieldsEnum.minimumFastenerLengthUOM,
        {
            field: 'minimumFastenerLengthUOM',
        },
    ],
    [
        ProductFieldsEnum.nailCoating,
        {
            field: 'nailCoating',
        },
    ],
    [
        ProductFieldsEnum.nailGauge,
        {
            field: 'nailGauge',
        },
    ],
    [
        ProductFieldsEnum.nailHeadStyle,
        {
            field: 'nailHeadStyle',
        },
    ],
    [
        ProductFieldsEnum.nailLength,
        {
            field: 'nailLength',
        },
    ],
    [
        ProductFieldsEnum.nailLengthUOM,
        {
            field: 'nailLengthUOM',
        },
    ],
    [
        ProductFieldsEnum.nailMaterial,
        {
            field: 'nailMaterial',
        },
    ],
    [
        ProductFieldsEnum.nailType,
        {
            field: 'nailType',
        },
    ],
    [
        ProductFieldsEnum.numberofVials,
        {
            field: 'numberofVials',
        },
    ],
    [
        ProductFieldsEnum.numberofVialsMeasuringLevel,
        {
            field: 'numberofVialsMeasuringLevel',
        },
    ],
    [
        ProductFieldsEnum.numberofVialsMeasuringPlumb,
        {
            field: 'numberofVialsMeasuringPlumb',
        },
    ],
    [
        ProductFieldsEnum.offsetHeadAngle1,
        {
            field: 'offsetHeadAngle1',
        },
    ],
    [
        ProductFieldsEnum.offsetHeadAngle2,
        {
            field: 'offsetHeadAngle2',
        },
    ],
    [
        ProductFieldsEnum.handToolsOutsideDiameter,
        {
            field: 'handToolsOutsideDiameter',
        },
    ],
    [
        ProductFieldsEnum.handToolsOutsideDiameterUOM,
        {
            field: 'handToolsOutsideDiameterUOM',
        },
    ],
    [
        ProductFieldsEnum.planeBedMaterial,
        {
            field: 'planeBedMaterial',
        },
    ],
    [
        ProductFieldsEnum.punchShape,
        {
            field: 'punchShape',
        },
    ],
    [
        ProductFieldsEnum.punchType,
        {
            field: 'punchType',
        },
    ],
    [
        ProductFieldsEnum.ratchetSize,
        {
            field: 'ratchetSize',
        },
    ],
    [
        ProductFieldsEnum.screwStyle,
        {
            field: 'screwStyle',
        },
    ],
    [
        ProductFieldsEnum.screwType,
        {
            field: 'screwType',
        },
    ],
    [
        ProductFieldsEnum.screwdriverHeadSize,
        {
            field: 'screwdriverHeadSize',
        },
    ],
    [
        ProductFieldsEnum.screwdriverSetsIncluded,
        {
            field: 'screwdriverSetsIncluded',
        },
    ],
    [
        ProductFieldsEnum.screwdriverStyle,
        {
            field: 'screwdriverStyle',
        },
    ],
    [
        ProductFieldsEnum.hasHandToolsSelfAdhesive,
        {
            field: 'hasHandToolsSelfAdhesive',
        },
    ],
    [
        ProductFieldsEnum.hasSelfDrilling,
        {
            field: 'hasSelfDrilling',
        },
    ],
    [
        ProductFieldsEnum.hasSelfTapping,
        {
            field: 'hasSelfTapping',
        },
    ],
    [
        ProductFieldsEnum.sensorRange,
        {
            field: 'sensorRange',
        },
    ],
    [
        ProductFieldsEnum.hasSharpenable,
        {
            field: 'hasSharpenable',
        },
    ],
    [
        ProductFieldsEnum.handToolsSize,
        {
            field: 'handToolsSize',
        },
    ],
    [
        ProductFieldsEnum.hasSocketDeepWell,
        {
            field: 'hasSocketDeepWell',
        },
    ],
    [
        ProductFieldsEnum.socketPoints,
        {
            field: 'socketPoints',
        },
    ],
    [
        ProductFieldsEnum.socketSize,
        {
            field: 'socketSize',
        },
    ],
    [
        ProductFieldsEnum.socketSizeUOM,
        {
            field: 'socketSizeUOM',
        },
    ],
    [
        ProductFieldsEnum.soleLength,
        {
            field: 'soleLength',
        },
    ],
    [
        ProductFieldsEnum.soleLengthUOM,
        {
            field: 'soleLengthUOM',
        },
    ],
    [
        ProductFieldsEnum.soleWidth,
        {
            field: 'soleWidth',
        },
    ],
    [
        ProductFieldsEnum.soleWidthUOM,
        {
            field: 'soleWidthUOM',
        },
    ],
    [
        ProductFieldsEnum.hasStampedSizeIdentification,
        {
            field: 'hasStampedSizeIdentification',
        },
    ],
    [
        ProductFieldsEnum.stapleCrownSize,
        {
            field: 'stapleCrownSize',
        },
    ],
    [
        ProductFieldsEnum.stapleCrownSizeUOM,
        {
            field: 'stapleCrownSizeUOM',
        },
    ],
    [
        ProductFieldsEnum.stapleLegLength,
        {
            field: 'stapleLegLength',
        },
    ],
    [
        ProductFieldsEnum.stapleLegLengthUOM,
        {
            field: 'stapleLegLengthUOM',
        },
    ],
    [
        ProductFieldsEnum.stringLength,
        {
            field: 'stringLength',
        },
    ],
    [
        ProductFieldsEnum.stringLengthUOM,
        {
            field: 'stringLengthUOM',
        },
    ],
    [
        ProductFieldsEnum.tapeLength,
        {
            field: 'tapeLength',
        },
    ],
    [
        ProductFieldsEnum.tapeLengthUOM,
        {
            field: 'tapeLengthUOM',
        },
    ],
    [
        ProductFieldsEnum.tapeWidth,
        {
            field: 'tapeWidth',
        },
    ],
    [
        ProductFieldsEnum.tapeWidthUOM,
        {
            field: 'tapeWidthUOM',
        },
    ],
    [
        ProductFieldsEnum.teethPerInch,
        {
            field: 'teethPerInch',
        },
    ],
    [
        ProductFieldsEnum.throatDepth,
        {
            field: 'throatDepth',
        },
    ],
    [
        ProductFieldsEnum.throatDepthUOM,
        {
            field: 'throatDepthUOM',
        },
    ],
    [
        ProductFieldsEnum.tipSize,
        {
            field: 'tipSize',
        },
    ],
    [
        ProductFieldsEnum.toothConfiguration,
        {
            field: 'toothConfiguration',
        },
    ],
    [
        ProductFieldsEnum.toothCount,
        {
            field: 'toothCount',
        },
    ],
    [
        ProductFieldsEnum.toothMaterial,
        {
            field: 'toothMaterial',
        },
    ],
    [
        ProductFieldsEnum.hasTripodIncluded,
        {
            field: 'hasTripodIncluded',
        },
    ],
    [
        ProductFieldsEnum.hasHandToolsWaterResistant,
        {
            field: 'hasHandToolsWaterResistant',
        },
    ],
    [
        ProductFieldsEnum.wrenchSize,
        {
            field: 'wrenchSize',
        },
    ],
    [
        ProductFieldsEnum.additionalCuttingSpecs,
        {
            field: 'additionalCuttingSpecs',
        },
    ],
    [
        ProductFieldsEnum.powerToolsAirInletSize,
        {
            field: 'powerToolsAirInletSize',
        },
    ],
    [
        ProductFieldsEnum.powerToolsAirInletSizeUOM,
        {
            field: 'powerToolsAirInletSizeUOM',
        },
    ],
    [
        ProductFieldsEnum.airVelocity,
        {
            field: 'airVelocity',
        },
    ],
    [
        ProductFieldsEnum.airVolume,
        {
            field: 'airVolume',
        },
    ],
    [
        ProductFieldsEnum.powerToolsAmperage,
        {
            field: 'powerToolsAmperage',
        },
    ],
    [
        ProductFieldsEnum.arborHoleSize,
        {
            field: 'arborHoleSize',
        },
    ],
    [
        ProductFieldsEnum.arborSize,
        {
            field: 'arborSize',
        },
    ],
    [
        ProductFieldsEnum.arborSizeUOM,
        {
            field: 'arborSizeUOM',
        },
    ],
    [
        ProductFieldsEnum.hasPowerToolsAutomaticShutOff,
        {
            field: 'hasPowerToolsAutomaticShutOff',
        },
    ],
    [
        ProductFieldsEnum.averageAirConsumption,
        {
            field: 'averageAirConsumption',
        },
    ],
    [
        ProductFieldsEnum.beltSize,
        {
            field: 'beltSize',
        },
    ],
    [
        ProductFieldsEnum.beltSizeUOM,
        {
            field: 'beltSizeUOM',
        },
    ],
    [
        ProductFieldsEnum.bevelCapability,
        {
            field: 'bevelCapability',
        },
    ],
    [
        ProductFieldsEnum.bevelCapacity,
        {
            field: 'bevelCapacity',
        },
    ],
    [
        ProductFieldsEnum.bevelDirection,
        {
            field: 'bevelDirection',
        },
    ],
    [
        ProductFieldsEnum.hasBevelStop,
        {
            field: 'hasBevelStop',
        },
    ],
    [
        ProductFieldsEnum.bitChangeType,
        {
            field: 'bitChangeType',
        },
    ],
    [
        ProductFieldsEnum.bitDiameter,
        {
            field: 'bitDiameter',
        },
    ],
    [
        ProductFieldsEnum.bitMaterials,
        {
            field: 'bitMaterials',
        },
    ],
    [
        ProductFieldsEnum.bitSizes,
        {
            field: 'bitSizes',
        },
    ],
    [
        ProductFieldsEnum.bitType,
        {
            field: 'bitType',
        },
    ],
    [
        ProductFieldsEnum.bladeCuttingMaterial,
        {
            field: 'bladeCuttingMaterial',
        },
    ],
    [
        ProductFieldsEnum.powerToolsBladeDiameter,
        {
            field: 'powerToolsBladeDiameter',
        },
    ],
    [
        ProductFieldsEnum.powerToolsBladeDiameterUOM,
        {
            field: 'powerToolsBladeDiameterUOM',
        },
    ],
    [
        ProductFieldsEnum.powerToolsBladeLocation,
        {
            field: 'powerToolsBladeLocation',
        },
    ],
    [
        ProductFieldsEnum.bladeMaterialCut,
        {
            field: 'bladeMaterialCut',
        },
    ],
    [
        ProductFieldsEnum.bladeSpeed,
        {
            field: 'bladeSpeed',
        },
    ],
    [
        ProductFieldsEnum.bladeWrenchIncluded,
        {
            field: 'bladeWrenchIncluded',
        },
    ],
    [
        ProductFieldsEnum.powerToolsBladesIncluded,
        {
            field: 'powerToolsBladesIncluded',
        },
    ],
    [
        ProductFieldsEnum.blastsPerMinute,
        {
            field: 'blastsPerMinute',
        },
    ],
    [
        ProductFieldsEnum.btuHeatRating,
        {
            field: 'btuHeatRating',
        },
    ],
    [
        ProductFieldsEnum.cartridgeType,
        {
            field: 'cartridgeType',
        },
    ],
    [
        ProductFieldsEnum.powerToolsCaseContents,
        {
            field: 'powerToolsCaseContents',
        },
    ],
    [
        ProductFieldsEnum.hasPowerToolsCaseIncluded,
        {
            field: 'hasPowerToolsCaseIncluded',
        },
    ],
    [
        ProductFieldsEnum.chargerBatterySizes,
        {
            field: 'chargerBatterySizes',
        },
    ],
    [
        ProductFieldsEnum.chargerBatteryVoltages,
        {
            field: 'chargerBatteryVoltages',
        },
    ],
    [
        ProductFieldsEnum.chargerInputVoltage,
        {
            field: 'chargerInputVoltage',
        },
    ],
    [
        ProductFieldsEnum.clutchSettings,
        {
            field: 'clutchSettings',
        },
    ],
    [
        ProductFieldsEnum.commercialResidential,
        {
            field: 'commercialResidential',
        },
    ],
    [
        ProductFieldsEnum.powerToolsCordLength,
        {
            field: 'powerToolsCordLength',
        },
    ],
    [
        ProductFieldsEnum.powerToolsCordLengthUOM,
        {
            field: 'powerToolsCordLengthUOM',
        },
    ],
    [
        ProductFieldsEnum.crosscutCapacity0Miter45LeftBevel,
        {
            field: 'crosscutCapacity0Miter45LeftBevel',
        },
    ],
    [
        ProductFieldsEnum.crosscutCapacity0Miter45RightBevel,
        {
            field: 'crosscutCapacity0Miter45RightBevel',
        },
    ],
    [
        ProductFieldsEnum.crosscutCapacity45Miter45LeftBevel,
        {
            field: 'crosscutCapacity45Miter45LeftBevel',
        },
    ],
    [
        ProductFieldsEnum.crosscutCapacity45Miter45RightBevel,
        {
            field: 'crosscutCapacity45Miter45RightBevel',
        },
    ],
    [
        ProductFieldsEnum.crosscutCapacity45Miter0Bevel,
        {
            field: 'crosscutCapacity45Miter0Bevel',
        },
    ],
    [
        ProductFieldsEnum.cutsPerMinute,
        {
            field: 'cutsPerMinute',
        },
    ],
    [
        ProductFieldsEnum.cuttingCapacity,
        {
            field: 'cuttingCapacity',
        },
    ],
    [
        ProductFieldsEnum.cuttingCapacityUOM,
        {
            field: 'cuttingCapacityUOM',
        },
    ],
    [
        ProductFieldsEnum.cuttingDepth,
        {
            field: 'cuttingDepth',
        },
    ],
    [
        ProductFieldsEnum.cuttingDepthUOM,
        {
            field: 'cuttingDepthUOM',
        },
    ],
    [
        ProductFieldsEnum.cuttingDiameter,
        {
            field: 'cuttingDiameter',
        },
    ],
    [
        ProductFieldsEnum.cuttingDiameterUOM,
        {
            field: 'cuttingDiameterUOM',
        },
    ],
    [
        ProductFieldsEnum.cuttingWidth,
        {
            field: 'cuttingWidth',
        },
    ],
    [
        ProductFieldsEnum.cuttingWidthUOM,
        {
            field: 'cuttingWidthUOM',
        },
    ],
    [
        ProductFieldsEnum.powerToolsDecibelRating,
        {
            field: 'powerToolsDecibelRating',
        },
    ],
    [
        ProductFieldsEnum.hasPowerToolsDepthAdjustment,
        {
            field: 'hasPowerToolsDepthAdjustment',
        },
    ],
    [
        ProductFieldsEnum.discDiameter,
        {
            field: 'discDiameter',
        },
    ],
    [
        ProductFieldsEnum.discDiameterUOM,
        {
            field: 'discDiameterUOM',
        },
    ],
    [
        ProductFieldsEnum.discThickness,
        {
            field: 'discThickness',
        },
    ],
    [
        ProductFieldsEnum.discThicknessUOM,
        {
            field: 'discThicknessUOM',
        },
    ],
    [
        ProductFieldsEnum.drillType,
        {
            field: 'drillType',
        },
    ],
    [
        ProductFieldsEnum.drillingDepth,
        {
            field: 'drillingDepth',
        },
    ],
    [
        ProductFieldsEnum.drillingDepthUOM,
        {
            field: 'drillingDepthUOM',
        },
    ],
    [
        ProductFieldsEnum.driveDesign,
        {
            field: 'driveDesign',
        },
    ],
    [
        ProductFieldsEnum.hasDustBlower,
        {
            field: 'hasDustBlower',
        },
    ],
    [
        ProductFieldsEnum.hasDustCollection,
        {
            field: 'hasDustCollection',
        },
    ],
    [
        ProductFieldsEnum.hasDustPort,
        {
            field: 'hasDustPort',
        },
    ],
    [
        ProductFieldsEnum.hasEdgerCapable,
        {
            field: 'hasEdgerCapable',
        },
    ],
    [
        ProductFieldsEnum.hasElectricMotorBrake,
        {
            field: 'hasElectricMotorBrake',
        },
    ],
    [
        ProductFieldsEnum.hasExternalMotorBrushAccess,
        {
            field: 'hasExternalMotorBrushAccess',
        },
    ],
    [
        ProductFieldsEnum.hasFleshSensingSystem,
        {
            field: 'hasFleshSensingSystem',
        },
    ],
    [
        ProductFieldsEnum.fluteLength,
        {
            field: 'fluteLength',
        },
    ],
    [
        ProductFieldsEnum.fluteLengthUOM,
        {
            field: 'fluteLengthUOM',
        },
    ],
    [
        ProductFieldsEnum.hasForwardReverseSwitch,
        {
            field: 'hasForwardReverseSwitch',
        },
    ],
    [
        ProductFieldsEnum.grinderType,
        {
            field: 'grinderType',
        },
    ],
    [
        ProductFieldsEnum.hasGrinderWheel,
        {
            field: 'hasGrinderWheel',
        },
    ],
    [
        ProductFieldsEnum.grit,
        {
            field: 'grit',
        },
    ],
    [
        ProductFieldsEnum.gritSizeCAMI,
        {
            field: 'gritSizeCAMI',
        },
    ],
    [
        ProductFieldsEnum.gritSizeFEPA,
        {
            field: 'gritSizeFEPA',
        },
    ],
    [
        ProductFieldsEnum.holeSawDiameter,
        {
            field: 'holeSawDiameter',
        },
    ],
    [
        ProductFieldsEnum.holeSawDiameterUOM,
        {
            field: 'holeSawDiameterUOM',
        },
    ],
    [
        ProductFieldsEnum.holeSawMaterial,
        {
            field: 'holeSawMaterial',
        },
    ],
    [
        ProductFieldsEnum.holeSawType,
        {
            field: 'holeSawType',
        },
    ],
    [
        ProductFieldsEnum.horizontalCrosscutCapacity,
        {
            field: 'horizontalCrosscutCapacity',
        },
    ],
    [
        ProductFieldsEnum.horizontalCrosscutCapacityUOM,
        {
            field: 'horizontalCrosscutCapacityUOM',
        },
    ],
    [
        ProductFieldsEnum.powerToolsHorsepower,
        {
            field: 'powerToolsHorsepower',
        },
    ],
    [
        ProductFieldsEnum.impactStandard,
        {
            field: 'impactStandard',
        },
    ],
    [
        ProductFieldsEnum.impactWrenchDriveSize,
        {
            field: 'impactWrenchDriveSize',
        },
    ],
    [
        ProductFieldsEnum.impactWrenchDriveSizeUOM,
        {
            field: 'impactWrenchDriveSizeUOM',
        },
    ],
    [
        ProductFieldsEnum.impactsPerMinute,
        {
            field: 'impactsPerMinute',
        },
    ],
    [
        ProductFieldsEnum.integratedRafterHook,
        {
            field: 'integratedRafterHook',
        },
    ],
    [
        ProductFieldsEnum.integratedWorkLight,
        {
            field: 'integratedWorkLight',
        },
    ],
    [
        ProductFieldsEnum.kerf,
        {
            field: 'kerf',
        },
    ],
    [
        ProductFieldsEnum.kerfUOM,
        {
            field: 'kerfUOM',
        },
    ],
    [
        ProductFieldsEnum.keylessKeyedBladeChange,
        {
            field: 'keylessKeyedBladeChange',
        },
    ],
    [
        ProductFieldsEnum.hasLadderHook,
        {
            field: 'hasLadderHook',
        },
    ],
    [
        ProductFieldsEnum.lineDiameter,
        {
            field: 'lineDiameter',
        },
    ],
    [
        ProductFieldsEnum.lineDiameterUOM,
        {
            field: 'lineDiameterUOM',
        },
    ],
    [
        ProductFieldsEnum.lineFeedType,
        {
            field: 'lineFeedType',
        },
    ],
    [
        ProductFieldsEnum.hasPowerToolsLockOnSwitch,
        {
            field: 'hasPowerToolsLockOnSwitch',
        },
    ],
    [
        ProductFieldsEnum.magazineCapacity,
        {
            field: 'magazineCapacity',
        },
    ],
    [
        ProductFieldsEnum.maxCutDepth45degrees,
        {
            field: 'maxCutDepth45degrees',
        },
    ],
    [
        ProductFieldsEnum.maxCutDepth45degreesUOM,
        {
            field: 'maxCutDepth45degreesUOM',
        },
    ],
    [
        ProductFieldsEnum.maxCutDepth90degrees,
        {
            field: 'maxCutDepth90degrees',
        },
    ],
    [
        ProductFieldsEnum.maxCutDepth90degreesUOM,
        {
            field: 'maxCutDepth90degreesUOM',
        },
    ],
    [
        ProductFieldsEnum.maximumLeftBevel,
        {
            field: 'maximumLeftBevel',
        },
    ],
    [
        ProductFieldsEnum.maximumLeftMiter,
        {
            field: 'maximumLeftMiter',
        },
    ],
    [
        ProductFieldsEnum.maximumPowerOutput,
        {
            field: 'maximumPowerOutput',
        },
    ],
    [
        ProductFieldsEnum.maximumRightBevel,
        {
            field: 'maximumRightBevel',
        },
    ],
    [
        ProductFieldsEnum.maximumRightMiter,
        {
            field: 'maximumRightMiter',
        },
    ],
    [
        ProductFieldsEnum.maximumStrokesperMinute,
        {
            field: 'maximumStrokesperMinute',
        },
    ],
    [
        ProductFieldsEnum.maximumTemperature,
        {
            field: 'maximumTemperature',
        },
    ],
    [
        ProductFieldsEnum.maximumTorqueftlbs,
        {
            field: 'maximumTorqueftlbs',
        },
    ],
    [
        ProductFieldsEnum.maximumTorqueinlbs,
        {
            field: 'maximumTorqueinlbs',
        },
    ],
    [
        ProductFieldsEnum.minimumChuckSize,
        {
            field: 'minimumChuckSize',
        },
    ],
    [
        ProductFieldsEnum.powerToolsMotorSpeed,
        {
            field: 'powerToolsMotorSpeed',
        },
    ],
    [
        ProductFieldsEnum.powerToolsNumberofPieces,
        {
            field: 'powerToolsNumberofPieces',
        },
    ],
    [
        ProductFieldsEnum.oscillationsPerMinute,
        {
            field: 'oscillationsPerMinute',
        },
    ],
    [
        ProductFieldsEnum.hasPowerToolsOverloadProtection,
        {
            field: 'hasPowerToolsOverloadProtection',
        },
    ],
    [
        ProductFieldsEnum.pilotBitDiameter,
        {
            field: 'pilotBitDiameter',
        },
    ],
    [
        ProductFieldsEnum.pilotBitDiameterUOM,
        {
            field: 'pilotBitDiameterUOM',
        },
    ],
    [
        ProductFieldsEnum.powerToolsPlateThickness,
        {
            field: 'powerToolsPlateThickness',
        },
    ],
    [
        ProductFieldsEnum.powerToolsPlateThicknessUOM,
        {
            field: 'powerToolsPlateThicknessUOM',
        },
    ],
    [
        ProductFieldsEnum.presetBevelAngleDetents,
        {
            field: 'presetBevelAngleDetents',
        },
    ],
    [
        ProductFieldsEnum.presetMiterAngleDetents,
        {
            field: 'presetMiterAngleDetents',
        },
    ],
    [
        ProductFieldsEnum.hasQuickChange,
        {
            field: 'hasQuickChange',
        },
    ],
    [
        ProductFieldsEnum.hasQuickReleaseVise,
        {
            field: 'hasQuickReleaseVise',
        },
    ],
    [
        ProductFieldsEnum.recommendedAirPressure,
        {
            field: 'recommendedAirPressure',
        },
    ],
    [
        ProductFieldsEnum.powerToolsRecommendedHoseSize,
        {
            field: 'powerToolsRecommendedHoseSize',
        },
    ],
    [
        ProductFieldsEnum.powerToolsRecommendedHoseSizeUOM,
        {
            field: 'powerToolsRecommendedHoseSizeUOM',
        },
    ],
    [
        ProductFieldsEnum.hasPowerToolsReverse,
        {
            field: 'hasPowerToolsReverse',
        },
    ],
    [
        ProductFieldsEnum.hasPowerToolsRockerSwitch,
        {
            field: 'hasPowerToolsRockerSwitch',
        },
    ],
    [
        ProductFieldsEnum.hasRustResistant,
        {
            field: 'hasRustResistant',
        },
    ],
    [
        ProductFieldsEnum.sanderBeltSize,
        {
            field: 'sanderBeltSize',
        },
    ],
    [
        ProductFieldsEnum.sanderBeltSizeUOM,
        {
            field: 'sanderBeltSizeUOM',
        },
    ],
    [
        ProductFieldsEnum.sandingGrade,
        {
            field: 'sandingGrade',
        },
    ],
    [
        ProductFieldsEnum.sandingGrit,
        {
            field: 'sandingGrit',
        },
    ],
    [
        ProductFieldsEnum.sandingMineral,
        {
            field: 'sandingMineral',
        },
    ],
    [
        ProductFieldsEnum.sandingSpeedMax,
        {
            field: 'sandingSpeedMax',
        },
    ],
    [
        ProductFieldsEnum.sandingSpeedMin,
        {
            field: 'sandingSpeedMin',
        },
    ],
    [
        ProductFieldsEnum.sandpaperAccessoryType,
        {
            field: 'sandpaperAccessoryType',
        },
    ],
    [
        ProductFieldsEnum.sawDrive,
        {
            field: 'sawDrive',
        },
    ],
    [
        ProductFieldsEnum.powerToolsSawType,
        {
            field: 'powerToolsSawType',
        },
    ],
    [
        ProductFieldsEnum.scanDepth,
        {
            field: 'scanDepth',
        },
    ],
    [
        ProductFieldsEnum.scanDepthUOM,
        {
            field: 'scanDepthUOM',
        },
    ],
    [
        ProductFieldsEnum.shankDiameter,
        {
            field: 'shankDiameter',
        },
    ],
    [
        ProductFieldsEnum.shankDiameterUOM,
        {
            field: 'shankDiameterUOM',
        },
    ],
    [
        ProductFieldsEnum.shoeLength,
        {
            field: 'shoeLength',
        },
    ],
    [
        ProductFieldsEnum.shoeLengthUOM,
        {
            field: 'shoeLengthUOM',
        },
    ],
    [
        ProductFieldsEnum.hasPowerToolsShoulderStrap,
        {
            field: 'hasPowerToolsShoulderStrap',
        },
    ],
    [
        ProductFieldsEnum.speedSurfaceFeetOrbitsPerMinute,
        {
            field: 'speedSurfaceFeetOrbitsPerMinute',
        },
    ],
    [
        ProductFieldsEnum.hasPowerToolsSpeedControl,
        {
            field: 'hasPowerToolsSpeedControl',
        },
    ],
    [
        ProductFieldsEnum.powerToolsStartType,
        {
            field: 'powerToolsStartType',
        },
    ],
    [
        ProductFieldsEnum.strokeLength,
        {
            field: 'strokeLength',
        },
    ],
    [
        ProductFieldsEnum.strokeLengthUOM,
        {
            field: 'strokeLengthUOM',
        },
    ],
    [
        ProductFieldsEnum.surfaceCoating,
        {
            field: 'surfaceCoating',
        },
    ],
    [
        ProductFieldsEnum.switchType,
        {
            field: 'switchType',
        },
    ],
    [
        ProductFieldsEnum.hasToolLessBladeChanging,
        {
            field: 'hasToolLessBladeChanging',
        },
    ],
    [
        ProductFieldsEnum.torqueIncrements,
        {
            field: 'torqueIncrements',
        },
    ],
    [
        ProductFieldsEnum.trimmerLineCount,
        {
            field: 'trimmerLineCount',
        },
    ],
    [
        ProductFieldsEnum.verticalCrosscutCapacity,
        {
            field: 'verticalCrosscutCapacity',
        },
    ],
    [
        ProductFieldsEnum.verticalCrosscutCapacityUOM,
        {
            field: 'verticalCrosscutCapacityUOM',
        },
    ],
    [
        ProductFieldsEnum.powerToolsVoltage,
        {
            field: 'powerToolsVoltage',
        },
    ],
    [
        ProductFieldsEnum.powerToolsWattage,
        {
            field: 'powerToolsWattage',
        },
    ],
    [
        ProductFieldsEnum.hasWetDry,
        {
            field: 'hasWetDry',
        },
    ],
    [
        ProductFieldsEnum.wetorDryApplication,
        {
            field: 'wetorDryApplication',
        },
    ],
    [
        ProductFieldsEnum.powerToolsWheelDiameter,
        {
            field: 'powerToolsWheelDiameter',
        },
    ],
    [
        ProductFieldsEnum.powerToolsWheelDiameterUOM,
        {
            field: 'powerToolsWheelDiameterUOM',
        },
    ],
    [
        ProductFieldsEnum.powerToolsWheelThickness,
        {
            field: 'powerToolsWheelThickness',
        },
    ],
    [
        ProductFieldsEnum.powerToolsWheelThicknessUOM,
        {
            field: 'powerToolsWheelThicknessUOM',
        },
    ],
    [
        ProductFieldsEnum.consumerPackageUOM,
        {
            field: 'consumerPackageUOM',
            description: 'UOM',
        },
    ],
    [
        ProductFieldsEnum.palletInformationNumberofCases,
        {
            field: 'palletInformationNumberofCases',
            description: 'NUMBER_OF_CASES',
        },
    ],
    [
        ProductFieldsEnum.palletInformationNumberofRows,
        {
            field: 'palletInformationNumberofRows',
            description: 'NUMBER_OF_ROWS',
        },
    ],
    [
        ProductFieldsEnum.masterPackCaseUOM,
        {
            field: 'masterPackCaseUOM',
            description: 'UOM',
        },
    ],
    [
        ProductFieldsEnum.palletInformationUOM,
        {
            field: 'palletInformationUOM',
            description: 'UOM',
        },
    ],
    [
        ProductFieldsEnum.hasCSACertified,
        {
            field: 'hasCSACertified',
        },
    ],
    [
        ProductFieldsEnum.hasETLListed,
        {
            field: 'hasETLListed',
        },
    ],
    [
        ProductFieldsEnum.hasULListed,
        {
            field: 'hasULListed',
        },
    ],
    [
        ProductFieldsEnum.isOriginalManufacturerEquipment,
        {
            field: 'isOriginalManufacturerEquipment',
        },
    ],
    [
        ProductFieldsEnum.consumerPackageDepth,
        {
            field: 'consumerPackage.depth',
            type: Type.Object,
            description: 'DEPTH',
        },
    ],
    [
        ProductFieldsEnum.consumerPackageDepthUOM,
        {
            field: 'consumerPackage.depthUOM',
            type: Type.Object,
            description: 'DEPTH_UOM',
        },
    ],
    [
        ProductFieldsEnum.acidType,
        {
            field: 'acidType',
        },
    ],
    [
        ProductFieldsEnum.braidMaterial,
        {
            field: 'braidMaterial',
        },
    ],
    [
        ProductFieldsEnum.burstPressure,
        {
            field: 'burstPressure',
        },
    ],
    [
        ProductFieldsEnum.compoundType,
        {
            field: 'compoundType',
        },
    ],
    [
        ProductFieldsEnum.connectionMaterial,
        {
            field: 'connectionMaterial',
        },
    ],
    [
        ProductFieldsEnum.connectionSize,
        {
            field: 'connectionSizes',
            type: Type.Array,
            arrayObjectField: 'size',
        },
    ],
    [
        ProductFieldsEnum.connectionSizeUOM,
        {
            field: 'connectionSizes',
            type: Type.Array,
            arrayObjectField: 'sizeUOM'
        },
    ],
    [
        ProductFieldsEnum.flexibleHoseExteriorDiameterUOM,
        {
            field: 'flexibleHoseExteriorDiameterUOM',
        },
    ],
    [
        ProductFieldsEnum.flexibleHoseExteriorDiameter,
        {
            field: 'flexibleHoseExteriorDiameter',
        },
    ],
    [
        ProductFieldsEnum.flexibleHoseInteriorDiameterUOM,
        {
            field: 'flexibleHoseInteriorDiameterUOM',
        },
    ],
    [
        ProductFieldsEnum.flexibleHoseInteriorDiameter,
        {
            field: 'flexibleHoseInteriorDiameter',
        },
    ],
    [
        ProductFieldsEnum.maximumWorkingPressure,
        {
            field: 'maximumWorkingPressure',
        },
    ],
    [
        ProductFieldsEnum.tubingMaterial,
        {
            field: 'tubingMaterial',
        },
    ],
    [
        ProductFieldsEnum.airFilterCapacity,
        {
            field: 'airFilterCapacity',
        },
    ],
    [
        ProductFieldsEnum.airFilterEfficiency,
        {
            field: 'airFilterEfficiency',
        },
    ],
    [
        ProductFieldsEnum.airFilterHeaderType,
        {
            field: 'airFilterHeaderType',
        },
    ],
    [
        ProductFieldsEnum.airFilterLayerType,
        {
            field: 'airFilterLayerType',
        },
    ],
    [
        ProductFieldsEnum.airFilterPerformanceRating,
        {
            field: 'airFilterPerformanceRating',
        },
    ],
    [
        ProductFieldsEnum.airFilterStyle,
        {
            field: 'airFilterStyle',
        },
    ],
    [
        ProductFieldsEnum.airFilterType,
        {
            field: 'airFilterType',
        },
    ],
    [
        ProductFieldsEnum.filtersOut,
        {
            field: 'filtersOut',
        },
    ],
    [
        ProductFieldsEnum.airFiltersMaximumTemperature,
        {
            field: 'airFiltersMaximumTemperature',
        },
    ],
    [
        ProductFieldsEnum.nominalFilterSize,
        {
            field: 'nominalFilterSize',
        },
    ],
    [
        ProductFieldsEnum.removesParticlesDownTo,
        {
            field: 'removesParticlesDownTo',
        },
    ],
    [
        ProductFieldsEnum.airCleaningMethod,
        {
            field: 'airCleaningMethod',
        },
    ],
    [
        ProductFieldsEnum.airCleaningTechnology,
        {
            field: 'airCleaningTechnology',
        },
    ],
    [
        ProductFieldsEnum.hasAirQualitySensor,
        {
            field: 'hasAirQualitySensor',
        },
    ],
    [
        ProductFieldsEnum.bucketCapacity,
        {
            field: 'bucketCapacity',
        },
    ],
    [
        ProductFieldsEnum.bucketCapacityUOM,
        {
            field: 'bucketCapacityUOM',
        },
    ],
    [
        ProductFieldsEnum.dustCleanAirDeliveryRate,
        {
            field: 'dustCleanAirDeliveryRate',
        },
    ],
    [
        ProductFieldsEnum.pollenCleanAirDeliveryRate,
        {
            field: 'pollenCleanAirDeliveryRate',
        },
    ],
    [
        ProductFieldsEnum.smokeCleanAirDeliveryRate,
        {
            field: 'smokeCleanAirDeliveryRate',
        },
    ],
    [
        ProductFieldsEnum.dailyHumidificationCapacity,
        {
            field: 'dailyHumidificationCapacity',
        },
    ],
    [
        ProductFieldsEnum.dailyHumidificationCapacityUOM,
        {
            field: 'dailyHumidificationCapacityUOM',
        },
    ],
    [
        ProductFieldsEnum.dailyWaterRemovalCapacity,
        {
            field: 'dailyWaterRemovalCapacity',
        },
    ],
    [
        ProductFieldsEnum.dailyWaterRemovalCapacityUOM,
        {
            field: 'dailyWaterRemovalCapacityUOM',
        },
    ],
    [
        ProductFieldsEnum.dehumidificationMethod,
        {
            field: 'dehumidificationMethod',
        },
    ],
    [
        ProductFieldsEnum.drainPumpOptions,
        {
            field: 'drainPumpOptions',
        },
    ],
    [
        ProductFieldsEnum.drainHoseLength,
        {
            field: 'drainHoseLength',
        },
    ],
    [
        ProductFieldsEnum.drainHoseLengthUOM,
        {
            field: 'drainHoseLengthUOM',
        },
    ],
    [
        ProductFieldsEnum.hasFilterChangeReminder,
        {
            field: 'hasFilterChangeReminder',
        },
    ],
    [
        ProductFieldsEnum.filtersDownTo,
        {
            field: 'filtersDownTo',
        },
    ],
    [
        ProductFieldsEnum.filtersIncluded,
        {
            field: 'filtersIncluded',
        },
    ],
    [
        ProductFieldsEnum.hasHourMeter,
        {
            field: 'hasHourMeter',
        },
    ],
    [
        ProductFieldsEnum.humidificationMethod,
        {
            field: 'humidificationMethod',
        },
    ],
    [
        ProductFieldsEnum.humiditySettings,
        {
            field: 'humiditySettings',
        },
    ],
    [
        ProductFieldsEnum.hasDrainHose,
        {
            field: 'hasDrainHose',
        },
    ],
    [
        ProductFieldsEnum.hasIonization,
        {
            field: 'hasIonization',
        },
    ],
    [
        ProductFieldsEnum.hasWaterFillHose,
        {
            field: 'hasWaterFillHose',
        },
    ],
    [
        ProductFieldsEnum.hasWaterLevelFloat,
        {
            field: 'hasWaterLevelFloat',
        },
    ],
    [
        ProductFieldsEnum.hasIntegratedHumidistat,
        {
            field: 'hasIntegratedHumidistat',
        },
    ],
    [
        ProductFieldsEnum.ionOutput,
        {
            field: 'ionOutput',
        },
    ],
    [
        ProductFieldsEnum.maximumAirFlow,
        {
            field: 'maximumAirFlow',
        },
    ],
    [
        ProductFieldsEnum.maximumCoverageArea,
        {
            field: 'maximumCoverageArea',
        },
    ],
    [
        ProductFieldsEnum.maximumRuntime,
        {
            field: 'maximumRuntime',
        },
    ],
    [
        ProductFieldsEnum.numberofReservoirs,
        {
            field: 'numberofReservoirs',
        },
    ],
    [
        ProductFieldsEnum.numberofStages,
        {
            field: 'numberofStages',
        },
    ],
    [
        ProductFieldsEnum.hasOccupancySensor,
        {
            field: 'hasOccupancySensor',
        },
    ],
    [
        ProductFieldsEnum.hasPadWickChangeReminder,
        {
            field: 'hasPadWickChangeReminder',
        },
    ],
    [
        ProductFieldsEnum.reservoirCapacity,
        {
            field: 'reservoirCapacity',
        },
    ],
    [
        ProductFieldsEnum.reservoirCapacityUOM,
        {
            field: 'reservoirCapacityUOM',
        },
    ],
    [
        ProductFieldsEnum.hasReservoirFillReminder,
        {
            field: 'hasReservoirFillReminder',
        },
    ],
    [
        ProductFieldsEnum.reservoirType,
        {
            field: 'reservoirType',
        },
    ],
    [
        ProductFieldsEnum.airFlow,
        {
            field: 'airFlow',
        },
    ],
    [
        ProductFieldsEnum.airFlowDirection,
        {
            field: 'airFlowDirection',
        },
    ],
    [
        ProductFieldsEnum.annualFuelUtilizationEfficiency,
        {
            field: 'annualFuelUtilizationEfficiency',
        },
    ],
    [
        ProductFieldsEnum.availableCoolingTons,
        {
            field: 'availableCoolingTons',
        },
    ],
    [
        ProductFieldsEnum.compressorType,
        {
            field: 'compressorType',
        },
    ],
    [
        ProductFieldsEnum.coolingCapacity,
        {
            field: 'coolingCapacity',
        },
    ],
    [
        ProductFieldsEnum.coolingMethod,
        {
            field: 'coolingMethod',
        },
    ],
    [
        ProductFieldsEnum.dehumidificationRate,
        {
            field: 'dehumidificationRate',
        },
    ],
    [
        ProductFieldsEnum.electricalConduitSize,
        {
            field: 'electricalConduitSize',
        },
    ],
    [
        ProductFieldsEnum.exhaustAirFlow,
        {
            field: 'exhaustAirFlow',
        },
    ],
    [
        ProductFieldsEnum.heatingCapacity,
        {
            field: 'heatingCapacity',
        },
    ],
    [
        ProductFieldsEnum.heatingCapacityInput,
        {
            field: 'heatingCapacityInput',
        },
    ],
    [
        ProductFieldsEnum.heatingCapacityOutput,
        {
            field: 'heatingCapacityOutput',
        },
    ],
    [
        ProductFieldsEnum.heatingMethod,
        {
            field: 'heatingMethod',
        },
    ],
    [
        ProductFieldsEnum.liquidLineSize,
        {
            field: 'liquidLineSize',
        },
    ],
    [
        ProductFieldsEnum.liquidLineSizeUOM,
        {
            field: 'liquidLineSizeUOM',
        },
    ],
    [
        ProductFieldsEnum.liquidValveSize,
        {
            field: 'liquidValveSize',
        },
    ],
    [
        ProductFieldsEnum.liquidValveSizeUOM,
        {
            field: 'liquidValveSizeUOM',
        },
    ],
    [
        ProductFieldsEnum.maximumCoolingCapacity,
        {
            field: 'maximumCoolingCapacity',
        },
    ],
    [
        ProductFieldsEnum.maximumOvercurrentProtection,
        {
            field: 'maximumOvercurrentProtection',
        },
    ],
    [
        ProductFieldsEnum.maximumOverloadProtectionDevice,
        {
            field: 'maximumOverloadProtectionDevice',
        },
    ],
    [
        ProductFieldsEnum.minimumMaximumVolts,
        {
            field: 'minimumMaximumVolts',
        },
    ],
    [
        ProductFieldsEnum.minimumCircuitAmpacity,
        {
            field: 'minimumCircuitAmpacity',
        },
    ],
    [
        ProductFieldsEnum.minimumOverloadProtectionDevice,
        {
            field: 'minimumOverloadProtectionDevice',
        },
    ],
    [
        ProductFieldsEnum.nominalCapacity,
        {
            field: 'nominalCapacity',
        },
    ],
    [
        ProductFieldsEnum.nominalCoolingCapacity,
        {
            field: 'nominalCoolingCapacity',
        },
    ],
    [
        ProductFieldsEnum.suctionLineSize,
        {
            field: 'suctionLineSize',
        },
    ],
    [
        ProductFieldsEnum.suctionLineSizeUOM,
        {
            field: 'suctionLineSizeUOM',
        },
    ],
    [
        ProductFieldsEnum.suctionValveSize,
        {
            field: 'suctionValveSize',
        },
    ],
    [
        ProductFieldsEnum.suctionValveSizeUOM,
        {
            field: 'suctionValveSizeUOM',
        },
    ],
    [
        ProductFieldsEnum.supplyAirFlow,
        {
            field: 'supplyAirFlow',
        },
    ],
    [
        ProductFieldsEnum.valveConnectionType,
        {
            field: 'valveConnectionTypes',
            type: Type.Array,
            arrayObjectField: 'type'
        },
    ],
    [
        ProductFieldsEnum.voltagePhase,
        {
            field: 'voltagePhase',
        },
    ],
    [
        ProductFieldsEnum.backlitScreen,
        {
            field: 'backlitScreen',
        },
    ],
    [
        ProductFieldsEnum.backlitScreenColor,
        {
            field: 'backlitScreenColor',
        },
    ],
    [
        ProductFieldsEnum.screenBacklightType,
        {
            field: 'screenBacklightType',
        },
    ],
    [
        ProductFieldsEnum.batteryBackup,
        {
            field: 'batteryBackup',
        },
    ],
    [
        ProductFieldsEnum.compatibleSystemType,
        {
            field: 'compatibleSystemType',
        },
    ],
    [
        ProductFieldsEnum.displayType,
        {
            field: 'displayType',
        },
    ],
    [
        ProductFieldsEnum.electricalConnectionType,
        {
            field: 'electricalConnectionType',
        },
    ],
    [
        ProductFieldsEnum.hasIncludesBatteries,
        {
            field: 'hasIncludesBatteries',
        },
    ],
    [
        ProductFieldsEnum.hasKeypadLockout,
        {
            field: 'hasKeypadLockout',
        },
    ],
    [
        ProductFieldsEnum.maximumControlTemperature,
        {
            field: 'maximumControlTemperature',
        },
    ],
    [
        ProductFieldsEnum.minimumControlTemperature,
        {
            field: 'minimumControlTemperature',
        },
    ],
    [
        ProductFieldsEnum.numberofCoolingStages,
        {
            field: 'numberofCoolingStages',
        },
    ],
    [
        ProductFieldsEnum.numberofHeatingStages,
        {
            field: 'numberofHeatingStages',
        },
    ],
    [
        ProductFieldsEnum.programmingCapability,
        {
            field: 'programmingCapability',
        },
    ],
    [
        ProductFieldsEnum.switchAction,
        {
            field: 'switchAction',
        },
    ],
    [
        ProductFieldsEnum.thermostatSwitchType,
        {
            field: 'thermostatSwitchType',
        },
    ],
    [
        ProductFieldsEnum.systemSettings,
        {
            field: 'systemSettings',
        },
    ],
    [
        ProductFieldsEnum.temperatureDifferential,
        {
            field: 'temperatureDifferential',
        },
    ],
    [
        ProductFieldsEnum.temperatureDisplay,
        {
            field: 'temperatureDisplay',
        },
    ],
    [
        ProductFieldsEnum.temperatureScale,
        {
            field: 'temperatureScale',
        },
    ],
    [
        ProductFieldsEnum.temperatureSensitivity,
        {
            field: 'temperatureSensitivity',
        },
    ],
    [
        ProductFieldsEnum.temperatureSettingsPerDay,
        {
            field: 'temperatureSettingsPerDay',
        },
    ],
    [
        ProductFieldsEnum.hasTemporaryProgramOverride,
        {
            field: 'hasTemporaryProgramOverride',
        },
    ],
    [
        ProductFieldsEnum.thermostatApplication,
        {
            field: 'thermostatApplication',
        },
    ],
    [
        ProductFieldsEnum.thermostatControlType,
        {
            field: 'thermostatControlType',
        },
    ],
    [
        ProductFieldsEnum.thermostatType,
        {
            field: 'thermostatType',
        },
    ],
    [
        ProductFieldsEnum.boreDiameter,
        {
            field: 'boreDiameter',
        },
    ],
    [
        ProductFieldsEnum.boreDiameterUOM,
        {
            field: 'boreDiameterUOM',
        },
    ],
    [
        ProductFieldsEnum.maximumMotorPower,
        {
            field: 'maximumMotorPower',
        },
    ],
    [
        ProductFieldsEnum.fanBladesPropellersMaximumSpeed,
        {
            field: 'fanBladesPropellersMaximumSpeed',
        },
    ],
    [
        ProductFieldsEnum.minimumMotorPower,
        {
            field: 'minimumMotorPower',
        },
    ],
    [
        ProductFieldsEnum.numberofSetScrews,
        {
            field: 'numberofSetScrews',
        },
    ],
    [
        ProductFieldsEnum.pitch,
        {
            field: 'pitch',
        },
    ],
    [
        ProductFieldsEnum.propellerDiameter,
        {
            field: 'propellerDiameter',
        },
    ],
    [
        ProductFieldsEnum.propellerDiameterUOM,
        {
            field: 'propellerDiameterUOM',
        },
    ],
    [
        ProductFieldsEnum.requiredMotorPower,
        {
            field: 'requiredMotorPower',
        },
    ],
    [
        ProductFieldsEnum.rotation,
        {
            field: 'rotation',
        },
    ],
    [
        ProductFieldsEnum.coefficientofPerformance,
        {
            field: 'coefficientofPerformance',
        },
    ],
    [
        ProductFieldsEnum.combinedEnergyEfficiencyRatio,
        {
            field: 'combinedEnergyEfficiencyRatio',
        },
    ],
    [
        ProductFieldsEnum.energyEfficiencyRatio,
        {
            field: 'energyEfficiencyRatio',
        },
    ],
    [
        ProductFieldsEnum.hvacAirflow,
        {
            field: 'hvacAirflow',
        },
    ],
    [
        ProductFieldsEnum.hvacApplication,
        {
            field: 'hvacApplication',
        },
    ],
    [
        ProductFieldsEnum.hasHVACAutoRestart,
        {
            field: 'hasHVACAutoRestart',
        },
    ],
    [
        ProductFieldsEnum.hasHVACAutoShutOff,
        {
            field: 'hasHVACAutoShutOff',
        },
    ],
    [
        ProductFieldsEnum.hvacBladeDiameter,
        {
            field: 'hvacBladeDiameter',
        },
    ],
    [
        ProductFieldsEnum.hvacBladeDiameterUOM,
        {
            field: 'hvacBladeDiameterUOM',
        },
    ],
    [
        ProductFieldsEnum.hvacBladeMaterial,
        {
            field: 'hvacBladeMaterial',
        },
    ],
    [
        ProductFieldsEnum.hasHVACBluetoothCompatible,
        {
            field: 'hasHVACBluetoothCompatible',
        },
    ],
    [
        ProductFieldsEnum.hvacComplianceStandards,
        {
            field: 'hvacComplianceStandards',
        },
    ],
    [
        ProductFieldsEnum.hvacControlFeatures,
        {
            field: 'hvacControlFeatures',
        },
    ],
    [
        ProductFieldsEnum.hasHVACControlLock,
        {
            field: 'hasHVACControlLock',
        },
    ],
    [
        ProductFieldsEnum.hvacControlType,
        {
            field: 'hvacControlType',
        },
    ],
    [
        ProductFieldsEnum.hvacCurrent,
        {
            field: 'hvacCurrent',
        },
    ],
    [
        ProductFieldsEnum.hvacDefrostType,
        {
            field: 'hvacDefrostType',
        },
    ],
    [
        ProductFieldsEnum.hasHVACEnergyStarCertified,
        {
            field: 'hasHVACEnergyStarCertified',
        },
    ],
    [
        ProductFieldsEnum.hvacEnergyStarRating,
        {
            field: 'hvacEnergyStarRating',
        },
    ],
    [
        ProductFieldsEnum.hvacEquipmentType,
        {
            field: 'hvacEquipmentType',
        },
    ],
    [
        ProductFieldsEnum.hvacFrequency,
        {
            field: 'hvacFrequency',
        },
    ],
    [
        ProductFieldsEnum.hvacFuelType,
        {
            field: 'hvacFuelType',
        },
    ],
    [
        ProductFieldsEnum.hvacFunction,
        {
            field: 'hvacFunction',
        },
    ],
    [
        ProductFieldsEnum.hvacMaximumFanSpeed,
        {
            field: 'hvacMaximumFanSpeed',
        },
    ],
    [
        ProductFieldsEnum.hvacMotorHorsepower,
        {
            field: 'hvacMotorHorsepower',
        },
    ],
    [
        ProductFieldsEnum.hvacMotorSpeed,
        {
            field: 'hvacMotorSpeed',
        },
    ],
    [
        ProductFieldsEnum.hvacMountType,
        {
            field: 'hvacMountType',
        },
    ],
    [
        ProductFieldsEnum.hvacMountingLocation,
        {
            field: 'hvacMountingLocation',
        },
    ],
    [
        ProductFieldsEnum.hvacMountingOrientation,
        {
            field: 'hvacMountingOrientation',
        },
    ],
    [
        ProductFieldsEnum.hvacNEMAPlugConfiguration,
        {
            field: 'hvacnemaPlugConfiguration',
        },
    ],
    [
        ProductFieldsEnum.hvacNEMAPlugRating,
        {
            field: 'hvacnemaPlugRating',
        },
    ],
    [
        ProductFieldsEnum.hvacNoiseLevel,
        {
            field: 'hvacNoiseLevel',
        },
    ],
    [
        ProductFieldsEnum.hvacNoiseLevelUOM,
        {
            field: 'hvacNoiseLevelUOM',
        },
    ],
    [
        ProductFieldsEnum.hvacNumberofBlades,
        {
            field: 'hvacNumberofBlades',
        },
    ],
    [
        ProductFieldsEnum.hvacNumberofCasters,
        {
            field: 'hvacNumberofCasters',
        },
    ],
    [
        ProductFieldsEnum.hvacNumberofSpeeds,
        {
            field: 'hvacNumberofSpeeds',
        },
    ],
    [
        ProductFieldsEnum.hvacOperatingMode,
        {
            field: 'hvacOperatingMode',
        },
    ],
    [
        ProductFieldsEnum.hvacOperatingTemperatureRange,
        {
            field: 'hvacOperatingTemperatureRange',
        },
    ],
    [
        ProductFieldsEnum.hvacPhase,
        {
            field: 'hvacPhase',
        },
    ],
    [
        ProductFieldsEnum.hvacPowerConsumption,
        {
            field: 'hvacPowerConsumption',
        },
    ],
    [
        ProductFieldsEnum.hvacPowerCordLength,
        {
            field: 'hvacPowerCordLength',
        },
    ],
    [
        ProductFieldsEnum.hvacPowerCordLengthUOM,
        {
            field: 'hvacPowerCordLengthUOM',
        },
    ],
    [
        ProductFieldsEnum.hvacProgrammingCapability,
        {
            field: 'hvacProgrammingCapability',
        },
    ],
    [
        ProductFieldsEnum.hvacRefrigerantCharge,
        {
            field: 'hvacRefrigerantCharge',
        },
    ],
    [
        ProductFieldsEnum.hvacRefrigerantType,
        {
            field: 'hvacRefrigerantType',
        },
    ],
    [
        ProductFieldsEnum.hvacRemoteControlFunctions,
        {
            field: 'hvacRemoteControlFunctions',
        },
    ],
    [
        ProductFieldsEnum.hvacSmartConnectivity,
        {
            field: 'hvacSmartConnectivity',
        },
    ],
    [
        ProductFieldsEnum.hvacSystemType,
        {
            field: 'hvacSystemType',
        },
    ],
    [
        ProductFieldsEnum.hvacVoltage,
        {
            field: 'hvacVoltage',
        },
    ],
    [
        ProductFieldsEnum.hvacWaterSupply,
        {
            field: 'hvacWaterSupply',
        },
    ],
    [
        ProductFieldsEnum.hvacWattage,
        {
            field: 'hvacWattage',
        },
    ],
    [
        ProductFieldsEnum.hasHVACWiFiCompatible,
        {
            field: 'hasHVACWiFiCompatible',
        },
    ],
    [
        ProductFieldsEnum.maximumVelocity,
        {
            field: 'maximumVelocity',
        },
    ],
    [
        ProductFieldsEnum.motorDutyClass,
        {
            field: 'motorDutyClass',
        },
    ],
    [
        ProductFieldsEnum.motorEnclosure,
        {
            field: 'motorEnclosure',
        },
    ],
    [
        ProductFieldsEnum.motorFrameDesignation,
        {
            field: 'motorFrameDesignation',
        },
    ],
    [
        ProductFieldsEnum.motorInsulation,
        {
            field: 'motorInsulation',
        },
    ],
    [
        ProductFieldsEnum.hvacMotorLocation,
        {
            field: 'hvacMotorLocation',
        },
    ],
    [
        ProductFieldsEnum.hvacMotorType,
        {
            field: 'hvacMotorType',
        },
    ],
    [
        ProductFieldsEnum.nameplateVoltage,
        {
            field: 'nameplateVoltage',
        },
    ],
    [
        ProductFieldsEnum.seasonalEnergyEfficiencyRatio,
        {
            field: 'seasonalEnergyEfficiencyRatio',
        },
    ],
    [
        ProductFieldsEnum.actuator,
        {
            field: 'actuator',
        },
    ],
    [
        ProductFieldsEnum.airType,
        {
            field: 'airType',
        },
    ],
    [
        ProductFieldsEnum.bearingType,
        {
            field: 'bearingType',
        },
    ],
    [
        ProductFieldsEnum.damperDiameter,
        {
            field: 'damperDiameter',
        },
    ],
    [
        ProductFieldsEnum.damperDiameterUOM,
        {
            field: 'damperDiameterUOM',
        },
    ],
    [
        ProductFieldsEnum.dischargeDirection,
        {
            field: 'dischargeDirection',
        },
    ],
    [
        ProductFieldsEnum.driveType,
        {
            field: 'driveType',
        },
    ],
    [
        ProductFieldsEnum.ductDiameter,
        {
            field: 'ductDiameter',
        },
    ],
    [
        ProductFieldsEnum.ductDiameterUOM,
        {
            field: 'ductDiameterUOM',
        },
    ],
    [
        ProductFieldsEnum.ductFittingDiameter,
        {
            field: 'ductFittingDiameter',
        },
    ],
    [
        ProductFieldsEnum.ductFittingDiameterUOM,
        {
            field: 'ductFittingDiameterUOM',
        },
    ],
    [
        ProductFieldsEnum.ductFittingLength,
        {
            field: 'ductFittingLength',
        },
    ],
    [
        ProductFieldsEnum.ductFittingLengthUOM,
        {
            field: 'ductFittingLengthUOM',
        },
    ],
    [
        ProductFieldsEnum.ductFittingMaterial,
        {
            field: 'ductFittingMaterial',
        },
    ],
    [
        ProductFieldsEnum.ductFittingType,
        {
            field: 'ductFittingType',
        },
    ],
    [
        ProductFieldsEnum.ductGauge,
        {
            field: 'ductGauge',
        },
    ],
    [
        ProductFieldsEnum.ductInsulationType,
        {
            field: 'ductInsulationType',
        },
    ],
    [
        ProductFieldsEnum.energyRecoveryWheel,
        {
            field: 'energyRecoveryWheel',
        },
    ],
    [
        ProductFieldsEnum.flangeWidth,
        {
            field: 'flangeWidth',
        },
    ],
    [
        ProductFieldsEnum.flangeWidthUOM,
        {
            field: 'flangeWidthUOM',
        },
    ],
    [
        ProductFieldsEnum.fullLoadCurrent,
        {
            field: 'fullLoadCurrent',
        },
    ],
    [
        ProductFieldsEnum.fullLoadWattage,
        {
            field: 'fullLoadWattage',
        },
    ],
    [
        ProductFieldsEnum.grilleMaterial,
        {
            field: 'grilleMaterial',
        },
    ],
    [
        ProductFieldsEnum.hasHighEfficiencyMotor,
        {
            field: 'hasHighEfficiencyMotor',
        },
    ],
    [
        ProductFieldsEnum.louverType,
        {
            field: 'louverType',
        },
    ],
    [
        ProductFieldsEnum.maximumAmbientTemperature,
        {
            field: 'maximumAmbientTemperature',
        },
    ],
    [
        ProductFieldsEnum.maximumExhaustAirflow,
        {
            field: 'maximumExhaustAirflow',
        },
    ],
    [
        ProductFieldsEnum.maximumInletAirTemperature,
        {
            field: 'maximumInletAirTemperature',
        },
    ],
    [
        ProductFieldsEnum.maximumStaticPressure,
        {
            field: 'maximumStaticPressure',
        },
    ],
    [
        ProductFieldsEnum.maximumVentPipeDiameter,
        {
            field: 'maximumVentPipeDiameter',
        },
    ],
    [
        ProductFieldsEnum.maximumVentPipeDiameterUOM,
        {
            field: 'maximumVentPipeDiameterUOM',
        },
    ],
    [
        ProductFieldsEnum.minimumVentPipeDiameter,
        {
            field: 'minimumVentPipeDiameter',
        },
    ],
    [
        ProductFieldsEnum.minimumVentPipeDiameterUOM,
        {
            field: 'minimumVentPipeDiameterUOM',
        },
    ],
    [
        ProductFieldsEnum.portLocation,
        {
            field: 'portLocation',
        },
    ],
    [
        ProductFieldsEnum.pressureDifferentialMaximum,
        {
            field: 'pressureDifferentialMaximum',
        },
    ],
    [
        ProductFieldsEnum.sparkResistantConstructionType,
        {
            field: 'sparkResistantConstructionType',
        },
    ],
    [
        ProductFieldsEnum.ventilationType,
        {
            field: 'ventilationType',
        },
    ],
    [
        ProductFieldsEnum.wheelMaterial,
        {
            field: 'wheelMaterial',
        },
    ],
    [
        ProductFieldsEnum.wheelType,
        {
            field: 'wheelType',
        },
    ],
    [
        ProductFieldsEnum.freightClassCode,
        {
            field: 'freightClassCode',
        },
    ],
    [
        ProductFieldsEnum.warningLabel,
        {
            field: 'warningLabels',
            type: Type.Array,
            arrayObjectField: 'label'
        },
    ],
    [
        ProductFieldsEnum.warningLabelDescription,
        {
            field: 'warningLabels',
            type: Type.Array,
            arrayObjectField: 'description'
        },
    ],
    [
        ProductFieldsEnum.suggestedHierarchy,
        {
            field: 'suggestedCategoryKey'
        }
    ],
    [
        ProductFieldsEnum.buildingMaterialsApplication,
        {
            field: 'buildingMaterialsApplication'
        }
    ],
    [
        ProductFieldsEnum.coverageArea,
        {
            field: 'coverageArea'
        }
    ],
    [
        ProductFieldsEnum.coverageAreaUOM,
        {
            field: 'coverageAreaUOM'
        }
    ],
    [
        ProductFieldsEnum.mil,
        {
            field: 'mil'
        }
    ],
    [
        ProductFieldsEnum.legDimensions,
        {
            field: 'legDimensions'
        }
    ],
    [
        ProductFieldsEnum.flangeThickness,
        {
            field: 'flangeThickness'
        }
    ],
    [
        ProductFieldsEnum.flangeThicknessUOM,
        {
            field: 'flangeThicknessUOM'
        }
    ],
    [
        ProductFieldsEnum.buildingMaterialsFlangeWidth,
        {
            field: 'buildingMaterialsFlangeWidth',
        },
    ],
    [
        ProductFieldsEnum.buildingMaterialsFlangeWidthUOM,
        {
            field: 'buildingMaterialsFlangeWidthUOM',
        },
    ],
    [
        ProductFieldsEnum.rValue,
        {
            field: 'rValue'
        }
    ],
    [
        ProductFieldsEnum.shelfLife,
        {
            field: 'shelfLife'
        }
    ],
    [
        ProductFieldsEnum.shelfLifeUOM,
        {
            field: 'shelfLifeUOM'
        }
    ],
    [
        ProductFieldsEnum.storageInformation,
        {
            field: 'storageInformation'
        }
    ],
    [
        ProductFieldsEnum.edgeType,
        {
            field: 'edgeType'
        }
    ],
    [
        ProductFieldsEnum.fireResistant,
        {
            field: 'fireResistant'
        }
    ],
    [
        ProductFieldsEnum.fireRating,
        {
            field: 'fireRating'
        }
    ],
    [
        ProductFieldsEnum.includedItems,
        {
            field: 'includedItems'
        }
    ],
    [
        ProductFieldsEnum.dryColour,
        {
            field: 'dryColour'
        }
    ],
    [
        ProductFieldsEnum.recycledContent,
        {
            field: 'recycledContent'
        }
    ],
    [
        ProductFieldsEnum.minimumEmbedment,
        {
            field: 'minimumEmbedment'
        }
    ],
    [
        ProductFieldsEnum.minimumEmbedmentUOM,
        {
            field: 'minimumEmbedmentUOM'
        }
    ],
    [
        ProductFieldsEnum.pullMaximum,
        {
            field: 'pullMaximum'
        }
    ],
    [
        ProductFieldsEnum.pullMaximumUOM,
        {
            field: 'pullMaximumUOM'
        }
    ],
    [
        ProductFieldsEnum.shearMaximum,
        {
            field: 'shearMaximum'
        }
    ],
    [
        ProductFieldsEnum.shearMaximumUOM,
        {
            field: 'shearMaximumUOM'
        }
    ],
    [
        ProductFieldsEnum.collated,
        {
            field: 'collated'
        }
    ],
    [
        ProductFieldsEnum.collationMaterial,
        {
            field: 'collationMaterial'
        }
    ],
    [
        ProductFieldsEnum.topShape,
        {
            field: 'topShape'
        }
    ],
    [
        ProductFieldsEnum.windResistance,
        {
            field: 'windResistance'
        }
    ],
    [
        ProductFieldsEnum.loadCapacity,
        {
            field: 'loadCapacity'
        }
    ],
    [
        ProductFieldsEnum.loadCapacityUOM,
        {
            field: 'loadCapacityUOM'
        }
    ],
    [
        ProductFieldsEnum.safeWorkingLoad,
        {
            field: 'safeWorkingLoad'
        }
    ],
    [
        ProductFieldsEnum.safeWorkingLoadUOM,
        {
            field: 'safeWorkingLoadUOM'
        }
    ],
    [
        ProductFieldsEnum.strength,
        {
            field: 'strength'
        }
    ],
    [
        ProductFieldsEnum.strengthUOM,
        {
            field: 'strengthUOM'
        }
    ],
    [
        ProductFieldsEnum.topShape,
        {
            field: 'topShape'
        }
    ],
    [
        ProductFieldsEnum.windResistance,
        {
            field: 'windResistance'
        }
    ],
    [
        ProductFieldsEnum.loadCapacity,
        {
            field: 'loadCapacity'
        }
    ],
    [
        ProductFieldsEnum.loadCapacityUOM,
        {
            field: 'loadCapacityUOM'
        }
    ],
    [
        ProductFieldsEnum.safeWorkingLoad,
        {
            field: 'safeWorkingLoad'
        }
    ],
    [
        ProductFieldsEnum.safeWorkingLoadUOM,
        {
            field: 'safeWorkingLoadUOM'
        }
    ],
    [
        ProductFieldsEnum.strength,
        {
            field: 'strength'
        }
    ],
    [
        ProductFieldsEnum.strength,
        {
            field: 'strength'
        }
    ],
    [
        ProductFieldsEnum.strengthUOM,
        {
            field: 'strengthUOM'
        }
    ],
    [
        ProductFieldsEnum.fastenerShankType,
        {
            field: 'fastenerShankType'
        }
    ],
    [
        ProductFieldsEnum.vocRating,
        {
            field: 'vocRating'
        }
    ],
    [
        ProductFieldsEnum.vocContent,
        {
            field: 'vocContent'
        }
    ],
    [
        ProductFieldsEnum.buildingMaterialsInstallationType,
        {
            field: 'buildingMaterialsInstallationType'
        }
    ],
    [
        ProductFieldsEnum.buildingMaterialsWattage,
        {
            field: 'buildingMaterialsWattage'
        }
    ],
    [
        ProductFieldsEnum.pressureTreatedType,
        {
            field: 'pressureTreatedType'
        }
    ],
    [
        ProductFieldsEnum.replacementProductId,
        {
            field: 'replacementProductId'
        }
    ],
    [
        ProductFieldsEnum.replacementProductDescription,
        {
            field: 'replacementProductDescription'
        }
    ],
    [
        ProductFieldsEnum.colorFamily,
        {
            field: 'colorFamily'
        }
    ],
    [
        ProductFieldsEnum.exposureDurability,
        {
            field: 'exposureDurability'
        }
    ],
    [
        ProductFieldsEnum.modelNumber,
        {
            field: 'modelNumber'
        }
    ],
    [
        ProductFieldsEnum.outboundHierarchy,
        {
            field: 'outboundHierarchy',
        },
    ],
    [
        ProductFieldsEnum.ratingLabel,
        {
            field: 'ratingLabels',
            type: Type.Array,
            arrayObjectField: 'label'
        },
    ],
    [
        ProductFieldsEnum.ratingLabelDescription,
        {
            field: 'ratingLabels',
            type: Type.Array,
            arrayObjectField: 'description'
        },
    ],
    [
        ProductFieldsEnum.breakingStrength,
        {
            field: 'breakingStrength',
        },
    ],
    [
        ProductFieldsEnum.workingLoadLimit,
        {
            field: 'workingLoadLimit',
        },
    ],
    [
        ProductFieldsEnum.minimumTemperature,
        {
            field: 'minimumTemperature',
        },
    ],
    [
        ProductFieldsEnum.recommendedTemperature,
        {
            field: 'recommendedTemperature',
        },
    ],
    [
        ProductFieldsEnum.recommendedWorkingPressure,
        {
            field: 'recommendedWorkingPressure',
        },
    ]
]);
function getFieldValue(object, path) {
    const obj = Object.assign({}, object);
    const pList = path.split('.');
    const key = pList.pop();
    const pointer = pList.reduce((accumulator, currentValue) => {
        return accumulator[currentValue];
    }, obj);
    if (!pointer && key) {
        return;
    }
    else {
        return pointer[key];
    }
}
const ɵ0 = (key) => {
    const productField = ProductFieldEnumMap.get(Number(key));
    return productField && productField.type;
};
const transformableFields = Object.keys(ProductFieldsEnum).filter(ɵ0);
function transformProduct(product) {
    const newProduct = transformableFields.reduce((newProd, fieldKey) => {
        const fieldKeyInt = Number(fieldKey);
        if (ProductFieldEnumMap.get(fieldKeyInt)) {
            const fieldData = ProductFieldEnumMap.get(fieldKeyInt);
            const value = fieldData.field.match(/\./)
                ? getFieldValue(product, fieldData.field)
                : product[fieldData.field];
            if (fieldData.type === Type.Array) {
                return Object.assign(Object.assign({}, newProd), { [ProductFieldsEnum[fieldKey]]: value
                        ? value.filter((x) => getFieldValue(x, fieldData.arrayObjectField))
                            .length
                        : 0 });
            }
            else {
                return Object.assign(Object.assign({}, newProd), { [ProductFieldsEnum[fieldKey]]: value });
            }
        }
        else {
            return Object.assign({}, newProd);
        }
    }, {});
    return Object.assign(Object.assign({}, product), newProduct);
}

class ApprovedProductsService {
    constructor(baseAPISrv, pimSrv, http) {
        this.baseAPISrv = baseAPISrv;
        this.pimSrv = pimSrv;
        this.http = http;
    }
    setApprovedProductsFilters(filters) {
        this.pimSrv.setFilters(filters);
    }
    getApprovedProductsFilters() {
        return this.pimSrv.getFilters();
    }
    getApprovedProducts(request) {
        this.baseAPISrv.set(this.pimSrv.getConfig().getApprovedProductsEndpoint);
        return this.baseAPISrv.get(request).pipe();
    }
    searchApprovedProducts(request) {
        this.baseAPISrv.set(this.pimSrv.getConfig().searchApprovedProductsEndpoint);
        return this.baseAPISrv.post(request).pipe();
    }
    deleteProducts(request) {
        this.baseAPISrv.set(this.pimSrv.getConfig().getProductDetailsEndpoint);
        return this.baseAPISrv.deleteMany(request).pipe();
    }
    export(request) {
        const url = urlJoin(this.pimSrv.getConfig().uriProduct.baseUri, 'product/export');
        return this.http.post(url, request, { withCredentials: true });
    }
    exportMinimal(request) {
        const url = urlJoin(this.pimSrv.getConfig().uriProduct.baseUri, 'product/export-minimal');
        return this.http.post(url, request, { withCredentials: true });
    }
    deleteProductsBySearch(request) {
        return this.http.request('delete', urlJoin(this.pimSrv.getConfig().getProductDetailsEndpoint, 'search'), { body: request, withCredentials: true });
    }
    getAssetThumbnail(supplierKey, fileName) {
        return of({
            dataUrl: urlJoin(this.pimSrv.getConfig().assetsEndPoint, supplierKey, fileName),
            isAvailable: true,
        });
    }
    updateProducts(updateProductsRequest) {
        this.baseAPISrv.set(this.pimSrv.getConfig().updateProductsEndpoint);
        const req = Object.assign(Object.assign({}, updateProductsRequest), { productInfo: this.convertToNull(updateProductsRequest.productInfo) });
        return this.baseAPISrv.post(req).pipe();
    }
    convertToNull(obj) {
        return Object.entries(obj).reduce((nulledObject, [key, value]) => (Object.assign(Object.assign({}, nulledObject), { [key]: value === '' ? null : value })), {});
    }
}
ApprovedProductsService.ɵprov = ɵɵdefineInjectable({ factory: function ApprovedProductsService_Factory() { return new ApprovedProductsService(ɵɵinject(BaseAPIService), ɵɵinject(PimService), ɵɵinject(HttpClient)); }, token: ApprovedProductsService, providedIn: "root" });
ApprovedProductsService.decorators = [
    { type: Injectable, args: [{
                providedIn: 'root',
            },] }
];
ApprovedProductsService.ctorParameters = () => [
    { type: BaseAPIService },
    { type: PimService },
    { type: HttpClient }
];

class CategoryHierarchy$1 {
    constructor(categoryKey, parentCategoryKey, categoryName, fullHierarchy, children = []) {
        this.categoryKey = categoryKey;
        this.parentCategoryKey = parentCategoryKey;
        this.categoryName = categoryName;
        this.fullHierarchy = fullHierarchy;
        this.children = children;
    }
}
class GetHierarchyService {
    constructor(baseAPISrv, pimSrv) {
        this.baseAPISrv = baseAPISrv;
        this.pimSrv = pimSrv;
    }
    getAllHierarchy() {
        const url = this.pimSrv.getConfig().uriProduct.baseUri + '/product/hierarchy';
        this.baseAPISrv.set(url);
        return this.baseAPISrv.get().pipe();
    }
    getAllHierarchyLabels() {
        return this.getAllHierarchy().pipe(map((it) => treeFoldAll(it.records, {}, (node, acc) => (Object.assign(Object.assign({}, acc), { [node.categoryKey]: node.fullHierarchy })))));
    }
    getFieldHierarchy(key) {
        const url = this.pimSrv.getConfig().uriProduct.baseUri + '/product/hierarchy/' + key;
        this.baseAPISrv.set(url);
        return this.baseAPISrv.get()
            .pipe(map(deduplicate));
    }
}
GetHierarchyService.ɵprov = ɵɵdefineInjectable({ factory: function GetHierarchyService_Factory() { return new GetHierarchyService(ɵɵinject(BaseAPIService), ɵɵinject(PimService)); }, token: GetHierarchyService, providedIn: "root" });
GetHierarchyService.decorators = [
    { type: Injectable, args: [{
                providedIn: 'root',
            },] }
];
GetHierarchyService.ctorParameters = () => [
    { type: BaseAPIService },
    { type: PimService }
];
function treeFoldAll(roots, initial, fold) {
    if (roots.length === 0) {
        return initial;
    }
    let foldedValue = initial;
    roots.forEach(node => {
        foldedValue = fold(node, foldedValue);
        if (node.children) {
            foldedValue = treeFoldAll(node.children, foldedValue, fold);
        }
    });
    return foldedValue;
}
function deduplicate(response) {
    const values = new Map();
    const hierarchies = response.record.hierarchies;
    for (const key in hierarchies) {
        if (hierarchies.hasOwnProperty(key)) {
            const list = hierarchies[key];
            for (const item of list) {
                if (!values.has(item.path)) {
                    values.set(item.path, item);
                }
            }
        }
    }
    return [...values.values()];
}

const createDateRangeValidator = (startDateKey, endDateKey) => {
    return (form) => {
        const start = form.get(startDateKey).value;
        const end = form.get(endDateKey).value;
        if (start && end && end.getTime() - start.getTime() <= 0) {
            return { dateRange: true };
        }
        return null;
    };
};
const ɵ0$1 = createDateRangeValidator;

class ApprovedProductsComponent {
    constructor(approvedProductsSrv, translocoSrv, router, route, formBuilder, datepipe, store, changeDetector, spinnerService, toastSrv, pimAPISrv, hierarchySrv) {
        this.approvedProductsSrv = approvedProductsSrv;
        this.translocoSrv = translocoSrv;
        this.router = router;
        this.route = route;
        this.formBuilder = formBuilder;
        this.datepipe = datepipe;
        this.store = store;
        this.changeDetector = changeDetector;
        this.spinnerService = spinnerService;
        this.toastSrv = toastSrv;
        this.pimAPISrv = pimAPISrv;
        this.hierarchySrv = hierarchySrv;
        this.showFilter = false;
        this.subscriptions = [];
        this.name = of('');
        this.dateType = { format: '', description: '', primeNgFormat: '' };
        this.approvedProducts = of([]);
        this.selectedColumns = [];
        this.buttons$ = this.translocoSrv
            .selectTranslate('ACTIONS')
            .pipe(withLatestFrom(this.route.data), map(([translate, data]) => [
            {
                name: 'new',
                label: translate.NEW,
                mode: 0 /* ALWAYS */,
                disabled: data.isPdx || !this.authorizedActions.new,
            },
            {
                name: 'delete',
                label: translate.DELETE,
                mode: 0 /* ALWAYS */,
                disabled: (data.isPdx && !this.authorizedActions.deletePdx) || (!data.isPdx && !this.authorizedActions.delete)
            },
            {
                name: 'export',
                label: translate.EXPORT,
                mode: 0 /* ALWAYS */,
                disabled: (data.isPdx && !this.authorizedActions.exportPdx) || (!data.isPdx && !this.authorizedActions.export),
            },
            {
                name: 'showOnline',
                label: translate.SHOW_ONLINE,
                mode: 0 /* ALWAYS */,
                disabled: ((data.isPdx && !this.authorizedActions.showOnlinePdx) || (!data.isPdx && !this.authorizedActions.showOnline))
                    || !this.fields.find((field) => !!field.fieldName.match(/showOnline/) && field.isIncluded),
                parent: 'more',
            },
        ].filter((f) => !f.disabled)));
        this.isLoading = false;
        this.rows = 25;
        this.first = 0;
        this.categories = [];
        this.facetFields = [];
        this.isPageLoading = true;
        this.facetEnum = Facets;
        this.facetsToDisplay = [];
        this.selectedProductIDs = [];
        this.authorizedActions = {};
        this.deleteFormGroup = this.formBuilder.group({
            selectedProduct: new FormControl('', [Validators.required]),
        });
        this.exportFormGroup = this.formBuilder.group({
            selectedExport: new FormControl('', [Validators.required]),
            selectedFormat: new FormControl('', [Validators.required]),
            selectedDataType: new FormControl('', [Validators.required]),
            filename: new FormControl('', [
                Validators.required,
                Validators.maxLength(100),
            ]),
            email: new FormControl('', [
                Validators.required,
                Validators.email,
                Validators.maxLength(100),
            ]),
            confirmEmail: new FormControl('', [
                Validators.required,
                Validators.email,
            ]),
        }, {
            validators: (form) => {
                return form.get('email').value !== form.get('confirmEmail').value
                    ? {
                        emailMismatch: true,
                    }
                    : null;
            }
        });
        this.showOnlineFormGroup = this.formBuilder.group({
            selected: new FormControl('', [Validators.required]),
            startDate: new FormControl(''),
            endDate: new FormControl(''),
        }, {
            validators: [createDateRangeValidator('startDate', 'endDate')],
        });
        this.previousSearchTerm = '';
    }
    redirectFilters(filters) {
        this.approvedProductsSrv.setApprovedProductsFilters(filters);
    }
    getColumnHeader(field, categories) {
        const categoryName = categories[field.categoryKey];
        const fieldName = field.description;
        return `${categoryName}\n${fieldName}`;
    }
    getImageThumbnail({ primaryImage, }) {
        if (primaryImage === null || primaryImage === void 0 ? void 0 : primaryImage.isAvailable) {
            return Object.assign(Object.assign({}, primaryImage), { dataUrl: primaryImage.dataUrl + '?size=small' });
        }
        return null;
    }
    mapFieldToColumn(categories, primaryImageTranslation) {
        return (field) => {
            if (field.fieldKey === ProductFieldsEnum.sku ||
                field.fieldKey === ProductFieldsEnum.description) {
                return {
                    field: field.fieldName,
                    header: this.getColumnHeader(field, categories),
                    link: ({ id }) => ({ path: `./${id}` }),
                    required: true,
                };
            }
            else if (field.fieldKey === ProductFieldsEnum.primaryImageFilename) {
                return {
                    field: field.fieldName,
                    header: `${categories[field.categoryKey]}\n${primaryImageTranslation}`,
                    imgSrc: this.getImageThumbnail,
                    imgClass: 'product-thumbnail',
                };
            }
            else {
                return {
                    field: field.fieldName,
                    header: this.getColumnHeader(field, categories),
                };
            }
        };
    }
    cancel() {
        this.showDeleteMessage = false;
        this.showInfoMessage = false;
        this.showOnlineMessage = false;
    }
    ngOnInit() {
        this.changeDetector.detectChanges();
        this.subscriptions.push(this.route.data.subscribe((data) => {
            this.isPdx = data.isPdx;
        }));
        this.name = this.route.data.pipe(switchMap((data) => data.isPdx
            ? this.translocoSrv.selectTranslate('PIM.PDX.VIEW_PRODUCTS_TITLE')
            : this.translocoSrv.selectTranslate('PIM.APPROVED_PRODUCTS_TITLE')));
        this.setUp();
        this.selectedColumns = ['sku', 'description'];
        this.paging = {
            sizes: [25, 50, 75, 100],
            page: { first: 0, rows: 25 },
            records: 250,
        };
        this.subscriptions.push(this.route.queryParams.subscribe((params) => {
            if (params !== null && params !== undefined && params['filters']) {
                this.paramFilters = JSON.parse(params.filters, (k, v) => {
                    let d = v;
                    if (typeof v === 'string' &&
                        v.match(/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}/)) {
                        d = new Date(v);
                    }
                    return d;
                });
            }
        }));
        this.subscriptions.push(this.store
            .pipe(select(selectors.userProfile), tap((user) => {
            this.personalEmail = user.sub;
            this.dateType = {
                format: user.userInfo.DateTypeFormat,
                description: user.userInfo.DateTypeDescription,
                primeNgFormat: user.userInfo.PrimeNGDateTypeFormat,
            };
        }))
            .subscribe());
        this.exportFormGroup.controls['email'].setValue(this.personalEmail);
        this.exportFormGroup.controls['confirmEmail'].setValue(this.personalEmail);
    }
    ngOnDestroy() {
        if (this.subscriptions) {
            this.subscriptions.forEach((subscription) => subscription.unsubscribe());
        }
    }
    deleteProducts() {
        var _a;
        const deleteRequest = new DeleteProductRequest();
        if (this.deleteFormGroup.get('selectedProduct').value ===
            ExportSelectionType.AllPages) {
            const searchRequest = new SearchProductsRequest();
            searchRequest.SearchWord = (_a = this.searchText) !== null && _a !== void 0 ? _a : '';
            searchRequest.Filters = this.filters;
            searchRequest.isApproved = true;
            this.subscriptions.push(this.approvedProductsSrv
                .deleteProductsBySearch(searchRequest)
                .subscribe((res) => {
                this.toastSrv.successNotify(this.translocoSrv.translate('PIM.PRODUCT_DELETE_SUCCESS'), null, 5000);
                this.showDeleteMessage = false;
                this.deleteFormGroup.reset();
                this.clearSelection();
                this.approvedProducts = of([]);
            }, (err) => {
                this.toastSrv.errorNotify(this.translocoSrv.translate('PIM.PRODUCT_DELETE_FAILURE'), null, 5000);
            }));
        }
        else {
            if (this.deleteFormGroup.get('selectedProduct').value ===
                ExportSelectionType.CurrentPage) {
                deleteRequest.ids = this.currentPageProductIDs;
            }
            else if (this.deleteFormGroup.get('selectedProduct').value ===
                ExportSelectionType.SelectedItems) {
                deleteRequest.ids = this.selectedProductIDs;
            }
            this.subscriptions.push(this.pimAPISrv.deleteProducts(deleteRequest).subscribe((res) => {
                this.toastSrv.successNotify(this.translocoSrv.translate('PIM.PRODUCT_DELETE_SUCCESS'), null, 5000);
                this.showDeleteMessage = false;
                this.deleteFormGroup.reset();
                this.clearSelection();
            }, (err) => {
                this.toastSrv.errorNotify(this.translocoSrv.translate('PIM.PRODUCT_DELETE_FAILURE'), null, 5000);
            }));
        }
    }
    exportProducts() {
        this.exportFormGroup.markAllAsTouched();
        if (this.exportFormGroup.valid) {
            this.showInfoMessage = false;
        }
        const exportReq = {
            dataType: this.exportFormGroup.get('selectedDataType').value,
            selectionType: this.exportFormGroup.get('selectedExport').value,
            format: this.exportFormGroup.get('selectedFormat').value,
            fileName: this.exportFormGroup.get('filename').value,
            email: this.exportFormGroup.get('email').value,
            pageSize: this.rows,
            filters: this.filters,
            searchWord: this.searchText,
            skip: this.first,
            sort: this.sort,
            selectedProductIDs: this.selectedProductIDs
        };
        const obs = this.isPdx
            ? this.approvedProductsSrv.exportMinimal(exportReq)
            : this.approvedProductsSrv.export(exportReq);
        this.subscriptions.push(obs.subscribe());
    }
    setUp() {
        this.spinnerService.on();
        this.subscriptions.push(forkJoin([
            this.store
                .select(selectors.categories)
                .pipe(first((c) => Object.keys(c).length !== 0)),
            this.store.select(selectors.sortedFields).pipe(map((fields) => Object.values(fields).map((f) => f)), first((fields) => fields.length !== 0), tap((f) => {
                this.facetsToDisplay = f.filter((field) => field.isIncluded && !field.isHidden && Facets[field.fieldName]);
                this.facetsToDisplay.push(f.filter((field) => field.fieldKey === ProductFieldsEnum.completionPercent)[0]);
            }), map((f) => {
                return f.filter((field) => field.isIncluded && !field.isHidden);
            })),
            this.store.select(selectors.userProfile).pipe(first()),
            this.store
                .select(selectors.isAuthorized, this.getButtonPermissions())
                .pipe(first()),
            this.translocoSrv
                .selectTranslate('PIM.PRODUCT_DETAILS_PRIMARYIMAGE')
                .pipe(first()),
            this.hierarchySrv.getAllHierarchyLabels()
        ])
            .pipe(finalize(() => this.spinnerService.off()), tap(([_categories, fields, user, authorizedActions, _, hierarchyLabels]) => {
            this.dateFormat = {
                format: user.userInfo.DateTypeFormat,
                primeNgFormat: user.userInfo.PrimeNGDateTypeFormat,
                description: user.userInfo.DateTypeDescription,
            };
            this.timeFormat = {
                format: user.userInfo.TimeFormat,
                description: user.userInfo.TimeTypeDescription,
            };
            this.timeZoneCode = user.userInfo.TimeZoneCode;
            this.timeZoneCodeIANA = user.userInfo.IANATimeZoneCode;
            this.fields = fields;
            this.authorizedActions = authorizedActions;
            this.facetFields = this.facetsToDisplay
                .map((x) => x.fieldName)
                .filter((f) => {
                const field = Facets[f];
                return (field !== Facets.dateAdded &&
                    field !== Facets.dateLastChanged &&
                    field !== Facets.discontinueDate &&
                    field !== Facets.startShipDate &&
                    field !== Facets.endShipDate &&
                    field !== Facets.consumerDate &&
                    field !== Facets.msrp &&
                    field !== Facets.listPrice &&
                    field !== Facets.completionPercent &&
                    field !== Facets.showOnlineStartDate &&
                    field !== Facets.showOnlineEndDate);
            });
            this.hierarchyLabels = hierarchyLabels;
        }), map(([categories, fields, _user, _permissions, primaryImageTranslation,]) => {
            return fields.map(this.mapFieldToColumn(categories, primaryImageTranslation));
        }))
            .subscribe((columns) => {
            this.columns = columns;
        }));
    }
    getButtonPermissions() {
        return {
            new: toolKeys.PIM_PRODUCTS_APPROVED_PRODUCTS_NEW,
            delete: toolKeys.PIM_PRODUCTS_APPROVED_PRODUCTS_DELETE,
            deletePdx: toolKeys.PDX_PRODUCTS_VIEW_PRODUCTS_DELETE,
            export: toolKeys.PIM_PRODUCTS_APPROVED_PRODUCTS_EXPORT,
            exportPdx: toolKeys.PDX_PRODUCTS_VIEW_PRODUCTS_EXPORT,
            showOnline: toolKeys.PIM_PRODUCTS_APPROVED_PRODUCTS_SHOW_ONLINE,
            showOnlinePdx: toolKeys.PDX_PRODUCTS_VIEW_PRODUCTS_SHOW_ONLINE,
        };
    }
    search(request) {
        this.isLoading = true;
        this.approvedProducts = forkJoin([
            this.pimAPISrv.searchApprovedProducts(request),
            this.store
                .select(selectors.users)
                .pipe(first((u) => Object.keys(u).length > 0)),
        ]).pipe(map(([productDetails, users]) => {
            this.paging = Object.assign(Object.assign({}, this.paging), { records: productDetails.paging.totalRecords });
            const { facets } = productDetails;
            this.facets = Object.assign(Object.assign({}, facets), { productImage: [
                    {
                        totalRows: 1,
                        key: 'productImage',
                        childBuckets: null,
                        label: 'No Primary Image',
                        value: 'primaryImageFileName',
                    },
                    {
                        totalRows: 1,
                        key: 'productImage',
                        childBuckets: null,
                        label: 'No Secondary Image',
                        value: 'secondaryImageFileName',
                    },
                ] });
            return productDetails.products.map((product) => {
                const p = transformProduct(product);
                return this.formatProduct(p, users);
            });
        }), tap((products) => {
            this.currentPageProductIDs = products.map((p) => p.id);
        }), switchMap((products) => {
            if (products.length === 0) {
                return of([]);
            }
            else {
                const imgs$ = products.map((p) => {
                    if (p.primaryImageFilename) {
                        return this.approvedProductsSrv
                            .getAssetThumbnail(p.supplierKey, p.primaryImageFilename)
                            .pipe(map((img) => {
                            return Object.assign(Object.assign({}, p), { primaryImage: img });
                        }));
                    }
                    else {
                        return of(Object.assign(Object.assign({}, p), { primaryImage: null }));
                    }
                });
                return forkJoin(imgs$);
            }
        }), finalize(() => (this.isLoading = false)));
    }
    searchApprovedProducts($event) {
        this.rows = $event.rows;
        this.first = $event.first;
        this.searchText = $event.filters.searchText;
        const _a = $event.filters, { searchText } = _a, filters = __rest(_a, ["searchText"]);
        this.sort = { field: $event.sortField, order: $event.sortOrder };
        this.search(this.buildSearchRequest(this.searchText, $event.rows, this.first, this.facetFields, filters, this.sort));
    }
    getPagedApprovedProducts($event) {
        this.searchText = $event.filters.searchText;
        const _a = $event.filters, { searchText } = _a, filters = __rest(_a, ["searchText"]);
        this.rows = $event.rows;
        this.first = $event.first;
        this.sort = { field: $event.sortField, order: $event.sortOrder };
        this.search(this.buildSearchRequest(this.searchText, $event.rows, this.first, this.facetFields, filters, this.sort));
    }
    clear() {
        this.search(this.buildSearchRequest('', this.rows, 0, this.facetFields, this.filters, this.sort));
    }
    formatProduct(product, users) {
        var _a;
        if (product.dateAdded != null) {
            product.dateAdded = this.datepipe.transform(utcToZonedTime(product.dateAdded, this.timeZoneCodeIANA), this.dateFormat.format + ' ' + this.timeFormat.format);
        }
        if (product.dateLastChanged != null) {
            product.dateLastChanged = this.datepipe.transform(utcToZonedTime(product.dateLastChanged, this.timeZoneCodeIANA), this.dateFormat.format + ' ' + this.timeFormat.format);
        }
        if (product.showOnlineStartDate != null) {
            product.showOnlineStartDate = this.datepipe.transform(utcToZonedTime(product.showOnlineStartDate, this.timeZoneCodeIANA), this.dateFormat.format);
        }
        if (product.showOnlineEndDate != null) {
            product.showOnlineEndDate = this.datepipe.transform(utcToZonedTime(product.showOnlineEndDate, this.timeZoneCodeIANA), this.dateFormat.format);
        }
        product.endShipDate = this.datepipe.transform(product.endShipDate, this.dateFormat.format);
        product.consumerDate = this.datepipe.transform(product.consumerDate, this.dateFormat.format);
        product.availableDate = this.datepipe.transform(product.availableDate, this.dateFormat.format);
        product.startShipDate = this.datepipe.transform(product.startShipDate, this.dateFormat.format);
        product.discontinueDate = this.datepipe.transform(product.discontinueDate, this.dateFormat.format);
        product.addedBy = users[product.addedBy]
            ? users[product.addedBy].fullname
            : null;
        product.modifiedBy = users[product.modifiedBy]
            ? users[product.modifiedBy].fullname
            : null;
        product.suggestedHierarchy = product.suggestedCategoryKey != null && product.suggestedCategoryKey > 0
            ? (_a = this.hierarchyLabels) === null || _a === void 0 ? void 0 : _a[product.suggestedCategoryKey] : this.translocoSrv.translate('PIM.PRODUCT_SUGGESTED_HIERARCHY_UNSPECIFIED');
        return product;
    }
    buildSearchRequest(searchText, pageSize, skip, facets, filters, sort) {
        const request = new SearchProductsRequest();
        request.PageSize = pageSize;
        request.Skip = skip;
        request.SearchWord = searchText === undefined ? '' : searchText;
        request.FacetList = facets;
        request.Sort = searchText === this.previousSearchTerm ? sort : {};
        request.isApproved = true;
        request.Filters = filters;
        this.filters = filters;
        this.previousSearchTerm = searchText;
        return request;
    }
    onToolbarClick({ command, selection, clearSelection }) {
        this.selectedProductIDs = selection.map((x) => x.id);
        switch (command) {
            case 'new':
                this.router.navigate(['./new'], {
                    relativeTo: this.route,
                });
                break;
            case 'export':
                // TODO : Find a way to disable Selected Products option using primeNG controls
                this.productsToExport = [
                    {
                        label: this.translocoSrv.translate('EXPORT_TYPES.SELECTED_ITEMS'),
                        value: ExportSelectionType.SelectedItems,
                        disabled: this.selectedProductIDs.length === 0,
                    },
                    {
                        label: this.translocoSrv.translate('EXPORT_TYPES.CURRENT_PAGE'),
                        value: ExportSelectionType.CurrentPage,
                    },
                    {
                        label: this.translocoSrv.translate('EXPORT_TYPES.ALL_PAGES'),
                        value: ExportSelectionType.AllPages,
                    },
                ].filter((option) => !option.disabled);
                this.formats = [
                    {
                        label: this.translocoSrv.translate('FILE_FORMATS.EXCEL'),
                        value: ExportFormatTypes.Excel,
                    },
                    {
                        label: this.translocoSrv.translate('FILE_FORMATS.XML'),
                        value: ExportFormatTypes.XML,
                    },
                    {
                        label: this.translocoSrv.translate('FILE_FORMATS.JSON'),
                        value: ExportFormatTypes.JSON,
                    },
                ];
                this.dataTypes = [
                    {
                        label: this.translocoSrv.translate('PIM.DATATYPE_DATA'),
                        value: ExportDataTypes.Data,
                    },
                    {
                        label: this.translocoSrv.translate('PIM.DATATYPE_ASSETS'),
                        value: ExportDataTypes.Assets,
                        disabled: this.isPdx,
                    },
                    {
                        label: this.translocoSrv.translate('PIM.DATATYPE_BOTH'),
                        value: ExportDataTypes.DataAndAssets,
                        disabled: this.isPdx,
                    },
                ].filter((option) => !option.disabled);
                if (this.dataTypes.length === 1) {
                    const selectedDataType = this.exportFormGroup.controls.selectedDataType;
                    selectedDataType.setValue(this.dataTypes[0].value);
                    selectedDataType.disable();
                }
                this.showInfoMessage = true;
                break;
            case 'delete':
                this.productsToDelete = [
                    {
                        label: this.translocoSrv.translate('EXPORT_TYPES.CURRENT_PAGE'),
                        value: ExportSelectionType.CurrentPage,
                    },
                    {
                        label: this.translocoSrv.translate('EXPORT_TYPES.ALL_PAGES'),
                        value: ExportSelectionType.AllPages,
                    },
                ];
                if (this.selectedProductIDs.length !== 0) {
                    this.productsToDelete.unshift({
                        label: this.translocoSrv.translate('EXPORT_TYPES.SELECTED_ITEMS'),
                        value: ExportSelectionType.SelectedItems,
                    });
                }
                this.showDeleteMessage = true;
                this.clearSelection = clearSelection;
                break;
            case 'showOnline':
                if (this.selectedProductIDs.length === 0) {
                    this.showOnlineProducts = [
                        {
                            label: this.translocoSrv.translate('EXPORT_TYPES.CURRENT_PAGE'),
                            value: ExportSelectionType.CurrentPage,
                        },
                        {
                            label: this.translocoSrv.translate('EXPORT_TYPES.ALL_PAGES'),
                            value: ExportSelectionType.AllPages,
                        },
                    ];
                }
                else {
                    this.showOnlineProducts = [
                        {
                            label: this.translocoSrv.translate('EXPORT_TYPES.SELECTED_ITEMS'),
                            value: ExportSelectionType.SelectedItems,
                        },
                        {
                            label: this.translocoSrv.translate('EXPORT_TYPES.CURRENT_PAGE'),
                            value: ExportSelectionType.CurrentPage,
                        },
                        {
                            label: this.translocoSrv.translate('EXPORT_TYPES.ALL_PAGES'),
                            value: ExportSelectionType.AllPages,
                        },
                    ];
                }
                this.showOnlineMessage = true;
                break;
            default:
                break;
        }
    }
    updateShowOnline() {
        this.showOnlineFormGroup.markAllAsTouched();
        if (this.showOnlineFormGroup.valid) {
            this.showOnlineMessage = false;
        }
        const request = {
            selectionType: this.showOnlineFormGroup.get('selected').value,
            pageSize: this.rows,
            filters: this.filters,
            searchWord: this.searchText,
            skipPage: this.first,
            sort: this.sort,
            productIds: this.selectedProductIDs,
            productInfo: {
                showOnlineStartDate: this.showOnlineFormGroup.get('startDate').value,
                showOnlineEndDate: this.showOnlineFormGroup.get('endDate').value,
            },
            facet: this.facetFields,
        };
        const req = Object.assign(Object.assign({}, request), { productInfo: this.convertToNull(request.productInfo) });
        this.subscriptions.push(this.pimAPISrv.updateProducts(req).subscribe((res) => {
            this.toastSrv.successNotify(this.translocoSrv.translate('PIM.SHOW_ONLINE.TOAST_SUCCESS'), null, 5000);
        }, (err) => {
            this.toastSrv.errorNotify(this.translocoSrv.translate('PIM.SHOW_ONLINE.TOAST_ERROR'), null, 5000);
        }));
        this.showOnlineFormGroup.reset();
    }
    convertToNull(obj) {
        return Object.entries(obj).reduce((nulledObject, [key, value]) => (Object.assign(Object.assign({}, nulledObject), { [key]: value === '' ? null : value })), {});
    }
}
ApprovedProductsComponent.decorators = [
    { type: Component, args: [{
                selector: 'lib-approved-products',
                template: "<div class=\"vertical-flow space-between-175\">\r\n  <h2>{{ name | async }}</h2>\r\n  <lib-search-container\r\n    *ngIf=\"columns && columns.length !== 0\"\r\n    i18nSearchField=\"{{ 'PIM.APPROVED_PRODUCTS_SUBTITLE' | transloco }}\"\r\n    idColumn=\"id\"\r\n    name=\"approvedProductSearch\"\r\n    [columns]=\"columns\"\r\n    [columnsToDisplay]=\"selectedColumns\"\r\n    [results]=\"approvedProducts\"\r\n    [lazy]=\"true\"\r\n    [loading]=\"isLoading\"\r\n    (clear)=\"clear()\"\r\n    [buttons]=\"buttons$ | async\"\r\n    (query)=\"searchApprovedProducts($event)\"\r\n    searchProperty=\"searchText\"\r\n    (toolbar)=\"onToolbarClick($event)\"\r\n    [paging]=\"paging\"\r\n    (lazyLoad)=\"getPagedApprovedProducts($event)\"\r\n    [lazyLoadOnInit]=\"false\"\r\n  >\r\n    <lib-advanced-search\r\n      libSearch\r\n      [facetData]=\"facets\"\r\n      [facetsToDisplay]=\"facetsToDisplay\"\r\n      [dateType]=\"dateFormat\"\r\n      [timeType]=\"timeFormat\"\r\n      [paramFilters]=\"paramFilters\"\r\n      [timeZoneCode]=\"timeZoneCode\"\r\n      (emitFilters)=\"redirectFilters($event)\"\r\n    >\r\n    </lib-advanced-search>\r\n  </lib-search-container>\r\n\r\n  <p-dialog\r\n    [(visible)]=\"showDeleteMessage\"\r\n    [modal]=\"true\"\r\n    [style]=\"{ width: '520px' }\"\r\n    [showHeader]=\"false\"\r\n    [baseZIndex]=\"10000\"\r\n    [draggable]=\"false\"\r\n    [resizable]=\"false\"\r\n    [closable]=\"false\"\r\n    position=\"center\"\r\n    [focusOnShow]=\"false\"\r\n  >\r\n    <form [formGroup]=\"deleteFormGroup\" (ngSubmit)=\"deleteProducts()\">\r\n      <div class=\"vertical-flow space-between-025 approved-product-export\">\r\n        <h2 class=\"center\">{{ 'PIM.DELETE_PRODUCTS_TITLE' | transloco }}</h2>\r\n        <div class=\"vertical-flow space-before-050\">\r\n          <label>Select Products to Delete</label>\r\n          <div>\r\n            <p-dropdown\r\n              [options]=\"productsToDelete\"\r\n              formControlName=\"selectedProduct\"\r\n              autoWidth=\"false\"\r\n              placeholder=\"{{ 'ACTIONS.SELECT' | transloco }}\"\r\n            ></p-dropdown>\r\n            <span class=\"feedback\">\r\n              <lib-control-message [control]=\"deleteFormGroup.get('selectedProduct')\"></lib-control-message>\r\n            </span>\r\n          </div>\r\n        </div>\r\n        <div class=\"horizontal-flow form-controls space-between-050 space-before-200\">\r\n          <button pButton type=\"button\" class=\"ds secondary\" label=\"{{ 'ACTIONS.CANCEL' | transloco }}\" (click)=\"cancel()\"></button>\r\n          <button\r\n            pButton\r\n            type=\"button\"\r\n            label=\"{{ 'ACTIONS.SUBMIT' | transloco }}\"\r\n            [disabled]=\"!deleteFormGroup.valid\"\r\n            class=\"ds primary\"\r\n            type=\"submit\"\r\n          ></button>\r\n        </div>\r\n      </div>\r\n    </form>\r\n  </p-dialog>\r\n\r\n  <p-dialog\r\n    [(visible)]=\"showInfoMessage\"\r\n    [modal]=\"true\"\r\n    [style]=\"{ width: '520px' }\"\r\n    [showHeader]=\"false\"\r\n    [baseZIndex]=\"10000\"\r\n    [draggable]=\"false\"\r\n    [resizable]=\"false\"\r\n    [closable]=\"false\"\r\n    position=\"center\"\r\n    [focusOnShow]=\"false\"\r\n  >\r\n    <form [formGroup]=\"exportFormGroup\" (ngSubmit)=\"exportProducts()\">\r\n      <div class=\"vertical-flow space-between-025 approved-product-export\">\r\n        <h2 class=\"center\">{{ 'PIM.EXPORT_PRODUCT_DATA' | transloco }}</h2>\r\n        <div class=\"vertical-flow space-before-050\">\r\n          <label>{{ 'PIM.PRODUCTS_TO_EXPORT' | transloco }}</label>\r\n          <div>\r\n            <p-dropdown\r\n              [options]=\"productsToExport\"\r\n              formControlName=\"selectedExport\"\r\n              autoWidth=\"false\"\r\n              placeholder=\"{{ 'ACTIONS.SELECT' | transloco }}\"\r\n            >\r\n            </p-dropdown>\r\n            <span class=\"feedback\">\r\n              <lib-control-message [control]=\"exportFormGroup.get('selectedExport')\"></lib-control-message>\r\n            </span>\r\n          </div>\r\n        </div>\r\n        <div class=\"vertical-flow space-between-025\">\r\n          <label>{{ 'COMMON.FORMAT' | transloco }}</label>\r\n          <div>\r\n            <p-dropdown\r\n              [options]=\"formats\"\r\n              formControlName=\"selectedFormat\"\r\n              autoWidth=\"false\"\r\n              placeholder=\"{{ 'ACTIONS.SELECT' | transloco }}\"\r\n            >\r\n            </p-dropdown>\r\n          </div>\r\n          <span class=\"feedback\"><lib-control-message [control]=\"exportFormGroup.get('selectedFormat')\"></lib-control-message></span>\r\n        </div>\r\n        <div class=\"vertical-flow space-between-025\">\r\n          <label>{{ 'PIM.TYPE_OF_DATA' | transloco }}</label>\r\n          <div>\r\n            <p-dropdown\r\n              [options]=\"dataTypes\"\r\n              formControlName=\"selectedDataType\"\r\n              autoWidth=\"false\"\r\n              placeholder=\"{{ 'ACTIONS.SELECT' | transloco }}\"\r\n            >\r\n            </p-dropdown>\r\n          </div>\r\n          <span class=\"feedback\"> <lib-control-message [control]=\"exportFormGroup.get('selectedDataType')\"></lib-control-message></span>\r\n        </div>\r\n        <div class=\"vertical-flow space-between-025\">\r\n          <label>{{ 'PIM.EXPORT_DATA_FILE_NAME' | transloco }}</label>\r\n          <div>\r\n            <input pInputText class=\"ui-inputtext\" type=\"text\" pInputText formControlName=\"filename\" />\r\n          </div>\r\n          <span class=\"feedback\"><lib-control-message [control]=\"exportFormGroup.get('filename')\"></lib-control-message></span>\r\n        </div>\r\n        <div class=\"vertical-flow space-between-025\">\r\n          <label>{{ 'COMMON.EMAIL_ADDRESS' | transloco }}</label>\r\n          <div>\r\n            <input pInputText class=\"ui-inputtext\" type=\"text\" formControlName=\"email\" />\r\n          </div>\r\n          <span class=\"feedback\"><lib-control-message [control]=\"exportFormGroup.get('email')\"></lib-control-message></span>\r\n        </div>\r\n        <div class=\"vertical-flow space-between-025\">\r\n          <label>{{ 'COMMON.EMAIL_CONFIRM' | transloco }}</label>\r\n          <div>\r\n            <input pInputText class=\"ui-inputtext\" type=\"text\" formControlName=\"confirmEmail\" />\r\n          </div>\r\n          <span class=\"export-feedback error\" *ngIf=\"this.exportFormGroup.getError('emailMismatch')\">{{ 'COMMON.EMAIL_ERROR' | transloco }}</span>\r\n          <span class=\"feedback\"><lib-control-message [control]=\"exportFormGroup.get('confirmEmail')\"></lib-control-message></span>\r\n        </div>\r\n        <div class=\"horizontal-flow form-controls space-between-050 space-before-200\">\r\n          <button pButton type=\"button\" class=\"ds secondary\" label=\"  {{ 'ACTIONS.CANCEL' | transloco }}\" (click)=\"cancel()\"></button>\r\n          <button\r\n            pButton\r\n            type=\"button\"\r\n            label=\"{{ 'ACTIONS.SUBMIT' | transloco }}\"\r\n            [disabled]=\"!exportFormGroup.valid\"\r\n            class=\"ds primary\"\r\n            type=\"submit\"\r\n          ></button>\r\n        </div>\r\n      </div>\r\n    </form>\r\n  </p-dialog>\r\n\r\n  <p-dialog\r\n    [(visible)]=\"showOnlineMessage\"\r\n    [modal]=\"true\"\r\n    [style]=\"{ width: '520px' }\"\r\n    [showHeader]=\"false\"\r\n    [baseZIndex]=\"10000\"\r\n    [draggable]=\"false\"\r\n    [resizable]=\"false\"\r\n    [closable]=\"false\"\r\n    position=\"center\"\r\n    [focusOnShow]=\"false\"\r\n  >\r\n    <form [formGroup]=\"showOnlineFormGroup\" (ngSubmit)=\"updateShowOnline()\">\r\n      <div class=\"vertical-flow space-between-025 approved-product-export\">\r\n        <h2 class=\"center\">{{ 'PIM.SHOW_ONLINE.TITLE' | transloco }}</h2>\r\n        <div class=\"vertical-flow space-before-050 space-between-075\">\r\n          <label>{{ 'PIM.SHOW_ONLINE.SELECT' | transloco }}</label>\r\n          <div>\r\n            <p-dropdown\r\n              [options]=\"showOnlineProducts\"\r\n              formControlName=\"selected\"\r\n              autoWidth=\"false\"\r\n              placeholder=\"{{ 'ACTIONS.SELECT' | transloco }}\"\r\n            >\r\n            </p-dropdown>\r\n            <span class=\"feedback\">\r\n              <lib-control-message [control]=\"showOnlineFormGroup.get('selected')\"></lib-control-message>\r\n            </span>\r\n          </div>\r\n        </div>\r\n        <div class=\"vertical-flow space-between-075\">\r\n          <label>{{ 'PIM.SHOW_ONLINE.START_DATE' | transloco }}</label>\r\n          <p-calendar\r\n            [dateFormat]=\"dateType.primeNgFormat\"\r\n            [placeholder]=\"dateType.description\"\r\n            [showIcon]=\"true\"\r\n            formControlName=\"startDate\"\r\n          ></p-calendar>\r\n          <span class=\"feedback\">\r\n            <lib-control-message [control]=\"showOnlineFormGroup.get('startDate')\"></lib-control-message>\r\n          </span>\r\n        </div>\r\n        <div class=\"vertical-flow space-between-075\">\r\n          <label>{{ 'PIM.SHOW_ONLINE.END_DATE' | transloco }}</label>\r\n          <p-calendar\r\n            [dateFormat]=\"dateType.primeNgFormat\"\r\n            [placeholder]=\"dateType.description\"\r\n            [showIcon]=\"true\"\r\n            formControlName=\"endDate\"\r\n          ></p-calendar>\r\n          <span class=\"feedback\">\r\n            <lib-control-message [control]=\"showOnlineFormGroup.get('endDate')\"></lib-control-message>\r\n            <span class=\"export-feedback error\" *ngIf=\"this.showOnlineFormGroup.getError('dateRange')\">{{ 'PIM.SHOW_ONLINE.DATE_RANGE_ERROR' | transloco }}</span>\r\n          </span>\r\n        </div>\r\n        <div class=\"horizontal-flow form-controls space-between-050 space-before-250\" style=\"margin-bottom: 10em\">\r\n          <button pButton type=\"button\" class=\"ds secondary\" label=\"{{ 'ACTIONS.CANCEL' | transloco }}\" (click)=\"cancel()\"></button>\r\n          <button\r\n            pButton\r\n            type=\"button\"\r\n            label=\"{{ 'ACTIONS.SAVE' | transloco }}\"\r\n            [disabled]=\"!showOnlineFormGroup.valid\"\r\n            class=\"ds primary\"\r\n            type=\"submit\"\r\n          ></button>\r\n        </div>\r\n      </div>\r\n    </form>\r\n  </p-dialog>\r\n</div>\r\n",
                styles: [""]
            },] }
];
ApprovedProductsComponent.ctorParameters = () => [
    { type: ApprovedProductsService },
    { type: TranslocoService },
    { type: Router },
    { type: ActivatedRoute },
    { type: FormBuilder },
    { type: DatePipe },
    { type: Store },
    { type: ChangeDetectorRef },
    { type: SpinnerService },
    { type: ToastrNotificationService },
    { type: PimAPIService },
    { type: GetHierarchyService }
];

const toTreeNodes = (selectProp, filter) => (state) => {
    const nodes = [];
    for (const [categoryKey, category] of state) {
        const children = [];
        for (const field of category.fields) {
            if (filter(field)) {
                children.push({ data: field });
            }
        }
        children.sort((a, b) => sortFields(a.data, b.data));
        if (children.length !== 0) {
            nodes.push({
                data: { categoryKey, categoryName: category.categoryName },
                expanded: category.expanded,
                children,
                partialSelected: children.findIndex(f => f.data[selectProp]) !== -1
            });
        }
    }
    return nodes;
};
const ɵ0$2 = toTreeNodes;
const toFieldsState = ([categoriesObj, fieldsObj]) => {
    const configurableFields = Object.values(fieldsObj).filter((f) => !(f.isHidden || f.isReadOnly));
    const stateMap = new Map();
    for (const field of configurableFields) {
        if (!stateMap.has(field.categoryKey)) {
            const category = {
                categoryKey: field.categoryKey,
                categoryName: categoriesObj[field.categoryKey],
                expanded: false,
                fields: [Object.assign({}, field)]
            };
            stateMap.set(category.categoryKey, category);
        }
        else {
            stateMap.get(field.categoryKey).fields.push(Object.assign({}, field));
        }
    }
    return stateMap;
};
const ɵ1 = toFieldsState;
class ConfigFieldService {
    constructor(store, pimSrv) {
        this.store = store;
        this.pimSrv = pimSrv;
        this.subscriptions = [];
        this.fieldState = new BehaviorSubject(new Map());
        this.includeTreeNodes$ = this.fieldState.pipe(map(toTreeNodes('isIncluded', f => !f.isRequired)));
        this.recommendedTreeNodes$ = this.fieldState.pipe(map(toTreeNodes('isRecommended', f => !f.isRequired && f.isIncluded)));
        this.excludedTreeNodes$ = this.fieldState.pipe(map(toTreeNodes('isExcludedFromUpdates', f => f.isIncluded)));
    }
    init() {
        this.subscriptions.push(combineLatest([
            this.store.pipe(select(selectors.categories)),
            this.store.pipe(select(selectors.productFields)),
        ])
            .pipe(map(toFieldsState), tap((state) => (this.fieldState.next(state)))).subscribe());
    }
    ngOnDestroy() {
        if (this.subscriptions) {
            this.subscriptions.forEach((subscription) => subscription.unsubscribe());
        }
    }
    selectAll(config) {
        const state = this.fieldState.getValue();
        for (const category of state.values()) {
            for (const f of category.fields) {
                if (config.isIncluded !== undefined) {
                    f.isIncluded = config.isIncluded;
                }
                if (config.isRecommended !== undefined) {
                    f.isRecommended = config.isRecommended;
                }
            }
        }
        this.fieldState.next(state);
    }
    selectNode(node, config) {
        const state = this.fieldState.getValue();
        const category = state.get(node.data.categoryKey);
        if (node.parent === null) {
            for (const f of node.children) {
                const i = category.fields.findIndex(e => e.fieldKey === f.data.fieldKey);
                category.fields[i] = Object.assign(Object.assign({}, f.data), config);
            }
        }
        else {
            const idx = category.fields.findIndex(f => f.fieldKey === node.data.fieldKey);
            const field = category.fields[idx];
            category.fields.splice(idx, 1, Object.assign(Object.assign({}, field), config));
        }
        this.fieldState.next(state);
    }
    toggleNode(node) {
        const state = this.fieldState.getValue();
        state.get(node.data.categoryKey).expanded = node.expanded;
        this.fieldState.next(state);
    }
    submit() {
        const updatedFields = {};
        for (const category of this.fieldState.getValue().values()) {
            for (const field of category.fields) {
                updatedFields[field.fieldKey] = Object.assign({}, field);
            }
        }
        this.store.dispatch(actions.updateProductFields({
            productFields: updatedFields,
            endPoints: this.pimSrv.getConfig().uriProduct
        }));
    }
    selectedNodes(nodes, field) {
        return nodes.reduce((acc, node) => {
            const selected = node.children.filter(c => c.data[field]);
            if (selected.length === node.children.length) {
                acc.push(node);
            }
            acc.push(...selected);
            return acc;
        }, []);
    }
}
ConfigFieldService.ɵprov = ɵɵdefineInjectable({ factory: function ConfigFieldService_Factory() { return new ConfigFieldService(ɵɵinject(Store), ɵɵinject(PimService)); }, token: ConfigFieldService, providedIn: "root" });
ConfigFieldService.decorators = [
    { type: Injectable, args: [{
                providedIn: 'root',
            },] }
];
ConfigFieldService.ctorParameters = () => [
    { type: Store },
    { type: PimService }
];

class ConfigProductFieldsComponent {
    constructor(configSrv, store) {
        this.configSrv = configSrv;
        this.store = store;
        this.selectedIncludedNodes = [];
        this.selectedRecommendedNodes = [];
        this.includedNodes$ = this.configSrv.includeTreeNodes$.pipe(tap((nodes) => {
            this.selectedIncludedNodes = this.configSrv.selectedNodes(nodes, 'isIncluded');
        }));
        this.recommendedNodes$ = this.configSrv.recommendedTreeNodes$.pipe(tap(nodes => {
            this.selectedRecommendedNodes = this.configSrv.selectedNodes(nodes, 'isRecommended');
        }));
    }
    ngOnInit() {
        this.configSrv.init();
    }
    handleSubmit() {
        this.configSrv.submit();
    }
    reset() {
        this.configSrv.init();
    }
    onSelect($event, config) {
        this.configSrv.selectNode($event.node, config);
    }
    onIncludedHeaderToggle(event) {
        const config = event.checked ?
            { isIncluded: true } :
            { isIncluded: false, isRecommended: false, isExcludedFromUpdates: false };
        this.configSrv.selectAll(config);
    }
    onRecommendedHeaderToggle(event) {
        this.configSrv.selectAll({ isRecommended: event.checked });
    }
    onToggle(event) {
        this.configSrv.toggleNode(event.node);
    }
}
ConfigProductFieldsComponent.decorators = [
    { type: Component, args: [{
                selector: 'lib-config-product-fields',
                template: "<div class=\"vertical-flow space-between-050\">\r\n  <h2>{{ 'PIM.PRODUCT_FIELD' | transloco }}</h2>\r\n  <p style=\"max-width: 56rem;\">{{ 'PIM.CHECK_ATTRIBUTES' | transloco }}</p>\r\n\r\n  <div class=\"horizontal-flow space-between-000\">\r\n    <div>\r\n      <div class=\"content-section implementation vertical-flow space-between-075\">\r\n        <p-treeTable\r\n          [value]=\"includedNodes$ | async\"\r\n          selectionMode=\"checkbox\"\r\n          [selection]=\"selectedIncludedNodes\"\r\n          (onNodeSelect)=\"onSelect($event, { isIncluded: true, isRecommended: false })\"\r\n          (onNodeUnselect)=\"onSelect($event, { isIncluded: false, isRecommended: false, isExcludedFromUpdates: false })\"\r\n          (onNodeExpand)=\"onToggle($event)\"\r\n          (onNodeCollapse)=\"onToggle($event)\"\r\n          (onHeaderCheckboxToggle)=\"onIncludedHeaderToggle($event)\"\r\n          compareSelectionBy=\"equals\"\r\n        >\r\n          <ng-template pTemplate=\"header\">\r\n            <tr>\r\n              <th class=\"border-right-med-light-grey\">\r\n                <p-treeTableHeaderCheckbox></p-treeTableHeaderCheckbox>\r\n                {{ 'PIM.OPTIONAL' | transloco }}\r\n              </th>\r\n            </tr>\r\n          </ng-template>\r\n\r\n          <ng-template pTemplate=\"body\" let-rowNode let-rowData=\"rowData\">\r\n            <tr>\r\n              <td>\r\n                <p-treeTableToggler [rowNode]=\"rowNode\"></p-treeTableToggler>\r\n                <p-treeTableCheckbox [value]=\"rowNode\"></p-treeTableCheckbox>\r\n                {{ rowData.categoryName }}\r\n                {{ rowData.description }}\r\n              </td>\r\n            </tr>\r\n          </ng-template>\r\n        </p-treeTable>\r\n      </div>\r\n    </div>\r\n    <div>\r\n      <div class=\"content-section implementation\">\r\n        <p-treeTable\r\n          [value]=\"recommendedNodes$ | async\"\r\n          [selection]=\"selectedRecommendedNodes\"\r\n          (onNodeSelect)=\"onSelect($event, { isRecommended: true })\"\r\n          (onNodeUnselect)=\"onSelect($event, { isRecommended: false })\"\r\n          (onNodeExpand)=\"onToggle($event)\"\r\n          (onNodeCollapse)=\"onToggle($event)\"\r\n          (onHeaderCheckboxToggle)=\"onRecommendedHeaderToggle($event)\"\r\n          selectionMode=\"checkbox\"\r\n          scrollHeight=\"500px\"\r\n          compareSelectionBy=\"equals\"\r\n        >\r\n          <ng-template pTemplate=\"header\">\r\n            <tr>\r\n              <th>\r\n                <p-treeTableHeaderCheckbox></p-treeTableHeaderCheckbox>\r\n                {{ 'PIM.RECOMMENDED' | transloco }}\r\n              </th>\r\n            </tr>\r\n          </ng-template>\r\n\r\n          <ng-template pTemplate=\"body\" let-rowNode let-rowData=\"rowData\">\r\n            <tr>\r\n              <td>\r\n                <p-treeTableToggler [rowNode]=\"rowNode\"></p-treeTableToggler>\r\n                <p-treeTableCheckbox [value]=\"rowNode\"></p-treeTableCheckbox>\r\n                {{ rowData.categoryName }}\r\n                {{ rowData.description }}\r\n              </td>\r\n            </tr>\r\n          </ng-template>\r\n        </p-treeTable>\r\n      </div>\r\n    </div>\r\n  </div>\r\n  <div class=\"horizontal-flow space-between-100\">\r\n    <button pButton label=\" {{ 'ACTIONS.CANCEL' | transloco }}\" (click)=\"reset()\" class=\"ds secondary\"></button>\r\n    <button pButton label=\" {{ 'ACTIONS.SAVE' | transloco }}\" (click)=\"handleSubmit()\" class=\"ds primary\"></button>\r\n  </div>\r\n</div>\r\n",
                changeDetection: ChangeDetectionStrategy.OnPush,
                styles: [".kb-cell{background-color:#fff}"]
            },] }
];
ConfigProductFieldsComponent.ctorParameters = () => [
    { type: ConfigFieldService },
    { type: Store }
];

class DashboardPdxComponent {
    constructor(store, datepipe, pimAPISrv, translocoSrv, pimSrv, http) {
        this.store = store;
        this.datepipe = datepipe;
        this.pimAPISrv = pimAPISrv;
        this.translocoSrv = translocoSrv;
        this.pimSrv = pimSrv;
        this.http = http;
        this.setFilterEvent = new EventEmitter();
        this.ISODateTimeFormat = 'yyyy-MM-ddTHH:mm:ss';
        this.templateTypes = TemplateTypes;
    }
    ngOnInit() {
        const uri = urlJoin(this.pimSrv.getConfig().uriProduct.baseUri, 'v1/dashboard/pdx-connections');
        const distributors = this.http
            .get(uri, {
            withCredentials: true,
        })
            .pipe(shareReplay(1), map((c) => c.records));
        this.distributorConnections$ = distributors.pipe(map(c => c.filter(r => r.isConnected)), map(c => c.sort((a, b) => {
            const dbnA = a.dbaName.toLocaleLowerCase();
            const dbnB = b.dbaName.toLocaleLowerCase();
            if (dbnA === dbnB) {
                return 0;
            }
            return dbnA < dbnB ? -1 : 1;
        })));
        this.availableCount$ = distributors.pipe(map(c => c.filter(r => !r.isConnected).length));
        this.connectedCount$ = this.distributorConnections$.pipe(map(val => val.length));
        const status = { isApproved: true, isPending: null };
        this.productCompletionCount$ = this.pimAPISrv.getKpi(Object.assign(Object.assign({}, status), { filters: this.productCompletionFilters() })).pipe(map(res => res.count));
        this.totalProductsCount$ = this.pimAPISrv.getKpi(Object.assign(Object.assign({}, status), { filters: new SearchFilters() })).pipe(map(res => res.count));
        const user$ = this.store.pipe(select(selectors.userProfile), first((user) => user.userInfo.DateTypeFormat !== null &&
            user.userInfo.TimeZoneCode !== null), shareReplay(1));
        this.asOfDate$ = user$.pipe(map((user) => this.translocoSrv.translate('PIM.DASHBOARD_AS_OF_DATE', {
            date: this.datepipe.transform(this.getCurrentDate(), user.userInfo.DateTypeFormat),
        })));
        this.newProductCount$ = user$.pipe(switchMap(user => this.pimAPISrv.getKpi(Object.assign(Object.assign({}, status), { filters: this.newProductsFilters(user.userInfo.TimeZoneCode) }))), map(res => res.count));
        this.productChangeCount$ = user$.pipe(switchMap(user => this.pimAPISrv.getKpi(Object.assign(Object.assign({}, status), { filters: this.changedProductsFilters(user.userInfo.TimeZoneCode) }))), map(res => res.count));
        this.noPrimaryImageCount$ = this.pimAPISrv.getKpi(Object.assign(Object.assign({}, status), { filters: this.noPrimaryImageFilters() })).pipe(map(res => res.count));
        this.noSecondaryImageCount$ = this.pimAPISrv.getKpi(Object.assign(Object.assign({}, status), { filters: this.noSecondaryImageFilters() })).pipe(map(res => res.count));
    }
    // #region Methods
    productCompletionFilters() {
        const completePercentRange = new SearchRange();
        completePercentRange.min = 0;
        completePercentRange.max = 80;
        const filters = this.buildDefaultSearchFilter();
        filters.NumericRange =
            filters.NumericRange === undefined ? {} : filters.NumericRange;
        filters.NumericRange['completionPercent'] = completePercentRange;
        this.productCompletionStringparam = JSON.stringify(filters);
        return filters;
    }
    changedProductsFilters(timeZoneCode) {
        const dateLastChangeRange = new SearchRange();
        dateLastChangeRange.timeZone = timeZoneCode;
        dateLastChangeRange.min = this.getCurrentDate();
        dateLastChangeRange.min.setDate(dateLastChangeRange.min.getDate() - 30);
        dateLastChangeRange.min = this.datepipe.transform(dateLastChangeRange.min, this.ISODateTimeFormat);
        dateLastChangeRange.max = this.getCurrentDate();
        dateLastChangeRange.max = this.datepipe.transform(dateLastChangeRange.max, this.ISODateTimeFormat);
        const filters = this.buildDefaultSearchFilter();
        filters.DateTimeRange =
            filters.DateTimeRange === undefined ? {} : filters.DateTimeRange;
        filters.DateTimeRange['dateLastChanged'] = dateLastChangeRange;
        this.changedProductsStringparam = JSON.stringify(filters);
        return filters;
    }
    newProductsFilters(timeZoneCode) {
        const dateAddedRange = new SearchRange();
        dateAddedRange.timeZone = timeZoneCode;
        dateAddedRange.min = this.getCurrentDate();
        dateAddedRange.min.setDate(dateAddedRange.min.getDate() - 30);
        dateAddedRange.min = this.datepipe.transform(dateAddedRange.min, this.ISODateTimeFormat);
        dateAddedRange.max = this.getCurrentDate();
        dateAddedRange.max = this.datepipe.transform(dateAddedRange.max, this.ISODateTimeFormat);
        const filters = this.buildDefaultSearchFilter();
        filters.DateTimeRange =
            filters.DateTimeRange === undefined ? {} : filters.DateTimeRange;
        filters.DateTimeRange['dateAdded'] = dateAddedRange;
        this.newProductsStringparam = JSON.stringify(filters);
        return filters;
    }
    noPrimaryImageFilters() {
        const filters = Object.assign(Object.assign({}, this.buildDefaultSearchFilter()), { PickList: {
                primaryImageFileName: ['Unspecified'],
            } });
        this.noPrimaryImageStringparam = JSON.stringify(filters);
        return filters;
    }
    noSecondaryImageFilters() {
        const filters = Object.assign(Object.assign({}, this.buildDefaultSearchFilter()), { PickList: { secondaryImageFileName: ['Unspecified'] } });
        this.noSecondaryImageStringparam = JSON.stringify(filters);
        return filters;
    }
    //#endregion
    //#region Helpers
    getCurrentDate() {
        // Set current date's hours, minutes, seconds and milliseconds to 0
        const currentDate = new Date();
        currentDate.setHours(0);
        currentDate.setMinutes(0);
        currentDate.setSeconds(0);
        currentDate.setMilliseconds(0);
        return currentDate;
    }
    buildDefaultSearchFilter() {
        const filters = new SearchFilters();
        const temp = new SearchRange();
        temp.min = this.getCurrentDate();
        temp.min.setDate(temp.min.getDate() + 1);
        temp.min = this.datepipe.transform(temp.min, this.ISODateTimeFormat);
        filters.DateRange = {};
        filters.DateRange['discontinueDate'] = temp;
        return filters;
    }
}
DashboardPdxComponent.decorators = [
    { type: Component, args: [{
                selector: 'lib-dashboard-pdx',
                template: "<div class=\"vertical-flow space-between-100\">\r\n  <h2>{{ 'PIM.CONTROL_CENTRE' | transloco }}</h2>\r\n  <div class=\"tile space-before-225\">\r\n    <lbmx-widget-wrapper styleClass=\"kpi raised center position-relative\" [request]=\"connectedCount$\">\r\n      <ng-template [laTemplate]=\"templateTypes.DONE\" let-state>\r\n          <h3 class=\"no-margin-top no-margin-bottom\">\r\n            {{ 'PIM.PDX.CONNECTIONS' | transloco }}\r\n          </h3>\r\n          <h1 class=\"margin-2\">\r\n            {{ state.value }}\r\n          </h1>\r\n          <p class=\"fontSize14px margin-top-5\">\r\n            {{ asOfDate$ | async }}\r\n          </p>\r\n      </ng-template>\r\n      <ng-template [laTemplate]=\"templateTypes.LOADING\">\r\n        <div class=\"spinner-background\">\r\n          <p-progressSpinner styleClass=\"custom-spinner\"></p-progressSpinner>\r\n        </div>\r\n      </ng-template>\r\n      <ng-template [laTemplate]=\"templateTypes.ERROR\">\r\n        <div class=\"center error\" style=\"cursor: default\">\r\n          <div class=\"message\">\r\n            <i class=\"pi pi-times-circle\"></i>\r\n            <span>{{ 'ANALYTICS.ERROR' | transloco }}</span>\r\n          </div>\r\n        </div>\r\n      </ng-template>\r\n    </lbmx-widget-wrapper>\r\n    <lbmx-widget-wrapper styleClass=\"kpi raised center position-relative\" [request]=\"availableCount$\">\r\n      <ng-template [laTemplate]=\"templateTypes.DONE\" let-state>\r\n          <h3 class=\"no-margin-top no-margin-bottom\">\r\n            {{ 'PIM.PDX.AVAILABLE_CONNECTION' | transloco }}\r\n          </h3>\r\n          <h1 class=\"margin-2\">\r\n            {{ state.value }}\r\n          </h1>\r\n          <p class=\"fontSize14px margin-top-5\">\r\n            {{ asOfDate$ | async }}\r\n          </p>\r\n      </ng-template>\r\n      <ng-template [laTemplate]=\"templateTypes.LOADING\">\r\n        <div class=\"spinner-background\">\r\n          <p-progressSpinner styleClass=\"custom-spinner\"></p-progressSpinner>\r\n        </div>\r\n      </ng-template>\r\n      <ng-template [laTemplate]=\"templateTypes.ERROR\">\r\n        <div class=\"center error\" style=\"cursor: default\">\r\n          <div class=\"message\">\r\n            <i class=\"pi pi-times-circle\"></i>\r\n            <span>{{ 'ANALYTICS.ERROR' | transloco }}</span>\r\n          </div>\r\n        </div>\r\n      </ng-template>\r\n    </lbmx-widget-wrapper>\r\n    <lbmx-widget-wrapper styleClass=\"kpi raised center position-relative\" [request]=\"productCompletionCount$\">\r\n      <ng-template [laTemplate]=\"templateTypes.DONE\" let-state>\r\n          <a\r\n            [routerLink]=\"['../products']\"\r\n            [queryParams]=\"{ filters: productCompletionStringparam }\"\r\n          >\r\n            <h3 class=\"no-margin-top no-margin-bottom\">\r\n              {{ 'PIM.DASHBOARD_PRODUCT_COMPLETE' | transloco }}\r\n            </h3>\r\n            <h1 class=\"margin-2\">\r\n              {{ state.value }}\r\n            </h1>\r\n            <p class=\"fontSize14px margin-top-5\">\r\n              {{ 'PIM.DASHBOARD_PRODUCT_COMPLETE_MSG' | transloco }}\r\n            </p>\r\n          </a>\r\n      </ng-template>\r\n      <ng-template [laTemplate]=\"templateTypes.LOADING\">\r\n        <div class=\"spinner-background\">\r\n          <p-progressSpinner styleClass=\"custom-spinner\"></p-progressSpinner>\r\n        </div>\r\n      </ng-template>\r\n      <ng-template [laTemplate]=\"templateTypes.ERROR\">\r\n        <div class=\"center error\" style=\"cursor: default\">\r\n          <div class=\"message\">\r\n            <i class=\"pi pi-times-circle\"></i>\r\n            <span>{{ 'ANALYTICS.ERROR' | transloco }}</span>\r\n          </div>\r\n        </div>\r\n      </ng-template>\r\n    </lbmx-widget-wrapper>\r\n    <lbmx-widget-wrapper styleClass=\"kpi raised center position-relative\" [request]=\"totalProductsCount$\">\r\n      <ng-template [laTemplate]=\"templateTypes.DONE\" let-state>\r\n          <a\r\n            [routerLink]=\"['../products']\"\r\n          >\r\n            <h3 class=\"no-margin-top no-margin-bottom\">\r\n              {{ 'PIM.DASHBOARD_TOTAL_PRODUCTS' | transloco }}\r\n            </h3>\r\n            <h1 class=\"margin-2\">\r\n              {{ state.value }}\r\n            </h1>\r\n            <p class=\"fontSize14px margin-top-5\">\r\n              {{ asOfDate$ | async }}\r\n            </p>\r\n          </a>\r\n      </ng-template>\r\n      <ng-template [laTemplate]=\"templateTypes.LOADING\">\r\n        <div class=\"spinner-background\">\r\n          <p-progressSpinner styleClass=\"custom-spinner\"></p-progressSpinner>\r\n        </div>\r\n      </ng-template>\r\n      <ng-template [laTemplate]=\"templateTypes.ERROR\">\r\n        <div class=\"center error\" style=\"cursor: default\">\r\n          <div class=\"message\">\r\n            <i class=\"pi pi-times-circle\"></i>\r\n            <span>{{ 'ANALYTICS.ERROR' | transloco }}</span>\r\n          </div>\r\n        </div>\r\n      </ng-template>\r\n    </lbmx-widget-wrapper>\r\n  </div>\r\n  <div class=\"tile space-before-225\">\r\n    <lbmx-widget-wrapper styleClass=\"kpi raised center position-relative\" [request]=\"newProductCount$\">\r\n      <ng-template [laTemplate]=\"templateTypes.DONE\" let-state>\r\n          <a\r\n            [routerLink]=\"['../products']\"\r\n            [queryParams]=\"{ filters: newProductsStringparam }\"\r\n          >\r\n            <h3 class=\"no-margin-top no-margin-bottom\">\r\n              {{ 'PIM.DASHBOARD_NEW_PRODUCT' | transloco }}\r\n            </h3>\r\n            <h1 class=\"margin-2\">\r\n              {{ state.value }}\r\n            </h1>\r\n            <p class=\"fontSize14px margin-top-5\">\r\n              {{ 'PIM.DASHBOARD_NEW_PRODUCT_MSG' | transloco }}\r\n            </p>\r\n          </a>\r\n      </ng-template>\r\n      <ng-template [laTemplate]=\"templateTypes.LOADING\">\r\n        <div class=\"spinner-background\">\r\n          <p-progressSpinner styleClass=\"custom-spinner\"></p-progressSpinner>\r\n        </div>\r\n      </ng-template>\r\n      <ng-template [laTemplate]=\"templateTypes.ERROR\">\r\n        <div class=\"center error\" style=\"cursor: default\">\r\n          <div class=\"message\">\r\n            <i class=\"pi pi-times-circle\"></i>\r\n            <span>{{ 'ANALYTICS.ERROR' | transloco }}</span>\r\n          </div>\r\n        </div>\r\n      </ng-template>\r\n    </lbmx-widget-wrapper>\r\n    <lbmx-widget-wrapper styleClass=\"kpi raised center position-relative\" [request]=\"productChangeCount$\">\r\n      <ng-template [laTemplate]=\"templateTypes.DONE\" let-state>\r\n          <a\r\n            [routerLink]=\"['../products']\"\r\n            [queryParams]=\"{ filters: changedProductsStringparam }\"\r\n          >\r\n            <h3 class=\"no-margin-top no-margin-bottom\">\r\n              {{ 'PIM.DASHBOARD_PRODUCT_CHANGE' | transloco }}\r\n            </h3>\r\n            <h1 class=\"margin-2\">\r\n              {{ state.value }}\r\n            </h1>\r\n            <p class=\"fontSize14px margin-top-5\">\r\n              {{ 'PIM.DASHBOARD_PRODUCT_CHANGE_MSG' | transloco }}\r\n            </p>\r\n          </a>\r\n      </ng-template>\r\n      <ng-template [laTemplate]=\"templateTypes.LOADING\">\r\n        <div class=\"spinner-background\">\r\n          <p-progressSpinner styleClass=\"custom-spinner\"></p-progressSpinner>\r\n        </div>\r\n      </ng-template>\r\n      <ng-template [laTemplate]=\"templateTypes.ERROR\">\r\n        <div class=\"center error\" style=\"cursor: default\">\r\n          <div class=\"message\">\r\n            <i class=\"pi pi-times-circle\"></i>\r\n            <span>{{ 'ANALYTICS.ERROR' | transloco }}</span>\r\n          </div>\r\n        </div>\r\n      </ng-template>\r\n    </lbmx-widget-wrapper>\r\n    <lbmx-widget-wrapper styleClass=\"kpi raised center position-relative\" [request]=\"noPrimaryImageCount$\">\r\n      <ng-template [laTemplate]=\"templateTypes.DONE\" let-state>\r\n          <a\r\n            [routerLink]=\"['../products']\"\r\n            [queryParams]=\"{ filters: noPrimaryImageStringparam }\"\r\n          >\r\n            <h3 class=\"no-margin-top no-margin-bottom\">\r\n              {{ 'PIM.DASHBOARD_NO_PRIMARY_IMAGE' | transloco }}\r\n            </h3>\r\n            <h1 class=\"margin-2\">\r\n              {{ state.value }}\r\n            </h1>\r\n            <p class=\"fontSize14px margin-top-5\">\r\n              {{ asOfDate$ | async }}\r\n            </p>\r\n          </a>\r\n      </ng-template>\r\n      <ng-template [laTemplate]=\"templateTypes.LOADING\">\r\n        <div class=\"spinner-background\">\r\n          <p-progressSpinner styleClass=\"custom-spinner\"></p-progressSpinner>\r\n        </div>\r\n      </ng-template>\r\n      <ng-template [laTemplate]=\"templateTypes.ERROR\">\r\n        <div class=\"center error\" style=\"cursor: default\">\r\n          <div class=\"message\">\r\n            <i class=\"pi pi-times-circle\"></i>\r\n            <span>{{ 'ANALYTICS.ERROR' | transloco }}</span>\r\n          </div>\r\n        </div>\r\n      </ng-template>\r\n    </lbmx-widget-wrapper>\r\n    <lbmx-widget-wrapper styleClass=\"kpi raised center position-relative\" [request]=\"noSecondaryImageCount$\">\r\n      <ng-template [laTemplate]=\"templateTypes.DONE\" let-state>\r\n          <a\r\n            [routerLink]=\"['../products']\"\r\n            [queryParams]=\"{ filters: noSecondaryImageStringparam }\"\r\n          >\r\n            <h3 class=\"no-margin-top no-margin-bottom\">\r\n              {{ 'PIM.DASHBOARD_NO_SECONDARY_IMAGE' | transloco }}\r\n            </h3>\r\n            <h1 class=\"margin-2\">\r\n              {{ state.value }}\r\n            </h1>\r\n            <p class=\"fontSize14px margin-top-5\">\r\n              {{ asOfDate$ | async }}\r\n            </p>\r\n          </a>\r\n      </ng-template>\r\n      <ng-template [laTemplate]=\"templateTypes.LOADING\">\r\n        <div class=\"spinner-background\">\r\n          <p-progressSpinner styleClass=\"custom-spinner\"></p-progressSpinner>\r\n        </div>\r\n      </ng-template>\r\n      <ng-template [laTemplate]=\"templateTypes.ERROR\">\r\n        <div class=\"center error\" style=\"cursor: default\">\r\n          <div class=\"message\">\r\n            <i class=\"pi pi-times-circle\"></i>\r\n            <span>{{ 'ANALYTICS.ERROR' | transloco }}</span>\r\n          </div>\r\n        </div>\r\n      </ng-template>\r\n    </lbmx-widget-wrapper>\r\n  </div>\r\n\r\n  <p-table\r\n    [value]=\"distributorConnections$ | async\"\r\n    scrollable=\"true\"\r\n    scrollHeight=\"256px\"\r\n    paginator=\"true\"\r\n    [rows]=\"100\"\r\n    [rowsPerPageOptions]=\"[25,50,75,100]\"\r\n    resizableColumns=\"true\"\r\n    columnResizeMode=\"expand\"\r\n  >\r\n    <ng-template pTemplate=\"caption\">\r\n      <h3>{{ 'PIM.PDX.CONNECTIONS' | transloco }}</h3>\r\n    </ng-template>\r\n    <ng-template pTemplate=\"colgroup\">\r\n      <colgroup>\r\n        <col />\r\n        <col />\r\n        <col />\r\n        <col />\r\n        <col />\r\n      </colgroup>\r\n    </ng-template>\r\n    <ng-template pTemplate=\"header\">\r\n      <tr>\r\n        <th pResizableColumn>{{ 'PIM.PDX.BUSINESS_NAME' | transloco }}</th>\r\n        <th pResizableColumn>{{ 'PIM.PDX.DISTRIBUTOR_ADDRESS' | transloco }}</th>\r\n        <th pResizableColumn>{{ 'MEMBER.CITY' | transloco }}</th>\r\n        <th pResizableColumn>{{ 'MEMBER.STATE_PROVINCE' | transloco }}</th>\r\n        <th pResizableColumn>{{ 'MEMBER.ZIP_POSTAL_CODE' | transloco }}</th>\r\n      </tr>\r\n    </ng-template>\r\n    <ng-template pTemplate=\"body\" let-distributorsConnected>\r\n      <tr>\r\n        <td class=\"ui-resizable-column\">\r\n          {{ distributorsConnected['dbaName'] }}\r\n        </td>\r\n        <td class=\"ui-resizable-column\">\r\n          {{ distributorsConnected['address'] }}\r\n        </td>\r\n        <td class=\"ui-resizable-column\">\r\n          {{ distributorsConnected['city'] }}\r\n        </td>\r\n        <td class=\"ui-resizable-column\">\r\n          {{ distributorsConnected['province'] }}\r\n        </td>\r\n        <td class=\"ui-resizable-column\">\r\n          {{ distributorsConnected['postalCode'] }}\r\n        </td>\r\n      </tr>\r\n    </ng-template>\r\n    <ng-template pTemplate=\"emptymessage\">\r\n      <tr>\r\n          <td colspan=\"8\" style=\"text-align:left\">No distributors found.</td>\r\n      </tr>\r\n    </ng-template>\r\n  </p-table>\r\n</div>\r\n",
                styles: [""]
            },] }
];
DashboardPdxComponent.ctorParameters = () => [
    { type: Store },
    { type: DatePipe },
    { type: PimAPIService },
    { type: TranslocoService },
    { type: PimService },
    { type: HttpClient }
];
DashboardPdxComponent.propDecorators = {
    setFilterEvent: [{ type: Output }]
};

class DashboardComponent {
    constructor(spinnerSrv, store, datepipe, pimAPISrv, translocoSrv, pimSrv) {
        this.spinnerSrv = spinnerSrv;
        this.store = store;
        this.datepipe = datepipe;
        this.pimAPISrv = pimAPISrv;
        this.translocoSrv = translocoSrv;
        this.pimSrv = pimSrv;
        this.setFilterEvent = new EventEmitter();
        this.subscriptions = [];
        this.ISODateTimeFormat = 'yyyy-MM-ddTHH:mm:ss';
        this.chartLabels = [];
        this.chartDataSets = [];
        this.templateTypes = TemplateTypes;
        this.topSupplierConfig = {
            topSupplier: {
                label: this.translocoSrv.translate('PIM.DASHBOARD_TOP_SUPPLIERS'),
                type: 'bar',
                endpoint: this.pimSrv.getConfig().getTermsAggregationEndPoint,
                query: this.buildTermsAggregationRequest(true, null, this.buildDefaultSearchFilter(), 10, -1, 'supplierName'),
                options: {
                    plugins: {
                        legend: {
                            display: false,
                        },
                    },
                },
            },
        };
        this.last10ProductsChanged = {
            last10ProductsChanged: {
                label: this.translocoSrv.translate('PIM.DASHBOARD_CHANGED_PRODUCTS'),
                request: of('').pipe(first()),
            },
        };
    }
    ngOnInit() {
        this.spinnerSrv.on();
        this.setUp();
    }
    ngOnDestroy() {
        if (this.subscriptions) {
            this.subscriptions.forEach((subscription) => subscription.unsubscribe());
        }
    }
    setUp() {
        this.subscriptions.push(this.store
            .pipe(select(selectors.userProfile), first((user) => user.userInfo.DateTypeFormat !== null &&
            user.userInfo.TimeZoneCode !== null), tap((user) => {
            this.asOfDate = this.translocoSrv.translate('PIM.DASHBOARD_AS_OF_DATE', {
                date: this.datepipe.transform(this.getCurrentDate(), user.userInfo.DateTypeFormat),
            });
        }), switchMap((user) => forkJoin({
            productCompletion: this.getProductCompletionKPI(),
            productChange: this.getChangedProductsKPI(user.userInfo.TimeZoneCode),
            newProduct: this.getNewProductsKPI(user.userInfo.TimeZoneCode),
            pendingProduct: this.getPendingProductsKPI(),
            topSuppliers: this.getTopSuppliers(),
            lastTenChangedProducts: forkJoin([
                this.getLastTenChangedProducts(),
                this.store
                    .select(selectors.users)
                    .pipe(first((u) => Object.keys(u).length > 0)),
            ]).pipe(map(([productDetails, users]) => productDetails.products
                // Only display products with Last Date Changed
                .filter((x) => x.dateLastChanged)
                .map((product) => {
                product.dateLastChanged = this.datepipe.transform(product.dateLastChanged, user.userInfo.DateTypeFormat);
                product.modifiedBy = users[parseInt(product.modifiedBy, 10)]
                    ? users[parseInt(product.modifiedBy, 10)].fullname
                    : null;
                return product;
            }))),
            totalProducts: this.getTotalProductsKPI(),
            noPrimaryImage: this.getNoPrimaryImageKPI(),
            noSecondaryImage: this.getNoSecondaryImageKPI(),
            discontinuedProducts: this.getDiscontinuedProductsKPI(),
        })), finalize(() => this.spinnerSrv.off()))
            .subscribe((res) => {
            this.productCompletionCount = res.productCompletion.count;
            this.productChangeCount = res.productChange.count;
            this.newProductCount = res.newProduct.count;
            this.pendingProductCount = res.pendingProduct.count;
            this.changedProducts = res.lastTenChangedProducts;
            res.topSuppliers.aggregations.forEach((aggregation) => {
                this.chartLabels.push(aggregation.value);
                this.chartDataSets.push(aggregation.totalRows);
            });
            this.chartData = {
                labels: this.chartLabels,
                datasets: [
                    {
                        backgroundColor: '#BD0024',
                        data: this.chartDataSets,
                    },
                ],
            };
            this.totalProductsCount = res.totalProducts.count;
            this.noPrimaryImageCount = res.noPrimaryImage.count;
            this.noSecondaryImageCount = res.noSecondaryImage.count;
            this.discontinuedProductsCount = res.discontinuedProducts.count;
        }));
    }
    // #region Methods
    getProductCompletionKPI() {
        this.isApproved = true;
        this.isPending = null;
        const completePercentRange = new SearchRange();
        completePercentRange.min = 0;
        completePercentRange.max = 80;
        const filters = this.buildDefaultSearchFilter();
        filters.NumericRange =
            filters.NumericRange === undefined ? {} : filters.NumericRange;
        filters.NumericRange['completionPercent'] = completePercentRange;
        this.productCompletionStringparam = JSON.stringify(filters);
        return this.pimAPISrv.getKpi(this.buildKPIRequest(this.isApproved, this.isPending, filters));
    }
    getChangedProductsKPI(timeZoneCode) {
        this.isApproved = true;
        this.isPending = null;
        const dateLastChangeRange = new SearchRange();
        dateLastChangeRange.timeZone = timeZoneCode;
        dateLastChangeRange.min = this.getCurrentDate();
        dateLastChangeRange.min.setDate(dateLastChangeRange.min.getDate() - 30);
        dateLastChangeRange.min = this.datepipe.transform(dateLastChangeRange.min, this.ISODateTimeFormat);
        dateLastChangeRange.max = this.getCurrentDate();
        dateLastChangeRange.max = this.datepipe.transform(dateLastChangeRange.max, this.ISODateTimeFormat);
        const filters = this.buildDefaultSearchFilter();
        filters.DateTimeRange =
            filters.DateTimeRange === undefined ? {} : filters.DateTimeRange;
        filters.DateTimeRange['dateLastChanged'] = dateLastChangeRange;
        this.changedProductsStringparam = JSON.stringify(filters);
        return this.pimAPISrv.getKpi(this.buildKPIRequest(this.isApproved, this.isPending, filters));
    }
    getNewProductsKPI(timeZoneCode) {
        this.isApproved = true;
        this.isPending = null;
        const dateAddedRange = new SearchRange();
        dateAddedRange.timeZone = timeZoneCode;
        dateAddedRange.min = this.getCurrentDate();
        dateAddedRange.min.setDate(dateAddedRange.min.getDate() - 30);
        dateAddedRange.min = this.datepipe.transform(dateAddedRange.min, this.ISODateTimeFormat);
        dateAddedRange.max = this.getCurrentDate();
        dateAddedRange.max = this.datepipe.transform(dateAddedRange.max, this.ISODateTimeFormat);
        const filters = this.buildDefaultSearchFilter();
        filters.DateTimeRange =
            filters.DateTimeRange === undefined ? {} : filters.DateTimeRange;
        filters.DateTimeRange['dateAdded'] = dateAddedRange;
        this.newProductsStringparam = JSON.stringify(filters);
        return this.pimAPISrv.getKpi(this.buildKPIRequest(this.isApproved, this.isPending, filters));
    }
    getPendingProductsKPI() {
        this.isApproved = null;
        this.isPending = true;
        const filters = new SearchFilters();
        return this.pimAPISrv.getKpi(this.buildKPIRequest(this.isApproved, this.isPending, filters));
    }
    getTotalProductsKPI() {
        this.isApproved = true;
        this.isPending = null;
        const filters = new SearchFilters();
        return this.pimAPISrv.getKpi(this.buildKPIRequest(this.isApproved, this.isPending, filters));
    }
    getNoPrimaryImageKPI() {
        this.isApproved = true;
        this.isPending = null;
        const filters = Object.assign(Object.assign({}, this.buildDefaultSearchFilter()), { PickList: {
                primaryImageFileName: ['Unspecified'],
            } });
        this.noPrimaryImageStringparam = JSON.stringify(filters);
        return this.pimAPISrv.getKpi(this.buildKPIRequest(this.isApproved, this.isPending, filters));
    }
    getNoSecondaryImageKPI() {
        this.isApproved = true;
        this.isPending = null;
        const filters = Object.assign(Object.assign({}, this.buildDefaultSearchFilter()), { PickList: { secondaryImageFileName: ['Unspecified'] } });
        this.noSecondaryImageStringparam = JSON.stringify(filters);
        return this.pimAPISrv.getKpi(this.buildKPIRequest(this.isApproved, this.isPending, filters));
    }
    getDiscontinuedProductsKPI() {
        this.isApproved = true;
        this.isPending = null;
        const filters = new SearchFilters();
        const temp = new SearchRange();
        temp.min = this.getCurrentDate();
        temp.min.setDate(temp.min.getDate() + 1);
        temp.min = this.datepipe.transform(temp.min, this.ISODateTimeFormat);
        temp.max = this.getCurrentDate();
        temp.max.setDate(temp.max.getDate() + 60);
        temp.max = this.datepipe.transform(temp.max, this.ISODateTimeFormat);
        filters.DateRange = {};
        filters.DateRange['discontinueDate'] = temp;
        this.discontinuedProductsStringparam = JSON.stringify(filters);
        return this.pimAPISrv.getKpi(this.buildKPIRequest(this.isApproved, this.isPending, filters));
    }
    getTopSuppliers() {
        this.isApproved = true;
        this.isPending = null;
        const filters = this.buildDefaultSearchFilter();
        return this.pimAPISrv.getTermsAggregation(this.buildTermsAggregationRequest(this.isApproved, this.isPending, filters, 10, -1, 'supplierName'));
    }
    getLastTenChangedProducts() {
        this.isApproved = true;
        this.isPending = false;
        const filters = this.buildDefaultSearchFilter();
        const sort = { field: 'dateLastChanged', order: -1 };
        return this.pimAPISrv.searchApprovedProducts(this.buildSearchRequest(null, 10, 0, [], filters, sort));
    }
    //#endregion
    //#region Helpers
    getCurrentDate() {
        // Set current date's hours, minutes, seconds and milliseconds to 0
        const currentDate = new Date();
        currentDate.setHours(0);
        currentDate.setMinutes(0);
        currentDate.setSeconds(0);
        currentDate.setMilliseconds(0);
        return currentDate;
    }
    buildKPIRequest(isApproved, isPending, filters) {
        const request = new KPIRequest();
        request.isApproved = isApproved;
        request.isPending = isPending;
        request.Filters = filters;
        return request;
    }
    buildDefaultSearchFilter() {
        const filters = new SearchFilters();
        const temp = new SearchRange();
        temp.min = this.getCurrentDate();
        temp.min.setDate(temp.min.getDate() + 1);
        temp.min = this.datepipe.transform(temp.min, this.ISODateTimeFormat);
        filters.DateRange = {};
        filters.DateRange['discontinueDate'] = temp;
        return filters;
    }
    buildTermsAggregationRequest(isApproved, isPending, filters, size, order, field) {
        const request = new TermsAggregationRequest();
        request.isApproved = isApproved;
        request.isPending = isPending;
        request.Size = size;
        request.Order = order;
        request.Field = field;
        request.Filters = filters;
        return request;
    }
    buildSearchRequest(searchText, pageSize, skip, facets, filters, sort) {
        const request = new SearchProductsRequest();
        request.PageSize = pageSize;
        request.Skip = skip;
        request.SearchWord = searchText === undefined ? '' : searchText;
        request.FacetList = facets;
        request.Sort = sort;
        request.isApproved = true;
        request.Filters = filters;
        return request;
    }
    //#endregion
    adapter(responsive) {
        return {
            data: responsive.aggregations.reduce((dataConfig, aggregation) => {
                return {
                    labels: [...dataConfig.labels, aggregation.value],
                    datasets: [
                        Object.assign(Object.assign({}, dataConfig.datasets[0]), { data: [...dataConfig.datasets[0].data, aggregation.totalRows], tooltips: [
                                ...dataConfig.datasets[0].tooltips,
                                [{ value: aggregation.totalRows, label: aggregation.value }],
                            ] }),
                    ],
                };
            }, {
                labels: [],
                datasets: [{ label: 'suppliers', data: [], tooltips: [] }],
            }),
        };
    }
}
DashboardComponent.decorators = [
    { type: Component, args: [{
                selector: 'lib-dashboard',
                template: "<div class=\"vertical-flow space-between-100\">\r\n  <div class=\"tile space-before-225\">\r\n    <div class=\"kpi raised center\">\r\n      <a\r\n        [routerLink]=\"['../products']\"\r\n        [queryParams]=\"{ filters: productCompletionStringparam }\"\r\n      >\r\n        <h3 class=\"no-margin-top no-margin-bottom\">\r\n          {{ 'PIM.DASHBOARD_PRODUCT_COMPLETE' | transloco }}\r\n        </h3>\r\n        <h1 class=\"margin-2\">\r\n          {{ productCompletionCount }}\r\n        </h1>\r\n        <p class=\"fontSize14px margin-top-5\">\r\n          {{ 'PIM.DASHBOARD_PRODUCT_COMPLETE_MSG' | transloco }}\r\n        </p>\r\n      </a>\r\n    </div>\r\n    <div class=\"kpi raised center\">\r\n      <a\r\n        [routerLink]=\"['../products']\"\r\n        [queryParams]=\"{ filters: changedProductsStringparam }\"\r\n      >\r\n        <h3 class=\"no-margin-top no-margin-bottom\">\r\n          {{ 'PIM.DASHBOARD_PRODUCT_CHANGE' | transloco }}\r\n        </h3>\r\n        <h1 class=\"margin-2\">\r\n          {{ productChangeCount }}\r\n        </h1>\r\n        <p class=\"fontSize14px margin-top-5\">\r\n          {{ 'PIM.DASHBOARD_PRODUCT_CHANGE_MSG' | transloco }}\r\n        </p>\r\n      </a>\r\n    </div>\r\n    <div class=\"kpi raised center\">\r\n      <a\r\n        [routerLink]=\"['../products']\"\r\n        [queryParams]=\"{ filters: newProductsStringparam }\"\r\n      >\r\n        <h3 class=\"no-margin-top no-margin-bottom\">\r\n          {{ 'PIM.DASHBOARD_NEW_PRODUCT' | transloco }}\r\n        </h3>\r\n        <h1 class=\"margin-2\">\r\n          {{ newProductCount }}\r\n        </h1>\r\n        <p class=\"fontSize14px margin-top-5\">\r\n          {{ 'PIM.DASHBOARD_NEW_PRODUCT_MSG' | transloco }}\r\n        </p>\r\n      </a>\r\n    </div>\r\n    <div class=\"kpi raised center\">\r\n      <a [routerLink]=\"['../products/products-pending']\">\r\n        <h3 class=\"no-margin-top no-margin-bottom\">\r\n          {{ 'PIM.DASHBOARD_PRODUCT_PENDING' | transloco }}\r\n        </h3>\r\n        <h1 class=\"margin-2\">\r\n          {{ pendingProductCount }}\r\n        </h1>\r\n        <p class=\"fontSize14px margin-top-5\">\r\n          {{ 'PIM.DASHBOARD_PRODUCT_PENDING_MSG' | transloco }}\r\n        </p>\r\n      </a>\r\n    </div>\r\n  </div>\r\n  <div class=\"tile space-before-225\">\r\n    <div class=\"kpi raised center\">\r\n      <a [routerLink]=\"['../products']\">\r\n        <h3 class=\"no-margin-top no-margin-bottom\">\r\n          {{ 'PIM.DASHBOARD_TOTAL_PRODUCTS' | transloco }}\r\n        </h3>\r\n        <h1 class=\"margin-2\">\r\n          {{ totalProductsCount }}\r\n        </h1>\r\n        <p class=\"fontSize14px margin-top-5\">\r\n          {{ asOfDate }}\r\n        </p>\r\n      </a>\r\n    </div>\r\n    <div class=\"kpi raised center\">\r\n      <a\r\n        [routerLink]=\"['../products']\"\r\n        [queryParams]=\"{ filters: noPrimaryImageStringparam }\"\r\n      >\r\n        <h3 class=\"no-margin-top no-margin-bottom\">\r\n          {{ 'PIM.DASHBOARD_NO_PRIMARY_IMAGE' | transloco }}\r\n        </h3>\r\n        <h1 class=\"margin-2\">\r\n          {{ noPrimaryImageCount }}\r\n        </h1>\r\n        <p class=\"fontSize14px margin-top-5\">\r\n          {{ asOfDate }}\r\n        </p>\r\n      </a>\r\n    </div>\r\n    <div class=\"kpi raised center\">\r\n      <a\r\n        [routerLink]=\"['../products']\"\r\n        [queryParams]=\"{ filters: noSecondaryImageStringparam }\"\r\n      >\r\n        <h3 class=\"no-margin-top no-margin-bottom\">\r\n          {{ 'PIM.DASHBOARD_NO_SECONDARY_IMAGE' | transloco }}\r\n        </h3>\r\n        <h1 class=\"margin-2\">\r\n          {{ noSecondaryImageCount }}\r\n        </h1>\r\n        <p class=\"fontSize14px margin-top-5\">\r\n          {{ asOfDate }}\r\n        </p>\r\n      </a>\r\n    </div>\r\n    <div class=\"kpi raised center\">\r\n      <a\r\n        [routerLink]=\"['../products']\"\r\n        [queryParams]=\"{ filters: discontinuedProductsStringparam }\"\r\n      >\r\n        <h3 class=\"no-margin-top no-margin-bottom\">\r\n          {{ 'PIM.DASHBOARD_DISCONTINUED_PRODUCTS' | transloco }}\r\n        </h3>\r\n        <h1 class=\"margin-2\">\r\n          {{ discontinuedProductsCount }}\r\n        </h1>\r\n        <p class=\"fontSize14px margin-top-5\">\r\n          {{ 'PIM.DASHBOARD_DISCONTINUE_DATE_RANGE' | transloco }}\r\n        </p>\r\n      </a>\r\n    </div>\r\n  </div>\r\n  <div class=\"tile-050\">\r\n    <div class=\"raised\">\r\n      <lbmx-tab-chart\r\n        [chartTabs]=\"topSupplierConfig\"\r\n        [adaptor]=\"adapter\"\r\n        class=\"position-relative elevated\"\r\n        style=\"display: block; height: 100%; width: 100%\"\r\n      ></lbmx-tab-chart>\r\n    </div>\r\n    <div class=\"raised\">\r\n      <!-- <h4 class=\"margin-2\">\r\n        {{ 'PIM.DASHBOARD_CHANGED_PRODUCTS' | transloco }}\r\n      </h4> -->\r\n      <lbmx-tab-widget-wrapper [tabs]=\"last10ProductsChanged\">\r\n        <ng-template [laTemplate]=\"templateTypes.DONE\">\r\n          <p-table\r\n            [value]=\"changedProducts\"\r\n            [scrollable]=\"true\"\r\n            scrollHeight=\"300px\"\r\n            [resizableColumns]=\"true\"\r\n            columnResizeMode=\"expand\"\r\n          >\r\n            <ng-template pTemplate=\"colgroup\">\r\n              <colgroup>\r\n                <col />\r\n                <col />\r\n                <col />\r\n                <col />\r\n              </colgroup>\r\n            </ng-template>\r\n            <ng-template pTemplate=\"header\">\r\n              <tr>\r\n                <th pResizableColumn>{{ 'PIM.PRODUCT_ID' | transloco }}</th>\r\n                <th pResizableColumn>\r\n                  {{ 'PIM.PRODUCT_DESCRIPTION' | transloco }}\r\n                </th>\r\n                <th pResizableColumn>{{ 'COMMON.DATE' | transloco }}</th>\r\n                <th pResizableColumn>{{ 'COMMON.NAME' | transloco }}</th>\r\n              </tr>\r\n            </ng-template>\r\n            <ng-template pTemplate=\"body\" let-changedProducts>\r\n              <tr>\r\n                <td class=\"ui-resizable-column\">\r\n                  {{ changedProducts['sku'] }}\r\n                </td>\r\n                <td class=\"ui-resizable-column\">\r\n                  {{ changedProducts['description'] }}\r\n                </td>\r\n                <td class=\"ui-resizable-column\">\r\n                  {{ changedProducts['dateLastChanged'] }}\r\n                </td>\r\n                <td class=\"ui-resizable-column\">\r\n                  {{ changedProducts['modifiedBy'] }}\r\n                </td>\r\n              </tr>\r\n            </ng-template>\r\n          </p-table>\r\n        </ng-template>\r\n      </lbmx-tab-widget-wrapper>\r\n    </div>\r\n  </div>\r\n</div>\r\n",
                styles: [""]
            },] }
];
DashboardComponent.ctorParameters = () => [
    { type: SpinnerService$1 },
    { type: Store },
    { type: DatePipe },
    { type: PimAPIService },
    { type: TranslocoService },
    { type: PimService }
];
DashboardComponent.propDecorators = {
    setFilterEvent: [{ type: Output }]
};

const autoApproveSettings = ['new', 'update', 'both', 'none'];

class InboundProfileService {
    constructor(http, pimSrv) {
        this.http = http;
        const config = pimSrv.getConfig();
        this.autoApproveUri = `${config.uriProduct.baseUri}/config/inbound/auto-approve`;
    }
    getAutoApproveProducts() {
        return this.http.get(this.autoApproveUri, { withCredentials: true })
            .pipe(map(this.mapResponse));
    }
    setAutoApproveProducts(value) {
        return this.http.post(this.autoApproveUri, { setting: value }, { withCredentials: true })
            .pipe(map(this.mapResponse));
    }
    mapResponse(response) {
        return autoApproveSettings.find((s) => { var _a; return (_a = s === (response === null || response === void 0 ? void 0 : response.record)) !== null && _a !== void 0 ? _a : 'none'; });
    }
}
InboundProfileService.ɵprov = ɵɵdefineInjectable({ factory: function InboundProfileService_Factory() { return new InboundProfileService(ɵɵinject(HttpClient), ɵɵinject(PimService)); }, token: InboundProfileService, providedIn: "root" });
InboundProfileService.decorators = [
    { type: Injectable, args: [{
                providedIn: 'root',
            },] }
];
InboundProfileService.ctorParameters = () => [
    { type: HttpClient },
    { type: PimService }
];

const autoApproveOptions = [
    { value: 'new', label: 'AUTO_APPROVE_OPTIONS.NEW' },
    { value: 'update', label: 'AUTO_APPROVE_OPTIONS.UPDATE' },
    { value: 'both', label: 'AUTO_APPROVE_OPTIONS.ALL' },
    { value: 'none', label: 'AUTO_APPROVE_OPTIONS.NONE' },
];
class ExcludedProductFieldsComponent {
    constructor(configSrv, inboundProfileService, transloco) {
        this.configSrv = configSrv;
        this.inboundProfileService = inboundProfileService;
        this.transloco = transloco;
        this.subscriptions = [];
        this.selectedNodes = [];
        this.options$ = of([]);
        this.disableSubmit = true;
        this.includedNodes$ = configSrv.excludedTreeNodes$.pipe(tap((nodes) => {
            this.selectedNodes = this.configSrv.selectedNodes(nodes, 'isExcludedFromUpdates');
            this.disableSubmit = nodes.length === 0;
        }));
    }
    ngOnInit() {
        this.configSrv.init();
        this.subscriptions.push(this.inboundProfileService
            .getAutoApproveProducts()
            .pipe(tap((value) => (this.autoApproveSetting = value)))
            .subscribe());
        const translatedOptions = autoApproveOptions.map((opt) => this.transloco
            .selectTranslate(opt.label)
            .pipe(map((translation) => (Object.assign(Object.assign({}, opt), { label: translation })))));
        this.options$ = combineLatest(translatedOptions);
    }
    onChange() {
        const subscription = this.inboundProfileService
            .setAutoApproveProducts(this.autoApproveSetting)
            .subscribe();
        this.subscriptions.push(subscription);
    }
    reset() {
        this.configSrv.init();
    }
    handleSubmit() {
        this.configSrv.submit();
    }
    onSelect($event, config) {
        this.configSrv.selectNode($event.node, config);
    }
    onHeaderSelect(event) {
        this.configSrv.selectAll({ isExcludedFromUpdates: event.checked });
    }
    onToggle(event) {
        this.configSrv.toggleNode(event.node);
    }
}
ExcludedProductFieldsComponent.decorators = [
    { type: Component, args: [{
                selector: 'lib-excluded-product-fields',
                template: "<div class=\"vertical-flow space-between-050\">\r\n  <h2>{{ 'PIM.UPDATE_PROFILE' | transloco }}</h2>\r\n\r\n  <p style =\"max-width: 56rem;\">{{ 'PIM.AUTO_APPROVE_EXPLANATION' | transloco }}</p>\r\n\r\n<div class=\"vertical-flow space-between-075\">\r\n  <label for=\"option\"> {{ 'PIM.AUTO_APPROVE' | transloco }} </label>\r\n    <div style=\"width: 32.5rem; margin-bottom: 3em\">\r\n      <p-dropdown\r\n        #option\r\n        [(ngModel)]=\"autoApproveSetting\"\r\n        [options]=\"options$ | async\"\r\n        (onChange)=\"onChange()\"\r\n        required\r\n      >\r\n      </p-dropdown>\r\n    </div>\r\n</div>\r\n\r\n  <p>\r\n    {{ 'PIM.CHECK_ATTRIBUTES_EXCLUDED' | transloco }}\r\n  </p>\r\n\r\n  <div class=\"content-section implementation vertical-flow space-between-075 no-margin-top\">\r\n    <p-treeTable\r\n      [value]=\"includedNodes$ | async\"\r\n      selectionMode=\"checkbox\"\r\n      [selection]=\"selectedNodes\"\r\n      (onNodeSelect)=\"onSelect($event, { isExcludedFromUpdates: true })\"\r\n      (onNodeUnselect)=\"onSelect($event, { isExcludedFromUpdates: false })\"\r\n      (onNodeExpand)=\"onToggle($event)\"\r\n      (onNodeCollapse)=\"onToggle($event)\"\r\n      (onHeaderCheckboxToggle)=\"onHeaderSelect($event)\"\r\n      compareSelectionBy=\"equals\"\r\n    >\r\n      <ng-template pTemplate=\"header\">\r\n        <tr>\r\n          <th>\r\n            <p-treeTableHeaderCheckbox></p-treeTableHeaderCheckbox>\r\n            {{ 'PIM.EXCLUDED' | transloco }}\r\n          </th>\r\n        </tr>\r\n      </ng-template>\r\n\r\n      <ng-template pTemplate=\"body\" let-rowNode let-rowData=\"rowData\">\r\n        <tr>\r\n          <td>\r\n            <p-treeTableToggler [rowNode]=\"rowNode\"></p-treeTableToggler>\r\n            <p-treeTableCheckbox [value]=\"rowNode\"></p-treeTableCheckbox>\r\n            {{ rowData.categoryName }}\r\n            {{ rowData.description }}\r\n          </td>\r\n        </tr>\r\n      </ng-template>\r\n    </p-treeTable>\r\n\r\n    <div class=\"horizontal-flow space-between-100\">\r\n      <button\r\n        pButton\r\n        label=\"{{ 'ACTIONS.CANCEL' | transloco }}\"\r\n        (click)=\"reset()\"\r\n        class=\"ds secondary\"\r\n      ></button>\r\n      <button\r\n        pButton\r\n        [disabled]=\"disableSubmit\"\r\n        label=\"{{ 'ACTIONS.SAVE' | transloco }}\"\r\n        (click)=\"handleSubmit()\"\r\n        class=\"ds primary\"\r\n      ></button>\r\n    </div>\r\n  </div>\r\n</div>\r\n",
                styles: [""]
            },] }
];
ExcludedProductFieldsComponent.ctorParameters = () => [
    { type: ConfigFieldService },
    { type: InboundProfileService },
    { type: TranslocoService }
];

class ExportService {
    constructor(baseAPISrv, pimSrv) {
        this.baseAPISrv = baseAPISrv;
        this.pimSrv = pimSrv;
    }
    getURL(exportKey) {
        return urlJoin(this.pimSrv.getConfig().exportFileEndPoint, exportKey);
    }
    searchExports() {
        this.baseAPISrv.set(this.pimSrv.getConfig().searchExportsEndpoint);
        return this.baseAPISrv.post('').pipe();
    }
    exportProducts(exportProductRequest) {
        this.baseAPISrv.set(this.pimSrv.getConfig().exportProductsEndpoint);
        return this.baseAPISrv.post(exportProductRequest).pipe();
    }
    downloadExportFile(exportKey) {
        const path = urlJoin(this.pimSrv.getConfig().exportFileEndPoint, exportKey);
        this.baseAPISrv.set(path);
        return this.baseAPISrv.get({ responseType: 'blob' }).pipe();
    }
    deleteExportFile(exportKey) {
        this.baseAPISrv.set(this.pimSrv.getConfig().exportFileEndPoint);
        return this.baseAPISrv.deleteMany(exportKey).pipe();
    }
}
ExportService.ɵprov = ɵɵdefineInjectable({ factory: function ExportService_Factory() { return new ExportService(ɵɵinject(BaseAPIService), ɵɵinject(PimService)); }, token: ExportService, providedIn: "root" });
ExportService.decorators = [
    { type: Injectable, args: [{
                providedIn: 'root',
            },] }
];
ExportService.ctorParameters = () => [
    { type: BaseAPIService },
    { type: PimService }
];

class ExportComponent {
    constructor(exportSrv, confirmationService, store, translocoSrv, toasterSrv, route, baseAPISrv, pimSrv) {
        this.exportSrv = exportSrv;
        this.confirmationService = confirmationService;
        this.store = store;
        this.translocoSrv = translocoSrv;
        this.toasterSrv = toasterSrv;
        this.route = route;
        this.baseAPISrv = baseAPISrv;
        this.pimSrv = pimSrv;
        this.subscriptions = [];
        this.selectedFiles = [];
        this.isDownloadDisabled = true;
        this.name = of('');
    }
    ngOnInit() {
        this.name = this.route.data.pipe(switchMap((data) => data.viewErrors
            ? this.translocoSrv.selectTranslate('PIM.PDX.VIEW_ERRORS')
            : this.translocoSrv.selectTranslate('PIM.EXPORT')));
        this.fields = [
            { description: 'Filename' },
            { description: 'Format' },
            { description: 'Type of Data' },
            { description: 'User Name' },
            { description: 'Date' },
        ];
        this.getExportFiles();
        this.selectedFiles = [];
        this.subscriptions.push(this.store
            .pipe(select(selectors.userProfile), tap((user) => (this.dateFormat = user.userInfo.DateTypeFormat)))
            .subscribe());
    }
    ngOnDestroy() {
        if (this.subscriptions) {
            this.subscriptions.forEach((subscription) => subscription.unsubscribe());
        }
    }
    getExportFiles() {
        this.errorFiles$ = this.route.data.pipe(switchMap((data) => {
            const excludeErrors = data.isPdx;
            const path = data.viewErrors
                ? urlJoin(this.pimSrv.getConfig().exportFileEndPoint, 'error-search')
                : this.pimSrv.getConfig().searchExportsEndpoint;
            this.baseAPISrv.set(path);
            return this.baseAPISrv.post('', excludeErrors && { params: { fromObject: { excludeErrors } } });
        }));
    }
    downloadExportFiles() {
        this.subscriptions.push(this.exportSrv
            .downloadExportFile(this.selectedFiles[0].exportKey)
            .subscribe((blob) => {
            saveAs(blob, this.selectedFiles[0].filename);
        }));
    }
    checkRowCount($event) {
        if (this.selectedFiles.length === 1) {
            this.isDownloadDisabled = false;
        }
        else {
            this.isDownloadDisabled = true;
        }
    }
    delete() {
        this.confirmationService.confirm({
            header: this.translocoSrv.translate('ACTIONS.DELETE'),
            message: this.translocoSrv.translate('PIM.DELETE_EXPORTS_CONFIRM'),
            accept: () => {
                const selectedIds = [];
                this.selectedFiles.forEach((file) => {
                    selectedIds.push(file.exportKey);
                });
                this.subscriptions.push(this.exportSrv.deleteExportFile(selectedIds).subscribe((res) => {
                    this.getExportFiles();
                    this.toasterSrv.successNotify(this.translocoSrv.translate('PIM.DELETE_SUCCESS'));
                    this.selectedFiles = [];
                }));
            },
        });
    }
}
ExportComponent.decorators = [
    { type: Component, args: [{
                selector: 'lib-export',
                template: "<div>\r\n  <div class=\"vertical-flow\">\r\n    <h2 class=\"no-margin-bottom\">{{ name | async }}</h2>\r\n    <div class=\"horizontal-flow space-between-025 toolbar\">\r\n      <button\r\n        pButton\r\n        class=\"ds tertiary small\"\r\n        [disabled]=\"selectedFiles.length === 0\"\r\n        label=\"{{ 'ACTIONS.DELETE' | transloco }}\"\r\n        (click)=\"delete()\"\r\n      ></button>\r\n    </div>\r\n\r\n    <p-table\r\n      [value]=\"errorFiles$ | async\"\r\n      [(selection)]=\"selectedFiles\"\r\n      [scrollable]=\"true\"\r\n      (onRowSelect)=\"checkRowCount($event)\"\r\n      (onRowUnselect)=\"checkRowCount($event)\"\r\n      [paginator]=\"true\"\r\n      [rows]=\"10\"\r\n      [resizableColumns]=\"true\"\r\n      columnResizeMode=\"expand\"\r\n    >\r\n      <ng-template pTemplate=\"colgroup\">\r\n        <colgroup>\r\n          <col style=\"width: 3em\" />\r\n          <col *ngFor=\"let field of fields\" style=\"width: 150px\" />\r\n        </colgroup>\r\n      </ng-template>\r\n      <ng-template pTemplate=\"header\">\r\n        <tr>\r\n          <th>\r\n            <p-tableHeaderCheckbox></p-tableHeaderCheckbox>\r\n          </th>\r\n          <th pResizableColumn *ngFor=\"let field of fields\">\r\n            {{ field.description }}\r\n          </th>\r\n        </tr>\r\n      </ng-template>\r\n      <ng-template pTemplate=\"body\" let-exportFile>\r\n        <tr>\r\n          <td>\r\n            <p-tableCheckbox [value]=\"exportFile\"></p-tableCheckbox>\r\n          </td>\r\n          <td class=\"ui-resizable-column\">\r\n            <a\r\n              href=\"{{ exportSrv.getURL(exportFile.exportKey) }}\"\r\n              download=\"{{ exportFile.filename }}\"\r\n              >{{ exportFile.filename }}</a\r\n            >\r\n          </td>\r\n          <td class=\"ui-resizable-column\">{{ exportFile.formatType }}</td>\r\n          <td class=\"ui-resizable-column\">{{ exportFile.dataType }}</td>\r\n          <td class=\"ui-resizable-column\">{{ exportFile.email }}</td>\r\n          <td class=\"ui-resizable-column\">\r\n            {{ exportFile.addedOn | date: dateFormat }}\r\n          </td>\r\n        </tr>\r\n      </ng-template>\r\n    </p-table>\r\n    <div class=\"exportNoteDiv\">\r\n      <i class=\"exportNote\"> {{ 'PIM.EXPORT_NOTE' | transloco }} </i>\r\n    </div>\r\n  </div>\r\n</div>\r\n\r\n<p-confirmDialog [closeOnEscape]=\"false\" [closable]=\"false\"></p-confirmDialog>\r\n",
                styles: [""]
            },] }
];
ExportComponent.ctorParameters = () => [
    { type: ExportService },
    { type: ConfirmationService },
    { type: Store },
    { type: TranslocoService },
    { type: ToastrNotificationService$1 },
    { type: ActivatedRoute },
    { type: BaseAPIService },
    { type: PimService }
];

var DataTypeEnum;
(function (DataTypeEnum) {
    DataTypeEnum[DataTypeEnum["Numeric"] = 1] = "Numeric";
    DataTypeEnum[DataTypeEnum["Alphanumeric"] = 2] = "Alphanumeric";
    DataTypeEnum[DataTypeEnum["Yes_No"] = 3] = "Yes_No";
    DataTypeEnum[DataTypeEnum["Date"] = 4] = "Date";
    DataTypeEnum[DataTypeEnum["Image"] = 5] = "Image";
    DataTypeEnum[DataTypeEnum["Video"] = 6] = "Video";
    DataTypeEnum[DataTypeEnum["Document"] = 7] = "Document";
    DataTypeEnum[DataTypeEnum["DateTime"] = 8] = "DateTime";
    DataTypeEnum[DataTypeEnum["HandToolMaterial"] = 9] = "HandToolMaterial";
    DataTypeEnum[DataTypeEnum["PowerTool"] = 10] = "PowerTool";
    DataTypeEnum[DataTypeEnum["Status"] = 11] = "Status";
    DataTypeEnum[DataTypeEnum["UOM"] = 12] = "UOM";
    DataTypeEnum[DataTypeEnum["UOMDimension"] = 13] = "UOMDimension";
    DataTypeEnum[DataTypeEnum["UOMVolume"] = 14] = "UOMVolume";
    DataTypeEnum[DataTypeEnum["UOMWeight"] = 15] = "UOMWeight";
    DataTypeEnum[DataTypeEnum["Country"] = 16] = "Country";
    DataTypeEnum[DataTypeEnum["Currency"] = 17] = "Currency";
    DataTypeEnum[DataTypeEnum["Right_Left"] = 18] = "Right_Left";
    DataTypeEnum[DataTypeEnum["NumericDecimal"] = 19] = "NumericDecimal";
    DataTypeEnum[DataTypeEnum["Supplier"] = 20] = "Supplier";
    DataTypeEnum[DataTypeEnum["Id"] = 21] = "Id";
    DataTypeEnum[DataTypeEnum["UOMTime"] = 22] = "UOMTime";
    DataTypeEnum[DataTypeEnum["UOMCapacity"] = 23] = "UOMCapacity";
    DataTypeEnum[DataTypeEnum["UOMTemperature"] = 24] = "UOMTemperature";
    DataTypeEnum[DataTypeEnum["UOMSound"] = 25] = "UOMSound";
    DataTypeEnum[DataTypeEnum["SpinSpeedUOM"] = 26] = "SpinSpeedUOM";
    DataTypeEnum[DataTypeEnum["FreightClass"] = 27] = "FreightClass";
    DataTypeEnum[DataTypeEnum["Hierarchy"] = 28] = "Hierarchy";
    DataTypeEnum[DataTypeEnum["field_type_suggested_hierarchy"] = 29] = "field_type_suggested_hierarchy";
})(DataTypeEnum || (DataTypeEnum = {}));

const addImport = createAction('[Email Notification] Add Import', props());
const addImportSuccess = createAction('[Email Notification] Add Success', props());
const addImportFailure = createAction('[Email Notification] Add Failure');
const importProcessing = createAction('[Email Notification] Import Processing');
const initialState = { email: '' };
const emailNotificationReducer = createReducer(initialState);
function reducers(state, action) {
    return emailNotificationReducer(state, action);
}

const uploadFile = createAction('[File Selection] Upload File', props());
const uploadFileSuccess = createAction('[File Selection] Upload Success', props());
const uploadFileFailure = createAction('[File Selection] Upload Failure');
const resetFileSelection = createAction('[File Selection] Reset File Selection');
const initialState$1 = {
    fileGuid: null,
    fileName: null,
    fileType: 0
};
const ɵ0$3 = (state, action) => (Object.assign(Object.assign({}, state), { fileGuid: action.guid, fileName: action.fileName, fileType: action.fileType, delimiter: action.delimiter })), ɵ1$1 = () => initialState$1;
const fileSelectionReducer = createReducer(initialState$1, on(uploadFileSuccess, ɵ0$3), on(resetFileSelection, ɵ1$1));
const selectFileGuid = (state) => state.fileGuid;
const selectFileInfo = (state) => ({
    fileGuid: state.fileGuid,
    fileName: state.fileName,
    fileType: state.fileType,
    delimiter: state.delimiter,
});
const selectIsFileUploaded = (state) => state.fileGuid !== null;
function reducers$1(state, action) {
    return fileSelectionReducer(state, action);
}

// Effects Actions
const fetchFields = createAction('[Column Wizard] Fetch Product Fields');
const fetchFieldsSuccess = createAction('[Column Wizard] Fetch Fields Success', props());
const fetchFieldsFailure = createAction('[Column Wizard] Fetch Fields Failure');
const fetchAllowedValues = createAction('[Column Wizard] Fetch Allowed Values');
const fetchAllowedValuesSuccess = createAction('[Column Wizard] Fetch Allowed Values Success', props());
const fetchAllowedValuesFailure = createAction('[Column Wizard] Fetch Allowed Values Failure');
const fetchCountryList = createAction('[Column Wizard] Fetch Country List');
const fetchCountryListSuccess = createAction('[Column Wizard] Fetch Country List Success', props());
const fetchCountryListFailure = createAction('[Column Wizard] Fetch Country List Failure');
const fetchCurrencyList = createAction('[Column Wizard] Fetch Currency List');
const fetchCurrencyListSuccess = createAction('[Column Wizard] Fetch Currency List Success', props());
const fetchCurrencyListFailure = createAction('[Column Wizard] Fetch Currency List Failure');
const fetchDocumentList = createAction('[Column Wizard] Fetch Document List');
const fetchDocumentListSuccess = createAction('[Column Wizard] Fetch Document List Success', props());
const fetchDocumentListFailure = createAction('[Column Wizard] Fetch Document List Failure');
// State Actions
const assignColumn = createAction('[Column Wizard] Assign Column', props());
const unassignColumn = createAction('[Column Wizard] Unassign Column', props());
const uploadDestinationColumns = createAction('[Column Wizard] Upload Destination Columns', props());
const applyLayout = createAction('[Column Wizard] Apply Layout', props());
const resetColumnWizard = createAction('[Column Wizard] Reset Column Wizard');
const initialState$2 = {
    guid: '',
    sourceColumns: [],
    destinationColumns: [],
    allowedValues: [],
    currencyList: [],
    countryList: [],
    documentList: [],
};
// Sort function for destination columns. sorts by sorts first by category, then places id
// and required fields at the top, then sorts by the translated name, then ordered by
// array index if it is an array field.
const sortDestinationColumns = (a, b) => {
    const catDiff = a.categoryKey - b.categoryKey;
    if (catDiff === 0) {
        if (a.fieldKey === ProductFieldsEnum.id) {
            return -1;
        }
        else if (b.fieldKey === ProductFieldsEnum.id) {
            return 1;
        }
        else {
            if (a.required && b.required) {
                return a.fieldKey - b.fieldKey;
            }
            else if (a.required && !b.required) {
                return -1;
            }
            else if (!a.required && b.required) {
                return 1;
            }
            else {
                if (a.fieldKey === b.fieldKey) {
                    if (a.arrayIndex > b.arrayIndex) {
                        return 1;
                    }
                    else {
                        return -1;
                    }
                }
                else {
                    if (a.description > b.description) {
                        return 1;
                    }
                    else {
                        return -1;
                    }
                }
            }
        }
    }
    else {
        return catDiff;
    }
};
const ɵ0$4 = sortDestinationColumns;
// Left Join Fields loaded from the API with fields in the store
// functions to apply mappings from the 'mappedColumns' onto the 'fieldColumns'
const applyColumnMappings = (fieldColumns, mappedColumns, sourceColumns) => {
    return fieldColumns.map((fCol) => {
        // search for a mapping for the current product field
        let mCol = mappedColumns.find((c) => fCol.fieldKey === c.fieldKey && fCol.arrayIndex === c.arrayIndex);
        // if a mapping was found, search in the import source file columns for the column to map to.
        // if the source file column was found, apply the mapping to the field,
        // otherwise the source file has fewer columns than the layout we are trying to apply
        // and this column cannot be mapped
        if (mCol && mCol.assignedColumn) {
            const sCol = sourceColumns.find((c) => c.number === mCol.assignedColumn.number);
            if (sCol) {
                mCol = Object.assign(Object.assign({}, mCol), { assignedColumn: {
                        number: mCol.assignedColumn.number,
                        name: sCol.name,
                    } });
            }
            else {
                mCol = null;
            }
        }
        return Object.assign(Object.assign({}, fCol), { assignedColumn: mCol ? mCol.assignedColumn : null });
    });
};
const ɵ1$2 = (state, action) => (Object.assign(Object.assign({}, state), { destinationColumns: applyColumnMappings(action.fields, state.destinationColumns, state.sourceColumns) })), ɵ2 = (state, action) => (Object.assign(Object.assign({}, state), { destinationColumns: [
        ...state.destinationColumns.filter((x) => !(x.fieldKey === action.dst.fieldKey && x.arrayIndex === action.dst.arrayIndex)),
        Object.assign(Object.assign({}, state.destinationColumns.find((x) => x.fieldKey === action.dst.fieldKey && x.arrayIndex === action.dst.arrayIndex)), { assignedColumn: {
                number: action.src.number,
                name: action.src.name,
            } }),
    ] })), ɵ3 = (state, action) => (Object.assign(Object.assign({}, state), { destinationColumns: [
        ...state.destinationColumns.filter((x) => !(x.fieldKey === action.dst.fieldKey && x.arrayIndex === action.dst.arrayIndex)),
        Object.assign(Object.assign({}, action.dst), { assignedColumn: null }),
    ] })), ɵ4 = (state, action) => (Object.assign(Object.assign({}, state), { destinationColumns: [...action.dst] })), ɵ5 = (state, action) => (Object.assign(Object.assign({}, state), { sourceColumns: [...action.columns] })), ɵ6 = (state, action) => (Object.assign(Object.assign({}, state), { destinationColumns: applyColumnMappings(state.destinationColumns, action.layout.columns, state.sourceColumns) })), ɵ7 = (state, action) => (Object.assign(Object.assign({}, state), { allowedValues: action.allowedValues })), ɵ8 = (state, action) => (Object.assign(Object.assign({}, state), { countryList: action.countryList })), ɵ9 = (state, action) => (Object.assign(Object.assign({}, state), { currencyList: action.currencyList })), ɵ10 = () => initialState$2, ɵ11 = () => initialState$2;
const columnWizardReducer = createReducer(initialState$2, on(fetchFieldsSuccess, ɵ1$2), on(assignColumn, ɵ2), on(unassignColumn, ɵ3), on(uploadDestinationColumns, ɵ4), on(uploadFileSuccess, ɵ5), on(applyLayout, ɵ6), on(fetchAllowedValuesSuccess, ɵ7), on(fetchCountryListSuccess, ɵ8), on(fetchCurrencyListSuccess, ɵ9), on(resetColumnWizard, ɵ10), 
// Reset state after successful product import processing
on(importProcessing, ɵ11));
const selectDestinationColumns = (state) => [...state.destinationColumns].sort(sortDestinationColumns);
const selectSourceColumns = (state) => [...state.sourceColumns].sort((a, b) => a.number - b.number);
const selectIsLayoutValid = (state) => {
    return state.destinationColumns.filter((col) => col.required && !col.assignedColumn).length === 0;
};
const selectMappedColumns = (state) => state.destinationColumns.filter((col) => col.assignedColumn !== null);
const selectAllowedValues = (state) => state.allowedValues;
const selectCountries = (state) => state.countryList;
const selectCurrencies = (state) => state.currencyList;
const selectDocuments = (state) => state.documentList;
function reducers$2(state, action) {
    return columnWizardReducer(state, action);
}

const fetchSuppliers = createAction('[Import Options] Fetch Suppliers');
const fetchSuppliersSuccess = createAction('[Import Options] Fetch Suppliers Success', props());
const resetImportOptions = createAction('[Import Options] Reset Import Options');
const initialState$3 = {
    suppliers: [],
};
const ɵ0$5 = (state, action) => (Object.assign(Object.assign({}, state), { suppliers: action.suppliers })), ɵ1$3 = () => initialState$3;
const importOptionsReducer = createReducer(initialState$3, on(fetchSuppliersSuccess, ɵ0$5), on(resetImportOptions, ɵ1$3));
const selectSortedSuppliers = ({ suppliers }) => suppliers
    .slice()
    .sort(({ legalName: a }, { legalName: b }) => a.localeCompare(b));
const selectHasLoadedSuppliers = ({ suppliers }) => suppliers.length !== 0;
function reducers$3(state, action) {
    return importOptionsReducer(state, action);
}

const addLayout = createAction('[Layout Manager] Add', props());
const addLayoutSuccess = createAction('[Layout Manager] Add Success', props());
const addLayoutFailure = createAction('[Layout Manager] Add Failure');
const updateLayout = createAction('[Layout Manager] Update', props());
const updateLayoutSuccess = createAction('[Layout Manager] Update Success', props());
const updateLayoutFailure = createAction('[Layout Manager] Update Failure');
const deleteLayout = createAction('[Layout Manager] Delete', props());
const deleteLayoutSuccess = createAction('[Layout Manager] Delete Success', props());
const deleteLayoutFailure = createAction('[Layout Manager] Delete Failure');
const fetchLayouts = createAction('[Layout Manager] Fetch');
const fetchLayoutsSuccess = createAction('[Layout Manager] Fetch Success', props());
const fetchLayoutsFailure = createAction('[Layout Manager] Fetch Failure');
const initialState$4 = {
    availableLayouts: [],
    loadedLayoutKey: null,
};
const sortLayouts = (a, b) => {
    if (a.name > b.name) {
        return 1;
    }
    else if (a.name === b.name) {
        return 0;
    }
    else {
        return -1;
    }
};
const ɵ0$6 = sortLayouts;
const ɵ1$4 = (state, action) => (Object.assign(Object.assign({}, state), { availableLayouts: [...action.layouts] })), ɵ2$1 = (state, action) => (Object.assign(Object.assign({}, state), { availableLayouts: [
        ...state.availableLayouts.filter((layout) => !action.responses.find((response) => response.wasDeleted && response.layoutKey === layout.layoutKey)),
    ] })), ɵ3$1 = (state, action) => (Object.assign(Object.assign({}, state), { availableLayouts: [...state.availableLayouts, action.layout] })), ɵ4$1 = (state, action) => (Object.assign(Object.assign({}, state), { availableLayouts: [...state.availableLayouts.filter((layout) => layout.layoutKey !== action.layout.layoutKey), action.layout] })), ɵ5$1 = (state, action) => (Object.assign(Object.assign({}, state), { loadedLayoutKey: action.layout.layoutKey })), ɵ6$1 = (state) => (Object.assign(Object.assign({}, state), { loadedLayoutKey: null })), ɵ7$1 = () => initialState$4;
const layoutManagerReducers = createReducer(initialState$4, on(fetchLayoutsSuccess, ɵ1$4), on(deleteLayoutSuccess, ɵ2$1), on(addLayoutSuccess, ɵ3$1), on(updateLayoutSuccess, ɵ4$1), on(applyLayout, ɵ5$1), on(uploadFile, ɵ6$1), on(importProcessing, ɵ7$1));
const selectLayouts = (state) => [...state.availableLayouts].sort(sortLayouts);
const selectLoadedLayout = (state) => state.availableLayouts.find((l) => l.layoutKey === state.loadedLayoutKey);
function reducers$4(state, action) {
    return layoutManagerReducers(state, action);
}

// export function debug(reducer: ActionReducer<any>): ActionReducer<any> {
//   return (state, action) => {
//     console.log('state before', state);
//     console.log('action', action);
//     return reducer(state, action);
//   };
// }
function logout(reducer) {
    return (state, action) => reducer(action.type === actionTypes.LOGOUT ? undefined : state, action);
}
const metaReducers = [logout];
const pimFeatureSelector = createFeatureSelector('pim');
const ɵ0$7 = (state) => state.options;
const selectImportOptions = createSelector(pimFeatureSelector, ɵ0$7);
const sortedSuppliers = createSelector(selectImportOptions, selectSortedSuppliers);
const hasLoadedSuppliers = createSelector(selectImportOptions, selectHasLoadedSuppliers);
const ɵ1$5 = (state) => state.file;
const selectFileSelection = createSelector(pimFeatureSelector, ɵ1$5);
const fileGuid = createSelector(selectFileSelection, selectFileGuid);
const fileInfo = createSelector(selectFileSelection, selectFileInfo);
const isFileUploaded = createSelector(selectFileSelection, selectIsFileUploaded);
const ɵ2$2 = (state) => state.layout;
const selectLayoutManager = createSelector(pimFeatureSelector, ɵ2$2);
const layouts = createSelector(selectLayoutManager, selectLayouts);
const loadedLayout = createSelector(selectLayoutManager, selectLoadedLayout);
const ɵ3$2 = (state) => state.wizard;
const selectColumnWizard = createSelector(pimFeatureSelector, ɵ3$2);
const destinationColumns = createSelector(selectColumnWizard, selectDestinationColumns);
const sourceColumns = createSelector(selectColumnWizard, selectSourceColumns);
const mappedColumns = createSelector(selectColumnWizard, selectMappedColumns);
const isLayoutValid = createSelector(selectColumnWizard, selectIsLayoutValid);
const allowedValues = createSelector(selectColumnWizard, selectAllowedValues);
const currencies = createSelector(selectColumnWizard, selectCurrencies);
const countries = createSelector(selectColumnWizard, selectCountries);
const documents = createSelector(selectColumnWizard, selectDocuments);
const reducers$5 = {
    options: reducers$3,
    email: reducers,
    file: reducers$1,
    layout: reducers$4,
    wizard: reducers$2,
};

class ImportAssetComponent {
    constructor(spinnerSrv, PimSrv, toastSrv, store, transloco, messageService, http) {
        this.spinnerSrv = spinnerSrv;
        this.PimSrv = PimSrv;
        this.toastSrv = toastSrv;
        this.store = store;
        this.transloco = transloco;
        this.messageService = messageService;
        this.http = http;
        this.suppliers$ = of([]);
        this.selectedSupplier = null;
        this.validFiles = [];
        this.onSelectFlag = false;
        this.isUploading = false;
        this.uploadSuccess = false;
        this.subscriptions = [];
    }
    get uploadAssetUrl() {
        if (!this.selectedSupplier) {
            return null;
        }
        return urlJoin(this.PimSrv.getConfig().upsertAssetsEndpoint, this.selectedSupplier.accountKey);
    }
    ngOnInit() {
        this.store.dispatch(fetchAllowedValues());
        this.store.dispatch(fetchSuppliers());
        this.suppliers$ = this.store.select(sortedSuppliers).pipe(map((suppliers) => suppliers
            .map((supplier) => ({
            label: supplier.legalName,
            value: supplier,
        }))));
        this.assetTypes$ = this.store.select(allowedValues).pipe(map((fileTypes) => fileTypes.filter((t) => t.dataTypeKey === DataTypeEnum.Image ||
            t.dataTypeKey === DataTypeEnum.Video ||
            t.dataTypeKey === DataTypeEnum.Document)), tap((fileTypes) => (this.allowedFileTypes = fileTypes.map((f) => '.' + f.description.toLocaleLowerCase()))));
        this.imageTypes$ = this.assetTypes$.pipe(map((type) => this.mapFileTypes(type, DataTypeEnum.Image)));
        this.videoTypes$ = this.assetTypes$.pipe(map((type) => this.mapFileTypes(type, DataTypeEnum.Video)));
        this.documentTypes$ = this.assetTypes$.pipe(map((type) => this.mapFileTypes(type, DataTypeEnum.Document)));
        this.spinnerSrv.on();
        this.subscriptions.push(combineLatest([this.suppliers$, this.assetTypes$])
            .pipe(first(([suppliers, vals]) => suppliers.length !== 0 && vals.length !== 0), finalize(() => this.spinnerSrv.off()))
            .subscribe());
    }
    ngOnDestroy() {
        if (this.subscriptions) {
            this.subscriptions.forEach((subscription) => subscription.unsubscribe());
        }
    }
    onChange(event) {
        if (event.value !== this.selectedSupplier) {
            this.selectedSupplier = event.value;
            this.selectFile.nativeElement.value = null;
            this.onSelectFlag = false;
            this.validFiles = [];
        }
    }
    fileEquals(a, b) {
        return (a.name === b.name &&
            a.size === b.size &&
            a.type === b.type &&
            a.lastModified === b.lastModified);
    }
    onSelect(event) {
        this.onSelectFlag = true;
        const filesToAdd = [...event.target.files].filter((f) => !this.validFiles.find((v) => this.fileEquals(f, v)));
        this.validFiles = [...this.validFiles, ...filesToAdd];
        const invalidFiles = this.validFiles.some((file) => !this.allowedFileTypes.includes(`.${file.name.split('.').pop().toLocaleLowerCase()}`));
        if (invalidFiles) {
            this.toastSrv.errorNotify(`${this.transloco.translate('PIM.INVALID_FORMAT_MSG')} ${this.allowedFileTypes.join(' ')}`, null, 8000);
            this.setupUpload();
        }
    }
    upload() {
        const url = this.uploadAssetUrl;
        const formData = new FormData();
        this.validFiles.forEach((file) => {
            formData.append('file', file, file.name);
        });
        this.subscriptions.push(this.http.post(url, formData, {
            reportProgress: true,
            observe: 'events',
            withCredentials: true
        }).pipe(tap((event) => {
            if (!this.isUploading) {
                this.timeStamp = Date.now();
            }
            this.onProgress(event);
        }, error => this.onError(error.status)), finalize(() => {
            this.onUpload();
            this.setupUpload();
        })).subscribe());
    }
    cancel() {
        this.onSelectFlag = false;
        if (this.isUploading) {
            this.subscriptions.forEach((subscription) => subscription.unsubscribe());
        }
        this.isUploading = false;
        this.setupUpload();
    }
    onProgress($event) {
        this.onSelectFlag = true;
        this.isUploading = true;
        const time = Date.now() - this.timeStamp;
        if (time === 0 && $event.status !== 200) {
            return;
        }
        const currentProgress = Math.round(100 * $event.loaded / $event.total);
        if (this.prevProgress === 100 && $event.status === 200) {
            this.uploadSuccess = true;
            return;
        }
        const percent = (currentProgress - this.prevProgress) / 100;
        const chunk = percent * $event.loaded;
        const speed = ((chunk / 1024 / 1024) / (time / 1000));
        this.timeStamp = Date.now();
        this.prevProgress = currentProgress;
        const loadedFileSize = ($event.loaded / (1024 * 1024));
        const totalFileSize = ($event.total / (1024 * 1024));
        const remainedFileSize = totalFileSize - loadedFileSize;
        if (speed !== 0) {
            const timeLeftSeconds = (remainedFileSize / speed);
            this.timeLeft = Math.ceil(timeLeftSeconds / 60);
        }
        else if (currentProgress === 100) {
            this.timeLeft = 0;
        }
        this.loadedFile = loadedFileSize.toFixed(1);
        this.totalFile = totalFileSize.toFixed(1);
    }
    onUpload() {
        if (!this.uploadSuccess) {
            return;
        }
        this.messageService.clear('import-assets');
        this.messageService.add({
            key: 'import-assets',
            sticky: true,
            severity: 'success',
            detail: this.transloco.translate('PIM.IMPORT_SUCCESS_MSG', {
                value: this.validFiles.length,
            })
        });
    }
    onError(errorStatus) {
        this.setupUpload();
        this.messageService.clear('import-assets');
        const msg = errorStatus === 415 ?
            this.transloco.translate('PIM.UPLOAD_INVALID_SIGNATURE') :
            this.transloco.translate('PIM.UPLOAD_FAILED_MSG');
        this.messageService.add({
            key: 'import-assets',
            sticky: true,
            severity: 'error',
            detail: msg,
        });
        return null;
    }
    setupUpload() {
        this.validFiles = [];
        this.selectedSupplier = null;
        this.isUploading = false;
        this.prevProgress = 0;
        this.progressPercent = 0;
        this.uploadSuccess = false;
        this.onSelectFlag = false;
        this.selectFile.nativeElement.value = null;
    }
    mapFileTypes(fileTypes, assetType) {
        return fileTypes
            .filter((ft) => ft.dataTypeKey === assetType)
            .map((ft) => '.' + ft.description)
            .join(', ');
    }
}
ImportAssetComponent.decorators = [
    { type: Component, args: [{
                selector: 'lib-import-assets',
                template: "<p-toast key=\"import-assets\" position=\"top-center\" modal=\"true\" styleClass=\"user-notification\"></p-toast>\r\n<div class=\"import-container vertical-flow space-between-100\">\r\n  <h2>{{ 'PIM.IMPORT_ASSETS' | transloco }}</h2>\r\n  <div class=\"vertical-flow space-between-200\">\r\n\r\n    <div class=\"vertical-flow space-between-025\">\r\n      <label for=\"suppliers\"> {{ 'PIM.SUPPLIER' | transloco }}</label>\r\n      <div>\r\n        <p-dropdown [disabled]=\"(suppliers$ | async).length === 0\" [options]=\"suppliers$ | async\"\r\n          [ngModel]=\"selectedSupplier\" placeholder=\"{{ 'ACTIONS.SELECT' | transloco }}\" filter=\"true\" (onChange) = \"onChange($event)\"\r\n\r\n          filterBy=\"value.number,value.legalName\">\r\n          <ng-template let-option pTemplate=\"selectedItem\">\r\n            <span>{{ option.label }}</span>\r\n          </ng-template>\r\n          <ng-template let-option pTemplate=\"item\">\r\n            <div class=\"import-message\">\r\n              <span>{{ option.value.legalName }}</span>\r\n              <span>{{ option.value.number }}</span>\r\n            </div>\r\n          </ng-template>\r\n        </p-dropdown>\r\n      </div>\r\n    </div>\r\n\r\n    <div class=\"vertical-flow space-between-025\">\r\n      <label> {{ 'PIM.IMPORT_SELECT' | transloco }}</label>\r\n      <br>\r\n      <label> {{ 'PIM.IMPORT_FILE_SIZE' | transloco }}</label>\r\n      <br>\r\n\r\n      <label>\r\n        {{ 'PIM.IMPORT_ASSET_FILE_TYPES' | transloco }}\r\n        {{ 'COMMON.IMAGES' | transloco }}:\r\n        {{ imageTypes$ | async }}\r\n      </label>\r\n      <label>\r\n        {{ 'COMMON.VIDEOS' | transloco }}:\r\n        {{ videoTypes$ | async }}\r\n      </label>\r\n      <label>\r\n        {{ 'COMMON.DOCUMENTS' | transloco }}:\r\n        {{ documentTypes$ | async }}\r\n      </label>\r\n    </div>\r\n    <div class=\"space-before-075\">\r\n      <div class=\"file_upload\" >\r\n        <button pButton (click)=\"cancel()\" class=\"ds secondary cancelbutton\" [disabled]=\"!onSelectFlag\">\r\n          {{ 'ACTIONS.CANCEL' | transloco }}\r\n        </button>\r\n        <button pButton (click)=\"selectFile.click()\" class=\"ds primary\" [disabled]=\"isUploading || selectedSupplier === null\">\r\n          {{ 'ACTIONS.CHOOSE' | transloco }}\r\n        </button>\r\n        <button pButton (click)=\"upload()\" class=\"ds primary\" [disabled]=\"isUploading || !onSelectFlag\">\r\n          {{ 'ACTIONS.UPLOAD' | transloco }}\r\n        </button>\r\n        <input\r\n          #selectFile\r\n          type=\"file\"\r\n          (change)=\"onSelect($event)\"\r\n          [accept]= \"allowedFileTypes\"\r\n          style=\"display: none;\"\r\n          multiple=\"true\"\r\n        />\r\n      </div>\r\n\r\n      <ng-container *ngIf=\"onSelectFlag && validFiles.length !== 0 && !isUploading && selectedSupplier !== null\">\r\n        <p>\r\n          {{'PIM.IMPORT_SELECT_MSG'\r\n          | transloco: { value: validFiles.length }\r\n          }}\r\n        </p>\r\n      </ng-container>\r\n\r\n      <ng-container *ngIf=\"isUploading && validFiles.length !== 0\">\r\n        <div class=\"card\">\r\n          <p-progressBar [value]=\"prevProgress\" [showValue]=\"false\">\r\n          </p-progressBar>\r\n        </div>\r\n        <p class=\"transfer-percentage\" style=\"font-weight:bolder\">{{\r\n          'PIM.UPLOAD_PROGRESS'\r\n          | transloco: { value: prevProgress }\r\n          }}\r\n        </p>\r\n        <p class=\"uploading-info\">{{\r\n          'PIM.UPLOAD_FILE_NUM'\r\n          | transloco: { value: validFiles.length }\r\n          }}\r\n        <br>\r\n        {{\r\n          'PIM.UPLOAD_SIZE_PROGRESS'\r\n          | transloco: { value1: loadedFile, value2: totalFile }\r\n          }}\r\n        <br>\r\n        {{\r\n          'PIM.UPLOAD_TIME_REMAINING'\r\n          | transloco: { value: timeLeft }\r\n          }}\r\n        </p>\r\n      </ng-container>\r\n    </div>\r\n  </div>\r\n</div>\r\n",
                styles: [""]
            },] }
];
ImportAssetComponent.ctorParameters = () => [
    { type: SpinnerService$1 },
    { type: PimService },
    { type: ToastrNotificationService$1 },
    { type: Store },
    { type: TranslocoService },
    { type: MessageService },
    { type: HttpClient }
];
ImportAssetComponent.propDecorators = {
    selectFile: [{ type: ViewChild, args: ['selectFile',] }]
};

const CanDeactivateDialogKey = 'can-deactivate-dialog';
class CanDeactivateGuard {
    constructor(confirmationService, logger, transloco) {
        this.confirmationService = confirmationService;
        this.logger = logger;
        this.transloco = transloco;
    }
    canDeactivate(component, currentRoute, currentState, nextState) {
        if (component.deactivateDirective === undefined) {
            this.logger.error('No p-confirmDialog component with a `deactivateDialog` directive was found', 'CanDeactivateGuard.canDeactivate');
            return true;
        }
        if (component.canDeactivate(nextState)) {
            return true;
        }
        else {
            return new Observable((obs) => {
                var _a;
                this.confirmationService.confirm({
                    key: CanDeactivateDialogKey,
                    header: this.transloco.translate('ACTIONS.CONFIRM'),
                    message: (_a = component.deactivateDirective.deactivateMessage) !== null && _a !== void 0 ? _a : this.transloco.translate('COMMON.CONFIRM_LEAVE'),
                    icon: 'pi pi-exclamation-triangle',
                    accept: () => {
                        obs.next(true);
                        obs.complete();
                    },
                    reject: () => {
                        obs.next(false);
                        obs.complete();
                    },
                });
            });
        }
    }
}
CanDeactivateGuard.decorators = [
    { type: Injectable }
];
CanDeactivateGuard.ctorParameters = () => [
    { type: ConfirmationService },
    { type: LoggerService },
    { type: TranslocoService }
];

class DeactivateDialogDirective {
    constructor(dialog) {
        dialog.key = CanDeactivateDialogKey;
    }
}
DeactivateDialogDirective.decorators = [
    { type: Directive, args: [{
                selector: 'p-confirmDialog[deactivateDialog]',
            },] }
];
DeactivateDialogDirective.ctorParameters = () => [
    { type: ConfirmDialog }
];
DeactivateDialogDirective.propDecorators = {
    deactivateMessage: [{ type: Input }]
};

class ReloadModule {
}
ReloadModule.decorators = [
    { type: NgModule, args: [{
                declarations: [
                    DeactivateDialogDirective,
                ],
                imports: [
                    CommonModule,
                    UtilsModule,
                    ConfirmDialogModule,
                ],
                exports: [
                    DeactivateDialogDirective,
                ]
            },] }
];

class ComponentCanDeactivateDirective {
    unloadNotification($event) {
        if (!this.canDeactivate()) {
            $event.returnValue = true;
        }
    }
}
ComponentCanDeactivateDirective.decorators = [
    { type: Directive }
];
ComponentCanDeactivateDirective.propDecorators = {
    deactivateDirective: [{ type: ViewChild, args: [DeactivateDialogDirective,] }],
    unloadNotification: [{ type: HostListener, args: ['window:beforeunload', ['$event'],] }]
};

const MAX_DISTANCE = 2;
class ColumnWizardComponent extends ComponentCanDeactivateDirective {
    constructor(store, route, router, spinnerSrv, toastSrv, translocoSrv) {
        super();
        this.store = store;
        this.route = route;
        this.router = router;
        this.spinnerSrv = spinnerSrv;
        this.toastSrv = toastSrv;
        this.translocoSrv = translocoSrv;
        this.srcColumns = of([]);
        this.productFields = of([]);
        this.dstColumns = of([]);
        this.allowedValues = [];
        this.countries = [];
        this.currencies = [];
        this.documents = [];
        this.subscriptions = [];
        this.fixedValues = [];
        this.selectedLayout$ = of('');
        this.documentsDataTypes = '';
        this.imagesDataTypes = '';
        this.videosDataTypes = '';
        this.infoMessageDataTypes = '';
        this.errorMapByNumber = new Map();
        this.srcMapByName = new Map();
        this.srcMapByNumber = new Map();
        this.showMappingErrors = false;
        this.showAssignMessage = false;
        this.errors = [];
        this.imports = [];
    }
    canDeactivate(nextState) {
        if (!nextState) {
            return false;
        }
        const url = nextState.url.split('/').pop();
        return url === 'layout-manager' || url === 'email-notify';
    }
    ngOnInit() {
        this.spinnerSrv.on();
        this.store.dispatch(fetchFields());
        this.store.dispatch(fetchAllowedValues());
        this.store.dispatch(fetchCurrencyList());
        this.store.dispatch(fetchCountryList());
        this.productFields = this.store.select(destinationColumns);
        this.dstColumns = this.productFields.pipe(map((cols) => cols.filter((col) => col.isIncluded)));
        this.srcColumns = this.store.select(sourceColumns);
        this.subscriptions.push(combineLatest([
            this.store
                .select(destinationColumns)
                .pipe(first((dst) => dst.length !== 0)),
            this.store
                .select(sourceColumns)
                .pipe(first((src) => src.length !== 0)),
            this.store
                .select(currencies)
                .pipe(first((currencies) => currencies.length !== 0)),
            this.store
                .select(countries)
                .pipe(first((countries) => countries.length !== 0)),
            this.store.select(allowedValues).pipe(first((av) => av.length !== 0), tap((allowedValue) => {
                allowedValue.forEach((value) => {
                    // if allowed values are document, image or video type,
                    // it populates this arrays
                    if (Number(value.dataTypeKey) === DataTypeEnum.Document) {
                        if (this.documentsDataTypes !== '') {
                            this.documentsDataTypes += ', ';
                        }
                        this.documentsDataTypes += '.' + value.description;
                    }
                    else if (Number(value.dataTypeKey) === DataTypeEnum.Image) {
                        if (this.imagesDataTypes !== '') {
                            this.imagesDataTypes += ', ';
                        }
                        this.imagesDataTypes += '.' + value.description;
                    }
                    else if (Number(value.dataTypeKey) === DataTypeEnum.Video) {
                        if (this.videosDataTypes !== '') {
                            this.videosDataTypes += ', ';
                        }
                        this.videosDataTypes += '.' + value.description;
                    }
                });
            })),
        ])
            .pipe(finalize(() => this.spinnerSrv.off()))
            .subscribe(([_dst, src, currencies, countries, allowedValues]) => {
            this.currencies = currencies;
            this.countries = countries;
            this.allowedValues = allowedValues;
            this.setupMaps(src);
        }));
        this.subscriptions.push(this.store
            .pipe(first(), select(selectors.readOnlyFields))
            .subscribe((fields) => {
            this.imports = fields;
        }));
        this.selectedLayout$ = this.store
            .select(loadedLayout)
            .pipe(map((loadedLayout) => `${loadedLayout
            ? loadedLayout.name
            : this.translocoSrv.translate('PIM.LAYOUT_NOT_SELECTED')}`));
        // Intialize fixedvalues array
        this.fixedValues.push({
            fixedValueCode: '',
            fixedValueName: '',
            dataTypeName: '',
        });
    }
    ngOnDestroy() {
        if (this.subscriptions) {
            this.subscriptions.forEach((subscription) => subscription.unsubscribe());
        }
    }
    ngAfterViewInit() {
        this.subscriptions.push(combineLatest([
            this.store
                .select(sourceColumns)
                .pipe(first((src) => src.length !== 0)),
            this.store.select(loadedLayout),
        ])
            .pipe(first(), tap(([src, layout]) => {
            if (layout &&
                layout.columns.filter((column) => column.assignedColumn.number > src.length).length > 0) {
                this.toastSrv.warnNotify(this.translocoSrv.translate('PIM.IMPORT_LAYOUT_WARNING'));
            }
        }))
            .subscribe());
    }
    dragStart(event, column) {
        this.draggedColumn = column;
    }
    drop(event, col) {
        if (this.draggedColumn) {
            this.store.dispatch(assignColumn({ src: this.draggedColumn, dst: col }));
            this.subscriptions.push(this.store
                .select(isLayoutValid)
                .pipe(first())
                .subscribe((validLayout) => {
                if (validLayout && this.showLayoutError) {
                    this.showLayoutError = false;
                }
                this.draggedColumn = null;
            }));
        }
    }
    dragEnd(event) {
        this.draggedColumn = null;
    }
    clear(col) {
        if (col) {
            this.store.dispatch(unassignColumn({ dst: col }));
        }
    }
    displayInformation(col) {
        this.showAllowedValues = true;
        this.fixedValues = [];
        this.infoMessage = '';
        if (col.dataTypeKey === DataTypeEnum.Image) {
            this.showInfoMessage = true;
            this.infoMessageDataTypes = this.imagesDataTypes;
            this.infoMessage = this.translocoSrv.translate('PIM.IMPORT_DATATYPE_INFO', { datatypes: this.infoMessageDataTypes });
        }
        else if (col.dataTypeKey === DataTypeEnum.Video) {
            this.showInfoMessage = true;
            this.infoMessageDataTypes = this.videosDataTypes;
            this.infoMessage = this.translocoSrv.translate('PIM.IMPORT_DATATYPE_INFO', { datatypes: this.infoMessageDataTypes });
        }
        else if (col.dataTypeKey === DataTypeEnum.Document) {
            this.showInfoMessage = true;
            this.infoMessageDataTypes = this.documentsDataTypes;
            this.infoMessage = this.translocoSrv.translate('PIM.IMPORT_DATATYPE_INFO', { datatypes: this.infoMessageDataTypes });
        }
        else if (col.dataTypeKey === DataTypeEnum.Alphanumeric &&
            col.fieldKey === ProductFieldsEnum.supplierProductKey) {
            this.showInfoMessage = true;
            this.infoMessage = this.translocoSrv.translate('PIM.IMPORT_ID_INFO');
        }
        else if (col.dataTypeKey === DataTypeEnum.Country) {
            this.showInfoMessage = false;
            this.countries.forEach((country) => {
                this.fixedValues.push({
                    fixedValueCode: country.countryCode,
                    fixedValueName: country.countryName,
                    dataTypeName: 'Country',
                });
            });
        }
        else if (col.dataTypeKey === DataTypeEnum.Currency) {
            this.showInfoMessage = false;
            this.currencies.forEach((currency) => {
                this.fixedValues.push({
                    fixedValueCode: currency.currencyCode,
                    fixedValueName: currency.currencyName,
                    dataTypeName: 'Currency',
                });
            });
        }
        else {
            this.showInfoMessage = false;
            this.allowedValues.forEach((value) => {
                if (value.dataTypeKey === col.dataTypeKey) {
                    this.fixedValues.push({
                        fixedValueCode: value.allowedValueKey,
                        fixedValueName: value.description,
                        dataTypeName: value.dataTypeDescription,
                    });
                }
            });
        }
    }
    submitLayout() {
        this.subscriptions.push(this.store
            .select(isLayoutValid)
            .pipe(first())
            .subscribe((validLayout) => {
            if (!validLayout) {
                this.showLayoutError = true;
            }
            else {
                this.router.navigate(['../email-notify'], {
                    relativeTo: this.route,
                    skipLocationChange: true,
                });
            }
        }));
    }
    autoAssign() {
        this.subscriptions.push(this.store
            .select(destinationColumns)
            .pipe(first(), tap((columns) => {
            this.assignColumns(columns);
            this.nonAssignedColumnsNum = this.errorMapByNumber.size;
            this.assignedColumnsNum =
                this.srcMapByNumber.size - this.nonAssignedColumnsNum;
            this.showUnMappedSrc();
        }), finalize(() => {
            this.showAssignMessage = true;
            if (this.errorMapByNumber.size > 0) {
                this.showMappingErrors = true;
            }
        }))
            .subscribe());
    }
    displayErrors(col) {
        this.showAllowedValues = true;
        this.showInfoMessage = true;
        this.infoMessage = this.translocoSrv.translate(this.errorMapByNumber.get(col.number));
    }
    assignColumns(columns) {
        return new Promise((resolve) => {
            const { assignedColumns, inactiveColumns, unassignedColumns } = matchColumns(this.srcMapByName, columns);
            assignedColumns.forEach(column => this.errorMapByNumber.delete(column.assignedColumn.number));
            inactiveColumns.forEach(index => this.errorMapByNumber.set(index, 'PIM.IMPORT_PRODUCT_FIELD_NOT_ACTIVE'));
            this.store.dispatch(uploadDestinationColumns({
                dst: [...assignedColumns, ...unassignedColumns],
            }));
            resolve('done');
        });
    }
    setupMaps(srcColumns) {
        const nonAssignedSrcColumns = [];
        srcColumns.forEach((column) => {
            let isImported = false;
            this.imports.forEach((field) => {
                if (column.name === field.description) {
                    isImported = true;
                }
            });
            if (!isImported) {
                this.errorMapByNumber.set(column.number, 'PIM.SOURCE_NOT_MAPPED');
                this.srcMapByNumber.set(column.number, column);
                if (!this.srcMapByName.get(column.name)) {
                    this.srcMapByName.set(column.name, column.number);
                }
                else {
                    this.errorMapByNumber.set(column.number, 'PIM.DUPLICATE_SOURCE_COLUMN');
                    nonAssignedSrcColumns.push(column);
                }
            }
        });
        nonAssignedSrcColumns.forEach((column) => {
            this.errorMapByNumber.set(this.srcMapByName.get(column.name), 'PIM.DUPLICATE_SOURCE_COLUMN');
            this.srcMapByName.delete(column.name);
        });
    }
    showUnMappedSrc() {
        this.errors = [];
        this.errorMapByNumber.forEach((value, key) => {
            const x = this.srcMapByNumber.get(key);
            if (x) {
                this.errors.push(Object.assign(Object.assign({}, x), { error: this.translocoSrv.translate(value) }));
            }
        });
        if (this.errorMapByNumber.size > 0) {
            this.showErrorsDialogue = true;
        }
    }
}
ColumnWizardComponent.decorators = [
    { type: Component, args: [{
                selector: 'lib-column-wizard',
                template: "<div id=\"column-wizard\">\r\n  <div>\r\n    <h2>\r\n      {{ 'PIM.IMPORT_PRODUCT_DATA' | transloco }}\r\n    </h2>\r\n  </div>\r\n  <div class=\"lbmx-grid-layout\">\r\n    <div class=\"left-header brand-light-grey-bg\">\r\n      <h3 class=\"margin-bottom-4\">{{ 'PIM.IMPORT_SOURCE_COLS' | transloco }}</h3>\r\n      <p class=\"margin-bottom-12 margin-top-4\">{{ 'PIM.LAYOUT_SELECTED' | transloco }} {{ selectedLayout$ | async }}</p>\r\n    </div>\r\n    <div class=\"right-header brand-light-grey-bg destination-title-bar\">\r\n      <div class=\"destination-column-title\">\r\n        <h3 class=\"margin-bottom-4\">{{ 'PIM.IMPORT_DESTINATION_COLS' | transloco }}</h3>\r\n      </div>\r\n      <div class=\"auto-assign-btn\">\r\n        <button pButton class=\"right-content ds tertiary small\" label=\"{{ 'PIM.AUTO_ASSIGN' | transloco }}\" (click)=\"autoAssign()\"></button>\r\n        <div *ngIf=\"showAssignMessage\" class=\"auto-assign-message\">\r\n          <div class=\"auto-assign-information\">{{ 'PIM.ASSIGNED' | transloco }}</div>\r\n          <div class=\"auto-assign-number\">{{ assignedColumnsNum }}</div>\r\n        </div>\r\n        <div *ngIf=\"showAssignMessage\" class=\"auto-assign-message\">\r\n          <div class=\"auto-assign-information\">\r\n            <i (click)=\"showUnMappedSrc()\" *ngIf=\"showMappingErrors\" class=\"pi pi-info-circle pi-info-circle-active pi-info-circle-clickable\"></i>\r\n            {{ 'PIM.NOT_ASSIGNED' | transloco }}\r\n          </div>\r\n          <div class=\"auto-assign-number\">{{ nonAssignedColumnsNum }}</div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n    <div class=\"left-content\">\r\n      <p-table [value]=\"srcColumns | async\" [responsive]=\"true\" [scrollable]=\"true\" scrollHeight=\"400px\">\r\n        <ng-template pTemplate=\"header\">\r\n          <tr>\r\n            <th>{{ 'COMMON.NAME' | transloco }}</th>\r\n          </tr>\r\n        </ng-template>\r\n        <ng-template pTemplate=\"body\" let-col>\r\n          <tr pDraggable (dragstart)=\"dragStart($event, col)\" (dragend)=\"dragEnd($event)\" class=\"table-no-background\">\r\n            <td [ngStyle]=\"{ width: '30px' }\">{{ col.number }}</td>\r\n            <td>{{ col.name }}</td>\r\n            <td [ngStyle]=\"{ width: '20px' }\" class=\"no-padding\">\r\n              <i *ngIf=\"showMappingErrors && errorMapByNumber.get(col.number)\" (click)=\"displayErrors(col)\" class=\"pi pi-info-circle pi-info-circle-active pi-info-circle-clickable\"></i>\r\n            </td>\r\n          </tr>\r\n        </ng-template>\r\n      </p-table>\r\n    </div>\r\n    <div class=\"right-content\">\r\n      <div>\r\n        <p-table [value]=\"dstColumns | async\" [scrollable]=\"true\" [responsive]=\"true\" scrollHeight=\"400px\">\r\n          <ng-template pTemplate=\"header\">\r\n            <tr>\r\n              <th [ngStyle]=\"{ width: '90px' }\">{{ 'COMMON.REQUIRED' | transloco }}</th>\r\n              <th>{{ 'PIM.SOURCE' | transloco }}</th>\r\n              <th>{{ 'PIM.IMPORT_DESTINATION_CATEGORY' | transloco }}</th>\r\n              <th>{{ 'PIM.IMPORT_DESTINATION_FILEDS' | transloco }}</th>\r\n              <th>{{ 'PIM.DATA_TYPES' | transloco }}</th>\r\n              <th [ngStyle]=\"{ width: '20px' }\"></th>\r\n            </tr>\r\n          </ng-template>\r\n          <ng-template pTemplate=\"body\" let-col>\r\n            <tr pDroppable (onDrop)=\"drop($event, col)\">\r\n              <td [ngStyle]=\"{ width: '90px' }\">{{ col.required ? 'Yes' : 'No' }}</td>\r\n              <td>\r\n                <i *ngIf=\"col.assignedColumn\" class=\"pi pi-times\" style=\"cursor: pointer; font-size: 1em\" (click)=\"clear(col)\"></i>\r\n                {{ col.assignedColumn?.name }}\r\n              </td>\r\n              <td>{{ col.categoryName }}</td>\r\n              <td>{{ col.description }}</td>\r\n              <td>{{ col.dataTypeName }}</td>\r\n              <td [ngStyle]=\"{ width: '20px' }\" class=\"no-padding\">\r\n                <i *ngIf=\"col.isInfoDisplayed\" (click)=\"displayInformation(col)\" class=\"pi pi-info-circle pi-info-circle-active pi-info-circle-clickable\"></i>\r\n              </td>\r\n            </tr>\r\n          </ng-template>\r\n        </p-table>\r\n      </div>\r\n      <div>\r\n        <p *ngIf=\"showLayoutError\" class=\"error\">{{ 'PIM.IMPORT_COLS_ERROR' | transloco }}</p>\r\n      </div>\r\n      <div class=\"horizontal-flow space-between-100\" style=\"margin-top: 3rem\">\r\n        <button\r\n          pButton\r\n          class=\"ds secondary\"\r\n          label=\"{{ 'ACTIONS.CANCEL' | transloco }}\"\r\n          [routerLink]=\"['../']\"\r\n          [skipLocationChange]=\"true\"\r\n        ></button>\r\n        <button\r\n          pButton\r\n          class=\"ds\"\r\n          label=\"{{ 'PIM.IMPORT_LAYOUT_MANAGER' | transloco }}\"\r\n          [routerLink]=\"['../layout-manager']\"\r\n          [skipLocationChange]=\"true\"\r\n        ></button>\r\n        <button pButton class=\"ds\" label=\"{{ 'ACTIONS.FINISH' | transloco }}\" (click)=\"submitLayout()\"></button>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n\r\n<!-- Dialog to show when there are unsaved changes -->\r\n<p-confirmDialog deactivateDialog [closeOnEscape]=\"false\" [closable]=\"false\"></p-confirmDialog>\r\n\r\n<!-- Dialog to display allowed values list -->\r\n<p-dialog\r\n  header=\"{{ 'COMMON.INFORMATION' | transloco }}\"\r\n  [(visible)]=\"showAllowedValues\"\r\n  styleClass=\"import-info-dialogue\"\r\n  [baseZIndex]=\"10000\"\r\n  [draggable]=\"false\"\r\n  [resizable]=\"false\"\r\n  position=\"center\"\r\n>\r\n  <ng-container *ngIf=\"showInfoMessage; else valuesTable\">\r\n    {{ infoMessage }}\r\n  </ng-container>\r\n  <ng-template #valuesTable>\r\n    <div class=\"padding-bottom-5\">{{ 'PIM.IMPORT_INFO_MESSAGE' | transloco }}</div>\r\n    <p-table [value]=\"fixedValues\" [scrollable]=\"true\" scrollHeight=\"200px\" class=\"margin-top-5\">\r\n      <ng-template pTemplate=\"header\">\r\n        <tr class=\"list-header\">\r\n          <th [ngStyle]=\"{ width: '5vw' }\">Code</th>\r\n          <th>{{ fixedValues[0].dataTypeName }}</th>\r\n        </tr>\r\n      </ng-template>\r\n      <ng-template pTemplate=\"body\" let-col>\r\n        <tr pDraggable (dragstart)=\"dragStart($event, col)\" (dragend)=\"dragEnd($event)\" class=\"table -no-background\">\r\n          <td [ngStyle]=\"{ width: '5vw' }\">{{ col.fixedValueCode }}</td>\r\n          <td>{{ col.fixedValueName }}</td>\r\n        </tr>\r\n      </ng-template>\r\n    </p-table>\r\n  </ng-template>\r\n</p-dialog>\r\n\r\n<p-dialog\r\n  header=\"{{ 'PIM.SOURCE_NOT_ASSIGNED' | transloco }}\"\r\n  [(visible)]=\"showErrorsDialogue\"\r\n  [baseZIndex]=\"10000\"\r\n  [draggable]=\"false\"\r\n  [resizable]=\"false\"\r\n  position=\"center\"\r\n  [style]=\"{ width: '40vw' }\"\r\n>\r\n  <ng-container>\r\n    <p-table [value]=\"errors\">\r\n      <ng-template pTemplate=\"header\">\r\n        <tr>\r\n          <th style=\"width: 4em\">{{ 'COMMON.COLUMN' | transloco }}</th>\r\n          <th>{{ 'COMMON.NAME' | transloco }}</th>\r\n          <th>{{ 'COMMON.ERROR' | transloco }}</th>\r\n        </tr>\r\n      </ng-template>\r\n      <ng-template pTemplate=\"body\" let-col>\r\n        <tr>\r\n          <td>{{ col.number }}</td>\r\n          <td>{{ col.name }}</td>\r\n          <td>{{ col.error }}</td>\r\n        </tr>\r\n      </ng-template>\r\n    </p-table>\r\n  </ng-container>\r\n</p-dialog>\r\n",
                styles: [""]
            },] }
];
ColumnWizardComponent.ctorParameters = () => [
    { type: Store },
    { type: ActivatedRoute },
    { type: Router },
    { type: SpinnerService$1 },
    { type: ToastrNotificationService$1 },
    { type: TranslocoService }
];
function levenshtein(source, target) {
    const d = new Array();
    for (let i = 0; i <= target.length; i++) {
        d[i] = i;
    }
    for (let i = 1; i <= source.length; i++) {
        let previousDiagonal = d[0];
        let previousColumn = d[0]++;
        for (let j = 1; j <= target.length; j++) {
            const insertOrDelete = Math.min(previousColumn, d[j]) + 1;
            const edit = previousDiagonal + (source[i - 1] === target[j - 1] ? 0 : 1);
            previousColumn = Math.min(insertOrDelete, edit);
            previousDiagonal = d[j];
            d[j] = previousColumn;
        }
    }
    return d[target.length];
}
function fuzzyMatch(srcMap, description) {
    let closestDistance = MAX_DISTANCE + 1;
    let index = srcMap.get(description);
    let name;
    if (index) {
        return { index, name: description, distance: 0 };
    }
    const normalizedDescription = description.replace(/\s/g, '').toLowerCase();
    srcMap.forEach((val, key) => {
        const normalizedKey = key.replace(/\s/g, '').toLowerCase();
        const distance = levenshtein(normalizedKey, normalizedDescription);
        if (distance < closestDistance) {
            closestDistance = distance;
            index = val;
            name = key;
        }
    });
    if (normalizedDescription.length < 2 && closestDistance > normalizedDescription.length) {
        // For small descriptions, the edit length must be smaller than the description length
        // Permits D -> 3D matching but rejects A -> 3D matching
        return undefined;
    }
    return index && { index, name, distance: closestDistance };
}
// exported for testing purposes
function matchColumns(sourceMap, columns) {
    const assignedColumns = [];
    const unassignedColumns = [];
    const inactiveColumns = [];
    const bestSourceMatches = new Map();
    columns.forEach((column) => {
        const match = fuzzyMatch(sourceMap, column.description);
        if (!match) {
            // No close matches found for this column
            unassignedColumns.push(column);
            return;
        }
        const { index, name, distance } = match;
        const existing = bestSourceMatches.get(name);
        if (!existing || distance < existing.distance) {
            if (existing) {
                // Existing match gets kicked out of the tenative assignment
                unassignedColumns.push(existing.column);
            }
            bestSourceMatches.set(name, { index, column, distance });
        }
        else {
            // Neither matches an existing name nor is it a better match
            unassignedColumns.push(column);
        }
    });
    bestSourceMatches.forEach(({ column, index }, name) => {
        if (column.isIncluded) {
            assignedColumns.push(Object.assign(Object.assign({}, column), { assignedColumn: {
                    number: index,
                    name
                } }));
        }
        else {
            inactiveColumns.push(index);
            unassignedColumns.push(column);
        }
    });
    return { assignedColumns, inactiveColumns, unassignedColumns };
}

class EmailNotificationComponent extends ComponentCanDeactivateDirective {
    constructor(fb, store, router, route) {
        super();
        this.fb = fb;
        this.store = store;
        this.router = router;
        this.route = route;
        this.subscriptions = [];
        this.emailGroup = this.fb.group({
            email: ['', Validators.email],
        });
    }
    ngOnInit() {
        this.subscriptions.push(this.route.data.subscribe((data) => {
            this.isPdx = data.isPdx;
        }));
        this.subscriptions.push(this.store
            .select(selectors.userProfile)
            .pipe(take(1))
            .subscribe((user) => this.emailGroup.get('email').setValue(user.sub)));
    }
    ngOnDestroy() {
        if (this.subscriptions) {
            this.subscriptions.forEach((subscription) => subscription.unsubscribe());
        }
    }
    canDeactivate(nextState) {
        if (!nextState) {
            return false;
        }
        const url = nextState.url.split('/').pop();
        return url === 'column-wizard' || url === 'finish';
    }
    nextPage() {
        this.emailGroup.markAllAsTouched();
        if (this.emailGroup.valid) {
            const email = this.emailGroup.value['email'];
            this.store.dispatch(addImport({ email, fromPdx: this.isPdx }));
            this.router.navigate(['../finish'], {
                relativeTo: this.route,
                skipLocationChange: true,
            });
        }
    }
}
EmailNotificationComponent.decorators = [
    { type: Component, args: [{
                selector: 'lib-email-notification',
                template: "<div class=\"import-container vertical-flow space-between-100\">\r\n  <h2>\r\n    {{ 'PIM.IMPORT_PRODUCT_DATA' | transloco }}\r\n  </h2>\r\n  <form [formGroup]=\"emailGroup\" (ngSubmit)=\"nextPage()\">\r\n    <div class=\"vertical-flow space-between-025\">\r\n      <label for=\"email\"> {{ 'COMMON.EMAIL_ADDRESS' | transloco }}</label>\r\n      <div>\r\n        <input\r\n          pInputText\r\n          class=\"ui-inputtext width-100\"\r\n          type=\"text\"\r\n          formControlName=\"email\"\r\n          placeholder=\"Hello@lbmx.com\"\r\n          required\r\n          maxlength=\"100\"\r\n        />\r\n      </div>\r\n      <span class=\"feedback\"> <lib-control-message [control]=\"emailGroup.get('email')\"></lib-control-message></span>\r\n    </div>\r\n\r\n    <div class=\"horizontal-flow space-between-100\">\r\n      <button\r\n        pButton\r\n        class=\"ds secondary width-50\"\r\n        label=\"{{ 'ACTIONS.CANCEL' | transloco }}\"\r\n        [routerLink]=\"['/PIMModule/imports/import-products/column-wizard']\"\r\n        [skipLocationChange]=\"true\"\r\n        type=\"button\"\r\n      ></button>\r\n      <button pButton class=\"ds width-50\" label=\"{{ 'ACTIONS.SUBMIT' | transloco }}\" type=\"submit\"></button>\r\n    </div>\r\n  </form>\r\n</div>\r\n\r\n<p-confirmDialog deactivateDialog [closeOnEscape]=\"false\" [closable]=\"false\"></p-confirmDialog>\r\n",
                styles: [""]
            },] }
];
EmailNotificationComponent.ctorParameters = () => [
    { type: FormBuilder },
    { type: Store },
    { type: Router },
    { type: ActivatedRoute }
];

class FileUploadRequest {
}

class FileSelectionComponent extends ComponentCanDeactivateDirective {
    constructor(store, toastSrv, translocoSrv, route, router) {
        super();
        this.store = store;
        this.toastSrv = toastSrv;
        this.translocoSrv = translocoSrv;
        this.route = route;
        this.router = router;
        this.importFile = null;
        this.isFileUploading = false;
        this.formatError = false;
    }
    ngOnInit() {
        // Reset the state
        this.store.dispatch(resetFileSelection());
        this.store.dispatch(resetColumnWizard());
        // pre-fetch layouts, fields and allowed values
        this.store.dispatch(fetchLayouts());
        this.store.dispatch(fetchFields());
        this.store.dispatch(fetchAllowedValues());
        this.store.dispatch(fetchCountryList());
        this.store.dispatch(fetchCurrencyList());
        this.fileUploadSubscription = this.store.select(isFileUploaded).pipe(first(f => f), tap(() => this.router.navigate(['./column-wizard'], {
            relativeTo: this.route,
            skipLocationChange: true
        }))).subscribe();
    }
    ngOnDestroy() {
        this.fileUploadSubscription.unsubscribe();
    }
    canDeactivate(nextState) {
        return !this.importFile || nextState && nextState.url.split('/').pop() === 'column-wizard';
    }
    onSelectFile(event) {
        const file = event.target.files[0];
        if (file) {
            const extension = file.name.split('.').pop().toLocaleLowerCase();
            const extensions = ['csv', 'xlsx'];
            if (extensions.includes(extension)) {
                this.importFile = file;
            }
            else {
                this.importFile = null;
                this.toastSrv.errorNotify(this.translocoSrv.translate('PIM.INVALID_FORMAT_MSG') + extensions, null, 8000);
            }
        }
    }
    uploadFile() {
        this.store.dispatch(uploadFile({ request: this.buildFileUploadRequest(this.importFile), file: this.importFile }));
        this.isFileUploading = true;
    }
    buildFileUploadRequest(file) {
        const extension = file.name.split('.').pop().toLocaleLowerCase();
        let fileType = 0;
        let delimiter = null;
        const headerLines = 1;
        switch (extension) {
            case 'xls':
                fileType = 1;
                break;
            case 'xlsx':
                fileType = 2;
                delimiter = '';
                break;
            case 'csv':
                fileType = 3;
                delimiter = ',';
                break;
        }
        const request = new FileUploadRequest();
        request.delimiter = delimiter;
        request.fileType = fileType;
        request.headerLines = headerLines;
        return request;
    }
}
FileSelectionComponent.decorators = [
    { type: Component, args: [{
                selector: 'lib-file-selection',
                template: "<div class=\"import-files-selection-container vertical-flow space-between-100\">\r\n  <h2>\r\n    {{ 'PIM.IMPORT_PRODUCT_DATA' | transloco }}\r\n  </h2>\r\n  <ng-container *ngIf=\"!isFileUploading; else fileUploading\">\r\n    <div class=\"vertical-flow space-between-100\">\r\n      <p class=\"white-space-pre-line\">\r\n        {{ 'PIM.IMPORT_DOCUMENT_TYPE_ACCEPTED' | transloco }}\r\n      </p>\r\n      <div class=\"horizontal-flow space-between-050\">\r\n        <div class=\"import-file-name-container\">\r\n          <input\r\n            pInputText\r\n            type=\"text\"\r\n            class=\"ui-inputtext\"\r\n            disabled\r\n            value=\"{{ importFile ? importFile.name : null }}\"\r\n            placeholder=\"import file\"\r\n          />\r\n        </div>\r\n        <div>\r\n          <button pButton class=\"ds\" label=\"{{ 'ACTIONS.BROWSE' | transloco }}\" (click)=\"selectFile.click()\"></button>\r\n          <input\r\n            #selectFile\r\n            type=\"file\"\r\n            (change)=\"onSelectFile($event)\"\r\n            accept=\"application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, .csv\"\r\n            style=\"display: none\"\r\n          />\r\n        </div>\r\n      </div>\r\n      <div class=\"import-file-btn\">\r\n        <button pButton class=\"ds\" [disabled]=\"importFile === null\" label=\"{{ 'PIM.IMPORT' | transloco }}\" (click)=\"uploadFile()\"></button>\r\n      </div>\r\n    </div>\r\n  </ng-container>\r\n  <ng-template #fileUploading>\r\n    <p>\r\n      {{ 'PIM.IMPORT_PROCESS_MSG' | transloco }}\r\n    </p>\r\n  </ng-template>\r\n</div>\r\n\r\n<p-confirmDialog deactivateDialog [closeOnEscape]=\"false\" [closable]=\"false\"></p-confirmDialog>\r\n",
                styles: [""]
            },] }
];
FileSelectionComponent.ctorParameters = () => [
    { type: Store },
    { type: ToastrNotificationService$1 },
    { type: TranslocoService },
    { type: ActivatedRoute },
    { type: Router }
];

class FinishComponent {
    constructor() {
        /* empty block */
    }
    ngOnInit() {
        /* empty block */
    }
}
FinishComponent.decorators = [
    { type: Component, args: [{
                selector: 'lib-finish',
                template: "<div class=\"import-container vertical-flow space-between-100\">\r\n  <h2>\r\n    {{ 'PIM.IMPORT_PRODUCT_DATA' | transloco }}\r\n  </h2>\r\n  <div>\r\n    <p>{{ 'PIM.IMPORT_FINISH_MSG' | transloco }}</p>\r\n  </div>\r\n</div>\r\n",
                styles: [""]
            },] }
];
FinishComponent.ctorParameters = () => [];

class ProductFieldService {
    constructor(baseAPISrv, pimSrv) {
        this.baseAPISrv = baseAPISrv;
        this.pimSrv = pimSrv;
    }
    getProductFields() {
        this.baseAPISrv.set(this.pimSrv.getConfig().getAllProductFieldsEndpoint);
        return this.baseAPISrv.get().pipe();
    }
    getIncludedFields() {
        this.baseAPISrv.set(this.pimSrv.getConfig().getIncludedFieldsEndpoint);
        return this.baseAPISrv.get().pipe();
    }
    getProductFieldCategories() {
        this.baseAPISrv.set(this.pimSrv.getConfig().getFieldCategoriesEndpoint);
        return this.baseAPISrv.get().pipe();
    }
}
ProductFieldService.ɵprov = ɵɵdefineInjectable({ factory: function ProductFieldService_Factory() { return new ProductFieldService(ɵɵinject(BaseAPIService), ɵɵinject(PimService)); }, token: ProductFieldService, providedIn: "root" });
ProductFieldService.decorators = [
    { type: Injectable, args: [{
                providedIn: 'root',
            },] }
];
ProductFieldService.ctorParameters = () => [
    { type: BaseAPIService },
    { type: PimService }
];

class ImportProductsService {
    constructor(baseAPISrv, pimSrv) {
        this.baseAPISrv = baseAPISrv;
        this.pimSrv = pimSrv;
    }
    getImportLayouts() {
        this.baseAPISrv.set(this.pimSrv.getConfig().importLayoutsEndPoint);
        return this.baseAPISrv.get().pipe();
    }
    addImportLayout(layout) {
        this.baseAPISrv.set(this.pimSrv.getConfig().importLayoutsEndPoint);
        return this.baseAPISrv.post(layout).pipe();
    }
    putImportLayout(layout) {
        this.baseAPISrv.set(urlJoin(this.pimSrv.getConfig().importLayoutsEndPoint, layout.layoutKey));
        return this.baseAPISrv.put(layout).pipe();
    }
    deleteImportLayout(layoutKey) {
        this.baseAPISrv.set(urlJoin(this.pimSrv.getConfig().importLayoutsEndPoint, layoutKey));
        return this.baseAPISrv.delete().pipe(map((response) => (Object.assign(Object.assign({}, response), { layoutKey }))));
    }
    addImport(layout) {
        this.baseAPISrv.set(this.pimSrv.getConfig().importEndPoint);
        return this.baseAPISrv.post(layout).pipe();
    }
    submitImport(importKey, fromPdx) {
        this.baseAPISrv.set(urlJoin(this.pimSrv.getConfig().importEndPoint, importKey));
        return this.baseAPISrv.put({}, {
            params: {
                fromObject: fromPdx && { fromPdx: fromPdx.toString() }
            }
        });
    }
    uploadFile(request, file) {
        this.baseAPISrv.set(this.pimSrv.getConfig().importFileEndPoint);
        const formData = new FormData();
        formData.append('file', file, file.name);
        return this.baseAPISrv.post(formData, {
            params: {
                fromObject: {
                    delimiter: request.delimiter,
                    fileType: request.fileType.toString(),
                    headerLines: request.headerLines.toString(),
                },
            },
            reportProgress: true,
        });
    }
    getAllowedValues() {
        this.baseAPISrv.set(this.pimSrv.getConfig().getFieldAllowedValuesEndpoint);
        return this.baseAPISrv.get().pipe();
    }
    getCountryList() {
        this.baseAPISrv.set(this.pimSrv.getConfig().getCountriesEndpoint);
        return this.baseAPISrv.get().pipe();
    }
    getCurrencyList() {
        this.baseAPISrv.set(this.pimSrv.getConfig().getCurrenciesEndpoint);
        return this.baseAPISrv.get().pipe();
    }
    getSuppliers() {
        const uri = `${this.pimSrv.getConfig().uriProduct.baseUri}/v2/supplier`;
        this.baseAPISrv.set(uri);
        return this.baseAPISrv
            .get()
            .pipe(map((resp) => resp.records));
    }
}
ImportProductsService.ɵprov = ɵɵdefineInjectable({ factory: function ImportProductsService_Factory() { return new ImportProductsService(ɵɵinject(BaseAPIService), ɵɵinject(PimService)); }, token: ImportProductsService, providedIn: "root" });
ImportProductsService.decorators = [
    { type: Injectable, args: [{
                providedIn: 'root',
            },] }
];
ImportProductsService.ctorParameters = () => [
    { type: BaseAPIService },
    { type: PimService }
];

class ImportLayout {
    constructor(columns, description, name, layoutKey) {
        this.columns = columns;
        this.description = description;
        this.name = name;
        this.layoutKey = layoutKey;
    }
    static fromDTO(layoutDTO, logger) {
        let columns = [];
        try {
            const settings = JSON.parse(layoutDTO.layoutJSON);
            columns = settings.columns.map((c) => {
                if (c.fieldKey) {
                    return {
                        fieldKey: c.fieldKey,
                        name: null,
                        description: null,
                        required: null,
                        dataTypeName: null,
                        dataTypeKey: c.dataTypeKey,
                        arrayCount: null,
                        arrayIndex: c.arrayIndex,
                        minLimit: null,
                        maxLimit: null,
                        decimalLimit: null,
                        isInfoDisplayed: null,
                        categoryName: null,
                        categoryKey: null,
                        assignedColumn: {
                            number: c.sourceColumn,
                        },
                        isIncluded: null,
                    };
                }
            });
        }
        catch (e) {
            logger.error('error decoding layout JSON', e);
        }
        return new ImportLayout(columns, layoutDTO.description, layoutDTO.name, layoutDTO.layoutKey);
    }
    static layoutJSON(columns, fileType, delimiter, dateFormat) {
        const columnMaps = columns.map((c) => {
            if (c.assignedColumn) {
                return {
                    fieldKey: c.fieldKey,
                    dataTypeKey: c.dataTypeKey,
                    required: c.required,
                    sourceColumn: c.assignedColumn.number,
                    fixedValue: null,
                    arrayIndex: c.arrayIndex,
                    minLimit: c.minLimit,
                    maxLimit: c.maxLimit,
                    decimalLimit: c.decimalLimit,
                };
            }
        });
        return {
            fileType,
            sheetName: null,
            delimiter,
            headerLines: 1,
            ignoreBlankLines: true,
            columns: columnMaps,
            dateFormat,
        };
    }
    toDTO() {
        const importSetting = ImportLayout.layoutJSON(this.columns);
        const dto = {
            layoutKey: this.layoutKey ? this.layoutKey : 0,
            accountKey: 0,
            description: this.description,
            importType: 1,
            layoutJSON: JSON.stringify(importSetting),
            name: this.name,
        };
        return dto;
    }
}

class ImportProductDataEffects {
    constructor(actions$, importSrv, productsSrv, store, loggerSrv, toasterSrv, translocoSrv) {
        this.actions$ = actions$;
        this.importSrv = importSrv;
        this.productsSrv = productsSrv;
        this.store = store;
        this.loggerSrv = loggerSrv;
        this.toasterSrv = toasterSrv;
        this.translocoSrv = translocoSrv;
        this.loadProductFields$ = createEffect(() => {
            return this.actions$.pipe(ofType(fetchFields), withLatestFrom(this.store.select(destinationColumns)), filter(([_, columns]) => columns.length === 0), switchMap(() => {
                return forkJoin([
                    this.productsSrv.getProductFields(),
                    this.store.select(selectors.categories).pipe(first()),
                    this.store.select(selectors.userProfile).pipe(first()),
                ]).pipe(map(([productFields, categories, profile]) => {
                    const fields = [];
                    productFields
                        .filter((field) => field.isImported)
                        .forEach((field) => {
                        const dataTypeMsg = this.getDataTypeMsg(profile.userInfo.DateTypeDescription, field);
                        if (field.arrayCount > 0) {
                            for (let i = 0; i < field.arrayCount; i++) {
                                fields.push({
                                    fieldKey: field.fieldKey,
                                    name: field.fieldName,
                                    description: field.description + ' ' + (i + 1),
                                    required: field.isRequired,
                                    dataTypeName: dataTypeMsg,
                                    dataTypeKey: field.dataTypeKey,
                                    assignedColumn: null,
                                    arrayCount: field.arrayCount,
                                    arrayIndex: i,
                                    minLimit: field.minLimit,
                                    maxLimit: field.maxLimit,
                                    decimalLimit: field.decimalLimit,
                                    isInfoDisplayed: this.isInfoDisplayed(field.dataTypeKey, field.fieldKey),
                                    categoryName: categories[field.categoryKey],
                                    categoryKey: field.categoryKey,
                                    isIncluded: field.isIncluded,
                                });
                            }
                        }
                        else {
                            fields.push({
                                fieldKey: field.fieldKey,
                                name: field.fieldName,
                                description: field.description,
                                required: field.isRequired,
                                dataTypeName: dataTypeMsg,
                                dataTypeKey: field.dataTypeKey,
                                assignedColumn: null,
                                arrayCount: field.arrayCount,
                                arrayIndex: 0,
                                minLimit: field.minLimit,
                                maxLimit: field.maxLimit,
                                decimalLimit: field.decimalLimit,
                                isInfoDisplayed: this.isInfoDisplayed(field.dataTypeKey, field.fieldKey),
                                categoryName: categories[field.categoryKey],
                                categoryKey: field.categoryKey,
                                isIncluded: field.isIncluded,
                            });
                        }
                    });
                    return fetchFieldsSuccess({ fields });
                }));
            }));
        });
        this.loadSuppliers$ = createEffect(() => {
            return this.actions$.pipe(ofType(fetchSuppliers), withLatestFrom(this.store.select(hasLoadedSuppliers)), filter(([_, hasLoaded]) => !hasLoaded), exhaustMap(() => this.importSrv.getSuppliers()), map((suppliers) => fetchSuppliersSuccess({ suppliers })));
        });
        this.loadLayouts$ = createEffect(() => {
            return this.actions$.pipe(ofType(fetchLayouts), switchMap(() => {
                return this.importSrv.getImportLayouts().pipe(map((dtos) => {
                    const layouts = dtos
                        ? dtos.map((dto) => ImportLayout.fromDTO(dto, this.loggerSrv))
                        : [];
                    return fetchLayoutsSuccess({ layouts });
                }));
            }));
        });
        this.addLayout$ = createEffect(() => {
            return this.actions$.pipe(ofType(addLayout), withLatestFrom(this.store.select(mappedColumns)), switchMap(([{ name, description }, cols]) => this.importSrv
                .addImportLayout(new ImportLayout(cols, description, name).toDTO())
                .pipe(map((response) => {
                if (response.wasAdded) {
                    this.toasterSrv.successNotify(this.translocoSrv.translate('PIM.LAYOUT_ADD_SUCCESS'), null);
                    return addLayoutSuccess({
                        layout: new ImportLayout(cols, description, name, response.layoutKey),
                    });
                }
                else {
                    this.toasterSrv.errorNotify(this.translocoSrv.translate('PIM.LAYOUT_ADD_FAILURE'), null);
                    return addLayoutFailure();
                }
            }), catchError(() => of(addLayoutFailure)))));
        });
        this.updateLayout$ = createEffect(() => {
            return this.actions$.pipe(ofType(updateLayout), withLatestFrom(this.store.select(mappedColumns)), mergeMap(([{ layoutKey, name, description }, cols]) => {
                const layout = new ImportLayout(cols, description, name, layoutKey);
                return this.importSrv.putImportLayout(layout.toDTO()).pipe(map((data) => {
                    if (data.wasUpdated) {
                        this.toasterSrv.successNotify(this.translocoSrv.translate('PIM.LAYOUT_UPDATE_SUCCESS'), null);
                        return updateLayoutSuccess({ layout });
                    }
                    else {
                        this.toasterSrv.errorNotify(this.translocoSrv.translate('PIM.LAYOUT_UPDATE_FAILURE'), null);
                        return updateLayoutFailure();
                    }
                }), catchError(() => of(updateLayoutFailure)));
            }));
        });
        this.deleteLayouts$ = createEffect(() => {
            return this.actions$.pipe(ofType(deleteLayout), mergeMap(({ layoutKeys }) => {
                const observables = layoutKeys.map((key) => this.importSrv.deleteImportLayout(key));
                return forkJoin(observables).pipe(map((responses) => {
                    if (responses.filter((response) => !response.wasDeleted).length < 0) {
                        this.toasterSrv.successNotify(this.translocoSrv.translate('PIM.LAYOUT_DELETE_FAILURE'), null);
                        return deleteLayoutFailure();
                    }
                    else {
                        this.toasterSrv.successNotify(this.translocoSrv.translate('PIM.LAYOUT_DELETE_SUCCESS'), null);
                        return deleteLayoutSuccess({ responses });
                    }
                }));
            }));
        });
        this.uploadImportedFile$ = createEffect(() => {
            return this.actions$.pipe(ofType(uploadFile), exhaustMap(({ request, file }) => this.importSrv.uploadFile(request, file).pipe(map((response) => {
                return uploadFileSuccess({
                    guid: response[0].guid,
                    fileName: response[0].fileName,
                    fileType: request.fileType,
                    delimiter: request.delimiter,
                    columns: response[0].fileHeaders,
                });
            }), catchError(() => of(uploadFileFailure)))));
        });
        this.addImport$ = createEffect(() => {
            return this.actions$.pipe(ofType(addImport), withLatestFrom(this.store.select(fileInfo), this.store.select(mappedColumns), this.store.select(selectors.userProfile)), mergeMap(([{ email, fromPdx }, file, layout, { userInfo: { DateTypeFormat }, },]) => {
                const setting = ImportLayout.layoutJSON(layout, file.fileType, file.delimiter, DateTypeFormat);
                const importDTO = {
                    importKey: 0,
                    userKey: 0,
                    importType: 1,
                    originalFileName: file.fileName,
                    importFile: file.fileGuid,
                    email,
                    status: 0,
                    layoutJSON: JSON.stringify(setting),
                    resultText: null,
                };
                return this.importSrv.addImport(importDTO).pipe(map((resp) => {
                    if (resp.wasAdded) {
                        return addImportSuccess({ importKey: resp.importKey, fromPdx });
                    }
                    else {
                        return addImportFailure();
                    }
                }));
            }), catchError(() => of(addImportFailure)));
        });
        this.processImport$ = createEffect(() => {
            return this.actions$.pipe(ofType(addImportSuccess), mergeMap((action) => this.importSrv
                .submitImport(action.importKey, action.fromPdx)
                .pipe(map(() => importProcessing()))));
        });
        this.getAllowedValues$ = createEffect(() => {
            return this.actions$.pipe(ofType(fetchAllowedValues), withLatestFrom(this.store.select(allowedValues)), filter(([_, allowedValues]) => allowedValues.length === 0), switchMap(() => {
                return this.importSrv.getAllowedValues().pipe(map((data) => {
                    const allowedValues = [];
                    data.forEach((value) => {
                        allowedValues.push({
                            dataTypeKey: value.dataTypeKey,
                            dataTypeDescription: value.dataTypeDescription,
                            description: value.description,
                            allowedValueKey: value.allowedValueKey,
                        });
                    });
                    return fetchAllowedValuesSuccess({ allowedValues });
                }));
            }));
        });
        this.getCountries$ = createEffect(() => {
            return this.actions$.pipe(ofType(fetchCountryList), withLatestFrom(this.store.select(countries)), filter(([_, countries]) => countries.length === 0), switchMap(() => {
                return this.importSrv.getCountryList().pipe(map((data) => {
                    const countryList = [];
                    data.forEach((country) => {
                        countryList.push({
                            countryCode: country.countryCode,
                            countryName: country.countryName,
                        });
                    });
                    return fetchCountryListSuccess({ countryList });
                }));
            }));
        });
        this.getCurrencies$ = createEffect(() => {
            return this.actions$.pipe(ofType(fetchCurrencyList), withLatestFrom(this.store.select(currencies)), filter(([_, currencies]) => currencies.length === 0), switchMap(() => {
                return this.importSrv.getCurrencyList().pipe(map((data) => {
                    const currencyList = [];
                    data.forEach((currency) => {
                        currencyList.push({
                            currencyCode: currency.currencyCode,
                            currencyName: currency.currencyName,
                        });
                    });
                    return fetchCurrencyListSuccess({ currencyList });
                }));
            }));
        });
    }
    getDataTypeMsg(userDateFormat, field) {
        if (field.dataTypeKey === DataTypeEnum.Numeric ||
            field.dataTypeKey === DataTypeEnum.Alphanumeric) {
            return field.dataTypeDescription + ' - ' + field.maxLimit + ' characters';
        }
        else if (field.dataTypeKey === DataTypeEnum.NumericDecimal) {
            return (field.dataTypeDescription + ' - ' + field.decimalLimit + ' decimals');
        }
        else if (field.dataTypeKey === DataTypeEnum.Date) {
            return field.dataTypeDescription + ' - ' + userDateFormat;
        }
        else {
            return field.dataTypeDescription;
        }
    }
    isInfoDisplayed(dataTypeKey, fieldKey) {
        return (dataTypeKey === DataTypeEnum.Yes_No ||
            dataTypeKey === DataTypeEnum.Image ||
            dataTypeKey === DataTypeEnum.Video ||
            dataTypeKey === DataTypeEnum.Document ||
            dataTypeKey === DataTypeEnum.HandToolMaterial ||
            dataTypeKey === DataTypeEnum.PowerTool ||
            dataTypeKey === DataTypeEnum.Status ||
            dataTypeKey === DataTypeEnum.UOM ||
            dataTypeKey === DataTypeEnum.UOMDimension ||
            dataTypeKey === DataTypeEnum.UOMVolume ||
            dataTypeKey === DataTypeEnum.UOMWeight ||
            dataTypeKey === DataTypeEnum.Country ||
            dataTypeKey === DataTypeEnum.Currency ||
            dataTypeKey === DataTypeEnum.Right_Left ||
            (dataTypeKey === DataTypeEnum.Alphanumeric &&
                fieldKey === ProductFieldsEnum.supplierProductKey) ||
            dataTypeKey === DataTypeEnum.UOMTime ||
            dataTypeKey === DataTypeEnum.UOMCapacity ||
            dataTypeKey === DataTypeEnum.UOMTemperature ||
            dataTypeKey === DataTypeEnum.UOMSound ||
            dataTypeKey === DataTypeEnum.SpinSpeedUOM ||
            dataTypeKey === DataTypeEnum.FreightClass);
    }
}
ImportProductDataEffects.decorators = [
    { type: Injectable }
];
ImportProductDataEffects.ctorParameters = () => [
    { type: Actions },
    { type: ImportProductsService },
    { type: ProductFieldService },
    { type: Store },
    { type: LoggerService },
    { type: ToastrNotificationService$1 },
    { type: TranslocoService }
];

class LayoutManagerComponent extends ComponentCanDeactivateDirective {
    constructor(route, router, store, fb, confirmSrv, toasterSrv, validationService, spinnerSrv, translocoSrv) {
        super();
        this.route = route;
        this.router = router;
        this.store = store;
        this.fb = fb;
        this.confirmSrv = confirmSrv;
        this.toasterSrv = toasterSrv;
        this.validationService = validationService;
        this.spinnerSrv = spinnerSrv;
        this.translocoSrv = translocoSrv;
        this.selectedLayouts = [];
        this.subscriptions = [];
        this.layoutForm = this.fb.group({
            name: ['', Validators.compose([this.validationService.noWhitespaceValidator()])],
            description: [''],
        });
    }
    canDeactivate(nextState) {
        if (this.ngForm.dirty && !this.ngForm.submitted) {
            return false;
        }
        else {
            return nextState && nextState.url.split('/').pop() === 'column-wizard';
        }
    }
    ngOnInit() {
        this.spinnerSrv.on();
        this.store.dispatch(fetchLayouts());
        this.layouts$ = this.store.select(layouts);
        this.subscriptions.push(this.store
            .select(loadedLayout)
            .pipe(first(), tap((loadedLayout) => {
            if (loadedLayout) {
                this.selectedLayouts = [loadedLayout];
                this.layoutForm.get('name').setValue(this.selectedLayouts[0].name);
                this.layoutForm.get('description').setValue(this.selectedLayouts[0].description);
            }
        }), finalize(() => this.spinnerSrv.off()))
            .subscribe());
    }
    ngOnDestroy() {
        if (this.subscriptions) {
            this.subscriptions.forEach((subscription) => subscription.unsubscribe());
        }
    }
    addLayout() {
        this.store.dispatch(addLayout({ name: this.layoutForm.value.name, description: this.layoutForm.value.description }));
        // Clear selected layouts and reset form if layout not loaded
        this.selectedLayouts = [];
        this.layoutForm.reset();
    }
    update() {
        const layout = this.selectedLayouts[0];
        // reassign name and description if the user interacted with the field and it has a value
        const descriptionControl = this.layoutForm.controls.description;
        const description = descriptionControl.touched && descriptionControl.value ? descriptionControl.value : layout.description;
        const nameControl = this.layoutForm.controls.name;
        const name = nameControl.touched && nameControl.value ? nameControl.value : layout.name;
        this.store.dispatch(updateLayout({ layoutKey: layout.layoutKey, name, description }));
        // Clear selected layouts and reset form if layout not loaded
        this.selectedLayouts = [];
        this.layoutForm.reset();
    }
    delete() {
        this.confirmSrv.confirm({
            header: this.translocoSrv.translate('ACTIONS.DELETE'),
            message: this.translocoSrv.translate('PIM.DELETE_LAYOUTS_CONFIRM'),
            icon: 'pi pi-exclamation-triangle',
            accept: () => {
                const layoutKeys = [];
                this.selectedLayouts.forEach((layout) => {
                    if (layout.layoutKey) {
                        layoutKeys.push(layout.layoutKey);
                    }
                });
                this.store.dispatch(deleteLayout({ layoutKeys }));
                // Clear selected layouts and reset form if layout not loaded
                this.selectedLayouts = [];
                this.layoutForm.reset();
            },
        });
    }
    load() {
        this.store.dispatch(applyLayout({ layout: this.selectedLayouts[0] }));
        this.toasterSrv.successNotify(this.translocoSrv.translate('PIM.LAYOUT_LOADED_SUCCESS'), null, 5000);
        this.router.navigate(['../column-wizard'], {
            relativeTo: this.route,
            skipLocationChange: true,
        });
    }
    back() {
        this.router.navigate(['../column-wizard'], {
            relativeTo: this.route,
            skipLocationChange: true,
        });
    }
    clear() {
        this.selectedLayouts = [];
    }
    rowSelect($event) {
        if (this.selectedLayouts.length === 1) {
            this.layoutForm.get('name').setValue(this.selectedLayouts[0].name);
            this.layoutForm.get('description').setValue(this.selectedLayouts[0].description);
        }
        else {
            this.layoutForm.reset();
        }
    }
    rowUnselect($event) {
        if (this.selectedLayouts.length === 1) {
            this.layoutForm.get('name').setValue(this.selectedLayouts[0].name);
            this.layoutForm.get('description').setValue(this.selectedLayouts[0].description);
        }
        else {
            this.layoutForm.reset();
        }
    }
}
LayoutManagerComponent.decorators = [
    { type: Component, args: [{
                selector: 'lib-layout-manager',
                template: "<div class=\"layout-manager vertical-flow space-between-100\">\r\n  <h2>\r\n    {{ 'PIM.IMPORT_PRODUCT_DATA' | transloco }}\r\n  </h2>\r\n  <form #ngForm=\"ngForm\" [formGroup]=\"layoutForm\" (ngSubmit)=\"addLayout()\">\r\n    <div class=\"vertical-flow\">\r\n      <div>\r\n        <p-table\r\n          [value]=\"layouts$ | async\"\r\n          [(selection)]=\"selectedLayouts\"\r\n          dataKey=\"layoutKey\"\r\n          [scrollable]=\"true\"\r\n          (onRowSelect)=\"rowSelect($event)\"\r\n          (onRowUnselect)=\"rowUnselect($event)\"\r\n          scrollHeight=\"300px\"\r\n        >\r\n          <ng-template pTemplate=\"caption\">\r\n            <h3>{{ 'PIM.IMPORT_LAYOUT_MANAGER' | transloco }}</h3>\r\n          </ng-template>\r\n          <ng-template pTemplate=\"header\">\r\n            <tr class=\"table-header\">\r\n              <th style=\"width: 3em\">\r\n                <p-tableHeaderCheckbox></p-tableHeaderCheckbox>\r\n              </th>\r\n              <th>{{ 'COMMON.NAME' | transloco }}</th>\r\n              <th>{{ 'COMMON.DESCRIPTION' | transloco }}</th>\r\n            </tr>\r\n          </ng-template>\r\n          <ng-template pTemplate=\"body\" let-layout>\r\n            <tr>\r\n              <td style=\"width: 3em\">\r\n                <p-tableCheckbox [value]=\"layout\"></p-tableCheckbox>\r\n              </td>\r\n              <td>{{ layout.name }}</td>\r\n              <td>{{ layout.description }}</td>\r\n            </tr>\r\n          </ng-template>\r\n        </p-table>\r\n      </div>\r\n      <div class=\"vertical-flow space-between-025 space-before-200\">\r\n        <label>\r\n          {{ 'COMMON.NAME' | transloco }}\r\n        </label>\r\n        <div>\r\n          <input pInputText type=\"text\" placeholder=\"{{ 'COMMON.NAME' | transloco }}\" formControlName=\"name\" required maxlength=\"50\" />\r\n        </div>\r\n        <span class=\"feedback\">\r\n          <label *ngIf=\"layoutForm.get('name').invalid && layoutForm.get('name').touched\" class=\"error\">{{\r\n            'COMMON.REQUIRED' | transloco\r\n          }}</label></span\r\n        >\r\n      </div>\r\n    </div>\r\n\r\n    <p-confirmDialog [closable]=\"false\" [closeOnEscape]=\"false\"></p-confirmDialog>\r\n\r\n    <div class=\"vertical-flow space-between-300\">\r\n      <div class=\"vertical-flow space-between-025\">\r\n        <label>\r\n          {{ 'COMMON.DESCRIPTION' | transloco }}\r\n        </label>\r\n        <div>\r\n          <textarea pInputTextArea style=\"width: 100%\" rows=\"5\" formControlName=\"description\" maxlength=\"100\"> </textarea>\r\n        </div>\r\n      </div>\r\n      <div class=\"horizontal-flow space-between-050\">\r\n        <button pButton type=\"button\" class=\"ds secondary\" label=\"{{ 'ACTIONS.CANCEL' | transloco }}\" (click)=\"back()\"></button>\r\n        <button pButton type=\"submit\" class=\"ds\" label=\"{{ 'ACTIONS.ADD' | transloco }}\" [disabled]=\"!layoutForm.valid\"></button>\r\n        <button\r\n          pButton\r\n          type=\"button\"\r\n          class=\"ds\"\r\n          label=\"{{ 'ACTIONS.UPDATE' | transloco }}\"\r\n          (click)=\"update()\"\r\n          [disabled]=\"this.selectedLayouts.length !== 1\"\r\n        ></button>\r\n        <button pButton type=\"reset\" class=\"ds\" label=\"{{ 'ACTIONS.CLEAR' | transloco }}\" (click)=\"clear()\"></button>\r\n        <button\r\n          pButton\r\n          type=\"button\"\r\n          class=\"ds\"\r\n          label=\"{{ 'ACTIONS.DELETE' | transloco }}\"\r\n          (click)=\"delete()\"\r\n          [disabled]=\"this.selectedLayouts.length < 1\"\r\n        ></button>\r\n        <button\r\n          pButton\r\n          type=\"button\"\r\n          class=\"ds\"\r\n          label=\"{{ 'ACTIONS.LOAD' | transloco }}\"\r\n          (click)=\"load()\"\r\n          [disabled]=\"this.selectedLayouts.length !== 1\"\r\n        ></button>\r\n      </div>\r\n    </div>\r\n  </form>\r\n</div>\r\n\r\n<p-confirmDialog deactivateDialog [closeOnEscape]=\"false\" [closable]=\"false\"></p-confirmDialog>\r\n",
                styles: [""]
            },] }
];
LayoutManagerComponent.ctorParameters = () => [
    { type: ActivatedRoute },
    { type: Router },
    { type: Store },
    { type: FormBuilder },
    { type: ConfirmationService$1 },
    { type: ToastrNotificationService$1 },
    { type: ValidationService },
    { type: SpinnerService$1 },
    { type: TranslocoService }
];
LayoutManagerComponent.propDecorators = {
    ngForm: [{ type: ViewChild, args: ['ngForm',] }]
};

class ImportProductDataModule {
}
ImportProductDataModule.decorators = [
    { type: NgModule, args: [{
                declarations: [
                    LayoutManagerComponent,
                    EmailNotificationComponent,
                    FileSelectionComponent,
                    FinishComponent,
                    ColumnWizardComponent,
                ],
                imports: [
                    RouterModule,
                    StoreModule.forFeature('pim', reducers$5, { metaReducers }),
                    EffectsModule.forFeature([ImportProductDataEffects]),
                    CommonModule,
                    DragDropModule,
                    CoreModule,
                    ButtonModule,
                    FormsModule,
                    TableModule,
                    DropdownModule,
                    ReactiveFormsModule,
                    UtilsModule,
                    ConfirmDialogModule$1,
                    InputTextModule,
                    InputTextareaModule,
                    TranslocoModule,
                    DialogModule,
                    ReloadModule,
                ],
                providers: [ImportProductsService, ConfirmationService$1, CanDeactivateGuard, SpinnerService$1],
            },] }
];

var PartnerPolicy;
(function (PartnerPolicy) {
    PartnerPolicy[PartnerPolicy["SupplierDirected"] = 1] = "SupplierDirected";
    PartnerPolicy[PartnerPolicy["GroupDirected"] = 2] = "GroupDirected";
})(PartnerPolicy || (PartnerPolicy = {}));

const defaultConfigurationForm = (transloco) => ({
    fields: {
        configuration: {
            type: 'dropdown',
            label: transloco.translate('PIM.OUTBOUND_CONFIGURATION.DEFAULT_PARTNER_CONFIGURATION.LABEL'),
            information: transloco.translate('PIM.OUTBOUND_CONFIGURATION.DEFAULT_PARTNER_CONFIGURATION.INFORMATION'),
            options: [
                {
                    label: transloco.translate('PIM.OUTBOUND_CONFIGURATION.SUPPLIER_DIRECTED'),
                    value: PartnerPolicy.SupplierDirected,
                },
                {
                    label: transloco.translate('PIM.OUTBOUND_CONFIGURATION.GROUP_DIRECTED'),
                    value: PartnerPolicy.GroupDirected,
                },
            ],
            disabled: true,
            componentProperties: {
                placeholder: transloco.translate('ACTIONS.SELECT')
            }
        }
    }
});

const editConfigurationForm = (transloco, callbacks) => ({
    controls: {
        cancel: {
            label: transloco.translate('ACTIONS.CANCEL'),
            type: 'button',
            role: FormControlRole.SECONDARY,
            callback: callbacks.cancel,
        },
        save: {
            label: transloco.translate('ACTIONS.SAVE'),
            type: 'button',
            role: FormControlRole.PRIMARY,
            callback: callbacks.save,
        }
    },
    fields: {
        configuration: {
            type: 'dropdown',
            label: transloco.translate('PIM.OUTBOUND_CONFIGURATION.EDIT_CONFIGURATION.PARTNER_CONFIGURATION.LABEL'),
            information: transloco.translate('PIM.OUTBOUND_CONFIGURATION.EDIT_CONFIGURATION.PARTNER_CONFIGURATION.INFORMATION'),
            options: [
                {
                    label: transloco.translate('PIM.OUTBOUND_CONFIGURATION.SUPPLIER_DIRECTED'),
                    value: PartnerPolicy.SupplierDirected,
                },
                {
                    label: transloco.translate('PIM.OUTBOUND_CONFIGURATION.GROUP_DIRECTED'),
                    value: PartnerPolicy.GroupDirected,
                },
            ],
            required: true,
            componentProperties: {
                placeholder: transloco.translate('ACTIONS.SELECT')
            }
        }
    }
});

class OutboundConfigurationService {
    constructor(http, pimService) {
        this.http = http;
        const config = pimService.getConfig();
        this.baseUri = `${config.uriProduct.baseUri}/config/outbound-config`;
    }
    getDefaultConfiguration() {
        return this.http
            .get(`${this.baseUri}/defaults`, { withCredentials: true })
            .pipe(map(response => response.record.defaults));
    }
    setDefaultPartnerPolicy(value) {
        return this.http
            .post(`${this.baseUri}/defaults`, { defaultPartnerPolicy: value }, { withCredentials: true });
    }
    setSuppliersPartnerPolicy(supplierKeys, value) {
        return this.http
            .post(`${this.baseUri}/setSupplierConfigs`, { supplierKeys, partnerPolicy: value }, { withCredentials: true });
    }
}
OutboundConfigurationService.ɵprov = ɵɵdefineInjectable({ factory: function OutboundConfigurationService_Factory() { return new OutboundConfigurationService(ɵɵinject(HttpClient), ɵɵinject(PimService)); }, token: OutboundConfigurationService, providedIn: "root" });
OutboundConfigurationService.decorators = [
    { type: Injectable, args: [{
                providedIn: 'root'
            },] }
];
OutboundConfigurationService.ctorParameters = () => [
    { type: HttpClient },
    { type: PimService }
];

class OutboundConfigurationComponent {
    constructor(translocoService, formService, configService, searchService, toastService) {
        this.translocoService = translocoService;
        this.formService = formService;
        this.configService = configService;
        this.searchService = searchService;
        this.toastService = toastService;
        // Search Container Loader inputs //
        this.searchContainerName = 'outboundConfiguration';
        this.i18nSearchField = 'ACTIONS.SEARCH';
        this.showEditConfig = false;
        this.toolbarActionsDispatcher = {
            edit: (selection, clearSelection) => {
                this.editState = { selectedSuppliers: selection, clearSelection };
                this.openEditConfig();
            },
        };
        this.subscriptions = [];
    }
    ngOnInit() {
        this.baseUrl = this.configService.baseUri;
        this.defaultConfigForm = this.formService.init(defaultConfigurationForm(this.translocoService));
        this.editConfigForm = this.formService.init(editConfigurationForm(this.translocoService, {
            cancel: () => this.onEditConfigClose(),
            save: (form) => this.onEditConfigSave(form)
        }));
        this.configService.getDefaultConfiguration()
            .pipe(tap(defaults => {
            this.defaultConfigForm.patch({ configuration: defaults.defaultPartnerPolicy });
            this.defaultConfigForm.setDisabled('configuration', false);
        }))
            .subscribe();
        this.subscriptions.push(this.defaultConfigForm.values$
            .pipe(map(values => values), filter(values => values.configuration !== null), skip(1), // skip the form patching update
        tap(values => {
            this.configService.setDefaultPartnerPolicy(values.configuration)
                .subscribe((_ok) => {
                this.searchService.refreshSearch();
                this.toastService.successNotify(this.translocoService.translate('PIM.OUTBOUND_CONFIGURATION.DEFAULT_PARTNER_CONFIGURATION.UPDATE_SUCCESS'), null, 5000);
            }, (_err) => {
                this.toastService.errorNotify(this.translocoService.translate('PIM.OUTBOUND_CONFIGURATION.DEFAULT_PARTNER_CONFIGURATION.UPDATE_ERROR'), null, 5000);
            });
        }))
            .subscribe());
    }
    ngOnDestroy() {
        this.subscriptions.forEach(subscription => subscription.unsubscribe());
    }
    openEditConfig() {
        this.editConfigForm.patch({});
        this.showEditConfig = true;
    }
    onEditConfigClose() {
        this.showEditConfig = false;
    }
    onEditConfigSave(form) {
        const config = form.values;
        const suppliers = this.editState.selectedSuppliers.map(record => record.accountKeySupplier);
        this.configService.setSuppliersPartnerPolicy(suppliers, config.configuration).subscribe(_ok => {
            this.editState.clearSelection();
            this.showEditConfig = false;
            this.toastService.successNotify(this.translocoService.translate('PIM.OUTBOUND_CONFIGURATION.EDIT_CONFIGURATION.UPDATE_SUCCESS'), null, 5000);
        }, _err => {
            this.toastService.errorNotify(this.translocoService.translate('PIM.OUTBOUND_CONFIGURATION.EDIT_CONFIGURATION.UPDATE_ERROR'), null, 5000);
        });
    }
}
OutboundConfigurationComponent.decorators = [
    { type: Component, args: [{
                selector: 'lib-outbound-profile-search',
                template: "<div class=\"vertical-flow space-between-050\">\r\n  <h2>{{ 'BREADCRUMB.OUTBOUND_CONFIGURATION' | transloco }}</h2>\r\n  <p class=\"outbound-configuration text-align-left\" style=\"max-width: 56rem;\" >\r\n    {{ 'PIM.OUTBOUND_CONFIGURATION.LEGEND' | transloco }} <br /><br />\r\n  </p>\r\n  <div class=\"vertical-flow space-between-050\">\r\n    <div class=\"horizontal-flow\">\r\n    <lui-form [form]=\"defaultConfigForm\"></lui-form>\r\n    </div>\r\n\r\n    <div class=\"space-before-275\">\r\n    <lib-search-container-loader\r\n      [searchContainerName]=\"searchContainerName\"\r\n      [i18nSearchField]=\"i18nSearchField\"\r\n      [params]=\"params\" [baseUrl]=\"baseUrl\"\r\n      [toolbarActionsDispatcher]=\"toolbarActionsDispatcher\">\r\n    </lib-search-container-loader>\r\n  </div>\r\n</div>\r\n\r\n<p-dialog\r\n  [(visible)]=\"showEditConfig\"\r\n  [header]=\"'PIM.OUTBOUND_CONFIGURATION.EDIT_CONFIGURATION.TITLE' | transloco\"\r\n  [modal]=\"true\"\r\n  [style]=\"{ width: '520px' }\"\r\n  [showHeader]=\"true\"\r\n  [draggable]=\"false\"\r\n  [resizable]=\"false\"\r\n  [closable]=\"false\"\r\n  [closeOnEscape]=\"false\"\r\n  position=\"center\"\r\n  [focusOnShow]=\"false\"\r\n>\r\n  <lui-form [form]=\"editConfigForm\"></lui-form>\r\n</p-dialog>\r\n",
                styles: [":host ::ng-deep .ui-dialog .ui-dialog-titlebar{padding:2em 2em 1em}:host ::ng-deep .ui-dialog .ui-dialog-titlebar .ui-dialog-title{color:var(--med-dark-grey);font-size:var(--h3-font-size);font-weight:500}:host ::ng-deep .ui-dialog .ui-dialog-titlebar .ui-dialog-titlebar-icon{color:var(--med-dark-grey)}:host ::ng-deep .ui-dialog .ui-dialog-content{border-top:0;border-bottom:0;padding:1em 2em;overflow:visible}:host ::ng-deep .ui-dialog .ui-dialog-content .lui-controls{display:flex;gap:.5em;margin-top:1em;margin-bottom:1em}:host ::ng-deep .ui-dialog .ui-dialog-content .lui-controls>button{flex-grow:1}"]
            },] }
];
OutboundConfigurationComponent.ctorParameters = () => [
    { type: TranslocoService },
    { type: GenerateFormService },
    { type: OutboundConfigurationService },
    { type: SearchContainerLoaderService },
    { type: ToastrNotificationService$1 }
];

class OutboundConfigurationModule {
}
OutboundConfigurationModule.decorators = [
    { type: NgModule, args: [{
                declarations: [OutboundConfigurationComponent],
                imports: [
                    CommonModule,
                    SearchContainerLoaderModule,
                    UtilsModule,
                    HttpClientModule,
                    TranslocoModule,
                    FormsModule,
                    PerFormPrimengModule,
                    SelectButtonModule,
                    DialogModule$1,
                ],
                providers: [
                    OutboundConfigurationService,
                    SearchContainerLoaderService,
                ]
            },] }
];

var WizardMode;
(function (WizardMode) {
    WizardMode[WizardMode["New"] = 0] = "New";
    WizardMode[WizardMode["Edit"] = 1] = "Edit";
    WizardMode[WizardMode["Copy"] = 2] = "Copy";
})(WizardMode || (WizardMode = {}));

class OutboundProfileSearchComponent {
    constructor(route, router, http, toastService, confirmationService, translocoService, pimService) {
        this.route = route;
        this.router = router;
        this.http = http;
        this.toastService = toastService;
        this.confirmationService = confirmationService;
        this.translocoService = translocoService;
        this.searchContainerName = 'outboundProfileSearch';
        this.i18nSearchField = 'ACTIONS.SEARCH';
        this.toolbarActionsDispatcher = {
            new: () => {
                this.router.navigate(['./wizard'], {
                    relativeTo: this.route,
                    state: { wizardMode: WizardMode.New, profileKey: null, },
                });
            },
            edit: (selection) => {
                this.router.navigate(['./wizard'], {
                    relativeTo: this.route,
                    state: { wizardMode: WizardMode.Edit, profileKey: selection[0].outboundProfileKey, },
                });
            },
            copy: (selection) => {
                this.router.navigate(['./wizard'], {
                    relativeTo: this.route,
                    state: { wizardMode: WizardMode.Copy, profileKey: selection[0].outboundProfileKey, },
                });
            },
            delete: (selection, clearSelection) => {
                this.confirmationService.confirm({
                    header: this.translocoService.translate('PIM.OUTBOUND_PROFILE.DELETE_CONFIRM_TITLE'),
                    message: this.translocoService.translate('PIM.OUTBOUND_PROFILE.DELETE_CONFIRM'),
                    icon: 'pi pi-exclamation-triangle',
                    accept: () => {
                        const toDelete = selection.map(profile => profile.outboundProfileKey);
                        this.http.post(`${this.baseUri}/delete-profiles`, { profileKeys: toDelete }, { withCredentials: true }).subscribe(_ok => {
                            this.toastService.successNotify(this.translocoService.translate('PIM.OUTBOUND_PROFILE.DELETE_SUCCESS'));
                            clearSelection();
                        }, _err => {
                            this.toastService.errorNotify(this.translocoService.translate('PIM.OUTBOUND_PROFILE.DELETE_FAILURE'));
                        });
                    },
                    reject: () => {
                        clearSelection();
                    },
                });
            },
            productPush: (selection, clearSelection) => {
                const translationKey = selection.length === 0
                    ? 'PIM.OUTBOUND_PROFILE.REPUBLISH_ALL_DIALOG'
                    : 'PIM.OUTBOUND_PROFILE.REPUBLISH_SELECTED_DIALOG';
                const { TITLE, MESSAGE } = this.translocoService.translate(translationKey);
                this.confirmationService.confirm({
                    header: TITLE,
                    message: MESSAGE,
                    accept: () => {
                        const toPublish = selection.map(profile => profile.outboundProfileKey);
                        this.http.post(`${this.baseUri}/publish-many`, { profileKeys: toPublish.length !== 0 ? toPublish : null }, { withCredentials: true }).subscribe(_ok => {
                            this.toastService.successNotify(this.translocoService.translate('PIM.OUTBOUND_PROFILE.REPUBLISH_SUCCESS'));
                            clearSelection();
                        }, _err => {
                            this.toastService.errorNotify(this.translocoService.translate('PIM.OUTBOUND_PROFILE.REPUBLISH_FAILURE'));
                        });
                    },
                    reject: () => {
                        clearSelection();
                    },
                });
            },
        };
        this.columnActions = {
            profileName: {
                link: () => ({ path: './' }),
                event: (outboundProfile) => {
                    return ({
                        data: outboundProfile,
                        eventType: 'edit'
                    });
                },
            }
        };
        const config = pimService.getConfig();
        this.baseUri = `${config.uriProduct.baseUri}/config/outbound`;
    }
    searchContainerEvent({ data, eventType }) {
        switch (eventType) {
            case 'edit':
                this.toolbarActionsDispatcher.edit([data]);
                break;
            default:
                break;
        }
    }
}
OutboundProfileSearchComponent.decorators = [
    { type: Component, args: [{
                selector: 'lib-outbound-profile-search',
                template: "<div class=\"vertical-flow space-between-050\">\r\n  <h2>{{ 'BREADCRUMB.OUTBOUND_UPDATE_PROFILE' | transloco }}</h2>\r\n  <p class=\"outbound-update-profile text-align-left\" style=\"max-width: 56rem;\" >\r\n    {{ 'PIM.OUTBOUND_PROFILE.LEGEND' | transloco }} <br /><br />\r\n  </p>\r\n  <div class=\"vertical-flow space-between-050\">\r\n    <lib-search-container-loader\r\n      [searchContainerName]=\"searchContainerName\"\r\n      [i18nSearchField]=\"i18nSearchField\"\r\n      [params]=\"params\" [baseUrl]=\"baseUri\"\r\n      [toolbarActionsDispatcher]=\"toolbarActionsDispatcher\"\r\n      [columnActions]=\"columnActions\"\r\n      (field)=\"searchContainerEvent($event)\">\r\n    </lib-search-container-loader>\r\n  </div>\r\n</div>\r\n",
                styles: [""]
            },] }
];
OutboundProfileSearchComponent.ctorParameters = () => [
    { type: ActivatedRoute },
    { type: Router },
    { type: HttpClient },
    { type: ToastrNotificationService$1 },
    { type: ConfirmationService$2 },
    { type: TranslocoService },
    { type: PimService }
];

class OutboundProfileSearchModule {
}
OutboundProfileSearchModule.decorators = [
    { type: NgModule, args: [{
                declarations: [OutboundProfileSearchComponent],
                imports: [
                    CommonModule,
                    SearchContainerLoaderModule,
                    HttpClientModule,
                    ConfirmDialogModule,
                    TranslocoModule,
                ],
                providers: [
                    SearchContainerLoaderService,
                    ConfirmationService$2,
                ]
            },] }
];

var ValidationSeverity;
(function (ValidationSeverity) {
    ValidationSeverity[ValidationSeverity["Error"] = 1] = "Error";
    ValidationSeverity[ValidationSeverity["Warning"] = 2] = "Warning";
})(ValidationSeverity || (ValidationSeverity = {}));
var MessageKind;
(function (MessageKind) {
    MessageKind[MessageKind["MissingProducts"] = 1] = "MissingProducts";
    MessageKind[MessageKind["DuplicateProducts"] = 2] = "DuplicateProducts";
})(MessageKind || (MessageKind = {}));

class OutboundProfileWizardService {
    constructor(http, pimService) {
        this.http = http;
        const config = pimService.getConfig();
        this.baseUri = config.uriProduct.baseUri;
        this.importUploadUri = `outbound-profile/selections/import`;
        this.request$ = of(null);
    }
    getExistingNames() {
        return this.http
            .get(`${this.baseUri}/outbound-profile/existingNames`, { withCredentials: true })
            .pipe(map((res) => res.records.map((record) => record.name)));
    }
    getOutboundPartners(profileKey) {
        const options = {
            params: profileKey
                ? new HttpParams().set('profile', profileKey.toString())
                : {},
            withCredentials: true,
        };
        return this.http
            .get(`${this.baseUri}/outbound-profile/partners`, options)
            .pipe(map(resp => resp.record));
    }
    getHierarchiesForType(hierarchyType) {
        return this.http
            .get(`${this.baseUri}/product/hierarchy/${hierarchyType}`, { withCredentials: true })
            .pipe(map((response) => response.record));
    }
    exportAllSkus(supplierKey) {
        return this.http.get(`${this.baseUri}/outbound-profile/selections/export-all`, {
            params: new HttpParams().set('supplier', supplierKey.toString()),
            withCredentials: true,
            observe: 'response',
            responseType: 'blob',
        });
    }
    exportProfileSkus(profileKey) {
        return this.http.get(`${this.baseUri}/outbound-profile/selections/export`, {
            params: new HttpParams().set('profile', profileKey.toString()),
            withCredentials: true,
            observe: 'response',
            responseType: 'blob',
        });
    }
    validateSkus(supplierKey, importedProducts) {
        return this.http
            .post(`${this.baseUri}/outbound-profile/selections/validate`, {
            supplierKey,
            selections: importedProducts,
        }, { withCredentials: true })
            .pipe(map((resp) => resp.records));
    }
    getProfile(profileKey) {
        return this.http
            .get(`${this.baseUri}/config/outbound/${profileKey}`, {
            withCredentials: true,
        }).pipe(map(resp => resp.record));
    }
    saveProfile(profile) {
        return this.http.post(`${this.baseUri}/config/outbound`, profile, {
            withCredentials: true,
        });
    }
    deleteProfile(id) {
        return this.http.delete(`${this.baseUri}/config/outbound/${id}`, {
            withCredentials: true,
        });
    }
    setFormLoadingRequest(formRequest) {
        const validation = formRequest.pipe(mergeMap((form) => form.errors$.pipe(map((errors) => Object.keys(errors).every((field) => errors[field].length === 0)))));
        this.setLoadingRequest(formRequest, validation);
    }
    setLoadingRequest(request, validation) {
        this.request$ = request;
        this.validation$ = validation !== null && validation !== void 0 ? validation : of(true);
    }
}
OutboundProfileWizardService.ɵprov = ɵɵdefineInjectable({ factory: function OutboundProfileWizardService_Factory() { return new OutboundProfileWizardService(ɵɵinject(HttpClient), ɵɵinject(PimService)); }, token: OutboundProfileWizardService, providedIn: "root" });
OutboundProfileWizardService.decorators = [
    { type: Injectable, args: [{
                providedIn: 'root',
            },] }
];
OutboundProfileWizardService.ctorParameters = () => [
    { type: HttpClient },
    { type: PimService }
];

var ProfilePolicy;
(function (ProfilePolicy) {
    ProfilePolicy[ProfilePolicy["IncludeAll"] = 1] = "IncludeAll";
    ProfilePolicy[ProfilePolicy["IncludeSpecific"] = 2] = "IncludeSpecific";
    ProfilePolicy[ProfilePolicy["ExcludeSpecific"] = 3] = "ExcludeSpecific";
    ProfilePolicy[ProfilePolicy["ExcludeAll"] = 4] = "ExcludeAll";
})(ProfilePolicy || (ProfilePolicy = {}));
var SelectionType;
(function (SelectionType) {
    SelectionType[SelectionType["HierarchyField"] = 1] = "HierarchyField";
    SelectionType[SelectionType["SkuImport"] = 2] = "SkuImport";
})(SelectionType || (SelectionType = {}));
var HierarchyType;
(function (HierarchyType) {
    HierarchyType[HierarchyType["SupplierHierarchy"] = 21] = "SupplierHierarchy";
    HierarchyType[HierarchyType["GroupHierarchy"] = 22] = "GroupHierarchy";
    HierarchyType[HierarchyType["MemberHierarchy"] = 23] = "MemberHierarchy";
    HierarchyType[HierarchyType["OutboundHierarchy"] = 1538] = "OutboundHierarchy";
})(HierarchyType || (HierarchyType = {}));

class OutboundProfileWizardStore extends ComponentStore {
    constructor(wizardService) {
        super({
            profileKey: null,
            profileName: null,
            partnerSelection: null,
            productSelection: null,
            saved: {},
            dirty: false,
        });
        this.wizardService = wizardService;
        this.initializeForMode = this.updater((state, initial) => (Object.assign(Object.assign({}, state), { wizardMode: initial.wizardMode, profileKey: initial.profileKey })));
        this.wizardMode$ = this.select((s) => s.wizardMode).pipe(notNull());
        this.seedProfileKey$ = this.select((s) => s.profileKey);
        this.profileKey$ = this.select(this.seedProfileKey$, this.wizardMode$, (profileKey, wizardMode) => wizardMode === WizardMode.Edit ? profileKey : null);
        this.initializationData$ = this.select(this.seedProfileKey$, this.wizardMode$, (profileKey, wizardMode) => ({ profileKey, wizardMode }), { debounce: true });
        this.fetchInitialState = this.effect((initializeData$) => {
            return initializeData$.pipe(switchMap(({ wizardMode, profileKey }) => {
                let initialValues;
                switch (wizardMode) {
                    case WizardMode.Edit:
                    case WizardMode.Copy:
                        initialValues = this.wizardService.getProfile(profileKey).pipe(map((profile) => {
                            var _a;
                            const initialName = wizardMode === WizardMode.Edit ? profile.profileName : null;
                            // We don't want to copy the old profile's partners, since there
                            // can only be one (supplier, partner) paring across any profiles.
                            const initialPartners = wizardMode === WizardMode.Edit ? profile.partnerKeys : null;
                            const specificPolicies = [
                                ProfilePolicy.IncludeSpecific,
                                ProfilePolicy.ExcludeSpecific,
                            ];
                            return {
                                profileName: {
                                    oldProfileName: initialName,
                                    profileName: initialName,
                                },
                                partnerSelection: {
                                    accountKeyMarketplace: profile.marketplaceKey,
                                    accountKeySupplier: profile.supplierKey,
                                    partnerAccountKeys: initialPartners,
                                    oldMarketplaceKey: profile.marketplaceKey,
                                    oldSupplierKey: profile.supplierKey,
                                },
                                productSelection: {
                                    oldSupplierKey: profile.supplierKey,
                                    oldHierarchyField: (_a = profile.hierarchyField) !== null && _a !== void 0 ? _a : null,
                                    profilePolicy: profile.profilePolicy,
                                    selectionType: specificPolicies.includes(profile.profilePolicy) &&
                                        profile.selectionType
                                        ? profile.selectionType
                                        : null,
                                    hierarchyField: profile.selectionType ===
                                        SelectionType.HierarchyField && profile.hierarchyField
                                        ? profile.hierarchyField
                                        : null,
                                    selectedHierarchies: profile.selectionType ===
                                        SelectionType.HierarchyField &&
                                        profile.selectedHierarchies
                                        ? profile.selectedHierarchies
                                        : null,
                                    importedProducts: profile.selectionType === SelectionType.SkuImport &&
                                        profile.selectedProducts
                                        ? [{ selectedProducts: profile.selectedProducts }]
                                        : null,
                                },
                                saved: {
                                    selectionType: profile.selectionType,
                                },
                                dirty: false,
                            };
                        }));
                        break;
                    case WizardMode.New:
                        initialValues = of({
                            profileKey: null,
                            profileName: {
                                oldProfileName: null,
                                profileName: null,
                            },
                            partnerSelection: {
                                accountKeyMarketplace: null,
                                accountKeySupplier: null,
                                partnerAccountKeys: [],
                            },
                            productSelection: {
                                profilePolicy: null,
                                selectionType: null,
                                hierarchyField: null,
                                selectedHierarchies: [],
                                importedProducts: null,
                            },
                            saved: {},
                            dirty: false,
                        });
                        break;
                }
                return initialValues.pipe(tap((values) => this.patchState((state) => (Object.assign(Object.assign(Object.assign({}, state), values), { cached: state.cached })))));
            }));
        });
        this.fetchExistingNames = this.effect((trigger$) => trigger$.pipe(switchMap(() => this.wizardService.getExistingNames().pipe(tap((names) => this.patchState((s) => (Object.assign(Object.assign({}, s), { cached: Object.assign(Object.assign({}, s.cached), { existingNames: names }) }))))))));
        this.fetchPartnerTree = this.effect((profileKey$) => profileKey$.pipe(switchMap((profileKey) => this.wizardService.getOutboundPartners(profileKey).pipe(tap((tree) => this.patchState((s) => (Object.assign(Object.assign({}, s), { cached: Object.assign(Object.assign({}, s.cached), { partnerTree: tree }) }))))))));
        this.fetchSupplierHierarchies = this.effect((supplierKey$) => {
            const hierarchyTypes = Object.values(HierarchyType).filter((it) => typeof it === 'number');
            return supplierKey$.pipe(switchMap((supplierKey) => from(hierarchyTypes).pipe(mergeMap((hierarchyType) => zip(of(hierarchyType), this.wizardService.getHierarchiesForType(hierarchyType))), map(([hierarchyType, hierarchy]) => ({
                [hierarchyType]: toOptionsList(hierarchy.hierarchies[supplierKey]),
            })), toArray(), 
            // Flatten it into a dictionary keyed by the hierarchy type
            map((it) => Object.assign({}, ...it)), tap((hierarchies) => this.patchState((s) => (Object.assign(Object.assign({}, s), { cached: Object.assign(Object.assign({}, s.cached), { supplierHierarchies: hierarchies }) })))))));
        });
        this.existingNames$ = this.select((s) => { var _a; return (_a = s.cached) === null || _a === void 0 ? void 0 : _a.existingNames; }).pipe(notNull());
        this.partnerTree$ = this.select((s) => { var _a; return (_a = s.cached) === null || _a === void 0 ? void 0 : _a.partnerTree; }).pipe(notNull());
        this.supplierHierarchies$ = this.select((s) => { var _a; return (_a = s.cached) === null || _a === void 0 ? void 0 : _a.supplierHierarchies; }).pipe(notNull());
        this.marketplaceKey$ = this.select((s) => { var _a; return (_a = s.partnerSelection) === null || _a === void 0 ? void 0 : _a.accountKeyMarketplace; }).pipe(notNull());
        this.supplierKey$ = this.select((s) => { var _a; return (_a = s.partnerSelection) === null || _a === void 0 ? void 0 : _a.accountKeySupplier; }).pipe(notNull());
        this.savedSelectionType$ = this.select((s) => s.saved.selectionType);
        this.importedProducts$ = this.select((s) => { var _a, _b, _c; return (_c = (_b = (_a = s.productSelection) === null || _a === void 0 ? void 0 : _a.importedProducts) === null || _b === void 0 ? void 0 : _b[0]) === null || _c === void 0 ? void 0 : _c.selectedProducts; }).pipe(notNull());
        this.profileNameForm$ = this.select((s) => s.profileName).pipe(notNull());
        this.partnerSelectionForm$ = this.select((s) => s.partnerSelection).pipe(notNull());
        this.productSelectionForm$ = this.select((s) => s.productSelection).pipe(notNull());
        this.profileNameView$ = this.select(this.profileNameForm$, this.existingNames$, (formState, existingNames) => ({ formState, existingNames }));
        this.partnerSelectionView$ = this.select(this.partnerSelectionForm$, this.partnerTree$, (formState, partnerTree) => ({
            formState,
            partnerOptions: intoPartnerOptions(partnerTree),
        }));
        // TODO(ngrx-component-store-11): Fold back in once Web.App.Main is at TS 4.0 / Angular 11
        this.productSelectionViewKeys$ = this.select(this.supplierKey$, this.profileKey$, (supplierKey, profileKey) => ({ supplierKey, profileKey }));
        this.productSelectionView$ = this.select(this.productSelectionForm$, this.supplierHierarchies$, this.savedSelectionType$, this.productSelectionViewKeys$, (formState, supplierHierarchies, savedSelectionType, keys) => ({
            formState,
            supplierKey: keys.supplierKey,
            supplierHierarchies,
            savedSelectionType,
            profileKey: keys.profileKey,
        }));
        this.importValidationView$ = this.select(this.supplierKey$, this.importedProducts$, (supplierKey, importedProducts) => ({ supplierKey, importedProducts }));
        this.partnerKeys$ = this.select((s) => { var _a; return (_a = s.partnerSelection) === null || _a === void 0 ? void 0 : _a.partnerAccountKeys; }).pipe(notNull(), filter((it) => it.length > 0));
        this.selectedPartners$ = this.select(this.partnerTree$, this.marketplaceKey$, this.supplierKey$, this.partnerKeys$, (partnerTree, marketplaceKey, supplierKey, partnerKeys) => {
            var _a;
            const marketplace = partnerTree.accounts.find((it) => it.accountKey === marketplaceKey);
            const supplier = partnerTree.accounts.find((it) => it.accountKey === supplierKey);
            const partners = (_a = partnerTree.accounts.filter((it) => { var _a; return (_a = partnerKeys.includes(it.accountKey)) !== null && _a !== void 0 ? _a : false; })) !== null && _a !== void 0 ? _a : [];
            return { marketplace, supplier, partners };
        });
        this.summaryView$ = this.select(this.profileNameForm$, this.selectedPartners$, this.productSelectionForm$, (profileNameState, selectedPartners, productSelectionState) => {
            var _a, _b, _c, _d, _e, _f;
            return ({
                profileName: profileNameState.profileName,
                marketplaceName: (_a = selectedPartners.marketplace) === null || _a === void 0 ? void 0 : _a.legalName,
                supplierName: (_b = selectedPartners.supplier) === null || _b === void 0 ? void 0 : _b.legalName,
                groupDirectedSupplier: ((_c = selectedPartners.partners) === null || _c === void 0 ? void 0 : _c.length) === 1
                    && ((_e = (_d = selectedPartners.partners) === null || _d === void 0 ? void 0 : _d[0]) === null || _e === void 0 ? void 0 : _e.accountKey) === ((_f = selectedPartners.marketplace) === null || _f === void 0 ? void 0 : _f.accountKey),
                partners: selectedPartners.partners,
                profilePolicy: productSelectionState === null || productSelectionState === void 0 ? void 0 : productSelectionState.profilePolicy,
                productSelectionType: productSelectionState === null || productSelectionState === void 0 ? void 0 : productSelectionState.selectionType,
                hierarchyField: productSelectionState === null || productSelectionState === void 0 ? void 0 : productSelectionState.hierarchyField,
                selectedHierarchies: productSelectionState === null || productSelectionState === void 0 ? void 0 : productSelectionState.selectedHierarchies,
                usedImport: (productSelectionState === null || productSelectionState === void 0 ? void 0 : productSelectionState.selectionType) === SelectionType.SkuImport,
            });
        });
        this.saveData$ = this.select(this.profileKey$, this.profileNameForm$, this.partnerSelectionForm$, this.productSelectionForm$, (profileKey, profileName, partnerSelection, productSelection) => {
            var _a, _b;
            return ({
                profileKey,
                profileName: profileName.profileName,
                marketplaceKey: partnerSelection.accountKeyMarketplace,
                supplierKey: partnerSelection.accountKeySupplier,
                partnerKeys: partnerSelection.partnerAccountKeys,
                profilePolicy: productSelection === null || productSelection === void 0 ? void 0 : productSelection.profilePolicy,
                selectionType: productSelection === null || productSelection === void 0 ? void 0 : productSelection.selectionType,
                hierarchyField: productSelection === null || productSelection === void 0 ? void 0 : productSelection.hierarchyField,
                selectedHierarchies: productSelection === null || productSelection === void 0 ? void 0 : productSelection.selectedHierarchies,
                selectedProducts: (_b = (_a = productSelection === null || productSelection === void 0 ? void 0 : productSelection.importedProducts) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.selectedProducts,
            });
        });
        this.dirty$ = this.select((s) => s.dirty);
        this.updateProfileNameForm = this.updater((state, formState) => (Object.assign(Object.assign({}, state), { profileName: formState, dirty: true })));
        this.updatePartnerSelectionForm = this.updater((state, formState) => (Object.assign(Object.assign({}, state), { partnerSelection: formState, dirty: true })));
        this.updateProductSelectionForm = this.updater((state, formState) => (Object.assign(Object.assign({}, state), { productSelection: formState, dirty: true })));
        // Fetches the initial form state & initial data whenever we're asked to
        // initialize the wizard
        this.fetchInitialState(this.initializationData$);
        this.fetchExistingNames(this.initializationData$);
        this.fetchPartnerTree(this.profileKey$);
        // Fetch the supplier hierarchies whenever the supplier changes
        this.fetchSupplierHierarchies(this.supplierKey$);
    }
}
OutboundProfileWizardStore.ɵprov = ɵɵdefineInjectable({ factory: function OutboundProfileWizardStore_Factory() { return new OutboundProfileWizardStore(ɵɵinject(OutboundProfileWizardService)); }, token: OutboundProfileWizardStore, providedIn: "root" });
OutboundProfileWizardStore.decorators = [
    { type: Injectable, args: [{
                providedIn: 'root',
            },] }
];
OutboundProfileWizardStore.ctorParameters = () => [
    { type: OutboundProfileWizardService }
];
function intoPartnerOptions(selectionTree) {
    var _a;
    const accounts = new Map(selectionTree.accounts.map((it) => [it.accountKey, it]));
    const intoOption = (accountKey) => {
        const account = accounts.get(accountKey);
        return {
            label: account.legalName,
            value: account.accountKey,
        };
    };
    const marketplaces = selectionTree.marketplaces
        .map((marketplace) => intoOption(marketplace.marketplaceKey))
        .sort((a, b) => a.label.localeCompare(b.label));
    const suppliers = Object.assign({}, ...selectionTree.marketplaces.map((marketplace) => ({
        [marketplace.marketplaceKey]: marketplace.suppliers
            .map((supplier) => intoOption(supplier.supplierKey))
            .sort((a, b) => a.label.localeCompare(b.label)),
    })));
    const partners = Object.assign({}, ...selectionTree.marketplaces.map((marketplace) => ({
        [marketplace.marketplaceKey]: Object.assign({}, ...marketplace.suppliers.map((supplier) => ({
            [supplier.supplierKey]: supplier.partners
                .map(intoOption)
                .sort((a, b) => a.label.localeCompare(b.label)),
        }))),
    })));
    // Collect which marketplaces a supplier is marked as group-directed in
    const groupDirectedIn = selectionTree.marketplaces.map((marketplace) => Object.assign({}, ...marketplace.suppliers.filter((supplier) => supplier.partners.length === 1 && supplier.partners[0] === marketplace.marketplaceKey)
        .map((supplier) => ({
        [supplier.supplierKey]: marketplace.marketplaceKey
    }))));
    const groupDirectedSuppliers = {};
    for (const supplier of groupDirectedIn) {
        for (const [supplierKey, marketplaceKey] of Object.entries(supplier)) {
            // Make sure the supplier has an array to fold into
            (_a = groupDirectedSuppliers[supplierKey]) !== null && _a !== void 0 ? _a : (groupDirectedSuppliers[supplierKey] = []);
            groupDirectedSuppliers[supplierKey].push(marketplaceKey);
        }
    }
    return { marketplaces, suppliers, partners, groupDirectedSuppliers };
}
const toOptionsList = (root) => {
    let selected = [];
    root === null || root === void 0 ? void 0 : root.forEach((child) => {
        selected = treeFold(child, selected, (node, acc) => {
            acc.push({ label: node.path.replace(/\|$/, ''), value: node.path });
            return acc;
        });
    });
    return selected;
};
const ɵ0$8 = toOptionsList;
function treeFold(node, initial, fold) {
    var _a;
    let foldedValue = fold(node, initial);
    (_a = node.children) === null || _a === void 0 ? void 0 : _a.forEach((child) => {
        foldedValue = treeFold(child, foldedValue, fold);
    });
    return foldedValue;
}
function notNull() {
    return filter((it) => it !== undefined && it !== null);
}

class ImportValidationComponent {
    constructor(route, transloco, wizardService, store) {
        this.wizardService = wizardService;
        this.store = store;
        this._valid = new BehaviorSubject(false);
        this.valid$ = this._valid.asObservable();
        this.translations$ = route.data.pipe(switchMap((data) => data.isPdx
            ? transloco.selectTranslate('PIM.OUTBOUND_PROFILE.WIZARD.PDX.IMPORT_VALIDATION')
            : transloco.selectTranslate('PIM.OUTBOUND_PROFILE.WIZARD.IMPORT_VALIDATION')));
    }
    ngOnInit() {
        this.validation$ = this.store.importValidationView$.pipe(first(), switchMap(({ supplierKey, importedProducts }) => this.wizardService.validateSkus(supplierKey, importedProducts)), map(messages => {
            const duplicateProducts = messages.find(it => it.kind === MessageKind.DuplicateProducts
                && it.severity === ValidationSeverity.Error);
            const missingProducts = messages.find(it => it.kind === MessageKind.MissingProducts
                && it.severity === ValidationSeverity.Warning);
            this._valid.next(!messages.some(message => message.severity === ValidationSeverity.Error));
            return duplicateProducts ? { kind: 'duplicateProducts', products: duplicateProducts.products }
                : missingProducts ? { kind: 'missingProducts', products: missingProducts.products }
                    : { kind: 'correct' };
        }), shareReplay(1));
        this.wizardService.setLoadingRequest(this.validation$, this.valid$);
    }
}
ImportValidationComponent.decorators = [
    { type: Component, args: [{
                selector: 'lib-import-validation',
                template: "<div class=\"wizard-screen\">\r\n  <lui-widget-wrapper [request]=\"validation$\" [doneTemplate]=\"done\">\r\n    <ng-template #done>\r\n      <div style=\"display: flex;\">\r\n        <h3 style=\"font-size: 14px !important; margin: 0; font-weight: bold;\">{{\r\n          'PIM.OUTBOUND_PROFILE.WIZARD.STEP_IMPORT_VALIDATION' | transloco }}</h3>\r\n      </div>\r\n      <ng-container *ngIf=\"(validation$ | async) as validation\">\r\n        <ng-container [ngSwitch]=\"validation.kind\">\r\n          <div *ngSwitchDefault>\r\n            <p>{{ (translations$ | async).CORRECT.INFORMATION }}</p>\r\n          </div>\r\n          <div *ngSwitchCase=\"'missingProducts'\">\r\n            <div>\r\n              <p>{{ (translations$ | async).MISSING_PRODUCTS.INFORMATION_1 }}</p>\r\n              <p>{{ (translations$ | async).MISSING_PRODUCTS.INFORMATION_2 }}</p>\r\n            </div>\r\n            <p-table [value]=\"validation.products\">\r\n              <ng-template pTemplate=\"colgroup\">\r\n                <colgroup>\r\n                  <col style=\"width: 30%;\" />\r\n                  <col style=\"width: 30%;\" />\r\n                  <col style=\"width: 50%;\" />\r\n                </colgroup>\r\n              </ng-template>\r\n              <ng-template pTemplate=\"header\">\r\n                <tr>\r\n                  <th>{{ 'PIM.SUPPLIER_PRODUCT_KEY' | transloco }}</th>\r\n                  <th>{{ 'PIM.PRODUCT_ID' | transloco }}</th>\r\n                  <th>{{ 'PIM.PRODUCT_DESCRIPTION' | transloco }}</th>\r\n                </tr>\r\n              </ng-template>\r\n              <ng-template pTemplate=\"body\" let-missingProduct>\r\n                <tr>\r\n                  <td>\r\n                    {{ missingProduct['supplierProductKey'] }}\r\n                  </td>\r\n                  <td>\r\n                    {{ missingProduct['productId'] }}\r\n                  </td>\r\n                  <td>\r\n                    {{ missingProduct['productDescription'] }}\r\n                  </td>\r\n                </tr>\r\n              </ng-template>\r\n            </p-table>\r\n          </div>\r\n          <div *ngSwitchCase=\"'duplicateProducts'\">\r\n            <div>\r\n              <p>{{ (translations$ | async).DUPLICATE_PRODUCTS.INFORMATION_1 }}</p>\r\n              <p>{{ (translations$ | async).DUPLICATE_PRODUCTS.INFORMATION_2 }}</p>\r\n            </div>\r\n            <p-table [value]=\"validation.products\">\r\n              <ng-template pTemplate=\"colgroup\">\r\n                <colgroup>\r\n                  <col style=\"width: 30%;\" />\r\n                  <col style=\"width: 30%;\" />\r\n                  <col style=\"width: 50%;\" />\r\n                </colgroup>\r\n              </ng-template>\r\n              <ng-template pTemplate=\"header\">\r\n                <tr>\r\n                  <th>{{ 'PIM.SUPPLIER_PRODUCT_KEY' | transloco }}</th>\r\n                  <th>{{ 'PIM.PRODUCT_ID' | transloco }}</th>\r\n                  <th>{{ 'PIM.PRODUCT_DESCRIPTION' | transloco }}</th>\r\n                </tr>\r\n              </ng-template>\r\n              <ng-template pTemplate=\"body\" let-missingProduct>\r\n                <tr>\r\n                  <td>\r\n                    {{ missingProduct['supplierProductKey'] }}\r\n                  </td>\r\n                  <td>\r\n                    {{ missingProduct['productId'] }}\r\n                  </td>\r\n                  <td>\r\n                    {{ missingProduct['productDescription'] }}\r\n                  </td>\r\n                </tr>\r\n              </ng-template>\r\n            </p-table>\r\n          </div>\r\n        </ng-container>\r\n      </ng-container>\r\n    </ng-template>\r\n  </lui-widget-wrapper>\r\n</div>",
                styles: [":host ::ng-deep .ui-table table{width:66%}:host ::ng-deep .ui-table table .ui-table-thead th{padding:1em 1.5em 1.5em;border-left:1px solid #ccc;font-weight:400;text-align:start}:host ::ng-deep .ui-table table .ui-table-thead th:first-child{border-left:none}:host ::ng-deep .ui-table table .ui-table-tbody td{padding-left:1.5em}"]
            },] }
];
ImportValidationComponent.ctorParameters = () => [
    { type: ActivatedRoute },
    { type: TranslocoService },
    { type: OutboundProfileWizardService },
    { type: OutboundProfileWizardStore }
];

class OutboundProfileWizardComponent extends ComponentCanDeactivateDirective {
    constructor(route, router, breadcrumb, transloco, toastService, wizardService, spinnerService, store, baseHttp, pimService) {
        var _a, _b, _c;
        super();
        this.route = route;
        this.router = router;
        this.breadcrumb = breadcrumb;
        this.transloco = transloco;
        this.toastService = toastService;
        this.wizardService = wizardService;
        this.spinnerService = spinnerService;
        this.store = store;
        this.subscriptions = [];
        this.dirty = false;
        this.wizardTitle = 'PIM.OUTBOUND_PROFILE.WIZARD.NEW_TITLE';
        this.selectedStep = 0;
        this.steps = [
            {
                disabled: false,
                label: 'PIM.OUTBOUND_PROFILE.WIZARD.STEP_PROFILE_NAME'
            },
            {
                disabled: false,
                label: 'PIM.OUTBOUND_PROFILE.WIZARD.STEP_PARTNER_SELECTION'
            },
            {
                disabled: false,
                label: 'PIM.OUTBOUND_PROFILE.WIZARD.STEP_PRODUCT_SELECTION'
            },
            {
                // By default, start out as disabled as new profiles don't have import data
                disabled: true,
                label: 'PIM.OUTBOUND_PROFILE.WIZARD.STEP_IMPORT_VALIDATION'
            },
            {
                disabled: false,
                label: 'PIM.OUTBOUND_PROFILE.WIZARD.STEP_SUMMARY'
            }
        ];
        // Set the base url for BaseHttpService requests (used by per-form-primeng)
        baseHttp.baseUrl = pimService.getConfig().uriProduct.baseUri;
        const initialWizardState = (_c = (_b = (_a = this.router.getCurrentNavigation()) === null || _a === void 0 ? void 0 : _a.extras) === null || _b === void 0 ? void 0 : _b.state) !== null && _c !== void 0 ? _c : {
            wizardMode: WizardMode.New,
            profileKey: null
        };
        this.store.initializeForMode(initialWizardState);
        switch (initialWizardState.wizardMode) {
            case WizardMode.Edit:
                this.wizardTitle = 'PIM.OUTBOUND_PROFILE.WIZARD.EDIT_TITLE';
                break;
            case WizardMode.Copy:
                this.wizardTitle = 'PIM.OUTBOUND_PROFILE.WIZARD.COPY_TITLE';
                break;
            case WizardMode.New:
            default:
                this.wizardTitle = 'PIM.OUTBOUND_PROFILE.WIZARD.NEW_TITLE';
        }
    }
    get formRequest$() {
        return this.wizardService.request$;
    }
    get validation$() {
        return this.wizardService.validation$;
    }
    ngOnInit() {
        const stepNumber = this.route.snapshot.queryParams.page;
        if (stepNumber !== undefined && stepNumber > 0 && stepNumber <= this.steps.length) {
            this.selectedStep = stepNumber - 1;
        }
        else {
            // Either first page load or invalid param, go back to the first page
            this.clickStep(0, true);
        }
        this.breadcrumb.set('@outbound-profile-wizard', { label: this.wizardTitle });
        this.subscriptions.push(this.store.dirty$.subscribe(dirty => {
            // Keep track of the dirty state
            this.dirty = dirty;
            if (!this.dirty && this.selectedStep !== 0) {
                // Not in a dirty state but we're not on the first page, kick us back to the start of the wizard
                this.clickStep(0, false);
            }
        }));
        this.subscriptions.push(this.store.productSelectionView$.subscribe(state => {
            // Disable the import validation step if SkuImport isn't selected
            this.steps[3].disabled = state.formState.selectionType !== SelectionType.SkuImport;
        }));
        this.subscriptions.push(this.route.queryParams.pipe(debounceTime(0), filter(params => !!params && Object.keys(params).includes('page')), 
        // Skip the initial page load
        skip(1)).subscribe(params => {
            // Since the only way to navigate through the wizard without leaving it
            // is via the browser back & forward navigations and the Back & Next
            // buttons, we can assume that the provided page is always valid.
            this.selectedStep = params.page - 1;
        }));
    }
    ngOnDestroy() {
        if (this.subscriptions) {
            this.subscriptions.forEach(subscription => subscription.unsubscribe());
        }
    }
    canDeactivate(_nextState) {
        return !this.dirty;
    }
    clickStep(stepNumber, initialLoad = false) {
        this.selectedStep = stepNumber;
        this.router.navigate(['./'], {
            relativeTo: this.route,
            queryParams: {
                page: stepNumber + 1
            },
            replaceUrl: initialLoad,
        });
    }
    back() {
        let prevStep = this.selectedStep - 1;
        // skip disabled steps
        while (prevStep > 0 && this.steps[prevStep].disabled) {
            prevStep--;
        }
        this.clickStep(prevStep);
    }
    next() {
        let nextStep = this.selectedStep + 1;
        // skip disabled steps
        while (nextStep < this.steps.length && this.steps[nextStep].disabled) {
            nextStep++;
        }
        this.clickStep(nextStep);
    }
    save() {
        this.store.saveData$.pipe(first(), tap(_ => this.spinnerService.on()), exhaustMap(currentState => this.wizardService.saveProfile(currentState))).subscribe(_ok => {
            this.spinnerService.off();
            this.toastService.successNotify(this.transloco.translate('PIM.OUTBOUND_PROFILE.SAVE_SUCCESS'));
            this.dirty = false;
            this.router.navigate(['../'], { relativeTo: this.route });
        }, err => {
            this.spinnerService.off();
            const message = (err === null || err === void 0 ? void 0 : err.errorCode) === 3 ? 'PIM.OUTBOUND_PROFILE.PROFILE_NAME_DUPLICATE' : 'MESSAGES.GENERIC_ERROR';
            this.toastService.errorNotify(this.transloco.translate(message), this.transloco.translate('PIM.OUTBOUND_PROFILE.SAVE_FAILURE_TITLE'));
        });
    }
}
OutboundProfileWizardComponent.decorators = [
    { type: Component, args: [{
                selector: 'lib-outbound-profile-wizard',
                template: "<div class=\"outbound-profile-wizard wizard-v2 visible-dropdown\">\r\n  <div style=\"display: flex\">\r\n    <h2>{{ wizardTitle | transloco }}</h2>\r\n  </div>\r\n\r\n  <div class=\"wizard-box\">\r\n    <div class=\"steps\">\r\n      <ng-container *ngFor=\"let step of steps; let i = index\" >\r\n        <div class=\"step tab-{{step.tab ? step.tab : 0}}\" [ngClass]=\"{\r\n            selected: selectedStep === i,\r\n            future: selectedStep < i && !step.disabled\r\n          }\" title=\"{{step.label | transloco}}\">\r\n          {{ step.label | transloco }}\r\n        </div>\r\n        <span class=\"icons\"></span>\r\n      </ng-container>\r\n    </div>\r\n\r\n    <div class=\"screen-menu position-relative\">\r\n      <div class=\"wizard-screen\">\r\n        <ng-container [ngSwitch]=\"selectedStep\">\r\n          <lib-profile-name *ngSwitchCase=\"0\"></lib-profile-name>\r\n          <lib-partner-selection *ngSwitchCase=\"1\"></lib-partner-selection>\r\n          <lib-product-selection *ngSwitchCase=\"2\"></lib-product-selection>\r\n          <lib-import-validation *ngSwitchCase=\"3\"></lib-import-validation>\r\n          <lib-summary *ngSwitchCase=\"4\"></lib-summary>\r\n        </ng-container>\r\n\r\n        <div class=\"controls\" *ngIf=\"formRequest$ | async\">\r\n          <button class=\"ds secondary\" pButton type=\"button\"\r\n            [routerLink]=\"['../']\">{{ \"ACTIONS.CANCEL\" | transloco }}</button>\r\n          <button class=\"ds primary\" pButton (click)=\"back()\" *ngIf=\"selectedStep !== 0\">{{ \"ACTIONS.BACK\" | transloco }}</button>\r\n          <button class=\"ds primary\" pButton (click)=\"next()\" *ngIf=\"selectedStep !== steps.length - 1\"\r\n            [disabled]=\"!(validation$ | async)\">\r\n            {{ \"ACTIONS.NEXT\" | transloco }}\r\n          </button>\r\n          <button class=\"ds primary\" pButton (click)=\"save()\" *ngIf=\"selectedStep === steps.length - 1\">{{ \"ACTIONS.SAVE\" | transloco }}</button>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n\r\n<p-confirmDialog deactivateDialog [closeOnEscape]=\"false\" [closable]=\"false\"></p-confirmDialog>\r\n",
                providers: [
                    OutboundProfileWizardStore
                ],
                styles: [".wizard-dialog body .ui-dialog .ui-dialog-content{padding:0}.wizard-v2 .wizard-box{display:flex;flex-direction:row;min-height:10em}.wizard-v2 .wizard-box>:not(:first-child){padding-left:30px;margin-left:30px;border-left:1px solid var(--light-grey)}.wizard-v2 .wizard-box .steps{display:grid;grid-template-columns:1fr auto;height:-moz-fit-content;height:fit-content;white-space:nowrap;row-gap:1em}.wizard-v2 .wizard-box .steps .step{display:flex;flex-direction:column;align-self:center;gap:.5em;color:var(--grey)}.wizard-v2 .wizard-box .steps .step.selected{color:var(--red-brand);font-weight:700}.wizard-v2 .wizard-box .steps .step.future{color:var(--dark-grey)}.wizard-v2 .wizard-box .steps .step.future.disabled{color:var(--grey)}.wizard-v2 .wizard-box .steps .step.link:hover{cursor:pointer}.wizard-v2 .wizard-box .steps .step.tab-1{padding-left:2em}.wizard-v2 .wizard-box .steps .step.tab-2{padding-left:4em}.wizard-v2 .wizard-box .steps .step.tab-3{padding-left:6em}.wizard-v2 .wizard-box .steps .icons{display:flex}.wizard-v2 .wizard-box .steps .icons>:first-child{padding-left:20px}.wizard-v2 .wizard-box .steps .icons .information-icon>*{color:#000}.wizard-v2 .wizard-box .steps .icons .warning-icon>*{color:#e50000}.wizard-v2 .wizard-box .screen-menu{flex-grow:1}.wizard-screen .controls{display:flex;gap:.5em;padding-top:1em;margin-bottom:5em}.ui-dialog-content .wizard-screen .controls{padding:unset;margin-bottom:1em}.wizard-v2 .wizard-box .steps .step:after{display:block;content:attr(title);font-weight:700;height:1px;color:transparent;overflow:hidden;visibility:hidden}"]
            },] }
];
OutboundProfileWizardComponent.ctorParameters = () => [
    { type: ActivatedRoute },
    { type: Router },
    { type: BreadcrumbService },
    { type: TranslocoService },
    { type: ToastrNotificationService$1 },
    { type: OutboundProfileWizardService },
    { type: SpinnerService$1 },
    { type: OutboundProfileWizardStore },
    { type: BaseHttpService },
    { type: PimService }
];

const partnerSelectionForm = (transloco, data, state) => {
    var _a, _b, _c;
    return ({
        layout: {
            'grid-template-columns': '1fr 1fr',
            'grid-template-areas': `
      "accountKeyMarketplace ."
      "accountKeySupplier ."
      "partnerAccountKeys partnerAccountKeys"
    `,
        },
        fields: {
            accountKeyMarketplace: {
                type: 'dropdown',
                label: transloco.translate('PIM.OUTBOUND_PROFILE.WIZARD.MARKETPLACE_NAME'),
                defaultValue: (_a = state === null || state === void 0 ? void 0 : state.accountKeyMarketplace) !== null && _a !== void 0 ? _a : null,
                options: data.marketplaces,
                required: data.marketplaces.length > 0,
                componentProperties: {
                    placeholder: transloco.translate('ACTIONS.SELECT')
                },
                validations: [
                    {
                        test: () => data.marketplaces.length > 0,
                        message: transloco.translate('PIM.OUTBOUND_PROFILE.WIZARD.MARKETPLACE_NO_PARTNERS'),
                    }
                ]
            },
            accountKeySupplier: {
                type: 'dropdown',
                label: transloco.translate('PIM.OUTBOUND_PROFILE.WIZARD.SUPPLIER_NAME'),
                defaultValue: (_b = state === null || state === void 0 ? void 0 : state.accountKeySupplier) !== null && _b !== void 0 ? _b : null,
                required: true,
                componentProperties: {
                    placeholder: transloco.translate('ACTIONS.SELECT'),
                    filter: true,
                    filterBy: 'label'
                }
            },
            partnerAccountKeys: {
                type: 'pickList',
                label: transloco.translate('PIM.OUTBOUND_PROFILE.WIZARD.PARTNER_SELECTION.LABEL'),
                information: transloco.translate('PIM.OUTBOUND_PROFILE.WIZARD.PARTNER_SELECTION.INFORMATION'),
                defaultValue: (_c = state === null || state === void 0 ? void 0 : state.partnerAccountKeys) !== null && _c !== void 0 ? _c : null,
                display: false,
                componentProperties: {
                    responsive: true,
                    dragdrop: true,
                    filterBy: 'label',
                    sourceHeader: transloco.translate('PIM.OUTBOUND_PROFILE.WIZARD.PARTNER_SELECTION.AVAILABLE'),
                    targetHeader: transloco.translate('PIM.OUTBOUND_PROFILE.WIZARD.PARTNER_SELECTION.SELECTED'),
                    showSourceControls: false,
                    showTargetControls: false,
                },
                validations: [
                    {
                        test: (values) => {
                            var _a, _b, _c;
                            return ((_b = (_a = data.partners[values.accountKeyMarketplace]) === null || _a === void 0 ? void 0 : _a[values.accountKeySupplier]) === null || _b === void 0 ? void 0 : _b.length) > 0
                                ? ((_c = values.partnerAccountKeys) === null || _c === void 0 ? void 0 : _c.length) > 0
                                : true;
                        },
                        message: transloco.translate('PIM.OUTBOUND_PROFILE.WIZARD.PARTNER_SELECTION.REQUIRED'),
                    }
                ]
            }
        },
        effects: [
            // Inject the old marketplace & supplier key into the form state
            {
                fields: [],
                actions: [
                    { set: ['oldMarketplaceKey', state === null || state === void 0 ? void 0 : state.oldMarketplaceKey] },
                    { set: ['oldSupplierKey', state === null || state === void 0 ? void 0 : state.oldSupplierKey] }
                ]
            },
            // If there's only one marketplace, select it and disable the field
            {
                fields: [],
                condition: {
                    '==': [
                        { length: [data.marketplaces] },
                        1
                    ]
                },
                actions: [
                    {
                        set: [
                            'accountKeyMarketplace',
                            {
                                getHashValue: [
                                    {
                                        getHashValue: [
                                            { literal: [data.marketplaces] },
                                            0
                                        ]
                                    },
                                    'value'
                                ]
                            }
                        ]
                    },
                    {
                        setFieldOptions: ['accountKeyMarketplace', data.marketplaces]
                    },
                    {
                        setFieldDisabled: ['accountKeyMarketplace', true]
                    }
                ]
            },
            // Set the correct set of suppliers
            {
                fields: ['accountKeyMarketplace'],
                condition: {
                    '&&': [
                        {
                            '!=': [
                                { get: ['accountKeyMarketplace'] },
                                null,
                            ]
                        },
                        {
                            '!=': [
                                { get: ['accountKeyMarketplace'] },
                                '',
                            ]
                        },
                    ]
                },
                actions: [
                    {
                        setFieldOptions: [
                            'accountKeySupplier',
                            {
                                getHashValue: [
                                    { literal: [data.suppliers] },
                                    { get: ['accountKeyMarketplace'] }
                                ]
                            }
                        ]
                    },
                ]
            },
            // Clear the supplier if the old marketplace changed at all
            {
                fields: ['accountKeyMarketplace'],
                condition: {
                    '&&': [
                        {
                            '!=': [
                                { get: ['accountKeyMarketplace'] },
                                null
                            ]
                        },
                        {
                            '!=': [
                                { get: ['accountKeyMarketplace'] },
                                { get: ['oldMarketplaceKey'] },
                            ]
                        }
                    ]
                },
                actions: [
                    {
                        set: [
                            'accountKeySupplier',
                            null,
                        ]
                    },
                ]
            },
            // If there's only one supplier, select it and disable the field
            {
                fields: ['accountKeyMarketplace'],
                condition: {
                    '&&': [
                        {
                            '!=': [
                                { get: ['accountKeyMarketplace'] },
                                null,
                            ]
                        },
                        {
                            '!=': [
                                { get: ['accountKeyMarketplace'] },
                                '',
                            ]
                        },
                        {
                            '==': [
                                {
                                    length: [
                                        {
                                            getHashValue: [
                                                { literal: [data.suppliers] },
                                                { get: ['accountKeyMarketplace'] }
                                            ]
                                        }
                                    ]
                                },
                                1
                            ],
                        }
                    ]
                },
                actions: [
                    {
                        set: [
                            'accountKeySupplier',
                            {
                                getHashValue: [
                                    {
                                        getHashValue: [
                                            {
                                                getHashValue: [
                                                    { literal: [data.suppliers] },
                                                    { get: ['accountKeyMarketplace'] }
                                                ]
                                            },
                                            0
                                        ]
                                    },
                                    'value'
                                ]
                            }
                        ]
                    },
                    {
                        setFieldDisabled: ['accountKeySupplier', true]
                    }
                ]
            },
            // If there's more than one supplier, enable the field again
            {
                fields: ['accountKeyMarketplace'],
                condition: {
                    '&&': [
                        {
                            '!=': [
                                { get: ['accountKeyMarketplace'] },
                                null,
                            ]
                        },
                        {
                            '!=': [
                                { get: ['accountKeyMarketplace'] },
                                '',
                            ]
                        },
                        {
                            '!=': [
                                {
                                    length: [
                                        {
                                            getHashValue: [
                                                { literal: [data.suppliers] },
                                                { get: ['accountKeyMarketplace'] }
                                            ]
                                        }
                                    ]
                                },
                                1
                            ],
                        }
                    ]
                },
                actions: [
                    {
                        setFieldDisabled: ['accountKeySupplier', false]
                    }
                ]
            },
            // Set the correct set of partners
            {
                fields: ['accountKeyMarketplace', 'accountKeySupplier'],
                condition: {
                    '&&': [
                        {
                            '!=': [
                                { get: ['accountKeyMarketplace'] },
                                null
                            ]
                        },
                        {
                            '!=': [
                                { get: ['accountKeySupplier'] },
                                null
                            ]
                        },
                    ]
                },
                actions: [
                    {
                        setFieldOptions: [
                            'partnerAccountKeys',
                            {
                                getHashValue: [
                                    {
                                        getHashValue: [
                                            { literal: [data.partners] },
                                            { get: ['accountKeyMarketplace'] }
                                        ]
                                    },
                                    { get: ['accountKeySupplier'] }
                                ]
                            }
                        ]
                    }
                ]
            },
            // Since setting the options clears the selection, set the partners again
            // if the supplier still hasn't changed
            {
                fields: [],
                condition: {
                    '==': [
                        { get: ['accountKeySupplier'] },
                        { get: ['oldSupplierKey'] },
                    ]
                },
                actions: [
                    {
                        set: [
                            'partnerAccountKeys',
                            { literal: [state.partnerAccountKeys] }
                        ]
                    }
                ]
            },
            // Clear the partner keys if the old supplier changed at all
            {
                fields: ['accountKeySupplier'],
                condition: {
                    '&&': [
                        {
                            '!=': [
                                { get: ['accountKeySupplier'] },
                                null
                            ]
                        },
                        {
                            '!=': [
                                { get: ['accountKeySupplier'] },
                                { get: ['oldSupplierKey'] },
                            ]
                        }
                    ]
                },
                actions: [
                    { set: ['partnerAccountKeys', null] },
                ]
            },
            // If the supplier was formerly group-directed but is now
            // supplier-directed, remove the marketplace partner selection
            {
                fields: ['accountKeyMarketplace', 'accountKeySupplier'],
                condition: {
                    '&&': [
                        {
                            '==': [
                                { get: ['accountKeyMarketplace'] },
                                state.accountKeyMarketplace,
                            ]
                        },
                        {
                            '==': [
                                { get: ['accountKeySupplier'] },
                                state.accountKeySupplier,
                            ]
                        },
                        // HACK: Intentionally lose type information through an any cast
                        // so that we can index into the group directed suppliers array
                        // dynamically
                        {
                            '!': [
                                {
                                    includes: [
                                        {
                                            getHashValue: [
                                                { literal: [data.groupDirectedSuppliers] },
                                                { get: ['accountKeySupplier'] },
                                            ],
                                        },
                                        { get: ['accountKeyMarketplace'] }
                                    ]
                                },
                            ]
                        },
                        {
                            '==': [
                                {
                                    length: [
                                        { get: ['partnerAccountKeys'] }
                                    ]
                                },
                                1
                            ]
                        },
                        {
                            '==': [
                                {
                                    getHashValue: [
                                        { get: ['partnerAccountKeys'] },
                                        0
                                    ]
                                },
                                state.accountKeyMarketplace,
                            ]
                        }
                    ]
                },
                actions: [
                    { set: ['partnerAccountKeys', null] },
                ]
            },
            // If the supplier is group-directed, auto-fill the marketplace
            // as the only partner
            {
                fields: ['accountKeyMarketplace', 'accountKeySupplier'],
                condition: {
                    '&&': [
                        {
                            '!=': [
                                { get: ['accountKeySupplier'] },
                                null
                            ]
                        },
                        // HACK: Intentionally lose type information through an any cast
                        // so that we can index into the group directed suppliers array
                        // dynamically
                        {
                            includes: [
                                {
                                    getHashValue: [
                                        { literal: [data.groupDirectedSuppliers] },
                                        { get: ['accountKeySupplier'] },
                                    ],
                                },
                                { get: ['accountKeyMarketplace'] }
                            ]
                        }
                    ]
                },
                actions: [
                    {
                        set: [
                            'partnerAccountKeys',
                            {
                                getHashValue: [
                                    { literal: [arrayify(data.marketplaces)] },
                                    { get: ['accountKeyMarketplace'] }
                                ]
                            },
                        ]
                    },
                ]
            },
            // Change detection effects, run after everything that inspects the changed
            // state and updates the old field values
            // Update the old marketplace key
            {
                fields: ['accountKeyMarketplace'],
                condition: {
                    '!=': [
                        { get: ['accountKeyMarketplace'] },
                        { get: ['oldMarketplaceKey'] },
                    ]
                },
                actions: [
                    {
                        set: [
                            'oldMarketplaceKey',
                            { get: ['accountKeyMarketplace'] }
                        ]
                    },
                ]
            },
            // Update the old supplier key
            {
                fields: ['accountKeySupplier'],
                condition: {
                    '!=': [
                        { get: ['accountKeySupplier'] },
                        { get: ['oldSupplierKey'] },
                    ]
                },
                actions: [
                    {
                        set: [
                            'oldSupplierKey',
                            { get: ['accountKeySupplier'] }
                        ]
                    },
                ]
            },
            // Visual Effects, run after all of the logic has been processed
            // Only show supplier selection if we've chosen a marketplace
            {
                fields: ['accountKeyMarketplace'],
                condition: {
                    '!': [{
                            '||': [
                                { '==': [{ get: ['accountKeyMarketplace'] }, null] },
                                { '==': [{ get: ['accountKeyMarketplace'] }, ''] },
                            ]
                        }]
                },
                actions: [
                    { setFieldProperty: ['accountKeySupplier', 'display', true] },
                ]
            },
            {
                fields: ['accountKeyMarketplace'],
                condition: {
                    '||': [
                        { '==': [{ get: ['accountKeyMarketplace'] }, null] },
                        { '==': [{ get: ['accountKeyMarketplace'] }, ''] },
                    ]
                },
                actions: [
                    { setFieldProperty: ['accountKeySupplier', 'display', false] },
                ]
            },
            // Only show partner selection if we've chosen a supplier who isn't group directed
            {
                fields: ['accountKeyMarketplace', 'accountKeySupplier'],
                actions: [
                    {
                        setFieldProperty: [
                            'partnerAccountKeys',
                            'display',
                            {
                                '&&': [
                                    {
                                        '!': [
                                            {
                                                '||': [
                                                    { '==': [{ get: ['accountKeySupplier'] }, null] },
                                                    { '==': [{ get: ['accountKeySupplier'] }, ''] },
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        '!': [
                                            {
                                                includes: [
                                                    {
                                                        getHashValue: [
                                                            { literal: [data.groupDirectedSuppliers] },
                                                            { get: ['accountKeySupplier'] },
                                                        ],
                                                    },
                                                    { get: ['accountKeyMarketplace'] }
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    },
                ]
            },
        ]
    });
};
// HACK: Used because PerForm can't generate an array with the given elements
// dynamically
const arrayify = (marketplaces) => Object.assign({}, ...marketplaces.map((marketplace) => ({ [marketplace.value]: [marketplace.value] })));
const ɵ0$9 = arrayify;

class PartnerSelectionComponent {
    constructor(formService, wizardService, store, transloco) {
        this.formService = formService;
        this.wizardService = wizardService;
        this.store = store;
        this.transloco = transloco;
        this.subscriptions = [];
    }
    ngOnInit() {
        this.form$ = this.store.partnerSelectionView$
            .pipe(first(), map(({ formState, partnerOptions }) => partnerSelectionForm(this.transloco, partnerOptions, formState)), map(formDefinition => this.formService.init(formDefinition)), withLatestFrom(this.store.partnerSelectionView$), tap(([form, { formState }]) => {
            // HACK: Force a validation after all effects have been applied
            // Ensures that the validation is run on the latest view of the form state
            form.validateForm();
            this.subscriptions.push(form.values$.pipe(
            // underlying observable is a BehaviorSubject, so we skip the initial
            // value so as to preserve the initial not dirty state.
            skip(1), tap((values) => {
                this.store.updatePartnerSelectionForm(values);
            })).subscribe());
            if (form.values.partnerAccountKeys !== formState.partnerAccountKeys) {
                // HACK: If the partner account keys have changed at all (using
                // reference equality because we want to detect supplier changes),
                // force a form value update
                form.patch(form.values);
            }
        }), map(([form]) => form), shareReplay(1));
        this.wizardService.setFormLoadingRequest(this.form$);
    }
    ngOnDestroy() {
        if (this.subscriptions) {
            this.subscriptions.forEach(subscription => subscription.unsubscribe());
        }
    }
}
PartnerSelectionComponent.decorators = [
    { type: Component, args: [{
                selector: 'lib-partner-selection',
                template: "<div class=\"wizard-screen\">\r\n  <lui-widget-wrapper [request]=\"form$\" [doneTemplate]=\"done\">\r\n    <ng-template #done>\r\n      <lui-form *ngIf=\"(form$ | async) as form\" [form]=\"form\"></lui-form>\r\n    </ng-template>\r\n  </lui-widget-wrapper>\r\n</div>\r\n",
                styles: [":host ::ng-deep p-picklist .ui-picklist-list{border:1px solid #e0e0e0;border-top:none}:host ::ng-deep p-picklist .ui-picklist-list .ui-picklist-item:nth-of-type(4n){background-color:#f2f2f2}:host ::ng-deep p-picklist .ui-picklist-list .ui-picklist-item:nth-of-type(4n).ui-state-highlight,:host ::ng-deep p-picklist .ui-picklist-list .ui-picklist-item:nth-of-type(4n):not(.ui-state-highlight):hover{background-color:#f9f9f9}:host ::ng-deep p-picklist .ui-picklist-caption{padding:.75em 1.5em;color:#525252;background-color:#e0e0e0;font-weight:400;text-align:start}:host ::ng-deep p-picklist .ui-picklist-buttons .ui-button{background-color:#e0e0e0;border-color:#e0e0e0;color:#525252;font-weight:400}"]
            },] }
];
PartnerSelectionComponent.ctorParameters = () => [
    { type: GenerateFormService },
    { type: OutboundProfileWizardService },
    { type: OutboundProfileWizardStore },
    { type: TranslocoService }
];

const productSelectionForm = (transloco, data, callbacks, state) => {
    var _a, _b, _c, _d, _e;
    return ({
        layout: {
            'grid-template-columns': '1fr 1fr',
            'grid-template-areas': [
                'profilePolicy',
                'selectionType',
                'hierarchyField',
                'selectedHierarchies',
                'exportButton',
                'importedProducts',
            ],
        },
        fields: {
            profilePolicy: {
                type: 'dropdown',
                label: transloco.translate('PIM.OUTBOUND_PROFILE.WIZARD.PROFILE_POLICY.LABEL'),
                information: transloco.translate('PIM.OUTBOUND_PROFILE.WIZARD.PROFILE_POLICY.INFORMATION'),
                defaultValue: (_a = state === null || state === void 0 ? void 0 : state.profilePolicy) !== null && _a !== void 0 ? _a : null,
                required: true,
                options: [
                    {
                        label: transloco.translate('PIM.OUTBOUND_PROFILE.WIZARD.PROFILE_POLICY.INCLUDE_ALL'),
                        value: ProfilePolicy.IncludeAll,
                    },
                    {
                        label: transloco.translate('PIM.OUTBOUND_PROFILE.WIZARD.PROFILE_POLICY.EXCLUDE_ALL'),
                        value: ProfilePolicy.ExcludeAll,
                    },
                    {
                        label: transloco.translate('PIM.OUTBOUND_PROFILE.WIZARD.PROFILE_POLICY.INCLUDE_SPECIFIC'),
                        value: ProfilePolicy.IncludeSpecific,
                    },
                    {
                        label: transloco.translate('PIM.OUTBOUND_PROFILE.WIZARD.PROFILE_POLICY.EXCLUDE_SPECIFIC'),
                        value: ProfilePolicy.ExcludeSpecific,
                    },
                ],
                componentProperties: {
                    placeholder: transloco.translate('ACTIONS.SELECT'),
                },
            },
            selectionType: {
                type: 'dropdown',
                label: transloco.translate('PIM.OUTBOUND_PROFILE.WIZARD.SELECTION_TYPE.LABEL'),
                information: transloco.translate('PIM.OUTBOUND_PROFILE.WIZARD.SELECTION_TYPE.INFORMATION'),
                defaultValue: (_b = state === null || state === void 0 ? void 0 : state.selectionType) !== null && _b !== void 0 ? _b : null,
                display: false,
                options: [
                    {
                        label: transloco.translate('PIM.OUTBOUND_PROFILE.WIZARD.SELECTION_TYPE.HIERARCHY_FIELD'),
                        value: SelectionType.HierarchyField,
                    },
                    {
                        label: transloco.translate('PIM.OUTBOUND_PROFILE.WIZARD.SELECTION_TYPE.SKU_IMPORT'),
                        value: SelectionType.SkuImport,
                    },
                ],
                componentProperties: {
                    placeholder: transloco.translate('ACTIONS.SELECT'),
                },
                validations: [
                    {
                        test: (values) => ([ProfilePolicy.IncludeSpecific, ProfilePolicy.ExcludeSpecific].includes(values.profilePolicy))
                            ? isNotEmpty(values.selectionType)
                            : true,
                        message: transloco.translate('VALIDATION_MESSAGE.FIELD_REQUIRED')
                    }
                ],
            },
            hierarchyField: {
                type: 'dropdown',
                label: transloco.translate('PIM.OUTBOUND_PROFILE.WIZARD.HIERARCHY_FIELD_SELECTION.LABEL'),
                information: transloco.translate('PIM.OUTBOUND_PROFILE.WIZARD.HIERARCHY_FIELD_SELECTION.INFORMATION'),
                defaultValue: (_c = state === null || state === void 0 ? void 0 : state.hierarchyField) !== null && _c !== void 0 ? _c : null,
                display: false,
                options: [
                    {
                        label: transloco.translate('PIM.OUTBOUND_PROFILE.WIZARD.HIERARCHY_FIELD_SELECTION.SUPPLIER_HIERARCHY'),
                        value: HierarchyType.SupplierHierarchy,
                    },
                    {
                        label: transloco.translate('PIM.OUTBOUND_PROFILE.WIZARD.HIERARCHY_FIELD_SELECTION.GROUP_HIERARCHY'),
                        value: HierarchyType.GroupHierarchy,
                    },
                    {
                        label: transloco.translate('PIM.OUTBOUND_PROFILE.WIZARD.HIERARCHY_FIELD_SELECTION.MEMBER_HIERARCHY'),
                        value: HierarchyType.MemberHierarchy,
                    },
                    {
                        label: transloco.translate('PIM.OUTBOUND_PROFILE.WIZARD.HIERARCHY_FIELD_SELECTION.OUTBOUND_HIERARCHY'),
                        value: HierarchyType.OutboundHierarchy,
                    },
                ],
                componentProperties: {
                    placeholder: transloco.translate('ACTIONS.SELECT')
                },
                validations: [
                    {
                        test: (values) => (values.selectionType === SelectionType.HierarchyField)
                            ? isNotEmpty(values.hierarchyField)
                            : true,
                        message: transloco.translate('VALIDATION_MESSAGE.FIELD_REQUIRED')
                    },
                    {
                        test: (values) => isHierarchySelected(values)
                            ? data.availableHierarchies.includes(values.hierarchyField)
                            : true,
                        message: transloco.translate('PIM.OUTBOUND_PROFILE.WIZARD.HIERARCHY_FIELD_SELECTION.FIELD_DISABLED')
                    },
                    {
                        test: (values) => isHierarchySelected(values)
                            ? data.supplierHierarchies[values.hierarchyField].length !== 0
                            : true,
                        message: transloco.translate('PIM.OUTBOUND_PROFILE.WIZARD.HIERARCHY_FIELD_SELECTION.FIELD_NO_DATA')
                    },
                ],
            },
            selectedHierarchies: {
                type: 'multiSelect',
                label: transloco.translate('PIM.OUTBOUND_PROFILE.WIZARD.HIERARCHY_SELECTION.LABEL'),
                information: transloco.translate('PIM.OUTBOUND_PROFILE.WIZARD.HIERARCHY_SELECTION.INFORMATION'),
                defaultValue: (_d = state === null || state === void 0 ? void 0 : state.selectedHierarchies) !== null && _d !== void 0 ? _d : null,
                display: false,
                options: [],
                validations: [
                    {
                        test: (values) => {
                            var _a;
                            return (values.selectionType === SelectionType.HierarchyField)
                                ? ((_a = values.selectedHierarchies) === null || _a === void 0 ? void 0 : _a.length) > 0
                                : true;
                        },
                        message: transloco.translate('PIM.OUTBOUND_PROFILE.WIZARD.HIERARCHY_SELECTION.REQUIRED')
                    }
                ],
            },
            exportButton: {
                type: 'button',
                label: transloco.translate('PIM.OUTBOUND_PROFILE.WIZARD.EXPORT.LABEL'),
                information: data.isPdx
                    ? transloco.translate('PIM.OUTBOUND_PROFILE.WIZARD.PDX.EXPORT.INFORMATION')
                    : transloco.translate('PIM.OUTBOUND_PROFILE.WIZARD.EXPORT.INFORMATION'),
                display: false,
                callback: callbacks.export
            },
            importedProducts: {
                type: 'fileUpload',
                label: transloco.translate('PIM.OUTBOUND_PROFILE.WIZARD.IMPORT.LABEL'),
                information: transloco.translate('PIM.OUTBOUND_PROFILE.WIZARD.IMPORT.INFORMATION'),
                defaultValue: (_e = state === null || state === void 0 ? void 0 : state.importedProducts) !== null && _e !== void 0 ? _e : null,
                display: false,
                componentProperties: {
                    uploadLabel: transloco.translate('PIM.OUTBOUND_PROFILE.WIZARD.IMPORT.LABEL'),
                    accept: '.xlsx,.csv',
                    multiple: false,
                    endpoint: data.uploadEndpoint,
                    maxFileSize: Math.pow(10, 6),
                },
                validations: [
                    {
                        test: (values) => (values.selectionType === SelectionType.SkuImport)
                            ? isNotEmpty(values.importedProducts)
                            : true,
                        message: transloco.translate('VALIDATION_MESSAGE.FIELD_REQUIRED')
                    }
                ]
            }
        },
        effects: [
            // Inject the old hierarchy field state & supplier key into the form state
            {
                fields: [],
                actions: [
                    { set: ['oldHierarchyField', state === null || state === void 0 ? void 0 : state.oldHierarchyField] },
                    { set: ['oldSupplierKey', state === null || state === void 0 ? void 0 : state.oldSupplierKey] }
                ]
            },
            // Clear the selected hierarchies if the supplier changed from the last time
            // we got the supplier hierarchies
            {
                fields: [],
                condition: {
                    '!=': [
                        { get: ['oldSupplierKey'] },
                        data.supplierKey
                    ]
                },
                actions: [
                    { set: ['selectedHierarchies', { literal: [] }] },
                    { set: ['oldSupplierKey', data.supplierKey] }
                ]
            },
            // Clear the selected hierarchies if the old hierarchy changed at all
            {
                fields: ['hierarchyField'],
                condition: {
                    '&&': [
                        {
                            '!=': [
                                { get: ['hierarchyField'] },
                                null
                            ]
                        },
                        {
                            '!=': [
                                { get: ['hierarchyField'] },
                                { get: ['oldHierarchyField'] },
                            ]
                        }
                    ]
                },
                actions: [
                    { set: ['selectedHierarchies', null,] },
                ]
            },
            // If we selected "Include All" or "Exclude All", reset the other fields
            {
                fields: ['profilePolicy'],
                condition: {
                    includes: [
                        { literal: [[ProfilePolicy.IncludeAll, ProfilePolicy.ExcludeAll]] },
                        {
                            get: ['profilePolicy'],
                        },
                    ]
                },
                actions: [
                    { set: ['selectionType', null] },
                    { set: ['hierarchyField', null] },
                    { set: ['selectedHierarchies', null] },
                    { set: ['exportButton', null] },
                    { set: ['importedProducts', null] },
                ]
            },
            // Set the options to the right hierarhcy
            {
                fields: ['hierarchyField'],
                condition: {
                    '!=': [
                        { get: ['hierarchyField'] },
                        null
                    ]
                },
                actions: [
                    {
                        setFieldOptions: [
                            'selectedHierarchies',
                            {
                                getHashValue: [
                                    { literal: [data.supplierHierarchies] },
                                    { get: ['hierarchyField'] }
                                ]
                            }
                        ]
                    },
                ]
            },
            // Disable the hierarchy selection if there are no fields to select from
            {
                fields: ['hierarchyField'],
                actions: [
                    {
                        setFieldDisabled: [
                            'selectedHierarchies',
                            {
                                '==': [
                                    { length: [{ getFieldOptions: ['selectedHierarchies'] }] },
                                    0
                                ]
                            }
                        ]
                    }
                ]
            },
            // Change detection effects, run after everything that inspects the changed
            // state and updates the old field values
            {
                fields: ['hierarchyField'],
                condition: {
                    '!=': [
                        { get: ['hierarchyField'] },
                        { get: ['oldHierarchyField'] },
                    ]
                },
                actions: [
                    { set: ['oldHierarchyField', { get: ['hierarchyField'] }] }
                ]
            },
            // Visual Effects, run after all of the logic has been processed
            {
                fields: ['profilePolicy'],
                condition: {
                    includes: [
                        { literal: [[ProfilePolicy.IncludeAll, ProfilePolicy.ExcludeAll]] },
                        {
                            get: ['profilePolicy'],
                        },
                    ]
                },
                actions: [
                    { setFieldProperty: ['selectionType', 'display', false] },
                    { setFieldProperty: ['hierarchyField', 'display', false] },
                    { setFieldProperty: ['selectedHierarchies', 'display', false] },
                    { setFieldProperty: ['exportButton', 'display', false] },
                    { setFieldProperty: ['importedProducts', 'display', false] },
                ],
            },
            {
                fields: ['profilePolicy'],
                condition: {
                    '||': [
                        {
                            '==': [
                                {
                                    get: ['profilePolicy'],
                                },
                                ProfilePolicy.IncludeSpecific,
                            ],
                        },
                        {
                            '==': [
                                {
                                    get: ['profilePolicy'],
                                },
                                ProfilePolicy.ExcludeSpecific,
                            ],
                        },
                    ],
                },
                actions: [{ setFieldProperty: ['selectionType', 'display', true] }],
            },
            {
                fields: ['selectionType'],
                condition: {
                    '==': [
                        {
                            get: ['selectionType']
                        },
                        SelectionType.SkuImport
                    ]
                },
                actions: [
                    { setFieldProperty: ['hierarchyField', 'display', false] },
                    { setFieldProperty: ['selectedHierarchies', 'display', false] },
                    { setFieldProperty: ['exportButton', 'display', true] },
                    { setFieldProperty: ['importedProducts', 'display', true] },
                ]
            },
            {
                fields: ['selectionType'],
                condition: {
                    '==': [
                        {
                            get: ['selectionType']
                        },
                        SelectionType.HierarchyField
                    ]
                },
                actions: [
                    { setFieldProperty: ['hierarchyField', 'display', true] },
                    { setFieldProperty: ['selectedHierarchies', 'display', true] },
                    { setFieldProperty: ['exportButton', 'display', false] },
                    { setFieldProperty: ['importedProducts', 'display', false] },
                ]
            },
        ],
    });
};
const isNotEmpty = (value) => value !== '' && value !== null && value !== undefined;
const ɵ0$a = isNotEmpty;
const isHierarchySelected = (values) => values.selectionType === SelectionType.HierarchyField && isNotEmpty(values.hierarchyField);
const ɵ1$6 = isHierarchySelected;

class ProductSelectionComponent {
    constructor(route, wizardService, store, globalStore, formService, transloco, toastService) {
        this.wizardService = wizardService;
        this.store = store;
        this.globalStore = globalStore;
        this.formService = formService;
        this.transloco = transloco;
        this.toastService = toastService;
        this.subscriptions = [];
        this.subscriptions.push(route.data.subscribe((data) => this.isPdx = data.isPdx));
    }
    ngOnInit() {
        let available;
        const availableHierarchies$ = this.globalStore.select(selectors.productFields).pipe(map((config) => [
            HierarchyType.SupplierHierarchy,
            HierarchyType.GroupHierarchy,
            HierarchyType.MemberHierarchy,
            HierarchyType.OutboundHierarchy,
        ].filter((field) => { var _a; return (_a = config[field]) === null || _a === void 0 ? void 0 : _a.isIncluded; })), tap((hierarchies) => available = hierarchies));
        this.form$ = combineLatest([this.store.productSelectionView$, availableHierarchies$])
            .pipe(first(), map(([view, availableHierarchies]) => (Object.assign(Object.assign({}, view), { availableHierarchies }))), map(({ formState, availableHierarchies, supplierHierarchies, supplierKey, profileKey, savedSelectionType }) => productSelectionForm(this.transloco, {
            isPdx: this.isPdx,
            uploadEndpoint: this.wizardService.importUploadUri,
            supplierHierarchies,
            availableHierarchies,
            supplierKey,
        }, {
            export: () => this.generateExport(supplierKey, savedSelectionType, profileKey)
        }, formState)), map(formDefinition => this.formService.init(formDefinition)), tap((form) => {
            // Force a validation after all effects have been applied
            // Ensures that the validation is run on the latest view of the form state
            form.validateForm();
            // Show the hierarchy field disabled validation if the field hasn't
            // been enabled yet
            if (form.values.hierarchyField && !available.includes(form.values.hierarchyField)) {
                form.setStatus('hierarchyField', 'dirty', true);
            }
            this.subscriptions.push(form.values$.pipe(
            // underlying observable is a BehaviorSubject, so we skip the initial
            // value so as to preserve the initial not dirty state.
            skip(1), tap((values) => {
                this.store.updateProductSelectionForm(values);
            })).subscribe());
        }), shareReplay(1));
        this.wizardService.setFormLoadingRequest(this.form$);
    }
    ngOnDestroy() {
        if (this.subscriptions) {
            this.subscriptions.forEach(subscription => subscription.unsubscribe());
        }
    }
    generateExport(supplierKey, savedSelectionType, profileKey) {
        let blob;
        if (savedSelectionType === SelectionType.SkuImport && profileKey) {
            blob = this.wizardService.exportProfileSkus(profileKey);
        }
        else {
            blob = this.wizardService.exportAllSkus(supplierKey);
        }
        blob.subscribe(response => {
            var _a;
            // Extract out the "filename=UTF-8''(name)" part of the content disposition
            const contentDisposition = response.headers.get('Content-Disposition');
            const filenamePart = /filename\*="?UTF-8''([^"]+)"?/i.exec(contentDisposition);
            const filename = (_a = (filenamePart && decodeURI(filenamePart[1]))) !== null && _a !== void 0 ? _a : 'export.xslx';
            saveAs(response.body, filename);
        }, _err => {
            this.toastService.errorNotify(this.transloco.translate('MESSAGES.GENERIC_ERROR'));
        });
    }
}
ProductSelectionComponent.decorators = [
    { type: Component, args: [{
                selector: 'lib-product-selection',
                template: "<div class=\"wizard-screen\">\r\n  <lui-widget-wrapper [request]=\"form$\" [doneTemplate]=\"done\">\r\n    <ng-template #done>\r\n      <lui-form *ngIf=\"(form$ | async) as form\" [form]=\"form\"></lui-form>\r\n    </ng-template>\r\n  </lui-widget-wrapper>\r\n</div>\r\n",
                styles: [""]
            },] }
];
ProductSelectionComponent.ctorParameters = () => [
    { type: ActivatedRoute },
    { type: OutboundProfileWizardService },
    { type: OutboundProfileWizardStore },
    { type: Store },
    { type: GenerateFormService },
    { type: TranslocoService },
    { type: ToastrNotificationService$1 }
];

const profileNameForm = (transloco, profileNames, state) => {
    var _a;
    return ({
        layout: {
            'grid-template-columns': '1fr 1fr',
            'grid-template-areas': `
      "profileName"
    `
        },
        fields: {
            profileName: {
                type: 'text',
                label: transloco.translate('PIM.OUTBOUND_PROFILE.PROFILE_NAME'),
                required: true,
                defaultValue: (_a = state === null || state === void 0 ? void 0 : state.profileName) !== null && _a !== void 0 ? _a : null,
                componentProperties: {
                    placeholder: transloco.translate('PIM.OUTBOUND_PROFILE.PROFILE_NAME')
                },
                validations: [
                    {
                        test: (values) => !/\s+$/.test(values.profileName),
                        message: transloco.translate('VALIDATION_MESSAGE.TRAILING_WHITESPACE'),
                    },
                    {
                        test: (values) => !profileNames.some((name) => name.localeCompare(values.profileName, 'en', { usage: 'search', sensitivity: 'base' }) === 0) || values.profileName === values.oldProfileName,
                        message: transloco.translate('PIM.OUTBOUND_PROFILE.PROFILE_NAME_DUPLICATE'),
                    },
                    {
                        test: (values) => { var _a, _b; return (_b = ((_a = values.profileName) === null || _a === void 0 ? void 0 : _a.length) <= 100) !== null && _b !== void 0 ? _b : true; },
                        message: transloco.translate('VALIDATION_MESSAGE.ALPHANUMERIC_MAX', {
                            length: 100
                        })
                    }
                ]
            },
        },
        effects: [
            // Seed in the old state
            {
                fields: [],
                actions: [
                    { set: ['oldProfileName', state.oldProfileName] }
                ]
            }
        ]
    });
};

class ProfileNameComponent {
    constructor(formService, wizardService, store, transloco) {
        this.formService = formService;
        this.wizardService = wizardService;
        this.store = store;
        this.transloco = transloco;
        this.subscriptions = [];
    }
    ngOnInit() {
        this.form$ = this.store.profileNameView$
            .pipe(first(), map(({ formState, existingNames }) => profileNameForm(this.transloco, existingNames, formState)), map(formDefinition => this.formService.init(formDefinition)), tap(form => {
            // Force a validation after all effects have been applied
            // Ensures that the validation is run on the latest view of the form state
            form.validateForm();
            const formValues = form.values$.pipe(
            // underlying observable is a BehaviorSubject, so we skip the initial
            // value so as to preserve the initial not dirty state.
            skip(1), tap((values) => {
                this.store.updateProfileNameForm(values);
            })).subscribe();
            this.subscriptions.push(formValues);
        }), shareReplay(1));
        this.wizardService.setFormLoadingRequest(this.form$);
    }
    ngOnDestroy() {
        if (this.subscriptions) {
            this.subscriptions.forEach(subscription => subscription.unsubscribe());
        }
    }
}
ProfileNameComponent.decorators = [
    { type: Component, args: [{
                selector: 'lib-profile-name',
                template: "<div class=\"wizard-screen\">\r\n  <lui-widget-wrapper [request]=\"form$\" [doneTemplate]=\"done\">\r\n    <ng-template #done>\r\n      <lui-form *ngIf=\"(form$ | async) as form\" [form]=\"form\"></lui-form>\r\n    </ng-template>\r\n  </lui-widget-wrapper>\r\n</div>\r\n\r\n",
                styles: [""]
            },] }
];
ProfileNameComponent.ctorParameters = () => [
    { type: GenerateFormService },
    { type: OutboundProfileWizardService },
    { type: OutboundProfileWizardStore },
    { type: TranslocoService }
];

class SummaryComponent {
    constructor(wizardService, store) {
        this.wizardService = wizardService;
        this.store = store;
        this.profilePolicy = ProfilePolicy;
        this.selectionTypes = SelectionType;
        this.hierarchyTypes = HierarchyType;
        this.isPartnerListVisible = false;
    }
    ngOnInit() {
        this.profileData$ = this.store.summaryView$
            .pipe(first(), shareReplay(1));
        this.wizardService.setLoadingRequest(this.profileData$);
    }
    showPartnerList() {
        this.isPartnerListVisible = true;
    }
}
SummaryComponent.decorators = [
    { type: Component, args: [{
                selector: 'lib-summary',
                template: "<div class=\"wizard-screen\">\r\n  <lui-widget-wrapper [request]=\"profileData$\" [doneTemplate]=\"done\">\r\n    <ng-template #done>\r\n      <ng-container *ngIf=\"(profileData$ | async) as profileData\">\r\n        <div class=\"wrapper\">\r\n          <span>{{ 'PIM.OUTBOUND_PROFILE.WIZARD.SUMMARY.DISPLAY_NAME' | transloco }}</span>\r\n          <span>{{ profileData.profileName }}</span>\r\n          <span>{{ 'PIM.OUTBOUND_PROFILE.WIZARD.MARKETPLACE_NAME' | transloco }}</span>\r\n          <span>{{ profileData.marketplaceName }}</span>\r\n          <span>{{ 'PIM.OUTBOUND_PROFILE.WIZARD.SUPPLIER_NAME' | transloco }}</span>\r\n          <span>{{ profileData.supplierName }}</span>\r\n          <ng-container *ngIf=\"!profileData.groupDirectedSupplier\">\r\n            <span>{{ 'PIM.OUTBOUND_PROFILE.WIZARD.PARTNER_NAME' | transloco }}</span>\r\n            <ng-container [ngSwitch]=\"profileData.partners.length\">\r\n              <span *ngSwitchCase=\"1\">{{ profileData.partners[0].legalName }}</span>\r\n              <a *ngSwitchDefault (click)=\"showPartnerList()\">\r\n                {{ 'PIM.OUTBOUND_PROFILE.WIZARD.SUMMARY.MULTIPLE_PARTNERS' | transloco }}\r\n              </a>\r\n            </ng-container>\r\n          </ng-container>\r\n          <span>{{ 'PIM.OUTBOUND_PROFILE.WIZARD.PROFILE_POLICY.LABEL' | transloco }}</span>\r\n          <ng-container [ngSwitch]=\"profileData.profilePolicy\">\r\n            <span *ngSwitchCase=\"profilePolicy.IncludeAll\"> {{\r\n              'PIM.OUTBOUND_PROFILE.WIZARD.PROFILE_POLICY.INCLUDE_ALL' | transloco }}</span>\r\n            <span *ngSwitchCase=\"profilePolicy.ExcludeAll\"> {{\r\n              'PIM.OUTBOUND_PROFILE.WIZARD.PROFILE_POLICY.EXCLUDE_ALL' | transloco }}</span>\r\n            <span *ngSwitchCase=\"profilePolicy.IncludeSpecific\">{{\r\n              'PIM.OUTBOUND_PROFILE.WIZARD.PROFILE_POLICY.INCLUDE_SPECIFIC' | transloco }}</span>\r\n            <span *ngSwitchCase=\"profilePolicy.ExcludeSpecific\">{{\r\n              'PIM.OUTBOUND_PROFILE.WIZARD.PROFILE_POLICY.EXCLUDE_SPECIFIC' | transloco }}</span>\r\n            <span *ngSwitchDefault>&lt;unknown&gt;</span>\r\n          </ng-container>\r\n          <ng-container\r\n            *ngIf=\"![profilePolicy.IncludeAll, profilePolicy.ExcludeAll].includes(profileData.profilePolicy)\">\r\n            <span>{{ 'PIM.OUTBOUND_PROFILE.WIZARD.SUMMARY.PRODUCT_SELECTION_TYPE' | transloco }}</span>\r\n            <ng-container [ngSwitch]=\"profileData.productSelectionType\">\r\n              <span *ngSwitchCase=\"selectionTypes.HierarchyField\">\r\n                {{ 'PIM.OUTBOUND_PROFILE.WIZARD.SELECTION_TYPE.HIERARCHY_FIELD' | transloco }}\r\n              </span>\r\n              <span *ngSwitchCase=\"selectionTypes.SkuImport\">\r\n                {{ 'PIM.OUTBOUND_PROFILE.WIZARD.SELECTION_TYPE.SKU_IMPORT' | transloco }}\r\n              </span>\r\n              <span *ngSwitchDefault></span>\r\n            </ng-container>\r\n          </ng-container>\r\n          <ng-container *ngIf=\"profileData.productSelectionType === selectionTypes.HierarchyField\">\r\n            <span>{{ 'PIM.OUTBOUND_PROFILE.WIZARD.SUMMARY.PIM_ATTRIBUTE_SELECTED' | transloco }}</span>\r\n            <ng-container [ngSwitch]=\"profileData.hierarchyField\">\r\n              <span *ngSwitchCase=\"hierarchyTypes.GroupHierarchy\"> {{\r\n                'PIM.OUTBOUND_PROFILE.WIZARD.HIERARCHY_FIELD_SELECTION.GROUP_HIERARCHY' | transloco}} </span>\r\n              <span *ngSwitchCase=\"hierarchyTypes.MemberHierarchy\"> {{\r\n                'PIM.OUTBOUND_PROFILE.WIZARD.HIERARCHY_FIELD_SELECTION.MEMBER_HIERARCHY' | transloco}} </span>\r\n              <span *ngSwitchCase=\"hierarchyTypes.SupplierHierarchy\">{{\r\n                'PIM.OUTBOUND_PROFILE.WIZARD.HIERARCHY_FIELD_SELECTION.SUPPLIER_HIERARCHY' | transloco}}</span>\r\n              <span *ngSwitchCase=\"hierarchyTypes.OutboundHierarchy\">{{\r\n                'PIM.OUTBOUND_PROFILE.WIZARD.HIERARCHY_FIELD_SELECTION.OUTBOUND_HIERARCHY' | transloco}}</span>\r\n              <span *ngSwitchDefault></span>\r\n            </ng-container>\r\n            <span>{{ 'PIM.OUTBOUND_PROFILE.WIZARD.SUMMARY.HIERARCHY_SELECTED' | transloco }}</span>\r\n            <span>{{ profileData.selectedHierarchies.join(', ') }}</span>\r\n          </ng-container>\r\n          <span>{{ 'PIM.OUTBOUND_PROFILE.WIZARD.SUMMARY.IMPORT' | transloco }}</span>\r\n          <span>{{ (profileData.usedImport ? 'PIM.OUTBOUND_PROFILE.WIZARD.SUMMARY.IMPORT_YES' :\r\n            'PIM.OUTBOUND_PROFILE.WIZARD.SUMMARY.IMPORT_NO') | transloco }}</span>\r\n        </div>\r\n      </ng-container>\r\n    </ng-template>\r\n  </lui-widget-wrapper>\r\n</div>\r\n\r\n<p-dialog [(visible)]=\"isPartnerListVisible\" [header]=\"'PIM.OUTBOUND_PROFILE.WIZARD.PARTNER_NAMES' | transloco\"\r\n  [modal]=\"true\" [style]=\"{ width: '520px' }\" [showHeader]=\"true\" [draggable]=\"false\" [resizable]=\"false\"\r\n  [closable]=\"true\" position=\"center\" [focusOnShow]=\"false\">\r\n  <ng-container *ngIf=\"(profileData$ | async) as profileData\">\r\n    <ul>\r\n      <li *ngFor=\"let partner of profileData.partners\">{{partner.legalName}}</li>\r\n    </ul>\r\n  </ng-container>\r\n</p-dialog>",
                styles: [":host ::ng-deep .wrapper{display:grid;grid-template-columns:1fr 2fr;gap:1em}:host ::ng-deep .ui-dialog{overflow:visible scroll}:host ::ng-deep .ui-dialog .ui-dialog-titlebar{padding:2em 2em 1em}:host ::ng-deep .ui-dialog .ui-dialog-titlebar .ui-dialog-title{color:var(--red-brand);font-size:var(--h3-font-size);font-weight:500}:host ::ng-deep .ui-dialog .ui-dialog-titlebar .ui-dialog-titlebar-icon{color:var(--med-dark-grey)}:host ::ng-deep .ui-dialog .ui-dialog-content{border-top:0;border-bottom:0;padding:1em 2em 2em;overflow:visible}"]
            },] }
];
SummaryComponent.ctorParameters = () => [
    { type: OutboundProfileWizardService },
    { type: OutboundProfileWizardStore }
];

class OutboundProfileWizardModule {
}
OutboundProfileWizardModule.decorators = [
    { type: NgModule, args: [{
                declarations: [
                    OutboundProfileWizardComponent,
                    ProfileNameComponent,
                    PartnerSelectionComponent,
                    SummaryComponent,
                    ProductSelectionComponent,
                    ImportValidationComponent
                ],
                imports: [
                    CommonModule,
                    UtilsModule,
                    RouterModule,
                    ButtonModule$1,
                    ReactiveFormsModule,
                    InputTextModule$1,
                    DropdownModule$1,
                    PickListModule,
                    TranslocoModule,
                    PerFormPrimengModule,
                    LuiWidgetWrapperModule,
                    TableModule$1,
                    DialogModule$2,
                    ConfirmDialogModule,
                    ReloadModule,
                ],
                providers: [
                    OutboundProfileWizardService
                ]
            },] }
];

class ComparisonComponent {
    constructor(ref, config, spinnerSrv, pimAPISrv, translocoSrv, toastSrv) {
        this.ref = ref;
        this.config = config;
        this.spinnerSrv = spinnerSrv;
        this.pimAPISrv = pimAPISrv;
        this.translocoSrv = translocoSrv;
        this.toastSrv = toastSrv;
        this.ids = [];
        this.productComparison = of([]);
        this.indexSubject = new BehaviorSubject(0);
        this.index = this.indexSubject.asObservable();
        this.btnIncrement = new Subject();
        this.btnDecrement = new Subject();
        this.btnApprove = new Subject();
        this.btnReject = new Subject();
        this.btnReset = new Subject();
        this.btnSave = new Subject();
        this.btnCancel = new Subject();
        this.programmaticCommandSubject = new Subject();
        this.ngOnDestroySubject = new Subject();
        this.initialComparisonState = {
            index: 0,
            total: 0,
            approve: [],
            reject: [],
            products: [],
        };
        this.stateCommands$ = merge(this.btnApprove.pipe(mapTo({})), this.btnReject.pipe(mapTo({})), this.btnIncrement.pipe(mapTo({})), this.btnDecrement.pipe(mapTo({})), this.btnReset.pipe(mapTo({})), this.btnSave.pipe(mapTo({})), this.btnCancel.pipe(mapTo({})), this.programmaticCommandSubject.asObservable());
        this.comparisonState$ = this.stateCommands$.pipe(scan((comparisonState, command) => (Object.assign(Object.assign({}, comparisonState), command)), this.initialComparisonState), shareReplay(1));
        this.incrementFromButtonClick = this.btnIncrement.pipe(withLatestFrom(this.comparisonState$), tap(([, state]) => {
            this.programmaticCommandSubject.next({ index: state.index + 1 });
        }));
        this.decrementFromButtonClick = this.btnDecrement.pipe(withLatestFrom(this.comparisonState$), tap(([, state]) => {
            this.programmaticCommandSubject.next({ index: state.index - 1 });
        }));
        this.approveFromButtonClick = this.btnApprove.pipe(withLatestFrom(this.comparisonState$), tap(([id, state]) => {
            const newApproved = state.approve.includes(id)
                ? state.approve.filter((productId) => productId !== id)
                : [...state.approve, id];
            this.programmaticCommandSubject.next({
                approve: newApproved,
                reject: state.reject.filter((productId) => productId !== id),
            });
        }));
        this.rejectFromButtonClick = this.btnReject.pipe(withLatestFrom(this.comparisonState$), tap(([id, state]) => {
            const newReject = state.reject.includes(id)
                ? state.reject.filter((productId) => productId !== id)
                : [...state.reject, id];
            this.programmaticCommandSubject.next({
                reject: newReject,
                approve: state.approve.filter((productId) => productId !== id),
            });
        }));
        this.resetFromButtonClick = this.btnReset.pipe(withLatestFrom(this.comparisonState$), tap(([id, state]) => this.programmaticCommandSubject.next({
            approve: state.approve.filter((x) => x !== id),
            reject: state.reject.filter((x) => x !== id),
        })));
        this.saveFromButtonClick = this.btnSave.pipe(withLatestFrom(this.comparisonState$), tap(([, state]) => this.save(state.approve, state.reject)));
        this.cancelFromButtonClick = this.btnCancel.pipe(tap(() => this.ref.close(false)));
    }
    ngOnInit() {
        this.spinnerSrv.on();
        this.ids = this.config.data.ids;
        this.updateProducts = this.pimAPISrv
            .compareProducts(this.ids)
            .pipe(map((res) => res.products), tap((products) => this.initializeState(products)), finalize(() => this.spinnerSrv.off()));
        merge(this.updateProducts, this.incrementFromButtonClick, this.decrementFromButtonClick, this.approveFromButtonClick, this.rejectFromButtonClick, this.resetFromButtonClick, this.saveFromButtonClick, this.cancelFromButtonClick)
            .pipe(takeUntil(this.ngOnDestroySubject.asObservable()))
            .subscribe();
    }
    ngOnDestroy() {
        this.ngOnDestroySubject.next(true);
    }
    save(approve, reject) {
        this.spinnerSrv.on();
        combineLatest([
            this.pimAPISrv.approveProducts(approve),
            this.pimAPISrv.rejectProducts(reject),
        ])
            .pipe(finalize(() => {
            this.spinnerSrv.off();
            this.ref.close();
        }))
            .subscribe(() => {
            this.toastSrv.successNotify(this.translocoSrv.translate('PIM.PRODUCT_UPDATE_SUCCESS'));
        }, (err) => {
            this.toastSrv.errorNotify(this.translocoSrv.translate('PIM.PRODUCT_UPDATE_FAILURE'));
        });
    }
    initializeState(products) {
        this.programmaticCommandSubject.next({
            products,
            total: products.length,
        });
    }
}
ComparisonComponent.decorators = [
    { type: Component, args: [{
                selector: 'lib-comparison',
                template: "<div id=\"comparison-dialog\">\r\n  <div *ngIf=\"comparisonState$ | async as state\" class=\"comparison-container\">\r\n    <div\r\n      *ngIf=\"state.products[state.index]; else noUpdates\"\r\n      class=\"comparison-content\"\r\n    >\r\n      <div class=\"comparison-header\">\r\n        <div class=\"comparison-title\">\r\n          <h2>\r\n            {{ 'PIM.COMPARISON.SUPPLIER_PRODUCT_KEY' | transloco }} -\r\n            {{ state.products[state.index]?.supplierProductKey }}\r\n          </h2>\r\n        </div>\r\n        <div class=\"comparison-index\">\r\n          {{ state.index + 1 }} {{ 'PIM.COMPARISON.OF_INDEX' | transloco }}\r\n          {{ state.total }}\r\n        </div>\r\n      </div>\r\n      <div class=\"comparison-description\">\r\n        <div>{{ state.products[state.index]?.supplierName }}</div>\r\n        <div>{{ state.products[state.index]?.description }}</div>\r\n      </div>\r\n      <div class=\"comparison-table\">\r\n        <p-table [value]=\"state.products[state.index]?.diffs\">\r\n          <ng-template pTemplate=\"header\">\r\n            <tr>\r\n              <th>{{ 'PIM.COMPARISON.COLUMN_NAME' | transloco }}</th>\r\n              <th>{{ 'PIM.COMPARISON.APPROVED_VALUE' | transloco }}</th>\r\n              <th>{{ 'PIM.COMPARISON.PENDING_VALUE' | transloco }}</th>\r\n            </tr>\r\n          </ng-template>\r\n          <ng-template pTemplate=\"body\" let-col>\r\n            <tr>\r\n              <td>{{ col.header }}</td>\r\n              <td>{{ col.approved }}</td>\r\n              <td>{{ col.pending }}</td>\r\n            </tr>\r\n          </ng-template>\r\n          <ng-template pTemplate=\"emptymessage\">\r\n            <tr>\r\n              <td [attr.colspan]=\"3\">\r\n                <p class=\"center\">\r\n                  {{ 'PIM.COMPARISON.NO_DATA_FOUND' | transloco }}\r\n                </p>\r\n              </td>\r\n            </tr>\r\n          </ng-template>\r\n        </p-table>\r\n      </div>\r\n      <div class=\"comparison-controls\">\r\n        <div class=\"comparison-state-controls\">\r\n          <div class=\"comparison-toggle-controls\">\r\n            <p-toggleButton\r\n              class=\"small\"\r\n              [ngModel]=\"\r\n                state.approve.includes(state.products[state.index]?.productId)\r\n              \"\r\n              (click)=\"btnApprove.next(state.products[state.index]?.productId)\"\r\n              onLabel=\"{{ 'PIM.APPROVE_PRODUCTS' | transloco }}\"\r\n              offLabel=\"{{ 'PIM.APPROVE_PRODUCTS' | transloco }}\"\r\n            ></p-toggleButton>\r\n            <p-toggleButton\r\n              class=\"small\"\r\n              [ngModel]=\"\r\n                state.reject.includes(state.products[state.index]?.productId)\r\n              \"\r\n              (click)=\"btnReject.next(state.products[state.index]?.productId)\"\r\n              onLabel=\"{{ 'PIM.REJECT_PRODUCTS' | transloco }}\"\r\n              offLabel=\"{{ 'PIM.REJECT_PRODUCTS' | transloco }}\"\r\n            ></p-toggleButton>\r\n          </div>\r\n          <div class=\"comparison-increment-controls\">\r\n            <button\r\n              pButton\r\n              class=\"ds tertiary small\"\r\n              [disabled]=\"state.index < 1\"\r\n              (click)=\"btnDecrement.next($event)\"\r\n            >\r\n              <i class=\"pi pi-angle-left\"></i>\r\n            </button>\r\n            <button\r\n              pButton\r\n              class=\"ds tertiary small\"\r\n              [disabled]=\"state.index >= state.total - 1\"\r\n              (click)=\"btnIncrement.next($event)\"\r\n            >\r\n              <i class=\"pi pi-angle-right\"></i>\r\n            </button>\r\n          </div>\r\n        </div>\r\n        <div class=\"comparison-save-cancel\">\r\n          <button pButton class=\"ds secondary\" (click)=\"btnCancel.next($event)\">\r\n            {{ 'ACTIONS.CANCEL' | transloco }}\r\n          </button>\r\n          <button\r\n            pButton\r\n            class=\"ds\"\r\n            [disabled]=\"!(state.approve.length > 0 || state.reject.length > 0)\"\r\n            (click)=\"btnSave.next($event)\"\r\n          >\r\n            {{ 'ACTIONS.SAVE' | transloco }}\r\n          </button>\r\n        </div>\r\n      </div>\r\n    </div>\r\n    <ng-template #noUpdates>\r\n      <div class=\"comparison-no-updates\">\r\n        <div>\r\n          <h2>\r\n            {{ 'PIM.COMPARISON.NO_UPDATED_PRODUCTS_SELECTED' | transloco }}\r\n          </h2>\r\n        </div>\r\n        <div class=\"comparison-no-updates-close\">\r\n          <button pButton class=\"ds\" (click)=\"btnCancel.next($event)\">\r\n            {{ 'ACTIONS.CLOSE' | transloco }}\r\n          </button>\r\n        </div>\r\n      </div>\r\n    </ng-template>\r\n  </div>\r\n</div>\r\n<lib-working-spinner-component></lib-working-spinner-component>\r\n",
                providers: [SpinnerService$1],
                styles: [""]
            },] }
];
ComparisonComponent.ctorParameters = () => [
    { type: DynamicDialogRef },
    { type: DynamicDialogConfig },
    { type: SpinnerService$1 },
    { type: PimAPIService },
    { type: TranslocoService },
    { type: ToastrNotificationService$1 }
];

var Buttons;
(function (Buttons) {
    Buttons["APPROVE"] = "approve";
    Buttons["REJECT"] = "reject";
    Buttons["VIEW_UPDATES"] = "viewUpdates";
})(Buttons || (Buttons = {}));
class PendingProductsComponent {
    constructor(approvedProductsSrv, translocoSrv, confirmationService, store, datepipe, spinnerSrv, toastSrv, pimAPISrv, dialogService, hierarchyService) {
        this.approvedProductsSrv = approvedProductsSrv;
        this.translocoSrv = translocoSrv;
        this.confirmationService = confirmationService;
        this.store = store;
        this.datepipe = datepipe;
        this.spinnerSrv = spinnerSrv;
        this.toastSrv = toastSrv;
        this.pimAPISrv = pimAPISrv;
        this.dialogService = dialogService;
        this.hierarchyService = hierarchyService;
        this.subscriptions = [];
        this.selectedColumns = [
            'sku',
            'supplierProductKey',
            'description',
            'status',
        ];
        this.isLoading = false;
        this.authorizedActions = {};
        this.buttons$ = combineLatest([
            this.translocoSrv.selectTranslate('PIM.APPROVE_PRODUCTS'),
            this.translocoSrv.selectTranslate('PIM.REJECT_PRODUCTS'),
            this.translocoSrv.selectTranslate('PIM.COMPARISON.VIEW_UPDATES'),
        ]).pipe(map(([approve, reject, viewUpdates]) => [
            {
                name: Buttons.APPROVE,
                label: approve,
                disabled: !this.authorizedActions.approve,
                mode: 2 /* MULTIPLE */,
            },
            {
                name: Buttons.REJECT,
                label: reject,
                disabled: !this.authorizedActions.reject,
                mode: 2 /* MULTIPLE */,
            },
            {
                name: Buttons.VIEW_UPDATES,
                label: viewUpdates,
                disabled: !this.authorizedActions.viewUpdates,
                mode: 2 /* MULTIPLE */,
            },
        ]));
        this.paging = {
            sizes: [25, 50, 75, 100],
            page: { first: 0, rows: 25 },
            records: 250,
        };
        this.rows = 25;
        this.first = 0;
        this.sort = { field: 'sku', order: 1 };
        this.searchText = '';
    }
    ngOnInit() {
        this.subscriptions.push(this.getFieldsAndCategories());
    }
    ngOnDestroy() {
        if (this.subscriptions) {
            this.subscriptions.forEach((subscription) => subscription.unsubscribe());
        }
        this.spinnerSrv.off();
    }
    getFieldsAndCategories() {
        this.spinnerSrv.on();
        return forkJoin([
            this.store.select(selectors.sortedFields).pipe(first((pf) => pf.length !== 0), map((f) => {
                return f.filter((field) => field.isIncluded);
            })),
            this.store
                .select(selectors.isAuthorized, this.getButtonPermissions())
                .pipe(first()),
            this.store
                .select(selectors.categories)
                .pipe(first((c) => Object.keys(c).length !== 0)),
            this.translocoSrv
                .selectTranslate('PIM.PRODUCT_DETAILS_PRIMARYIMAGE')
                .pipe(first()),
            this.hierarchyService.getAllHierarchyLabels()
        ])
            .pipe(finalize(() => this.spinnerSrv.off()), map(([fields, authorizedActions, categories, primaryImageTranslation, hierarchyLabels,]) => {
            this.authorizedActions = authorizedActions;
            this.hierarchyLabels = hierarchyLabels;
            return fields
                .filter((f) => !f.isHidden)
                .map((f) => {
                if (f.fieldKey === ProductFieldsEnum.primaryImageFilename) {
                    return {
                        field: f.fieldName.trim(),
                        header: `${categories[f.categoryKey]} \n${primaryImageTranslation}`,
                        imgSrc: (data) => data.primaryImage
                            ? Object.assign(Object.assign({}, data.primaryImage), { dataUrl: data.primaryImage.dataUrl + '?size=small' }) : data.primaryImage,
                        imgClass: 'product-thumbnail',
                    };
                }
                else if (f.fieldKey === ProductFieldsEnum.sku ||
                    f.fieldKey === ProductFieldsEnum.description ||
                    f.fieldKey === ProductFieldsEnum.supplierProductKey) {
                    return {
                        field: f.fieldName.trim(),
                        header: categories[f.categoryKey] + ' \n' + f.description.trim(),
                        required: true,
                    };
                }
                else {
                    return {
                        field: f.fieldName.trim(),
                        header: categories[f.categoryKey] + ' \n' + f.description.trim(),
                    };
                }
            })
                .concat({
                field: 'status',
                header: this.translocoSrv.translate('COMMON.STATUS'),
            });
        }), tap((columns) => (this.columns = columns)))
            .subscribe();
    }
    getButtonPermissions() {
        return {
            approve: toolKeys.PIM_PRODUCTS_PRODUCTS_PENDING_APPROVE,
            reject: toolKeys.PIM_PRODUCTS_PRODUCTS_PENDING_REJECT,
            viewUpdates: toolKeys.PIM_PRODUCTS_PRODUCTS_PENDING_VIEW_UPDATES,
        };
    }
    search(request) {
        this.isLoading = true;
        this.pendingProducts = forkJoin([
            this.pimAPISrv
                .searchPendingProducts(request)
                .pipe(tap(({ paging }) => {
                this.paging = Object.assign(Object.assign({}, this.paging), { records: paging.totalRecords });
            })),
            this.store.select(selectors.userProfile).pipe(first()),
            this.store
                .select(selectors.users)
                .pipe(first((u) => Object.keys(u).length > 0)),
        ]).pipe(map(([products, profile, users]) => {
            return products.products.map((product) => {
                const p = transformProduct(product);
                let status = '';
                if (p.isApproved) {
                    status = this.translocoSrv.translate('PRODUCT_STATUS.UPDATE');
                }
                else {
                    status = this.translocoSrv.translate('PRODUCT_STATUS.NEW');
                }
                return Object.assign({ status }, this.formatProduct(p, profile.userInfo.DateTypeFormat, profile.userInfo.IANATimeZoneCode, profile.userInfo.TimeFormat, users));
            });
        }), switchMap((products) => {
            const imgs$ = products.map((p) => {
                if (p.primaryImageFilename) {
                    return this.approvedProductsSrv
                        .getAssetThumbnail(p.supplierKey, p.primaryImageFilename)
                        .pipe(map((img) => {
                        return Object.assign(Object.assign({}, p), { primaryImage: img });
                    }));
                }
                else {
                    return of(Object.assign(Object.assign({}, p), { primaryImage: null }));
                }
            });
            return forkJoin(imgs$).pipe(defaultIfEmpty([]));
        }), finalize(() => (this.isLoading = false)));
    }
    onClear() {
        this.searchText = '';
        this.search(this.buildSearchRequest(this.searchText, this.rows, 0, this.sort));
    }
    onSearch($event) {
        this.rows = $event.rows;
        this.first = $event.first;
        this.searchText = $event.filters.searchText;
        this.sort = { field: $event.sortField, order: $event.sortOrder };
        this.search(this.buildSearchRequest(this.searchText, this.rows, 0, this.sort));
    }
    onPage($event) {
        this.searchText = $event.filters.searchText;
        this.rows = $event.rows;
        this.first = $event.first;
        this.sort = { field: $event.sortField, order: $event.sortOrder };
        this.search(this.buildSearchRequest(this.searchText, this.rows, this.first, this.sort));
    }
    onToolbarClick({ command, selection, clearSelection }) {
        const selectedIds = selection.map((p) => p.id);
        switch (command) {
            case Buttons.APPROVE:
                this.confirmationService.confirm({
                    header: this.translocoSrv.translate('PIM.APPROVE_PRODUCTS'),
                    message: this.translocoSrv.translate('PIM.APPROVE_PRODUCTS_CONFIRM'),
                    accept: () => {
                        this.subscriptions.push(this.pimAPISrv.approveProducts(selectedIds).subscribe(() => {
                            clearSelection();
                            this.isLoading = true;
                            this.toastSrv.successNotify(this.translocoSrv.translate('PIM.PRODUCT_ACCEPTED'));
                        }, (err) => {
                            this.toastSrv.errorNotify(this.translocoSrv.translate('PIM.PRODUCT_APPROVAL_FAILURE'));
                        }));
                    },
                });
                break;
            case Buttons.REJECT:
                this.confirmationService.confirm({
                    header: this.translocoSrv.translate('PIM.REJECT_PRODUCTS'),
                    message: this.translocoSrv.translate('PIM.REJECT_PRODUCTS_CONFIRM'),
                    accept: () => {
                        this.subscriptions.push(this.pimAPISrv.rejectProducts(selectedIds).subscribe(() => {
                            clearSelection();
                            this.isLoading = true;
                            this.toastSrv.successNotify(this.translocoSrv.translate('PIM.PRODUCT_REJECTED'));
                        }, (err) => {
                            this.toastSrv.errorNotify(this.translocoSrv.translate('PIM.PRODUCT_REJECTION_FAILURE'));
                        }));
                    },
                });
                break;
            case Buttons.VIEW_UPDATES:
                this.show(selectedIds);
                break;
        }
    }
    buildSearchRequest(searchText, pageSize, skip, sort) {
        const request = new SearchProductsRequest();
        request.PageSize = pageSize;
        request.Skip = skip;
        request.SearchWord = searchText === undefined ? '' : searchText;
        request.FacetList = [];
        request.Filters = null;
        request.Sort = sort;
        if (request.Sort.field === 'status') {
            request.Sort.field = 'isApproved';
        }
        request.isApproved = true;
        return request;
    }
    formatProduct(product, dateFormat, timeZoneCodeIANA, timeFormat, users) {
        var _a;
        if (product.dateAdded != null) {
            product.dateAdded = this.datepipe.transform(utcToZonedTime(product.dateAdded, timeZoneCodeIANA), dateFormat + ' ' + timeFormat);
        }
        if (product.dateLastChanged != null) {
            product.dateLastChanged = this.datepipe.transform(utcToZonedTime(product.dateLastChanged, timeZoneCodeIANA), dateFormat + ' ' + timeFormat);
        }
        product.endShipDate = this.datepipe.transform(product.endShipDate, dateFormat.format);
        product.consumerDate = this.datepipe.transform(product.consumerDate, dateFormat.format);
        product.availableDate = this.datepipe.transform(product.availableDate, dateFormat.format);
        product.startShipDate = this.datepipe.transform(product.startShipDate, dateFormat.format);
        product.discontinueDate = this.datepipe.transform(product.discontinueDate, dateFormat.format);
        product.addedBy = users[product.addedBy]
            ? users[product.addedBy].fullname
            : null;
        product.modifiedBy = users[product.modifiedBy]
            ? users[product.modifiedBy].fullname
            : null;
        product.suggestedHierarchy = product.suggestedCategoryKey != null && product.suggestedCategoryKey > 0
            ? (_a = this.hierarchyLabels) === null || _a === void 0 ? void 0 : _a[product.suggestedCategoryKey] : this.translocoSrv.translate('PIM.PRODUCT_SUGGESTED_HIERARCHY_UNSPECIFIED');
        return product;
    }
    show(ids) {
        const ref = this.dialogService.open(ComparisonComponent, {
            data: { ids },
            width: '70%',
            closable: false,
            showHeader: false,
        });
        ref.onClose.subscribe((search = true) => search &&
            this.search(this.buildSearchRequest(this.searchText, this.rows, 0, this.sort)));
    }
}
PendingProductsComponent.decorators = [
    { type: Component, args: [{
                selector: 'lib-pending-products',
                template: "<div class=\"vertical-flow space-between-175\">\r\n  <h2>{{ 'PIM.PENDING_PRODUCTS_TITLE' | transloco }}</h2>\r\n  <lib-search-container\r\n    *ngIf=\"columns && columns.length !== 0\"\r\n    i18nSearchField=\"{{ 'PIM.APPROVED_PRODUCTS_SUBTITLE' | transloco }}\"\r\n    idColumn=\"id\"\r\n    name=\"pendingProductSearch\"\r\n    searchProperty=\"searchText\"\r\n    [disableAdvancedSearch]=\"true\"\r\n    [columns]=\"columns\"\r\n    [columnsToDisplay]=\"selectedColumns\"\r\n    [results]=\"pendingProducts\"\r\n    [lazy]=\"true\"\r\n    [loading]=\"isLoading\"\r\n    [buttons]=\"buttons$ | async\"\r\n    [paging]=\"paging\"\r\n    [lazyLoadOnInit]=\"true\"\r\n    [initialQuery]=\"{}\"\r\n    (query)=\"onSearch($event)\"\r\n    (lazyLoad)=\"onPage($event)\"\r\n    (toolbar)=\"onToolbarClick($event)\"\r\n    (clear)=\"onClear()\"\r\n  ></lib-search-container>\r\n</div>\r\n\r\n<p-confirmDialog [closeOnEscape]=\"false\" [closable]=\"false\"></p-confirmDialog>\r\n",
                providers: [DialogService],
                styles: [""]
            },] }
];
PendingProductsComponent.ctorParameters = () => [
    { type: ApprovedProductsService },
    { type: TranslocoService },
    { type: ConfirmationService },
    { type: Store },
    { type: DatePipe },
    { type: SpinnerService$1 },
    { type: ToastrNotificationService$1 },
    { type: PimAPIService },
    { type: DialogService },
    { type: GetHierarchyService }
];

const hierarchyInputForm = (fieldName, transloco, callbacks) => ({
    controls: {
        cancel: {
            label: transloco.translate('ACTIONS.CANCEL'),
            type: 'button',
            role: FormControlRole.SECONDARY,
            callback: callbacks.cancel,
        },
        save: {
            label: transloco.translate('ACTIONS.SAVE'),
            type: 'button',
            role: FormControlRole.PRIMARY,
            callback: callbacks.save,
            disabled: (form) => !form.valid,
        },
    },
    fields: {
        hierarchyValue: {
            type: 'text',
            label: fieldName,
            information: transloco.translate('PIM.HIERARCHY_MODAL.ADD_HIERARCHY_INFORMATION'),
            required: true,
        },
    },
});

class HierarchyFormInputEditableComponent {
    constructor(elementRef, translocoSrv, formService) {
        this.elementRef = elementRef;
        this.translocoSrv = translocoSrv;
        this.formService = formService;
        this.dropdownVisible = false;
        this.displayDialog = false;
    }
    set productHierarchies(hierarchies) {
        this.nodes = this.toTreeNodes(hierarchies);
    }
    handleClickOutside(event) {
        if (!this.elementRef.nativeElement.contains(event.target)) {
            this.dropdownVisible = false;
        }
    }
    writeValue(value) {
        this.setHierarchy(value);
    }
    registerOnChange(fn) {
        this.onChange = fn;
    }
    registerOnTouched(fn) {
        this.onTouched = fn;
    }
    ngOnInit() {
        this.hierarchyForm = this.formService.init(hierarchyInputForm(this.fieldLabel, this.translocoSrv, {
            cancel: () => (this.displayDialog = false),
            save: (form) => this.onSaveDialog(form),
        }));
        this.items = [
            {
                label: this.translocoSrv.translate('ACTIONS.ADD'),
                command: () => this.showDialog(),
            },
        ];
    }
    toTreeNodes(hierarchies) {
        const nodeMap = new Map();
        const roots = [];
        for (const item of hierarchies) {
            const segments = item.path.split('|').filter(Boolean);
            const node = {
                label: item.name,
                children: [],
                data: {
                    path: item.path,
                    checked: false,
                },
            };
            if (segments.length > 1) {
                const parentPath = segments.slice(0, -1).join('|') + '|';
                const parentNode = nodeMap.get(parentPath);
                if (parentNode) {
                    node.parent = parentNode;
                    parentNode.children.push(node);
                }
            }
            else {
                roots.push(node);
            }
            nodeMap.set(item.path, node);
        }
        return roots;
    }
    setHierarchy(hierarchy) {
        this.clearSelection(this.nodes);
        this.hierarchyValue = hierarchy;
        if (!hierarchy) {
            return;
        }
        const parts = hierarchy.split('|').filter(Boolean);
        let nodes = this.nodes;
        let parent;
        let path = '';
        for (const part of parts) {
            path += part + '|';
            let found = false;
            for (const node of nodes) {
                if (hierarchy.startsWith(node.data.path)) {
                    node.data.checked = true;
                    found = true;
                    if (hierarchy !== node.data.path) {
                        nodes = node.children;
                        parent = node;
                    }
                    break;
                }
            }
            if (!found) {
                const children = [];
                const node = {
                    label: part,
                    children,
                    parent,
                    data: {
                        checked: true,
                        path,
                    },
                };
                nodes.push(node);
                nodes = children;
            }
        }
    }
    getDropdownPlaceholder() {
        if (!this.hierarchyValue) {
            return this.translocoSrv.translate('ACTIONS.SELECT');
        }
        return this.hierarchyValue.length > 50
            ? this.hierarchyValue.slice(0, 55) + '...'
            : this.hierarchyValue;
    }
    onSelectHierarchy(node, event) {
        const hierarchy = event.checked ? node.data.path : null;
        this.setHierarchy(hierarchy);
        this.onChange(hierarchy);
    }
    toggleDropdown() {
        this.dropdownVisible = !this.dropdownVisible;
        this.onTouched();
    }
    showDialog() {
        this.displayDialog = true;
        this.onTouched();
    }
    onSaveDialog(hierarchyForm) {
        let value = hierarchyForm.values.hierarchyValue;
        if (!value.endsWith('|')) {
            value += '|';
        }
        this.setHierarchy(value);
        this.onChange(value);
        this.displayDialog = false;
    }
    onCancelDialog() {
        this.displayDialog = false;
    }
    clearSelection(nodes) {
        for (const node of nodes) {
            node.data.checked = false;
            if (node.children) {
                this.clearSelection(node.children);
            }
        }
    }
}
HierarchyFormInputEditableComponent.decorators = [
    { type: Component, args: [{
                selector: 'lib-hierarchy-form-input-editable',
                template: "<div class=\"hierarchy-form\">\r\n  <div class=\"hierarchy-menu\">\r\n    <div class=\"hierarchy-menu-button\">\r\n      <i class=\"pi pi-ellipsis-h\" (click)=\"buttonSubMenu.toggle($event)\"></i>\r\n      <p-menu\r\n        #buttonSubMenu\r\n        data-testid=\"searchContainerToolbarMenu\"\r\n        appendTo=\"body\"\r\n        [styleClass]=\"'more-menu'\"\r\n        [model]=\"items\"\r\n        [popup]=\"true\"\r\n      ></p-menu>\r\n    </div>\r\n  </div>\r\n\r\n  <div class=\"dropdown-tree\">\r\n    <p-dropdown\r\n      [options]=\"[]\"\r\n      [placeholder]=\"getDropdownPlaceholder()\"\r\n      [showClear]=\"true\"\r\n      [panelStyle]=\"{ display: dropdownVisible ? 'block' : 'none' }\"\r\n      (onClick)=\"toggleDropdown()\"\r\n    >\r\n    </p-dropdown>\r\n\r\n    <div *ngIf=\"dropdownVisible\" class=\"dropdown-panel\">\r\n      <p-tree [value]=\"nodes\">\r\n        <ng-template let-node pTemplate=\"default\">\r\n          <p-checkbox\r\n            [label]=\"node.label\"\r\n            [binary]=\"true\"\r\n            [ngModel]=\"node.data.checked\"\r\n            (onChange)=\"onSelectHierarchy(node, $event)\"\r\n          >\r\n          </p-checkbox>\r\n        </ng-template>\r\n      </p-tree>\r\n    </div>\r\n  </div>\r\n</div>\r\n<p-dialog\r\n  [(visible)]=\"displayDialog\"\r\n  modal=\"true\"\r\n  [resizable]=\"false\"\r\n  [draggable]=\"false\"\r\n  [header]=\"'PIM.HIERARCHY_MODAL.ADD_HIERARCHY' | transloco\"\r\n  [closable]=\"false\"\r\n  [closeOnEscape]=\"false\"\r\n  [style]=\"{ width: '520px' }\"\r\n>\r\n  <lui-form [form]=\"hierarchyForm\"></lui-form>\r\n</p-dialog>\r\n",
                providers: [
                    {
                        provide: NG_VALUE_ACCESSOR,
                        multi: true,
                        useExisting: HierarchyFormInputEditableComponent,
                    },
                ],
                styles: [".hierarchy-form{position:relative}.hierarchy-menu{position:absolute;top:-1em;right:0;cursor:pointer}:host ::ng-deep .ui-dialog .ui-dialog-titlebar{padding:2em 2em 1em}:host ::ng-deep .ui-dialog .ui-dialog-titlebar .ui-dialog-title{color:var(--med-dark-grey);font-size:var(--h3-font-size);font-weight:500}:host ::ng-deep .ui-dialog .ui-dialog-titlebar .ui-dialog-titlebar-icon{color:var(--med-dark-grey)}:host ::ng-deep .ui-dialog .ui-dialog-content{border-top:0;border-bottom:0;padding:1em 2em;overflow:visible}:host ::ng-deep .ui-dialog .ui-dialog-content .lui-controls{display:flex;gap:.5em;margin-top:1em;margin-bottom:1em}:host ::ng-deep .ui-dialog .ui-dialog-content .lui-controls>button{flex-grow:1}.dialog-body{margin-bottom:12rem}.dialog-content{height:360px}.dropdown-tree{position:relative;display:inline-block;width:100%}.dropdown-panel{position:absolute;top:100%;left:0;width:100%;max-height:300px;border:1px solid #d9d9d9;border-radius:4px;background-color:#fff;box-shadow:0 4px 8px rgba(0,0,0,.1);overflow-y:auto;z-index:1000}::ng-deep .dropdown-tree .ui-dropdown .ui-dropdown-panel{display:none}"]
            },] }
];
HierarchyFormInputEditableComponent.ctorParameters = () => [
    { type: ElementRef },
    { type: TranslocoService },
    { type: GenerateFormService }
];
HierarchyFormInputEditableComponent.propDecorators = {
    formControlName: [{ type: Input }],
    fieldLabel: [{ type: Input }],
    productHierarchies: [{ type: Input }],
    handleClickOutside: [{ type: HostListener, args: ['document:click', ['$event'],] }]
};

class HierarchyFormInputComponent {
    constructor(translocoService) {
        this.translocoService = translocoService;
        this.icon = 'pi pi-info-circle';
        this.nodes = [];
        this.dropdownVisible = false;
        this.selectedNode = null;
        this.display = false;
        this.inputTextValue = '';
        this.categoryIdCounter = 0;
    }
    ngOnInit() {
        this.initializeNodes();
    }
    writeValue(value) {
        var _a, _b;
        this.selectedNode = this.findNode(value);
        this.savedValue = ((_b = (_a = this.selectedNode) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.fullHierarchy) || '';
    }
    registerOnChange(fn) {
        this.onChange = fn;
    }
    registerOnTouched(fn) {
        this.onTouched = fn;
    }
    getPlaceholder() {
        if (this.savedValue) {
            return this.savedValue.length > 50
                ? this.savedValue.substring(0, 50) + '...'
                : this.savedValue;
        }
        return this.translocoService.translate('ACTIONS.SELECT');
    }
    showDialog() {
        this.display = true;
    }
    onCancel() {
        this.display = false;
        this.inputTextValue = '';
    }
    onCheckboxChange(node, fh, event) {
        if (event) {
            this.selectedNode = node;
            const outputValue = this.selectedNode.data.categoryKey;
            this.savedValue = fh;
            this.onChange(outputValue);
        }
        else {
            this.selectedNode = null;
        }
    }
    onShow() {
        this.dropdownVisible = true;
        this.onTouched();
    }
    onHide() {
        this.dropdownVisible = false;
        this.onTouched();
    }
    initializeNodes() {
        this.nodes = this.convertToTreeNode(this.suggestedHierarchyData ? this.suggestedHierarchyData.records : []);
    }
    convertToTreeNode(categories) {
        return ((categories === null || categories === void 0 ? void 0 : categories.map((category) => ({
            label: category.categoryName,
            data: {
                categoryKey: category.categoryKey,
                parentCategoryKey: category.parentCategoryKey,
                fullHierarchy: category.fullHierarchy,
            },
            children: this.convertToTreeNode(category.children),
            leaf: !category.children || category.children.length === 0,
        }))) || []);
    }
    findNode(value) {
        function flatten(nodes) {
            return nodes.reduce((arr, node) => {
                var _a;
                return ((_a = node.children) === null || _a === void 0 ? void 0 : _a.length) !== 0
                    ? arr.concat(flatten(node.children))
                    : [...arr, node];
            }, []);
        }
        const flat = flatten(this.nodes);
        return flat.find((n) => n.data.categoryKey === value);
    }
}
HierarchyFormInputComponent.decorators = [
    { type: Component, args: [{
                selector: 'lib-hierarchy-form-input',
                template: "<div class=\"hierarchy-form\">\r\n  <div class=\"dropdown-tree\">\r\n    <p-dropdown\r\n      #input\r\n      [placeholder]=\"getPlaceholder()\"\r\n      (onShow)=\"onShow()\"\r\n    >\r\n    </p-dropdown>\r\n\r\n    <div\r\n      [selectionClickOutside]=\"inputElement\"\r\n      (clickOutside)=\"onHide()\"\r\n      *ngIf=\"dropdownVisible\"\r\n      class=\"dropdown-panel\"\r\n    >\r\n      <p-tree [value]=\"nodes\" [style]=\"{ width: '100%' }\">\r\n        <ng-template let-node pTemplate=\"default\">\r\n          <div class=\"custom-node\">\r\n            <ng-container *ngIf=\"node.leaf; else label\">\r\n              <p-checkbox\r\n                labelStyleClass=\"clickable\"\r\n                [binary]=\"true\"\r\n                [ngModel]=\"selectedNode === node\"\r\n                [label]=\"node.label\"\r\n                (ngModelChange)=\"\r\n                  onCheckboxChange(node, node.data.fullHierarchy, $event)\r\n                \"\r\n              ></p-checkbox>\r\n            </ng-container>\r\n            <ng-template #label>\r\n              <span (click)=\"node.expanded = !node.expanded\">{{\r\n                node.label\r\n              }}</span>\r\n            </ng-template>\r\n          </div>\r\n        </ng-template>\r\n      </p-tree>\r\n    </div>\r\n  </div>\r\n</div>\r\n",
                providers: [
                    {
                        provide: NG_VALUE_ACCESSOR,
                        multi: true,
                        useExisting: HierarchyFormInputComponent,
                    },
                ],
                styles: [".dropdown-tree,.hierarchy-form{position:relative}.dropdown-tree{display:inline-block;width:100%}.dropdown-panel{position:absolute;top:100%;left:0;width:100%;max-height:300px;border:1px solid #d9d9d9;border-radius:4px;background-color:#fff;box-shadow:0 4px 8px rgba(0,0,0,.1);overflow-y:auto;z-index:1000}::ng-deep .dropdown-tree .ui-dropdown .ui-dropdown-panel{display:none}"]
            },] }
];
HierarchyFormInputComponent.ctorParameters = () => [
    { type: TranslocoService }
];
HierarchyFormInputComponent.propDecorators = {
    suggestedHierarchyData: [{ type: Input }],
    formControlName: [{ type: Input }],
    icon: [{ type: Input }],
    inputElement: [{ type: ViewChild, args: ['input', { read: ElementRef },] }]
};

class SelectionClickOutsideDirective {
    constructor(elementRef) {
        this.elementRef = elementRef;
        this.clickOutside = new EventEmitter();
    }
    onClick(target) {
        const clickedInside = this.elementRef.nativeElement.contains(target) ||
            this.inputElement.nativeElement.contains(target);
        if (!clickedInside) {
            this.clickOutside.emit();
        }
    }
}
SelectionClickOutsideDirective.decorators = [
    { type: Directive, args: [{
                selector: '[selectionClickOutside]',
            },] }
];
SelectionClickOutsideDirective.ctorParameters = () => [
    { type: ElementRef }
];
SelectionClickOutsideDirective.propDecorators = {
    clickOutside: [{ type: Output }],
    inputElement: [{ type: Input, args: ['selectionClickOutside',] }],
    onClick: [{ type: HostListener, args: ['document:click', ['$event.target'],] }]
};

class ProductDetailsService {
    constructor(baseAPISrv, pimSrv, datePipe, translocoSrv) {
        this.baseAPISrv = baseAPISrv;
        this.pimSrv = pimSrv;
        this.datePipe = datePipe;
        this.translocoSrv = translocoSrv;
    }
    getApprovedProductFilters() {
        return this.pimSrv.getFilters();
    }
    getProductFieldCategories() {
        this.baseAPISrv.set(this.pimSrv.getConfig().getFieldCategoriesEndpoint);
        return this.baseAPISrv.get().pipe();
    }
    getProductDetails(id) {
        this.baseAPISrv.set(urlJoin(this.pimSrv.getConfig().getProductDetailsEndpoint, id));
        return this.baseAPISrv
            .get()
            .pipe(map((res) => res.product));
    }
    getAssetUrl(supplierKey, fileName) {
        return of(urlJoin(this.pimSrv.getConfig().assetsEndPoint, supplierKey, fileName));
    }
    updateProduct(product, id) {
        const path = urlJoin(this.pimSrv.getConfig().getProductDetailsEndpoint, id);
        this.baseAPISrv.set(path);
        return this.baseAPISrv.put(product);
    }
    insertProduct(product) {
        const path = urlJoin(this.pimSrv.getConfig().getProductDetailsEndpoint);
        this.baseAPISrv.set(path);
        return this.baseAPISrv.post(product);
    }
    fieldAllowedValues() {
        this.baseAPISrv.set(this.pimSrv.getConfig().getFieldAllowedValuesEndpoint);
        return this.baseAPISrv.get().pipe();
    }
    getCountries() {
        this.baseAPISrv.set(this.pimSrv.getConfig().getCountriesEndpoint);
        return this.baseAPISrv.get().pipe();
    }
    getCurrencies() {
        this.baseAPISrv.set(this.pimSrv.getConfig().getCurrenciesEndpoint);
        return this.baseAPISrv.get().pipe();
    }
    /** Calculate completion percentage -
     * If the mandatory field is an array, atleast one of the array item should not be null/undefined
     */
    getCompletionPercent(mandatoryFields, productDetails, productFieldEnum) {
        if (!mandatoryFields || mandatoryFields.length === 0) {
            return 100;
        }
        let count = 0;
        mandatoryFields.forEach((field) => {
            const fieldInfo = ProductFieldEnumMap.get(field.fieldKey);
            if (!fieldInfo.type || fieldInfo.type === Type.Object) {
                if (!this.isEmpty(this.get(productDetails, fieldInfo.field))) {
                    count++;
                }
            }
            else {
                const arrayValue = this.get(productDetails, fieldInfo.field);
                const validCount = arrayValue.findIndex((element) => !this.isEmpty(this.get(element, fieldInfo.arrayObjectField)));
                if (validCount !== -1) {
                    count++;
                }
            }
        });
        /**
         * Displaying completion % rounded to 2 decimals to clear the discrepancy in  advance search  completion % filter
         */
        const completionPercent = (count / mandatoryFields.length) * 100;
        return Math.floor(completionPercent * 100) / 100;
    }
    isEmpty(val) {
        return val === undefined || val == null || val.length <= 0 ? true : false;
    }
    get(object, path) {
        const obj = Object.assign({}, object);
        const pList = path.split('.');
        const key = pList.pop();
        const pointer = pList.reduce((accumulator, currentValue) => {
            return accumulator[currentValue];
        }, obj);
        if (!pointer && key) {
            return;
        }
        else {
            return pointer[key];
        }
    }
    isDateType(dataTypeKey) {
        return dataTypeKey === DataTypeEnum.Date;
    }
    isDateTimeType(dataTypeKey) {
        return dataTypeKey === DataTypeEnum.DateTime;
    }
    isAllowedValueType(dataTypeKey) {
        return (dataTypeKey !== DataTypeEnum.Numeric &&
            dataTypeKey !== DataTypeEnum.Alphanumeric &&
            dataTypeKey !== DataTypeEnum.Date &&
            dataTypeKey !== DataTypeEnum.Image &&
            dataTypeKey !== DataTypeEnum.Video &&
            dataTypeKey !== DataTypeEnum.Document &&
            dataTypeKey !== DataTypeEnum.DateTime &&
            dataTypeKey !== DataTypeEnum.NumericDecimal &&
            dataTypeKey !== DataTypeEnum.Id &&
            dataTypeKey !== DataTypeEnum.Hierarchy &&
            dataTypeKey !== DataTypeEnum.field_type_suggested_hierarchy);
    }
    getArray(count) {
        return Array(count);
    }
    getType(col) {
        return ProductFieldEnumMap.get(col.fieldKey).type;
    }
    getNestedFormName(col) {
        const fieldInfo = ProductFieldEnumMap.get(col.fieldKey);
        if (fieldInfo.type === Type.Object) {
            return fieldInfo.field.split('.')[0];
        }
        else if (fieldInfo.type === Type.Array) {
            return fieldInfo.field;
        }
    }
    getNestedForm(form, col, type, i) {
        return type === Type.Array
            ? form.get(this.getNestedFormName(col))['controls'][i]
            : form.get(this.getNestedFormName(col));
    }
    getFormControlName(col) {
        const fieldInfo = ProductFieldEnumMap.get(col.fieldKey);
        if (fieldInfo.type === Type.Object) {
            return fieldInfo.field.split('.')[1];
        }
        else if (fieldInfo.type === Type.Array) {
            return fieldInfo.arrayObjectField;
        }
        else {
            return fieldInfo.field;
        }
    }
    getValue(productDetails, fieldInfo, index) {
        return fieldInfo.type === Type.Object
            ? this.get(productDetails, fieldInfo.field)
            : this.get(productDetails[fieldInfo.field][index], fieldInfo.arrayObjectField);
    }
    displayProductDetails(value, colDataType, dropDownData, dateFormat, timeFormat) {
        if (this.isAllowedValueType(colDataType)) {
            return this.mapDropDown(value, colDataType, dropDownData);
        }
        else if (this.isDateType(colDataType)) {
            return this.datePipe.transform(value, dateFormat.format);
        }
        else if (this.isDateTimeType(colDataType)) {
            if (value != null) {
                return this.datePipe.transform(utcToZonedTime(value, timeFormat.timeZoneCodeIANA), dateFormat.format + ' ' + timeFormat.format);
            }
        }
        else {
            return value;
        }
    }
    mapDropDown(code, dataTypeKey, dropDownData) {
        if (code === undefined ||
            code === null ||
            dataTypeKey === undefined ||
            dataTypeKey === null ||
            dropDownData[dataTypeKey] === undefined) {
            return '';
        }
        if (dataTypeKey === DataTypeEnum.Country ||
            dataTypeKey === DataTypeEnum.Currency) {
            const temp = dropDownData[dataTypeKey].filter((item) => item.value === code)[0];
            return temp.label + ' - (' + temp.value + ') ';
        }
        else if (dataTypeKey === DataTypeEnum.Supplier) {
            const temp = dropDownData[dataTypeKey].filter((item) => item.value === code)[0];
            return temp.label + (temp.number ? ` - (${temp.number})` : '');
        }
        else {
            return dropDownData[dataTypeKey].filter((item) => item.value === code)[0]
                .label;
        }
    }
    getColumnDescription(col) {
        return ProductFieldEnumMap.get(col.fieldKey).description
            ? this.translocoSrv.translate('PIM.DIMENSIONS.' + ProductFieldEnumMap.get(col.fieldKey).description)
            : col.description;
    }
}
ProductDetailsService.ɵprov = ɵɵdefineInjectable({ factory: function ProductDetailsService_Factory() { return new ProductDetailsService(ɵɵinject(BaseAPIService), ɵɵinject(PimService), ɵɵinject(DatePipe), ɵɵinject(TranslocoService)); }, token: ProductDetailsService, providedIn: "root" });
ProductDetailsService.decorators = [
    { type: Injectable, args: [{
                providedIn: 'root',
            },] }
];
ProductDetailsService.ctorParameters = () => [
    { type: BaseAPIService },
    { type: PimService },
    { type: DatePipe },
    { type: TranslocoService }
];

class ProductDetailsBasicComponent {
    constructor(productDetailsSrv, translocoSrv) {
        this.productDetailsSrv = productDetailsSrv;
        this.translocoSrv = translocoSrv;
        this.ProductFieldEnum = ProductFieldsEnum;
        this.ProductFieldEnumMap = ProductFieldEnumMap;
        this.DataTypeEnum = DataTypeEnum;
        this.Type = Type;
    }
    ngOnInit() {
        if (this.suggestedHierarchyData) {
            this.hierarchyArray = this.createCategoryKeyToHierarchyMap(this.suggestedHierarchyData.records);
        }
    }
    display(value, col) {
        if (col.fieldKey === ProductFieldsEnum.addedBy ||
            col.fieldKey === ProductFieldsEnum.modifiedBy) {
            return this.users[value] ? this.users[value].fullname : null;
        }
        if (col.dataTypeKey === 29) {
            value = this.hierarchyArray[value];
            if (value === undefined) {
                value = this.translocoSrv.translate('PIM.PRODUCT_SUGGESTED_HIERARCHY_UNSPECIFIED');
            }
        }
        return !this.productDetailsSrv.isEmpty(value)
            ? this.productDetailsSrv.displayProductDetails(value, col.dataTypeKey, this.dropDownData, this.dateFormat, this.timeFormat)
            : value;
    }
    createCategoryKeyToHierarchyMap(tree) {
        const map = {};
        function traverse(node) {
            map[node.categoryKey] = node.fullHierarchy;
            if (node.children && node.children.length > 0) {
                node.children.forEach((child) => traverse(child));
            }
        }
        tree.forEach((rootNode) => traverse(rootNode));
        return map;
    }
}
ProductDetailsBasicComponent.decorators = [
    { type: Component, args: [{
                selector: 'lib-product-details-basic',
                template: "<div class=\"vertical-flow space-between-000\">\r\n  <ng-container *ngFor=\"let col of cols\">\r\n    <ng-container *ngIf=\"col.isIncluded\">\r\n      <div\r\n        *ngIf=\"\r\n          productDetailsSrv.getType(col) === undefined &&\r\n          (!col.isHidden || col.fieldKey === ProductFieldEnum.supplierKey) &&\r\n          col.fieldKey !== ProductFieldEnum.supplierName &&\r\n          col.fieldKey !== ProductFieldEnum.supplierNumber\r\n        \"\r\n        class=\"line product-details product-details-row\"\r\n      >\r\n        <div\r\n          [ngClass]=\"template ? 'tile' : 'product-details product-details-tile'\"\r\n        >\r\n          <div class=\"product-details product-details-label\">\r\n            {{ productDetailsSrv.getColumnDescription(col) }}\r\n          </div>\r\n          <div *ngIf=\"!isEditable\">\r\n            <span>\r\n              {{\r\n                display(\r\n                  productDetails[ProductFieldEnumMap.get(col.fieldKey).field],\r\n                  col\r\n                )\r\n              }}\r\n            </span>\r\n          </div>\r\n          <div\r\n            *ngIf=\"\r\n              isEditable &&\r\n              col.dataTypeKey !== DataTypeEnum.DateTime &&\r\n              col.fieldKey !== ProductFieldEnum.id &&\r\n              col.fieldKey !== ProductFieldEnum.addedBy &&\r\n              col.fieldKey !== ProductFieldEnum.modifiedBy\r\n            \"\r\n          >\r\n            <lib-product-details-child\r\n              [form]=\"form\"\r\n              [productDetails]=\"productDetails\"\r\n              [suggestedHierarchyData]=\"suggestedHierarchyData\"\r\n              [productHierarchies]=\"productHierarchies\"\r\n              [dropDownData]=\"dropDownData\"\r\n              [col]=\"col\"\r\n              [dateFormat]=\"dateFormat\"\r\n              [timeFormat]=\"timeFormat\"\r\n            ></lib-product-details-child>\r\n            <lib-control-message [control]=\"form.get(col.fieldName.trim())\">\r\n            </lib-control-message>\r\n          </div>\r\n          <div\r\n            *ngIf=\"\r\n              isEditable &&\r\n              (col.dataTypeKey === DataTypeEnum.DateTime ||\r\n                col.fieldKey === ProductFieldEnum.id ||\r\n                col.fieldKey === ProductFieldEnum.addedBy ||\r\n                col.fieldKey === ProductFieldEnum.modifiedBy)\r\n            \"\r\n          >\r\n            <span>{{\r\n              display(\r\n                productDetails[ProductFieldEnumMap.get(col.fieldKey).field],\r\n                col\r\n              )\r\n            }}</span>\r\n          </div>\r\n        </div>\r\n      </div>\r\n\r\n      <div\r\n        *ngIf=\"productDetailsSrv.getType(col) === Type.Array\"\r\n        class=\"vertical-flow\"\r\n      >\r\n        <ng-container [formGroup]=\"form\">\r\n          <ng-container\r\n            [formArrayName]=\"productDetailsSrv.getNestedFormName(col)\"\r\n            *ngIf=\"productDetailsSrv.getNestedFormName(col) !== undefined\"\r\n          >\r\n            <div\r\n              class=\"line product-details product-details-row\"\r\n              *ngFor=\"\r\n                let val of form.get(productDetailsSrv.getNestedFormName(col))[\r\n                  'controls'\r\n                ];\r\n                let i = index\r\n              \"\r\n              [formGroupName]=\"i\"\r\n            >\r\n              <div\r\n                [ngClass]=\"\r\n                  template ? 'tile' : 'product-details  product-details-tile'\r\n                \"\r\n              >\r\n                <div class=\"product-details product-details-label\">\r\n                  {{ productDetailsSrv.getColumnDescription(col) }} {{ i + 1 }}\r\n                </div>\r\n                <div *ngIf=\"!isEditable\">\r\n                  <span>{{\r\n                    display(\r\n                      productDetailsSrv.getValue(\r\n                        productDetails,\r\n                        ProductFieldEnumMap.get(col.fieldKey),\r\n                        i\r\n                      ),\r\n                      col\r\n                    )\r\n                  }}</span>\r\n                </div>\r\n\r\n                <div *ngIf=\"isEditable\">\r\n                  <lib-product-details-child\r\n                    [form]=\"\r\n                      productDetailsSrv.getNestedForm(form, col, Type.Array, i)\r\n                    \"\r\n                    [productDetails]=\"productDetails\"\r\n                    [dropDownData]=\"dropDownData\"\r\n                    [col]=\"col\"\r\n                    [dateFormat]=\"dateFormat\"\r\n                    [timeFormat]=\"timeFormat\"\r\n                  ></lib-product-details-child>\r\n                </div>\r\n              </div>\r\n            </div>\r\n          </ng-container>\r\n        </ng-container>\r\n      </div>\r\n      <div\r\n        *ngIf=\"productDetailsSrv.getType(col) === Type.Object\"\r\n        class=\"line product-details product-details-row\"\r\n      >\r\n        <ng-container [formGroup]=\"form\">\r\n          <div\r\n            [ngClass]=\"\r\n              template ? 'tile' : 'product-details  product-details-tile'\r\n            \"\r\n          >\r\n            <div class=\"product-details product-details-label\">\r\n              {{ productDetailsSrv.getColumnDescription(col) }}\r\n            </div>\r\n            <div *ngIf=\"!isEditable\">\r\n              <span>{{\r\n                display(\r\n                  productDetailsSrv.getValue(\r\n                    productDetails,\r\n                    ProductFieldEnumMap.get(col.fieldKey)\r\n                  ),\r\n                  col\r\n                )\r\n              }}</span>\r\n            </div>\r\n            <div *ngIf=\"isEditable\">\r\n              <lib-product-details-child\r\n                [form]=\"productDetailsSrv.getNestedForm(form, col, Type.Object)\"\r\n                [productDetails]=\"productDetails\"\r\n                [dropDownData]=\"dropDownData\"\r\n                [col]=\"col\"\r\n                [dateFormat]=\"dateFormat\"\r\n                [timeFormat]=\"timeFormat\"\r\n              ></lib-product-details-child>\r\n            </div>\r\n          </div>\r\n        </ng-container>\r\n      </div>\r\n    </ng-container>\r\n  </ng-container>\r\n</div>\r\n",
                styles: [""]
            },] }
];
ProductDetailsBasicComponent.ctorParameters = () => [
    { type: ProductDetailsService },
    { type: TranslocoService }
];
ProductDetailsBasicComponent.propDecorators = {
    productDetails: [{ type: Input }],
    dropDownData: [{ type: Input }],
    cols: [{ type: Input }],
    form: [{ type: Input }],
    dateFormat: [{ type: Input }],
    timeFormat: [{ type: Input }],
    isEditable: [{ type: Input }],
    users: [{ type: Input }],
    template: [{ type: Input }],
    suggestedHierarchyData: [{ type: Input }],
    productHierarchies: [{ type: Input }]
};

/**
 * Child Component that renders HTML in edit mode and  takes the following as parameters from parent
 * ProductDetails of the current edited prodcut, dropDownData, Included fields, Form,
 * Dimension type - to render Masterpack, Consumer Pack & pallet information,
 * styleClass - CSS styles
 *
 */
class ProductDetailsChildComponent {
    constructor(productDetailsSrv, translocoSrv, datePipe) {
        this.productDetailsSrv = productDetailsSrv;
        this.translocoSrv = translocoSrv;
        this.datePipe = datePipe;
        // TO BE POPULATED BY DATA RETURNED FROM LBMX HIERARCHY ENDPOINT PIM-193 & PIM-194
        this.hierarchyRoot = [null];
        this.ProductFieldEnum = ProductFieldsEnum;
        this.DataTypeEnum = DataTypeEnum;
        /** empty block */
    }
    ngOnInit() {
        this.fieldFormControlName = this.productDetailsSrv.getFormControlName(this.col);
    }
    getPlaceHolderText(col) {
        if (col.dataTypeKey === DataTypeEnum.Numeric) {
            return this.translocoSrv.translate('PIM.PLACEHOLDER_TEXT.NUMERIC', {
                value1: this.productDetailsSrv.getColumnDescription(col),
                value2: col.minLimit,
                value3: col.maxLimit,
            });
        }
        else if (col.dataTypeKey === DataTypeEnum.NumericDecimal) {
            return this.translocoSrv.translate('PIM.PLACEHOLDER_TEXT.NUMERIC_DECIMAL', {
                value1: this.productDetailsSrv.getColumnDescription(col),
            });
        }
        else {
            return this.translocoSrv.translate('PIM.PLACEHOLDER_TEXT.GENERIC', {
                value1: this.productDetailsSrv.getColumnDescription(col),
            });
        }
    }
}
ProductDetailsChildComponent.decorators = [
    { type: Component, args: [{
                selector: 'lib-product-details-child',
                template: "<div [formGroup]=\"form\" class=\"product-details padding-right-2em\">\r\n  <p-dropdown\r\n    *ngIf=\"\r\n      productDetailsSrv.isAllowedValueType(col.dataTypeKey) === true &&\r\n      col.dataTypeKey !== DataTypeEnum.Country &&\r\n      col.dataTypeKey !== DataTypeEnum.Currency &&\r\n      col.dataTypeKey !== DataTypeEnum.Supplier &&\r\n      col.dataTypeKey !== DataTypeEnum.field_type_suggested_hierarchy &&\r\n      col.dataTypeKey !== DataTypeEnum.Hierarchy\r\n    \"\r\n    [options]=\"dropDownData[col.dataTypeKey]\"\r\n    [formControlName]=\"fieldFormControlName\"\r\n    [placeholder]=\"'ACTIONS.SELECT' | transloco\"\r\n    filter=\"true\"\r\n    showClear=\"true\"\r\n  >\r\n  </p-dropdown>\r\n  <!--Dropdown for Allowed value fields ends-->\r\n  <!-- Dropdown & Input specific to Countries & country name-->\r\n  <p-dropdown\r\n    *ngIf=\"\r\n      col.dataTypeKey === DataTypeEnum.Country ||\r\n      col.dataTypeKey === DataTypeEnum.Currency\r\n    \"\r\n    [options]=\"dropDownData[col.dataTypeKey]\"\r\n    [formControlName]=\"fieldFormControlName\"\r\n    [placeholder]=\"'ACTIONS.SELECT' | transloco\"\r\n    filter=\"true\"\r\n    showClear=\"true\"\r\n    filterBy=\"label,value\"\r\n  >\r\n    <ng-template let-item pTemplate=\"selectedItem\">\r\n      <span>{{ item.label }}</span>\r\n    </ng-template>\r\n    <ng-template let-obj pTemplate=\"item\">\r\n      <div class=\"ui-helper-clearfix product-details-dropdown-div\">\r\n        <div class=\"product-details-dropdown-left-div\">\r\n          {{ obj.label }}\r\n        </div>\r\n        <div class=\"product-details-dropdown-right-div\">\r\n          {{ obj.value }}\r\n        </div>\r\n      </div>\r\n    </ng-template>\r\n  </p-dropdown>\r\n\r\n  <!-- Dropdown & Input specific to Supplier-->\r\n  <lib-supplier-input\r\n    *ngIf=\"col.dataTypeKey === DataTypeEnum.Supplier\"\r\n    [suppliers]=\"dropDownData[col.dataTypeKey]\"\r\n    [formControlName]=\"fieldFormControlName\"\r\n    [isTransient]=\"!productDetails.id\"\r\n  >\r\n  </lib-supplier-input>\r\n\r\n  <!-- Input for calendar type-->\r\n  <p-calendar\r\n    [dateFormat]=\"dateFormat.primeNgFormat\"\r\n    [placeholder]=\"dateFormat.description\"\r\n    [formControlName]=\"fieldFormControlName\"\r\n    *ngIf=\"productDetailsSrv.isDateType(col.dataTypeKey) === true\"\r\n  >\r\n  </p-calendar>\r\n  <!-- Input for calendar type ends-->\r\n\r\n  <!-- Input for Numeric types-->\r\n  <input\r\n    pInputText\r\n    *ngIf=\"col.dataTypeKey === DataTypeEnum.Numeric\"\r\n    [formControlName]=\"fieldFormControlName\"\r\n    pKeyFilter=\"pint\"\r\n    [minlength]=\"col.minLimit\"\r\n    [maxlength]=\"col.maxLimit\"\r\n    [placeholder]=\"\r\n      col.fieldKey === ProductFieldEnum.id ? '' : getPlaceHolderText(col)\r\n    \"\r\n  />\r\n  <!-- Input for Numeric types end-->\r\n\r\n  <!-- Input for AlphaNumerics-->\r\n  <textarea\r\n    pInputTextarea\r\n    [maxLength]=\"col.maxLimit\"\r\n    [minLength]=\"col.minLimit\"\r\n    *ngIf=\"col.dataTypeKey === DataTypeEnum.Alphanumeric\"\r\n    [placeholder]=\"getPlaceHolderText(col)\"\r\n    [formControlName]=\"fieldFormControlName\"\r\n    rows=\"1\"\r\n  >\r\n  </textarea>\r\n  <!-- Input for AlphaNumerics end-->\r\n\r\n  <!--Input for Numeric Decimal-->\r\n  <!-- Min & Max to be fixed when primeNG version is updated. PrimeNG version 9 takes exclusive limits.  -->\r\n  <p-inputNumber\r\n    [formControlName]=\"fieldFormControlName\"\r\n    *ngIf=\"col.dataTypeKey === DataTypeEnum.NumericDecimal\"\r\n    [minFractionDigits]=\"col.decimalLimit\"\r\n    [maxFractionDigits]=\"col.decimalLimit\"\r\n    [min]=\"col.minLimit\"\r\n    [max]=\"col.maxLimit\"\r\n    [placeholder]=\"getPlaceHolderText(col)\"\r\n  ></p-inputNumber>\r\n  <!-- Input for Numeric Decimal end-->\r\n\r\n  <!-- Input for Hierarchy fields-->\r\n  <lib-hierarchy-form-input\r\n    *ngIf=\"col.dataTypeKey === DataTypeEnum.field_type_suggested_hierarchy\"\r\n    [formControlName]=\"fieldFormControlName\"\r\n    [suggestedHierarchyData]=\"suggestedHierarchyData && suggestedHierarchyData\"\r\n  ></lib-hierarchy-form-input>\r\n\r\n  <lib-hierarchy-form-input-editable\r\n    *ngIf=\"col.dataTypeKey === DataTypeEnum.Hierarchy\"\r\n    [formControlName]=\"fieldFormControlName\"\r\n    [fieldLabel]=\"col.description\"\r\n    [productHierarchies]=\"productHierarchies.get(col.fieldKey)\"\r\n  ></lib-hierarchy-form-input-editable>\r\n  <!-- Input for Hierarchy fields end-->\r\n</div>\r\n",
                styles: [""]
            },] }
];
ProductDetailsChildComponent.ctorParameters = () => [
    { type: ProductDetailsService },
    { type: TranslocoService },
    { type: DatePipe }
];
ProductDetailsChildComponent.propDecorators = {
    productDetails: [{ type: Input }],
    dropDownData: [{ type: Input }],
    col: [{ type: Input }],
    form: [{ type: Input }],
    dateFormat: [{ type: Input }],
    timeFormat: [{ type: Input }],
    styleClass: [{ type: Input }],
    suggestedHierarchyData: [{ type: Input }],
    productHierarchies: [{ type: Input }]
};

var CategoryEnum;
(function (CategoryEnum) {
    CategoryEnum[CategoryEnum["CoreInformation"] = 0] = "CoreInformation";
    CategoryEnum[CategoryEnum["Hierarchy"] = 1] = "Hierarchy";
    CategoryEnum[CategoryEnum["OrderInformation"] = 2] = "OrderInformation";
    CategoryEnum[CategoryEnum["Dimensions"] = 3] = "Dimensions";
    CategoryEnum[CategoryEnum["ProductEnrichment"] = 4] = "ProductEnrichment";
    CategoryEnum[CategoryEnum["Assets"] = 5] = "Assets";
    CategoryEnum[CategoryEnum["HazardInformation"] = 6] = "HazardInformation";
    CategoryEnum[CategoryEnum["ApparelInformation"] = 7] = "ApparelInformation";
    CategoryEnum[CategoryEnum["BatteryInformation"] = 8] = "BatteryInformation";
    CategoryEnum[CategoryEnum["HVACPipeInformation"] = 9] = "HVACPipeInformation";
    CategoryEnum[CategoryEnum["WarrantyInformation"] = 10] = "WarrantyInformation";
    CategoryEnum[CategoryEnum["BuildingMaterials"] = 11] = "BuildingMaterials";
    CategoryEnum[CategoryEnum["HandTools"] = 12] = "HandTools";
    CategoryEnum[CategoryEnum["PowerTools"] = 13] = "PowerTools";
    CategoryEnum[CategoryEnum["AirToolsAndCompressors"] = 14] = "AirToolsAndCompressors";
    CategoryEnum[CategoryEnum["ToolStorage"] = 15] = "ToolStorage";
    CategoryEnum[CategoryEnum["FridgeAndFreezer"] = 16] = "FridgeAndFreezer";
    CategoryEnum[CategoryEnum["Appliances"] = 17] = "Appliances";
    CategoryEnum[CategoryEnum["CookersAndOvens"] = 18] = "CookersAndOvens";
    CategoryEnum[CategoryEnum["DishWashers"] = 19] = "DishWashers";
    CategoryEnum[CategoryEnum["WashersAndDryers"] = 20] = "WashersAndDryers";
    CategoryEnum[CategoryEnum["SinkAndSplashback"] = 21] = "SinkAndSplashback";
    CategoryEnum[CategoryEnum["TVs"] = 22] = "TVs";
    CategoryEnum[CategoryEnum["ACRefrigerationAndSupplies"] = 23] = "ACRefrigerationAndSupplies";
    CategoryEnum[CategoryEnum["AirFilters"] = 24] = "AirFilters";
    CategoryEnum[CategoryEnum["AirTreatment"] = 25] = "AirTreatment";
    CategoryEnum[CategoryEnum["CentralEquipment"] = 26] = "CentralEquipment";
    CategoryEnum[CategoryEnum["ControlsAndThermostats"] = 27] = "ControlsAndThermostats";
    CategoryEnum[CategoryEnum["FanBladesAndPropellers"] = 28] = "FanBladesAndPropellers";
    CategoryEnum[CategoryEnum["HVACRefrigeration"] = 29] = "HVACRefrigeration";
    CategoryEnum[CategoryEnum["VentilationEquipment"] = 30] = "VentilationEquipment";
})(CategoryEnum || (CategoryEnum = {}));

class FormCanDeactivateDirective extends ComponentCanDeactivateDirective {
    canDeactivate() {
        return this.form.submitted || !this.form.dirty;
    }
}
FormCanDeactivateDirective.decorators = [
    { type: Directive }
];

class ProductDetailsComponent extends FormCanDeactivateDirective {
    constructor(route, productDetailsSrv, hierarchySrv, PimSrv, confirmationService, router, toastSrv, loggerSrv, translocoSrv, store, spinnerService, pimAPISrv) {
        super();
        this.route = route;
        this.productDetailsSrv = productDetailsSrv;
        this.hierarchySrv = hierarchySrv;
        this.PimSrv = PimSrv;
        this.confirmationService = confirmationService;
        this.router = router;
        this.toastSrv = toastSrv;
        this.loggerSrv = loggerSrv;
        this.translocoSrv = translocoSrv;
        this.store = store;
        this.spinnerService = spinnerService;
        this.pimAPISrv = pimAPISrv;
        // Variables for assets
        this.activeIndex = 0;
        this.authorizedActions = {};
        this.documentTypes = '';
        this.imageTypes = '';
        this.videoTypes = '';
        // HTML Templates
        this.templateB = true;
        this.templateC = false;
        this.templateD = false;
        // Boolean variables
        this.isEditable = false;
        this.isPdx = false;
        this.enableSave = false;
        this.showDiscontinueDate = false;
        this.cols = [];
        this.mandatoryFields = [];
        this.allowedValues = [];
        this.dropDownData = {};
        this.completionPercent = 0;
        this.mappedFields = [];
        this.DataTypeEnum = DataTypeEnum;
        this.ProductFieldEnum = ProductFieldsEnum;
        this.CategoryEnum = CategoryEnum;
        this.productForm = new FormGroup({});
        this.subscriptions = [];
        this.destroy$ = new Subject();
    }
    ngOnInit() {
        this.store.dispatch(fetchAllowedValues());
        this.store.dispatch(fetchCountryList());
        this.store.dispatch(fetchCurrencyList());
        this.store.dispatch(fetchSuppliers());
        this.subscriptions.push(this.route.data.subscribe((data) => {
            this.isPdx = data.isPdx;
        }), this.hierarchySrv.getAllHierarchy().subscribe((a) => {
            this.suggestedHierarchy = a;
        }), this.store
            .pipe(select(selectors.userProfile), tap((user) => {
            (this.dateFormat = {
                format: user.userInfo.DateTypeFormat,
                primeNgFormat: user.userInfo.PrimeNGDateTypeFormat,
                description: user.userInfo.DateTypeDescription,
            }),
                (this.timeFormat = {
                    format: user.userInfo.TimeFormat,
                    description: user.userInfo.TimeTypeDescription,
                    timeZoneCodeIANA: user.userInfo.IANATimeZoneCode,
                }),
                ((this.accountKey = user.userInfo.AccountKey),
                    (this.userKey = user.userInfo.UserKey));
        }))
            .subscribe());
        this.setUp();
    }
    ngOnDestroy() {
        this.destroy$.next();
        this.destroy$.complete();
        if (this.subscriptions) {
            this.subscriptions.forEach((subscription) => subscription.unsubscribe());
        }
    }
    getPermissions() {
        return {
            maintainAssets: (!this.isPdx &&
                toolKeys.PIM_PRODUCTS_APPROVED_PRODUCTS_MAINTAIN_ASSETS) ||
                (this.isPdx && toolKeys.PDX_PRODUCTS_VIEW_PRODUCTS_MAINTAIN_ASSETS),
            edit: (!this.isPdx && toolKeys.PIM_PRODUCTS_APPROVED_PRODUCTS_EDIT) ||
                (this.isPdx && toolKeys.PDX_PRODUCTS_VIEW_PRODUCTS_EDIT),
            new: (!this.isPdx && toolKeys.PIM_PRODUCTS_APPROVED_PRODUCTS_NEW) ||
                (this.isPdx && toolKeys.PDX_PRODUCTS_VIEW_PRODUCTS_NEW),
        };
    }
    setUp() {
        this.spinnerService.on();
        const fieldsObservable = this.store.select(selectors.sortedFields).pipe(first((f) => f.length !== 0), map((f) => f.filter((field) => field.isIncluded &&
            (!field.isHidden ||
                field.fieldKey === ProductFieldsEnum.supplierKey))), shareReplay(1));
        this.subscriptions.push(forkJoin({
            categories: this.store
                .select(selectors.rawCategories)
                .pipe(first((c) => c.length !== 0)),
            fields: fieldsObservable,
            hierarchies: fieldsObservable.pipe(switchMap((fields) => {
                const hierarchyFields = fields.filter((f) => f.dataTypeKey === DataTypeEnum.Hierarchy);
                if (hierarchyFields.length === 0) {
                    return of([]);
                }
                return forkJoin(hierarchyFields.map((f) => this.hierarchySrv
                    .getFieldHierarchy(f.fieldKey)
                    .pipe(map((h) => [f.fieldKey, h]))));
            }), takeUntil(this.destroy$)),
            allowedValues: this.store
                .select(allowedValues)
                .pipe(first((av) => av.length !== 0)),
            countries: this.store
                .select(countries)
                .pipe(first((ct) => ct.length !== 0)),
            currencies: this.store
                .select(currencies)
                .pipe(first((cr) => cr.length !== 0)),
            suppliers: this.store
                .select(sortedSuppliers)
                .pipe(first((s) => s.length !== 0)),
            users: this.store
                .select(selectors.users)
                .pipe(first((u) => Object.keys(u).length > 0)),
            product: combineLatest([this.route.params, this.route.data]).pipe(first(), switchMap(([params, data]) => {
                if (data.isPdx || !data.isNew) {
                    return this.fetchProductDetails(params.id);
                }
                return of(new Product());
            }), catchError(() => {
                this.router.navigate(['../'], { relativeTo: this.route });
                return of(new Product());
            })),
            authorizedActions: this.store
                .select(selectors.isAuthorized, this.getPermissions())
                .pipe(first()),
        })
            .pipe(takeUntil(this.destroy$))
            .subscribe(({ categories, fields, hierarchies, allowedValues, countries, currencies, suppliers, users, product, authorizedActions, }) => {
            this.fields = fields;
            this.productHierarchies = new Map(hierarchies);
            this.country = countries;
            this.currency = currencies;
            this.suppliers = suppliers;
            this.allowedValues = allowedValues;
            this.productDetails = product;
            this.authorizedActions = authorizedActions;
            const assetTypes = this.getAssetTypes(this.allowedValues);
            this.imageTypes = assetTypes.imageTypes;
            this.documentTypes = assetTypes.documentTypes;
            this.videoTypes = assetTypes.videoTypes;
            this.fieldCategories = this.getFieldCategories(this.fields, categories);
            this.mandatoryFields = this.fields.filter((x) => x.isRecommended === true);
            this.mappedFields = this.mapFieldsToCategories(this.fieldCategories, this.fields);
            this.cols = this.mappedFields[0].cols;
            this.productForm = this.generateForm(this.fields, this.productDetails);
            this.dropDownData = this.getDropdownData(this.allowedValues, this.country, this.currency, this.suppliers);
            this.isEditable = !this.productDetails.id;
            this.uploadAssetsUrl = urlJoin(this.PimSrv.getConfig().uploadAssetsEndPoint, this.productForm.value.supplierKey);
            this.completionPercent =
                this.productDetailsSrv.getCompletionPercent(this.mandatoryFields, this.productForm.getRawValue(), this.ProductFieldEnum);
            this.users = users;
            this.spinnerService.off();
        }, (err) => {
            this.loggerSrv.error('Error loading', 'ProductDetails', err);
        }));
    }
    dataCleanUp(data) {
        const product = new Product();
        Object.keys(product).forEach((key) => {
            if (data[key] === null || data[key] === undefined) {
                data[key] = {};
            }
        });
        data.endShipDate = data.endShipDate ? new Date(data.endShipDate) : null;
        data.consumerDate = data.consumerDate ? new Date(data.consumerDate) : null;
        data.availableDate = data.availableDate
            ? new Date(data.availableDate)
            : null;
        data.discontinueDate = data.discontinueDate
            ? new Date(data.discontinueDate)
            : null;
        data.startShipDate = data.startShipDate
            ? new Date(data.startShipDate)
            : null;
        data.dateAdded = data.dateAdded ? new Date(data.dateAdded) : null;
        data.dateLastChanged = data.dateLastChanged
            ? new Date(data.dateLastChanged)
            : null;
        data.showOnlineStartDate = data.showOnlineStartDate
            ? new Date(data.showOnlineStartDate)
            : null;
        data.showOnlineEndDate = data.showOnlineEndDate
            ? new Date(data.showOnlineEndDate)
            : null;
        if (data.discontinueDate && data.discontinueDate <= new Date()) {
            this.showDiscontinueDate = true;
        }
        return data;
    }
    getAssetTypes(allowedValue) {
        let imageTypes = '';
        let documentTypes = '';
        let videoTypes = '';
        allowedValue.forEach((value) => {
            // if allowed values are document, image or video type,
            // it populates this arrays
            if (Number(value.dataTypeKey) === DataTypeEnum.Document) {
                if (documentTypes !== '') {
                    documentTypes += ', ';
                }
                documentTypes += '.' + value.description.toLowerCase();
            }
            else if (Number(value.dataTypeKey) === DataTypeEnum.Image) {
                if (imageTypes !== '') {
                    imageTypes += ', ';
                }
                imageTypes += '.' + value.description.toLowerCase();
            }
            else if (Number(value.dataTypeKey) === DataTypeEnum.Video) {
                if (videoTypes !== '') {
                    videoTypes += ', ';
                }
                videoTypes += '.' + value.description.toLowerCase();
            }
        });
        return { imageTypes, videoTypes, documentTypes };
    }
    fetchProductDetails(id) {
        return this.pimAPISrv.getProductId(id).pipe(map((res) => res.product), map(this.dataCleanUp), switchMap((product) => {
            const primaryImage$ = product.primaryImage
                ? this.getAssets(Array(product.primaryImage), product.supplierKey)
                : of([{ isAvailable: false }]);
            const secondaryImages$ = this.getAssets(product.secondaryImages, product.supplierKey);
            const videos$ = this.getAssets(product.videos, product.supplierKey, 'video');
            const documents$ = this.getAssets(product.documents, product.supplierKey);
            return forkJoin({
                primaryImage: forkJoin(primaryImage$),
                secondaryImages: forkJoin(secondaryImages$).pipe(defaultIfEmpty([])),
                videos: forkJoin(videos$).pipe(defaultIfEmpty([])),
                documents: forkJoin(documents$).pipe(defaultIfEmpty([])),
            }).pipe(map((res) => {
                return Object.assign(Object.assign({}, product), { primaryImage: res.primaryImage[0], secondaryImages: res.secondaryImages, videos: res.videos, documents: res.documents });
            }));
        }));
    }
    getAssets(assetArray, supplierKey, type) {
        return assetArray.map((p) => {
            if (p.filename) {
                return this.productDetailsSrv.getAssetUrl(supplierKey, p.filename).pipe(map((url) => {
                    if (type) {
                        return Object.assign(Object.assign({}, p), { url, isAvailable: true, type: 'video/' + p.filename.split('.')[1] });
                    }
                    else {
                        return Object.assign(Object.assign({}, p), { url, isAvailable: true });
                    }
                }), catchError((err) => {
                    if (err.status === 404) {
                        return of(Object.assign(Object.assign({}, p), { url: null, isAvailable: false }));
                    }
                    else {
                        throw err;
                    }
                }));
            }
            else {
                return of(Object.assign(Object.assign({}, p), { url: null, isAvailable: false }));
            }
        });
    }
    // Map allowed values to format -- <dataTypeKey,List<allowedValues>>
    getDropdownData(allowedValues, country, currency, suppliers) {
        return allowedValues
            .filter((x) => x.dataTypeKey !== DataTypeEnum.FreightClass)
            .reduce((acc, val) => {
            if (!acc[val.dataTypeKey]) {
                acc[val.dataTypeKey] = [];
            }
            let value;
            if (val.dataTypeKey === DataTypeEnum.Yes_No) {
                value = val.allowedValueKey === 'True' ? true : false;
            }
            else {
                value = val.allowedValueKey;
            }
            acc[val.dataTypeKey].push({
                label: val.description.trim(),
                value,
            });
            return acc;
        }, {
            [DataTypeEnum.Country]: country.map((c) => ({
                label: c.countryName,
                value: c.countryCode,
            })),
            [DataTypeEnum.Currency]: currency.map((c) => ({
                label: c.currencyName,
                value: c.currencyCode,
            })),
            [DataTypeEnum.Supplier]: suppliers.map((s) => ({
                label: s.legalName,
                value: s.accountKey,
                number: s.number,
                lbmxId: s.lbmxId,
            })),
            [DataTypeEnum.FreightClass]: allowedValues
                .filter((a) => a.dataTypeKey === DataTypeEnum.FreightClass)
                .sort((a, b) => parseFloat(a.allowedValueKey) - parseFloat(b.allowedValueKey))
                .map((a) => ({
                label: a.description.trim(),
                value: a.allowedValueKey,
            })),
        });
    }
    //#region Event Handlers for toolbar buttons
    editClicked() {
        this.isEditable = true;
    }
    cancelClicked() {
        if (this.productForm.dirty) {
            this.confirmationService.confirm({
                header: this.translocoSrv.translate('ACTIONS.CANCEL'),
                message: this.translocoSrv.translate('COMMON.CONFIRM_CANCEL'),
                icon: 'pi pi-exclamation-triangle',
                accept: () => {
                    this.isEditable = false;
                    this.productForm.reset();
                    this.productForm.patchValue(this.productDetails);
                    this.handleChange({ index: this.activeIndex });
                },
            });
        }
        else {
            this.isEditable = false;
            this.handleChange({ index: this.activeIndex });
        }
    }
    backClicked() {
        this.router.navigate(['../'], {
            relativeTo: this.route,
            queryParams: { filters: this.PimSrv.getFilters() },
        });
    }
    saveClicked() {
        var _a;
        const product = this.productForm.getRawValue();
        if ((_a = this.productForm.controls.suggestedCategoryKey) === null || _a === void 0 ? void 0 : _a.pristine) {
            product.suggestedCategoryKey = null;
        }
        if (!product.id) {
            this.spinnerService.on();
            this.productForm.patchValue({
                isPending: false,
                isApproved: true,
                isExcluded: false,
            });
            const tempProduct = this.productCleanUp(this.productForm.value);
            this.subscriptions.push(this.pimAPISrv.postProduct(tempProduct).subscribe((res) => {
                this.loggerSrv.info('Added new product', 'ProductDetailsService.insertProduct', res.productId);
                this.subscriptions.push(forkJoin([this.fetchProductDetails(res.productId)]).subscribe((result) => {
                    this.productDetails = result[0];
                    this.productForm.patchValue(this.productDetails);
                    this.productForm.patchValue({ id: this.productDetails.id });
                    this.router.navigate([], {
                        relativeTo: this.route,
                        queryParams: { id: this.productDetails.id },
                        queryParamsHandling: 'merge',
                    });
                    this.uploadAssetsUrl = urlJoin(this.PimSrv.getConfig().uploadAssetsEndPoint, this.productForm.value.supplierKey);
                    this.toastSrv.successNotify(this.translocoSrv.translate('PIM.PRODUCT_ADD_SUCCESS') +
                        '\n' +
                        this.productDetails.id, null, 5000);
                    this.isEditable = false;
                    this.spinnerService.off();
                }));
            }, (err) => {
                this.spinnerService.off();
                this.isEditable = true;
                if (err.error && err.error.errorCode === 3) {
                    this.loggerSrv.error('Error adding new product', 'ProductDetailsService.insertProduct', err);
                    this.toastSrv.errorNotify(this.translocoSrv.translate('PIM.PRODUCT_ADD_UPDATE_FAILURE_ON_SUPPLIER_DATA'), null, 5000);
                }
                else {
                    this.loggerSrv.error('Error adding new product', 'ProductDetailsService.insertProduct', err);
                    this.toastSrv.errorNotify(this.translocoSrv.translate('PIM.PRODUCT_ADD_FAILURE'), null, 5000);
                }
            }));
            this.handleChange({ index: this.activeIndex });
        }
        else {
            this.uploadAssetsUrl = urlJoin(this.PimSrv.getConfig().uploadAssetsEndPoint, this.productForm.value.supplierKey);
            this.productForm.patchValue({ modifiedBy: this.userKey });
            this.updateProduct(this.productCleanUp(product), this.activeIndex);
        }
        this.completionPercent = this.productDetailsSrv.getCompletionPercent(this.mandatoryFields, product, this.ProductFieldEnum);
    }
    //#endregion Event handlers
    productCleanUp(product) {
        if (product.videos) {
            product.videos = this.cleanUpHelper(product.videos);
        }
        if (product.secondaryImages) {
            product.secondaryImages = this.cleanUpHelper(product.secondaryImages);
        }
        if (product.optionalAccessories) {
            product.optionalAccessories = this.cleanUpHelper(product.optionalAccessories);
        }
        if (product.productBullets) {
            product.productBullets = this.cleanUpHelper(product.productBullets);
        }
        if (product.documents) {
            product.documents = this.cleanUpHelper(product.documents);
        }
        if (product.harmonizedTariffCodes) {
            product.harmonizedTariffCodes = this.cleanUpHelper(product.harmonizedTariffCodes);
        }
        if (product.cookerHeatingElements) {
            product.cookerHeatingElements = this.cleanUpHelper(product.cookerHeatingElements);
        }
        if (product.cookerOvenHeatingElementDimensions) {
            product.cookerOvenHeatingElementDimensions = this.cleanUpHelper(product.cookerOvenHeatingElementDimensions);
        }
        if (product.cookerOvenCompartmentFeatures) {
            product.cookerOvenCompartmentFeatures = this.cleanUpHelper(product.cookerOvenCompartmentFeatures);
        }
        if (product.cookerOvenCompartmentCapacities) {
            product.cookerOvenCompartmentCapacities = this.cleanUpHelper(product.cookerOvenCompartmentCapacities);
        }
        if (product.cookerOvenCompartments) {
            product.cookerOvenCompartments = this.cleanUpHelper(product.cookerOvenCompartments);
        }
        if (product.gasBurnerEfficiencies) {
            product.gasBurnerEfficiencies = this.cleanUpHelper(product.gasBurnerEfficiencies);
        }
        return product;
    }
    cleanUpHelper(array) {
        return array.filter((x) => !this.isObjEmpty(x));
    }
    isObjEmpty(obj) {
        return Object.values(obj).reduce((hasNoValues, value) => {
            return typeof value === 'boolean' ? false : hasNoValues && !value;
        }, true);
    }
    handleChange(e) {
        this.activeIndex = e.index;
        const _a = this.mappedFields[e.index], { cols } = _a, category = __rest(_a, ["cols"]);
        this.cols = cols;
        const categoryKey = category.categoryKey;
        if (categoryKey - 1 === this.CategoryEnum.Dimensions) {
            this.templateB = false;
            this.templateC = true;
            this.templateD = false;
        }
        else if (categoryKey - 1 === this.CategoryEnum.Assets) {
            this.templateB = false;
            this.templateC = false;
            this.templateD = true;
        }
        else {
            this.templateB = true;
            this.templateC = false;
            this.templateD = false;
        }
    }
    //#region  Helpers
    updateProduct(tempProductDetails, currentIndex) {
        this.spinnerService.on();
        this.subscriptions.push(this.pimAPISrv
            .putProductId(tempProductDetails.id, tempProductDetails)
            .subscribe(() => {
            this.subscriptions.push(forkJoin([
                this.fetchProductDetails(tempProductDetails.id),
            ]).subscribe((res) => {
                this.productDetails = res[0];
                this.productForm.reset();
                this.productForm.patchValue(this.productDetails);
                this.handleChange({ index: currentIndex });
                this.isEditable = false;
                this.spinnerService.off();
            }));
            this.toastSrv.successNotify(this.translocoSrv.translate('PIM.PRODUCT_UPDATE_SUCCESS'));
        }, (err) => {
            this.spinnerService.off();
            this.isEditable = true;
            if (err.error && err.error.errorCode === 3) {
                this.loggerSrv.error('Error updating product', 'ProductDetailsService.insertProduct', err);
                this.toastSrv.errorNotify(this.translocoSrv.translate('PIM.PRODUCT_ADD_UPDATE_FAILURE_ON_SUPPLIER_DATA'), null, 5000);
            }
            else {
                this.loggerSrv.error('Error updating  product', 'ProductDetailsService.updateProduct', err);
                this.toastSrv.errorNotify(this.translocoSrv.translate('PIM.PRODUCT_UPDATE_FAILURE'), null, 5000);
            }
        }));
    }
    // Group included fields under categories
    mapFieldsToCategories(categories, fields) {
        let temp = [];
        const mappedFields = [];
        categories.forEach((val) => {
            temp = fields.filter((field) => field.categoryKey === val.categoryKey && field.isIncluded);
            if (temp.length > 0) {
                mappedFields.push({ cols: temp, categoryKey: val.categoryKey });
            }
        });
        return mappedFields;
    }
    // Get included fields
    getFieldCategories(fields, categories) {
        const includedCategories = [
            ...new Set(fields.filter((x) => x.isIncluded).map((x) => x.categoryKey)),
        ];
        return categories.filter((value) => {
            return includedCategories.includes(value.categoryKey);
        });
    }
    buildRequest() {
        const request = new ProductDetailsRequest();
        request.id = this.id;
        return request;
    }
    // Method that Generates & adds form validators dynamically
    generateForm(fields, product) {
        const productForm = new FormGroup({});
        for (const field of fields) {
            const fieldInfo = ProductFieldEnumMap.get(field.fieldKey);
            if (fieldInfo.type === Type.Object) {
                this.addObjectField(field, fieldInfo, productForm);
            }
            else if (fieldInfo.type === Type.Array) {
                this.addArrayField(field, fieldInfo, productForm);
            }
            else {
                this.addField(field, fieldInfo, productForm);
            }
        }
        productForm.patchValue(product);
        return productForm;
    }
    addObjectField(field, fieldInfo, productForm) {
        const [groupName, fieldName] = fieldInfo.field.split('.');
        let group;
        if (productForm.contains(groupName)) {
            group = productForm.get(groupName);
        }
        else {
            group = new FormGroup({});
            productForm.addControl(groupName, group);
        }
        group.addControl(fieldName, this.getFormControl(field, null));
    }
    addArrayField(field, fieldInfo, productForm) {
        let array;
        if (productForm.contains(fieldInfo.field)) {
            array = productForm.get(fieldInfo.field);
        }
        else {
            array = new FormArray([]);
            productForm.addControl(fieldInfo.field, array);
        }
        for (let idx = 0; idx < field.arrayCount; idx++) {
            let group;
            if (array.length > idx) {
                group = array.at(idx);
            }
            else {
                group = new FormGroup({});
                array.setControl(idx, group);
            }
            group.addControl(fieldInfo.arrayObjectField, this.getFormControl(field, null));
        }
    }
    addField(field, fieldInfo, productForm) {
        productForm.addControl(fieldInfo.field, this.getFormControl(field, null));
    }
    getFormControl(field, initialValue) {
        switch (field.fieldKey) {
            case this.ProductFieldEnum.id:
            case this.ProductFieldEnum.accountKey:
            case this.ProductFieldEnum.dateAdded:
            case this.ProductFieldEnum.addedBy:
            case this.ProductFieldEnum.dateLastChanged:
            case this.ProductFieldEnum.modifiedBy:
            case this.ProductFieldEnum.supplierName:
            case this.ProductFieldEnum.supplierNumber:
                return new FormControl({ value: initialValue, disabled: true });
            case this.ProductFieldEnum.supplierKey:
                return new FormControl(initialValue, [Validators.required]);
        }
        const validators = [];
        if (field.isRequired) {
            validators.push(Validators.required);
        }
        if (field.minLimit !== null) {
            validators.push(Validators.minLength(field.minLimit));
        }
        if (field.maxLimit !== null) {
            validators.push(Validators.maxLength(field.maxLimit));
        }
        return new FormControl(initialValue, validators);
    }
    assetEventHandler($event) {
        this.updateProduct(this.productCleanUp($event), this.activeIndex);
        this.completionPercent = this.productDetailsSrv.getCompletionPercent(this.mandatoryFields, this.productForm.getRawValue(), this.ProductFieldEnum);
    }
}
ProductDetailsComponent.decorators = [
    { type: Component, args: [{
                selector: 'lib-product-details',
                template: "<form #form=\"ngForm\" [formGroup]=\"productForm\" (ngSubmit)=\"saveClicked()\">\r\n  <div class=\"vertical-flow space-between-000\" *ngIf=\"productDetails\">\r\n    <!-- #region Header-->\r\n    <h2 class=\"no-margin-bottom\">{{ 'PIM.PRODUCT_DETAILS' | transloco }}</h2>\r\n    <div\r\n      class=\"horizontal-flow space-between-250 space-before-075\"\r\n      *ngIf=\"templateD === false\"\r\n    >\r\n      <div class=\"product-details-header\">\r\n        <!--The primary image container <Hidden in Assets page> -->\r\n        <ng-container\r\n          *ngIf=\"\r\n            productDetails.primaryImage && productDetails.primaryImage.url;\r\n            else imageMissing\r\n          \"\r\n        >\r\n          <div class=\"img-container header\">\r\n            <img\r\n              class=\"target\"\r\n              [src]=\"productDetails.primaryImage.url + '?size=small'\"\r\n            />\r\n          </div>\r\n        </ng-container>\r\n        <ng-template #imageMissing>\r\n          <div class=\"img-container no-img\">\r\n            <span>\r\n              {{ 'PIM.ASSET' | transloco }}<br />{{\r\n                'PIM.NOT_FOUND' | transloco\r\n              }}\r\n            </span>\r\n          </div>\r\n        </ng-template>\r\n      </div>\r\n      <div class=\"product-details-imagedesc\">\r\n        <div>\r\n          <h3\r\n            class=\"no-margin-top no-margin-bottom product-details-primaryColor\"\r\n          >\r\n            {{ productForm.value.description }}\r\n          </h3>\r\n        </div>\r\n        <div>\r\n          <h4 class=\"product-details-primaryColor\">\r\n            {{ 'PIM.COMPLETED' | transloco }} : {{ completionPercent }} %\r\n          </h4>\r\n        </div>\r\n        <div *ngIf=\"showDiscontinueDate\">\r\n          <h4 class=\"no-margin-top product-details-primaryDarkerColor\">\r\n            {{ 'PIM.DISCONTINUED' | transloco }} :\r\n            {{ productForm.value.discontinueDate | date : dateFormat.format }}\r\n          </h4>\r\n        </div>\r\n        <div>\r\n          <h4 class=\"no-margin-top product-details-primaryColor\">\r\n            {{ 'PIM.PRODUCT_ID' | transloco }} #{{ productForm.value.sku }}\r\n          </h4>\r\n        </div>\r\n      </div>\r\n    </div>\r\n    <!-- #endregion -->\r\n\r\n    <!--#region Header Panel-->\r\n\r\n    <div class=\"horizontal-flow space-between-025 toolbar space-before-250\">\r\n      <button\r\n        pButton\r\n        *ngIf=\"authorizedActions.edit\"\r\n        class=\"ds tertiary small\"\r\n        type=\"button\"\r\n        label=\"{{ 'ACTIONS.EDIT' | transloco }}\"\r\n        [disabled]=\"isEditable\"\r\n        (click)=\"editClicked()\"\r\n      ></button>\r\n\r\n      <button\r\n        pButton\r\n        *ngIf=\"authorizedActions.new || authorizedActions.edit\"\r\n        class=\"ds tertiary small\"\r\n        type=\"button\"\r\n        label=\"{{ 'ACTIONS.CANCEL' | transloco }}\"\r\n        [disabled]=\"!isEditable\"\r\n        (click)=\"cancelClicked()\"\r\n      ></button>\r\n\r\n      <button\r\n        pButton\r\n        *ngIf=\"authorizedActions.new || authorizedActions.edit\"\r\n        class=\"ds tertiary small\"\r\n        label=\"{{ 'ACTIONS.SAVE' | transloco }}\"\r\n        type=\"submit\"\r\n        [disabled]=\"!isEditable || !productForm.valid\"\r\n      ></button>\r\n\r\n      <button\r\n        pButton\r\n        class=\"ds tertiary small\"\r\n        type=\"button\"\r\n        label=\"{{ 'ACTIONS.BACK_TO_SEARCH' | transloco }}\"\r\n        (click)=\"backClicked()\"\r\n      ></button>\r\n    </div>\r\n\r\n    <!-- #endregion -->\r\n\r\n    <!--#region Body-->\r\n    <div>\r\n      <p-tabView (onChange)=\"handleChange($event)\" [activeIndex]=\"activeIndex\">\r\n        <p-tabPanel\r\n          [header]=\"fieldCategory.categoryName\"\r\n          *ngFor=\"let fieldCategory of fieldCategories; let i = index\"\r\n          [selected]=\"i == 0\"\r\n          [cache]=\"false\"\r\n        >\r\n          <ng-template pTemplate=\"content\">\r\n            <div>\r\n              <!-- #region Template B-->\r\n              <ng-container *ngIf=\"templateB === true\">\r\n                <lib-template-b\r\n                  [form]=\"productForm\"\r\n                  [productDetails]=\"productDetails\"\r\n                  [dropDownData]=\"dropDownData\"\r\n                  [suggestedHierarchyData]=\"suggestedHierarchy\"\r\n                  [productHierarchies]=\"productHierarchies\"\r\n                  [cols]=\"cols\"\r\n                  [dateFormat]=\"dateFormat\"\r\n                  [timeFormat]=\"timeFormat\"\r\n                  [isEditable]=\"isEditable\"\r\n                  [users]=\"users\"\r\n                ></lib-template-b>\r\n              </ng-container>\r\n              <!-- #endregion -->\r\n              <!-- #region Template C-->\r\n              <ng-container *ngIf=\"templateC === true\">\r\n                <lib-template-c\r\n                  [form]=\"productForm\"\r\n                  [productDetails]=\"productDetails\"\r\n                  [dropDownData]=\"dropDownData\"\r\n                  [cols]=\"cols\"\r\n                  [dateFormat]=\"dateFormat\"\r\n                  [timeFormat]=\"timeFormat\"\r\n                  [isEditable]=\"isEditable\"\r\n                  [users]=\"users\"\r\n                ></lib-template-c>\r\n              </ng-container>\r\n              <!-- #endregion -->\r\n              <!--#region Template D-->\r\n              <ng-container *ngIf=\"templateD === true\">\r\n                <lib-template-d\r\n                  [form]=\"productForm\"\r\n                  [productDetails]=\"productDetails\"\r\n                  [dropDownData]=\"dropDownData\"\r\n                  [cols]=\"cols\"\r\n                  [imageTypes]=\"imageTypes\"\r\n                  [videoTypes]=\"videoTypes\"\r\n                  [documentTypes]=\"documentTypes\"\r\n                  [dateFormat]=\"dateFormat\"\r\n                  [timeFormat]=\"timeFormat\"\r\n                  [isEditable]=\"isEditable\"\r\n                  [assetPermissions]=\"\r\n                    authorizedActions.maintainAssets || authorizedActions.edit\r\n                  \"\r\n                  [assetURL]=\"uploadAssetsUrl\"\r\n                  (assetEvent)=\"assetEventHandler($event)\"\r\n                ></lib-template-d>\r\n              </ng-container>\r\n            </div>\r\n          </ng-template>\r\n        </p-tabPanel>\r\n      </p-tabView>\r\n    </div>\r\n    <p-confirmDialog [closable]=\"false\" [closeOnEscape]=\"false\"></p-confirmDialog>\r\n    <!-- #endregion -->\r\n  </div>\r\n</form>\r\n\r\n<p-confirmDialog deactivateDialog [closeOnEscape]=\"false\" [closable]=\"false\"></p-confirmDialog>\r\n",
                styles: [""]
            },] }
];
ProductDetailsComponent.ctorParameters = () => [
    { type: ActivatedRoute },
    { type: ProductDetailsService },
    { type: GetHierarchyService },
    { type: PimService },
    { type: ConfirmationService$1 },
    { type: Router },
    { type: ToastrNotificationService$1 },
    { type: LoggerService },
    { type: TranslocoService },
    { type: Store },
    { type: SpinnerService$1 },
    { type: PimAPIService }
];
ProductDetailsComponent.propDecorators = {
    videoPlayer: [{ type: ViewChild, args: ['videoPlayer',] }],
    form: [{ type: ViewChild, args: ['form',] }]
};

class SupplierInputComponent {
    constructor(translocoSrv, confirmationService) {
        this.translocoSrv = translocoSrv;
        this.confirmationService = confirmationService;
        this.isTransient = true;
    }
    writeValue(obj) {
        this.currentValue = obj;
        this.savedValue = obj;
    }
    registerOnChange(fn) {
        this.onChange = fn;
    }
    registerOnTouched(fn) {
        this.onTouched = fn;
    }
    setDisabledState(isDisabled) {
        this.disabled = isDisabled;
    }
    setSupplier(value) {
        if (this.isTransient) {
            this.savedValue = value;
            this.change(value);
        }
        else if (this.savedValue !== value) {
            this.confirmationService.confirm({
                header: this.translocoSrv.translate('ACTIONS.CONFIRM'),
                message: this.translocoSrv.translate('PIM.PRODUCT_DETAILS_CHANGE_SUPPLIER'),
                icon: 'pi pi-exclamation-triangle',
                accept: () => {
                    this.change(value);
                    this.currentValue = value;
                },
                reject: () => {
                    this.currentValue = this.savedValue;
                },
            });
        }
    }
    onClick() {
        this.onTouched();
    }
    change(value) {
        if (this.onChange) {
            this.onChange(value);
        }
    }
}
SupplierInputComponent.decorators = [
    { type: Component, args: [{
                selector: 'lib-supplier-input',
                template: "<p-dropdown\r\n  [options]=\"suppliers\"\r\n  [placeholder]=\"'ACTIONS.SELECT' | transloco\"\r\n  [disabled]=\"disabled\"\r\n  [(ngModel)]=\"currentValue\"\r\n  (ngModelChange)=\"setSupplier($event)\"\r\n  (onClick)=\"onClick()\"\r\n  filter=\"true\"\r\n  filterBy=\"label,number\"\r\n>\r\n  <ng-template let-item pTemplate=\"selectedItem\">\r\n    <span>{{ item.label }}</span>\r\n  </ng-template>\r\n  <ng-template let-obj pTemplate=\"item\">\r\n    <div class=\"ui-helper-clearfix product-details-dropdown-div\">\r\n      <div class=\"product-details-dropdown-left-div\">\r\n        {{ obj.label }}\r\n      </div>\r\n      <div class=\"product-details-dropdown-right-div\">\r\n        {{ obj.number }}\r\n      </div>\r\n    </div>\r\n  </ng-template>\r\n</p-dropdown>\r\n",
                providers: [
                    {
                        provide: NG_VALUE_ACCESSOR,
                        multi: true,
                        useExisting: SupplierInputComponent,
                    },
                ],
                styles: [""]
            },] }
];
SupplierInputComponent.ctorParameters = () => [
    { type: TranslocoService },
    { type: ConfirmationService }
];
SupplierInputComponent.propDecorators = {
    suppliers: [{ type: Input }],
    isTransient: [{ type: Input }]
};

class TemplateBComponent {
    constructor() {
        this.fieldMap = ProductFieldEnumMap;
        this.nonFeatures = [];
        this.showFeatures = false;
        this.warningLabels = [[], []];
        this.ratingLabels = [[], []];
        this.showWarningLabels = false;
        this.showRatingLabels = false;
        /** empty block */
    }
    ngOnInit() {
        /** empty block */
    }
    ngOnChanges() {
        this.getTemplateBData(this.cols);
    }
    getTemplateBData(cols) {
        this.nonFeatures = [];
        this.features = [[], []];
        this.showFeatures = false;
        this.warningLabels = [[], []];
        this.showWarningLabels = false;
        this.ratingLabels = [[], []];
        this.showRatingLabels = false;
        let featureCount = 0;
        for (const c of cols) {
            if (c.dataTypeKey === 3) {
                this.features[featureCount++ % 2].push(c);
                this.showFeatures = true;
            }
            else if (c.fieldKey === ProductFieldsEnum.warningLabel) {
                this.warningLabels[0].push(c);
                this.showWarningLabels = true;
            }
            else if (c.fieldKey === ProductFieldsEnum.warningLabelDescription) {
                this.warningLabels[1].push(c);
                this.showWarningLabels = true;
            }
            else if (c.fieldKey === ProductFieldsEnum.ratingLabel) {
                this.ratingLabels[0].push(c);
                this.showRatingLabels = true;
            }
            else if (c.fieldKey === ProductFieldsEnum.ratingLabelDescription) {
                this.ratingLabels[1].push(c);
                this.showRatingLabels = true;
            }
            else {
                this.nonFeatures.push(c);
            }
        }
        this.nonFeatures.sort((a, b) => {
            if (a.fieldKey === ProductFieldsEnum.suggestedHierarchy) {
                return -1;
            }
            else if (b.fieldKey === ProductFieldsEnum.suggestedHierarchy) {
                return 1;
            }
            return 0;
        });
    }
}
TemplateBComponent.decorators = [
    { type: Component, args: [{
                selector: 'lib-template-b',
                template: "<lib-product-details-basic\r\n  [form]=\"form\"\r\n  [productDetails]=\"productDetails\"\r\n  [suggestedHierarchyData]=\"suggestedHierarchyData\"\r\n  [productHierarchies]=\"productHierarchies\"\r\n  [dropDownData]=\"dropDownData\"\r\n  [cols]=\"nonFeatures\"\r\n  [dateFormat]=\"dateFormat\"\r\n  [timeFormat]=\"timeFormat\"\r\n  [isEditable]=\"isEditable\"\r\n  [users]=\"users\"\r\n></lib-product-details-basic>\r\n<div class=\"vertical-flow\" *ngIf=\"showRatingLabels === true\">\r\n  <div class=\"product-details header brand-light-grey-bg\">\r\n    <div>\r\n      <p class=\"lbmx-h4\">\r\n        {{ 'PIM.PRODUCT_DETAILS_RATING_LABELS' | transloco }}\r\n      </p>\r\n    </div>\r\n  </div>\r\n  <div class=\"tile-050\">\r\n    <div>\r\n      <lib-product-details-basic\r\n        [form]=\"form\"\r\n        [productDetails]=\"productDetails\"\r\n        [dropDownData]=\"dropDownData\"\r\n        [cols]=\"ratingLabels[0]\"\r\n        [dateFormat]=\"dateFormat\"\r\n        [timeFormat]=\"timeFormat\"\r\n        [isEditable]=\"isEditable\"\r\n        [template]=\"true\"\r\n        [users]=\"users\"\r\n      ></lib-product-details-basic>\r\n    </div>\r\n    <div>\r\n      <lib-product-details-basic\r\n        [form]=\"form\"\r\n        [productDetails]=\"productDetails\"\r\n        [dropDownData]=\"dropDownData\"\r\n        [cols]=\"ratingLabels[1]\"\r\n        [dateFormat]=\"dateFormat\"\r\n        [timeFormat]=\"timeFormat\"\r\n        [isEditable]=\"isEditable\"\r\n        [template]=\"true\"\r\n        [users]=\"users\"\r\n      ></lib-product-details-basic>\r\n    </div>\r\n  </div>\r\n</div>\r\n<div class=\"vertical-flow\" *ngIf=\"showWarningLabels === true\">\r\n  <div class=\"product-details header brand-light-grey-bg\">\r\n    <div>\r\n      <p class=\"lbmx-h4\">\r\n        {{ 'PIM.PRODUCT_DETAILS_WARNING_LABELS' | transloco }}\r\n      </p>\r\n    </div>\r\n  </div>\r\n  <div class=\"tile-050\">\r\n    <div>\r\n      <lib-product-details-basic\r\n        [form]=\"form\"\r\n        [productDetails]=\"productDetails\"\r\n        [dropDownData]=\"dropDownData\"\r\n        [cols]=\"warningLabels[0]\"\r\n        [dateFormat]=\"dateFormat\"\r\n        [timeFormat]=\"timeFormat\"\r\n        [isEditable]=\"isEditable\"\r\n        [template]=\"true\"\r\n        [users]=\"users\"\r\n      ></lib-product-details-basic>\r\n    </div>\r\n    <div>\r\n      <lib-product-details-basic\r\n        [form]=\"form\"\r\n        [productDetails]=\"productDetails\"\r\n        [dropDownData]=\"dropDownData\"\r\n        [cols]=\"warningLabels[1]\"\r\n        [dateFormat]=\"dateFormat\"\r\n        [timeFormat]=\"timeFormat\"\r\n        [isEditable]=\"isEditable\"\r\n        [template]=\"true\"\r\n        [users]=\"users\"\r\n      ></lib-product-details-basic>\r\n    </div>\r\n  </div>\r\n</div>\r\n<div class=\"vertical-flow\" *ngIf=\"showFeatures === true\">\r\n  <div class=\"product-details header brand-light-grey-bg\">\r\n    <div>\r\n      <p class=\"lbmx-h4\">{{ 'PIM.PRODUCT_DETAILS_FEATURES' | transloco }}</p>\r\n    </div>\r\n  </div>\r\n  <div class=\"tile-050\">\r\n    <div>\r\n      <lib-product-details-basic\r\n        [form]=\"form\"\r\n        [productDetails]=\"productDetails\"\r\n        [dropDownData]=\"dropDownData\"\r\n        [cols]=\"features[0]\"\r\n        [dateFormat]=\"dateFormat\"\r\n        [timeFormat]=\"timeFormat\"\r\n        [isEditable]=\"isEditable\"\r\n        [template]=\"true\"\r\n        [users]=\"users\"\r\n      ></lib-product-details-basic>\r\n    </div>\r\n    <div>\r\n      <lib-product-details-basic\r\n        [form]=\"form\"\r\n        [productDetails]=\"productDetails\"\r\n        [dropDownData]=\"dropDownData\"\r\n        [cols]=\"features[1]\"\r\n        [dateFormat]=\"dateFormat\"\r\n        [timeFormat]=\"timeFormat\"\r\n        [isEditable]=\"isEditable\"\r\n        [template]=\"true\"\r\n        [users]=\"users\"\r\n      ></lib-product-details-basic>\r\n    </div>\r\n  </div>\r\n</div>\r\n",
                styles: [""]
            },] }
];
TemplateBComponent.ctorParameters = () => [];
TemplateBComponent.propDecorators = {
    productDetails: [{ type: Input }],
    dropDownData: [{ type: Input }],
    cols: [{ type: Input }],
    form: [{ type: Input }],
    dateFormat: [{ type: Input }],
    timeFormat: [{ type: Input }],
    isEditable: [{ type: Input }],
    users: [{ type: Input }],
    suggestedHierarchyData: [{ type: Input }],
    productHierarchies: [{ type: Input }]
};

class TemplateCComponent {
    constructor() {
        this.ProductFieldEnum = ProductFieldsEnum;
        this.ProductFieldEnumMap = ProductFieldEnumMap;
        this.DataTypeEnum = DataTypeEnum;
        this.Type = Type;
        this.otherDimensions = [];
        this.masterPack1 = [];
        this.masterPack2 = [];
        this.consumerPack1 = [];
        this.consumerPack2 = [];
        this.consumerItem1 = [];
        this.consumerItem2 = [];
        this.palletInfo1 = [];
        this.palletInfo2 = [];
        this.showMasterPack = false;
        this.showPalletInfo = false;
        this.showConsumerInfo = false;
        this.showConsumerItemInfo = false;
        this.masterPackOrder = [
            ProductFieldsEnum.masterPackCaseHeight,
            ProductFieldsEnum.masterPackCaseHeightUOM,
            ProductFieldsEnum.masterPackCaseLength,
            ProductFieldsEnum.masterPackCaseLengthUOM,
            ProductFieldsEnum.masterPackCaseVolume,
            ProductFieldsEnum.masterPackCaseVolumeUOM,
            ProductFieldsEnum.masterPackCaseWeight,
            ProductFieldsEnum.masterPackCaseWeightUOM,
            ProductFieldsEnum.masterPackCaseWidth,
            ProductFieldsEnum.masterPackCaseWidthUOM,
            ProductFieldsEnum.masterPackCaseQuantity,
            ProductFieldsEnum.masterPackCaseUOM,
        ];
        this.consumerPackOrder = [
            ProductFieldsEnum.consumerPackageDepth,
            ProductFieldsEnum.consumerPackageDepthUOM,
            ProductFieldsEnum.consumerPackageHeight,
            ProductFieldsEnum.consumerPackageHeightUOM,
            ProductFieldsEnum.consumerPackageLength,
            ProductFieldsEnum.consumerPackageLengthUOM,
            ProductFieldsEnum.consumerPackageVolume,
            ProductFieldsEnum.consumerPackageVolumeUOM,
            ProductFieldsEnum.consumerPackageWeight,
            ProductFieldsEnum.consumerPackageWeightUOM,
            ProductFieldsEnum.consumerPackageWidth,
            ProductFieldsEnum.consumerPackageWidthUOM,
            ProductFieldsEnum.consumerPackageQuantity,
            ProductFieldsEnum.consumerPackageUOM,
        ];
        this.consumerItemOrder = [
            ProductFieldsEnum.consumerItemDepth,
            ProductFieldsEnum.consumerItemDepthUom,
            ProductFieldsEnum.consumerItemGrossWeight,
            ProductFieldsEnum.consumerItemGrossWeightUom,
            ProductFieldsEnum.consumerItemHeight,
            ProductFieldsEnum.consumerItemHeightUom,
            ProductFieldsEnum.consumerItemLength,
            ProductFieldsEnum.consumerItemLengthUom,
            ProductFieldsEnum.consumerItemNetWeight,
            ProductFieldsEnum.consumerItemNetWeightUom,
            ProductFieldsEnum.consumerItemWidth,
            ProductFieldsEnum.consumerItemWidthUom,
        ];
        this.palletInfoOrder = [
            ProductFieldsEnum.palletInformationHeight,
            ProductFieldsEnum.palletInformationHeightUOM,
            ProductFieldsEnum.palletInformationLength,
            ProductFieldsEnum.palletInformationLengthUOM,
            ProductFieldsEnum.palletInformationVolume,
            ProductFieldsEnum.palletInformationVolumeUOM,
            ProductFieldsEnum.palletInformationWeight,
            ProductFieldsEnum.palletInformationWeightUOM,
            ProductFieldsEnum.palletInformationWidth,
            ProductFieldsEnum.palletInformationWidthUOM,
            ProductFieldsEnum.palletInformationNumberofCases,
            ProductFieldsEnum.palletInformationNumberofRows,
            ProductFieldsEnum.palletInformationBlocks,
            ProductFieldsEnum.palletInformationUOM,
        ];
        /**
         * Empty
         */
    }
    ngOnChanges() {
        this.getTemplateCData(this.cols);
    }
    ngOnInit() {
        /** empty block */
    }
    getTemplateCData(cols) {
        const fieldsArr = Object.values(this.ProductFieldEnum).map((e, i) => ({
            name: e.toString(),
            value: i + 1,
        }));
        const masterPack = cols
            .filter((col) => fieldsArr
            .filter((f) => f.name.startsWith('masterPack'))
            .find((f) => col.fieldKey === f.value))
            .sort((a, b) => this.masterPackOrder.indexOf(a.fieldKey) -
            this.masterPackOrder.indexOf(b.fieldKey));
        const consumerPack = cols
            .filter((col) => fieldsArr
            .filter((f) => f.name.startsWith('consumerPack'))
            .find((f) => col.fieldKey === f.value))
            .sort((a, b) => this.consumerPackOrder.indexOf(a.fieldKey) -
            this.consumerPackOrder.indexOf(b.fieldKey));
        const consumerItem = cols
            .filter((col) => fieldsArr
            .filter((f) => f.name.startsWith('consumerItem'))
            .find((f) => col.fieldKey === f.value))
            .sort((a, b) => this.consumerItemOrder.indexOf(a.fieldKey) -
            this.consumerItemOrder.indexOf(b.fieldKey));
        const palletInfo = cols
            .filter((col) => fieldsArr
            .filter((f) => f.name.startsWith('palletInformation'))
            .find((f) => col.fieldKey === f.value))
            .sort((a, b) => this.palletInfoOrder.indexOf(a.fieldKey) -
            this.palletInfoOrder.indexOf(b.fieldKey));
        this.otherDimensions = cols.filter((col) => col.fieldKey === this.ProductFieldEnum.innerPackQty ||
            col.fieldKey === this.ProductFieldEnum.outerPackQty ||
            col.fieldKey === this.ProductFieldEnum.gaugeDimension ||
            col.fieldKey === this.ProductFieldEnum.gaugeDimensionUOM);
        if (masterPack.length !== 0) {
            this.showMasterPack = true;
            [this.masterPack1, this.masterPack2, this.masterPackCaseUPC] =
                this.splitDimension(masterPack, this.ProductFieldEnum.masterPackCaseUPC);
        }
        if (consumerPack.length !== 0) {
            this.showConsumerInfo = true;
            [this.consumerPack1, this.consumerPack2, this.consumerPackUPC] =
                this.splitDimension(consumerPack, this.ProductFieldEnum.consumerPackageUPC);
        }
        if (consumerItem.length !== 0) {
            this.showConsumerItemInfo = true;
            [this.consumerItem1, this.consumerItem2] = this.bifrucate(consumerItem);
        }
        if (palletInfo.length !== 0) {
            this.showPalletInfo = true;
            [this.palletInfo1, this.palletInfo2, this.palletInfoUPC] =
                this.splitDimension(palletInfo, this.ProductFieldEnum.palletInformationUPC);
        }
    }
    splitDimension(arr, field) {
        const [a, v] = this.pluck(arr, (f) => f.fieldKey === field);
        const [a1, a2] = this.bifrucate(a);
        return [a1, a2, v];
    }
    pluck(arr, selector) {
        return arr.reduce(([rest, plucked], val) => selector(val) ? [[...rest], val] : [[...rest, val], plucked], [[], null]);
    }
    bifrucate(arr) {
        return arr.reduce((acc, v, i) => {
            acc[i % 2] = [...acc[i % 2], v];
            return acc;
        }, [[], []]);
    }
}
TemplateCComponent.decorators = [
    { type: Component, args: [{
                selector: 'lib-template-c',
                template: "<lib-product-details-basic\r\n  [form]=\"form\"\r\n  [productDetails]=\"productDetails\"\r\n  [dropDownData]=\"dropDownData\"\r\n  [cols]=\"otherDimensions\"\r\n  [dateFormat]=\"dateFormat\"\r\n  [timeFormat]=\"timeFormat\"\r\n  [isEditable]=\"isEditable\"\r\n  [users]=\"users\"\r\n></lib-product-details-basic>\r\n<div class=\"vertical-flow\" *ngIf=\"showMasterPack === true\">\r\n  <div class=\"product-details header brand-light-grey-bg\">\r\n    <div>\r\n      <p class=\"lbmx-h4\">{{ 'PIM.PRODUCT_DETAILS_MASTERPACK' | transloco }}</p>\r\n    </div>\r\n  </div>\r\n  <lib-product-details-basic\r\n    *ngIf=\"masterPackCaseUPC\"\r\n    [form]=\"form\"\r\n    [productDetails]=\"productDetails\"\r\n    [dropDownData]=\"dropDownData\"\r\n    [cols]=\"[masterPackCaseUPC]\"\r\n    [dateFormat]=\"dateFormat\"\r\n    [timeFormat]=\"timeFormat\"\r\n    [isEditable]=\"isEditable\"\r\n    [users]=\"users\"\r\n  ></lib-product-details-basic>\r\n  <div class=\"tile-050\">\r\n    <div>\r\n      <lib-product-details-basic\r\n        [form]=\"form\"\r\n        [productDetails]=\"productDetails\"\r\n        [dropDownData]=\"dropDownData\"\r\n        [cols]=\"masterPack1\"\r\n        [dateFormat]=\"dateFormat\"\r\n        [timeFormat]=\"timeFormat\"\r\n        [isEditable]=\"isEditable\"\r\n        [template]=\"true\"\r\n        [users]=\"users\"\r\n      ></lib-product-details-basic>\r\n    </div>\r\n    <div>\r\n      <lib-product-details-basic\r\n        [form]=\"form\"\r\n        [productDetails]=\"productDetails\"\r\n        [dropDownData]=\"dropDownData\"\r\n        [cols]=\"masterPack2\"\r\n        [dateFormat]=\"dateFormat\"\r\n        [timeFormat]=\"timeFormat\"\r\n        [isEditable]=\"isEditable\"\r\n        [template]=\"true\"\r\n        [users]=\"users\"\r\n      ></lib-product-details-basic>\r\n    </div>\r\n  </div>\r\n</div>\r\n<div class=\"vertical-flow\" *ngIf=\"showConsumerInfo === true\">\r\n  <div class=\"product-details header brand-light-grey-bg\">\r\n    <div>\r\n      <p class=\"lbmx-h4\">{{ 'PIM.PRODUCT_DETAILS_CONSUMERPACKAGE' | transloco }}</p>\r\n    </div>\r\n  </div>\r\n  <lib-product-details-basic\r\n    *ngIf=\"consumerPackUPC\"\r\n    [form]=\"form\"\r\n    [productDetails]=\"productDetails\"\r\n    [dropDownData]=\"dropDownData\"\r\n    [cols]=\"[consumerPackUPC]\"\r\n    [dateFormat]=\"dateFormat\"\r\n    [timeFormat]=\"timeFormat\"\r\n    [isEditable]=\"isEditable\"\r\n    [users]=\"users\"\r\n  ></lib-product-details-basic>\r\n  <div class=\"tile-050\">\r\n    <div>\r\n      <lib-product-details-basic\r\n        [form]=\"form\"\r\n        [productDetails]=\"productDetails\"\r\n        [dropDownData]=\"dropDownData\"\r\n        [cols]=\"consumerPack1\"\r\n        [dateFormat]=\"dateFormat\"\r\n        [timeFormat]=\"timeFormat\"\r\n        [isEditable]=\"isEditable\"\r\n        [template]=\"true\"\r\n        [users]=\"users\"\r\n      ></lib-product-details-basic>\r\n    </div>\r\n    <div>\r\n      <lib-product-details-basic\r\n        [form]=\"form\"\r\n        [productDetails]=\"productDetails\"\r\n        [dropDownData]=\"dropDownData\"\r\n        [cols]=\"consumerPack2\"\r\n        [dateFormat]=\"dateFormat\"\r\n        [timeFormat]=\"timeFormat\"\r\n        [isEditable]=\"isEditable\"\r\n        [template]=\"true\"\r\n        [users]=\"users\"\r\n      ></lib-product-details-basic>\r\n    </div>\r\n  </div>\r\n</div>\r\n\r\n<div class=\"vertical-flow\" *ngIf=\"showConsumerItemInfo === true\">\r\n  <div class=\"product-details header brand-light-grey-bg\">\r\n    <div>\r\n      <p class=\"lbmx-h4\">{{ 'PIM.PRODUCT_DETAILS_CONSUMERITEM' | transloco }}</p>\r\n    </div>\r\n  </div>\r\n  <div class=\"tile-050\">\r\n    <div>\r\n      <lib-product-details-basic\r\n        [form]=\"form\"\r\n        [productDetails]=\"productDetails\"\r\n        [dropDownData]=\"dropDownData\"\r\n        [cols]=\"consumerItem1\"\r\n        [dateFormat]=\"dateFormat\"\r\n        [timeFormat]=\"timeFormat\"\r\n        [isEditable]=\"isEditable\"\r\n        [template]=\"true\"\r\n        [users]=\"users\"\r\n      ></lib-product-details-basic>\r\n    </div>\r\n    <div>\r\n      <lib-product-details-basic\r\n        [form]=\"form\"\r\n        [productDetails]=\"productDetails\"\r\n        [dropDownData]=\"dropDownData\"\r\n        [cols]=\"consumerItem2\"\r\n        [dateFormat]=\"dateFormat\"\r\n        [timeFormat]=\"timeFormat\"\r\n        [isEditable]=\"isEditable\"\r\n        [template]=\"true\"\r\n        [users]=\"users\"\r\n      ></lib-product-details-basic>\r\n    </div>\r\n  </div>\r\n</div>\r\n<div class=\"vertical-flow\" *ngIf=\"showPalletInfo === true\">\r\n  <div class=\"product-details header brand-light-grey-bg\">\r\n    <div>\r\n      <p class=\"lbmx-h4\">{{ 'PIM.PRODUCT_DETAILS_PALLETINFO' | transloco }}</p>\r\n    </div>\r\n  </div>\r\n  <lib-product-details-basic\r\n    *ngIf=\"palletInfoUPC\"\r\n    [form]=\"form\"\r\n    [productDetails]=\"productDetails\"\r\n    [dropDownData]=\"dropDownData\"\r\n    [cols]=\"[palletInfoUPC]\"\r\n    [dateFormat]=\"dateFormat\"\r\n    [timeFormat]=\"timeFormat\"\r\n    [isEditable]=\"isEditable\"\r\n    [users]=\"users\"\r\n  ></lib-product-details-basic>\r\n  <div class=\"tile-050\">\r\n    <div>\r\n      <lib-product-details-basic\r\n        [form]=\"form\"\r\n        [productDetails]=\"productDetails\"\r\n        [dropDownData]=\"dropDownData\"\r\n        [cols]=\"palletInfo1\"\r\n        [dateFormat]=\"dateFormat\"\r\n        [timeFormat]=\"timeFormat\"\r\n        [isEditable]=\"isEditable\"\r\n        [template]=\"true\"\r\n        [users]=\"users\"\r\n      ></lib-product-details-basic>\r\n    </div>\r\n    <div>\r\n      <lib-product-details-basic\r\n        [form]=\"form\"\r\n        [productDetails]=\"productDetails\"\r\n        [dropDownData]=\"dropDownData\"\r\n        [cols]=\"palletInfo2\"\r\n        [dateFormat]=\"dateFormat\"\r\n        [timeFormat]=\"timeFormat\"\r\n        [isEditable]=\"isEditable\"\r\n        [template]=\"true\"\r\n        [users]=\"users\"\r\n      ></lib-product-details-basic>\r\n    </div>\r\n  </div>\r\n</div>\r\n",
                styles: [""]
            },] }
];
TemplateCComponent.ctorParameters = () => [];
TemplateCComponent.propDecorators = {
    productDetails: [{ type: Input }],
    dropDownData: [{ type: Input }],
    cols: [{ type: Input }],
    form: [{ type: Input }],
    dateFormat: [{ type: Input }],
    timeFormat: [{ type: Input }],
    isEditable: [{ type: Input }],
    users: [{ type: Input }]
};

class AssetService {
    constructor(productDetailsSrv, translocoSrv, toasterSrv, loggerSrv) {
        this.productDetailsSrv = productDetailsSrv;
        this.translocoSrv = translocoSrv;
        this.toasterSrv = toasterSrv;
        this.loggerSrv = loggerSrv;
        this.assetEvent = new EventEmitter();
        this.subscriptions = [];
    }
    ngOnDestroy() {
        if (this.subscriptions) {
            this.subscriptions.forEach((subscription) => subscription.unsubscribe());
        }
    }
    onAssetUpload(event, type, form) {
        const newAsset = {
            filename: event.files[0].name,
            isAvailable: true,
            name: event.files[0].name.split('.')[0],
        };
        if (type === Templates.PRIMARYIMAGE) {
            form.patchValue({ primaryImage: newAsset });
        }
        else if (type === Templates.SECONDARYIMAGE) {
            const index = form.value.secondaryImages.findIndex((x) => !x.filename);
            form.value.secondaryImages.splice(index, 1);
            const temp = form.value.secondaryImages;
            temp.splice(index, 0, newAsset);
            form.patchValue({ secondaryImages: temp });
        }
        else if (type === Templates.VIDEOS) {
            const index = form.value.videos.findIndex((x) => !x.filename);
            form.value.videos.splice(index, 1);
            const temp = form.value.videos;
            temp.splice(index, 0, newAsset);
            form.patchValue({ videos: temp });
        }
        else if (type === Templates.DOCUMENTS) {
            const index = form.value.documents.findIndex((x) => !x.filename);
            form.value.documents.splice(index, 1);
            const temp = form.value.documents;
            temp.splice(index, 0, newAsset);
            form.patchValue({ documents: temp });
        }
        this.toasterSrv.infoNotify(this.translocoSrv.translate('PIM.FILE_UPLOAD'));
        return form;
    }
    onAssetSelect(event, selectedAssetTypes) {
        const fileExtension = event.files[0].name.split('.')[1].toLowerCase();
        const invalidMessage = this.translocoSrv.translate('PIM.INVALID_FORMAT_MSG');
        if (!selectedAssetTypes.includes(fileExtension)) {
            this.toasterSrv.errorNotify(invalidMessage + selectedAssetTypes);
        }
    }
    confirmAssetDelete(type, asset, form) {
        let imageIndex = 0;
        if (type === Templates.PRIMARYIMAGE || type === Templates.SECONDARYIMAGE) {
            if (type === Templates.PRIMARYIMAGE) {
                form.patchValue({
                    primaryImage: { name: '', filename: '', isAvailable: false },
                });
            }
            else {
                imageIndex = form.value.secondaryImages.findIndex((x) => x.filename === asset.filename && x.name === asset.name);
                const temp = form.value.secondaryImages;
                temp.splice(imageIndex, 1);
                temp.push({ name: '', filename: '' });
                form.patchValue({ secondaryImages: temp });
            }
        }
        else if (type === Templates.VIDEOS) {
            const videoIndex = form.value.videos.findIndex((x) => x.filename === asset.filename && x.name === asset.name);
            const temp = form.value.videos;
            temp.splice(videoIndex, 1);
            temp.push({ name: '', filename: '' });
            form.patchValue({ videos: temp });
        }
        else if (type === Templates.DOCUMENTS) {
            const docIndex = form.value.documents.findIndex((x) => x.filename === asset.filename && x.name === asset.name);
            const temp = form.value.documents;
            temp.splice(docIndex, 1);
            temp.push({ name: '', filename: '' });
            form.patchValue({ documents: temp });
        }
        return form;
    }
    download(assetName, supplierKey) {
        this.subscriptions.push(this.productDetailsSrv.getAssetUrl(supplierKey, assetName).subscribe((url) => {
            saveAs(url, assetName);
        }, (err) => {
            this.loggerSrv.error('Error downloading', 'ProductDetailsService.getAssetUrl', err);
        }));
    }
}
AssetService.ɵprov = ɵɵdefineInjectable({ factory: function AssetService_Factory() { return new AssetService(ɵɵinject(ProductDetailsService), ɵɵinject(TranslocoService), ɵɵinject(ToastrNotificationService$1), ɵɵinject(LoggerService)); }, token: AssetService, providedIn: "root" });
AssetService.decorators = [
    { type: Injectable, args: [{
                providedIn: 'root',
            },] }
];
AssetService.ctorParameters = () => [
    { type: ProductDetailsService },
    { type: TranslocoService },
    { type: ToastrNotificationService$1 },
    { type: LoggerService }
];
AssetService.propDecorators = {
    assetEvent: [{ type: Output }]
};

class DocumentRendererComponent {
    constructor(productDetailsSrv, translocoSrv, toasterSrv, confirmationService, assetSrv, spinnerService) {
        this.productDetailsSrv = productDetailsSrv;
        this.translocoSrv = translocoSrv;
        this.toasterSrv = toasterSrv;
        this.confirmationService = confirmationService;
        this.assetSrv = assetSrv;
        this.spinnerService = spinnerService;
        this.assetEvent = new EventEmitter();
        this.disabled = false;
    }
    ngOnInit() {
        /** empty block */
    }
    ngOnChanges() {
        this.fieldFormControlName = this.productDetailsSrv.getFormControlName(this.col);
        this.formgroup = this.productDetailsSrv.getNestedForm(this.form, this.col, Type.Object);
        if (!this.productDetails.id ||
            this.productDetails.documents.length >= this.col.arrayCount ||
            !this.assetPermissions) {
            this.disabled = true;
        }
        else {
            this.disabled = false;
        }
    }
    upload(event, type) {
        this.form = this.assetSrv.onAssetUpload(event, type, this.form);
        this.assetEvent.emit(this.form.getRawValue());
    }
    confirmAssetDelete(type, asset) {
        this.confirmationService.confirm({
            header: this.translocoSrv.translate('ACTIONS.DELETE'),
            message: this.translocoSrv.translate('PIM.DELETE_ASSET_CONFIRM'),
            accept: () => {
                this.form = this.assetSrv.confirmAssetDelete(type, asset, this.form);
                this.assetEvent.emit(this.form.getRawValue());
            },
        });
    }
    onAssetSelect($event) {
        this.assetSrv.onAssetSelect($event, this.documentTypes);
    }
    showMessage() {
        this.toasterSrv.errorNotify(this.translocoSrv.translate('PIM.DOCUMENT_NOT_AVAILABLE'));
    }
    getDocumentIcon(filename) {
        const fileNameParts = filename.split('.');
        if (fileNameParts[fileNameParts.length - 1].toLowerCase() === 'pdf') {
            return 'assets/images/Acrobatpdf.png';
        }
        else {
            return 'assets/images/Word-doc.png';
        }
    }
    onBeforeUpload($event) {
        // The spinner is turned off when the product is updated successfully
        this.spinnerService.on();
    }
}
DocumentRendererComponent.decorators = [
    { type: Component, args: [{
                selector: 'lib-document-renderer',
                template: "<div class=\"product-details space-before-100\">\r\n  <p-table [value]=\"documents\">\r\n    <ng-template pTemplate=\"header\">\r\n      <tr class=\"table-productdetails\">\r\n        <th>\r\n          <p class=\"lbmx-h4\">\r\n            {{ 'PIM.PRODUCT_DETAILS_DOCUMENTNAME' | transloco }}\r\n          </p>\r\n        </th>\r\n        <th>\r\n          <p class=\"lbmx-h4\">\r\n            {{ 'PIM.PRODUCT_DETAILS_DOCUMENTFILE' | transloco }}\r\n          </p>\r\n        </th>\r\n        <th>\r\n          <p class=\"lbmx-h4\">{{ 'ACTIONS.DELETE' | transloco }}</p>\r\n        </th>\r\n        <th>\r\n          <div class=\"addButtonDocSection\" *ngIf=\"!disabled\">\r\n            <p-fileUpload\r\n              chooseLabel=\"{{ 'ACTIONS.ADD' | transloco }}\"\r\n              styleClass=\"ds tertiary small\"\r\n              [url]=\"uploadAssetsUrl\"\r\n              mode=\"basic\"\r\n              name=\"assets[]\"\r\n              (onUpload)=\"upload($event, 'Document')\"\r\n              (onSelect)=\"onAssetSelect($event)\"\r\n              (onBeforeUpload)=\"onBeforeUpload($event)\"\r\n              [accept]=\"documentTypes\"\r\n              [auto]=\"true\"\r\n              withCredentials=\"true\"\r\n              title=\"\"\r\n            >\r\n            </p-fileUpload>\r\n          </div>\r\n        </th>\r\n      </tr>\r\n    </ng-template>\r\n    <ng-template pTemplate=\"body\" let-doc let-i=\"rowIndex\">\r\n      <tr class=\"table-productdetails\" *ngIf=\"doc.filename\">\r\n        <td *ngIf=\"isEditable === false\">{{ doc.name }}</td>\r\n        <td *ngIf=\"isEditable === true\">\r\n          <ng-container [formGroup]=\"form\">\r\n            <ng-container\r\n              [formArrayName]=\"productDetailsSrv.getNestedFormName(col)\"\r\n              *ngIf=\"\r\n                productDetailsSrv.getNestedFormName(col) !== undefined &&\r\n                isEditable === true\r\n              \"\r\n            >\r\n              <ng-container class=\"row\" [formGroupName]=\"i\">\r\n                <textarea\r\n                  type=\"text\"\r\n                  pInputTextarea\r\n                  [rows]=\"2\"\r\n                  [formControlName]=\"fieldFormControlName\"\r\n                  [cols]=\"29\"\r\n                ></textarea>\r\n              </ng-container>\r\n            </ng-container>\r\n          </ng-container>\r\n        </td>\r\n\r\n        <td *ngIf=\"!doc.isAvailable\">\r\n          <a (click)=\"showMessage()\"\r\n            ><i class=\"pi pi-info-circle pi-info-circle-active padding-right-5\"\r\n            ></i>\r\n            <input\r\n              type=\"image\"\r\n              [src]=\"getDocumentIcon(doc.filename)\"\r\n              class=\"padding-right-5\"\r\n            />{{ doc.filename }}</a\r\n          >\r\n        </td>\r\n        <td *ngIf=\"doc.isAvailable\">\r\n          <a download [href]=\"doc.url\">\r\n            <img\r\n              [src]=\"getDocumentIcon(doc.filename)\"\r\n              class=\"padding-right-5\"\r\n            />\r\n            {{ doc.filename }}\r\n          </a>\r\n        </td>\r\n        <td>\r\n          <div *ngIf=\"!disabled\">\r\n          <button\r\n            pButton\r\n            class=\"ds tertiary small\"\r\n            type=\"button\"\r\n            label=\"{{ 'ACTIONS.DELETE' | transloco }}\"\r\n            (click)=\"confirmAssetDelete('Document', doc)\"\r\n          ></button>\r\n        </div>\r\n        </td>\r\n        <td></td>\r\n      </tr>\r\n    </ng-template>\r\n  </p-table>\r\n</div>\r\n",
                providers: [AssetService],
                styles: [""]
            },] }
];
DocumentRendererComponent.ctorParameters = () => [
    { type: ProductDetailsService },
    { type: TranslocoService },
    { type: ToastrNotificationService$1 },
    { type: ConfirmationService$1 },
    { type: AssetService },
    { type: SpinnerService$1 }
];
DocumentRendererComponent.propDecorators = {
    form: [{ type: Input }],
    uploadAssetsUrl: [{ type: Input }],
    isEditable: [{ type: Input }],
    productDetails: [{ type: Input }],
    col: [{ type: Input }],
    documents: [{ type: Input }],
    documentTypes: [{ type: Input }],
    assetPermissions: [{ type: Input }],
    assetEvent: [{ type: Output }]
};

class ImageRendererComponent {
    constructor(productDetailsSrv, confirmationService, assetSrv, translocoSrv, spinnerService) {
        this.productDetailsSrv = productDetailsSrv;
        this.confirmationService = confirmationService;
        this.assetSrv = assetSrv;
        this.translocoSrv = translocoSrv;
        this.spinnerService = spinnerService;
        this.assetEvent = new EventEmitter();
        this.isImageEnlarged = false;
        this.disabled = false;
    }
    ngOnInit() {
        /** empty block */
    }
    ngOnChanges() {
        this.fieldFormControlName = this.productDetailsSrv.getFormControlName(this.col);
        this.formgroup = this.productDetailsSrv.getNestedForm(this.form, this.col, Type.Object);
        if (this.image && this.image.isAvailable) {
            this.isImagePresent = true;
        }
        else {
            this.isImagePresent = false;
        }
        if (!this.productDetails.id || !this.assetPermissions) {
            this.disabled = true;
        }
        else {
            this.disabled = false;
        }
    }
    imageClick($event, image) {
        $event.preventDefault();
        this.isImageEnlarged = this.isImageEnlarged === true ? false : true;
        this.isEditable = false;
        this.enlargedImage = image;
    }
    upload(event, type) {
        this.form = this.assetSrv.onAssetUpload(event, type, this.form);
        this.assetEvent.emit(this.form.getRawValue());
    }
    confirmAssetDelete(type, asset) {
        this.confirmationService.confirm({
            header: this.translocoSrv.translate('ACTIONS.DELETE'),
            message: this.translocoSrv.translate('PIM.DELETE_ASSET_CONFIRM'),
            accept: () => {
                this.form = this.assetSrv.confirmAssetDelete(type, asset, this.form);
                this.assetEvent.emit(this.form.getRawValue());
            },
        });
    }
    onAssetSelect($event) {
        this.assetSrv.onAssetSelect($event, this.imageTypes);
    }
    onBeforeUpload($event) {
        // The spinner is turned off when the product is updated successfully
        this.spinnerService.on();
    }
}
ImageRendererComponent.decorators = [
    { type: Component, args: [{
                selector: 'lib-image-renderer',
                template: "<div class=\"product-details header brand-light-grey-bg\">\r\n  <div>\r\n    <p class=\"lbmx-h4\">{{ 'PIM.PRODUCT_DETAILS_PRIMARYIMAGE' | transloco }}</p>\r\n  </div>\r\n\r\n  <div class=\"upload\" *ngIf=\"!disabled\">\r\n    <p-fileUpload\r\n      chooseLabel=\"{{\r\n        (isImagePresent ? 'ACTIONS.UPDATE' : 'ACTIONS.ADD') | transloco\r\n      }}\"\r\n      styleClass=\"ds tertiary small\"\r\n      [url]=\"uploadAssetsUrl\"\r\n      mode=\"basic\"\r\n      (onUpload)=\"upload($event, 'Primary')\"\r\n      (onSelect)=\"onAssetSelect($event)\"\r\n      (onBeforeUpload)=\"onBeforeUpload($event)\"\r\n      [accept]=\"imageTypes\"\r\n      [auto]=\"true\"\r\n      withCredentials=\"true\"\r\n      title=\"\"\r\n    >\r\n    </p-fileUpload>\r\n  </div>\r\n</div>\r\n\r\n<div class=\"vertical-flow space-between-100\">\r\n  <div class=\"space-before-025 primary-enlarged-image\">\r\n    <div *ngIf=\"isImageEnlarged === true\">\r\n      <!-- #region Enlarge primary image -->\r\n      <div>\r\n        <input\r\n          type=\"image\"\r\n          [src]=\"enlargedImage.url + '?size=medium'\"\r\n          (click)=\"imageClick($event, enlargedImage)\"\r\n        />\r\n      </div>\r\n      <div>\r\n        <p>\r\n          {{ enlargedImage.name }}\r\n        </p>\r\n      </div>\r\n      <!-- #endregion -->\r\n    </div>\r\n  </div>\r\n\r\n  <div id=\"primary-image\" class=\"product-details image-container-parent\">\r\n    <div class=\"image-container-controls vertical-flow space-between-100\">\r\n      <div class=\"wrapper img-container standard\" *ngIf=\"isImagePresent\">\r\n        <input\r\n          type=\"image\"\r\n          class=\"target\"\r\n          [src]=\"image.url + '?size=small'\"\r\n          (click)=\"imageClick($event, image)\"\r\n        />\r\n        <div *ngIf=\"!disabled\">\r\n          <button\r\n            pButton\r\n            class=\"ds tertiary small control\"\r\n            type=\"button\"\r\n            label=\"{{ 'ACTIONS.DELETE' | transloco }}\"\r\n            *ngIf=\"isImagePresent === true\"\r\n            (click)=\"confirmAssetDelete('Primary', image)\"\r\n          ></button>\r\n        </div>\r\n      </div>\r\n      <div class=\"wrapper asset-not-available\" *ngIf=\"!isImagePresent\">\r\n        <div class=\"defaultImageStyle no-image\">\r\n          <span>\r\n            {{ 'PIM.ASSET' | transloco }}<br />{{ 'PIM.NOT_FOUND' | transloco }}\r\n          </span>\r\n        </div>\r\n      </div>\r\n\r\n      <div *ngIf=\"isEditable === true && isImagePresent === true\">\r\n        <div [formGroup]=\"formgroup\">\r\n          <textarea\r\n            pInputTextarea\r\n            class=\"asset-description\"\r\n            rows=\"2\"\r\n            cols=\"29\"\r\n            [formControlName]=\"fieldFormControlName\"\r\n          ></textarea>\r\n        </div>\r\n      </div>\r\n\r\n      <div class=\"horizontal-flow space-between-100\">\r\n        <div *ngIf=\"isEditable === false && isImagePresent\">\r\n          <a [href]=\"image.url\" download>\r\n            <img src=\"assets/images/downlod_icon.png\" />\r\n          </a>\r\n        </div>\r\n        <div *ngIf=\"isEditable === false\">\r\n          <span class=\"asset-description\">\r\n            {{ image.name }}\r\n          </span>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n",
                providers: [AssetService],
                styles: [""]
            },] }
];
ImageRendererComponent.ctorParameters = () => [
    { type: ProductDetailsService },
    { type: ConfirmationService },
    { type: AssetService },
    { type: TranslocoService },
    { type: SpinnerService$1 }
];
ImageRendererComponent.propDecorators = {
    form: [{ type: Input }],
    uploadAssetsUrl: [{ type: Input }],
    image: [{ type: Input }],
    isEditable: [{ type: Input }],
    productDetails: [{ type: Input }],
    col: [{ type: Input }],
    imageTypes: [{ type: Input }],
    uploadAssetsURL: [{ type: Input }],
    assetPermissions: [{ type: Input }],
    assetEvent: [{ type: Output }]
};

class SecondaryImageRendererComponent {
    constructor(productDetailsSrv, assetSrv, translocoSrv, confirmationService, spinnerService) {
        this.productDetailsSrv = productDetailsSrv;
        this.assetSrv = assetSrv;
        this.translocoSrv = translocoSrv;
        this.confirmationService = confirmationService;
        this.spinnerService = spinnerService;
        this.assetEvent = new EventEmitter();
        this.isImageEnlarged = false;
        this.noImg = false;
        this.disabled = false;
    }
    ngOnInit() {
        /** empty block */
    }
    ngOnChanges() {
        this.fieldFormControlName = this.productDetailsSrv.getFormControlName(this.col);
        this.formgroup = this.productDetailsSrv.getNestedForm(this.form, this.col, Type.Object);
        if (!this.productDetails.id || this.productDetails.secondaryImages.length >= this.col.arrayCount || !this.assetPermissions) {
            this.disabled = true;
        }
        else {
            this.disabled = false;
        }
    }
    imageClick($event, image) {
        $event.preventDefault();
        this.isImageEnlarged = this.isImageEnlarged === true ? false : true;
        this.isEditable = false;
        this.enlargedImage = image;
    }
    upload(event, type) {
        this.form = this.assetSrv.onAssetUpload(event, type, this.form);
        this.assetEvent.emit(this.form.getRawValue());
    }
    confirmAssetDelete(type, asset) {
        this.confirmationService.confirm({
            header: this.translocoSrv.translate('ACTIONS.DELETE'),
            message: this.translocoSrv.translate('PIM.DELETE_ASSET_CONFIRM'),
            accept: () => {
                this.form = this.assetSrv.confirmAssetDelete(type, asset, this.form);
                this.assetEvent.emit(this.form.getRawValue());
            },
        });
    }
    onAssetSelect($event) {
        this.assetSrv.onAssetSelect($event, this.imageTypes);
    }
    onBeforeUpload($event) {
        // The spinner is turned off when the product is updated successfully
        this.spinnerService.on();
    }
}
SecondaryImageRendererComponent.decorators = [
    { type: Component, args: [{
                selector: 'lib-secondary-image-renderer',
                template: "<div class=\"product-details header brand-light-grey-bg\">\r\n  <div>\r\n    <p class=\"lbmx-h4\">\r\n      {{ 'PIM.PRODUCT_DETAILS_SECONDARYIMAGE' | transloco }}\r\n    </p>\r\n  </div>\r\n\r\n  <div class=\"upload\" *ngIf=\"!disabled\">\r\n    <p-fileUpload\r\n      chooseLabel=\"{{ 'ACTIONS.ADD' | transloco }}\"\r\n      styleClass=\"ds tertiary small\"\r\n      [url]=\"uploadAssetsUrl\"\r\n      mode=\"basic\"\r\n      (onUpload)=\"upload($event, 'Secondary')\"\r\n      (onBeforeUpload)=\"onBeforeUpload($event)\"\r\n      (onSelect)=\"onAssetSelect($event)\"\r\n      [accept]=\"imageTypes\"\r\n      [auto]=\"true\"\r\n      withCredentials=\"true\"\r\n      title=\"\"\r\n    >\r\n    </p-fileUpload>\r\n  </div>\r\n</div>\r\n\r\n<div class=\"vertical-flow secondary-enlarged-image\">\r\n  <div class=\"space-before-100\" *ngIf=\"isImageEnlarged === true\">\r\n    <!-- #region Enlarge primary image -->\r\n    <div>\r\n      <input\r\n        type=\"image\"\r\n        [src]=\"enlargedImage.url + '?size=medium'\"\r\n        (click)=\"imageClick($event, enlargedImage)\"\r\n      />\r\n    </div>\r\n    <div class=\"margin-bottom-2\">\r\n      <p>\r\n        {{ enlargedImage.name }}\r\n      </p>\r\n    </div>\r\n    <!-- #endregion -->\r\n  </div>\r\n</div>\r\n\r\n<div id=\"secondary-images\" class=\"product-details image-container-parent\">\r\n  <div\r\n    class=\"image-container-controls vertical-flow space-between-100\"\r\n    *ngFor=\"let i of imageMatrix; let j = index\"\r\n  >\r\n    <div class=\"wrapper img-container standard\" *ngIf=\"i.url\">\r\n      <input\r\n        type=\"image\"\r\n        class=\"target\"\r\n        [src]=\"i.url + '?size=small'\"\r\n        (click)=\"imageClick($event, i)\"\r\n      />\r\n      <div *ngIf=\"!disabled\">\r\n        <button\r\n          pButton\r\n          class=\"ds tertiary small control\"\r\n          type=\"button\"\r\n          label=\"{{ 'ACTIONS.REMOVE' | transloco }}\"\r\n          (click)=\"confirmAssetDelete('Secondary', i)\"\r\n        ></button>\r\n      </div>\r\n    </div>\r\n    <div class=\"wrapper asset-not-available\" *ngIf=\"!i.url && i.filename\">\r\n      <div class=\"defaultImageStyle no-image\">\r\n        <span>\r\n          {{ 'PIM.ASSET' | transloco }}<br />{{ 'PIM.NOT_FOUND' | transloco }}\r\n        </span>\r\n      </div>\r\n      <div *ngIf=\"!disabled\">\r\n        <button\r\n          pButton\r\n          class=\"ds tertiary small\"\r\n          type=\"button\"\r\n          label=\"{{ 'ACTIONS.REMOVE' | transloco }}\"\r\n          (click)=\"confirmAssetDelete('Secondary', i)\"\r\n        ></button>\r\n      </div>\r\n    </div>\r\n\r\n    <div class=\"horizontal-flow space-between-100\">\r\n      <a\r\n        *ngIf=\"isEditable === false && i.isAvailable === true\"\r\n        download\r\n        [href]=\"i.url\"\r\n      >\r\n        <img src=\"assets/images/downlod_icon.png\" />\r\n      </a>\r\n      <span class=\"asset-description\" *ngIf=\"isEditable === false\">\r\n        {{ i.name }}\r\n      </span>\r\n    </div>\r\n\r\n    <ng-container [formGroup]=\"form\">\r\n      <ng-container\r\n        [formArrayName]=\"productDetailsSrv.getNestedFormName(col)\"\r\n        *ngIf=\"\r\n          productDetailsSrv.getNestedFormName(col) !== undefined &&\r\n          isEditable === true\r\n        \"\r\n      >\r\n        <ng-container [formGroupName]=\"j\">\r\n          <textarea\r\n            pInputTextarea\r\n            class=\"asset-description\"\r\n            [rows]=\"2\"\r\n            [formControlName]=\"fieldFormControlName\"\r\n            [cols]=\"29\"\r\n          ></textarea>\r\n        </ng-container>\r\n      </ng-container>\r\n    </ng-container>\r\n  </div>\r\n</div>\r\n",
                providers: [AssetService],
                styles: [""]
            },] }
];
SecondaryImageRendererComponent.ctorParameters = () => [
    { type: ProductDetailsService },
    { type: AssetService },
    { type: TranslocoService },
    { type: ConfirmationService },
    { type: SpinnerService$1 }
];
SecondaryImageRendererComponent.propDecorators = {
    form: [{ type: Input }],
    uploadAssetsUrl: [{ type: Input }],
    isEditable: [{ type: Input }],
    productDetails: [{ type: Input }],
    col: [{ type: Input }],
    imageMatrix: [{ type: Input }],
    assetPermissions: [{ type: Input }],
    imageTypes: [{ type: Input }],
    assetEvent: [{ type: Output }]
};

class TemplateDComponent {
    constructor(productDetailsSrv) {
        this.productDetailsSrv = productDetailsSrv;
        this.assetEvent = new EventEmitter();
        this.ProductFieldEnum = ProductFieldsEnum;
        this.ProductFieldEnumMap = ProductFieldEnumMap;
        this.DataTypeEnum = DataTypeEnum;
        this.Type = Type;
        this.showSecondaryImages = false;
        this.showPrimaryImage = false;
        this.showVideos = false;
        this.showDocuments = false;
        this.isImageEnlarged = false;
        this.isSecondaryImageEnlarged = false;
        this.isPrimaryImagePresent = false;
        this.enableSave = false;
        this.addMoreSecondaryImages = true;
        this.addMoreVideos = true;
        this.addMoreDocuments = true;
        this.matrix = [];
        this.videoMatrix = [];
    }
    ngOnInit() {
        /** empty block */
    }
    ngOnChanges() {
        const product = this.form.getRawValue();
        this.showInfo = !product.id;
        this.primaryImageCol = this.cols.filter((col) => col.fieldKey === ProductFieldsEnum.primaryImageName)[0];
        this.secondaryImageCol = this.cols.filter((col) => col.fieldKey === ProductFieldsEnum.secondaryImageName)[0];
        this.videoCol = this.cols.filter((col) => col.fieldKey === ProductFieldsEnum.videoName)[0];
        this.documentCol = this.cols.filter((col) => col.fieldKey === ProductFieldsEnum.documentName)[0];
        this.getTemplateDData(this.cols);
    }
    getTemplateDData(cols) {
        this.showSecondaryImages =
            cols.filter((col) => col.fieldKey === ProductFieldsEnum.secondaryImageFilename || col.fieldKey === ProductFieldsEnum.secondaryImageName).length > 0;
        this.showPrimaryImage =
            cols.filter((col) => col.fieldKey === ProductFieldsEnum.primaryImageFilename || col.fieldKey === ProductFieldsEnum.primaryImageName)
                .length > 0;
        this.showVideos =
            cols.filter((col) => col.fieldKey === ProductFieldsEnum.videoFilename || col.fieldKey === ProductFieldsEnum.videoName).length > 0;
        this.showDocuments =
            cols.filter((col) => col.fieldKey === ProductFieldsEnum.documentFilename || col.fieldKey === ProductFieldsEnum.documentName).length >
                0;
        if (this.showSecondaryImages) {
            const tempSecondaryImages = this.productDetails.secondaryImages ? this.productDetails.secondaryImages : [];
            const validSecondaryImages = tempSecondaryImages.filter((x) => x.filename);
            const totalLength = tempSecondaryImages.length;
            validSecondaryImages.fill({ filename: '', url: null, name: '', isAvailable: false }, validSecondaryImages.length, totalLength - 1);
            this.matrix = validSecondaryImages;
            this.form.patchValue({ secondaryImages: validSecondaryImages });
        }
        if (this.showVideos) {
            const tempVideos = this.productDetails.videos ? this.productDetails.videos : [];
            const validVideos = tempVideos.filter((x) => x.filename);
            const totalLength = tempVideos.length;
            validVideos.fill({ filename: '', url: null, name: '', isAvailable: false, type: '' }, validVideos.length, totalLength - 1);
            this.videoMatrix = validVideos;
            this.form.patchValue({ videos: validVideos });
        }
        if (this.showDocuments) {
            const tempDocuments = this.productDetails.documents ? this.productDetails.documents : [];
            const validDocuments = tempDocuments.filter((x) => x.filename);
            const totalLength = tempDocuments.length;
            validDocuments.fill({ filename: '', url: null, name: '', isAvailable: false }, validDocuments.length, totalLength - 1);
            this.form.patchValue({ documents: validDocuments });
        }
    }
    assetEventHandler($event) {
        this.assetEvent.emit($event);
    }
}
TemplateDComponent.decorators = [
    { type: Component, args: [{
                selector: 'lib-template-d',
                template: "<div class=\"vertical-flow space-between-100\">\r\n  <div class=\"horizontal-flow space-before-100\" *ngIf=\"showInfo\">\r\n    <div class=\"space-before-400\">\r\n      <i class=\"pi pi-info-circle\"></i><span> {{ 'PIM.ADD_ASSET_INFO' | transloco }} </span>\r\n    </div>\r\n  </div>\r\n\r\n  <div class=\"space-before-100\" *ngIf=\"showPrimaryImage\">\r\n    <lib-image-renderer\r\n      [form]=\"form\"\r\n      [isEditable]=\"isEditable\"\r\n      [image]=\"productDetails.primaryImage\"\r\n      [productDetails]=\"productDetails\"\r\n      [col]=\"primaryImageCol\"\r\n      [imageTypes]=\"imageTypes\"\r\n      [uploadAssetsUrl]=\"assetURL\"\r\n      [assetPermissions]=\"assetPermissions\"\r\n      (assetEvent)=\"assetEventHandler($event)\"\r\n    ></lib-image-renderer>\r\n  </div>\r\n\r\n  <div *ngIf=\"showSecondaryImages\">\r\n    <lib-secondary-image-renderer\r\n      [form]=\"form\"\r\n      [isEditable]=\"isEditable\"\r\n      [imageMatrix]=\"matrix\"\r\n      [productDetails]=\"productDetails\"\r\n      [imageTypes]=\"imageTypes\"\r\n      [col]=\"secondaryImageCol\"\r\n      [uploadAssetsUrl]=\"assetURL\"\r\n      [assetPermissions]=\"assetPermissions\"\r\n      (assetEvent)=\"assetEventHandler($event)\"\r\n    ></lib-secondary-image-renderer>\r\n  </div>\r\n\r\n  <div *ngIf=\"showVideos\">\r\n    <lib-video-renderer\r\n      [form]=\"form\"\r\n      [isEditable]=\"isEditable\"\r\n      [videoMatrix]=\"videoMatrix\"\r\n      [videoTypes]=\"videoTypes\"\r\n      [uploadAssetsUrl]=\"assetURL\"\r\n      (assetEvent)=\"assetEventHandler($event)\"\r\n      [assetPermissions]=\"assetPermissions\"\r\n      [productDetails]=\"productDetails\"\r\n      [col]=\"videoCol\"\r\n    ></lib-video-renderer>\r\n  </div>\r\n\r\n  <div *ngIf=\"showDocuments\">\r\n    <lib-document-renderer\r\n      [form]=\"form\"\r\n      [uploadAssetsUrl]=\"assetURL\"\r\n      (assetEvent)=\"assetEventHandler($event)\"\r\n      [isEditable]=\"isEditable\"\r\n      [documentTypes]=\"documentTypes\"\r\n      [documents]=\"productDetails.documents\"\r\n      [productDetails]=\"productDetails\"\r\n      [assetPermissions]=\"assetPermissions\"\r\n      [col]=\"documentCol\"\r\n    ></lib-document-renderer>\r\n  </div>\r\n</div>\r\n",
                styles: [""]
            },] }
];
TemplateDComponent.ctorParameters = () => [
    { type: ProductDetailsService }
];
TemplateDComponent.propDecorators = {
    productDetails: [{ type: Input }],
    dropDownData: [{ type: Input }],
    cols: [{ type: Input }],
    form: [{ type: Input }],
    dateFormat: [{ type: Input }],
    timeFormat: [{ type: Input }],
    isEditable: [{ type: Input }],
    assetURL: [{ type: Input }],
    imageTypes: [{ type: Input }],
    videoTypes: [{ type: Input }],
    documentTypes: [{ type: Input }],
    assetPermissions: [{ type: Input }],
    assetEvent: [{ type: Output }]
};

class VideoRendererComponent {
    constructor(productDetailsSrv, assetSrv, translocoSrv, confirmationService, spinnerService) {
        this.productDetailsSrv = productDetailsSrv;
        this.assetSrv = assetSrv;
        this.translocoSrv = translocoSrv;
        this.confirmationService = confirmationService;
        this.spinnerService = spinnerService;
        this.assetEvent = new EventEmitter();
        this.disabled = false;
    }
    ngOnInit() {
        /** empty block */
    }
    ngOnChanges() {
        this.fieldFormControlName = this.productDetailsSrv.getFormControlName(this.col);
        this.formgroup = this.productDetailsSrv.getNestedForm(this.form, this.col, Type.Object);
        if (!this.productDetails.id || this.productDetails.videos.length >= this.col.arrayCount || !this.assetPermissions) {
            this.disabled = true;
        }
        else {
            this.disabled = false;
        }
    }
    upload(event, type) {
        this.form = this.assetSrv.onAssetUpload(event, type, this.form);
        this.assetEvent.emit(this.form.getRawValue());
    }
    confirmAssetDelete(type, asset) {
        this.confirmationService.confirm({
            header: this.translocoSrv.translate('ACTIONS.DELETE'),
            message: this.translocoSrv.translate('PIM.DELETE_ASSET_CONFIRM'),
            accept: () => {
                this.form = this.assetSrv.confirmAssetDelete(type, asset, this.form);
                this.assetEvent.emit(this.form.getRawValue());
            },
        });
    }
    onAssetSelect($event) {
        this.assetSrv.onAssetSelect($event, this.videoTypes);
    }
    onBeforeUpload($event) {
        // The spinner is turned off when the product is updated successfully
        this.spinnerService.on();
    }
}
VideoRendererComponent.decorators = [
    { type: Component, args: [{
                selector: 'lib-video-renderer',
                template: "<div class=\"product-details header brand-light-grey-bg\">\r\n  <div>\r\n    <p class=\"lbmx-h4\">{{ 'PIM.PRODUCT_DETAILS_VIDEO' | transloco }}</p>\r\n  </div>\r\n  <div class=\"upload\" *ngIf=\"!disabled\">\r\n    <p-fileUpload\r\n      chooseLabel=\"{{ 'ACTIONS.ADD' | transloco }}\"\r\n      styleClass=\"ds tertiary small\"\r\n      [url]=\"uploadAssetsUrl\"\r\n      mode=\"basic\"\r\n      name=\"assets[]\"\r\n      (onBeforeUpload)=\"onBeforeUpload($event)\"\r\n      (onUpload)=\"upload($event, 'Video')\"\r\n      (onSelect)=\"onAssetSelect($event)\"\r\n      [accept]=\"videoTypes\"\r\n      [auto]=\"true\"\r\n      withCredentials=\"true\"\r\n      title=\"\"\r\n    >\r\n    </p-fileUpload>\r\n  </div>\r\n</div>\r\n\r\n<div id=\"videos\" class=\"product-details video-container-parent\">\r\n  <div\r\n    class=\"video-container vertical-flow space-between-100\"\r\n    *ngFor=\"let i of videoMatrix; let j = index\"\r\n  >\r\n    <div class=\"img-container video\" *ngIf=\"i.url\">\r\n      <video class=\"target\" controls preload=\"auto\" controlslist=\"nodownload\">\r\n        <source [src]=\"i.url\" [type]=\"i.type\" />\r\n        {{ 'PIM.BROWSER_NOT_SUPPORTED' | transloco }}\r\n      </video>\r\n      <div *ngIf=\"!disabled\">\r\n        <button\r\n          pButton\r\n          class=\"ds tertiary small control\"\r\n          type=\"button\"\r\n          label=\"{{ 'ACTIONS.REMOVE' | transloco }}\"\r\n          (click)=\"confirmAssetDelete('Video', i)\"\r\n        ></button>\r\n      </div>\r\n    </div>\r\n    <div class=\"wrapper asset-not-available\" *ngIf=\"!i.url && i.filename\">\r\n      <div class=\"defaultImageStyle no-video\">\r\n        <span>\r\n          {{ 'PIM.ASSET' | transloco }}<br />{{ 'PIM.NOT_FOUND' | transloco }}\r\n        </span>\r\n      </div>\r\n      <div *ngIf=\"!disabled\">\r\n        <button\r\n          pButton\r\n          class=\"ds tertiary small\"\r\n          type=\"button\"\r\n          label=\"{{ 'ACTIONS.REMOVE' | transloco }}\"\r\n          (click)=\"confirmAssetDelete('Video', i)\"\r\n        ></button>\r\n      </div>\r\n    </div>\r\n    <div class=\"horizontal-flow space-between-100\">\r\n      <a\r\n        *ngIf=\"isEditable === false && i.isAvailable === true\"\r\n        download\r\n        [href]=\"i.url\"\r\n      >\r\n        <img src=\"assets/images/downlod_icon.png\" />\r\n      </a>\r\n      <span class=\"asset-description\" *ngIf=\"isEditable === false\">\r\n        {{ i.name }}\r\n      </span>\r\n    </div>\r\n\r\n    <ng-container [formGroup]=\"form\">\r\n      <ng-container\r\n        [formArrayName]=\"productDetailsSrv.getNestedFormName(col)\"\r\n        *ngIf=\"\r\n          productDetailsSrv.getNestedFormName(col) !== undefined &&\r\n          isEditable === true\r\n        \"\r\n      >\r\n        <ng-container class=\"row\" [formGroupName]=\"j\">\r\n          <textarea\r\n            pInputTextarea\r\n            class=\"asset-description\"\r\n            [rows]=\"2\"\r\n            [formControlName]=\"fieldFormControlName\"\r\n            [cols]=\"29\"\r\n          ></textarea>\r\n        </ng-container>\r\n      </ng-container>\r\n    </ng-container>\r\n  </div>\r\n</div>\r\n",
                providers: [AssetService],
                styles: [""]
            },] }
];
VideoRendererComponent.ctorParameters = () => [
    { type: ProductDetailsService },
    { type: AssetService },
    { type: TranslocoService },
    { type: ConfirmationService },
    { type: SpinnerService$1 }
];
VideoRendererComponent.propDecorators = {
    form: [{ type: Input }],
    uploadAssetsUrl: [{ type: Input }],
    isEditable: [{ type: Input }],
    productDetails: [{ type: Input }],
    col: [{ type: Input }],
    videoMatrix: [{ type: Input }],
    videoTypes: [{ type: Input }],
    assetPermissions: [{ type: Input }],
    assetEvent: [{ type: Output }],
    videoPlayer: [{ type: ViewChild, args: ['videoPlayer',] }]
};

const getTranslations$ = (transloco) => {
    const keys = [
        'ACTIONS.CANCEL',
        'ACTIONS.SAVE',
        { key: 'VALIDATION_MESSAGE.ALPHANUMERIC_MAX', params: { length: 100 } },
        'VALIDATION_MESSAGE.TRAILING_WHITESPACE',
        'PIM.SUPPLIER_CROSS_REFERENCES.BUSINESS_NAME',
        'PIM.SUPPLIER_CROSS_REFERENCES.SUPPLIER_NUMBER',
        'PIM.SUPPLIER_CROSS_REFERENCES.MY_SUPPLIER_NUMBER',
        'PIM.SUPPLIER_CROSS_REFERENCES.DUPLICATE_SUPPLIER_NUMBER',
    ];
    const translations = keys.map((val) => typeof val === 'string'
        ? transloco
            .selectTranslate(val)
            .pipe(map((translation) => [val, translation]))
        : transloco
            .selectTranslate(val.key, val.params)
            .pipe(map((translation) => [val.key, translation])));
    return combineLatest(translations).pipe(map((t) => t.reduce((acc, [key, translation]) => (Object.assign(Object.assign({}, acc), { [key]: translation })), {})));
};
const editSupplierCrossReferenceForm = (isEditable, suppliers, translations, callbacks) => ({
    controls: {
        cancel: {
            label: translations['ACTIONS.CANCEL'],
            type: 'button',
            role: FormControlRole.SECONDARY,
            callback: callbacks.cancel,
        },
        save: {
            label: translations['ACTIONS.SAVE'],
            type: 'button',
            role: FormControlRole.PRIMARY,
            callback: callbacks.save,
            disabled: (form) => !form.valid,
        },
    },
    fields: {
        accountKey: {
            display: false,
        },
        dbaName: {
            type: 'text',
            label: translations['PIM.SUPPLIER_CROSS_REFERENCES.BUSINESS_NAME'],
            readonly: true,
        },
        supplierNumber: {
            type: 'text',
            label: translations['PIM.SUPPLIER_CROSS_REFERENCES.SUPPLIER_NUMBER'],
            readonly: true,
        },
        mySupplierNumber: {
            type: 'text',
            label: translations['PIM.SUPPLIER_CROSS_REFERENCES.MY_SUPPLIER_NUMBER'],
            readonly: !isEditable,
            required: isEditable,
            validations: [
                {
                    test: (values) => !/\s+$/.test(values.mySupplierNumber),
                    message: translations['VALIDATION_MESSAGE.TRAILING_WHITESPACE'],
                },
                {
                    test: (values) => { var _a, _b; return (_b = ((_a = values.mySupplierNumber) === null || _a === void 0 ? void 0 : _a.length) <= 100) !== null && _b !== void 0 ? _b : true; },
                    message: translations['VALIDATION_MESSAGE.ALPHANUMERIC_MAX'],
                },
                {
                    test: (values) => !suppliers.some((s) => duplicateSupplierNumber(s, values)),
                    message: translations['PIM.SUPPLIER_CROSS_REFERENCES.DUPLICATE_SUPPLIER_NUMBER'],
                },
            ],
        },
    },
});
const duplicateSupplierNumber = (supplier, formState) => {
    var _a;
    return (supplier.supplierNumber.localeCompare((_a = formState.mySupplierNumber) !== null && _a !== void 0 ? _a : '', 'en', {
        usage: 'search',
        sensitivity: 'base',
    }) === 0 && supplier.accountKey !== formState.accountKey);
};
const ɵ0$b = duplicateSupplierNumber;

class SupplierCrossReferencesService {
    constructor(http, pim) {
        this.http = http;
        this.pim = pim;
        this.baseUrl =
            this.pim.getConfig().uriProduct.baseUri + '/v2/account/supplier';
    }
    fetchSuppliers() {
        return this.http
            .get(this.baseUrl, { withCredentials: true })
            .pipe(map((resp) => resp.records));
    }
    setSupplierNumber(request) {
        return this.http.post(`${this.baseUrl}/set-number`, request, {
            withCredentials: true,
        });
    }
    exportSupplierNumbers() {
        return this.http.get(`${this.baseUrl}/export`, {
            responseType: 'blob',
            withCredentials: true,
        });
    }
    importSupplierNumbers(file) {
        const formData = new FormData();
        formData.append('file', file);
        return this.http.post(`${this.baseUrl}/import`, formData, { withCredentials: true });
    }
}
SupplierCrossReferencesService.ɵprov = ɵɵdefineInjectable({ factory: function SupplierCrossReferencesService_Factory() { return new SupplierCrossReferencesService(ɵɵinject(HttpClient), ɵɵinject(PimService)); }, token: SupplierCrossReferencesService, providedIn: "root" });
SupplierCrossReferencesService.decorators = [
    { type: Injectable, args: [{
                providedIn: 'root'
            },] }
];
SupplierCrossReferencesService.ctorParameters = () => [
    { type: HttpClient },
    { type: PimService }
];

class SupplierCrossReferencesComponent {
    constructor(formService, translocoService, search, toast, spinner, store, service) {
        this.formService = formService;
        this.translocoService = translocoService;
        this.search = search;
        this.toast = toast;
        this.spinner = spinner;
        this.store = store;
        this.service = service;
        this.showEdit = false;
        this.isEditable = false;
        this.columnActions = {
            dbaName: {
                link: () => ({ path: './' }),
                event: (row) => ({
                    data: row,
                    eventType: 'edit',
                }),
            },
        };
        this.toolbarActions = {
            edit: (selection) => {
                this.editForm.patch({
                    accountKey: selection[0].accountKey,
                    dbaName: selection[0].dbaName,
                    supplierNumber: selection[0].supplierNumber,
                    mySupplierNumber: selection[0].mySupplierNumber,
                });
                this.showEdit = true;
            },
            import: () => {
                this.importFileInput.nativeElement.click();
            },
            export: () => {
                this.service.exportSupplierNumbers().subscribe((response) => {
                    saveAs(response);
                });
            },
        };
        this.baseUrl = service.baseUrl;
    }
    ngOnInit() {
        const callbacks = {
            cancel: () => {
                this.showEdit = false;
            },
            save: (form) => {
                this.showEdit = false;
                this.spinner.on();
                this.service
                    .setSupplierNumber({
                    supplierNumber: form.values.supplierNumber,
                    mySupplierNumber: form.values.mySupplierNumber,
                })
                    .subscribe(() => {
                    this.search.refreshSearch();
                    this.toast.successNotify(this.translocoService.translate('PIM.SUPPLIER_CROSS_REFERENCES.EDIT_SUCCESS'));
                    this.spinner.off();
                }, () => {
                    this.toast.errorNotify(this.translocoService.translate('PIM.SUPPLIER_CROSS_REFERENCES.EDIT_FAILURE'));
                    this.spinner.off();
                });
            },
        };
        const isEditable$ = this.store.pipe(select(selectors.userToolKeys), map((userTools) => {
            const requiredTools = [
                toolKeys.PIM_CROSS_REFERENCES_SUPPLIER_CROSS_REFERENCES_EDIT,
                toolKeys.PDX_CROSS_REFERENCES_SUPPLIER_CROSS_REFERENCES_EDIT,
            ];
            return (userTools.find((key) => requiredTools.includes(key)) !== undefined);
        }), tap((isEditable) => (this.isEditable = isEditable)));
        this.formSubscription = combineLatest([
            isEditable$,
            this.service.fetchSuppliers(),
            getTranslations$(this.translocoService),
        ])
            .pipe(map(([isEditable, suppliers, translations]) => this.formService.init(editSupplierCrossReferenceForm(isEditable, suppliers, translations, callbacks))), tap((form) => (this.editForm = form)))
            .subscribe();
    }
    ngOnDestroy() {
        this.formSubscription.unsubscribe();
    }
    searchContainerEvent($event) {
        switch ($event.eventType) {
            case 'edit':
                this.toolbarActions.edit([$event.data]);
                break;
            default:
                break;
        }
    }
    onFileChange($event) {
        this.spinner.on();
        this.service.importSupplierNumbers($event.target.files[0]).subscribe(() => {
            this.search.refreshSearch();
            this.toast.successNotify(this.translocoService.translate('PIM.SUPPLIER_CROSS_REFERENCES.IMPORT_SUCCESS'));
            this.spinner.off();
            this.importFileInput.nativeElement.value = '';
        }, () => {
            this.toast.errorNotify(this.translocoService.translate('PIM.SUPPLIER_CROSS_REFERENCES.IMPORT_FAILURE'));
            this.spinner.off();
            this.importFileInput.nativeElement.value = '';
        });
    }
}
SupplierCrossReferencesComponent.decorators = [
    { type: Component, args: [{
                selector: 'lib-suppliers-grid',
                template: "<h2> {{ 'PIM.SUPPLIER_CROSS_REFERENCES.HEADER' | transloco }}</h2>\r\n\r\n<p-dialog [visible]=\"showEdit\"\r\n  [header]=\"(isEditable ? 'PIM.SUPPLIER_CROSS_REFERENCES.EDIT' : 'PIM.SUPPLIER_CROSS_REFERENCES.VIEW') | transloco\"\r\n  [style]=\"{ width: '520px' }\" [modal]=\"true\" [closable]=\"false\" [closeOnEscape]=\"false\">\r\n    <lui-form *ngIf=\"editForm\" [form]=\"editForm\"></lui-form>\r\n</p-dialog>\r\n\r\n<input #fileInput type=\"file\" style=\"display: none;\"\r\n  accept=\"text/csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel\"\r\n  (change)=\"onFileChange($event)\" />\r\n\r\n<lib-search-container-loader searchContainerName=\"pimSuppliersSearch\" i18nSearchField=\"ACTIONS.SEARCH\"\r\n  [disableAdvancedSearch]=\"true\" [baseUrl]=\"baseUrl\" [toolbarActionsDispatcher]=\"toolbarActions\"\r\n  [columnActions]=\"columnActions\" (field)=\"searchContainerEvent($event)\">\r\n</lib-search-container-loader>\r\n",
                styles: [""]
            },] }
];
SupplierCrossReferencesComponent.ctorParameters = () => [
    { type: GenerateFormService },
    { type: TranslocoService },
    { type: SearchContainerLoaderService },
    { type: ToastrNotificationService$1 },
    { type: SpinnerService$1 },
    { type: Store },
    { type: SupplierCrossReferencesService }
];
SupplierCrossReferencesComponent.propDecorators = {
    importFileInput: [{ type: ViewChild, args: ['fileInput',] }]
};

class SupplierCrossReferencesModule {
}
SupplierCrossReferencesModule.decorators = [
    { type: NgModule, args: [{
                declarations: [SupplierCrossReferencesComponent],
                imports: [
                    CommonModule,
                    SearchContainerLoaderModule,
                    DialogModule$2,
                    TranslocoModule,
                    PerFormPrimengModule,
                    LuiWizardV3Module,
                    FileUploadModule,
                ],
                providers: [SupplierCrossReferencesService],
            },] }
];

const importRoutes = [
    {
        path: '',
        component: FileSelectionComponent,
        canDeactivate: [CanDeactivateGuard]
    },
    {
        path: 'column-wizard',
        component: ColumnWizardComponent,
        canDeactivate: [CanDeactivateGuard]
    },
    {
        path: 'layout-manager',
        component: LayoutManagerComponent,
        canDeactivate: [CanDeactivateGuard]
    },
    {
        path: 'email-notify',
        component: EmailNotificationComponent,
        canDeactivate: [CanDeactivateGuard]
    },
    {
        path: 'finish',
        component: FinishComponent
    }
];

class PIMComponent {
    constructor(store, translocoService, pimAPISrv, pimSrv) {
        this.store = store;
        this.translocoService = translocoService;
        this.pimAPISrv = pimAPISrv;
        this.pimSrv = pimSrv;
        this.subscriptions = [];
        this.pimAPISrv.setBaseUrl(this.pimSrv.getConfig().getProductDetailsEndpoint);
    }
    ngOnInit() {
        this.subscriptions.push(this.store
            .pipe(select(selectors.userProfile), tap((user) => {
            // when logging out, it will change to en-ca automatically
            this.translocoService.setActiveLang(user.userInfo.LanguageCode ? user.userInfo.LanguageCode : 'en-ca');
        }))
            .subscribe());
    }
    ngOnDestroy() {
        if (this.subscriptions) {
            this.subscriptions.forEach((subscription) => subscription.unsubscribe());
        }
    }
}
PIMComponent.decorators = [
    { type: Component, args: [{
                selector: 'lib-pim',
                template: ` <lib-working-spinner-component></lib-working-spinner-component>
    <lib-toast-notification></lib-toast-notification>
    <router-outlet></router-outlet>`
            },] }
];
PIMComponent.ctorParameters = () => [
    { type: Store },
    { type: TranslocoService },
    { type: PimAPIService },
    { type: PimService }
];

class AuthGuardService {
    constructor(router, store) {
        this.router = router;
        this.store = store;
    }
    canActivateChild(route, _) {
        const routePermissions = route.data.permissions;
        if (!routePermissions) {
            return true;
        }
        const permissionsQuery = routePermissions.reduce((acc, val) => (Object.assign(Object.assign({}, acc), { [val]: val })), {});
        return this.store.pipe(select(selectors.isAuthorized, permissionsQuery), map((permissions) => routePermissions.find(p => permissions[p]) !== undefined), catchError(() => of(this.router.parseUrl('/'))));
    }
}
AuthGuardService.ɵprov = ɵɵdefineInjectable({ factory: function AuthGuardService_Factory() { return new AuthGuardService(ɵɵinject(Router), ɵɵinject(Store)); }, token: AuthGuardService, providedIn: "root" });
AuthGuardService.decorators = [
    { type: Injectable, args: [{
                providedIn: 'root',
            },] }
];
AuthGuardService.ctorParameters = () => [
    { type: Router },
    { type: Store }
];

function matchPim(segments, group, route) {
    if (group.segments[0].path === 'PIMModule') {
        return { consumed: [] };
    }
    return null;
}
function matchPdx(segments, group, route) {
    if (group.segments[0].path === 'pdx-module') {
        return { consumed: [] };
    }
    return null;
}
const ɵ0$c = { breadcrumb: 'BREADCRUMB.PIM' }, ɵ1$7 = {
    permissions: [toolKeys.PIM_PRODUCTS],
    breadcrumb: 'BREADCRUMB.PRODUCTS',
}, ɵ2$3 = {
    breadcrumb: 'BREADCRUMB.PRODUCTS',
    permissions: [toolKeys.PIM_PRODUCTS_APPROVED_PRODUCTS],
}, ɵ3$3 = {
    breadcrumb: 'BREADCRUMB.PENDING_PRODUCT',
    permissions: [toolKeys.PIM_PRODUCTS_PRODUCTS_PENDING],
}, ɵ4$2 = {
    breadcrumb: 'BREADCRUMB.PRODUCT_FIELDS',
}, ɵ5$2 = {
    breadcrumb: 'BREADCRUMB.INBOUND_UPDATE_PROFILE',
    permissions: [toolKeys.PIM_PRODUCTS_INBOUND_UPDATE_PROFILE],
}, ɵ6$2 = {
    breadcrumb: 'BREADCRUMB.OUTBOUND_UPDATE_PROFILE',
    permissions: [toolKeys.PIM_PRODUCTS_OUTBOUND_UPDATE_PROFILES],
}, ɵ7$2 = {
    breadcrumb: {
        alias: 'outbound-profile-wizard',
    },
}, ɵ8$1 = {
    breadcrumb: 'BREADCRUMB.OUTBOUND_CONFIGURATION',
    permissions: [toolKeys.PIM_PRODUCTS_OUTBOUND_CONFIGURATION],
}, ɵ9$1 = {
    breadcrumb: 'BREADCRUMB.PRODUCT_DETAILS',
    isNew: true,
}, ɵ10$1 = {
    breadcrumb: 'BREADCRUMB.PRODUCT_DETAILS',
}, ɵ11$1 = {
    breadcrumb: {
        label: 'BREADCRUMB.IMPORTS',
        disable: true,
        permissions: [toolKeys.PIM_IMPORTS],
    },
}, ɵ12 = {
    breadcrumb: 'PIM.IMPORT_ASSETS',
    permissions: [toolKeys.PIM_IMPORTS_IMPORT_ASSETS],
}, ɵ13 = {
    breadcrumb: 'PIM.IMPORT_PRODUCT_DATA',
    permissions: [toolKeys.PIM_IMPORTS_IMPORT_PRODUCT_DATA],
}, ɵ14 = {
    breadcrumb: {
        label: 'BREADCRUMB.EXPORT',
        disable: true,
        permissions: [toolKeys.PIM_PRODUCTS],
    },
}, ɵ15 = { breadcrumb: 'PIM.EXPORT' }, ɵ16 = {
    permissions: [toolKeys.PIM],
    breadcrumb: 'PIM.CONTROL_CENTRE',
}, ɵ17 = {
    permissions: [
        toolKeys.PIM_CROSS_REFERENCES_SUPPLIER_CROSS_REFERENCES,
    ],
}, ɵ18 = { breadcrumb: 'BREADCRUMB.PDX' }, ɵ19 = {
    isPdx: true,
    permissions: [toolKeys.PDX],
    breadcrumb: 'PIM.CONTROL_CENTRE',
}, ɵ20 = {
    permissions: [toolKeys.PDX_PRODUCTS],
    breadcrumb: 'BREADCRUMB.PRODUCTS',
}, ɵ21 = {
    isPdx: true,
}, ɵ22 = {
    breadcrumb: 'BREADCRUMB.OUTBOUND_UPDATE_PROFILE',
    permissions: [toolKeys.PDX_PRODUCTS_OUTBOUND_UPDATE_PROFILES],
}, ɵ23 = {
    breadcrumb: {
        alias: 'outbound-profile-wizard',
    },
    isPdx: true,
}, ɵ24 = {
    breadcrumb: 'BREADCRUMB.OUTBOUND_CONFIGURATION',
    permissions: [toolKeys.PDX_PRODUCTS_OUTBOUND_CONFIGURATION],
}, ɵ25 = {
    isPdx: true,
    permissions: [toolKeys.PDX_PRODUCTS_PRODUCT_FIELDS_VIEW],
    breadcrumb: 'BREADCRUMB.PRODUCT_FIELDS',
}, ɵ26 = {
    isPdx: true,
    breadcrumb: 'BREADCRUMB.PRODUCT_DETAILS',
}, ɵ27 = {
    permissions: [toolKeys.PDX_IMPORTS],
    breadcrumb: {
        disable: true,
        label: 'BREADCRUMB.IMPORTS',
    },
}, ɵ28 = {
    isPdx: true,
    permissions: [toolKeys.PDX_IMPORTS_IMPORT_PRODUCT_DATA_VIEW],
    breadcrumb: 'PIM.IMPORT_PRODUCT_DATA',
}, ɵ29 = {
    isPdx: true,
    permissions: [toolKeys.PDX_IMPORTS_IMPORT_ASSETS_VIEW],
    breadcrumb: 'BREADCRUMB.IMPORT_ASSETS',
}, ɵ30 = {
    breadcrumb: {
        isPdx: true,
        label: 'BREADCRUMB.EXPORT',
        disable: true,
        permissions: [toolKeys.PDX_EXPORTS],
    },
}, ɵ31 = {
    isPdx: true,
    breadcrumb: 'PIM.EXPORT',
}, ɵ32 = {
    isPdx: true,
    permissions: [toolKeys.PDX_ERROR_MESSAGES_VIEW],
    breadcrumb: 'BREADCRUMB.ERROR_MESSAGES',
}, ɵ33 = {
    isPdx: true,
    viewErrors: true,
}, ɵ34 = {
    permissions: [
        toolKeys.PDX_CROSS_REFERENCES_SUPPLIER_CROSS_REFERENCES,
    ],
};
const appRoutes = [
    {
        data: ɵ0$c,
        component: PIMComponent,
        matcher: matchPim,
        canActivateChild: [AuthGuardService],
        children: [
            {
                path: '',
                redirectTo: 'analytics',
            },
            {
                path: 'products',
                data: ɵ1$7,
                children: [
                    {
                        path: '',
                        component: ApprovedProductsComponent,
                        data: ɵ2$3,
                    },
                    {
                        path: 'products-pending',
                        component: PendingProductsComponent,
                        data: ɵ3$3,
                    },
                    {
                        path: 'product-fields',
                        component: ConfigProductFieldsComponent,
                        data: ɵ4$2,
                    },
                    {
                        path: 'inbound-update-profile',
                        component: ExcludedProductFieldsComponent,
                        data: ɵ5$2,
                    },
                    {
                        path: 'outbound-update-profile',
                        data: ɵ6$2,
                        children: [
                            {
                                path: '',
                                component: OutboundProfileSearchComponent,
                            },
                            {
                                path: 'wizard',
                                data: ɵ7$2,
                                component: OutboundProfileWizardComponent,
                                canDeactivate: [CanDeactivateGuard],
                            },
                        ],
                    },
                    {
                        path: 'outbound-configuration',
                        data: ɵ8$1,
                        component: OutboundConfigurationComponent,
                    },
                    {
                        path: 'new',
                        component: ProductDetailsComponent,
                        canDeactivate: [CanDeactivateGuard],
                        data: ɵ9$1,
                    },
                    {
                        path: ':id',
                        component: ProductDetailsComponent,
                        canDeactivate: [CanDeactivateGuard],
                        data: ɵ10$1,
                    },
                ],
            },
            {
                path: 'imports',
                data: ɵ11$1,
                children: [
                    {
                        path: 'import-assets',
                        component: ImportAssetComponent,
                        data: ɵ12,
                    },
                    {
                        path: 'import-products',
                        data: ɵ13,
                        children: [...importRoutes],
                    },
                ],
            },
            {
                path: 'exports',
                data: ɵ14,
                children: [
                    {
                        path: 'view-exports',
                        data: ɵ15,
                        component: ExportComponent,
                    },
                ],
            },
            {
                path: 'analytics',
                data: ɵ16,
                component: DashboardComponent,
            },
            {
                path: 'supplier-cross-references',
                component: SupplierCrossReferencesComponent,
                data: ɵ17,
            },
        ],
    },
    {
        data: ɵ18,
        component: PIMComponent,
        matcher: matchPdx,
        canActivateChild: [AuthGuardService],
        children: [
            {
                path: '',
                redirectTo: 'control-centre',
            },
            {
                path: 'control-centre',
                component: DashboardPdxComponent,
                data: ɵ19,
            },
            {
                path: 'products',
                data: ɵ20,
                children: [
                    {
                        path: '',
                        data: ɵ21,
                        component: ApprovedProductsComponent,
                    },
                    {
                        path: 'outbound-update-profile',
                        data: ɵ22,
                        children: [
                            {
                                path: '',
                                component: OutboundProfileSearchComponent,
                            },
                            {
                                path: 'wizard',
                                data: ɵ23,
                                component: OutboundProfileWizardComponent,
                                canDeactivate: [CanDeactivateGuard],
                            },
                        ],
                    },
                    {
                        path: 'outbound-configuration',
                        data: ɵ24,
                        component: OutboundConfigurationComponent,
                    },
                    {
                        path: 'fields',
                        data: ɵ25,
                        component: ConfigProductFieldsComponent,
                    },
                    {
                        path: ':id',
                        data: ɵ26,
                        component: ProductDetailsComponent,
                    },
                ],
            },
            {
                path: 'import',
                data: ɵ27,
                children: [
                    {
                        path: 'products',
                        data: ɵ28,
                        children: [...importRoutes],
                    },
                    {
                        path: 'assets',
                        data: ɵ29,
                        component: ImportAssetComponent,
                    },
                ],
            },
            {
                path: 'exports',
                data: ɵ30,
                children: [
                    {
                        path: 'view-exports',
                        data: ɵ31,
                        component: ExportComponent,
                    },
                ],
            },
            {
                path: 'errors',
                data: ɵ32,
                children: [
                    {
                        path: 'export',
                        data: ɵ33,
                        component: ExportComponent,
                    },
                ],
            },
            {
                path: 'supplier-cross-references',
                component: SupplierCrossReferencesComponent,
                data: ɵ34,
            },
        ],
    },
];
class PimRoutingModule {
}
PimRoutingModule.decorators = [
    { type: NgModule, args: [{
                imports: [RouterModule.forChild(appRoutes)],
                exports: [RouterModule],
            },] }
];

class Alert {
    constructor(init) {
        Object.assign(this, init);
    }
}
var AlertType;
(function (AlertType) {
    AlertType[AlertType["Success"] = 0] = "Success";
    AlertType[AlertType["Error"] = 1] = "Error";
    AlertType[AlertType["Info"] = 2] = "Info";
    AlertType[AlertType["Warning"] = 3] = "Warning";
})(AlertType || (AlertType = {}));

class AlertService {
    constructor() {
        this.subject = new Subject();
        this.defaultId = 'default-alert';
    }
    // enable subscribing to alerts observable
    onAlert(id = this.defaultId) {
        return this.subject.asObservable().pipe(filter((x) => x && x.id === id));
    }
    // convenience methods
    success(message, options) {
        this.alert(new Alert(Object.assign(Object.assign({}, options), { type: AlertType.Success, message })));
    }
    error(message, options) {
        this.alert(new Alert(Object.assign(Object.assign({}, options), { type: AlertType.Error, message })));
    }
    info(message, options) {
        this.alert(new Alert(Object.assign(Object.assign({}, options), { type: AlertType.Info, message })));
    }
    warn(message, options) {
        this.alert(new Alert(Object.assign(Object.assign({}, options), { type: AlertType.Warning, message })));
    }
    // main alert method
    alert(alert) {
        alert.id = alert.id || this.defaultId;
        this.subject.next(alert);
    }
    // clear alerts
    clear(id = this.defaultId) {
        this.subject.next(new Alert({ id }));
    }
}
AlertService.ɵprov = ɵɵdefineInjectable({ factory: function AlertService_Factory() { return new AlertService(); }, token: AlertService, providedIn: "root" });
AlertService.decorators = [
    { type: Injectable, args: [{ providedIn: 'root' },] }
];

// tslint:disable-next-line: component-selector
class AlertComponent {
    constructor(router, alertService) {
        this.router = router;
        this.alertService = alertService;
        this.id = 'default-alert';
        this.fade = true;
        this.alerts = [];
        this.subscriptions = [];
    }
    ngOnInit() {
        // subscribe to new alert notifications
        this.subscriptions.push(this.alertService.onAlert(this.id).subscribe((alert) => {
            // clear alerts when an empty alert is received
            if (!alert.message) {
                // filter out alerts without 'keepAfterRouteChange' flag
                this.alerts = this.alerts.filter((x) => x.keepAfterRouteChange);
                // remove 'keepAfterRouteChange' flag on the rest
                this.alerts.forEach((x) => delete x.keepAfterRouteChange);
                return;
            }
            // add alert to array
            this.alerts.push(alert);
            // auto close alert if required
            if (alert.autoClose) {
                setTimeout(() => this.removeAlert(alert), 3000);
            }
        }));
        // clear alerts on location change
        this.subscriptions.push(this.router.events.subscribe((event) => {
            if (event instanceof NavigationStart) {
                this.alertService.clear(this.id);
            }
        }));
    }
    ngOnDestroy() {
        if (this.subscriptions) {
            this.subscriptions.forEach((subscription) => subscription.unsubscribe());
        }
    }
    removeAlert(alert) {
        // check if already removed to prevent error on auto close
        if (!this.alerts.includes(alert)) {
            return;
        }
        if (this.fade) {
            // fade out alert
            this.alerts.find((x) => x === alert).fade = true;
            // remove alert after faded out
            setTimeout(() => {
                this.alerts = this.alerts.filter((x) => x !== alert);
            }, 250);
        }
        else {
            // remove alert
            this.alerts = this.alerts.filter((x) => x !== alert);
        }
    }
    cssClass(alert) {
        if (!alert) {
            return;
        }
        const classes = ['alert', 'alert-dismissable'];
        const alertTypeClass = {
            [AlertType.Success]: 'alert alert-success',
            [AlertType.Error]: 'alert alert-danger',
            [AlertType.Info]: 'alert alert-info',
            [AlertType.Warning]: 'alert alert-warning',
        };
        classes.push(alertTypeClass[alert.type]);
        if (alert.fade) {
            classes.push('fade');
        }
        return classes.join(' ');
    }
}
AlertComponent.decorators = [
    { type: Component, args: [{ selector: 'alert', template: "<div *ngFor=\"let alert of alerts\" class=\"{{cssClass(alert)}}\">\r\n    <a class=\"close\" (click)=\"removeAlert(alert)\">&times;</a>\r\n    <span [innerHTML]=\"alert.message\"></span>\r\n</div>" },] }
];
AlertComponent.ctorParameters = () => [
    { type: Router },
    { type: AlertService }
];
AlertComponent.propDecorators = {
    id: [{ type: Input }],
    fade: [{ type: Input }]
};

class AlertModule {
}
AlertModule.decorators = [
    { type: NgModule, args: [{
                imports: [CommonModule],
                declarations: [AlertComponent],
                exports: [AlertComponent]
            },] }
];

class PimModule {
}
PimModule.decorators = [
    { type: NgModule, args: [{
                imports: [
                    CommonModule,
                    PimRoutingModule,
                    FormsModule,
                    ButtonModule,
                    AccordionModule,
                    ReactiveFormsModule,
                    SplitButtonModule,
                    CoreModule,
                    UtilsModule,
                    MenubarModule,
                    AuthModule,
                    TableModule,
                    DropdownModule,
                    SearchContainerModule,
                    DragDropModule,
                    CardModule,
                    CalendarModule,
                    CheckboxModule,
                    ConfirmDialogModule$1,
                    DialogModule,
                    InputNumberModule,
                    InputTextModule,
                    PasswordModule,
                    PanelModule,
                    TabViewModule,
                    KeyFilterModule,
                    TreeModule,
                    TreeTableModule,
                    SelectButtonModule$1,
                    ChartModule,
                    EditorModule,
                    AlertModule,
                    MultiSelectModule,
                    TranslocoModule,
                    FileUploadModule$1,
                    FullCalendarModule,
                    ScrollingModule,
                    ToastModule,
                    PickListModule$1,
                    ImportProductDataModule,
                    InputTextareaModule,
                    ProgressSpinnerModule,
                    DynamicDialogModule,
                    ToggleButtonModule,
                    AnalyticsModule,
                    OutboundProfileWizardModule,
                    OutboundProfileSearchModule,
                    OutboundConfigurationModule,
                    ReloadModule,
                    MenuModule,
                    TooltipModule,
                    OverlayModule,
                    PerFormPrimengModule,
                    SupplierCrossReferencesModule,
                ],
                declarations: [
                    ConfigProductFieldsComponent,
                    ExcludedProductFieldsComponent,
                    ImportAssetComponent,
                    ApprovedProductsComponent,
                    ProductDetailsComponent,
                    ProductDetailsChildComponent,
                    ExportComponent,
                    DashboardComponent,
                    AdvancedSearchComponent,
                    PIMComponent,
                    PendingProductsComponent,
                    TemplateDComponent,
                    TemplateCComponent,
                    TemplateBComponent,
                    ProductDetailsBasicComponent,
                    ImageRendererComponent,
                    SecondaryImageRendererComponent,
                    VideoRendererComponent,
                    DocumentRendererComponent,
                    ComparisonComponent,
                    HierarchyFormInputComponent,
                    DashboardPdxComponent,
                    SelectionClickOutsideDirective,
                    HierarchyFormInputEditableComponent,
                    SupplierInputComponent,
                ],
                providers: [
                    ProductFieldService,
                    ConfirmationService$1,
                    CanDeactivateGuard,
                    GetHierarchyService,
                    SpinnerService$1,
                    ToastrNotificationService$1,
                    MessageService$1,
                ],
                schemas: [CUSTOM_ELEMENTS_SCHEMA],
                entryComponents: [ComparisonComponent],
            },] }
];

class PimConfig {
    constructor() {
        this.getFieldCategoriesEndpoint = null;
        this.getFieldConfigurationsEndpoint = null;
        this.getAllProductFieldsEndpoint = null;
        this.updateFieldConfigurationsEndpoint = null;
        this.assetsEndPoint = null;
        this.uploadAssetsEndPoint = null;
        this.uploadSupplierAssetsEndPoint = null;
        this.importFileEndPoint = null;
        this.exportFileEndPoint = null;
        this.importLayoutsEndPoint = null;
        this.getIncludedFieldsEndpoint = null;
        this.getApprovedProductsEndpoint = null;
        this.searchApprovedProductsEndpoint = null;
        this.getProductDetailsEndpoint = null;
        this.importEndPoint = null;
        this.getFileHeadersEndPoint = null;
        this.getFieldAllowedValuesEndpoint = null;
        this.getCountriesEndpoint = null;
        this.getCurrenciesEndpoint = null;
        this.getPartnersByType = null;
        this.getPartnersByPermission = null;
        this.account = null;
        this.exportProductsEndpoint = null;
        this.updateProductsEndpoint = null;
        this.searchExportsEndpoint = null;
        this.upsertAssetsEndpoint = null;
        this.searchPendingProductsEndpoint = null;
        this.approvePendingProductEndpoint = null;
        this.rejectPendingProductEndpoint = null;
        this.getKpiEndPoint = null;
        this.getTermsAggregationEndPoint = null;
        this.getUsersFullNameEndPoint = null;
        this.outboundProfileEndPoint = null;
        this.searchOutboundProfilesEndPoint = null;
        this.validateOutboundProfileNameEndPoint = null;
        this.getCategoryAggregationsEndPoint = null;
        this.outboundProfileConfigurationsEndpoint = null;
        this.auditProfileEndpoint = null;
        this.getAutoApproveProducts = null;
        this.setAutoApproveProducts = null;
    }
}

/*
 * Public API Surface of pim
 */

/**
 * Generated bundle index. Do not edit.
 */

export { PimConfig, PimModule, PimService, matchPim as ɵa, matchPdx as ɵb, ImportAssetComponent as ɵba, importRoutes as ɵbb, FileSelectionComponent as ɵbc, ColumnWizardComponent as ɵbd, LayoutManagerComponent as ɵbe, EmailNotificationComponent as ɵbf, FinishComponent as ɵbg, ExportComponent as ɵbh, ExportService as ɵbi, DashboardComponent as ɵbj, SupplierCrossReferencesComponent as ɵbk, SupplierCrossReferencesService as ɵbl, DashboardPdxComponent as ɵbm, AlertModule as ɵbn, AlertComponent as ɵbo, AlertService as ɵbp, ImportProductDataModule as ɵbq, logout as ɵbs, metaReducers as ɵbt, reducers$5 as ɵbu, fetchSuppliersSuccess as ɵbv, resetImportOptions as ɵbw, initialState$3 as ɵbx, importOptionsReducer as ɵby, reducers$3 as ɵbz, appRoutes as ɵc, importProcessing as ɵca, initialState as ɵcb, reducers as ɵcc, uploadFile as ɵcd, uploadFileSuccess as ɵce, resetFileSelection as ɵcf, initialState$1 as ɵcg, reducers$1 as ɵch, addLayoutSuccess as ɵci, updateLayoutSuccess as ɵcj, deleteLayoutSuccess as ɵck, fetchLayoutsSuccess as ɵcl, initialState$4 as ɵcm, reducers$4 as ɵcn, fetchFieldsSuccess as ɵco, fetchAllowedValuesSuccess as ɵcp, fetchCountryListSuccess as ɵcq, fetchCurrencyListSuccess as ɵcr, assignColumn as ɵcs, unassignColumn as ɵct, uploadDestinationColumns as ɵcu, applyLayout as ɵcv, resetColumnWizard as ɵcw, initialState$2 as ɵcx, reducers$2 as ɵcy, ImportProductDataEffects as ɵcz, PimRoutingModule as ɵd, ImportProductsService as ɵda, ProductFieldService as ɵdb, ReloadModule as ɵdc, OutboundProfileWizardModule as ɵdd, ProfileNameComponent as ɵde, PartnerSelectionComponent as ɵdf, SummaryComponent as ɵdg, ProductSelectionComponent as ɵdh, ImportValidationComponent as ɵdi, OutboundProfileSearchModule as ɵdj, OutboundConfigurationModule as ɵdk, SupplierCrossReferencesModule as ɵdl, ProductDetailsChildComponent as ɵdm, AdvancedSearchComponent as ɵdn, TemplateDComponent as ɵdo, TemplateCComponent as ɵdp, TemplateBComponent as ɵdq, ProductDetailsBasicComponent as ɵdr, ImageRendererComponent as ɵds, AssetService as ɵdt, SecondaryImageRendererComponent as ɵdu, VideoRendererComponent as ɵdv, DocumentRendererComponent as ɵdw, ComparisonComponent as ɵdx, HierarchyFormInputComponent as ɵdy, SelectionClickOutsideDirective as ɵdz, PIMComponent as ɵe, HierarchyFormInputEditableComponent as ɵea, SupplierInputComponent as ɵeb, AuthGuardService as ɵf, ApprovedProductsComponent as ɵg, ApprovedProductsService as ɵh, GetHierarchyService as ɵi, PendingProductsComponent as ɵj, ConfigProductFieldsComponent as ɵk, ConfigFieldService as ɵl, ExcludedProductFieldsComponent as ɵm, InboundProfileService as ɵn, OutboundProfileSearchComponent as ɵo, OutboundProfileWizardComponent as ɵp, ComponentCanDeactivateDirective as ɵq, DeactivateDialogDirective as ɵr, OutboundProfileWizardStore as ɵs, OutboundProfileWizardService as ɵt, CanDeactivateGuard as ɵu, OutboundConfigurationComponent as ɵv, OutboundConfigurationService as ɵw, ProductDetailsComponent as ɵx, FormCanDeactivateDirective as ɵy, ProductDetailsService as ɵz };
//# sourceMappingURL=lbmx-phoenix-pim.js.map
